/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Analytics_Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Auth_DateTime: any;
  /** A valid email address */
  Auth_EmailAddress: any;
  /** A valid ObjectID */
  Auth_ObjectID: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Chat_DateTime: any;
  /** A valid JWT Token */
  Chat_JWTToken: any;
  /** A valid ObjectID or a Unix timestamp (in seconds) */
  Chat_ObjectID: any;
  /** A valid UUID */
  Chat_UUID: any;
  /** Representation of date in "YYYY-MM-DD" format */
  Core_Date: any;
  /** Representation of date and time in "YYYY-MM-DD HH:mm:ss" format */
  Core_DateTime: any;
  Core_MimeType: any;
  Core_Timestamp: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Sync_DateTime: any;
};

export type Analytics_Activity = {
  __typename?: 'Analytics_Activity';
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
};

export type Analytics_AddOpen = {
  __typename?: 'Analytics_AddOpen';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_AddOpenArray = {
  __typename?: 'Analytics_AddOpenArray';
  addId?: Maybe<Scalars['String']>;
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_AdvertisementOpen = {
  __typename?: 'Analytics_AdvertisementOpen';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_AdvertisementOpenArray = {
  __typename?: 'Analytics_AdvertisementOpenArray';
  advertisementId?: Maybe<Scalars['String']>;
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_AdvertisementShow = {
  __typename?: 'Analytics_AdvertisementShow';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  durationAndroidAverage?: Maybe<Scalars['Float']>;
  durationAndroidSum?: Maybe<Scalars['Float']>;
  durationAverage?: Maybe<Scalars['Float']>;
  durationIosAverage?: Maybe<Scalars['Float']>;
  durationIosSum?: Maybe<Scalars['Float']>;
  durationSum?: Maybe<Scalars['Float']>;
  durationWebAverage?: Maybe<Scalars['Float']>;
  durationWebSum?: Maybe<Scalars['Float']>;
  durationWebTeamAverage?: Maybe<Scalars['Float']>;
  durationWebTeamSum?: Maybe<Scalars['Float']>;
  durationWebUserAverage?: Maybe<Scalars['Float']>;
  durationWebUserSum?: Maybe<Scalars['Float']>;
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_AdvertisementShowArray = {
  __typename?: 'Analytics_AdvertisementShowArray';
  advertisementId?: Maybe<Scalars['String']>;
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  durationAndroidAverage?: Maybe<Scalars['Float']>;
  durationAndroidSum?: Maybe<Scalars['Float']>;
  durationAverage?: Maybe<Scalars['Float']>;
  durationIosAverage?: Maybe<Scalars['Float']>;
  durationIosSum?: Maybe<Scalars['Float']>;
  durationSum?: Maybe<Scalars['Float']>;
  durationWebAverage?: Maybe<Scalars['Float']>;
  durationWebSum?: Maybe<Scalars['Float']>;
  durationWebTeamAverage?: Maybe<Scalars['Float']>;
  durationWebTeamSum?: Maybe<Scalars['Float']>;
  durationWebUserAverage?: Maybe<Scalars['Float']>;
  durationWebUserSum?: Maybe<Scalars['Float']>;
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_Bookmark = {
  __typename?: 'Analytics_Bookmark';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
};

export type Analytics_BookmarkReceive = {
  __typename?: 'Analytics_BookmarkReceive';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
};

export type Analytics_ChannelOpen = {
  __typename?: 'Analytics_ChannelOpen';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_ChannelOpenArray = {
  __typename?: 'Analytics_ChannelOpenArray';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  eventViewId?: Maybe<Scalars['String']>;
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_CommunityExhibitors = {
  __typename?: 'Analytics_CommunityExhibitors';
  activity: Analytics_Activity;
  addOpen: Analytics_AddOpen;
  addOpenArray: Array<Analytics_AddOpenArray>;
  advertisementOpen: Analytics_AdvertisementOpen;
  advertisementOpenArray: Array<Analytics_AdvertisementOpenArray>;
  advertisementShow: Analytics_AdvertisementShow;
  advertisementShowArray: Array<Analytics_AdvertisementShowArray>;
  bookmark: Analytics_Bookmark;
  bookmarkReceive: Analytics_BookmarkReceive;
  channelOpen: Analytics_ChannelOpen;
  channelOpenArray: Array<Analytics_ChannelOpenArray>;
  connection: Analytics_Connection;
  connectionReceive: Analytics_ConnectionReceive;
  connectionRequest: Analytics_ConnectionRequest;
  connectionRequestReceive: Analytics_ConnectionRequestReceive;
  contact: Analytics_Contact;
  documentOpen: Analytics_DocumentOpen;
  documentOpenArray: Array<Analytics_DocumentOpenArray>;
  eventShow: Analytics_EventShow;
  eventViewShow: Analytics_EventViewShow;
  eventViewShowArray: Array<Analytics_EventViewShowArray>;
  exhibitorAdvertisementOpen: Analytics_ExhibitorAdvertisementOpen;
  exhibitorAdvertisementOpenArray: Array<Analytics_ExhibitorAdvertisementOpenArray>;
  exhibitorAdvertisementOpenReceive: Analytics_ExhibitorAdvertisementOpenReceive;
  exhibitorAdvertisementOpenReceiveArray: Array<Analytics_ExhibitorAdvertisementOpenReceiveArray>;
  exhibitorAdvertisementShow: Analytics_ExhibitorAdvertisementShow;
  exhibitorAdvertisementShowArray: Array<Analytics_ExhibitorAdvertisementShowArray>;
  exhibitorAdvertisementShowReceive: Analytics_ExhibitorAdvertisementShowReceive;
  exhibitorAdvertisementShowReceiveArray: Array<Analytics_ExhibitorAdvertisementShowReceiveArray>;
  exhibitorBookmark: Analytics_ExhibitorBookmark;
  exhibitorBookmarkArray: Array<Analytics_ExhibitorBookmarkArray>;
  exhibitorBookmarkReceive: Analytics_ExhibitorBookmarkReceive;
  exhibitorId: Scalars['String'];
  exhibitorPopularity: Analytics_ExhibitorPopularity;
  exhibitorSelfShow: Analytics_ExhibitorSelfShow;
  exhibitorShow: Analytics_ExhibitorShow;
  exhibitorShowArray: Array<Analytics_ExhibitorShowArray>;
  exhibitorShowReceive: Analytics_ExhibitorShowReceive;
  interstitialAddShow: Analytics_InterstitialAddShow;
  interstitialAddShowArray: Array<Analytics_InterstitialAddShowArray>;
  meeting: Analytics_Meeting;
  meetingParticipant: Analytics_MeetingParticipant;
  meetingRequest: Analytics_MeetingRequest;
  meetingRequestReceive: Analytics_MeetingRequestReceive;
  message: Analytics_Message;
  messageReceive: Analytics_MessageReceive;
  networkActivity: Analytics_NetworkActivity;
  personShow: Analytics_PersonShow;
  personShowReceive: Analytics_PersonShowReceive;
  planningBookmark: Analytics_PlanningBookmark;
  planningPopularity: Analytics_PlanningPopularity;
  planningStream: Analytics_PlanningStream;
  planningStreamArray: Array<Analytics_PlanningStreamArray>;
  planningStreamStart: Analytics_PlanningStreamStart;
  planningStreamStartArray: Array<Analytics_PlanningStreamStartArray>;
  planningStreamStop: Analytics_PlanningStreamStop;
  planningStreamStopArray: Array<Analytics_PlanningStreamStopArray>;
  postLinkOpen: Analytics_PostLinkOpen;
  postLinkOpenArray: Array<Analytics_PostLinkOpenArray>;
  productBookmark: Analytics_ProductBookmark;
  productBookmarkArray: Array<Analytics_ProductBookmarkArray>;
  productShow: Analytics_ProductShow;
  productShowArray: Array<Analytics_ProductShowArray>;
  registration: Analytics_Registration;
  sponsorShow: Analytics_SponsorShow;
  sponsorShowArray: Array<Analytics_SponsorShowArray>;
  streamStart: Analytics_StreamStart;
  streamStartArray: Array<Analytics_StreamStartArray>;
  streamStop: Analytics_StreamStop;
  streamStopArray: Array<Analytics_StreamStopArray>;
  usage: Analytics_Usage;
  videoCallRoom: Analytics_VideoCallRoom;
};


export type Analytics_CommunityExhibitorsActivityArgs = {
  events?: InputMaybe<Array<Analytics_EventName>>;
};


export type Analytics_CommunityExhibitorsChannelOpenArgs = {
  channel?: InputMaybe<Scalars['String']>;
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsChannelOpenArrayArgs = {
  channel?: InputMaybe<Scalars['String']>;
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsDocumentOpenArgs = {
  documentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsDocumentOpenArrayArgs = {
  documentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsEventViewShowArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsEventViewShowArrayArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsExhibitorAdvertisementOpenArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsExhibitorAdvertisementOpenArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsExhibitorAdvertisementOpenReceiveArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsExhibitorAdvertisementOpenReceiveArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsExhibitorAdvertisementShowArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsExhibitorAdvertisementShowArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsExhibitorAdvertisementShowReceiveArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsExhibitorAdvertisementShowReceiveArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsExhibitorBookmarkArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsExhibitorBookmarkArrayArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsExhibitorBookmarkReceiveArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsExhibitorShowArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_CommunityExhibitorsExhibitorShowArrayArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_CommunityExhibitorsExhibitorShowReceiveArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_CommunityExhibitorsPlanningStreamArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsPlanningStreamArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsPlanningStreamStartArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsPlanningStreamStartArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsPlanningStreamStopArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsPlanningStreamStopArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsPostLinkOpenArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
  postLink?: InputMaybe<Scalars['String']>;
};


export type Analytics_CommunityExhibitorsPostLinkOpenArrayArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
  postLink?: InputMaybe<Scalars['String']>;
};


export type Analytics_CommunityExhibitorsProductBookmarkArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsProductBookmarkArrayArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsProductShowArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_CommunityExhibitorsProductShowArrayArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_CommunityExhibitorsStreamStartArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsStreamStartArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsStreamStopArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityExhibitorsStreamStopArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Analytics_CommunityGroups = {
  __typename?: 'Analytics_CommunityGroups';
  activity: Analytics_Activity;
  addOpen: Analytics_AddOpen;
  addOpenArray: Array<Analytics_AddOpenArray>;
  advertisementOpen: Analytics_AdvertisementOpen;
  advertisementOpenArray: Array<Analytics_AdvertisementOpenArray>;
  advertisementShow: Analytics_AdvertisementShow;
  advertisementShowArray: Array<Analytics_AdvertisementShowArray>;
  bookmark: Analytics_Bookmark;
  bookmarkReceive: Analytics_BookmarkReceive;
  channelOpen: Analytics_ChannelOpen;
  channelOpenArray: Array<Analytics_ChannelOpenArray>;
  connection: Analytics_Connection;
  connectionReceive: Analytics_ConnectionReceive;
  connectionRequest: Analytics_ConnectionRequest;
  connectionRequestReceive: Analytics_ConnectionRequestReceive;
  contact: Analytics_Contact;
  documentOpen: Analytics_DocumentOpen;
  documentOpenArray: Array<Analytics_DocumentOpenArray>;
  eventShow: Analytics_EventShow;
  eventViewShow: Analytics_EventViewShow;
  eventViewShowArray: Array<Analytics_EventViewShowArray>;
  exhibitorAdvertisementOpen: Analytics_ExhibitorAdvertisementOpen;
  exhibitorAdvertisementOpenArray: Array<Analytics_ExhibitorAdvertisementOpenArray>;
  exhibitorAdvertisementOpenReceive: Analytics_ExhibitorAdvertisementOpenReceive;
  exhibitorAdvertisementOpenReceiveArray: Array<Analytics_ExhibitorAdvertisementOpenReceiveArray>;
  exhibitorAdvertisementShow: Analytics_ExhibitorAdvertisementShow;
  exhibitorAdvertisementShowArray: Array<Analytics_ExhibitorAdvertisementShowArray>;
  exhibitorAdvertisementShowReceive: Analytics_ExhibitorAdvertisementShowReceive;
  exhibitorAdvertisementShowReceiveArray: Array<Analytics_ExhibitorAdvertisementShowReceiveArray>;
  exhibitorBookmark: Analytics_ExhibitorBookmark;
  exhibitorBookmarkArray: Array<Analytics_ExhibitorBookmarkArray>;
  exhibitorBookmarkReceive: Analytics_ExhibitorBookmarkReceive;
  exhibitorPopularity: Analytics_ExhibitorPopularity;
  exhibitorSelfShow: Analytics_ExhibitorSelfShow;
  exhibitorShow: Analytics_ExhibitorShow;
  exhibitorShowArray: Array<Analytics_ExhibitorShowArray>;
  exhibitorShowReceive: Analytics_ExhibitorShowReceive;
  groupId: Scalars['String'];
  interstitialAddShow: Analytics_InterstitialAddShow;
  interstitialAddShowArray: Array<Analytics_InterstitialAddShowArray>;
  meeting: Analytics_Meeting;
  meetingParticipant: Analytics_MeetingParticipant;
  meetingRequest: Analytics_MeetingRequest;
  meetingRequestReceive: Analytics_MeetingRequestReceive;
  message: Analytics_Message;
  messageReceive: Analytics_MessageReceive;
  networkActivity: Analytics_NetworkActivity;
  personShow: Analytics_PersonShow;
  personShowReceive: Analytics_PersonShowReceive;
  planningBookmark: Analytics_PlanningBookmark;
  planningPopularity: Analytics_PlanningPopularity;
  planningStream: Analytics_PlanningStream;
  planningStreamArray: Array<Analytics_PlanningStreamArray>;
  planningStreamStart: Analytics_PlanningStreamStart;
  planningStreamStartArray: Array<Analytics_PlanningStreamStartArray>;
  planningStreamStop: Analytics_PlanningStreamStop;
  planningStreamStopArray: Array<Analytics_PlanningStreamStopArray>;
  postLinkOpen: Analytics_PostLinkOpen;
  postLinkOpenArray: Array<Analytics_PostLinkOpenArray>;
  productBookmark: Analytics_ProductBookmark;
  productBookmarkArray: Array<Analytics_ProductBookmarkArray>;
  productShow: Analytics_ProductShow;
  productShowArray: Array<Analytics_ProductShowArray>;
  registration: Analytics_Registration;
  sponsorShow: Analytics_SponsorShow;
  sponsorShowArray: Array<Analytics_SponsorShowArray>;
  streamStart: Analytics_StreamStart;
  streamStartArray: Array<Analytics_StreamStartArray>;
  streamStop: Analytics_StreamStop;
  streamStopArray: Array<Analytics_StreamStopArray>;
  usage: Analytics_Usage;
  videoCallRoom: Analytics_VideoCallRoom;
};


export type Analytics_CommunityGroupsActivityArgs = {
  events?: InputMaybe<Array<Analytics_EventName>>;
};


export type Analytics_CommunityGroupsChannelOpenArgs = {
  channel?: InputMaybe<Scalars['String']>;
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsChannelOpenArrayArgs = {
  channel?: InputMaybe<Scalars['String']>;
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsDocumentOpenArgs = {
  documentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsDocumentOpenArrayArgs = {
  documentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsEventViewShowArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsEventViewShowArrayArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsExhibitorAdvertisementOpenArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsExhibitorAdvertisementOpenArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsExhibitorAdvertisementOpenReceiveArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsExhibitorAdvertisementOpenReceiveArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsExhibitorAdvertisementShowArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsExhibitorAdvertisementShowArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsExhibitorAdvertisementShowReceiveArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsExhibitorAdvertisementShowReceiveArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsExhibitorBookmarkArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsExhibitorBookmarkArrayArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsExhibitorBookmarkReceiveArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsExhibitorShowArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_CommunityGroupsExhibitorShowArrayArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_CommunityGroupsExhibitorShowReceiveArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_CommunityGroupsPlanningStreamArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsPlanningStreamArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsPlanningStreamStartArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsPlanningStreamStartArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsPlanningStreamStopArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsPlanningStreamStopArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsPostLinkOpenArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
  postLink?: InputMaybe<Scalars['String']>;
};


export type Analytics_CommunityGroupsPostLinkOpenArrayArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
  postLink?: InputMaybe<Scalars['String']>;
};


export type Analytics_CommunityGroupsProductBookmarkArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsProductBookmarkArrayArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsProductShowArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_CommunityGroupsProductShowArrayArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_CommunityGroupsStreamStartArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsStreamStartArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsStreamStopArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityGroupsStreamStopArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Analytics_CommunityPlannings = {
  __typename?: 'Analytics_CommunityPlannings';
  planningBookmark: Analytics_PlanningBookmark;
  planningId: Scalars['String'];
  planningPopularity: Analytics_PlanningPopularity;
  planningStream: Analytics_PlanningStream;
  planningStreamArray: Array<Analytics_PlanningStreamArray>;
  planningStreamStart: Analytics_PlanningStreamStart;
  planningStreamStartArray: Array<Analytics_PlanningStreamStartArray>;
  planningStreamStop: Analytics_PlanningStreamStop;
  planningStreamStopArray: Array<Analytics_PlanningStreamStopArray>;
};


export type Analytics_CommunityPlanningsPlanningStreamArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityPlanningsPlanningStreamArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityPlanningsPlanningStreamStartArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityPlanningsPlanningStreamStartArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityPlanningsPlanningStreamStopArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityPlanningsPlanningStreamStopArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Analytics_CommunityUsers = {
  __typename?: 'Analytics_CommunityUsers';
  activity: Analytics_Activity;
  addOpen: Analytics_AddOpen;
  addOpenArray: Array<Analytics_AddOpenArray>;
  advertisementOpen: Analytics_AdvertisementOpen;
  advertisementOpenArray: Array<Analytics_AdvertisementOpenArray>;
  advertisementShow: Analytics_AdvertisementShow;
  advertisementShowArray: Array<Analytics_AdvertisementShowArray>;
  bookmark: Analytics_Bookmark;
  bookmarkReceive: Analytics_BookmarkReceive;
  channelOpen: Analytics_ChannelOpen;
  channelOpenArray: Array<Analytics_ChannelOpenArray>;
  connection: Analytics_Connection;
  connectionReceive: Analytics_ConnectionReceive;
  connectionRequest: Analytics_ConnectionRequest;
  connectionRequestReceive: Analytics_ConnectionRequestReceive;
  contact: Analytics_Contact;
  documentOpen: Analytics_DocumentOpen;
  documentOpenArray: Array<Analytics_DocumentOpenArray>;
  eventShow: Analytics_EventShow;
  eventViewShow: Analytics_EventViewShow;
  eventViewShowArray: Array<Analytics_EventViewShowArray>;
  exhibitorAdvertisementOpen: Analytics_ExhibitorAdvertisementOpen;
  exhibitorAdvertisementOpenArray: Array<Analytics_ExhibitorAdvertisementOpenArray>;
  exhibitorAdvertisementOpenReceive: Analytics_ExhibitorAdvertisementOpenReceive;
  exhibitorAdvertisementOpenReceiveArray: Array<Analytics_ExhibitorAdvertisementOpenReceiveArray>;
  exhibitorAdvertisementShow: Analytics_ExhibitorAdvertisementShow;
  exhibitorAdvertisementShowArray: Array<Analytics_ExhibitorAdvertisementShowArray>;
  exhibitorAdvertisementShowReceive: Analytics_ExhibitorAdvertisementShowReceive;
  exhibitorAdvertisementShowReceiveArray: Array<Analytics_ExhibitorAdvertisementShowReceiveArray>;
  exhibitorBookmark: Analytics_ExhibitorBookmark;
  exhibitorBookmarkArray: Array<Analytics_ExhibitorBookmarkArray>;
  exhibitorBookmarkReceive: Analytics_ExhibitorBookmarkReceive;
  exhibitorPopularity: Analytics_ExhibitorPopularity;
  exhibitorSelfShow: Analytics_ExhibitorSelfShow;
  exhibitorShow: Analytics_ExhibitorShow;
  exhibitorShowArray: Array<Analytics_ExhibitorShowArray>;
  exhibitorShowReceive: Analytics_ExhibitorShowReceive;
  interstitialAddShow: Analytics_InterstitialAddShow;
  interstitialAddShowArray: Array<Analytics_InterstitialAddShowArray>;
  meeting: Analytics_Meeting;
  meetingParticipant: Analytics_MeetingParticipant;
  meetingRequest: Analytics_MeetingRequest;
  meetingRequestReceive: Analytics_MeetingRequestReceive;
  message: Analytics_Message;
  messageReceive: Analytics_MessageReceive;
  networkActivity: Analytics_NetworkActivity;
  personShow: Analytics_PersonShow;
  personShowReceive: Analytics_PersonShowReceive;
  planningBookmark: Analytics_PlanningBookmark;
  planningPopularity: Analytics_PlanningPopularity;
  planningStream: Analytics_PlanningStream;
  planningStreamArray: Array<Analytics_PlanningStreamArray>;
  planningStreamStart: Analytics_PlanningStreamStart;
  planningStreamStartArray: Array<Analytics_PlanningStreamStartArray>;
  planningStreamStop: Analytics_PlanningStreamStop;
  planningStreamStopArray: Array<Analytics_PlanningStreamStopArray>;
  postLinkOpen: Analytics_PostLinkOpen;
  postLinkOpenArray: Array<Analytics_PostLinkOpenArray>;
  productBookmark: Analytics_ProductBookmark;
  productBookmarkArray: Array<Analytics_ProductBookmarkArray>;
  productShow: Analytics_ProductShow;
  productShowArray: Array<Analytics_ProductShowArray>;
  registration: Analytics_Registration;
  sponsorShow: Analytics_SponsorShow;
  sponsorShowArray: Array<Analytics_SponsorShowArray>;
  streamStart: Analytics_StreamStart;
  streamStartArray: Array<Analytics_StreamStartArray>;
  streamStop: Analytics_StreamStop;
  streamStopArray: Array<Analytics_StreamStopArray>;
  usage: Analytics_Usage;
  userId: Scalars['String'];
  videoCallRoom: Analytics_VideoCallRoom;
};


export type Analytics_CommunityUsersActivityArgs = {
  events?: InputMaybe<Array<Analytics_EventName>>;
};


export type Analytics_CommunityUsersChannelOpenArgs = {
  channel?: InputMaybe<Scalars['String']>;
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersChannelOpenArrayArgs = {
  channel?: InputMaybe<Scalars['String']>;
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersDocumentOpenArgs = {
  documentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersDocumentOpenArrayArgs = {
  documentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersEventViewShowArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersEventViewShowArrayArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersExhibitorAdvertisementOpenArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersExhibitorAdvertisementOpenArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersExhibitorAdvertisementOpenReceiveArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersExhibitorAdvertisementOpenReceiveArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersExhibitorAdvertisementShowArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersExhibitorAdvertisementShowArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersExhibitorAdvertisementShowReceiveArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersExhibitorAdvertisementShowReceiveArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersExhibitorBookmarkArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersExhibitorBookmarkArrayArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersExhibitorBookmarkReceiveArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersExhibitorShowArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_CommunityUsersExhibitorShowArrayArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_CommunityUsersExhibitorShowReceiveArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_CommunityUsersPlanningStreamArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersPlanningStreamArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersPlanningStreamStartArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersPlanningStreamStartArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersPlanningStreamStopArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersPlanningStreamStopArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersPostLinkOpenArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
  postLink?: InputMaybe<Scalars['String']>;
};


export type Analytics_CommunityUsersPostLinkOpenArrayArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
  postLink?: InputMaybe<Scalars['String']>;
};


export type Analytics_CommunityUsersProductBookmarkArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersProductBookmarkArrayArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersProductShowArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_CommunityUsersProductShowArrayArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_CommunityUsersStreamStartArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersStreamStartArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersStreamStopArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityUsersStreamStopArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Analytics_CommunityWrapper = {
  __typename?: 'Analytics_CommunityWrapper';
  communityExhibitors: Array<Analytics_CommunityExhibitors>;
  communityPlannings: Array<Analytics_CommunityPlannings>;
  communityUsers: Array<Analytics_CommunityUsers>;
  metric: Analytics_Metric;
  timeline: Array<Analytics_Timeline>;
};


export type Analytics_CommunityWrapperCommunityExhibitorsArgs = {
  after?: InputMaybe<Scalars['Analytics_Date']>;
  before?: InputMaybe<Scalars['Analytics_Date']>;
  eventIdIsNull?: InputMaybe<Scalars['Boolean']>;
  eventIds?: InputMaybe<Array<Scalars['ID']>>;
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  sort?: InputMaybe<Analytics_SortCommunityExhibitors>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
  withExhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  withGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  withUserIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityWrapperCommunityPlanningsArgs = {
  after?: InputMaybe<Scalars['Analytics_Date']>;
  before?: InputMaybe<Scalars['Analytics_Date']>;
  eventIdIsNull?: InputMaybe<Scalars['Boolean']>;
  eventIds?: InputMaybe<Array<Scalars['ID']>>;
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  sort?: InputMaybe<Analytics_SortCommunityPlannings>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
  withExhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  withGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  withUserIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityWrapperCommunityUsersArgs = {
  after?: InputMaybe<Scalars['Analytics_Date']>;
  before?: InputMaybe<Scalars['Analytics_Date']>;
  eventIdIsNull?: InputMaybe<Scalars['Boolean']>;
  eventIds?: InputMaybe<Array<Scalars['ID']>>;
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  sort?: InputMaybe<Analytics_SortCommunityUsers>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
  withExhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  withGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  withUserIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityWrapperMetricArgs = {
  after?: InputMaybe<Scalars['Analytics_Date']>;
  before?: InputMaybe<Scalars['Analytics_Date']>;
  eventIdIsNull?: InputMaybe<Scalars['Boolean']>;
  eventIds?: InputMaybe<Array<Scalars['ID']>>;
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
  withExhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  withGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  withUserIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_CommunityWrapperTimelineArgs = {
  after?: InputMaybe<Scalars['Analytics_Date']>;
  before?: InputMaybe<Scalars['Analytics_Date']>;
  eventIdIsNull?: InputMaybe<Scalars['Boolean']>;
  eventIds?: InputMaybe<Array<Scalars['ID']>>;
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  gapfill?: InputMaybe<Scalars['Boolean']>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  interval: Analytics_Interval;
  timezone?: InputMaybe<Scalars['String']>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
  weekStart?: InputMaybe<Analytics_WeekDay>;
  withExhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  withGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  withUserIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Analytics_Connection = {
  __typename?: 'Analytics_Connection';
  allCount: Scalars['Int'];
  allUnique: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  allWithUniqueUser: Scalars['Int'];
  notScanCount: Scalars['Int'];
  notScanUnique: Scalars['Int'];
  notScanUniqueUser: Scalars['Int'];
  notScanWithUniqueUser: Scalars['Int'];
  scanCount: Scalars['Int'];
  scanUnique: Scalars['Int'];
  scanUniqueUser: Scalars['Int'];
  scanWithUniqueUser: Scalars['Int'];
  scoreAverage?: Maybe<Scalars['Float']>;
  scoreCount: Scalars['Int'];
  scoreHistogram?: Maybe<Analytics_Histogram>;
  scoreUnique: Scalars['Int'];
  scoreUniqueUser: Scalars['Int'];
  scoreWithUniqueUser: Scalars['Int'];
};

export type Analytics_ConnectionReceive = {
  __typename?: 'Analytics_ConnectionReceive';
  allCount: Scalars['Int'];
  allUnique: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  allWithUniqueUser: Scalars['Int'];
  notScanCount: Scalars['Int'];
  notScanUnique: Scalars['Int'];
  notScanUniqueUser: Scalars['Int'];
  notScanWithUniqueUser: Scalars['Int'];
  scanCount: Scalars['Int'];
  scanUnique: Scalars['Int'];
  scanUniqueUser: Scalars['Int'];
  scanWithUniqueUser: Scalars['Int'];
  scoreAverage?: Maybe<Scalars['Float']>;
  scoreCount: Scalars['Int'];
  scoreHistogram?: Maybe<Analytics_Histogram>;
  scoreUnique: Scalars['Int'];
  scoreUniqueUser: Scalars['Int'];
  scoreWithUniqueUser: Scalars['Int'];
};

export type Analytics_ConnectionRequest = {
  __typename?: 'Analytics_ConnectionRequest';
  acceptedCount: Scalars['Int'];
  acceptedUniqueUser: Scalars['Int'];
  acceptedWithUniqueUser: Scalars['Int'];
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  allWithUniqueUser: Scalars['Int'];
  declinedCount: Scalars['Int'];
  declinedUniqueUser: Scalars['Int'];
  declinedWithUniqueUser: Scalars['Int'];
  pendingCount: Scalars['Int'];
  pendingUniqueUser: Scalars['Int'];
  pendingWithUniqueUser: Scalars['Int'];
};

export type Analytics_ConnectionRequestReceive = {
  __typename?: 'Analytics_ConnectionRequestReceive';
  acceptedCount: Scalars['Int'];
  acceptedUniqueUser: Scalars['Int'];
  acceptedWithUniqueUser: Scalars['Int'];
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  allWithUniqueUser: Scalars['Int'];
  declinedCount: Scalars['Int'];
  declinedUniqueUser: Scalars['Int'];
  declinedWithUniqueUser: Scalars['Int'];
  pendingCount: Scalars['Int'];
  pendingUniqueUser: Scalars['Int'];
  pendingWithUniqueUser: Scalars['Int'];
};

export type Analytics_Contact = {
  __typename?: 'Analytics_Contact';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  notScanCount: Scalars['Int'];
  notScanUniqueUser: Scalars['Int'];
  scanCount: Scalars['Int'];
  scanUniqueUser: Scalars['Int'];
};

export type Analytics_DocumentOpen = {
  __typename?: 'Analytics_DocumentOpen';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
};

export type Analytics_DocumentOpenArray = {
  __typename?: 'Analytics_DocumentOpenArray';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  documentId?: Maybe<Scalars['String']>;
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
};

export type Analytics_DocumentOpenRow = {
  __typename?: 'Analytics_DocumentOpenRow';
  createdAt: Scalars['Analytics_Date'];
  cursor: Scalars['String'];
  documentId?: Maybe<Scalars['String']>;
  eventId: Scalars['ID'];
  userId?: Maybe<Scalars['ID']>;
};

export enum Analytics_EventName {
  ChannelOpen = 'channel_open',
  ConnectionCreate = 'connection_create',
  ConnectionRequestCreate = 'connection_request_create',
  ConnectionRequestUpdate = 'connection_request_update',
  ConnectionUpdate = 'connection_update',
  ContactConnectionCreate = 'contact_connection_create',
  DocumentOpen = 'document_open',
  EventAdvertisementOpen = 'event_advertisement_open',
  EventAdvertisementShow = 'event_advertisement_show',
  EventShow = 'event_show',
  EventStart = 'event_start',
  EventStop = 'event_stop',
  EventViewShow = 'event_view_show',
  ExhibitorAdvertisementOpen = 'exhibitor_advertisement_open',
  ExhibitorAdvertisementShow = 'exhibitor_advertisement_show',
  ExhibitorBookmarkCreate = 'exhibitor_bookmark_create',
  ExhibitorSelfShow = 'exhibitor_self_show',
  ExhibitorShow = 'exhibitor_show',
  ExhibitorStart = 'exhibitor_start',
  ExhibitorStop = 'exhibitor_stop',
  ExhibitorsViewFilter = 'exhibitors_view_filter',
  ExhibitorsViewSearch = 'exhibitors_view_search',
  MeetingCreate = 'meeting_create',
  MeetingParticipantCreate = 'meeting_participant_create',
  MeetingParticipantUpdate = 'meeting_participant_update',
  MeetingRequestCreate = 'meeting_request_create',
  MeetingRequestDelete = 'meeting_request_delete',
  MeetingRequestUpdate = 'meeting_request_update',
  MeetingUpdate = 'meeting_update',
  MessageCreate = 'message_create',
  PeopleViewFilter = 'people_view_filter',
  PeopleViewSearch = 'people_view_search',
  PersonShow = 'person_show',
  PlanningBookmarkCreate = 'planning_bookmark_create',
  PlanningScanCreate = 'planning_scan_create',
  PlanningStreamStart = 'planning_stream_start',
  PlanningStreamStop = 'planning_stream_stop',
  PlanningsViewFilter = 'plannings_view_filter',
  PlanningsViewSearch = 'plannings_view_search',
  PostLinkOpen = 'post_link_open',
  ProductBookmarkCreate = 'product_bookmark_create',
  ProductShow = 'product_show',
  ProductsViewFilter = 'products_view_filter',
  ProductsViewSearch = 'products_view_search',
  RegistrationUpdate = 'registration_update',
  SponsorShow = 'sponsor_show',
  StreamStart = 'stream_start',
  StreamStop = 'stream_stop',
  VideoCallRoomEnd = 'video_call_room_end'
}

export type Analytics_EventShow = {
  __typename?: 'Analytics_EventShow';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_EventViewShow = {
  __typename?: 'Analytics_EventViewShow';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_EventViewShowArray = {
  __typename?: 'Analytics_EventViewShowArray';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  eventViewId?: Maybe<Scalars['String']>;
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_EventWrapper = {
  __typename?: 'Analytics_EventWrapper';
  exhibitors: Array<Analytics_Exhibitors>;
  metric: Analytics_Metric;
  plannings: Array<Analytics_Plannings>;
  timeline: Array<Analytics_Timeline>;
  users: Array<Analytics_Users>;
};


export type Analytics_EventWrapperExhibitorsArgs = {
  after?: InputMaybe<Scalars['Analytics_Date']>;
  before?: InputMaybe<Scalars['Analytics_Date']>;
  communityIds?: InputMaybe<Array<Scalars['ID']>>;
  eventIdIsNull?: InputMaybe<Scalars['Boolean']>;
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  sort?: InputMaybe<Analytics_SortExhibitors>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
  withExhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  withGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  withUserIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventWrapperMetricArgs = {
  after?: InputMaybe<Scalars['Analytics_Date']>;
  before?: InputMaybe<Scalars['Analytics_Date']>;
  communityIds?: InputMaybe<Array<Scalars['ID']>>;
  eventIdIsNull?: InputMaybe<Scalars['Boolean']>;
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
  withExhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  withGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  withUserIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventWrapperPlanningsArgs = {
  after?: InputMaybe<Scalars['Analytics_Date']>;
  before?: InputMaybe<Scalars['Analytics_Date']>;
  communityIds?: InputMaybe<Array<Scalars['ID']>>;
  eventIdIsNull?: InputMaybe<Scalars['Boolean']>;
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  sort?: InputMaybe<Analytics_SortPlannings>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
  withExhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  withGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  withUserIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventWrapperTimelineArgs = {
  after?: InputMaybe<Scalars['Analytics_Date']>;
  before?: InputMaybe<Scalars['Analytics_Date']>;
  communityIds?: InputMaybe<Array<Scalars['ID']>>;
  eventIdIsNull?: InputMaybe<Scalars['Boolean']>;
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  gapfill?: InputMaybe<Scalars['Boolean']>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  interval: Analytics_Interval;
  timezone?: InputMaybe<Scalars['String']>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
  weekStart?: InputMaybe<Analytics_WeekDay>;
  withExhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  withGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  withUserIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventWrapperUsersArgs = {
  after?: InputMaybe<Scalars['Analytics_Date']>;
  before?: InputMaybe<Scalars['Analytics_Date']>;
  communityIds?: InputMaybe<Array<Scalars['ID']>>;
  eventIdIsNull?: InputMaybe<Scalars['Boolean']>;
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  sort?: InputMaybe<Analytics_SortUsers>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
  withExhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  withGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  withUserIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Analytics_Events = {
  __typename?: 'Analytics_Events';
  activity: Analytics_Activity;
  addOpen: Analytics_AddOpen;
  addOpenArray: Array<Analytics_AddOpenArray>;
  advertisementOpen: Analytics_AdvertisementOpen;
  advertisementOpenArray: Array<Analytics_AdvertisementOpenArray>;
  advertisementShow: Analytics_AdvertisementShow;
  advertisementShowArray: Array<Analytics_AdvertisementShowArray>;
  bookmark: Analytics_Bookmark;
  bookmarkReceive: Analytics_BookmarkReceive;
  channelOpen: Analytics_ChannelOpen;
  channelOpenArray: Array<Analytics_ChannelOpenArray>;
  communityId: Scalars['String'];
  connection: Analytics_Connection;
  connectionReceive: Analytics_ConnectionReceive;
  connectionRequest: Analytics_ConnectionRequest;
  connectionRequestReceive: Analytics_ConnectionRequestReceive;
  contact: Analytics_Contact;
  documentOpen: Analytics_DocumentOpen;
  documentOpenArray: Array<Analytics_DocumentOpenArray>;
  eventId: Scalars['String'];
  eventShow: Analytics_EventShow;
  eventViewShow: Analytics_EventViewShow;
  eventViewShowArray: Array<Analytics_EventViewShowArray>;
  exhibitorAdvertisementOpen: Analytics_ExhibitorAdvertisementOpen;
  exhibitorAdvertisementOpenArray: Array<Analytics_ExhibitorAdvertisementOpenArray>;
  exhibitorAdvertisementOpenReceive: Analytics_ExhibitorAdvertisementOpenReceive;
  exhibitorAdvertisementOpenReceiveArray: Array<Analytics_ExhibitorAdvertisementOpenReceiveArray>;
  exhibitorAdvertisementShow: Analytics_ExhibitorAdvertisementShow;
  exhibitorAdvertisementShowArray: Array<Analytics_ExhibitorAdvertisementShowArray>;
  exhibitorAdvertisementShowReceive: Analytics_ExhibitorAdvertisementShowReceive;
  exhibitorAdvertisementShowReceiveArray: Array<Analytics_ExhibitorAdvertisementShowReceiveArray>;
  exhibitorBookmark: Analytics_ExhibitorBookmark;
  exhibitorBookmarkArray: Array<Analytics_ExhibitorBookmarkArray>;
  exhibitorBookmarkReceive: Analytics_ExhibitorBookmarkReceive;
  exhibitorPopularity: Analytics_ExhibitorPopularity;
  exhibitorSelfShow: Analytics_ExhibitorSelfShow;
  exhibitorShow: Analytics_ExhibitorShow;
  exhibitorShowArray: Array<Analytics_ExhibitorShowArray>;
  exhibitorShowReceive: Analytics_ExhibitorShowReceive;
  interstitialAddShow: Analytics_InterstitialAddShow;
  interstitialAddShowArray: Array<Analytics_InterstitialAddShowArray>;
  meeting: Analytics_Meeting;
  meetingParticipant: Analytics_MeetingParticipant;
  meetingRequest: Analytics_MeetingRequest;
  meetingRequestReceive: Analytics_MeetingRequestReceive;
  message: Analytics_Message;
  messageReceive: Analytics_MessageReceive;
  networkActivity: Analytics_NetworkActivity;
  personShow: Analytics_PersonShow;
  personShowReceive: Analytics_PersonShowReceive;
  planningBookmark: Analytics_PlanningBookmark;
  planningPopularity: Analytics_PlanningPopularity;
  planningStream: Analytics_PlanningStream;
  planningStreamArray: Array<Analytics_PlanningStreamArray>;
  planningStreamStart: Analytics_PlanningStreamStart;
  planningStreamStartArray: Array<Analytics_PlanningStreamStartArray>;
  planningStreamStop: Analytics_PlanningStreamStop;
  planningStreamStopArray: Array<Analytics_PlanningStreamStopArray>;
  postLinkOpen: Analytics_PostLinkOpen;
  postLinkOpenArray: Array<Analytics_PostLinkOpenArray>;
  productBookmark: Analytics_ProductBookmark;
  productBookmarkArray: Array<Analytics_ProductBookmarkArray>;
  productShow: Analytics_ProductShow;
  productShowArray: Array<Analytics_ProductShowArray>;
  registration: Analytics_Registration;
  sponsorShow: Analytics_SponsorShow;
  sponsorShowArray: Array<Analytics_SponsorShowArray>;
  streamStart: Analytics_StreamStart;
  streamStartArray: Array<Analytics_StreamStartArray>;
  streamStop: Analytics_StreamStop;
  streamStopArray: Array<Analytics_StreamStopArray>;
  usage: Analytics_Usage;
  videoCallRoom: Analytics_VideoCallRoom;
};


export type Analytics_EventsActivityArgs = {
  events?: InputMaybe<Array<Analytics_EventName>>;
};


export type Analytics_EventsChannelOpenArgs = {
  channel?: InputMaybe<Scalars['String']>;
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsChannelOpenArrayArgs = {
  channel?: InputMaybe<Scalars['String']>;
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsDocumentOpenArgs = {
  documentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsDocumentOpenArrayArgs = {
  documentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsEventViewShowArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsEventViewShowArrayArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsExhibitorAdvertisementOpenArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsExhibitorAdvertisementOpenArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsExhibitorAdvertisementOpenReceiveArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsExhibitorAdvertisementOpenReceiveArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsExhibitorAdvertisementShowArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsExhibitorAdvertisementShowArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsExhibitorAdvertisementShowReceiveArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsExhibitorAdvertisementShowReceiveArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsExhibitorBookmarkArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsExhibitorBookmarkArrayArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsExhibitorBookmarkReceiveArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsExhibitorShowArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_EventsExhibitorShowArrayArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_EventsExhibitorShowReceiveArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_EventsPlanningStreamArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsPlanningStreamArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsPlanningStreamStartArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsPlanningStreamStartArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsPlanningStreamStopArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsPlanningStreamStopArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsPostLinkOpenArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
  postLink?: InputMaybe<Scalars['String']>;
};


export type Analytics_EventsPostLinkOpenArrayArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
  postLink?: InputMaybe<Scalars['String']>;
};


export type Analytics_EventsProductBookmarkArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsProductBookmarkArrayArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsProductShowArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_EventsProductShowArrayArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_EventsStreamStartArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsStreamStartArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsStreamStopArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_EventsStreamStopArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Analytics_ExhibitorAdvertisementOpen = {
  __typename?: 'Analytics_ExhibitorAdvertisementOpen';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_ExhibitorAdvertisementOpenArray = {
  __typename?: 'Analytics_ExhibitorAdvertisementOpenArray';
  advertisementId?: Maybe<Scalars['String']>;
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_ExhibitorAdvertisementOpenReceive = {
  __typename?: 'Analytics_ExhibitorAdvertisementOpenReceive';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_ExhibitorAdvertisementOpenReceiveArray = {
  __typename?: 'Analytics_ExhibitorAdvertisementOpenReceiveArray';
  advertisementId?: Maybe<Scalars['String']>;
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_ExhibitorAdvertisementOpenRow = {
  __typename?: 'Analytics_ExhibitorAdvertisementOpenRow';
  advertisementId?: Maybe<Scalars['String']>;
  createdAt: Scalars['Analytics_Date'];
  cursor: Scalars['String'];
  eventId: Scalars['ID'];
  userId?: Maybe<Scalars['ID']>;
};

export type Analytics_ExhibitorAdvertisementShow = {
  __typename?: 'Analytics_ExhibitorAdvertisementShow';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_ExhibitorAdvertisementShowArray = {
  __typename?: 'Analytics_ExhibitorAdvertisementShowArray';
  advertisementId?: Maybe<Scalars['String']>;
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_ExhibitorAdvertisementShowReceive = {
  __typename?: 'Analytics_ExhibitorAdvertisementShowReceive';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_ExhibitorAdvertisementShowReceiveArray = {
  __typename?: 'Analytics_ExhibitorAdvertisementShowReceiveArray';
  advertisementId?: Maybe<Scalars['String']>;
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_ExhibitorAdvertisementShowRow = {
  __typename?: 'Analytics_ExhibitorAdvertisementShowRow';
  advertisementId?: Maybe<Scalars['String']>;
  createdAt: Scalars['Analytics_Date'];
  cursor: Scalars['String'];
  eventId: Scalars['ID'];
  userId?: Maybe<Scalars['ID']>;
};

export type Analytics_ExhibitorBookmark = {
  __typename?: 'Analytics_ExhibitorBookmark';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
};

export type Analytics_ExhibitorBookmarkArray = {
  __typename?: 'Analytics_ExhibitorBookmarkArray';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  exhibitorId?: Maybe<Scalars['String']>;
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
};

export type Analytics_ExhibitorBookmarkReceive = {
  __typename?: 'Analytics_ExhibitorBookmarkReceive';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
};

export type Analytics_ExhibitorPopularity = {
  __typename?: 'Analytics_ExhibitorPopularity';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_ExhibitorSelfShow = {
  __typename?: 'Analytics_ExhibitorSelfShow';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_ExhibitorShow = {
  __typename?: 'Analytics_ExhibitorShow';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_ExhibitorShowArray = {
  __typename?: 'Analytics_ExhibitorShowArray';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  exhibitorId?: Maybe<Scalars['String']>;
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_ExhibitorShowReceive = {
  __typename?: 'Analytics_ExhibitorShowReceive';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_ExhibitorShowRow = {
  __typename?: 'Analytics_ExhibitorShowRow';
  createdAt: Scalars['Analytics_Date'];
  cursor: Scalars['String'];
  eventId: Scalars['ID'];
  exhibitorId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export type Analytics_ExhibitorWrapper = {
  __typename?: 'Analytics_ExhibitorWrapper';
  metric: Analytics_Metric;
  timeline: Array<Analytics_Timeline>;
  users: Array<Analytics_Users>;
};


export type Analytics_ExhibitorWrapperMetricArgs = {
  after?: InputMaybe<Scalars['Analytics_Date']>;
  before?: InputMaybe<Scalars['Analytics_Date']>;
  communityIds?: InputMaybe<Array<Scalars['ID']>>;
  eventIdIsNull?: InputMaybe<Scalars['Boolean']>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
  withExhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  withGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  withUserIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorWrapperTimelineArgs = {
  after?: InputMaybe<Scalars['Analytics_Date']>;
  before?: InputMaybe<Scalars['Analytics_Date']>;
  communityIds?: InputMaybe<Array<Scalars['ID']>>;
  eventIdIsNull?: InputMaybe<Scalars['Boolean']>;
  gapfill?: InputMaybe<Scalars['Boolean']>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  interval: Analytics_Interval;
  timezone?: InputMaybe<Scalars['String']>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
  weekStart?: InputMaybe<Analytics_WeekDay>;
  withExhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  withGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  withUserIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorWrapperUsersArgs = {
  after?: InputMaybe<Scalars['Analytics_Date']>;
  before?: InputMaybe<Scalars['Analytics_Date']>;
  communityIds?: InputMaybe<Array<Scalars['ID']>>;
  eventIdIsNull?: InputMaybe<Scalars['Boolean']>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  sort?: InputMaybe<Analytics_SortUsers>;
  userIdIsNull?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
  withExhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  withGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  withUserIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Analytics_Exhibitors = {
  __typename?: 'Analytics_Exhibitors';
  activity: Analytics_Activity;
  addOpen: Analytics_AddOpen;
  addOpenArray: Array<Analytics_AddOpenArray>;
  advertisementOpen: Analytics_AdvertisementOpen;
  advertisementOpenArray: Array<Analytics_AdvertisementOpenArray>;
  advertisementShow: Analytics_AdvertisementShow;
  advertisementShowArray: Array<Analytics_AdvertisementShowArray>;
  bookmark: Analytics_Bookmark;
  bookmarkReceive: Analytics_BookmarkReceive;
  channelOpen: Analytics_ChannelOpen;
  channelOpenArray: Array<Analytics_ChannelOpenArray>;
  connection: Analytics_Connection;
  connectionReceive: Analytics_ConnectionReceive;
  connectionRequest: Analytics_ConnectionRequest;
  connectionRequestReceive: Analytics_ConnectionRequestReceive;
  contact: Analytics_Contact;
  documentOpen: Analytics_DocumentOpen;
  documentOpenArray: Array<Analytics_DocumentOpenArray>;
  eventShow: Analytics_EventShow;
  eventViewShow: Analytics_EventViewShow;
  eventViewShowArray: Array<Analytics_EventViewShowArray>;
  exhibitorAdvertisementOpen: Analytics_ExhibitorAdvertisementOpen;
  exhibitorAdvertisementOpenArray: Array<Analytics_ExhibitorAdvertisementOpenArray>;
  exhibitorAdvertisementOpenReceive: Analytics_ExhibitorAdvertisementOpenReceive;
  exhibitorAdvertisementOpenReceiveArray: Array<Analytics_ExhibitorAdvertisementOpenReceiveArray>;
  exhibitorAdvertisementShow: Analytics_ExhibitorAdvertisementShow;
  exhibitorAdvertisementShowArray: Array<Analytics_ExhibitorAdvertisementShowArray>;
  exhibitorAdvertisementShowReceive: Analytics_ExhibitorAdvertisementShowReceive;
  exhibitorAdvertisementShowReceiveArray: Array<Analytics_ExhibitorAdvertisementShowReceiveArray>;
  exhibitorBookmark: Analytics_ExhibitorBookmark;
  exhibitorBookmarkArray: Array<Analytics_ExhibitorBookmarkArray>;
  exhibitorBookmarkReceive: Analytics_ExhibitorBookmarkReceive;
  exhibitorId: Scalars['String'];
  exhibitorPopularity: Analytics_ExhibitorPopularity;
  exhibitorSelfShow: Analytics_ExhibitorSelfShow;
  exhibitorShow: Analytics_ExhibitorShow;
  exhibitorShowArray: Array<Analytics_ExhibitorShowArray>;
  exhibitorShowReceive: Analytics_ExhibitorShowReceive;
  interstitialAddShow: Analytics_InterstitialAddShow;
  interstitialAddShowArray: Array<Analytics_InterstitialAddShowArray>;
  meeting: Analytics_Meeting;
  meetingParticipant: Analytics_MeetingParticipant;
  meetingRequest: Analytics_MeetingRequest;
  meetingRequestReceive: Analytics_MeetingRequestReceive;
  message: Analytics_Message;
  messageReceive: Analytics_MessageReceive;
  networkActivity: Analytics_NetworkActivity;
  personShow: Analytics_PersonShow;
  personShowReceive: Analytics_PersonShowReceive;
  planningBookmark: Analytics_PlanningBookmark;
  planningPopularity: Analytics_PlanningPopularity;
  planningStream: Analytics_PlanningStream;
  planningStreamArray: Array<Analytics_PlanningStreamArray>;
  planningStreamStart: Analytics_PlanningStreamStart;
  planningStreamStartArray: Array<Analytics_PlanningStreamStartArray>;
  planningStreamStop: Analytics_PlanningStreamStop;
  planningStreamStopArray: Array<Analytics_PlanningStreamStopArray>;
  postLinkOpen: Analytics_PostLinkOpen;
  postLinkOpenArray: Array<Analytics_PostLinkOpenArray>;
  productBookmark: Analytics_ProductBookmark;
  productBookmarkArray: Array<Analytics_ProductBookmarkArray>;
  productShow: Analytics_ProductShow;
  productShowArray: Array<Analytics_ProductShowArray>;
  registration: Analytics_Registration;
  sponsorShow: Analytics_SponsorShow;
  sponsorShowArray: Array<Analytics_SponsorShowArray>;
  streamStart: Analytics_StreamStart;
  streamStartArray: Array<Analytics_StreamStartArray>;
  streamStop: Analytics_StreamStop;
  streamStopArray: Array<Analytics_StreamStopArray>;
  usage: Analytics_Usage;
  videoCallRoom: Analytics_VideoCallRoom;
};


export type Analytics_ExhibitorsActivityArgs = {
  events?: InputMaybe<Array<Analytics_EventName>>;
};


export type Analytics_ExhibitorsChannelOpenArgs = {
  channel?: InputMaybe<Scalars['String']>;
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsChannelOpenArrayArgs = {
  channel?: InputMaybe<Scalars['String']>;
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsDocumentOpenArgs = {
  documentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsDocumentOpenArrayArgs = {
  documentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsEventViewShowArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsEventViewShowArrayArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsExhibitorAdvertisementOpenArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsExhibitorAdvertisementOpenArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsExhibitorAdvertisementOpenReceiveArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsExhibitorAdvertisementOpenReceiveArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsExhibitorAdvertisementShowArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsExhibitorAdvertisementShowArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsExhibitorAdvertisementShowReceiveArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsExhibitorAdvertisementShowReceiveArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsExhibitorBookmarkArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsExhibitorBookmarkArrayArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsExhibitorBookmarkReceiveArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsExhibitorShowArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_ExhibitorsExhibitorShowArrayArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_ExhibitorsExhibitorShowReceiveArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_ExhibitorsPlanningStreamArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsPlanningStreamArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsPlanningStreamStartArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsPlanningStreamStartArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsPlanningStreamStopArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsPlanningStreamStopArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsPostLinkOpenArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
  postLink?: InputMaybe<Scalars['String']>;
};


export type Analytics_ExhibitorsPostLinkOpenArrayArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
  postLink?: InputMaybe<Scalars['String']>;
};


export type Analytics_ExhibitorsProductBookmarkArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsProductBookmarkArrayArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsProductShowArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_ExhibitorsProductShowArrayArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_ExhibitorsStreamStartArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsStreamStartArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsStreamStopArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_ExhibitorsStreamStopArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Analytics_Groups = {
  __typename?: 'Analytics_Groups';
  activity: Analytics_Activity;
  addOpen: Analytics_AddOpen;
  addOpenArray: Array<Analytics_AddOpenArray>;
  advertisementOpen: Analytics_AdvertisementOpen;
  advertisementOpenArray: Array<Analytics_AdvertisementOpenArray>;
  advertisementShow: Analytics_AdvertisementShow;
  advertisementShowArray: Array<Analytics_AdvertisementShowArray>;
  bookmark: Analytics_Bookmark;
  bookmarkReceive: Analytics_BookmarkReceive;
  channelOpen: Analytics_ChannelOpen;
  channelOpenArray: Array<Analytics_ChannelOpenArray>;
  connection: Analytics_Connection;
  connectionReceive: Analytics_ConnectionReceive;
  connectionRequest: Analytics_ConnectionRequest;
  connectionRequestReceive: Analytics_ConnectionRequestReceive;
  contact: Analytics_Contact;
  documentOpen: Analytics_DocumentOpen;
  documentOpenArray: Array<Analytics_DocumentOpenArray>;
  eventShow: Analytics_EventShow;
  eventViewShow: Analytics_EventViewShow;
  eventViewShowArray: Array<Analytics_EventViewShowArray>;
  exhibitorAdvertisementOpen: Analytics_ExhibitorAdvertisementOpen;
  exhibitorAdvertisementOpenArray: Array<Analytics_ExhibitorAdvertisementOpenArray>;
  exhibitorAdvertisementOpenReceive: Analytics_ExhibitorAdvertisementOpenReceive;
  exhibitorAdvertisementOpenReceiveArray: Array<Analytics_ExhibitorAdvertisementOpenReceiveArray>;
  exhibitorAdvertisementShow: Analytics_ExhibitorAdvertisementShow;
  exhibitorAdvertisementShowArray: Array<Analytics_ExhibitorAdvertisementShowArray>;
  exhibitorAdvertisementShowReceive: Analytics_ExhibitorAdvertisementShowReceive;
  exhibitorAdvertisementShowReceiveArray: Array<Analytics_ExhibitorAdvertisementShowReceiveArray>;
  exhibitorBookmark: Analytics_ExhibitorBookmark;
  exhibitorBookmarkArray: Array<Analytics_ExhibitorBookmarkArray>;
  exhibitorBookmarkReceive: Analytics_ExhibitorBookmarkReceive;
  exhibitorPopularity: Analytics_ExhibitorPopularity;
  exhibitorSelfShow: Analytics_ExhibitorSelfShow;
  exhibitorShow: Analytics_ExhibitorShow;
  exhibitorShowArray: Array<Analytics_ExhibitorShowArray>;
  exhibitorShowReceive: Analytics_ExhibitorShowReceive;
  groupId: Scalars['String'];
  interstitialAddShow: Analytics_InterstitialAddShow;
  interstitialAddShowArray: Array<Analytics_InterstitialAddShowArray>;
  meeting: Analytics_Meeting;
  meetingParticipant: Analytics_MeetingParticipant;
  meetingRequest: Analytics_MeetingRequest;
  meetingRequestReceive: Analytics_MeetingRequestReceive;
  message: Analytics_Message;
  messageReceive: Analytics_MessageReceive;
  networkActivity: Analytics_NetworkActivity;
  personShow: Analytics_PersonShow;
  personShowReceive: Analytics_PersonShowReceive;
  planningBookmark: Analytics_PlanningBookmark;
  planningPopularity: Analytics_PlanningPopularity;
  planningStream: Analytics_PlanningStream;
  planningStreamArray: Array<Analytics_PlanningStreamArray>;
  planningStreamStart: Analytics_PlanningStreamStart;
  planningStreamStartArray: Array<Analytics_PlanningStreamStartArray>;
  planningStreamStop: Analytics_PlanningStreamStop;
  planningStreamStopArray: Array<Analytics_PlanningStreamStopArray>;
  postLinkOpen: Analytics_PostLinkOpen;
  postLinkOpenArray: Array<Analytics_PostLinkOpenArray>;
  productBookmark: Analytics_ProductBookmark;
  productBookmarkArray: Array<Analytics_ProductBookmarkArray>;
  productShow: Analytics_ProductShow;
  productShowArray: Array<Analytics_ProductShowArray>;
  registration: Analytics_Registration;
  sponsorShow: Analytics_SponsorShow;
  sponsorShowArray: Array<Analytics_SponsorShowArray>;
  streamStart: Analytics_StreamStart;
  streamStartArray: Array<Analytics_StreamStartArray>;
  streamStop: Analytics_StreamStop;
  streamStopArray: Array<Analytics_StreamStopArray>;
  usage: Analytics_Usage;
  videoCallRoom: Analytics_VideoCallRoom;
};


export type Analytics_GroupsActivityArgs = {
  events?: InputMaybe<Array<Analytics_EventName>>;
};


export type Analytics_GroupsChannelOpenArgs = {
  channel?: InputMaybe<Scalars['String']>;
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsChannelOpenArrayArgs = {
  channel?: InputMaybe<Scalars['String']>;
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsDocumentOpenArgs = {
  documentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsDocumentOpenArrayArgs = {
  documentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsEventViewShowArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsEventViewShowArrayArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsExhibitorAdvertisementOpenArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsExhibitorAdvertisementOpenArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsExhibitorAdvertisementOpenReceiveArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsExhibitorAdvertisementOpenReceiveArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsExhibitorAdvertisementShowArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsExhibitorAdvertisementShowArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsExhibitorAdvertisementShowReceiveArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsExhibitorAdvertisementShowReceiveArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsExhibitorBookmarkArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsExhibitorBookmarkArrayArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsExhibitorBookmarkReceiveArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsExhibitorShowArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_GroupsExhibitorShowArrayArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_GroupsExhibitorShowReceiveArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_GroupsPlanningStreamArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsPlanningStreamArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsPlanningStreamStartArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsPlanningStreamStartArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsPlanningStreamStopArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsPlanningStreamStopArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsPostLinkOpenArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
  postLink?: InputMaybe<Scalars['String']>;
};


export type Analytics_GroupsPostLinkOpenArrayArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
  postLink?: InputMaybe<Scalars['String']>;
};


export type Analytics_GroupsProductBookmarkArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsProductBookmarkArrayArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsProductShowArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_GroupsProductShowArrayArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_GroupsStreamStartArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsStreamStartArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsStreamStopArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_GroupsStreamStopArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Analytics_Histogram = {
  __typename?: 'Analytics_Histogram';
  aboveCount: Scalars['Int'];
  belowCount: Scalars['Int'];
  bins: Array<Analytics_HistogramBin>;
};

export type Analytics_HistogramBin = {
  __typename?: 'Analytics_HistogramBin';
  count: Scalars['Int'];
  max: Scalars['Float'];
  min: Scalars['Float'];
};

export type Analytics_InterstitialAddShow = {
  __typename?: 'Analytics_InterstitialAddShow';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  durationAndroidAverage?: Maybe<Scalars['Float']>;
  durationAndroidSum?: Maybe<Scalars['Float']>;
  durationAverage?: Maybe<Scalars['Float']>;
  durationIosAverage?: Maybe<Scalars['Float']>;
  durationIosSum?: Maybe<Scalars['Float']>;
  durationSum?: Maybe<Scalars['Float']>;
  durationWebAverage?: Maybe<Scalars['Float']>;
  durationWebSum?: Maybe<Scalars['Float']>;
  durationWebTeamAverage?: Maybe<Scalars['Float']>;
  durationWebTeamSum?: Maybe<Scalars['Float']>;
  durationWebUserAverage?: Maybe<Scalars['Float']>;
  durationWebUserSum?: Maybe<Scalars['Float']>;
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_InterstitialAddShowArray = {
  __typename?: 'Analytics_InterstitialAddShowArray';
  addId?: Maybe<Scalars['String']>;
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  durationAndroidAverage?: Maybe<Scalars['Float']>;
  durationAndroidSum?: Maybe<Scalars['Float']>;
  durationAverage?: Maybe<Scalars['Float']>;
  durationIosAverage?: Maybe<Scalars['Float']>;
  durationIosSum?: Maybe<Scalars['Float']>;
  durationSum?: Maybe<Scalars['Float']>;
  durationWebAverage?: Maybe<Scalars['Float']>;
  durationWebSum?: Maybe<Scalars['Float']>;
  durationWebTeamAverage?: Maybe<Scalars['Float']>;
  durationWebTeamSum?: Maybe<Scalars['Float']>;
  durationWebUserAverage?: Maybe<Scalars['Float']>;
  durationWebUserSum?: Maybe<Scalars['Float']>;
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_Interval = {
  range: Scalars['Int'];
  unit: Analytics_TimeUnit;
};

export type Analytics_ListDocumentOpen = {
  __typename?: 'Analytics_ListDocumentOpen';
  nextCursor?: Maybe<Scalars['String']>;
  rows: Array<Analytics_DocumentOpenRow>;
};

export type Analytics_ListExhibitorAdvertisementOpen = {
  __typename?: 'Analytics_ListExhibitorAdvertisementOpen';
  nextCursor?: Maybe<Scalars['String']>;
  rows: Array<Analytics_ExhibitorAdvertisementOpenRow>;
};

export type Analytics_ListExhibitorAdvertisementShow = {
  __typename?: 'Analytics_ListExhibitorAdvertisementShow';
  nextCursor?: Maybe<Scalars['String']>;
  rows: Array<Analytics_ExhibitorAdvertisementShowRow>;
};

export type Analytics_ListExhibitorShow = {
  __typename?: 'Analytics_ListExhibitorShow';
  nextCursor?: Maybe<Scalars['String']>;
  rows: Array<Analytics_ExhibitorShowRow>;
};

export type Analytics_ListProductShow = {
  __typename?: 'Analytics_ListProductShow';
  nextCursor?: Maybe<Scalars['String']>;
  rows: Array<Analytics_ProductShowRow>;
};

export type Analytics_Meeting = {
  __typename?: 'Analytics_Meeting';
  allCount: Scalars['Int'];
  allUnique: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  canceledCount: Scalars['Int'];
  canceledUnique: Scalars['Int'];
  canceledUniqueUser: Scalars['Int'];
  confirmedCount: Scalars['Int'];
  confirmedUnique: Scalars['Int'];
  confirmedUniqueUser: Scalars['Int'];
  declinedCount: Scalars['Int'];
  declinedUnique: Scalars['Int'];
  declinedUniqueUser: Scalars['Int'];
  expiredCount: Scalars['Int'];
  expiredUnique: Scalars['Int'];
  expiredUniqueUser: Scalars['Int'];
  noShowCount: Scalars['Int'];
  noShowUnique: Scalars['Int'];
  noShowUniqueUser: Scalars['Int'];
  pendingCount: Scalars['Int'];
  pendingUnique: Scalars['Int'];
  pendingUniqueUser: Scalars['Int'];
  rescheduledCount: Scalars['Int'];
  rescheduledUnique: Scalars['Int'];
  rescheduledUniqueUser: Scalars['Int'];
};

export type Analytics_MeetingParticipant = {
  __typename?: 'Analytics_MeetingParticipant';
  allCount: Scalars['Int'];
  allUnique: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  canceledCount: Scalars['Int'];
  canceledUnique: Scalars['Int'];
  canceledUniqueUser: Scalars['Int'];
  confirmedCount: Scalars['Int'];
  confirmedUnique: Scalars['Int'];
  confirmedUniqueUser: Scalars['Int'];
  declinedCount: Scalars['Int'];
  declinedUnique: Scalars['Int'];
  declinedUniqueUser: Scalars['Int'];
  expiredCount: Scalars['Int'];
  expiredUnique: Scalars['Int'];
  expiredUniqueUser: Scalars['Int'];
  noShowCount: Scalars['Int'];
  noShowUnique: Scalars['Int'];
  noShowUniqueUser: Scalars['Int'];
  pendingCount: Scalars['Int'];
  pendingUnique: Scalars['Int'];
  pendingUniqueUser: Scalars['Int'];
};

export type Analytics_MeetingRequest = {
  __typename?: 'Analytics_MeetingRequest';
  acceptedCount: Scalars['Int'];
  acceptedUniqueUser: Scalars['Int'];
  acceptedWithUniqueUser: Scalars['Int'];
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  allWithUniqueUser: Scalars['Int'];
  cancelledCount: Scalars['Int'];
  cancelledUniqueUser: Scalars['Int'];
  cancelledWithUniqueUser: Scalars['Int'];
  declinedCount: Scalars['Int'];
  declinedUniqueUser: Scalars['Int'];
  declinedWithUniqueUser: Scalars['Int'];
  expiredCount: Scalars['Int'];
  expiredUniqueUser: Scalars['Int'];
  expiredWithUniqueUser: Scalars['Int'];
  pendingCount: Scalars['Int'];
  pendingUniqueUser: Scalars['Int'];
  pendingWithUniqueUser: Scalars['Int'];
};

export type Analytics_MeetingRequestReceive = {
  __typename?: 'Analytics_MeetingRequestReceive';
  acceptedCount: Scalars['Int'];
  acceptedUniqueUser: Scalars['Int'];
  acceptedWithUniqueUser: Scalars['Int'];
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  allWithUniqueUser: Scalars['Int'];
  cancelledCount: Scalars['Int'];
  cancelledUniqueUser: Scalars['Int'];
  cancelledWithUniqueUser: Scalars['Int'];
  declinedCount: Scalars['Int'];
  declinedUniqueUser: Scalars['Int'];
  declinedWithUniqueUser: Scalars['Int'];
  expiredCount: Scalars['Int'];
  expiredUniqueUser: Scalars['Int'];
  expiredWithUniqueUser: Scalars['Int'];
  pendingCount: Scalars['Int'];
  pendingUniqueUser: Scalars['Int'];
  pendingWithUniqueUser: Scalars['Int'];
};

export type Analytics_Message = {
  __typename?: 'Analytics_Message';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  channelUnique: Scalars['Int'];
  privateCount: Scalars['Int'];
  privateUniqueUser: Scalars['Int'];
  privateWithUniqueUser: Scalars['Int'];
  publicCount: Scalars['Int'];
  publicUniqueUser: Scalars['Int'];
};

export type Analytics_MessageReceive = {
  __typename?: 'Analytics_MessageReceive';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  channelUnique: Scalars['Int'];
  privateCount: Scalars['Int'];
  privateUniqueUser: Scalars['Int'];
  privateWithUniqueUser: Scalars['Int'];
  publicCount: Scalars['Int'];
  publicUniqueUser: Scalars['Int'];
};

export type Analytics_Metric = {
  __typename?: 'Analytics_Metric';
  activity: Analytics_Activity;
  addOpen: Analytics_AddOpen;
  addOpenArray: Array<Analytics_AddOpenArray>;
  advertisementOpen: Analytics_AdvertisementOpen;
  advertisementOpenArray: Array<Analytics_AdvertisementOpenArray>;
  advertisementShow: Analytics_AdvertisementShow;
  advertisementShowArray: Array<Analytics_AdvertisementShowArray>;
  bookmark: Analytics_Bookmark;
  bookmarkReceive: Analytics_BookmarkReceive;
  channelOpen: Analytics_ChannelOpen;
  channelOpenArray: Array<Analytics_ChannelOpenArray>;
  connection: Analytics_Connection;
  connectionReceive: Analytics_ConnectionReceive;
  connectionRequest: Analytics_ConnectionRequest;
  connectionRequestReceive: Analytics_ConnectionRequestReceive;
  contact: Analytics_Contact;
  documentOpen: Analytics_DocumentOpen;
  documentOpenArray: Array<Analytics_DocumentOpenArray>;
  eventShow: Analytics_EventShow;
  eventViewShow: Analytics_EventViewShow;
  eventViewShowArray: Array<Analytics_EventViewShowArray>;
  exhibitorAdvertisementOpen: Analytics_ExhibitorAdvertisementOpen;
  exhibitorAdvertisementOpenArray: Array<Analytics_ExhibitorAdvertisementOpenArray>;
  exhibitorAdvertisementOpenReceive: Analytics_ExhibitorAdvertisementOpenReceive;
  exhibitorAdvertisementOpenReceiveArray: Array<Analytics_ExhibitorAdvertisementOpenReceiveArray>;
  exhibitorAdvertisementShow: Analytics_ExhibitorAdvertisementShow;
  exhibitorAdvertisementShowArray: Array<Analytics_ExhibitorAdvertisementShowArray>;
  exhibitorAdvertisementShowReceive: Analytics_ExhibitorAdvertisementShowReceive;
  exhibitorAdvertisementShowReceiveArray: Array<Analytics_ExhibitorAdvertisementShowReceiveArray>;
  exhibitorBookmark: Analytics_ExhibitorBookmark;
  exhibitorBookmarkArray: Array<Analytics_ExhibitorBookmarkArray>;
  exhibitorBookmarkReceive: Analytics_ExhibitorBookmarkReceive;
  exhibitorPopularity: Analytics_ExhibitorPopularity;
  exhibitorSelfShow: Analytics_ExhibitorSelfShow;
  exhibitorShow: Analytics_ExhibitorShow;
  exhibitorShowArray: Array<Analytics_ExhibitorShowArray>;
  exhibitorShowReceive: Analytics_ExhibitorShowReceive;
  interstitialAddShow: Analytics_InterstitialAddShow;
  interstitialAddShowArray: Array<Analytics_InterstitialAddShowArray>;
  meeting: Analytics_Meeting;
  meetingParticipant: Analytics_MeetingParticipant;
  meetingRequest: Analytics_MeetingRequest;
  meetingRequestReceive: Analytics_MeetingRequestReceive;
  message: Analytics_Message;
  messageReceive: Analytics_MessageReceive;
  networkActivity: Analytics_NetworkActivity;
  personShow: Analytics_PersonShow;
  personShowReceive: Analytics_PersonShowReceive;
  planningBookmark: Analytics_PlanningBookmark;
  planningPopularity: Analytics_PlanningPopularity;
  planningStream: Analytics_PlanningStream;
  planningStreamArray: Array<Analytics_PlanningStreamArray>;
  planningStreamStart: Analytics_PlanningStreamStart;
  planningStreamStartArray: Array<Analytics_PlanningStreamStartArray>;
  planningStreamStop: Analytics_PlanningStreamStop;
  planningStreamStopArray: Array<Analytics_PlanningStreamStopArray>;
  postLinkOpen: Analytics_PostLinkOpen;
  postLinkOpenArray: Array<Analytics_PostLinkOpenArray>;
  productBookmark: Analytics_ProductBookmark;
  productBookmarkArray: Array<Analytics_ProductBookmarkArray>;
  productShow: Analytics_ProductShow;
  productShowArray: Array<Analytics_ProductShowArray>;
  registration: Analytics_Registration;
  sponsorShow: Analytics_SponsorShow;
  sponsorShowArray: Array<Analytics_SponsorShowArray>;
  streamStart: Analytics_StreamStart;
  streamStartArray: Array<Analytics_StreamStartArray>;
  streamStop: Analytics_StreamStop;
  streamStopArray: Array<Analytics_StreamStopArray>;
  usage: Analytics_Usage;
  videoCallRoom: Analytics_VideoCallRoom;
};


export type Analytics_MetricActivityArgs = {
  events?: InputMaybe<Array<Analytics_EventName>>;
};


export type Analytics_MetricChannelOpenArgs = {
  channel?: InputMaybe<Scalars['String']>;
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricChannelOpenArrayArgs = {
  channel?: InputMaybe<Scalars['String']>;
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricDocumentOpenArgs = {
  documentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricDocumentOpenArrayArgs = {
  documentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricEventViewShowArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricEventViewShowArrayArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricExhibitorAdvertisementOpenArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricExhibitorAdvertisementOpenArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricExhibitorAdvertisementOpenReceiveArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricExhibitorAdvertisementOpenReceiveArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricExhibitorAdvertisementShowArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricExhibitorAdvertisementShowArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricExhibitorAdvertisementShowReceiveArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricExhibitorAdvertisementShowReceiveArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricExhibitorBookmarkArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricExhibitorBookmarkArrayArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricExhibitorBookmarkReceiveArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricExhibitorShowArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_MetricExhibitorShowArrayArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_MetricExhibitorShowReceiveArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_MetricPlanningStreamArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricPlanningStreamArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricPlanningStreamStartArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricPlanningStreamStartArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricPlanningStreamStopArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricPlanningStreamStopArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricPostLinkOpenArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
  postLink?: InputMaybe<Scalars['String']>;
};


export type Analytics_MetricPostLinkOpenArrayArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
  postLink?: InputMaybe<Scalars['String']>;
};


export type Analytics_MetricProductBookmarkArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricProductBookmarkArrayArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricProductShowArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_MetricProductShowArrayArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_MetricStreamStartArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricStreamStartArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricStreamStopArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_MetricStreamStopArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Analytics_NetworkActivity = {
  __typename?: 'Analytics_NetworkActivity';
  allCount: Scalars['Int'];
  allUnique: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  allWithUniqueUser: Scalars['Int'];
};

export type Analytics_PersonShow = {
  __typename?: 'Analytics_PersonShow';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  allWithUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  androidWithUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  iosWithUniqueUser: Scalars['Int'];
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webTeamWithUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
  webUserWithUniqueUser: Scalars['Int'];
  webWithUniqueUser: Scalars['Int'];
};

export type Analytics_PersonShowReceive = {
  __typename?: 'Analytics_PersonShowReceive';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  allWithUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  androidWithUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  iosWithUniqueUser: Scalars['Int'];
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webTeamWithUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
  webUserWithUniqueUser: Scalars['Int'];
  webWithUniqueUser: Scalars['Int'];
};

export type Analytics_PlanningBookmark = {
  __typename?: 'Analytics_PlanningBookmark';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
};

export type Analytics_PlanningPopularity = {
  __typename?: 'Analytics_PlanningPopularity';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_PlanningStream = {
  __typename?: 'Analytics_PlanningStream';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_PlanningStreamArray = {
  __typename?: 'Analytics_PlanningStreamArray';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  planningId?: Maybe<Scalars['String']>;
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_PlanningStreamStart = {
  __typename?: 'Analytics_PlanningStreamStart';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_PlanningStreamStartArray = {
  __typename?: 'Analytics_PlanningStreamStartArray';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  planningId?: Maybe<Scalars['String']>;
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_PlanningStreamStop = {
  __typename?: 'Analytics_PlanningStreamStop';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  durationAndroidAverage?: Maybe<Scalars['Float']>;
  durationAndroidSum?: Maybe<Scalars['Float']>;
  durationAverage?: Maybe<Scalars['Float']>;
  durationIosAverage?: Maybe<Scalars['Float']>;
  durationIosSum?: Maybe<Scalars['Float']>;
  durationSum?: Maybe<Scalars['Float']>;
  durationWebAverage?: Maybe<Scalars['Float']>;
  durationWebSum?: Maybe<Scalars['Float']>;
  durationWebTeamAverage?: Maybe<Scalars['Float']>;
  durationWebTeamSum?: Maybe<Scalars['Float']>;
  durationWebUserAverage?: Maybe<Scalars['Float']>;
  durationWebUserSum?: Maybe<Scalars['Float']>;
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_PlanningStreamStopArray = {
  __typename?: 'Analytics_PlanningStreamStopArray';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  durationAndroidAverage?: Maybe<Scalars['Float']>;
  durationAndroidSum?: Maybe<Scalars['Float']>;
  durationAverage?: Maybe<Scalars['Float']>;
  durationIosAverage?: Maybe<Scalars['Float']>;
  durationIosSum?: Maybe<Scalars['Float']>;
  durationSum?: Maybe<Scalars['Float']>;
  durationWebAverage?: Maybe<Scalars['Float']>;
  durationWebSum?: Maybe<Scalars['Float']>;
  durationWebTeamAverage?: Maybe<Scalars['Float']>;
  durationWebTeamSum?: Maybe<Scalars['Float']>;
  durationWebUserAverage?: Maybe<Scalars['Float']>;
  durationWebUserSum?: Maybe<Scalars['Float']>;
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  planningId?: Maybe<Scalars['String']>;
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_Plannings = {
  __typename?: 'Analytics_Plannings';
  planningBookmark: Analytics_PlanningBookmark;
  planningId: Scalars['String'];
  planningPopularity: Analytics_PlanningPopularity;
  planningStream: Analytics_PlanningStream;
  planningStreamArray: Array<Analytics_PlanningStreamArray>;
  planningStreamStart: Analytics_PlanningStreamStart;
  planningStreamStartArray: Array<Analytics_PlanningStreamStartArray>;
  planningStreamStop: Analytics_PlanningStreamStop;
  planningStreamStopArray: Array<Analytics_PlanningStreamStopArray>;
};


export type Analytics_PlanningsPlanningStreamArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_PlanningsPlanningStreamArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_PlanningsPlanningStreamStartArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_PlanningsPlanningStreamStartArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_PlanningsPlanningStreamStopArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_PlanningsPlanningStreamStopArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Analytics_PostLinkOpen = {
  __typename?: 'Analytics_PostLinkOpen';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_PostLinkOpenArray = {
  __typename?: 'Analytics_PostLinkOpenArray';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  eventViewId?: Maybe<Scalars['String']>;
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_ProductBookmark = {
  __typename?: 'Analytics_ProductBookmark';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
};

export type Analytics_ProductBookmarkArray = {
  __typename?: 'Analytics_ProductBookmarkArray';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  productId?: Maybe<Scalars['String']>;
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
};

export type Analytics_ProductShow = {
  __typename?: 'Analytics_ProductShow';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_ProductShowArray = {
  __typename?: 'Analytics_ProductShowArray';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  productId?: Maybe<Scalars['String']>;
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_ProductShowRow = {
  __typename?: 'Analytics_ProductShowRow';
  createdAt: Scalars['Analytics_Date'];
  cursor: Scalars['String'];
  eventId: Scalars['ID'];
  productId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export type Analytics_Registration = {
  __typename?: 'Analytics_Registration';
  abandonedCount: Scalars['Int'];
  allCount: Scalars['Int'];
  canceledCount: Scalars['Int'];
  checkedInCount: Scalars['Int'];
  registeredCount: Scalars['Int'];
};

export type Analytics_SortCommunityExhibitors = {
  direction: Analytics_SortDirection;
  field: Analytics_SortCommunityExhibitorsField;
  limit?: InputMaybe<Scalars['Int']>;
};

export enum Analytics_SortCommunityExhibitorsField {
  ActivityTimestampMax = 'activity_timestampMax',
  ActivityTimestampMin = 'activity_timestampMin',
  AddOpenAllCount = 'addOpen_allCount',
  AddOpenAllUniqueUser = 'addOpen_allUniqueUser',
  AddOpenAndroidCount = 'addOpen_androidCount',
  AddOpenAndroidUniqueUser = 'addOpen_androidUniqueUser',
  AddOpenIosCount = 'addOpen_iosCount',
  AddOpenIosUniqueUser = 'addOpen_iosUniqueUser',
  AddOpenTimestampMax = 'addOpen_timestampMax',
  AddOpenTimestampMin = 'addOpen_timestampMin',
  AddOpenWebCount = 'addOpen_webCount',
  AddOpenWebTeamCount = 'addOpen_webTeamCount',
  AddOpenWebTeamUniqueUser = 'addOpen_webTeamUniqueUser',
  AddOpenWebUniqueUser = 'addOpen_webUniqueUser',
  AddOpenWebUserCount = 'addOpen_webUserCount',
  AddOpenWebUserUniqueUser = 'addOpen_webUserUniqueUser',
  AdvertisementOpenAllCount = 'advertisementOpen_allCount',
  AdvertisementOpenAllUniqueUser = 'advertisementOpen_allUniqueUser',
  AdvertisementOpenAndroidCount = 'advertisementOpen_androidCount',
  AdvertisementOpenAndroidUniqueUser = 'advertisementOpen_androidUniqueUser',
  AdvertisementOpenIosCount = 'advertisementOpen_iosCount',
  AdvertisementOpenIosUniqueUser = 'advertisementOpen_iosUniqueUser',
  AdvertisementOpenTimestampMax = 'advertisementOpen_timestampMax',
  AdvertisementOpenTimestampMin = 'advertisementOpen_timestampMin',
  AdvertisementOpenWebCount = 'advertisementOpen_webCount',
  AdvertisementOpenWebTeamCount = 'advertisementOpen_webTeamCount',
  AdvertisementOpenWebTeamUniqueUser = 'advertisementOpen_webTeamUniqueUser',
  AdvertisementOpenWebUniqueUser = 'advertisementOpen_webUniqueUser',
  AdvertisementOpenWebUserCount = 'advertisementOpen_webUserCount',
  AdvertisementOpenWebUserUniqueUser = 'advertisementOpen_webUserUniqueUser',
  AdvertisementShowAllCount = 'advertisementShow_allCount',
  AdvertisementShowAllUniqueUser = 'advertisementShow_allUniqueUser',
  AdvertisementShowAndroidCount = 'advertisementShow_androidCount',
  AdvertisementShowAndroidUniqueUser = 'advertisementShow_androidUniqueUser',
  AdvertisementShowDurationAndroidAverage = 'advertisementShow_durationAndroidAverage',
  AdvertisementShowDurationAndroidSum = 'advertisementShow_durationAndroidSum',
  AdvertisementShowDurationAverage = 'advertisementShow_durationAverage',
  AdvertisementShowDurationIosAverage = 'advertisementShow_durationIosAverage',
  AdvertisementShowDurationIosSum = 'advertisementShow_durationIosSum',
  AdvertisementShowDurationSum = 'advertisementShow_durationSum',
  AdvertisementShowDurationWebAverage = 'advertisementShow_durationWebAverage',
  AdvertisementShowDurationWebSum = 'advertisementShow_durationWebSum',
  AdvertisementShowDurationWebTeamAverage = 'advertisementShow_durationWebTeamAverage',
  AdvertisementShowDurationWebTeamSum = 'advertisementShow_durationWebTeamSum',
  AdvertisementShowDurationWebUserAverage = 'advertisementShow_durationWebUserAverage',
  AdvertisementShowDurationWebUserSum = 'advertisementShow_durationWebUserSum',
  AdvertisementShowIosCount = 'advertisementShow_iosCount',
  AdvertisementShowIosUniqueUser = 'advertisementShow_iosUniqueUser',
  AdvertisementShowWebCount = 'advertisementShow_webCount',
  AdvertisementShowWebTeamCount = 'advertisementShow_webTeamCount',
  AdvertisementShowWebTeamUniqueUser = 'advertisementShow_webTeamUniqueUser',
  AdvertisementShowWebUniqueUser = 'advertisementShow_webUniqueUser',
  AdvertisementShowWebUserCount = 'advertisementShow_webUserCount',
  AdvertisementShowWebUserUniqueUser = 'advertisementShow_webUserUniqueUser',
  BookmarkReceiveAllCount = 'bookmarkReceive_allCount',
  BookmarkReceiveAllUniqueUser = 'bookmarkReceive_allUniqueUser',
  BookmarkReceiveTimestampMax = 'bookmarkReceive_timestampMax',
  BookmarkReceiveTimestampMin = 'bookmarkReceive_timestampMin',
  BookmarkAllCount = 'bookmark_allCount',
  BookmarkAllUniqueUser = 'bookmark_allUniqueUser',
  BookmarkTimestampMax = 'bookmark_timestampMax',
  BookmarkTimestampMin = 'bookmark_timestampMin',
  ChannelOpenAllCount = 'channelOpen_allCount',
  ChannelOpenAllUniqueUser = 'channelOpen_allUniqueUser',
  ChannelOpenAndroidCount = 'channelOpen_androidCount',
  ChannelOpenAndroidUniqueUser = 'channelOpen_androidUniqueUser',
  ChannelOpenIosCount = 'channelOpen_iosCount',
  ChannelOpenIosUniqueUser = 'channelOpen_iosUniqueUser',
  ChannelOpenWebCount = 'channelOpen_webCount',
  ChannelOpenWebTeamCount = 'channelOpen_webTeamCount',
  ChannelOpenWebTeamUniqueUser = 'channelOpen_webTeamUniqueUser',
  ChannelOpenWebUniqueUser = 'channelOpen_webUniqueUser',
  ChannelOpenWebUserCount = 'channelOpen_webUserCount',
  ChannelOpenWebUserUniqueUser = 'channelOpen_webUserUniqueUser',
  ConnectionReceiveAllCount = 'connectionReceive_allCount',
  ConnectionReceiveAllUnique = 'connectionReceive_allUnique',
  ConnectionReceiveAllUniqueUser = 'connectionReceive_allUniqueUser',
  ConnectionReceiveAllWithUniqueUser = 'connectionReceive_allWithUniqueUser',
  ConnectionReceiveNotScanCount = 'connectionReceive_notScanCount',
  ConnectionReceiveNotScanUnique = 'connectionReceive_notScanUnique',
  ConnectionReceiveNotScanUniqueUser = 'connectionReceive_notScanUniqueUser',
  ConnectionReceiveNotScanWithUniqueUser = 'connectionReceive_notScanWithUniqueUser',
  ConnectionReceiveScanCount = 'connectionReceive_scanCount',
  ConnectionReceiveScanUnique = 'connectionReceive_scanUnique',
  ConnectionReceiveScanUniqueUser = 'connectionReceive_scanUniqueUser',
  ConnectionReceiveScanWithUniqueUser = 'connectionReceive_scanWithUniqueUser',
  ConnectionReceiveScoreAverage = 'connectionReceive_scoreAverage',
  ConnectionReceiveScoreCount = 'connectionReceive_scoreCount',
  ConnectionReceiveScoreUnique = 'connectionReceive_scoreUnique',
  ConnectionReceiveScoreUniqueUser = 'connectionReceive_scoreUniqueUser',
  ConnectionReceiveScoreWithUniqueUser = 'connectionReceive_scoreWithUniqueUser',
  ConnectionRequestReceiveAcceptedCount = 'connectionRequestReceive_acceptedCount',
  ConnectionRequestReceiveAcceptedUniqueUser = 'connectionRequestReceive_acceptedUniqueUser',
  ConnectionRequestReceiveAcceptedWithUniqueUser = 'connectionRequestReceive_acceptedWithUniqueUser',
  ConnectionRequestReceiveAllCount = 'connectionRequestReceive_allCount',
  ConnectionRequestReceiveAllUniqueUser = 'connectionRequestReceive_allUniqueUser',
  ConnectionRequestReceiveAllWithUniqueUser = 'connectionRequestReceive_allWithUniqueUser',
  ConnectionRequestReceiveDeclinedCount = 'connectionRequestReceive_declinedCount',
  ConnectionRequestReceiveDeclinedUniqueUser = 'connectionRequestReceive_declinedUniqueUser',
  ConnectionRequestReceiveDeclinedWithUniqueUser = 'connectionRequestReceive_declinedWithUniqueUser',
  ConnectionRequestReceivePendingCount = 'connectionRequestReceive_pendingCount',
  ConnectionRequestReceivePendingUniqueUser = 'connectionRequestReceive_pendingUniqueUser',
  ConnectionRequestReceivePendingWithUniqueUser = 'connectionRequestReceive_pendingWithUniqueUser',
  ConnectionRequestAcceptedCount = 'connectionRequest_acceptedCount',
  ConnectionRequestAcceptedUniqueUser = 'connectionRequest_acceptedUniqueUser',
  ConnectionRequestAcceptedWithUniqueUser = 'connectionRequest_acceptedWithUniqueUser',
  ConnectionRequestAllCount = 'connectionRequest_allCount',
  ConnectionRequestAllUniqueUser = 'connectionRequest_allUniqueUser',
  ConnectionRequestAllWithUniqueUser = 'connectionRequest_allWithUniqueUser',
  ConnectionRequestDeclinedCount = 'connectionRequest_declinedCount',
  ConnectionRequestDeclinedUniqueUser = 'connectionRequest_declinedUniqueUser',
  ConnectionRequestDeclinedWithUniqueUser = 'connectionRequest_declinedWithUniqueUser',
  ConnectionRequestPendingCount = 'connectionRequest_pendingCount',
  ConnectionRequestPendingUniqueUser = 'connectionRequest_pendingUniqueUser',
  ConnectionRequestPendingWithUniqueUser = 'connectionRequest_pendingWithUniqueUser',
  ConnectionAllCount = 'connection_allCount',
  ConnectionAllUnique = 'connection_allUnique',
  ConnectionAllUniqueUser = 'connection_allUniqueUser',
  ConnectionAllWithUniqueUser = 'connection_allWithUniqueUser',
  ConnectionNotScanCount = 'connection_notScanCount',
  ConnectionNotScanUnique = 'connection_notScanUnique',
  ConnectionNotScanUniqueUser = 'connection_notScanUniqueUser',
  ConnectionNotScanWithUniqueUser = 'connection_notScanWithUniqueUser',
  ConnectionScanCount = 'connection_scanCount',
  ConnectionScanUnique = 'connection_scanUnique',
  ConnectionScanUniqueUser = 'connection_scanUniqueUser',
  ConnectionScanWithUniqueUser = 'connection_scanWithUniqueUser',
  ConnectionScoreAverage = 'connection_scoreAverage',
  ConnectionScoreCount = 'connection_scoreCount',
  ConnectionScoreUnique = 'connection_scoreUnique',
  ConnectionScoreUniqueUser = 'connection_scoreUniqueUser',
  ConnectionScoreWithUniqueUser = 'connection_scoreWithUniqueUser',
  ContactAllCount = 'contact_allCount',
  ContactAllUniqueUser = 'contact_allUniqueUser',
  ContactNotScanCount = 'contact_notScanCount',
  ContactNotScanUniqueUser = 'contact_notScanUniqueUser',
  ContactScanCount = 'contact_scanCount',
  ContactScanUniqueUser = 'contact_scanUniqueUser',
  DocumentOpenAllCount = 'documentOpen_allCount',
  DocumentOpenAllUniqueUser = 'documentOpen_allUniqueUser',
  DocumentOpenTimestampMax = 'documentOpen_timestampMax',
  DocumentOpenTimestampMin = 'documentOpen_timestampMin',
  EventShowAllCount = 'eventShow_allCount',
  EventShowAllUniqueUser = 'eventShow_allUniqueUser',
  EventShowAndroidCount = 'eventShow_androidCount',
  EventShowAndroidUniqueUser = 'eventShow_androidUniqueUser',
  EventShowIosCount = 'eventShow_iosCount',
  EventShowIosUniqueUser = 'eventShow_iosUniqueUser',
  EventShowWebCount = 'eventShow_webCount',
  EventShowWebTeamCount = 'eventShow_webTeamCount',
  EventShowWebTeamUniqueUser = 'eventShow_webTeamUniqueUser',
  EventShowWebUniqueUser = 'eventShow_webUniqueUser',
  EventShowWebUserCount = 'eventShow_webUserCount',
  EventShowWebUserUniqueUser = 'eventShow_webUserUniqueUser',
  EventViewShowAllCount = 'eventViewShow_allCount',
  EventViewShowAllUniqueUser = 'eventViewShow_allUniqueUser',
  EventViewShowAndroidCount = 'eventViewShow_androidCount',
  EventViewShowAndroidUniqueUser = 'eventViewShow_androidUniqueUser',
  EventViewShowIosCount = 'eventViewShow_iosCount',
  EventViewShowIosUniqueUser = 'eventViewShow_iosUniqueUser',
  EventViewShowWebCount = 'eventViewShow_webCount',
  EventViewShowWebTeamCount = 'eventViewShow_webTeamCount',
  EventViewShowWebTeamUniqueUser = 'eventViewShow_webTeamUniqueUser',
  EventViewShowWebUniqueUser = 'eventViewShow_webUniqueUser',
  EventViewShowWebUserCount = 'eventViewShow_webUserCount',
  EventViewShowWebUserUniqueUser = 'eventViewShow_webUserUniqueUser',
  ExhibitorAdvertisementOpenReceiveAllCount = 'exhibitorAdvertisementOpenReceive_allCount',
  ExhibitorAdvertisementOpenReceiveAllUniqueUser = 'exhibitorAdvertisementOpenReceive_allUniqueUser',
  ExhibitorAdvertisementOpenReceiveAndroidCount = 'exhibitorAdvertisementOpenReceive_androidCount',
  ExhibitorAdvertisementOpenReceiveAndroidUniqueUser = 'exhibitorAdvertisementOpenReceive_androidUniqueUser',
  ExhibitorAdvertisementOpenReceiveIosCount = 'exhibitorAdvertisementOpenReceive_iosCount',
  ExhibitorAdvertisementOpenReceiveIosUniqueUser = 'exhibitorAdvertisementOpenReceive_iosUniqueUser',
  ExhibitorAdvertisementOpenReceiveTimestampMax = 'exhibitorAdvertisementOpenReceive_timestampMax',
  ExhibitorAdvertisementOpenReceiveTimestampMin = 'exhibitorAdvertisementOpenReceive_timestampMin',
  ExhibitorAdvertisementOpenReceiveWebCount = 'exhibitorAdvertisementOpenReceive_webCount',
  ExhibitorAdvertisementOpenReceiveWebTeamCount = 'exhibitorAdvertisementOpenReceive_webTeamCount',
  ExhibitorAdvertisementOpenReceiveWebTeamUniqueUser = 'exhibitorAdvertisementOpenReceive_webTeamUniqueUser',
  ExhibitorAdvertisementOpenReceiveWebUniqueUser = 'exhibitorAdvertisementOpenReceive_webUniqueUser',
  ExhibitorAdvertisementOpenReceiveWebUserCount = 'exhibitorAdvertisementOpenReceive_webUserCount',
  ExhibitorAdvertisementOpenReceiveWebUserUniqueUser = 'exhibitorAdvertisementOpenReceive_webUserUniqueUser',
  ExhibitorAdvertisementOpenAllCount = 'exhibitorAdvertisementOpen_allCount',
  ExhibitorAdvertisementOpenAllUniqueUser = 'exhibitorAdvertisementOpen_allUniqueUser',
  ExhibitorAdvertisementOpenAndroidCount = 'exhibitorAdvertisementOpen_androidCount',
  ExhibitorAdvertisementOpenAndroidUniqueUser = 'exhibitorAdvertisementOpen_androidUniqueUser',
  ExhibitorAdvertisementOpenIosCount = 'exhibitorAdvertisementOpen_iosCount',
  ExhibitorAdvertisementOpenIosUniqueUser = 'exhibitorAdvertisementOpen_iosUniqueUser',
  ExhibitorAdvertisementOpenTimestampMax = 'exhibitorAdvertisementOpen_timestampMax',
  ExhibitorAdvertisementOpenTimestampMin = 'exhibitorAdvertisementOpen_timestampMin',
  ExhibitorAdvertisementOpenWebCount = 'exhibitorAdvertisementOpen_webCount',
  ExhibitorAdvertisementOpenWebTeamCount = 'exhibitorAdvertisementOpen_webTeamCount',
  ExhibitorAdvertisementOpenWebTeamUniqueUser = 'exhibitorAdvertisementOpen_webTeamUniqueUser',
  ExhibitorAdvertisementOpenWebUniqueUser = 'exhibitorAdvertisementOpen_webUniqueUser',
  ExhibitorAdvertisementOpenWebUserCount = 'exhibitorAdvertisementOpen_webUserCount',
  ExhibitorAdvertisementOpenWebUserUniqueUser = 'exhibitorAdvertisementOpen_webUserUniqueUser',
  ExhibitorAdvertisementShowReceiveAllCount = 'exhibitorAdvertisementShowReceive_allCount',
  ExhibitorAdvertisementShowReceiveAllUniqueUser = 'exhibitorAdvertisementShowReceive_allUniqueUser',
  ExhibitorAdvertisementShowReceiveAndroidCount = 'exhibitorAdvertisementShowReceive_androidCount',
  ExhibitorAdvertisementShowReceiveAndroidUniqueUser = 'exhibitorAdvertisementShowReceive_androidUniqueUser',
  ExhibitorAdvertisementShowReceiveIosCount = 'exhibitorAdvertisementShowReceive_iosCount',
  ExhibitorAdvertisementShowReceiveIosUniqueUser = 'exhibitorAdvertisementShowReceive_iosUniqueUser',
  ExhibitorAdvertisementShowReceiveTimestampMax = 'exhibitorAdvertisementShowReceive_timestampMax',
  ExhibitorAdvertisementShowReceiveTimestampMin = 'exhibitorAdvertisementShowReceive_timestampMin',
  ExhibitorAdvertisementShowReceiveWebCount = 'exhibitorAdvertisementShowReceive_webCount',
  ExhibitorAdvertisementShowReceiveWebTeamCount = 'exhibitorAdvertisementShowReceive_webTeamCount',
  ExhibitorAdvertisementShowReceiveWebTeamUniqueUser = 'exhibitorAdvertisementShowReceive_webTeamUniqueUser',
  ExhibitorAdvertisementShowReceiveWebUniqueUser = 'exhibitorAdvertisementShowReceive_webUniqueUser',
  ExhibitorAdvertisementShowReceiveWebUserCount = 'exhibitorAdvertisementShowReceive_webUserCount',
  ExhibitorAdvertisementShowReceiveWebUserUniqueUser = 'exhibitorAdvertisementShowReceive_webUserUniqueUser',
  ExhibitorAdvertisementShowAllCount = 'exhibitorAdvertisementShow_allCount',
  ExhibitorAdvertisementShowAllUniqueUser = 'exhibitorAdvertisementShow_allUniqueUser',
  ExhibitorAdvertisementShowAndroidCount = 'exhibitorAdvertisementShow_androidCount',
  ExhibitorAdvertisementShowAndroidUniqueUser = 'exhibitorAdvertisementShow_androidUniqueUser',
  ExhibitorAdvertisementShowIosCount = 'exhibitorAdvertisementShow_iosCount',
  ExhibitorAdvertisementShowIosUniqueUser = 'exhibitorAdvertisementShow_iosUniqueUser',
  ExhibitorAdvertisementShowTimestampMax = 'exhibitorAdvertisementShow_timestampMax',
  ExhibitorAdvertisementShowTimestampMin = 'exhibitorAdvertisementShow_timestampMin',
  ExhibitorAdvertisementShowWebCount = 'exhibitorAdvertisementShow_webCount',
  ExhibitorAdvertisementShowWebTeamCount = 'exhibitorAdvertisementShow_webTeamCount',
  ExhibitorAdvertisementShowWebTeamUniqueUser = 'exhibitorAdvertisementShow_webTeamUniqueUser',
  ExhibitorAdvertisementShowWebUniqueUser = 'exhibitorAdvertisementShow_webUniqueUser',
  ExhibitorAdvertisementShowWebUserCount = 'exhibitorAdvertisementShow_webUserCount',
  ExhibitorAdvertisementShowWebUserUniqueUser = 'exhibitorAdvertisementShow_webUserUniqueUser',
  ExhibitorBookmarkReceiveAllCount = 'exhibitorBookmarkReceive_allCount',
  ExhibitorBookmarkReceiveAllUniqueUser = 'exhibitorBookmarkReceive_allUniqueUser',
  ExhibitorBookmarkReceiveTimestampMax = 'exhibitorBookmarkReceive_timestampMax',
  ExhibitorBookmarkReceiveTimestampMin = 'exhibitorBookmarkReceive_timestampMin',
  ExhibitorBookmarkAllCount = 'exhibitorBookmark_allCount',
  ExhibitorBookmarkAllUniqueUser = 'exhibitorBookmark_allUniqueUser',
  ExhibitorBookmarkTimestampMax = 'exhibitorBookmark_timestampMax',
  ExhibitorBookmarkTimestampMin = 'exhibitorBookmark_timestampMin',
  ExhibitorPopularityAllCount = 'exhibitorPopularity_allCount',
  ExhibitorPopularityAllUniqueUser = 'exhibitorPopularity_allUniqueUser',
  ExhibitorPopularityAndroidCount = 'exhibitorPopularity_androidCount',
  ExhibitorPopularityAndroidUniqueUser = 'exhibitorPopularity_androidUniqueUser',
  ExhibitorPopularityIosCount = 'exhibitorPopularity_iosCount',
  ExhibitorPopularityIosUniqueUser = 'exhibitorPopularity_iosUniqueUser',
  ExhibitorPopularityTimestampMax = 'exhibitorPopularity_timestampMax',
  ExhibitorPopularityTimestampMin = 'exhibitorPopularity_timestampMin',
  ExhibitorPopularityWebCount = 'exhibitorPopularity_webCount',
  ExhibitorPopularityWebTeamCount = 'exhibitorPopularity_webTeamCount',
  ExhibitorPopularityWebTeamUniqueUser = 'exhibitorPopularity_webTeamUniqueUser',
  ExhibitorPopularityWebUniqueUser = 'exhibitorPopularity_webUniqueUser',
  ExhibitorPopularityWebUserCount = 'exhibitorPopularity_webUserCount',
  ExhibitorPopularityWebUserUniqueUser = 'exhibitorPopularity_webUserUniqueUser',
  ExhibitorSelfShowAllCount = 'exhibitorSelfShow_allCount',
  ExhibitorSelfShowAllUniqueUser = 'exhibitorSelfShow_allUniqueUser',
  ExhibitorSelfShowAndroidCount = 'exhibitorSelfShow_androidCount',
  ExhibitorSelfShowAndroidUniqueUser = 'exhibitorSelfShow_androidUniqueUser',
  ExhibitorSelfShowIosCount = 'exhibitorSelfShow_iosCount',
  ExhibitorSelfShowIosUniqueUser = 'exhibitorSelfShow_iosUniqueUser',
  ExhibitorSelfShowWebCount = 'exhibitorSelfShow_webCount',
  ExhibitorSelfShowWebTeamCount = 'exhibitorSelfShow_webTeamCount',
  ExhibitorSelfShowWebTeamUniqueUser = 'exhibitorSelfShow_webTeamUniqueUser',
  ExhibitorSelfShowWebUniqueUser = 'exhibitorSelfShow_webUniqueUser',
  ExhibitorSelfShowWebUserCount = 'exhibitorSelfShow_webUserCount',
  ExhibitorSelfShowWebUserUniqueUser = 'exhibitorSelfShow_webUserUniqueUser',
  ExhibitorShowReceiveAllCount = 'exhibitorShowReceive_allCount',
  ExhibitorShowReceiveAllUniqueUser = 'exhibitorShowReceive_allUniqueUser',
  ExhibitorShowReceiveAndroidCount = 'exhibitorShowReceive_androidCount',
  ExhibitorShowReceiveAndroidUniqueUser = 'exhibitorShowReceive_androidUniqueUser',
  ExhibitorShowReceiveIosCount = 'exhibitorShowReceive_iosCount',
  ExhibitorShowReceiveIosUniqueUser = 'exhibitorShowReceive_iosUniqueUser',
  ExhibitorShowReceiveTimestampMax = 'exhibitorShowReceive_timestampMax',
  ExhibitorShowReceiveTimestampMin = 'exhibitorShowReceive_timestampMin',
  ExhibitorShowReceiveWebCount = 'exhibitorShowReceive_webCount',
  ExhibitorShowReceiveWebTeamCount = 'exhibitorShowReceive_webTeamCount',
  ExhibitorShowReceiveWebTeamUniqueUser = 'exhibitorShowReceive_webTeamUniqueUser',
  ExhibitorShowReceiveWebUniqueUser = 'exhibitorShowReceive_webUniqueUser',
  ExhibitorShowReceiveWebUserCount = 'exhibitorShowReceive_webUserCount',
  ExhibitorShowReceiveWebUserUniqueUser = 'exhibitorShowReceive_webUserUniqueUser',
  ExhibitorShowAllCount = 'exhibitorShow_allCount',
  ExhibitorShowAllUniqueUser = 'exhibitorShow_allUniqueUser',
  ExhibitorShowAndroidCount = 'exhibitorShow_androidCount',
  ExhibitorShowAndroidUniqueUser = 'exhibitorShow_androidUniqueUser',
  ExhibitorShowIosCount = 'exhibitorShow_iosCount',
  ExhibitorShowIosUniqueUser = 'exhibitorShow_iosUniqueUser',
  ExhibitorShowTimestampMax = 'exhibitorShow_timestampMax',
  ExhibitorShowTimestampMin = 'exhibitorShow_timestampMin',
  ExhibitorShowWebCount = 'exhibitorShow_webCount',
  ExhibitorShowWebTeamCount = 'exhibitorShow_webTeamCount',
  ExhibitorShowWebTeamUniqueUser = 'exhibitorShow_webTeamUniqueUser',
  ExhibitorShowWebUniqueUser = 'exhibitorShow_webUniqueUser',
  ExhibitorShowWebUserCount = 'exhibitorShow_webUserCount',
  ExhibitorShowWebUserUniqueUser = 'exhibitorShow_webUserUniqueUser',
  InterstitialAddShowAllCount = 'interstitialAddShow_allCount',
  InterstitialAddShowAllUniqueUser = 'interstitialAddShow_allUniqueUser',
  InterstitialAddShowAndroidCount = 'interstitialAddShow_androidCount',
  InterstitialAddShowAndroidUniqueUser = 'interstitialAddShow_androidUniqueUser',
  InterstitialAddShowDurationAndroidAverage = 'interstitialAddShow_durationAndroidAverage',
  InterstitialAddShowDurationAndroidSum = 'interstitialAddShow_durationAndroidSum',
  InterstitialAddShowDurationAverage = 'interstitialAddShow_durationAverage',
  InterstitialAddShowDurationIosAverage = 'interstitialAddShow_durationIosAverage',
  InterstitialAddShowDurationIosSum = 'interstitialAddShow_durationIosSum',
  InterstitialAddShowDurationSum = 'interstitialAddShow_durationSum',
  InterstitialAddShowDurationWebAverage = 'interstitialAddShow_durationWebAverage',
  InterstitialAddShowDurationWebSum = 'interstitialAddShow_durationWebSum',
  InterstitialAddShowDurationWebTeamAverage = 'interstitialAddShow_durationWebTeamAverage',
  InterstitialAddShowDurationWebTeamSum = 'interstitialAddShow_durationWebTeamSum',
  InterstitialAddShowDurationWebUserAverage = 'interstitialAddShow_durationWebUserAverage',
  InterstitialAddShowDurationWebUserSum = 'interstitialAddShow_durationWebUserSum',
  InterstitialAddShowIosCount = 'interstitialAddShow_iosCount',
  InterstitialAddShowIosUniqueUser = 'interstitialAddShow_iosUniqueUser',
  InterstitialAddShowWebCount = 'interstitialAddShow_webCount',
  InterstitialAddShowWebTeamCount = 'interstitialAddShow_webTeamCount',
  InterstitialAddShowWebTeamUniqueUser = 'interstitialAddShow_webTeamUniqueUser',
  InterstitialAddShowWebUniqueUser = 'interstitialAddShow_webUniqueUser',
  InterstitialAddShowWebUserCount = 'interstitialAddShow_webUserCount',
  InterstitialAddShowWebUserUniqueUser = 'interstitialAddShow_webUserUniqueUser',
  MeetingParticipantAllCount = 'meetingParticipant_allCount',
  MeetingParticipantAllUnique = 'meetingParticipant_allUnique',
  MeetingParticipantAllUniqueUser = 'meetingParticipant_allUniqueUser',
  MeetingParticipantCanceledCount = 'meetingParticipant_canceledCount',
  MeetingParticipantCanceledUnique = 'meetingParticipant_canceledUnique',
  MeetingParticipantCanceledUniqueUser = 'meetingParticipant_canceledUniqueUser',
  MeetingParticipantConfirmedCount = 'meetingParticipant_confirmedCount',
  MeetingParticipantConfirmedUnique = 'meetingParticipant_confirmedUnique',
  MeetingParticipantConfirmedUniqueUser = 'meetingParticipant_confirmedUniqueUser',
  MeetingParticipantDeclinedCount = 'meetingParticipant_declinedCount',
  MeetingParticipantDeclinedUnique = 'meetingParticipant_declinedUnique',
  MeetingParticipantDeclinedUniqueUser = 'meetingParticipant_declinedUniqueUser',
  MeetingParticipantExpiredCount = 'meetingParticipant_expiredCount',
  MeetingParticipantExpiredUnique = 'meetingParticipant_expiredUnique',
  MeetingParticipantExpiredUniqueUser = 'meetingParticipant_expiredUniqueUser',
  MeetingParticipantNoShowCount = 'meetingParticipant_noShowCount',
  MeetingParticipantNoShowUnique = 'meetingParticipant_noShowUnique',
  MeetingParticipantNoShowUniqueUser = 'meetingParticipant_noShowUniqueUser',
  MeetingParticipantPendingCount = 'meetingParticipant_pendingCount',
  MeetingParticipantPendingUnique = 'meetingParticipant_pendingUnique',
  MeetingParticipantPendingUniqueUser = 'meetingParticipant_pendingUniqueUser',
  MeetingRequestReceiveAcceptedCount = 'meetingRequestReceive_acceptedCount',
  MeetingRequestReceiveAcceptedUniqueUser = 'meetingRequestReceive_acceptedUniqueUser',
  MeetingRequestReceiveAcceptedWithUniqueUser = 'meetingRequestReceive_acceptedWithUniqueUser',
  MeetingRequestReceiveAllCount = 'meetingRequestReceive_allCount',
  MeetingRequestReceiveAllUniqueUser = 'meetingRequestReceive_allUniqueUser',
  MeetingRequestReceiveAllWithUniqueUser = 'meetingRequestReceive_allWithUniqueUser',
  MeetingRequestReceiveCancelledCount = 'meetingRequestReceive_cancelledCount',
  MeetingRequestReceiveCancelledUniqueUser = 'meetingRequestReceive_cancelledUniqueUser',
  MeetingRequestReceiveCancelledWithUniqueUser = 'meetingRequestReceive_cancelledWithUniqueUser',
  MeetingRequestReceiveDeclinedCount = 'meetingRequestReceive_declinedCount',
  MeetingRequestReceiveDeclinedUniqueUser = 'meetingRequestReceive_declinedUniqueUser',
  MeetingRequestReceiveDeclinedWithUniqueUser = 'meetingRequestReceive_declinedWithUniqueUser',
  MeetingRequestReceiveExpiredCount = 'meetingRequestReceive_expiredCount',
  MeetingRequestReceiveExpiredUniqueUser = 'meetingRequestReceive_expiredUniqueUser',
  MeetingRequestReceiveExpiredWithUniqueUser = 'meetingRequestReceive_expiredWithUniqueUser',
  MeetingRequestReceivePendingCount = 'meetingRequestReceive_pendingCount',
  MeetingRequestReceivePendingUniqueUser = 'meetingRequestReceive_pendingUniqueUser',
  MeetingRequestReceivePendingWithUniqueUser = 'meetingRequestReceive_pendingWithUniqueUser',
  MeetingRequestAcceptedCount = 'meetingRequest_acceptedCount',
  MeetingRequestAcceptedUniqueUser = 'meetingRequest_acceptedUniqueUser',
  MeetingRequestAcceptedWithUniqueUser = 'meetingRequest_acceptedWithUniqueUser',
  MeetingRequestAllCount = 'meetingRequest_allCount',
  MeetingRequestAllUniqueUser = 'meetingRequest_allUniqueUser',
  MeetingRequestAllWithUniqueUser = 'meetingRequest_allWithUniqueUser',
  MeetingRequestCancelledCount = 'meetingRequest_cancelledCount',
  MeetingRequestCancelledUniqueUser = 'meetingRequest_cancelledUniqueUser',
  MeetingRequestCancelledWithUniqueUser = 'meetingRequest_cancelledWithUniqueUser',
  MeetingRequestDeclinedCount = 'meetingRequest_declinedCount',
  MeetingRequestDeclinedUniqueUser = 'meetingRequest_declinedUniqueUser',
  MeetingRequestDeclinedWithUniqueUser = 'meetingRequest_declinedWithUniqueUser',
  MeetingRequestExpiredCount = 'meetingRequest_expiredCount',
  MeetingRequestExpiredUniqueUser = 'meetingRequest_expiredUniqueUser',
  MeetingRequestExpiredWithUniqueUser = 'meetingRequest_expiredWithUniqueUser',
  MeetingRequestPendingCount = 'meetingRequest_pendingCount',
  MeetingRequestPendingUniqueUser = 'meetingRequest_pendingUniqueUser',
  MeetingRequestPendingWithUniqueUser = 'meetingRequest_pendingWithUniqueUser',
  MeetingAllCount = 'meeting_allCount',
  MeetingAllUnique = 'meeting_allUnique',
  MeetingAllUniqueUser = 'meeting_allUniqueUser',
  MeetingCanceledCount = 'meeting_canceledCount',
  MeetingCanceledUnique = 'meeting_canceledUnique',
  MeetingCanceledUniqueUser = 'meeting_canceledUniqueUser',
  MeetingConfirmedCount = 'meeting_confirmedCount',
  MeetingConfirmedUnique = 'meeting_confirmedUnique',
  MeetingConfirmedUniqueUser = 'meeting_confirmedUniqueUser',
  MeetingDeclinedCount = 'meeting_declinedCount',
  MeetingDeclinedUnique = 'meeting_declinedUnique',
  MeetingDeclinedUniqueUser = 'meeting_declinedUniqueUser',
  MeetingExpiredCount = 'meeting_expiredCount',
  MeetingExpiredUnique = 'meeting_expiredUnique',
  MeetingExpiredUniqueUser = 'meeting_expiredUniqueUser',
  MeetingNoShowCount = 'meeting_noShowCount',
  MeetingNoShowUnique = 'meeting_noShowUnique',
  MeetingNoShowUniqueUser = 'meeting_noShowUniqueUser',
  MeetingPendingCount = 'meeting_pendingCount',
  MeetingPendingUnique = 'meeting_pendingUnique',
  MeetingPendingUniqueUser = 'meeting_pendingUniqueUser',
  MeetingRescheduledCount = 'meeting_rescheduledCount',
  MeetingRescheduledUnique = 'meeting_rescheduledUnique',
  MeetingRescheduledUniqueUser = 'meeting_rescheduledUniqueUser',
  MessageReceiveAllCount = 'messageReceive_allCount',
  MessageReceiveAllUniqueUser = 'messageReceive_allUniqueUser',
  MessageReceiveChannelUnique = 'messageReceive_channelUnique',
  MessageReceivePrivateCount = 'messageReceive_privateCount',
  MessageReceivePrivateUniqueUser = 'messageReceive_privateUniqueUser',
  MessageReceivePrivateWithUniqueUser = 'messageReceive_privateWithUniqueUser',
  MessageReceivePublicCount = 'messageReceive_publicCount',
  MessageReceivePublicUniqueUser = 'messageReceive_publicUniqueUser',
  MessageAllCount = 'message_allCount',
  MessageAllUniqueUser = 'message_allUniqueUser',
  MessageChannelUnique = 'message_channelUnique',
  MessagePrivateCount = 'message_privateCount',
  MessagePrivateUniqueUser = 'message_privateUniqueUser',
  MessagePrivateWithUniqueUser = 'message_privateWithUniqueUser',
  MessagePublicCount = 'message_publicCount',
  MessagePublicUniqueUser = 'message_publicUniqueUser',
  NetworkActivityAllCount = 'networkActivity_allCount',
  NetworkActivityAllUnique = 'networkActivity_allUnique',
  NetworkActivityAllUniqueUser = 'networkActivity_allUniqueUser',
  NetworkActivityAllWithUniqueUser = 'networkActivity_allWithUniqueUser',
  PersonShowReceiveAllCount = 'personShowReceive_allCount',
  PersonShowReceiveAllUniqueUser = 'personShowReceive_allUniqueUser',
  PersonShowReceiveAllWithUniqueUser = 'personShowReceive_allWithUniqueUser',
  PersonShowReceiveAndroidCount = 'personShowReceive_androidCount',
  PersonShowReceiveAndroidUniqueUser = 'personShowReceive_androidUniqueUser',
  PersonShowReceiveAndroidWithUniqueUser = 'personShowReceive_androidWithUniqueUser',
  PersonShowReceiveIosCount = 'personShowReceive_iosCount',
  PersonShowReceiveIosUniqueUser = 'personShowReceive_iosUniqueUser',
  PersonShowReceiveIosWithUniqueUser = 'personShowReceive_iosWithUniqueUser',
  PersonShowReceiveWebCount = 'personShowReceive_webCount',
  PersonShowReceiveWebTeamCount = 'personShowReceive_webTeamCount',
  PersonShowReceiveWebTeamUniqueUser = 'personShowReceive_webTeamUniqueUser',
  PersonShowReceiveWebTeamWithUniqueUser = 'personShowReceive_webTeamWithUniqueUser',
  PersonShowReceiveWebUniqueUser = 'personShowReceive_webUniqueUser',
  PersonShowReceiveWebUserCount = 'personShowReceive_webUserCount',
  PersonShowReceiveWebUserUniqueUser = 'personShowReceive_webUserUniqueUser',
  PersonShowReceiveWebUserWithUniqueUser = 'personShowReceive_webUserWithUniqueUser',
  PersonShowReceiveWebWithUniqueUser = 'personShowReceive_webWithUniqueUser',
  PersonShowAllCount = 'personShow_allCount',
  PersonShowAllUniqueUser = 'personShow_allUniqueUser',
  PersonShowAllWithUniqueUser = 'personShow_allWithUniqueUser',
  PersonShowAndroidCount = 'personShow_androidCount',
  PersonShowAndroidUniqueUser = 'personShow_androidUniqueUser',
  PersonShowAndroidWithUniqueUser = 'personShow_androidWithUniqueUser',
  PersonShowIosCount = 'personShow_iosCount',
  PersonShowIosUniqueUser = 'personShow_iosUniqueUser',
  PersonShowIosWithUniqueUser = 'personShow_iosWithUniqueUser',
  PersonShowWebCount = 'personShow_webCount',
  PersonShowWebTeamCount = 'personShow_webTeamCount',
  PersonShowWebTeamUniqueUser = 'personShow_webTeamUniqueUser',
  PersonShowWebTeamWithUniqueUser = 'personShow_webTeamWithUniqueUser',
  PersonShowWebUniqueUser = 'personShow_webUniqueUser',
  PersonShowWebUserCount = 'personShow_webUserCount',
  PersonShowWebUserUniqueUser = 'personShow_webUserUniqueUser',
  PersonShowWebUserWithUniqueUser = 'personShow_webUserWithUniqueUser',
  PersonShowWebWithUniqueUser = 'personShow_webWithUniqueUser',
  PlanningBookmarkAllCount = 'planningBookmark_allCount',
  PlanningBookmarkAllUniqueUser = 'planningBookmark_allUniqueUser',
  PlanningPopularityAllCount = 'planningPopularity_allCount',
  PlanningPopularityAllUniqueUser = 'planningPopularity_allUniqueUser',
  PlanningPopularityAndroidCount = 'planningPopularity_androidCount',
  PlanningPopularityAndroidUniqueUser = 'planningPopularity_androidUniqueUser',
  PlanningPopularityIosCount = 'planningPopularity_iosCount',
  PlanningPopularityIosUniqueUser = 'planningPopularity_iosUniqueUser',
  PlanningPopularityTimestampMax = 'planningPopularity_timestampMax',
  PlanningPopularityTimestampMin = 'planningPopularity_timestampMin',
  PlanningPopularityWebCount = 'planningPopularity_webCount',
  PlanningPopularityWebTeamCount = 'planningPopularity_webTeamCount',
  PlanningPopularityWebTeamUniqueUser = 'planningPopularity_webTeamUniqueUser',
  PlanningPopularityWebUniqueUser = 'planningPopularity_webUniqueUser',
  PlanningPopularityWebUserCount = 'planningPopularity_webUserCount',
  PlanningPopularityWebUserUniqueUser = 'planningPopularity_webUserUniqueUser',
  PlanningStreamStartAllCount = 'planningStreamStart_allCount',
  PlanningStreamStartAllUniqueUser = 'planningStreamStart_allUniqueUser',
  PlanningStreamStartAndroidCount = 'planningStreamStart_androidCount',
  PlanningStreamStartAndroidUniqueUser = 'planningStreamStart_androidUniqueUser',
  PlanningStreamStartIosCount = 'planningStreamStart_iosCount',
  PlanningStreamStartIosUniqueUser = 'planningStreamStart_iosUniqueUser',
  PlanningStreamStartTimestampMax = 'planningStreamStart_timestampMax',
  PlanningStreamStartTimestampMin = 'planningStreamStart_timestampMin',
  PlanningStreamStartWebCount = 'planningStreamStart_webCount',
  PlanningStreamStartWebTeamCount = 'planningStreamStart_webTeamCount',
  PlanningStreamStartWebTeamUniqueUser = 'planningStreamStart_webTeamUniqueUser',
  PlanningStreamStartWebUniqueUser = 'planningStreamStart_webUniqueUser',
  PlanningStreamStartWebUserCount = 'planningStreamStart_webUserCount',
  PlanningStreamStartWebUserUniqueUser = 'planningStreamStart_webUserUniqueUser',
  PlanningStreamStopAllCount = 'planningStreamStop_allCount',
  PlanningStreamStopAllUniqueUser = 'planningStreamStop_allUniqueUser',
  PlanningStreamStopAndroidCount = 'planningStreamStop_androidCount',
  PlanningStreamStopAndroidUniqueUser = 'planningStreamStop_androidUniqueUser',
  PlanningStreamStopDurationAndroidAverage = 'planningStreamStop_durationAndroidAverage',
  PlanningStreamStopDurationAndroidSum = 'planningStreamStop_durationAndroidSum',
  PlanningStreamStopDurationAverage = 'planningStreamStop_durationAverage',
  PlanningStreamStopDurationIosAverage = 'planningStreamStop_durationIosAverage',
  PlanningStreamStopDurationIosSum = 'planningStreamStop_durationIosSum',
  PlanningStreamStopDurationSum = 'planningStreamStop_durationSum',
  PlanningStreamStopDurationWebAverage = 'planningStreamStop_durationWebAverage',
  PlanningStreamStopDurationWebSum = 'planningStreamStop_durationWebSum',
  PlanningStreamStopDurationWebTeamAverage = 'planningStreamStop_durationWebTeamAverage',
  PlanningStreamStopDurationWebTeamSum = 'planningStreamStop_durationWebTeamSum',
  PlanningStreamStopDurationWebUserAverage = 'planningStreamStop_durationWebUserAverage',
  PlanningStreamStopDurationWebUserSum = 'planningStreamStop_durationWebUserSum',
  PlanningStreamStopIosCount = 'planningStreamStop_iosCount',
  PlanningStreamStopIosUniqueUser = 'planningStreamStop_iosUniqueUser',
  PlanningStreamStopTimestampMax = 'planningStreamStop_timestampMax',
  PlanningStreamStopTimestampMin = 'planningStreamStop_timestampMin',
  PlanningStreamStopWebCount = 'planningStreamStop_webCount',
  PlanningStreamStopWebTeamCount = 'planningStreamStop_webTeamCount',
  PlanningStreamStopWebTeamUniqueUser = 'planningStreamStop_webTeamUniqueUser',
  PlanningStreamStopWebUniqueUser = 'planningStreamStop_webUniqueUser',
  PlanningStreamStopWebUserCount = 'planningStreamStop_webUserCount',
  PlanningStreamStopWebUserUniqueUser = 'planningStreamStop_webUserUniqueUser',
  PlanningStreamAllCount = 'planningStream_allCount',
  PlanningStreamAllUniqueUser = 'planningStream_allUniqueUser',
  PlanningStreamAndroidCount = 'planningStream_androidCount',
  PlanningStreamAndroidUniqueUser = 'planningStream_androidUniqueUser',
  PlanningStreamIosCount = 'planningStream_iosCount',
  PlanningStreamIosUniqueUser = 'planningStream_iosUniqueUser',
  PlanningStreamTimestampMax = 'planningStream_timestampMax',
  PlanningStreamTimestampMin = 'planningStream_timestampMin',
  PlanningStreamWebCount = 'planningStream_webCount',
  PlanningStreamWebTeamCount = 'planningStream_webTeamCount',
  PlanningStreamWebTeamUniqueUser = 'planningStream_webTeamUniqueUser',
  PlanningStreamWebUniqueUser = 'planningStream_webUniqueUser',
  PlanningStreamWebUserCount = 'planningStream_webUserCount',
  PlanningStreamWebUserUniqueUser = 'planningStream_webUserUniqueUser',
  PostLinkOpenAllCount = 'postLinkOpen_allCount',
  PostLinkOpenAllUniqueUser = 'postLinkOpen_allUniqueUser',
  PostLinkOpenAndroidCount = 'postLinkOpen_androidCount',
  PostLinkOpenAndroidUniqueUser = 'postLinkOpen_androidUniqueUser',
  PostLinkOpenIosCount = 'postLinkOpen_iosCount',
  PostLinkOpenIosUniqueUser = 'postLinkOpen_iosUniqueUser',
  PostLinkOpenWebCount = 'postLinkOpen_webCount',
  PostLinkOpenWebTeamCount = 'postLinkOpen_webTeamCount',
  PostLinkOpenWebTeamUniqueUser = 'postLinkOpen_webTeamUniqueUser',
  PostLinkOpenWebUniqueUser = 'postLinkOpen_webUniqueUser',
  PostLinkOpenWebUserCount = 'postLinkOpen_webUserCount',
  PostLinkOpenWebUserUniqueUser = 'postLinkOpen_webUserUniqueUser',
  ProductBookmarkAllCount = 'productBookmark_allCount',
  ProductBookmarkAllUniqueUser = 'productBookmark_allUniqueUser',
  ProductBookmarkTimestampMax = 'productBookmark_timestampMax',
  ProductBookmarkTimestampMin = 'productBookmark_timestampMin',
  ProductShowAllCount = 'productShow_allCount',
  ProductShowAllUniqueUser = 'productShow_allUniqueUser',
  ProductShowAndroidCount = 'productShow_androidCount',
  ProductShowAndroidUniqueUser = 'productShow_androidUniqueUser',
  ProductShowIosCount = 'productShow_iosCount',
  ProductShowIosUniqueUser = 'productShow_iosUniqueUser',
  ProductShowTimestampMax = 'productShow_timestampMax',
  ProductShowTimestampMin = 'productShow_timestampMin',
  ProductShowWebCount = 'productShow_webCount',
  ProductShowWebTeamCount = 'productShow_webTeamCount',
  ProductShowWebTeamUniqueUser = 'productShow_webTeamUniqueUser',
  ProductShowWebUniqueUser = 'productShow_webUniqueUser',
  ProductShowWebUserCount = 'productShow_webUserCount',
  ProductShowWebUserUniqueUser = 'productShow_webUserUniqueUser',
  RegistrationAbandonedCount = 'registration_abandonedCount',
  RegistrationAllCount = 'registration_allCount',
  RegistrationCanceledCount = 'registration_canceledCount',
  RegistrationCheckedInCount = 'registration_checkedInCount',
  RegistrationRegisteredCount = 'registration_registeredCount',
  SponsorShowAllCount = 'sponsorShow_allCount',
  SponsorShowAllUniqueUser = 'sponsorShow_allUniqueUser',
  SponsorShowAndroidCount = 'sponsorShow_androidCount',
  SponsorShowAndroidUniqueUser = 'sponsorShow_androidUniqueUser',
  SponsorShowIosCount = 'sponsorShow_iosCount',
  SponsorShowIosUniqueUser = 'sponsorShow_iosUniqueUser',
  SponsorShowTimestampMax = 'sponsorShow_timestampMax',
  SponsorShowTimestampMin = 'sponsorShow_timestampMin',
  SponsorShowWebCount = 'sponsorShow_webCount',
  SponsorShowWebTeamCount = 'sponsorShow_webTeamCount',
  SponsorShowWebTeamUniqueUser = 'sponsorShow_webTeamUniqueUser',
  SponsorShowWebUniqueUser = 'sponsorShow_webUniqueUser',
  SponsorShowWebUserCount = 'sponsorShow_webUserCount',
  SponsorShowWebUserUniqueUser = 'sponsorShow_webUserUniqueUser',
  StreamStartAllCount = 'streamStart_allCount',
  StreamStartAllUniqueUser = 'streamStart_allUniqueUser',
  StreamStartAndroidCount = 'streamStart_androidCount',
  StreamStartAndroidUniqueUser = 'streamStart_androidUniqueUser',
  StreamStartIosCount = 'streamStart_iosCount',
  StreamStartIosUniqueUser = 'streamStart_iosUniqueUser',
  StreamStartTimestampMax = 'streamStart_timestampMax',
  StreamStartTimestampMin = 'streamStart_timestampMin',
  StreamStartWebCount = 'streamStart_webCount',
  StreamStartWebTeamCount = 'streamStart_webTeamCount',
  StreamStartWebTeamUniqueUser = 'streamStart_webTeamUniqueUser',
  StreamStartWebUniqueUser = 'streamStart_webUniqueUser',
  StreamStartWebUserCount = 'streamStart_webUserCount',
  StreamStartWebUserUniqueUser = 'streamStart_webUserUniqueUser',
  StreamStopAllCount = 'streamStop_allCount',
  StreamStopAllUniqueUser = 'streamStop_allUniqueUser',
  StreamStopAndroidCount = 'streamStop_androidCount',
  StreamStopAndroidUniqueUser = 'streamStop_androidUniqueUser',
  StreamStopDurationAndroidAverage = 'streamStop_durationAndroidAverage',
  StreamStopDurationAndroidSum = 'streamStop_durationAndroidSum',
  StreamStopDurationAverage = 'streamStop_durationAverage',
  StreamStopDurationIosAverage = 'streamStop_durationIosAverage',
  StreamStopDurationIosSum = 'streamStop_durationIosSum',
  StreamStopDurationSum = 'streamStop_durationSum',
  StreamStopDurationWebAverage = 'streamStop_durationWebAverage',
  StreamStopDurationWebSum = 'streamStop_durationWebSum',
  StreamStopDurationWebTeamAverage = 'streamStop_durationWebTeamAverage',
  StreamStopDurationWebTeamSum = 'streamStop_durationWebTeamSum',
  StreamStopDurationWebUserAverage = 'streamStop_durationWebUserAverage',
  StreamStopDurationWebUserSum = 'streamStop_durationWebUserSum',
  StreamStopIosCount = 'streamStop_iosCount',
  StreamStopIosUniqueUser = 'streamStop_iosUniqueUser',
  StreamStopTimestampMax = 'streamStop_timestampMax',
  StreamStopTimestampMin = 'streamStop_timestampMin',
  StreamStopWebCount = 'streamStop_webCount',
  StreamStopWebTeamCount = 'streamStop_webTeamCount',
  StreamStopWebTeamUniqueUser = 'streamStop_webTeamUniqueUser',
  StreamStopWebUniqueUser = 'streamStop_webUniqueUser',
  StreamStopWebUserCount = 'streamStop_webUserCount',
  StreamStopWebUserUniqueUser = 'streamStop_webUserUniqueUser',
  UsageAllUniqueUser = 'usage_allUniqueUser',
  UsageAndroidUniqueUser = 'usage_androidUniqueUser',
  UsageIosUniqueUser = 'usage_iosUniqueUser',
  UsageWebTeamUniqueUser = 'usage_webTeamUniqueUser',
  UsageWebUniqueUser = 'usage_webUniqueUser',
  UsageWebUserUniqueUser = 'usage_webUserUniqueUser',
  VideoCallRoomAllCount = 'videoCallRoom_allCount',
  VideoCallRoomAllUniqueUser = 'videoCallRoom_allUniqueUser',
  VideoCallRoomAllWithUniqueUser = 'videoCallRoom_allWithUniqueUser',
  VideoCallRoomSucceededCount = 'videoCallRoom_succeededCount',
  VideoCallRoomSucceededDurationAverage = 'videoCallRoom_succeededDurationAverage',
  VideoCallRoomSucceededDurationSum = 'videoCallRoom_succeededDurationSum',
  VideoCallRoomSucceededUniqueUser = 'videoCallRoom_succeededUniqueUser',
  VideoCallRoomSucceededWithUniqueUser = 'videoCallRoom_succeededWithUniqueUser'
}

export type Analytics_SortCommunityGroups = {
  direction: Analytics_SortDirection;
  field: Analytics_SortCommunityGroupsField;
  limit?: InputMaybe<Scalars['Int']>;
};

export enum Analytics_SortCommunityGroupsField {
  ActivityTimestampMax = 'activity_timestampMax',
  ActivityTimestampMin = 'activity_timestampMin',
  AddOpenAllCount = 'addOpen_allCount',
  AddOpenAllUniqueUser = 'addOpen_allUniqueUser',
  AddOpenAndroidCount = 'addOpen_androidCount',
  AddOpenAndroidUniqueUser = 'addOpen_androidUniqueUser',
  AddOpenIosCount = 'addOpen_iosCount',
  AddOpenIosUniqueUser = 'addOpen_iosUniqueUser',
  AddOpenTimestampMax = 'addOpen_timestampMax',
  AddOpenTimestampMin = 'addOpen_timestampMin',
  AddOpenWebCount = 'addOpen_webCount',
  AddOpenWebTeamCount = 'addOpen_webTeamCount',
  AddOpenWebTeamUniqueUser = 'addOpen_webTeamUniqueUser',
  AddOpenWebUniqueUser = 'addOpen_webUniqueUser',
  AddOpenWebUserCount = 'addOpen_webUserCount',
  AddOpenWebUserUniqueUser = 'addOpen_webUserUniqueUser',
  AdvertisementOpenAllCount = 'advertisementOpen_allCount',
  AdvertisementOpenAllUniqueUser = 'advertisementOpen_allUniqueUser',
  AdvertisementOpenAndroidCount = 'advertisementOpen_androidCount',
  AdvertisementOpenAndroidUniqueUser = 'advertisementOpen_androidUniqueUser',
  AdvertisementOpenIosCount = 'advertisementOpen_iosCount',
  AdvertisementOpenIosUniqueUser = 'advertisementOpen_iosUniqueUser',
  AdvertisementOpenTimestampMax = 'advertisementOpen_timestampMax',
  AdvertisementOpenTimestampMin = 'advertisementOpen_timestampMin',
  AdvertisementOpenWebCount = 'advertisementOpen_webCount',
  AdvertisementOpenWebTeamCount = 'advertisementOpen_webTeamCount',
  AdvertisementOpenWebTeamUniqueUser = 'advertisementOpen_webTeamUniqueUser',
  AdvertisementOpenWebUniqueUser = 'advertisementOpen_webUniqueUser',
  AdvertisementOpenWebUserCount = 'advertisementOpen_webUserCount',
  AdvertisementOpenWebUserUniqueUser = 'advertisementOpen_webUserUniqueUser',
  AdvertisementShowAllCount = 'advertisementShow_allCount',
  AdvertisementShowAllUniqueUser = 'advertisementShow_allUniqueUser',
  AdvertisementShowAndroidCount = 'advertisementShow_androidCount',
  AdvertisementShowAndroidUniqueUser = 'advertisementShow_androidUniqueUser',
  AdvertisementShowDurationAndroidAverage = 'advertisementShow_durationAndroidAverage',
  AdvertisementShowDurationAndroidSum = 'advertisementShow_durationAndroidSum',
  AdvertisementShowDurationAverage = 'advertisementShow_durationAverage',
  AdvertisementShowDurationIosAverage = 'advertisementShow_durationIosAverage',
  AdvertisementShowDurationIosSum = 'advertisementShow_durationIosSum',
  AdvertisementShowDurationSum = 'advertisementShow_durationSum',
  AdvertisementShowDurationWebAverage = 'advertisementShow_durationWebAverage',
  AdvertisementShowDurationWebSum = 'advertisementShow_durationWebSum',
  AdvertisementShowDurationWebTeamAverage = 'advertisementShow_durationWebTeamAverage',
  AdvertisementShowDurationWebTeamSum = 'advertisementShow_durationWebTeamSum',
  AdvertisementShowDurationWebUserAverage = 'advertisementShow_durationWebUserAverage',
  AdvertisementShowDurationWebUserSum = 'advertisementShow_durationWebUserSum',
  AdvertisementShowIosCount = 'advertisementShow_iosCount',
  AdvertisementShowIosUniqueUser = 'advertisementShow_iosUniqueUser',
  AdvertisementShowWebCount = 'advertisementShow_webCount',
  AdvertisementShowWebTeamCount = 'advertisementShow_webTeamCount',
  AdvertisementShowWebTeamUniqueUser = 'advertisementShow_webTeamUniqueUser',
  AdvertisementShowWebUniqueUser = 'advertisementShow_webUniqueUser',
  AdvertisementShowWebUserCount = 'advertisementShow_webUserCount',
  AdvertisementShowWebUserUniqueUser = 'advertisementShow_webUserUniqueUser',
  BookmarkReceiveAllCount = 'bookmarkReceive_allCount',
  BookmarkReceiveAllUniqueUser = 'bookmarkReceive_allUniqueUser',
  BookmarkReceiveTimestampMax = 'bookmarkReceive_timestampMax',
  BookmarkReceiveTimestampMin = 'bookmarkReceive_timestampMin',
  BookmarkAllCount = 'bookmark_allCount',
  BookmarkAllUniqueUser = 'bookmark_allUniqueUser',
  BookmarkTimestampMax = 'bookmark_timestampMax',
  BookmarkTimestampMin = 'bookmark_timestampMin',
  ChannelOpenAllCount = 'channelOpen_allCount',
  ChannelOpenAllUniqueUser = 'channelOpen_allUniqueUser',
  ChannelOpenAndroidCount = 'channelOpen_androidCount',
  ChannelOpenAndroidUniqueUser = 'channelOpen_androidUniqueUser',
  ChannelOpenIosCount = 'channelOpen_iosCount',
  ChannelOpenIosUniqueUser = 'channelOpen_iosUniqueUser',
  ChannelOpenWebCount = 'channelOpen_webCount',
  ChannelOpenWebTeamCount = 'channelOpen_webTeamCount',
  ChannelOpenWebTeamUniqueUser = 'channelOpen_webTeamUniqueUser',
  ChannelOpenWebUniqueUser = 'channelOpen_webUniqueUser',
  ChannelOpenWebUserCount = 'channelOpen_webUserCount',
  ChannelOpenWebUserUniqueUser = 'channelOpen_webUserUniqueUser',
  ConnectionReceiveAllCount = 'connectionReceive_allCount',
  ConnectionReceiveAllUnique = 'connectionReceive_allUnique',
  ConnectionReceiveAllUniqueUser = 'connectionReceive_allUniqueUser',
  ConnectionReceiveAllWithUniqueUser = 'connectionReceive_allWithUniqueUser',
  ConnectionReceiveNotScanCount = 'connectionReceive_notScanCount',
  ConnectionReceiveNotScanUnique = 'connectionReceive_notScanUnique',
  ConnectionReceiveNotScanUniqueUser = 'connectionReceive_notScanUniqueUser',
  ConnectionReceiveNotScanWithUniqueUser = 'connectionReceive_notScanWithUniqueUser',
  ConnectionReceiveScanCount = 'connectionReceive_scanCount',
  ConnectionReceiveScanUnique = 'connectionReceive_scanUnique',
  ConnectionReceiveScanUniqueUser = 'connectionReceive_scanUniqueUser',
  ConnectionReceiveScanWithUniqueUser = 'connectionReceive_scanWithUniqueUser',
  ConnectionReceiveScoreAverage = 'connectionReceive_scoreAverage',
  ConnectionReceiveScoreCount = 'connectionReceive_scoreCount',
  ConnectionReceiveScoreUnique = 'connectionReceive_scoreUnique',
  ConnectionReceiveScoreUniqueUser = 'connectionReceive_scoreUniqueUser',
  ConnectionReceiveScoreWithUniqueUser = 'connectionReceive_scoreWithUniqueUser',
  ConnectionRequestReceiveAcceptedCount = 'connectionRequestReceive_acceptedCount',
  ConnectionRequestReceiveAcceptedUniqueUser = 'connectionRequestReceive_acceptedUniqueUser',
  ConnectionRequestReceiveAcceptedWithUniqueUser = 'connectionRequestReceive_acceptedWithUniqueUser',
  ConnectionRequestReceiveAllCount = 'connectionRequestReceive_allCount',
  ConnectionRequestReceiveAllUniqueUser = 'connectionRequestReceive_allUniqueUser',
  ConnectionRequestReceiveAllWithUniqueUser = 'connectionRequestReceive_allWithUniqueUser',
  ConnectionRequestReceiveDeclinedCount = 'connectionRequestReceive_declinedCount',
  ConnectionRequestReceiveDeclinedUniqueUser = 'connectionRequestReceive_declinedUniqueUser',
  ConnectionRequestReceiveDeclinedWithUniqueUser = 'connectionRequestReceive_declinedWithUniqueUser',
  ConnectionRequestReceivePendingCount = 'connectionRequestReceive_pendingCount',
  ConnectionRequestReceivePendingUniqueUser = 'connectionRequestReceive_pendingUniqueUser',
  ConnectionRequestReceivePendingWithUniqueUser = 'connectionRequestReceive_pendingWithUniqueUser',
  ConnectionRequestAcceptedCount = 'connectionRequest_acceptedCount',
  ConnectionRequestAcceptedUniqueUser = 'connectionRequest_acceptedUniqueUser',
  ConnectionRequestAcceptedWithUniqueUser = 'connectionRequest_acceptedWithUniqueUser',
  ConnectionRequestAllCount = 'connectionRequest_allCount',
  ConnectionRequestAllUniqueUser = 'connectionRequest_allUniqueUser',
  ConnectionRequestAllWithUniqueUser = 'connectionRequest_allWithUniqueUser',
  ConnectionRequestDeclinedCount = 'connectionRequest_declinedCount',
  ConnectionRequestDeclinedUniqueUser = 'connectionRequest_declinedUniqueUser',
  ConnectionRequestDeclinedWithUniqueUser = 'connectionRequest_declinedWithUniqueUser',
  ConnectionRequestPendingCount = 'connectionRequest_pendingCount',
  ConnectionRequestPendingUniqueUser = 'connectionRequest_pendingUniqueUser',
  ConnectionRequestPendingWithUniqueUser = 'connectionRequest_pendingWithUniqueUser',
  ConnectionAllCount = 'connection_allCount',
  ConnectionAllUnique = 'connection_allUnique',
  ConnectionAllUniqueUser = 'connection_allUniqueUser',
  ConnectionAllWithUniqueUser = 'connection_allWithUniqueUser',
  ConnectionNotScanCount = 'connection_notScanCount',
  ConnectionNotScanUnique = 'connection_notScanUnique',
  ConnectionNotScanUniqueUser = 'connection_notScanUniqueUser',
  ConnectionNotScanWithUniqueUser = 'connection_notScanWithUniqueUser',
  ConnectionScanCount = 'connection_scanCount',
  ConnectionScanUnique = 'connection_scanUnique',
  ConnectionScanUniqueUser = 'connection_scanUniqueUser',
  ConnectionScanWithUniqueUser = 'connection_scanWithUniqueUser',
  ConnectionScoreAverage = 'connection_scoreAverage',
  ConnectionScoreCount = 'connection_scoreCount',
  ConnectionScoreUnique = 'connection_scoreUnique',
  ConnectionScoreUniqueUser = 'connection_scoreUniqueUser',
  ConnectionScoreWithUniqueUser = 'connection_scoreWithUniqueUser',
  ContactAllCount = 'contact_allCount',
  ContactAllUniqueUser = 'contact_allUniqueUser',
  ContactNotScanCount = 'contact_notScanCount',
  ContactNotScanUniqueUser = 'contact_notScanUniqueUser',
  ContactScanCount = 'contact_scanCount',
  ContactScanUniqueUser = 'contact_scanUniqueUser',
  DocumentOpenAllCount = 'documentOpen_allCount',
  DocumentOpenAllUniqueUser = 'documentOpen_allUniqueUser',
  DocumentOpenTimestampMax = 'documentOpen_timestampMax',
  DocumentOpenTimestampMin = 'documentOpen_timestampMin',
  EventShowAllCount = 'eventShow_allCount',
  EventShowAllUniqueUser = 'eventShow_allUniqueUser',
  EventShowAndroidCount = 'eventShow_androidCount',
  EventShowAndroidUniqueUser = 'eventShow_androidUniqueUser',
  EventShowIosCount = 'eventShow_iosCount',
  EventShowIosUniqueUser = 'eventShow_iosUniqueUser',
  EventShowWebCount = 'eventShow_webCount',
  EventShowWebTeamCount = 'eventShow_webTeamCount',
  EventShowWebTeamUniqueUser = 'eventShow_webTeamUniqueUser',
  EventShowWebUniqueUser = 'eventShow_webUniqueUser',
  EventShowWebUserCount = 'eventShow_webUserCount',
  EventShowWebUserUniqueUser = 'eventShow_webUserUniqueUser',
  EventViewShowAllCount = 'eventViewShow_allCount',
  EventViewShowAllUniqueUser = 'eventViewShow_allUniqueUser',
  EventViewShowAndroidCount = 'eventViewShow_androidCount',
  EventViewShowAndroidUniqueUser = 'eventViewShow_androidUniqueUser',
  EventViewShowIosCount = 'eventViewShow_iosCount',
  EventViewShowIosUniqueUser = 'eventViewShow_iosUniqueUser',
  EventViewShowWebCount = 'eventViewShow_webCount',
  EventViewShowWebTeamCount = 'eventViewShow_webTeamCount',
  EventViewShowWebTeamUniqueUser = 'eventViewShow_webTeamUniqueUser',
  EventViewShowWebUniqueUser = 'eventViewShow_webUniqueUser',
  EventViewShowWebUserCount = 'eventViewShow_webUserCount',
  EventViewShowWebUserUniqueUser = 'eventViewShow_webUserUniqueUser',
  ExhibitorAdvertisementOpenReceiveAllCount = 'exhibitorAdvertisementOpenReceive_allCount',
  ExhibitorAdvertisementOpenReceiveAllUniqueUser = 'exhibitorAdvertisementOpenReceive_allUniqueUser',
  ExhibitorAdvertisementOpenReceiveAndroidCount = 'exhibitorAdvertisementOpenReceive_androidCount',
  ExhibitorAdvertisementOpenReceiveAndroidUniqueUser = 'exhibitorAdvertisementOpenReceive_androidUniqueUser',
  ExhibitorAdvertisementOpenReceiveIosCount = 'exhibitorAdvertisementOpenReceive_iosCount',
  ExhibitorAdvertisementOpenReceiveIosUniqueUser = 'exhibitorAdvertisementOpenReceive_iosUniqueUser',
  ExhibitorAdvertisementOpenReceiveTimestampMax = 'exhibitorAdvertisementOpenReceive_timestampMax',
  ExhibitorAdvertisementOpenReceiveTimestampMin = 'exhibitorAdvertisementOpenReceive_timestampMin',
  ExhibitorAdvertisementOpenReceiveWebCount = 'exhibitorAdvertisementOpenReceive_webCount',
  ExhibitorAdvertisementOpenReceiveWebTeamCount = 'exhibitorAdvertisementOpenReceive_webTeamCount',
  ExhibitorAdvertisementOpenReceiveWebTeamUniqueUser = 'exhibitorAdvertisementOpenReceive_webTeamUniqueUser',
  ExhibitorAdvertisementOpenReceiveWebUniqueUser = 'exhibitorAdvertisementOpenReceive_webUniqueUser',
  ExhibitorAdvertisementOpenReceiveWebUserCount = 'exhibitorAdvertisementOpenReceive_webUserCount',
  ExhibitorAdvertisementOpenReceiveWebUserUniqueUser = 'exhibitorAdvertisementOpenReceive_webUserUniqueUser',
  ExhibitorAdvertisementOpenAllCount = 'exhibitorAdvertisementOpen_allCount',
  ExhibitorAdvertisementOpenAllUniqueUser = 'exhibitorAdvertisementOpen_allUniqueUser',
  ExhibitorAdvertisementOpenAndroidCount = 'exhibitorAdvertisementOpen_androidCount',
  ExhibitorAdvertisementOpenAndroidUniqueUser = 'exhibitorAdvertisementOpen_androidUniqueUser',
  ExhibitorAdvertisementOpenIosCount = 'exhibitorAdvertisementOpen_iosCount',
  ExhibitorAdvertisementOpenIosUniqueUser = 'exhibitorAdvertisementOpen_iosUniqueUser',
  ExhibitorAdvertisementOpenTimestampMax = 'exhibitorAdvertisementOpen_timestampMax',
  ExhibitorAdvertisementOpenTimestampMin = 'exhibitorAdvertisementOpen_timestampMin',
  ExhibitorAdvertisementOpenWebCount = 'exhibitorAdvertisementOpen_webCount',
  ExhibitorAdvertisementOpenWebTeamCount = 'exhibitorAdvertisementOpen_webTeamCount',
  ExhibitorAdvertisementOpenWebTeamUniqueUser = 'exhibitorAdvertisementOpen_webTeamUniqueUser',
  ExhibitorAdvertisementOpenWebUniqueUser = 'exhibitorAdvertisementOpen_webUniqueUser',
  ExhibitorAdvertisementOpenWebUserCount = 'exhibitorAdvertisementOpen_webUserCount',
  ExhibitorAdvertisementOpenWebUserUniqueUser = 'exhibitorAdvertisementOpen_webUserUniqueUser',
  ExhibitorAdvertisementShowReceiveAllCount = 'exhibitorAdvertisementShowReceive_allCount',
  ExhibitorAdvertisementShowReceiveAllUniqueUser = 'exhibitorAdvertisementShowReceive_allUniqueUser',
  ExhibitorAdvertisementShowReceiveAndroidCount = 'exhibitorAdvertisementShowReceive_androidCount',
  ExhibitorAdvertisementShowReceiveAndroidUniqueUser = 'exhibitorAdvertisementShowReceive_androidUniqueUser',
  ExhibitorAdvertisementShowReceiveIosCount = 'exhibitorAdvertisementShowReceive_iosCount',
  ExhibitorAdvertisementShowReceiveIosUniqueUser = 'exhibitorAdvertisementShowReceive_iosUniqueUser',
  ExhibitorAdvertisementShowReceiveTimestampMax = 'exhibitorAdvertisementShowReceive_timestampMax',
  ExhibitorAdvertisementShowReceiveTimestampMin = 'exhibitorAdvertisementShowReceive_timestampMin',
  ExhibitorAdvertisementShowReceiveWebCount = 'exhibitorAdvertisementShowReceive_webCount',
  ExhibitorAdvertisementShowReceiveWebTeamCount = 'exhibitorAdvertisementShowReceive_webTeamCount',
  ExhibitorAdvertisementShowReceiveWebTeamUniqueUser = 'exhibitorAdvertisementShowReceive_webTeamUniqueUser',
  ExhibitorAdvertisementShowReceiveWebUniqueUser = 'exhibitorAdvertisementShowReceive_webUniqueUser',
  ExhibitorAdvertisementShowReceiveWebUserCount = 'exhibitorAdvertisementShowReceive_webUserCount',
  ExhibitorAdvertisementShowReceiveWebUserUniqueUser = 'exhibitorAdvertisementShowReceive_webUserUniqueUser',
  ExhibitorAdvertisementShowAllCount = 'exhibitorAdvertisementShow_allCount',
  ExhibitorAdvertisementShowAllUniqueUser = 'exhibitorAdvertisementShow_allUniqueUser',
  ExhibitorAdvertisementShowAndroidCount = 'exhibitorAdvertisementShow_androidCount',
  ExhibitorAdvertisementShowAndroidUniqueUser = 'exhibitorAdvertisementShow_androidUniqueUser',
  ExhibitorAdvertisementShowIosCount = 'exhibitorAdvertisementShow_iosCount',
  ExhibitorAdvertisementShowIosUniqueUser = 'exhibitorAdvertisementShow_iosUniqueUser',
  ExhibitorAdvertisementShowTimestampMax = 'exhibitorAdvertisementShow_timestampMax',
  ExhibitorAdvertisementShowTimestampMin = 'exhibitorAdvertisementShow_timestampMin',
  ExhibitorAdvertisementShowWebCount = 'exhibitorAdvertisementShow_webCount',
  ExhibitorAdvertisementShowWebTeamCount = 'exhibitorAdvertisementShow_webTeamCount',
  ExhibitorAdvertisementShowWebTeamUniqueUser = 'exhibitorAdvertisementShow_webTeamUniqueUser',
  ExhibitorAdvertisementShowWebUniqueUser = 'exhibitorAdvertisementShow_webUniqueUser',
  ExhibitorAdvertisementShowWebUserCount = 'exhibitorAdvertisementShow_webUserCount',
  ExhibitorAdvertisementShowWebUserUniqueUser = 'exhibitorAdvertisementShow_webUserUniqueUser',
  ExhibitorBookmarkReceiveAllCount = 'exhibitorBookmarkReceive_allCount',
  ExhibitorBookmarkReceiveAllUniqueUser = 'exhibitorBookmarkReceive_allUniqueUser',
  ExhibitorBookmarkReceiveTimestampMax = 'exhibitorBookmarkReceive_timestampMax',
  ExhibitorBookmarkReceiveTimestampMin = 'exhibitorBookmarkReceive_timestampMin',
  ExhibitorBookmarkAllCount = 'exhibitorBookmark_allCount',
  ExhibitorBookmarkAllUniqueUser = 'exhibitorBookmark_allUniqueUser',
  ExhibitorBookmarkTimestampMax = 'exhibitorBookmark_timestampMax',
  ExhibitorBookmarkTimestampMin = 'exhibitorBookmark_timestampMin',
  ExhibitorPopularityAllCount = 'exhibitorPopularity_allCount',
  ExhibitorPopularityAllUniqueUser = 'exhibitorPopularity_allUniqueUser',
  ExhibitorPopularityAndroidCount = 'exhibitorPopularity_androidCount',
  ExhibitorPopularityAndroidUniqueUser = 'exhibitorPopularity_androidUniqueUser',
  ExhibitorPopularityIosCount = 'exhibitorPopularity_iosCount',
  ExhibitorPopularityIosUniqueUser = 'exhibitorPopularity_iosUniqueUser',
  ExhibitorPopularityTimestampMax = 'exhibitorPopularity_timestampMax',
  ExhibitorPopularityTimestampMin = 'exhibitorPopularity_timestampMin',
  ExhibitorPopularityWebCount = 'exhibitorPopularity_webCount',
  ExhibitorPopularityWebTeamCount = 'exhibitorPopularity_webTeamCount',
  ExhibitorPopularityWebTeamUniqueUser = 'exhibitorPopularity_webTeamUniqueUser',
  ExhibitorPopularityWebUniqueUser = 'exhibitorPopularity_webUniqueUser',
  ExhibitorPopularityWebUserCount = 'exhibitorPopularity_webUserCount',
  ExhibitorPopularityWebUserUniqueUser = 'exhibitorPopularity_webUserUniqueUser',
  ExhibitorSelfShowAllCount = 'exhibitorSelfShow_allCount',
  ExhibitorSelfShowAllUniqueUser = 'exhibitorSelfShow_allUniqueUser',
  ExhibitorSelfShowAndroidCount = 'exhibitorSelfShow_androidCount',
  ExhibitorSelfShowAndroidUniqueUser = 'exhibitorSelfShow_androidUniqueUser',
  ExhibitorSelfShowIosCount = 'exhibitorSelfShow_iosCount',
  ExhibitorSelfShowIosUniqueUser = 'exhibitorSelfShow_iosUniqueUser',
  ExhibitorSelfShowWebCount = 'exhibitorSelfShow_webCount',
  ExhibitorSelfShowWebTeamCount = 'exhibitorSelfShow_webTeamCount',
  ExhibitorSelfShowWebTeamUniqueUser = 'exhibitorSelfShow_webTeamUniqueUser',
  ExhibitorSelfShowWebUniqueUser = 'exhibitorSelfShow_webUniqueUser',
  ExhibitorSelfShowWebUserCount = 'exhibitorSelfShow_webUserCount',
  ExhibitorSelfShowWebUserUniqueUser = 'exhibitorSelfShow_webUserUniqueUser',
  ExhibitorShowReceiveAllCount = 'exhibitorShowReceive_allCount',
  ExhibitorShowReceiveAllUniqueUser = 'exhibitorShowReceive_allUniqueUser',
  ExhibitorShowReceiveAndroidCount = 'exhibitorShowReceive_androidCount',
  ExhibitorShowReceiveAndroidUniqueUser = 'exhibitorShowReceive_androidUniqueUser',
  ExhibitorShowReceiveIosCount = 'exhibitorShowReceive_iosCount',
  ExhibitorShowReceiveIosUniqueUser = 'exhibitorShowReceive_iosUniqueUser',
  ExhibitorShowReceiveTimestampMax = 'exhibitorShowReceive_timestampMax',
  ExhibitorShowReceiveTimestampMin = 'exhibitorShowReceive_timestampMin',
  ExhibitorShowReceiveWebCount = 'exhibitorShowReceive_webCount',
  ExhibitorShowReceiveWebTeamCount = 'exhibitorShowReceive_webTeamCount',
  ExhibitorShowReceiveWebTeamUniqueUser = 'exhibitorShowReceive_webTeamUniqueUser',
  ExhibitorShowReceiveWebUniqueUser = 'exhibitorShowReceive_webUniqueUser',
  ExhibitorShowReceiveWebUserCount = 'exhibitorShowReceive_webUserCount',
  ExhibitorShowReceiveWebUserUniqueUser = 'exhibitorShowReceive_webUserUniqueUser',
  ExhibitorShowAllCount = 'exhibitorShow_allCount',
  ExhibitorShowAllUniqueUser = 'exhibitorShow_allUniqueUser',
  ExhibitorShowAndroidCount = 'exhibitorShow_androidCount',
  ExhibitorShowAndroidUniqueUser = 'exhibitorShow_androidUniqueUser',
  ExhibitorShowIosCount = 'exhibitorShow_iosCount',
  ExhibitorShowIosUniqueUser = 'exhibitorShow_iosUniqueUser',
  ExhibitorShowTimestampMax = 'exhibitorShow_timestampMax',
  ExhibitorShowTimestampMin = 'exhibitorShow_timestampMin',
  ExhibitorShowWebCount = 'exhibitorShow_webCount',
  ExhibitorShowWebTeamCount = 'exhibitorShow_webTeamCount',
  ExhibitorShowWebTeamUniqueUser = 'exhibitorShow_webTeamUniqueUser',
  ExhibitorShowWebUniqueUser = 'exhibitorShow_webUniqueUser',
  ExhibitorShowWebUserCount = 'exhibitorShow_webUserCount',
  ExhibitorShowWebUserUniqueUser = 'exhibitorShow_webUserUniqueUser',
  InterstitialAddShowAllCount = 'interstitialAddShow_allCount',
  InterstitialAddShowAllUniqueUser = 'interstitialAddShow_allUniqueUser',
  InterstitialAddShowAndroidCount = 'interstitialAddShow_androidCount',
  InterstitialAddShowAndroidUniqueUser = 'interstitialAddShow_androidUniqueUser',
  InterstitialAddShowDurationAndroidAverage = 'interstitialAddShow_durationAndroidAverage',
  InterstitialAddShowDurationAndroidSum = 'interstitialAddShow_durationAndroidSum',
  InterstitialAddShowDurationAverage = 'interstitialAddShow_durationAverage',
  InterstitialAddShowDurationIosAverage = 'interstitialAddShow_durationIosAverage',
  InterstitialAddShowDurationIosSum = 'interstitialAddShow_durationIosSum',
  InterstitialAddShowDurationSum = 'interstitialAddShow_durationSum',
  InterstitialAddShowDurationWebAverage = 'interstitialAddShow_durationWebAverage',
  InterstitialAddShowDurationWebSum = 'interstitialAddShow_durationWebSum',
  InterstitialAddShowDurationWebTeamAverage = 'interstitialAddShow_durationWebTeamAverage',
  InterstitialAddShowDurationWebTeamSum = 'interstitialAddShow_durationWebTeamSum',
  InterstitialAddShowDurationWebUserAverage = 'interstitialAddShow_durationWebUserAverage',
  InterstitialAddShowDurationWebUserSum = 'interstitialAddShow_durationWebUserSum',
  InterstitialAddShowIosCount = 'interstitialAddShow_iosCount',
  InterstitialAddShowIosUniqueUser = 'interstitialAddShow_iosUniqueUser',
  InterstitialAddShowWebCount = 'interstitialAddShow_webCount',
  InterstitialAddShowWebTeamCount = 'interstitialAddShow_webTeamCount',
  InterstitialAddShowWebTeamUniqueUser = 'interstitialAddShow_webTeamUniqueUser',
  InterstitialAddShowWebUniqueUser = 'interstitialAddShow_webUniqueUser',
  InterstitialAddShowWebUserCount = 'interstitialAddShow_webUserCount',
  InterstitialAddShowWebUserUniqueUser = 'interstitialAddShow_webUserUniqueUser',
  MeetingParticipantAllCount = 'meetingParticipant_allCount',
  MeetingParticipantAllUnique = 'meetingParticipant_allUnique',
  MeetingParticipantAllUniqueUser = 'meetingParticipant_allUniqueUser',
  MeetingParticipantCanceledCount = 'meetingParticipant_canceledCount',
  MeetingParticipantCanceledUnique = 'meetingParticipant_canceledUnique',
  MeetingParticipantCanceledUniqueUser = 'meetingParticipant_canceledUniqueUser',
  MeetingParticipantConfirmedCount = 'meetingParticipant_confirmedCount',
  MeetingParticipantConfirmedUnique = 'meetingParticipant_confirmedUnique',
  MeetingParticipantConfirmedUniqueUser = 'meetingParticipant_confirmedUniqueUser',
  MeetingParticipantDeclinedCount = 'meetingParticipant_declinedCount',
  MeetingParticipantDeclinedUnique = 'meetingParticipant_declinedUnique',
  MeetingParticipantDeclinedUniqueUser = 'meetingParticipant_declinedUniqueUser',
  MeetingParticipantExpiredCount = 'meetingParticipant_expiredCount',
  MeetingParticipantExpiredUnique = 'meetingParticipant_expiredUnique',
  MeetingParticipantExpiredUniqueUser = 'meetingParticipant_expiredUniqueUser',
  MeetingParticipantNoShowCount = 'meetingParticipant_noShowCount',
  MeetingParticipantNoShowUnique = 'meetingParticipant_noShowUnique',
  MeetingParticipantNoShowUniqueUser = 'meetingParticipant_noShowUniqueUser',
  MeetingParticipantPendingCount = 'meetingParticipant_pendingCount',
  MeetingParticipantPendingUnique = 'meetingParticipant_pendingUnique',
  MeetingParticipantPendingUniqueUser = 'meetingParticipant_pendingUniqueUser',
  MeetingRequestReceiveAcceptedCount = 'meetingRequestReceive_acceptedCount',
  MeetingRequestReceiveAcceptedUniqueUser = 'meetingRequestReceive_acceptedUniqueUser',
  MeetingRequestReceiveAcceptedWithUniqueUser = 'meetingRequestReceive_acceptedWithUniqueUser',
  MeetingRequestReceiveAllCount = 'meetingRequestReceive_allCount',
  MeetingRequestReceiveAllUniqueUser = 'meetingRequestReceive_allUniqueUser',
  MeetingRequestReceiveAllWithUniqueUser = 'meetingRequestReceive_allWithUniqueUser',
  MeetingRequestReceiveCancelledCount = 'meetingRequestReceive_cancelledCount',
  MeetingRequestReceiveCancelledUniqueUser = 'meetingRequestReceive_cancelledUniqueUser',
  MeetingRequestReceiveCancelledWithUniqueUser = 'meetingRequestReceive_cancelledWithUniqueUser',
  MeetingRequestReceiveDeclinedCount = 'meetingRequestReceive_declinedCount',
  MeetingRequestReceiveDeclinedUniqueUser = 'meetingRequestReceive_declinedUniqueUser',
  MeetingRequestReceiveDeclinedWithUniqueUser = 'meetingRequestReceive_declinedWithUniqueUser',
  MeetingRequestReceiveExpiredCount = 'meetingRequestReceive_expiredCount',
  MeetingRequestReceiveExpiredUniqueUser = 'meetingRequestReceive_expiredUniqueUser',
  MeetingRequestReceiveExpiredWithUniqueUser = 'meetingRequestReceive_expiredWithUniqueUser',
  MeetingRequestReceivePendingCount = 'meetingRequestReceive_pendingCount',
  MeetingRequestReceivePendingUniqueUser = 'meetingRequestReceive_pendingUniqueUser',
  MeetingRequestReceivePendingWithUniqueUser = 'meetingRequestReceive_pendingWithUniqueUser',
  MeetingRequestAcceptedCount = 'meetingRequest_acceptedCount',
  MeetingRequestAcceptedUniqueUser = 'meetingRequest_acceptedUniqueUser',
  MeetingRequestAcceptedWithUniqueUser = 'meetingRequest_acceptedWithUniqueUser',
  MeetingRequestAllCount = 'meetingRequest_allCount',
  MeetingRequestAllUniqueUser = 'meetingRequest_allUniqueUser',
  MeetingRequestAllWithUniqueUser = 'meetingRequest_allWithUniqueUser',
  MeetingRequestCancelledCount = 'meetingRequest_cancelledCount',
  MeetingRequestCancelledUniqueUser = 'meetingRequest_cancelledUniqueUser',
  MeetingRequestCancelledWithUniqueUser = 'meetingRequest_cancelledWithUniqueUser',
  MeetingRequestDeclinedCount = 'meetingRequest_declinedCount',
  MeetingRequestDeclinedUniqueUser = 'meetingRequest_declinedUniqueUser',
  MeetingRequestDeclinedWithUniqueUser = 'meetingRequest_declinedWithUniqueUser',
  MeetingRequestExpiredCount = 'meetingRequest_expiredCount',
  MeetingRequestExpiredUniqueUser = 'meetingRequest_expiredUniqueUser',
  MeetingRequestExpiredWithUniqueUser = 'meetingRequest_expiredWithUniqueUser',
  MeetingRequestPendingCount = 'meetingRequest_pendingCount',
  MeetingRequestPendingUniqueUser = 'meetingRequest_pendingUniqueUser',
  MeetingRequestPendingWithUniqueUser = 'meetingRequest_pendingWithUniqueUser',
  MeetingAllCount = 'meeting_allCount',
  MeetingAllUnique = 'meeting_allUnique',
  MeetingAllUniqueUser = 'meeting_allUniqueUser',
  MeetingCanceledCount = 'meeting_canceledCount',
  MeetingCanceledUnique = 'meeting_canceledUnique',
  MeetingCanceledUniqueUser = 'meeting_canceledUniqueUser',
  MeetingConfirmedCount = 'meeting_confirmedCount',
  MeetingConfirmedUnique = 'meeting_confirmedUnique',
  MeetingConfirmedUniqueUser = 'meeting_confirmedUniqueUser',
  MeetingDeclinedCount = 'meeting_declinedCount',
  MeetingDeclinedUnique = 'meeting_declinedUnique',
  MeetingDeclinedUniqueUser = 'meeting_declinedUniqueUser',
  MeetingExpiredCount = 'meeting_expiredCount',
  MeetingExpiredUnique = 'meeting_expiredUnique',
  MeetingExpiredUniqueUser = 'meeting_expiredUniqueUser',
  MeetingNoShowCount = 'meeting_noShowCount',
  MeetingNoShowUnique = 'meeting_noShowUnique',
  MeetingNoShowUniqueUser = 'meeting_noShowUniqueUser',
  MeetingPendingCount = 'meeting_pendingCount',
  MeetingPendingUnique = 'meeting_pendingUnique',
  MeetingPendingUniqueUser = 'meeting_pendingUniqueUser',
  MeetingRescheduledCount = 'meeting_rescheduledCount',
  MeetingRescheduledUnique = 'meeting_rescheduledUnique',
  MeetingRescheduledUniqueUser = 'meeting_rescheduledUniqueUser',
  MessageReceiveAllCount = 'messageReceive_allCount',
  MessageReceiveAllUniqueUser = 'messageReceive_allUniqueUser',
  MessageReceiveChannelUnique = 'messageReceive_channelUnique',
  MessageReceivePrivateCount = 'messageReceive_privateCount',
  MessageReceivePrivateUniqueUser = 'messageReceive_privateUniqueUser',
  MessageReceivePrivateWithUniqueUser = 'messageReceive_privateWithUniqueUser',
  MessageReceivePublicCount = 'messageReceive_publicCount',
  MessageReceivePublicUniqueUser = 'messageReceive_publicUniqueUser',
  MessageAllCount = 'message_allCount',
  MessageAllUniqueUser = 'message_allUniqueUser',
  MessageChannelUnique = 'message_channelUnique',
  MessagePrivateCount = 'message_privateCount',
  MessagePrivateUniqueUser = 'message_privateUniqueUser',
  MessagePrivateWithUniqueUser = 'message_privateWithUniqueUser',
  MessagePublicCount = 'message_publicCount',
  MessagePublicUniqueUser = 'message_publicUniqueUser',
  NetworkActivityAllCount = 'networkActivity_allCount',
  NetworkActivityAllUnique = 'networkActivity_allUnique',
  NetworkActivityAllUniqueUser = 'networkActivity_allUniqueUser',
  NetworkActivityAllWithUniqueUser = 'networkActivity_allWithUniqueUser',
  PersonShowReceiveAllCount = 'personShowReceive_allCount',
  PersonShowReceiveAllUniqueUser = 'personShowReceive_allUniqueUser',
  PersonShowReceiveAllWithUniqueUser = 'personShowReceive_allWithUniqueUser',
  PersonShowReceiveAndroidCount = 'personShowReceive_androidCount',
  PersonShowReceiveAndroidUniqueUser = 'personShowReceive_androidUniqueUser',
  PersonShowReceiveAndroidWithUniqueUser = 'personShowReceive_androidWithUniqueUser',
  PersonShowReceiveIosCount = 'personShowReceive_iosCount',
  PersonShowReceiveIosUniqueUser = 'personShowReceive_iosUniqueUser',
  PersonShowReceiveIosWithUniqueUser = 'personShowReceive_iosWithUniqueUser',
  PersonShowReceiveWebCount = 'personShowReceive_webCount',
  PersonShowReceiveWebTeamCount = 'personShowReceive_webTeamCount',
  PersonShowReceiveWebTeamUniqueUser = 'personShowReceive_webTeamUniqueUser',
  PersonShowReceiveWebTeamWithUniqueUser = 'personShowReceive_webTeamWithUniqueUser',
  PersonShowReceiveWebUniqueUser = 'personShowReceive_webUniqueUser',
  PersonShowReceiveWebUserCount = 'personShowReceive_webUserCount',
  PersonShowReceiveWebUserUniqueUser = 'personShowReceive_webUserUniqueUser',
  PersonShowReceiveWebUserWithUniqueUser = 'personShowReceive_webUserWithUniqueUser',
  PersonShowReceiveWebWithUniqueUser = 'personShowReceive_webWithUniqueUser',
  PersonShowAllCount = 'personShow_allCount',
  PersonShowAllUniqueUser = 'personShow_allUniqueUser',
  PersonShowAllWithUniqueUser = 'personShow_allWithUniqueUser',
  PersonShowAndroidCount = 'personShow_androidCount',
  PersonShowAndroidUniqueUser = 'personShow_androidUniqueUser',
  PersonShowAndroidWithUniqueUser = 'personShow_androidWithUniqueUser',
  PersonShowIosCount = 'personShow_iosCount',
  PersonShowIosUniqueUser = 'personShow_iosUniqueUser',
  PersonShowIosWithUniqueUser = 'personShow_iosWithUniqueUser',
  PersonShowWebCount = 'personShow_webCount',
  PersonShowWebTeamCount = 'personShow_webTeamCount',
  PersonShowWebTeamUniqueUser = 'personShow_webTeamUniqueUser',
  PersonShowWebTeamWithUniqueUser = 'personShow_webTeamWithUniqueUser',
  PersonShowWebUniqueUser = 'personShow_webUniqueUser',
  PersonShowWebUserCount = 'personShow_webUserCount',
  PersonShowWebUserUniqueUser = 'personShow_webUserUniqueUser',
  PersonShowWebUserWithUniqueUser = 'personShow_webUserWithUniqueUser',
  PersonShowWebWithUniqueUser = 'personShow_webWithUniqueUser',
  PlanningBookmarkAllCount = 'planningBookmark_allCount',
  PlanningBookmarkAllUniqueUser = 'planningBookmark_allUniqueUser',
  PlanningPopularityAllCount = 'planningPopularity_allCount',
  PlanningPopularityAllUniqueUser = 'planningPopularity_allUniqueUser',
  PlanningPopularityAndroidCount = 'planningPopularity_androidCount',
  PlanningPopularityAndroidUniqueUser = 'planningPopularity_androidUniqueUser',
  PlanningPopularityIosCount = 'planningPopularity_iosCount',
  PlanningPopularityIosUniqueUser = 'planningPopularity_iosUniqueUser',
  PlanningPopularityTimestampMax = 'planningPopularity_timestampMax',
  PlanningPopularityTimestampMin = 'planningPopularity_timestampMin',
  PlanningPopularityWebCount = 'planningPopularity_webCount',
  PlanningPopularityWebTeamCount = 'planningPopularity_webTeamCount',
  PlanningPopularityWebTeamUniqueUser = 'planningPopularity_webTeamUniqueUser',
  PlanningPopularityWebUniqueUser = 'planningPopularity_webUniqueUser',
  PlanningPopularityWebUserCount = 'planningPopularity_webUserCount',
  PlanningPopularityWebUserUniqueUser = 'planningPopularity_webUserUniqueUser',
  PlanningStreamStartAllCount = 'planningStreamStart_allCount',
  PlanningStreamStartAllUniqueUser = 'planningStreamStart_allUniqueUser',
  PlanningStreamStartAndroidCount = 'planningStreamStart_androidCount',
  PlanningStreamStartAndroidUniqueUser = 'planningStreamStart_androidUniqueUser',
  PlanningStreamStartIosCount = 'planningStreamStart_iosCount',
  PlanningStreamStartIosUniqueUser = 'planningStreamStart_iosUniqueUser',
  PlanningStreamStartTimestampMax = 'planningStreamStart_timestampMax',
  PlanningStreamStartTimestampMin = 'planningStreamStart_timestampMin',
  PlanningStreamStartWebCount = 'planningStreamStart_webCount',
  PlanningStreamStartWebTeamCount = 'planningStreamStart_webTeamCount',
  PlanningStreamStartWebTeamUniqueUser = 'planningStreamStart_webTeamUniqueUser',
  PlanningStreamStartWebUniqueUser = 'planningStreamStart_webUniqueUser',
  PlanningStreamStartWebUserCount = 'planningStreamStart_webUserCount',
  PlanningStreamStartWebUserUniqueUser = 'planningStreamStart_webUserUniqueUser',
  PlanningStreamStopAllCount = 'planningStreamStop_allCount',
  PlanningStreamStopAllUniqueUser = 'planningStreamStop_allUniqueUser',
  PlanningStreamStopAndroidCount = 'planningStreamStop_androidCount',
  PlanningStreamStopAndroidUniqueUser = 'planningStreamStop_androidUniqueUser',
  PlanningStreamStopDurationAndroidAverage = 'planningStreamStop_durationAndroidAverage',
  PlanningStreamStopDurationAndroidSum = 'planningStreamStop_durationAndroidSum',
  PlanningStreamStopDurationAverage = 'planningStreamStop_durationAverage',
  PlanningStreamStopDurationIosAverage = 'planningStreamStop_durationIosAverage',
  PlanningStreamStopDurationIosSum = 'planningStreamStop_durationIosSum',
  PlanningStreamStopDurationSum = 'planningStreamStop_durationSum',
  PlanningStreamStopDurationWebAverage = 'planningStreamStop_durationWebAverage',
  PlanningStreamStopDurationWebSum = 'planningStreamStop_durationWebSum',
  PlanningStreamStopDurationWebTeamAverage = 'planningStreamStop_durationWebTeamAverage',
  PlanningStreamStopDurationWebTeamSum = 'planningStreamStop_durationWebTeamSum',
  PlanningStreamStopDurationWebUserAverage = 'planningStreamStop_durationWebUserAverage',
  PlanningStreamStopDurationWebUserSum = 'planningStreamStop_durationWebUserSum',
  PlanningStreamStopIosCount = 'planningStreamStop_iosCount',
  PlanningStreamStopIosUniqueUser = 'planningStreamStop_iosUniqueUser',
  PlanningStreamStopTimestampMax = 'planningStreamStop_timestampMax',
  PlanningStreamStopTimestampMin = 'planningStreamStop_timestampMin',
  PlanningStreamStopWebCount = 'planningStreamStop_webCount',
  PlanningStreamStopWebTeamCount = 'planningStreamStop_webTeamCount',
  PlanningStreamStopWebTeamUniqueUser = 'planningStreamStop_webTeamUniqueUser',
  PlanningStreamStopWebUniqueUser = 'planningStreamStop_webUniqueUser',
  PlanningStreamStopWebUserCount = 'planningStreamStop_webUserCount',
  PlanningStreamStopWebUserUniqueUser = 'planningStreamStop_webUserUniqueUser',
  PlanningStreamAllCount = 'planningStream_allCount',
  PlanningStreamAllUniqueUser = 'planningStream_allUniqueUser',
  PlanningStreamAndroidCount = 'planningStream_androidCount',
  PlanningStreamAndroidUniqueUser = 'planningStream_androidUniqueUser',
  PlanningStreamIosCount = 'planningStream_iosCount',
  PlanningStreamIosUniqueUser = 'planningStream_iosUniqueUser',
  PlanningStreamTimestampMax = 'planningStream_timestampMax',
  PlanningStreamTimestampMin = 'planningStream_timestampMin',
  PlanningStreamWebCount = 'planningStream_webCount',
  PlanningStreamWebTeamCount = 'planningStream_webTeamCount',
  PlanningStreamWebTeamUniqueUser = 'planningStream_webTeamUniqueUser',
  PlanningStreamWebUniqueUser = 'planningStream_webUniqueUser',
  PlanningStreamWebUserCount = 'planningStream_webUserCount',
  PlanningStreamWebUserUniqueUser = 'planningStream_webUserUniqueUser',
  PostLinkOpenAllCount = 'postLinkOpen_allCount',
  PostLinkOpenAllUniqueUser = 'postLinkOpen_allUniqueUser',
  PostLinkOpenAndroidCount = 'postLinkOpen_androidCount',
  PostLinkOpenAndroidUniqueUser = 'postLinkOpen_androidUniqueUser',
  PostLinkOpenIosCount = 'postLinkOpen_iosCount',
  PostLinkOpenIosUniqueUser = 'postLinkOpen_iosUniqueUser',
  PostLinkOpenWebCount = 'postLinkOpen_webCount',
  PostLinkOpenWebTeamCount = 'postLinkOpen_webTeamCount',
  PostLinkOpenWebTeamUniqueUser = 'postLinkOpen_webTeamUniqueUser',
  PostLinkOpenWebUniqueUser = 'postLinkOpen_webUniqueUser',
  PostLinkOpenWebUserCount = 'postLinkOpen_webUserCount',
  PostLinkOpenWebUserUniqueUser = 'postLinkOpen_webUserUniqueUser',
  ProductBookmarkAllCount = 'productBookmark_allCount',
  ProductBookmarkAllUniqueUser = 'productBookmark_allUniqueUser',
  ProductBookmarkTimestampMax = 'productBookmark_timestampMax',
  ProductBookmarkTimestampMin = 'productBookmark_timestampMin',
  ProductShowAllCount = 'productShow_allCount',
  ProductShowAllUniqueUser = 'productShow_allUniqueUser',
  ProductShowAndroidCount = 'productShow_androidCount',
  ProductShowAndroidUniqueUser = 'productShow_androidUniqueUser',
  ProductShowIosCount = 'productShow_iosCount',
  ProductShowIosUniqueUser = 'productShow_iosUniqueUser',
  ProductShowTimestampMax = 'productShow_timestampMax',
  ProductShowTimestampMin = 'productShow_timestampMin',
  ProductShowWebCount = 'productShow_webCount',
  ProductShowWebTeamCount = 'productShow_webTeamCount',
  ProductShowWebTeamUniqueUser = 'productShow_webTeamUniqueUser',
  ProductShowWebUniqueUser = 'productShow_webUniqueUser',
  ProductShowWebUserCount = 'productShow_webUserCount',
  ProductShowWebUserUniqueUser = 'productShow_webUserUniqueUser',
  RegistrationAbandonedCount = 'registration_abandonedCount',
  RegistrationAllCount = 'registration_allCount',
  RegistrationCanceledCount = 'registration_canceledCount',
  RegistrationCheckedInCount = 'registration_checkedInCount',
  RegistrationRegisteredCount = 'registration_registeredCount',
  SponsorShowAllCount = 'sponsorShow_allCount',
  SponsorShowAllUniqueUser = 'sponsorShow_allUniqueUser',
  SponsorShowAndroidCount = 'sponsorShow_androidCount',
  SponsorShowAndroidUniqueUser = 'sponsorShow_androidUniqueUser',
  SponsorShowIosCount = 'sponsorShow_iosCount',
  SponsorShowIosUniqueUser = 'sponsorShow_iosUniqueUser',
  SponsorShowTimestampMax = 'sponsorShow_timestampMax',
  SponsorShowTimestampMin = 'sponsorShow_timestampMin',
  SponsorShowWebCount = 'sponsorShow_webCount',
  SponsorShowWebTeamCount = 'sponsorShow_webTeamCount',
  SponsorShowWebTeamUniqueUser = 'sponsorShow_webTeamUniqueUser',
  SponsorShowWebUniqueUser = 'sponsorShow_webUniqueUser',
  SponsorShowWebUserCount = 'sponsorShow_webUserCount',
  SponsorShowWebUserUniqueUser = 'sponsorShow_webUserUniqueUser',
  StreamStartAllCount = 'streamStart_allCount',
  StreamStartAllUniqueUser = 'streamStart_allUniqueUser',
  StreamStartAndroidCount = 'streamStart_androidCount',
  StreamStartAndroidUniqueUser = 'streamStart_androidUniqueUser',
  StreamStartIosCount = 'streamStart_iosCount',
  StreamStartIosUniqueUser = 'streamStart_iosUniqueUser',
  StreamStartTimestampMax = 'streamStart_timestampMax',
  StreamStartTimestampMin = 'streamStart_timestampMin',
  StreamStartWebCount = 'streamStart_webCount',
  StreamStartWebTeamCount = 'streamStart_webTeamCount',
  StreamStartWebTeamUniqueUser = 'streamStart_webTeamUniqueUser',
  StreamStartWebUniqueUser = 'streamStart_webUniqueUser',
  StreamStartWebUserCount = 'streamStart_webUserCount',
  StreamStartWebUserUniqueUser = 'streamStart_webUserUniqueUser',
  StreamStopAllCount = 'streamStop_allCount',
  StreamStopAllUniqueUser = 'streamStop_allUniqueUser',
  StreamStopAndroidCount = 'streamStop_androidCount',
  StreamStopAndroidUniqueUser = 'streamStop_androidUniqueUser',
  StreamStopDurationAndroidAverage = 'streamStop_durationAndroidAverage',
  StreamStopDurationAndroidSum = 'streamStop_durationAndroidSum',
  StreamStopDurationAverage = 'streamStop_durationAverage',
  StreamStopDurationIosAverage = 'streamStop_durationIosAverage',
  StreamStopDurationIosSum = 'streamStop_durationIosSum',
  StreamStopDurationSum = 'streamStop_durationSum',
  StreamStopDurationWebAverage = 'streamStop_durationWebAverage',
  StreamStopDurationWebSum = 'streamStop_durationWebSum',
  StreamStopDurationWebTeamAverage = 'streamStop_durationWebTeamAverage',
  StreamStopDurationWebTeamSum = 'streamStop_durationWebTeamSum',
  StreamStopDurationWebUserAverage = 'streamStop_durationWebUserAverage',
  StreamStopDurationWebUserSum = 'streamStop_durationWebUserSum',
  StreamStopIosCount = 'streamStop_iosCount',
  StreamStopIosUniqueUser = 'streamStop_iosUniqueUser',
  StreamStopTimestampMax = 'streamStop_timestampMax',
  StreamStopTimestampMin = 'streamStop_timestampMin',
  StreamStopWebCount = 'streamStop_webCount',
  StreamStopWebTeamCount = 'streamStop_webTeamCount',
  StreamStopWebTeamUniqueUser = 'streamStop_webTeamUniqueUser',
  StreamStopWebUniqueUser = 'streamStop_webUniqueUser',
  StreamStopWebUserCount = 'streamStop_webUserCount',
  StreamStopWebUserUniqueUser = 'streamStop_webUserUniqueUser',
  UsageAllUniqueUser = 'usage_allUniqueUser',
  UsageAndroidUniqueUser = 'usage_androidUniqueUser',
  UsageIosUniqueUser = 'usage_iosUniqueUser',
  UsageWebTeamUniqueUser = 'usage_webTeamUniqueUser',
  UsageWebUniqueUser = 'usage_webUniqueUser',
  UsageWebUserUniqueUser = 'usage_webUserUniqueUser',
  VideoCallRoomAllCount = 'videoCallRoom_allCount',
  VideoCallRoomAllUniqueUser = 'videoCallRoom_allUniqueUser',
  VideoCallRoomAllWithUniqueUser = 'videoCallRoom_allWithUniqueUser',
  VideoCallRoomSucceededCount = 'videoCallRoom_succeededCount',
  VideoCallRoomSucceededDurationAverage = 'videoCallRoom_succeededDurationAverage',
  VideoCallRoomSucceededDurationSum = 'videoCallRoom_succeededDurationSum',
  VideoCallRoomSucceededUniqueUser = 'videoCallRoom_succeededUniqueUser',
  VideoCallRoomSucceededWithUniqueUser = 'videoCallRoom_succeededWithUniqueUser'
}

export type Analytics_SortCommunityPlannings = {
  direction: Analytics_SortDirection;
  field: Analytics_SortCommunityPlanningsField;
  limit?: InputMaybe<Scalars['Int']>;
};

export enum Analytics_SortCommunityPlanningsField {
  PlanningBookmarkAllCount = 'planningBookmark_allCount',
  PlanningBookmarkAllUniqueUser = 'planningBookmark_allUniqueUser',
  PlanningPopularityAllCount = 'planningPopularity_allCount',
  PlanningPopularityAllUniqueUser = 'planningPopularity_allUniqueUser',
  PlanningPopularityAndroidCount = 'planningPopularity_androidCount',
  PlanningPopularityAndroidUniqueUser = 'planningPopularity_androidUniqueUser',
  PlanningPopularityIosCount = 'planningPopularity_iosCount',
  PlanningPopularityIosUniqueUser = 'planningPopularity_iosUniqueUser',
  PlanningPopularityTimestampMax = 'planningPopularity_timestampMax',
  PlanningPopularityTimestampMin = 'planningPopularity_timestampMin',
  PlanningPopularityWebCount = 'planningPopularity_webCount',
  PlanningPopularityWebTeamCount = 'planningPopularity_webTeamCount',
  PlanningPopularityWebTeamUniqueUser = 'planningPopularity_webTeamUniqueUser',
  PlanningPopularityWebUniqueUser = 'planningPopularity_webUniqueUser',
  PlanningPopularityWebUserCount = 'planningPopularity_webUserCount',
  PlanningPopularityWebUserUniqueUser = 'planningPopularity_webUserUniqueUser',
  PlanningStreamStartAllCount = 'planningStreamStart_allCount',
  PlanningStreamStartAllUniqueUser = 'planningStreamStart_allUniqueUser',
  PlanningStreamStartAndroidCount = 'planningStreamStart_androidCount',
  PlanningStreamStartAndroidUniqueUser = 'planningStreamStart_androidUniqueUser',
  PlanningStreamStartIosCount = 'planningStreamStart_iosCount',
  PlanningStreamStartIosUniqueUser = 'planningStreamStart_iosUniqueUser',
  PlanningStreamStartTimestampMax = 'planningStreamStart_timestampMax',
  PlanningStreamStartTimestampMin = 'planningStreamStart_timestampMin',
  PlanningStreamStartWebCount = 'planningStreamStart_webCount',
  PlanningStreamStartWebTeamCount = 'planningStreamStart_webTeamCount',
  PlanningStreamStartWebTeamUniqueUser = 'planningStreamStart_webTeamUniqueUser',
  PlanningStreamStartWebUniqueUser = 'planningStreamStart_webUniqueUser',
  PlanningStreamStartWebUserCount = 'planningStreamStart_webUserCount',
  PlanningStreamStartWebUserUniqueUser = 'planningStreamStart_webUserUniqueUser',
  PlanningStreamStopAllCount = 'planningStreamStop_allCount',
  PlanningStreamStopAllUniqueUser = 'planningStreamStop_allUniqueUser',
  PlanningStreamStopAndroidCount = 'planningStreamStop_androidCount',
  PlanningStreamStopAndroidUniqueUser = 'planningStreamStop_androidUniqueUser',
  PlanningStreamStopDurationAndroidAverage = 'planningStreamStop_durationAndroidAverage',
  PlanningStreamStopDurationAndroidSum = 'planningStreamStop_durationAndroidSum',
  PlanningStreamStopDurationAverage = 'planningStreamStop_durationAverage',
  PlanningStreamStopDurationIosAverage = 'planningStreamStop_durationIosAverage',
  PlanningStreamStopDurationIosSum = 'planningStreamStop_durationIosSum',
  PlanningStreamStopDurationSum = 'planningStreamStop_durationSum',
  PlanningStreamStopDurationWebAverage = 'planningStreamStop_durationWebAverage',
  PlanningStreamStopDurationWebSum = 'planningStreamStop_durationWebSum',
  PlanningStreamStopDurationWebTeamAverage = 'planningStreamStop_durationWebTeamAverage',
  PlanningStreamStopDurationWebTeamSum = 'planningStreamStop_durationWebTeamSum',
  PlanningStreamStopDurationWebUserAverage = 'planningStreamStop_durationWebUserAverage',
  PlanningStreamStopDurationWebUserSum = 'planningStreamStop_durationWebUserSum',
  PlanningStreamStopIosCount = 'planningStreamStop_iosCount',
  PlanningStreamStopIosUniqueUser = 'planningStreamStop_iosUniqueUser',
  PlanningStreamStopTimestampMax = 'planningStreamStop_timestampMax',
  PlanningStreamStopTimestampMin = 'planningStreamStop_timestampMin',
  PlanningStreamStopWebCount = 'planningStreamStop_webCount',
  PlanningStreamStopWebTeamCount = 'planningStreamStop_webTeamCount',
  PlanningStreamStopWebTeamUniqueUser = 'planningStreamStop_webTeamUniqueUser',
  PlanningStreamStopWebUniqueUser = 'planningStreamStop_webUniqueUser',
  PlanningStreamStopWebUserCount = 'planningStreamStop_webUserCount',
  PlanningStreamStopWebUserUniqueUser = 'planningStreamStop_webUserUniqueUser',
  PlanningStreamAllCount = 'planningStream_allCount',
  PlanningStreamAllUniqueUser = 'planningStream_allUniqueUser',
  PlanningStreamAndroidCount = 'planningStream_androidCount',
  PlanningStreamAndroidUniqueUser = 'planningStream_androidUniqueUser',
  PlanningStreamIosCount = 'planningStream_iosCount',
  PlanningStreamIosUniqueUser = 'planningStream_iosUniqueUser',
  PlanningStreamTimestampMax = 'planningStream_timestampMax',
  PlanningStreamTimestampMin = 'planningStream_timestampMin',
  PlanningStreamWebCount = 'planningStream_webCount',
  PlanningStreamWebTeamCount = 'planningStream_webTeamCount',
  PlanningStreamWebTeamUniqueUser = 'planningStream_webTeamUniqueUser',
  PlanningStreamWebUniqueUser = 'planningStream_webUniqueUser',
  PlanningStreamWebUserCount = 'planningStream_webUserCount',
  PlanningStreamWebUserUniqueUser = 'planningStream_webUserUniqueUser'
}

export type Analytics_SortCommunityUsers = {
  direction: Analytics_SortDirection;
  field: Analytics_SortCommunityUsersField;
  limit?: InputMaybe<Scalars['Int']>;
};

export enum Analytics_SortCommunityUsersField {
  ActivityTimestampMax = 'activity_timestampMax',
  ActivityTimestampMin = 'activity_timestampMin',
  AddOpenAllCount = 'addOpen_allCount',
  AddOpenAllUniqueUser = 'addOpen_allUniqueUser',
  AddOpenAndroidCount = 'addOpen_androidCount',
  AddOpenAndroidUniqueUser = 'addOpen_androidUniqueUser',
  AddOpenIosCount = 'addOpen_iosCount',
  AddOpenIosUniqueUser = 'addOpen_iosUniqueUser',
  AddOpenTimestampMax = 'addOpen_timestampMax',
  AddOpenTimestampMin = 'addOpen_timestampMin',
  AddOpenWebCount = 'addOpen_webCount',
  AddOpenWebTeamCount = 'addOpen_webTeamCount',
  AddOpenWebTeamUniqueUser = 'addOpen_webTeamUniqueUser',
  AddOpenWebUniqueUser = 'addOpen_webUniqueUser',
  AddOpenWebUserCount = 'addOpen_webUserCount',
  AddOpenWebUserUniqueUser = 'addOpen_webUserUniqueUser',
  AdvertisementOpenAllCount = 'advertisementOpen_allCount',
  AdvertisementOpenAllUniqueUser = 'advertisementOpen_allUniqueUser',
  AdvertisementOpenAndroidCount = 'advertisementOpen_androidCount',
  AdvertisementOpenAndroidUniqueUser = 'advertisementOpen_androidUniqueUser',
  AdvertisementOpenIosCount = 'advertisementOpen_iosCount',
  AdvertisementOpenIosUniqueUser = 'advertisementOpen_iosUniqueUser',
  AdvertisementOpenTimestampMax = 'advertisementOpen_timestampMax',
  AdvertisementOpenTimestampMin = 'advertisementOpen_timestampMin',
  AdvertisementOpenWebCount = 'advertisementOpen_webCount',
  AdvertisementOpenWebTeamCount = 'advertisementOpen_webTeamCount',
  AdvertisementOpenWebTeamUniqueUser = 'advertisementOpen_webTeamUniqueUser',
  AdvertisementOpenWebUniqueUser = 'advertisementOpen_webUniqueUser',
  AdvertisementOpenWebUserCount = 'advertisementOpen_webUserCount',
  AdvertisementOpenWebUserUniqueUser = 'advertisementOpen_webUserUniqueUser',
  AdvertisementShowAllCount = 'advertisementShow_allCount',
  AdvertisementShowAllUniqueUser = 'advertisementShow_allUniqueUser',
  AdvertisementShowAndroidCount = 'advertisementShow_androidCount',
  AdvertisementShowAndroidUniqueUser = 'advertisementShow_androidUniqueUser',
  AdvertisementShowDurationAndroidAverage = 'advertisementShow_durationAndroidAverage',
  AdvertisementShowDurationAndroidSum = 'advertisementShow_durationAndroidSum',
  AdvertisementShowDurationAverage = 'advertisementShow_durationAverage',
  AdvertisementShowDurationIosAverage = 'advertisementShow_durationIosAverage',
  AdvertisementShowDurationIosSum = 'advertisementShow_durationIosSum',
  AdvertisementShowDurationSum = 'advertisementShow_durationSum',
  AdvertisementShowDurationWebAverage = 'advertisementShow_durationWebAverage',
  AdvertisementShowDurationWebSum = 'advertisementShow_durationWebSum',
  AdvertisementShowDurationWebTeamAverage = 'advertisementShow_durationWebTeamAverage',
  AdvertisementShowDurationWebTeamSum = 'advertisementShow_durationWebTeamSum',
  AdvertisementShowDurationWebUserAverage = 'advertisementShow_durationWebUserAverage',
  AdvertisementShowDurationWebUserSum = 'advertisementShow_durationWebUserSum',
  AdvertisementShowIosCount = 'advertisementShow_iosCount',
  AdvertisementShowIosUniqueUser = 'advertisementShow_iosUniqueUser',
  AdvertisementShowWebCount = 'advertisementShow_webCount',
  AdvertisementShowWebTeamCount = 'advertisementShow_webTeamCount',
  AdvertisementShowWebTeamUniqueUser = 'advertisementShow_webTeamUniqueUser',
  AdvertisementShowWebUniqueUser = 'advertisementShow_webUniqueUser',
  AdvertisementShowWebUserCount = 'advertisementShow_webUserCount',
  AdvertisementShowWebUserUniqueUser = 'advertisementShow_webUserUniqueUser',
  BookmarkReceiveAllCount = 'bookmarkReceive_allCount',
  BookmarkReceiveAllUniqueUser = 'bookmarkReceive_allUniqueUser',
  BookmarkReceiveTimestampMax = 'bookmarkReceive_timestampMax',
  BookmarkReceiveTimestampMin = 'bookmarkReceive_timestampMin',
  BookmarkAllCount = 'bookmark_allCount',
  BookmarkAllUniqueUser = 'bookmark_allUniqueUser',
  BookmarkTimestampMax = 'bookmark_timestampMax',
  BookmarkTimestampMin = 'bookmark_timestampMin',
  ChannelOpenAllCount = 'channelOpen_allCount',
  ChannelOpenAllUniqueUser = 'channelOpen_allUniqueUser',
  ChannelOpenAndroidCount = 'channelOpen_androidCount',
  ChannelOpenAndroidUniqueUser = 'channelOpen_androidUniqueUser',
  ChannelOpenIosCount = 'channelOpen_iosCount',
  ChannelOpenIosUniqueUser = 'channelOpen_iosUniqueUser',
  ChannelOpenWebCount = 'channelOpen_webCount',
  ChannelOpenWebTeamCount = 'channelOpen_webTeamCount',
  ChannelOpenWebTeamUniqueUser = 'channelOpen_webTeamUniqueUser',
  ChannelOpenWebUniqueUser = 'channelOpen_webUniqueUser',
  ChannelOpenWebUserCount = 'channelOpen_webUserCount',
  ChannelOpenWebUserUniqueUser = 'channelOpen_webUserUniqueUser',
  ConnectionReceiveAllCount = 'connectionReceive_allCount',
  ConnectionReceiveAllUnique = 'connectionReceive_allUnique',
  ConnectionReceiveAllUniqueUser = 'connectionReceive_allUniqueUser',
  ConnectionReceiveAllWithUniqueUser = 'connectionReceive_allWithUniqueUser',
  ConnectionReceiveNotScanCount = 'connectionReceive_notScanCount',
  ConnectionReceiveNotScanUnique = 'connectionReceive_notScanUnique',
  ConnectionReceiveNotScanUniqueUser = 'connectionReceive_notScanUniqueUser',
  ConnectionReceiveNotScanWithUniqueUser = 'connectionReceive_notScanWithUniqueUser',
  ConnectionReceiveScanCount = 'connectionReceive_scanCount',
  ConnectionReceiveScanUnique = 'connectionReceive_scanUnique',
  ConnectionReceiveScanUniqueUser = 'connectionReceive_scanUniqueUser',
  ConnectionReceiveScanWithUniqueUser = 'connectionReceive_scanWithUniqueUser',
  ConnectionReceiveScoreAverage = 'connectionReceive_scoreAverage',
  ConnectionReceiveScoreCount = 'connectionReceive_scoreCount',
  ConnectionReceiveScoreUnique = 'connectionReceive_scoreUnique',
  ConnectionReceiveScoreUniqueUser = 'connectionReceive_scoreUniqueUser',
  ConnectionReceiveScoreWithUniqueUser = 'connectionReceive_scoreWithUniqueUser',
  ConnectionRequestReceiveAcceptedCount = 'connectionRequestReceive_acceptedCount',
  ConnectionRequestReceiveAcceptedUniqueUser = 'connectionRequestReceive_acceptedUniqueUser',
  ConnectionRequestReceiveAcceptedWithUniqueUser = 'connectionRequestReceive_acceptedWithUniqueUser',
  ConnectionRequestReceiveAllCount = 'connectionRequestReceive_allCount',
  ConnectionRequestReceiveAllUniqueUser = 'connectionRequestReceive_allUniqueUser',
  ConnectionRequestReceiveAllWithUniqueUser = 'connectionRequestReceive_allWithUniqueUser',
  ConnectionRequestReceiveDeclinedCount = 'connectionRequestReceive_declinedCount',
  ConnectionRequestReceiveDeclinedUniqueUser = 'connectionRequestReceive_declinedUniqueUser',
  ConnectionRequestReceiveDeclinedWithUniqueUser = 'connectionRequestReceive_declinedWithUniqueUser',
  ConnectionRequestReceivePendingCount = 'connectionRequestReceive_pendingCount',
  ConnectionRequestReceivePendingUniqueUser = 'connectionRequestReceive_pendingUniqueUser',
  ConnectionRequestReceivePendingWithUniqueUser = 'connectionRequestReceive_pendingWithUniqueUser',
  ConnectionRequestAcceptedCount = 'connectionRequest_acceptedCount',
  ConnectionRequestAcceptedUniqueUser = 'connectionRequest_acceptedUniqueUser',
  ConnectionRequestAcceptedWithUniqueUser = 'connectionRequest_acceptedWithUniqueUser',
  ConnectionRequestAllCount = 'connectionRequest_allCount',
  ConnectionRequestAllUniqueUser = 'connectionRequest_allUniqueUser',
  ConnectionRequestAllWithUniqueUser = 'connectionRequest_allWithUniqueUser',
  ConnectionRequestDeclinedCount = 'connectionRequest_declinedCount',
  ConnectionRequestDeclinedUniqueUser = 'connectionRequest_declinedUniqueUser',
  ConnectionRequestDeclinedWithUniqueUser = 'connectionRequest_declinedWithUniqueUser',
  ConnectionRequestPendingCount = 'connectionRequest_pendingCount',
  ConnectionRequestPendingUniqueUser = 'connectionRequest_pendingUniqueUser',
  ConnectionRequestPendingWithUniqueUser = 'connectionRequest_pendingWithUniqueUser',
  ConnectionAllCount = 'connection_allCount',
  ConnectionAllUnique = 'connection_allUnique',
  ConnectionAllUniqueUser = 'connection_allUniqueUser',
  ConnectionAllWithUniqueUser = 'connection_allWithUniqueUser',
  ConnectionNotScanCount = 'connection_notScanCount',
  ConnectionNotScanUnique = 'connection_notScanUnique',
  ConnectionNotScanUniqueUser = 'connection_notScanUniqueUser',
  ConnectionNotScanWithUniqueUser = 'connection_notScanWithUniqueUser',
  ConnectionScanCount = 'connection_scanCount',
  ConnectionScanUnique = 'connection_scanUnique',
  ConnectionScanUniqueUser = 'connection_scanUniqueUser',
  ConnectionScanWithUniqueUser = 'connection_scanWithUniqueUser',
  ConnectionScoreAverage = 'connection_scoreAverage',
  ConnectionScoreCount = 'connection_scoreCount',
  ConnectionScoreUnique = 'connection_scoreUnique',
  ConnectionScoreUniqueUser = 'connection_scoreUniqueUser',
  ConnectionScoreWithUniqueUser = 'connection_scoreWithUniqueUser',
  ContactAllCount = 'contact_allCount',
  ContactAllUniqueUser = 'contact_allUniqueUser',
  ContactNotScanCount = 'contact_notScanCount',
  ContactNotScanUniqueUser = 'contact_notScanUniqueUser',
  ContactScanCount = 'contact_scanCount',
  ContactScanUniqueUser = 'contact_scanUniqueUser',
  DocumentOpenAllCount = 'documentOpen_allCount',
  DocumentOpenAllUniqueUser = 'documentOpen_allUniqueUser',
  DocumentOpenTimestampMax = 'documentOpen_timestampMax',
  DocumentOpenTimestampMin = 'documentOpen_timestampMin',
  EventShowAllCount = 'eventShow_allCount',
  EventShowAllUniqueUser = 'eventShow_allUniqueUser',
  EventShowAndroidCount = 'eventShow_androidCount',
  EventShowAndroidUniqueUser = 'eventShow_androidUniqueUser',
  EventShowIosCount = 'eventShow_iosCount',
  EventShowIosUniqueUser = 'eventShow_iosUniqueUser',
  EventShowWebCount = 'eventShow_webCount',
  EventShowWebTeamCount = 'eventShow_webTeamCount',
  EventShowWebTeamUniqueUser = 'eventShow_webTeamUniqueUser',
  EventShowWebUniqueUser = 'eventShow_webUniqueUser',
  EventShowWebUserCount = 'eventShow_webUserCount',
  EventShowWebUserUniqueUser = 'eventShow_webUserUniqueUser',
  EventViewShowAllCount = 'eventViewShow_allCount',
  EventViewShowAllUniqueUser = 'eventViewShow_allUniqueUser',
  EventViewShowAndroidCount = 'eventViewShow_androidCount',
  EventViewShowAndroidUniqueUser = 'eventViewShow_androidUniqueUser',
  EventViewShowIosCount = 'eventViewShow_iosCount',
  EventViewShowIosUniqueUser = 'eventViewShow_iosUniqueUser',
  EventViewShowWebCount = 'eventViewShow_webCount',
  EventViewShowWebTeamCount = 'eventViewShow_webTeamCount',
  EventViewShowWebTeamUniqueUser = 'eventViewShow_webTeamUniqueUser',
  EventViewShowWebUniqueUser = 'eventViewShow_webUniqueUser',
  EventViewShowWebUserCount = 'eventViewShow_webUserCount',
  EventViewShowWebUserUniqueUser = 'eventViewShow_webUserUniqueUser',
  ExhibitorAdvertisementOpenReceiveAllCount = 'exhibitorAdvertisementOpenReceive_allCount',
  ExhibitorAdvertisementOpenReceiveAllUniqueUser = 'exhibitorAdvertisementOpenReceive_allUniqueUser',
  ExhibitorAdvertisementOpenReceiveAndroidCount = 'exhibitorAdvertisementOpenReceive_androidCount',
  ExhibitorAdvertisementOpenReceiveAndroidUniqueUser = 'exhibitorAdvertisementOpenReceive_androidUniqueUser',
  ExhibitorAdvertisementOpenReceiveIosCount = 'exhibitorAdvertisementOpenReceive_iosCount',
  ExhibitorAdvertisementOpenReceiveIosUniqueUser = 'exhibitorAdvertisementOpenReceive_iosUniqueUser',
  ExhibitorAdvertisementOpenReceiveTimestampMax = 'exhibitorAdvertisementOpenReceive_timestampMax',
  ExhibitorAdvertisementOpenReceiveTimestampMin = 'exhibitorAdvertisementOpenReceive_timestampMin',
  ExhibitorAdvertisementOpenReceiveWebCount = 'exhibitorAdvertisementOpenReceive_webCount',
  ExhibitorAdvertisementOpenReceiveWebTeamCount = 'exhibitorAdvertisementOpenReceive_webTeamCount',
  ExhibitorAdvertisementOpenReceiveWebTeamUniqueUser = 'exhibitorAdvertisementOpenReceive_webTeamUniqueUser',
  ExhibitorAdvertisementOpenReceiveWebUniqueUser = 'exhibitorAdvertisementOpenReceive_webUniqueUser',
  ExhibitorAdvertisementOpenReceiveWebUserCount = 'exhibitorAdvertisementOpenReceive_webUserCount',
  ExhibitorAdvertisementOpenReceiveWebUserUniqueUser = 'exhibitorAdvertisementOpenReceive_webUserUniqueUser',
  ExhibitorAdvertisementOpenAllCount = 'exhibitorAdvertisementOpen_allCount',
  ExhibitorAdvertisementOpenAllUniqueUser = 'exhibitorAdvertisementOpen_allUniqueUser',
  ExhibitorAdvertisementOpenAndroidCount = 'exhibitorAdvertisementOpen_androidCount',
  ExhibitorAdvertisementOpenAndroidUniqueUser = 'exhibitorAdvertisementOpen_androidUniqueUser',
  ExhibitorAdvertisementOpenIosCount = 'exhibitorAdvertisementOpen_iosCount',
  ExhibitorAdvertisementOpenIosUniqueUser = 'exhibitorAdvertisementOpen_iosUniqueUser',
  ExhibitorAdvertisementOpenTimestampMax = 'exhibitorAdvertisementOpen_timestampMax',
  ExhibitorAdvertisementOpenTimestampMin = 'exhibitorAdvertisementOpen_timestampMin',
  ExhibitorAdvertisementOpenWebCount = 'exhibitorAdvertisementOpen_webCount',
  ExhibitorAdvertisementOpenWebTeamCount = 'exhibitorAdvertisementOpen_webTeamCount',
  ExhibitorAdvertisementOpenWebTeamUniqueUser = 'exhibitorAdvertisementOpen_webTeamUniqueUser',
  ExhibitorAdvertisementOpenWebUniqueUser = 'exhibitorAdvertisementOpen_webUniqueUser',
  ExhibitorAdvertisementOpenWebUserCount = 'exhibitorAdvertisementOpen_webUserCount',
  ExhibitorAdvertisementOpenWebUserUniqueUser = 'exhibitorAdvertisementOpen_webUserUniqueUser',
  ExhibitorAdvertisementShowReceiveAllCount = 'exhibitorAdvertisementShowReceive_allCount',
  ExhibitorAdvertisementShowReceiveAllUniqueUser = 'exhibitorAdvertisementShowReceive_allUniqueUser',
  ExhibitorAdvertisementShowReceiveAndroidCount = 'exhibitorAdvertisementShowReceive_androidCount',
  ExhibitorAdvertisementShowReceiveAndroidUniqueUser = 'exhibitorAdvertisementShowReceive_androidUniqueUser',
  ExhibitorAdvertisementShowReceiveIosCount = 'exhibitorAdvertisementShowReceive_iosCount',
  ExhibitorAdvertisementShowReceiveIosUniqueUser = 'exhibitorAdvertisementShowReceive_iosUniqueUser',
  ExhibitorAdvertisementShowReceiveTimestampMax = 'exhibitorAdvertisementShowReceive_timestampMax',
  ExhibitorAdvertisementShowReceiveTimestampMin = 'exhibitorAdvertisementShowReceive_timestampMin',
  ExhibitorAdvertisementShowReceiveWebCount = 'exhibitorAdvertisementShowReceive_webCount',
  ExhibitorAdvertisementShowReceiveWebTeamCount = 'exhibitorAdvertisementShowReceive_webTeamCount',
  ExhibitorAdvertisementShowReceiveWebTeamUniqueUser = 'exhibitorAdvertisementShowReceive_webTeamUniqueUser',
  ExhibitorAdvertisementShowReceiveWebUniqueUser = 'exhibitorAdvertisementShowReceive_webUniqueUser',
  ExhibitorAdvertisementShowReceiveWebUserCount = 'exhibitorAdvertisementShowReceive_webUserCount',
  ExhibitorAdvertisementShowReceiveWebUserUniqueUser = 'exhibitorAdvertisementShowReceive_webUserUniqueUser',
  ExhibitorAdvertisementShowAllCount = 'exhibitorAdvertisementShow_allCount',
  ExhibitorAdvertisementShowAllUniqueUser = 'exhibitorAdvertisementShow_allUniqueUser',
  ExhibitorAdvertisementShowAndroidCount = 'exhibitorAdvertisementShow_androidCount',
  ExhibitorAdvertisementShowAndroidUniqueUser = 'exhibitorAdvertisementShow_androidUniqueUser',
  ExhibitorAdvertisementShowIosCount = 'exhibitorAdvertisementShow_iosCount',
  ExhibitorAdvertisementShowIosUniqueUser = 'exhibitorAdvertisementShow_iosUniqueUser',
  ExhibitorAdvertisementShowTimestampMax = 'exhibitorAdvertisementShow_timestampMax',
  ExhibitorAdvertisementShowTimestampMin = 'exhibitorAdvertisementShow_timestampMin',
  ExhibitorAdvertisementShowWebCount = 'exhibitorAdvertisementShow_webCount',
  ExhibitorAdvertisementShowWebTeamCount = 'exhibitorAdvertisementShow_webTeamCount',
  ExhibitorAdvertisementShowWebTeamUniqueUser = 'exhibitorAdvertisementShow_webTeamUniqueUser',
  ExhibitorAdvertisementShowWebUniqueUser = 'exhibitorAdvertisementShow_webUniqueUser',
  ExhibitorAdvertisementShowWebUserCount = 'exhibitorAdvertisementShow_webUserCount',
  ExhibitorAdvertisementShowWebUserUniqueUser = 'exhibitorAdvertisementShow_webUserUniqueUser',
  ExhibitorBookmarkReceiveAllCount = 'exhibitorBookmarkReceive_allCount',
  ExhibitorBookmarkReceiveAllUniqueUser = 'exhibitorBookmarkReceive_allUniqueUser',
  ExhibitorBookmarkReceiveTimestampMax = 'exhibitorBookmarkReceive_timestampMax',
  ExhibitorBookmarkReceiveTimestampMin = 'exhibitorBookmarkReceive_timestampMin',
  ExhibitorBookmarkAllCount = 'exhibitorBookmark_allCount',
  ExhibitorBookmarkAllUniqueUser = 'exhibitorBookmark_allUniqueUser',
  ExhibitorBookmarkTimestampMax = 'exhibitorBookmark_timestampMax',
  ExhibitorBookmarkTimestampMin = 'exhibitorBookmark_timestampMin',
  ExhibitorPopularityAllCount = 'exhibitorPopularity_allCount',
  ExhibitorPopularityAllUniqueUser = 'exhibitorPopularity_allUniqueUser',
  ExhibitorPopularityAndroidCount = 'exhibitorPopularity_androidCount',
  ExhibitorPopularityAndroidUniqueUser = 'exhibitorPopularity_androidUniqueUser',
  ExhibitorPopularityIosCount = 'exhibitorPopularity_iosCount',
  ExhibitorPopularityIosUniqueUser = 'exhibitorPopularity_iosUniqueUser',
  ExhibitorPopularityTimestampMax = 'exhibitorPopularity_timestampMax',
  ExhibitorPopularityTimestampMin = 'exhibitorPopularity_timestampMin',
  ExhibitorPopularityWebCount = 'exhibitorPopularity_webCount',
  ExhibitorPopularityWebTeamCount = 'exhibitorPopularity_webTeamCount',
  ExhibitorPopularityWebTeamUniqueUser = 'exhibitorPopularity_webTeamUniqueUser',
  ExhibitorPopularityWebUniqueUser = 'exhibitorPopularity_webUniqueUser',
  ExhibitorPopularityWebUserCount = 'exhibitorPopularity_webUserCount',
  ExhibitorPopularityWebUserUniqueUser = 'exhibitorPopularity_webUserUniqueUser',
  ExhibitorSelfShowAllCount = 'exhibitorSelfShow_allCount',
  ExhibitorSelfShowAllUniqueUser = 'exhibitorSelfShow_allUniqueUser',
  ExhibitorSelfShowAndroidCount = 'exhibitorSelfShow_androidCount',
  ExhibitorSelfShowAndroidUniqueUser = 'exhibitorSelfShow_androidUniqueUser',
  ExhibitorSelfShowIosCount = 'exhibitorSelfShow_iosCount',
  ExhibitorSelfShowIosUniqueUser = 'exhibitorSelfShow_iosUniqueUser',
  ExhibitorSelfShowWebCount = 'exhibitorSelfShow_webCount',
  ExhibitorSelfShowWebTeamCount = 'exhibitorSelfShow_webTeamCount',
  ExhibitorSelfShowWebTeamUniqueUser = 'exhibitorSelfShow_webTeamUniqueUser',
  ExhibitorSelfShowWebUniqueUser = 'exhibitorSelfShow_webUniqueUser',
  ExhibitorSelfShowWebUserCount = 'exhibitorSelfShow_webUserCount',
  ExhibitorSelfShowWebUserUniqueUser = 'exhibitorSelfShow_webUserUniqueUser',
  ExhibitorShowReceiveAllCount = 'exhibitorShowReceive_allCount',
  ExhibitorShowReceiveAllUniqueUser = 'exhibitorShowReceive_allUniqueUser',
  ExhibitorShowReceiveAndroidCount = 'exhibitorShowReceive_androidCount',
  ExhibitorShowReceiveAndroidUniqueUser = 'exhibitorShowReceive_androidUniqueUser',
  ExhibitorShowReceiveIosCount = 'exhibitorShowReceive_iosCount',
  ExhibitorShowReceiveIosUniqueUser = 'exhibitorShowReceive_iosUniqueUser',
  ExhibitorShowReceiveTimestampMax = 'exhibitorShowReceive_timestampMax',
  ExhibitorShowReceiveTimestampMin = 'exhibitorShowReceive_timestampMin',
  ExhibitorShowReceiveWebCount = 'exhibitorShowReceive_webCount',
  ExhibitorShowReceiveWebTeamCount = 'exhibitorShowReceive_webTeamCount',
  ExhibitorShowReceiveWebTeamUniqueUser = 'exhibitorShowReceive_webTeamUniqueUser',
  ExhibitorShowReceiveWebUniqueUser = 'exhibitorShowReceive_webUniqueUser',
  ExhibitorShowReceiveWebUserCount = 'exhibitorShowReceive_webUserCount',
  ExhibitorShowReceiveWebUserUniqueUser = 'exhibitorShowReceive_webUserUniqueUser',
  ExhibitorShowAllCount = 'exhibitorShow_allCount',
  ExhibitorShowAllUniqueUser = 'exhibitorShow_allUniqueUser',
  ExhibitorShowAndroidCount = 'exhibitorShow_androidCount',
  ExhibitorShowAndroidUniqueUser = 'exhibitorShow_androidUniqueUser',
  ExhibitorShowIosCount = 'exhibitorShow_iosCount',
  ExhibitorShowIosUniqueUser = 'exhibitorShow_iosUniqueUser',
  ExhibitorShowTimestampMax = 'exhibitorShow_timestampMax',
  ExhibitorShowTimestampMin = 'exhibitorShow_timestampMin',
  ExhibitorShowWebCount = 'exhibitorShow_webCount',
  ExhibitorShowWebTeamCount = 'exhibitorShow_webTeamCount',
  ExhibitorShowWebTeamUniqueUser = 'exhibitorShow_webTeamUniqueUser',
  ExhibitorShowWebUniqueUser = 'exhibitorShow_webUniqueUser',
  ExhibitorShowWebUserCount = 'exhibitorShow_webUserCount',
  ExhibitorShowWebUserUniqueUser = 'exhibitorShow_webUserUniqueUser',
  InterstitialAddShowAllCount = 'interstitialAddShow_allCount',
  InterstitialAddShowAllUniqueUser = 'interstitialAddShow_allUniqueUser',
  InterstitialAddShowAndroidCount = 'interstitialAddShow_androidCount',
  InterstitialAddShowAndroidUniqueUser = 'interstitialAddShow_androidUniqueUser',
  InterstitialAddShowDurationAndroidAverage = 'interstitialAddShow_durationAndroidAverage',
  InterstitialAddShowDurationAndroidSum = 'interstitialAddShow_durationAndroidSum',
  InterstitialAddShowDurationAverage = 'interstitialAddShow_durationAverage',
  InterstitialAddShowDurationIosAverage = 'interstitialAddShow_durationIosAverage',
  InterstitialAddShowDurationIosSum = 'interstitialAddShow_durationIosSum',
  InterstitialAddShowDurationSum = 'interstitialAddShow_durationSum',
  InterstitialAddShowDurationWebAverage = 'interstitialAddShow_durationWebAverage',
  InterstitialAddShowDurationWebSum = 'interstitialAddShow_durationWebSum',
  InterstitialAddShowDurationWebTeamAverage = 'interstitialAddShow_durationWebTeamAverage',
  InterstitialAddShowDurationWebTeamSum = 'interstitialAddShow_durationWebTeamSum',
  InterstitialAddShowDurationWebUserAverage = 'interstitialAddShow_durationWebUserAverage',
  InterstitialAddShowDurationWebUserSum = 'interstitialAddShow_durationWebUserSum',
  InterstitialAddShowIosCount = 'interstitialAddShow_iosCount',
  InterstitialAddShowIosUniqueUser = 'interstitialAddShow_iosUniqueUser',
  InterstitialAddShowWebCount = 'interstitialAddShow_webCount',
  InterstitialAddShowWebTeamCount = 'interstitialAddShow_webTeamCount',
  InterstitialAddShowWebTeamUniqueUser = 'interstitialAddShow_webTeamUniqueUser',
  InterstitialAddShowWebUniqueUser = 'interstitialAddShow_webUniqueUser',
  InterstitialAddShowWebUserCount = 'interstitialAddShow_webUserCount',
  InterstitialAddShowWebUserUniqueUser = 'interstitialAddShow_webUserUniqueUser',
  MeetingParticipantAllCount = 'meetingParticipant_allCount',
  MeetingParticipantAllUnique = 'meetingParticipant_allUnique',
  MeetingParticipantAllUniqueUser = 'meetingParticipant_allUniqueUser',
  MeetingParticipantCanceledCount = 'meetingParticipant_canceledCount',
  MeetingParticipantCanceledUnique = 'meetingParticipant_canceledUnique',
  MeetingParticipantCanceledUniqueUser = 'meetingParticipant_canceledUniqueUser',
  MeetingParticipantConfirmedCount = 'meetingParticipant_confirmedCount',
  MeetingParticipantConfirmedUnique = 'meetingParticipant_confirmedUnique',
  MeetingParticipantConfirmedUniqueUser = 'meetingParticipant_confirmedUniqueUser',
  MeetingParticipantDeclinedCount = 'meetingParticipant_declinedCount',
  MeetingParticipantDeclinedUnique = 'meetingParticipant_declinedUnique',
  MeetingParticipantDeclinedUniqueUser = 'meetingParticipant_declinedUniqueUser',
  MeetingParticipantExpiredCount = 'meetingParticipant_expiredCount',
  MeetingParticipantExpiredUnique = 'meetingParticipant_expiredUnique',
  MeetingParticipantExpiredUniqueUser = 'meetingParticipant_expiredUniqueUser',
  MeetingParticipantNoShowCount = 'meetingParticipant_noShowCount',
  MeetingParticipantNoShowUnique = 'meetingParticipant_noShowUnique',
  MeetingParticipantNoShowUniqueUser = 'meetingParticipant_noShowUniqueUser',
  MeetingParticipantPendingCount = 'meetingParticipant_pendingCount',
  MeetingParticipantPendingUnique = 'meetingParticipant_pendingUnique',
  MeetingParticipantPendingUniqueUser = 'meetingParticipant_pendingUniqueUser',
  MeetingRequestReceiveAcceptedCount = 'meetingRequestReceive_acceptedCount',
  MeetingRequestReceiveAcceptedUniqueUser = 'meetingRequestReceive_acceptedUniqueUser',
  MeetingRequestReceiveAcceptedWithUniqueUser = 'meetingRequestReceive_acceptedWithUniqueUser',
  MeetingRequestReceiveAllCount = 'meetingRequestReceive_allCount',
  MeetingRequestReceiveAllUniqueUser = 'meetingRequestReceive_allUniqueUser',
  MeetingRequestReceiveAllWithUniqueUser = 'meetingRequestReceive_allWithUniqueUser',
  MeetingRequestReceiveCancelledCount = 'meetingRequestReceive_cancelledCount',
  MeetingRequestReceiveCancelledUniqueUser = 'meetingRequestReceive_cancelledUniqueUser',
  MeetingRequestReceiveCancelledWithUniqueUser = 'meetingRequestReceive_cancelledWithUniqueUser',
  MeetingRequestReceiveDeclinedCount = 'meetingRequestReceive_declinedCount',
  MeetingRequestReceiveDeclinedUniqueUser = 'meetingRequestReceive_declinedUniqueUser',
  MeetingRequestReceiveDeclinedWithUniqueUser = 'meetingRequestReceive_declinedWithUniqueUser',
  MeetingRequestReceiveExpiredCount = 'meetingRequestReceive_expiredCount',
  MeetingRequestReceiveExpiredUniqueUser = 'meetingRequestReceive_expiredUniqueUser',
  MeetingRequestReceiveExpiredWithUniqueUser = 'meetingRequestReceive_expiredWithUniqueUser',
  MeetingRequestReceivePendingCount = 'meetingRequestReceive_pendingCount',
  MeetingRequestReceivePendingUniqueUser = 'meetingRequestReceive_pendingUniqueUser',
  MeetingRequestReceivePendingWithUniqueUser = 'meetingRequestReceive_pendingWithUniqueUser',
  MeetingRequestAcceptedCount = 'meetingRequest_acceptedCount',
  MeetingRequestAcceptedUniqueUser = 'meetingRequest_acceptedUniqueUser',
  MeetingRequestAcceptedWithUniqueUser = 'meetingRequest_acceptedWithUniqueUser',
  MeetingRequestAllCount = 'meetingRequest_allCount',
  MeetingRequestAllUniqueUser = 'meetingRequest_allUniqueUser',
  MeetingRequestAllWithUniqueUser = 'meetingRequest_allWithUniqueUser',
  MeetingRequestCancelledCount = 'meetingRequest_cancelledCount',
  MeetingRequestCancelledUniqueUser = 'meetingRequest_cancelledUniqueUser',
  MeetingRequestCancelledWithUniqueUser = 'meetingRequest_cancelledWithUniqueUser',
  MeetingRequestDeclinedCount = 'meetingRequest_declinedCount',
  MeetingRequestDeclinedUniqueUser = 'meetingRequest_declinedUniqueUser',
  MeetingRequestDeclinedWithUniqueUser = 'meetingRequest_declinedWithUniqueUser',
  MeetingRequestExpiredCount = 'meetingRequest_expiredCount',
  MeetingRequestExpiredUniqueUser = 'meetingRequest_expiredUniqueUser',
  MeetingRequestExpiredWithUniqueUser = 'meetingRequest_expiredWithUniqueUser',
  MeetingRequestPendingCount = 'meetingRequest_pendingCount',
  MeetingRequestPendingUniqueUser = 'meetingRequest_pendingUniqueUser',
  MeetingRequestPendingWithUniqueUser = 'meetingRequest_pendingWithUniqueUser',
  MeetingAllCount = 'meeting_allCount',
  MeetingAllUnique = 'meeting_allUnique',
  MeetingAllUniqueUser = 'meeting_allUniqueUser',
  MeetingCanceledCount = 'meeting_canceledCount',
  MeetingCanceledUnique = 'meeting_canceledUnique',
  MeetingCanceledUniqueUser = 'meeting_canceledUniqueUser',
  MeetingConfirmedCount = 'meeting_confirmedCount',
  MeetingConfirmedUnique = 'meeting_confirmedUnique',
  MeetingConfirmedUniqueUser = 'meeting_confirmedUniqueUser',
  MeetingDeclinedCount = 'meeting_declinedCount',
  MeetingDeclinedUnique = 'meeting_declinedUnique',
  MeetingDeclinedUniqueUser = 'meeting_declinedUniqueUser',
  MeetingExpiredCount = 'meeting_expiredCount',
  MeetingExpiredUnique = 'meeting_expiredUnique',
  MeetingExpiredUniqueUser = 'meeting_expiredUniqueUser',
  MeetingNoShowCount = 'meeting_noShowCount',
  MeetingNoShowUnique = 'meeting_noShowUnique',
  MeetingNoShowUniqueUser = 'meeting_noShowUniqueUser',
  MeetingPendingCount = 'meeting_pendingCount',
  MeetingPendingUnique = 'meeting_pendingUnique',
  MeetingPendingUniqueUser = 'meeting_pendingUniqueUser',
  MeetingRescheduledCount = 'meeting_rescheduledCount',
  MeetingRescheduledUnique = 'meeting_rescheduledUnique',
  MeetingRescheduledUniqueUser = 'meeting_rescheduledUniqueUser',
  MessageReceiveAllCount = 'messageReceive_allCount',
  MessageReceiveAllUniqueUser = 'messageReceive_allUniqueUser',
  MessageReceiveChannelUnique = 'messageReceive_channelUnique',
  MessageReceivePrivateCount = 'messageReceive_privateCount',
  MessageReceivePrivateUniqueUser = 'messageReceive_privateUniqueUser',
  MessageReceivePrivateWithUniqueUser = 'messageReceive_privateWithUniqueUser',
  MessageReceivePublicCount = 'messageReceive_publicCount',
  MessageReceivePublicUniqueUser = 'messageReceive_publicUniqueUser',
  MessageAllCount = 'message_allCount',
  MessageAllUniqueUser = 'message_allUniqueUser',
  MessageChannelUnique = 'message_channelUnique',
  MessagePrivateCount = 'message_privateCount',
  MessagePrivateUniqueUser = 'message_privateUniqueUser',
  MessagePrivateWithUniqueUser = 'message_privateWithUniqueUser',
  MessagePublicCount = 'message_publicCount',
  MessagePublicUniqueUser = 'message_publicUniqueUser',
  NetworkActivityAllCount = 'networkActivity_allCount',
  NetworkActivityAllUnique = 'networkActivity_allUnique',
  NetworkActivityAllUniqueUser = 'networkActivity_allUniqueUser',
  NetworkActivityAllWithUniqueUser = 'networkActivity_allWithUniqueUser',
  PersonShowReceiveAllCount = 'personShowReceive_allCount',
  PersonShowReceiveAllUniqueUser = 'personShowReceive_allUniqueUser',
  PersonShowReceiveAllWithUniqueUser = 'personShowReceive_allWithUniqueUser',
  PersonShowReceiveAndroidCount = 'personShowReceive_androidCount',
  PersonShowReceiveAndroidUniqueUser = 'personShowReceive_androidUniqueUser',
  PersonShowReceiveAndroidWithUniqueUser = 'personShowReceive_androidWithUniqueUser',
  PersonShowReceiveIosCount = 'personShowReceive_iosCount',
  PersonShowReceiveIosUniqueUser = 'personShowReceive_iosUniqueUser',
  PersonShowReceiveIosWithUniqueUser = 'personShowReceive_iosWithUniqueUser',
  PersonShowReceiveWebCount = 'personShowReceive_webCount',
  PersonShowReceiveWebTeamCount = 'personShowReceive_webTeamCount',
  PersonShowReceiveWebTeamUniqueUser = 'personShowReceive_webTeamUniqueUser',
  PersonShowReceiveWebTeamWithUniqueUser = 'personShowReceive_webTeamWithUniqueUser',
  PersonShowReceiveWebUniqueUser = 'personShowReceive_webUniqueUser',
  PersonShowReceiveWebUserCount = 'personShowReceive_webUserCount',
  PersonShowReceiveWebUserUniqueUser = 'personShowReceive_webUserUniqueUser',
  PersonShowReceiveWebUserWithUniqueUser = 'personShowReceive_webUserWithUniqueUser',
  PersonShowReceiveWebWithUniqueUser = 'personShowReceive_webWithUniqueUser',
  PersonShowAllCount = 'personShow_allCount',
  PersonShowAllUniqueUser = 'personShow_allUniqueUser',
  PersonShowAllWithUniqueUser = 'personShow_allWithUniqueUser',
  PersonShowAndroidCount = 'personShow_androidCount',
  PersonShowAndroidUniqueUser = 'personShow_androidUniqueUser',
  PersonShowAndroidWithUniqueUser = 'personShow_androidWithUniqueUser',
  PersonShowIosCount = 'personShow_iosCount',
  PersonShowIosUniqueUser = 'personShow_iosUniqueUser',
  PersonShowIosWithUniqueUser = 'personShow_iosWithUniqueUser',
  PersonShowWebCount = 'personShow_webCount',
  PersonShowWebTeamCount = 'personShow_webTeamCount',
  PersonShowWebTeamUniqueUser = 'personShow_webTeamUniqueUser',
  PersonShowWebTeamWithUniqueUser = 'personShow_webTeamWithUniqueUser',
  PersonShowWebUniqueUser = 'personShow_webUniqueUser',
  PersonShowWebUserCount = 'personShow_webUserCount',
  PersonShowWebUserUniqueUser = 'personShow_webUserUniqueUser',
  PersonShowWebUserWithUniqueUser = 'personShow_webUserWithUniqueUser',
  PersonShowWebWithUniqueUser = 'personShow_webWithUniqueUser',
  PlanningBookmarkAllCount = 'planningBookmark_allCount',
  PlanningBookmarkAllUniqueUser = 'planningBookmark_allUniqueUser',
  PlanningPopularityAllCount = 'planningPopularity_allCount',
  PlanningPopularityAllUniqueUser = 'planningPopularity_allUniqueUser',
  PlanningPopularityAndroidCount = 'planningPopularity_androidCount',
  PlanningPopularityAndroidUniqueUser = 'planningPopularity_androidUniqueUser',
  PlanningPopularityIosCount = 'planningPopularity_iosCount',
  PlanningPopularityIosUniqueUser = 'planningPopularity_iosUniqueUser',
  PlanningPopularityTimestampMax = 'planningPopularity_timestampMax',
  PlanningPopularityTimestampMin = 'planningPopularity_timestampMin',
  PlanningPopularityWebCount = 'planningPopularity_webCount',
  PlanningPopularityWebTeamCount = 'planningPopularity_webTeamCount',
  PlanningPopularityWebTeamUniqueUser = 'planningPopularity_webTeamUniqueUser',
  PlanningPopularityWebUniqueUser = 'planningPopularity_webUniqueUser',
  PlanningPopularityWebUserCount = 'planningPopularity_webUserCount',
  PlanningPopularityWebUserUniqueUser = 'planningPopularity_webUserUniqueUser',
  PlanningStreamStartAllCount = 'planningStreamStart_allCount',
  PlanningStreamStartAllUniqueUser = 'planningStreamStart_allUniqueUser',
  PlanningStreamStartAndroidCount = 'planningStreamStart_androidCount',
  PlanningStreamStartAndroidUniqueUser = 'planningStreamStart_androidUniqueUser',
  PlanningStreamStartIosCount = 'planningStreamStart_iosCount',
  PlanningStreamStartIosUniqueUser = 'planningStreamStart_iosUniqueUser',
  PlanningStreamStartTimestampMax = 'planningStreamStart_timestampMax',
  PlanningStreamStartTimestampMin = 'planningStreamStart_timestampMin',
  PlanningStreamStartWebCount = 'planningStreamStart_webCount',
  PlanningStreamStartWebTeamCount = 'planningStreamStart_webTeamCount',
  PlanningStreamStartWebTeamUniqueUser = 'planningStreamStart_webTeamUniqueUser',
  PlanningStreamStartWebUniqueUser = 'planningStreamStart_webUniqueUser',
  PlanningStreamStartWebUserCount = 'planningStreamStart_webUserCount',
  PlanningStreamStartWebUserUniqueUser = 'planningStreamStart_webUserUniqueUser',
  PlanningStreamStopAllCount = 'planningStreamStop_allCount',
  PlanningStreamStopAllUniqueUser = 'planningStreamStop_allUniqueUser',
  PlanningStreamStopAndroidCount = 'planningStreamStop_androidCount',
  PlanningStreamStopAndroidUniqueUser = 'planningStreamStop_androidUniqueUser',
  PlanningStreamStopDurationAndroidAverage = 'planningStreamStop_durationAndroidAverage',
  PlanningStreamStopDurationAndroidSum = 'planningStreamStop_durationAndroidSum',
  PlanningStreamStopDurationAverage = 'planningStreamStop_durationAverage',
  PlanningStreamStopDurationIosAverage = 'planningStreamStop_durationIosAverage',
  PlanningStreamStopDurationIosSum = 'planningStreamStop_durationIosSum',
  PlanningStreamStopDurationSum = 'planningStreamStop_durationSum',
  PlanningStreamStopDurationWebAverage = 'planningStreamStop_durationWebAverage',
  PlanningStreamStopDurationWebSum = 'planningStreamStop_durationWebSum',
  PlanningStreamStopDurationWebTeamAverage = 'planningStreamStop_durationWebTeamAverage',
  PlanningStreamStopDurationWebTeamSum = 'planningStreamStop_durationWebTeamSum',
  PlanningStreamStopDurationWebUserAverage = 'planningStreamStop_durationWebUserAverage',
  PlanningStreamStopDurationWebUserSum = 'planningStreamStop_durationWebUserSum',
  PlanningStreamStopIosCount = 'planningStreamStop_iosCount',
  PlanningStreamStopIosUniqueUser = 'planningStreamStop_iosUniqueUser',
  PlanningStreamStopTimestampMax = 'planningStreamStop_timestampMax',
  PlanningStreamStopTimestampMin = 'planningStreamStop_timestampMin',
  PlanningStreamStopWebCount = 'planningStreamStop_webCount',
  PlanningStreamStopWebTeamCount = 'planningStreamStop_webTeamCount',
  PlanningStreamStopWebTeamUniqueUser = 'planningStreamStop_webTeamUniqueUser',
  PlanningStreamStopWebUniqueUser = 'planningStreamStop_webUniqueUser',
  PlanningStreamStopWebUserCount = 'planningStreamStop_webUserCount',
  PlanningStreamStopWebUserUniqueUser = 'planningStreamStop_webUserUniqueUser',
  PlanningStreamAllCount = 'planningStream_allCount',
  PlanningStreamAllUniqueUser = 'planningStream_allUniqueUser',
  PlanningStreamAndroidCount = 'planningStream_androidCount',
  PlanningStreamAndroidUniqueUser = 'planningStream_androidUniqueUser',
  PlanningStreamIosCount = 'planningStream_iosCount',
  PlanningStreamIosUniqueUser = 'planningStream_iosUniqueUser',
  PlanningStreamTimestampMax = 'planningStream_timestampMax',
  PlanningStreamTimestampMin = 'planningStream_timestampMin',
  PlanningStreamWebCount = 'planningStream_webCount',
  PlanningStreamWebTeamCount = 'planningStream_webTeamCount',
  PlanningStreamWebTeamUniqueUser = 'planningStream_webTeamUniqueUser',
  PlanningStreamWebUniqueUser = 'planningStream_webUniqueUser',
  PlanningStreamWebUserCount = 'planningStream_webUserCount',
  PlanningStreamWebUserUniqueUser = 'planningStream_webUserUniqueUser',
  PostLinkOpenAllCount = 'postLinkOpen_allCount',
  PostLinkOpenAllUniqueUser = 'postLinkOpen_allUniqueUser',
  PostLinkOpenAndroidCount = 'postLinkOpen_androidCount',
  PostLinkOpenAndroidUniqueUser = 'postLinkOpen_androidUniqueUser',
  PostLinkOpenIosCount = 'postLinkOpen_iosCount',
  PostLinkOpenIosUniqueUser = 'postLinkOpen_iosUniqueUser',
  PostLinkOpenWebCount = 'postLinkOpen_webCount',
  PostLinkOpenWebTeamCount = 'postLinkOpen_webTeamCount',
  PostLinkOpenWebTeamUniqueUser = 'postLinkOpen_webTeamUniqueUser',
  PostLinkOpenWebUniqueUser = 'postLinkOpen_webUniqueUser',
  PostLinkOpenWebUserCount = 'postLinkOpen_webUserCount',
  PostLinkOpenWebUserUniqueUser = 'postLinkOpen_webUserUniqueUser',
  ProductBookmarkAllCount = 'productBookmark_allCount',
  ProductBookmarkAllUniqueUser = 'productBookmark_allUniqueUser',
  ProductBookmarkTimestampMax = 'productBookmark_timestampMax',
  ProductBookmarkTimestampMin = 'productBookmark_timestampMin',
  ProductShowAllCount = 'productShow_allCount',
  ProductShowAllUniqueUser = 'productShow_allUniqueUser',
  ProductShowAndroidCount = 'productShow_androidCount',
  ProductShowAndroidUniqueUser = 'productShow_androidUniqueUser',
  ProductShowIosCount = 'productShow_iosCount',
  ProductShowIosUniqueUser = 'productShow_iosUniqueUser',
  ProductShowTimestampMax = 'productShow_timestampMax',
  ProductShowTimestampMin = 'productShow_timestampMin',
  ProductShowWebCount = 'productShow_webCount',
  ProductShowWebTeamCount = 'productShow_webTeamCount',
  ProductShowWebTeamUniqueUser = 'productShow_webTeamUniqueUser',
  ProductShowWebUniqueUser = 'productShow_webUniqueUser',
  ProductShowWebUserCount = 'productShow_webUserCount',
  ProductShowWebUserUniqueUser = 'productShow_webUserUniqueUser',
  RegistrationAbandonedCount = 'registration_abandonedCount',
  RegistrationAllCount = 'registration_allCount',
  RegistrationCanceledCount = 'registration_canceledCount',
  RegistrationCheckedInCount = 'registration_checkedInCount',
  RegistrationRegisteredCount = 'registration_registeredCount',
  SponsorShowAllCount = 'sponsorShow_allCount',
  SponsorShowAllUniqueUser = 'sponsorShow_allUniqueUser',
  SponsorShowAndroidCount = 'sponsorShow_androidCount',
  SponsorShowAndroidUniqueUser = 'sponsorShow_androidUniqueUser',
  SponsorShowIosCount = 'sponsorShow_iosCount',
  SponsorShowIosUniqueUser = 'sponsorShow_iosUniqueUser',
  SponsorShowTimestampMax = 'sponsorShow_timestampMax',
  SponsorShowTimestampMin = 'sponsorShow_timestampMin',
  SponsorShowWebCount = 'sponsorShow_webCount',
  SponsorShowWebTeamCount = 'sponsorShow_webTeamCount',
  SponsorShowWebTeamUniqueUser = 'sponsorShow_webTeamUniqueUser',
  SponsorShowWebUniqueUser = 'sponsorShow_webUniqueUser',
  SponsorShowWebUserCount = 'sponsorShow_webUserCount',
  SponsorShowWebUserUniqueUser = 'sponsorShow_webUserUniqueUser',
  StreamStartAllCount = 'streamStart_allCount',
  StreamStartAllUniqueUser = 'streamStart_allUniqueUser',
  StreamStartAndroidCount = 'streamStart_androidCount',
  StreamStartAndroidUniqueUser = 'streamStart_androidUniqueUser',
  StreamStartIosCount = 'streamStart_iosCount',
  StreamStartIosUniqueUser = 'streamStart_iosUniqueUser',
  StreamStartTimestampMax = 'streamStart_timestampMax',
  StreamStartTimestampMin = 'streamStart_timestampMin',
  StreamStartWebCount = 'streamStart_webCount',
  StreamStartWebTeamCount = 'streamStart_webTeamCount',
  StreamStartWebTeamUniqueUser = 'streamStart_webTeamUniqueUser',
  StreamStartWebUniqueUser = 'streamStart_webUniqueUser',
  StreamStartWebUserCount = 'streamStart_webUserCount',
  StreamStartWebUserUniqueUser = 'streamStart_webUserUniqueUser',
  StreamStopAllCount = 'streamStop_allCount',
  StreamStopAllUniqueUser = 'streamStop_allUniqueUser',
  StreamStopAndroidCount = 'streamStop_androidCount',
  StreamStopAndroidUniqueUser = 'streamStop_androidUniqueUser',
  StreamStopDurationAndroidAverage = 'streamStop_durationAndroidAverage',
  StreamStopDurationAndroidSum = 'streamStop_durationAndroidSum',
  StreamStopDurationAverage = 'streamStop_durationAverage',
  StreamStopDurationIosAverage = 'streamStop_durationIosAverage',
  StreamStopDurationIosSum = 'streamStop_durationIosSum',
  StreamStopDurationSum = 'streamStop_durationSum',
  StreamStopDurationWebAverage = 'streamStop_durationWebAverage',
  StreamStopDurationWebSum = 'streamStop_durationWebSum',
  StreamStopDurationWebTeamAverage = 'streamStop_durationWebTeamAverage',
  StreamStopDurationWebTeamSum = 'streamStop_durationWebTeamSum',
  StreamStopDurationWebUserAverage = 'streamStop_durationWebUserAverage',
  StreamStopDurationWebUserSum = 'streamStop_durationWebUserSum',
  StreamStopIosCount = 'streamStop_iosCount',
  StreamStopIosUniqueUser = 'streamStop_iosUniqueUser',
  StreamStopTimestampMax = 'streamStop_timestampMax',
  StreamStopTimestampMin = 'streamStop_timestampMin',
  StreamStopWebCount = 'streamStop_webCount',
  StreamStopWebTeamCount = 'streamStop_webTeamCount',
  StreamStopWebTeamUniqueUser = 'streamStop_webTeamUniqueUser',
  StreamStopWebUniqueUser = 'streamStop_webUniqueUser',
  StreamStopWebUserCount = 'streamStop_webUserCount',
  StreamStopWebUserUniqueUser = 'streamStop_webUserUniqueUser',
  UsageAllUniqueUser = 'usage_allUniqueUser',
  UsageAndroidUniqueUser = 'usage_androidUniqueUser',
  UsageIosUniqueUser = 'usage_iosUniqueUser',
  UsageWebTeamUniqueUser = 'usage_webTeamUniqueUser',
  UsageWebUniqueUser = 'usage_webUniqueUser',
  UsageWebUserUniqueUser = 'usage_webUserUniqueUser',
  VideoCallRoomAllCount = 'videoCallRoom_allCount',
  VideoCallRoomAllUniqueUser = 'videoCallRoom_allUniqueUser',
  VideoCallRoomAllWithUniqueUser = 'videoCallRoom_allWithUniqueUser',
  VideoCallRoomSucceededCount = 'videoCallRoom_succeededCount',
  VideoCallRoomSucceededDurationAverage = 'videoCallRoom_succeededDurationAverage',
  VideoCallRoomSucceededDurationSum = 'videoCallRoom_succeededDurationSum',
  VideoCallRoomSucceededUniqueUser = 'videoCallRoom_succeededUniqueUser',
  VideoCallRoomSucceededWithUniqueUser = 'videoCallRoom_succeededWithUniqueUser'
}

export enum Analytics_SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Analytics_SortExhibitors = {
  direction: Analytics_SortDirection;
  field: Analytics_SortExhibitorsField;
  limit?: InputMaybe<Scalars['Int']>;
};

export enum Analytics_SortExhibitorsField {
  ActivityTimestampMax = 'activity_timestampMax',
  ActivityTimestampMin = 'activity_timestampMin',
  AddOpenAllCount = 'addOpen_allCount',
  AddOpenAllUniqueUser = 'addOpen_allUniqueUser',
  AddOpenAndroidCount = 'addOpen_androidCount',
  AddOpenAndroidUniqueUser = 'addOpen_androidUniqueUser',
  AddOpenIosCount = 'addOpen_iosCount',
  AddOpenIosUniqueUser = 'addOpen_iosUniqueUser',
  AddOpenTimestampMax = 'addOpen_timestampMax',
  AddOpenTimestampMin = 'addOpen_timestampMin',
  AddOpenWebCount = 'addOpen_webCount',
  AddOpenWebTeamCount = 'addOpen_webTeamCount',
  AddOpenWebTeamUniqueUser = 'addOpen_webTeamUniqueUser',
  AddOpenWebUniqueUser = 'addOpen_webUniqueUser',
  AddOpenWebUserCount = 'addOpen_webUserCount',
  AddOpenWebUserUniqueUser = 'addOpen_webUserUniqueUser',
  AdvertisementOpenAllCount = 'advertisementOpen_allCount',
  AdvertisementOpenAllUniqueUser = 'advertisementOpen_allUniqueUser',
  AdvertisementOpenAndroidCount = 'advertisementOpen_androidCount',
  AdvertisementOpenAndroidUniqueUser = 'advertisementOpen_androidUniqueUser',
  AdvertisementOpenIosCount = 'advertisementOpen_iosCount',
  AdvertisementOpenIosUniqueUser = 'advertisementOpen_iosUniqueUser',
  AdvertisementOpenTimestampMax = 'advertisementOpen_timestampMax',
  AdvertisementOpenTimestampMin = 'advertisementOpen_timestampMin',
  AdvertisementOpenWebCount = 'advertisementOpen_webCount',
  AdvertisementOpenWebTeamCount = 'advertisementOpen_webTeamCount',
  AdvertisementOpenWebTeamUniqueUser = 'advertisementOpen_webTeamUniqueUser',
  AdvertisementOpenWebUniqueUser = 'advertisementOpen_webUniqueUser',
  AdvertisementOpenWebUserCount = 'advertisementOpen_webUserCount',
  AdvertisementOpenWebUserUniqueUser = 'advertisementOpen_webUserUniqueUser',
  AdvertisementShowAllCount = 'advertisementShow_allCount',
  AdvertisementShowAllUniqueUser = 'advertisementShow_allUniqueUser',
  AdvertisementShowAndroidCount = 'advertisementShow_androidCount',
  AdvertisementShowAndroidUniqueUser = 'advertisementShow_androidUniqueUser',
  AdvertisementShowDurationAndroidAverage = 'advertisementShow_durationAndroidAverage',
  AdvertisementShowDurationAndroidSum = 'advertisementShow_durationAndroidSum',
  AdvertisementShowDurationAverage = 'advertisementShow_durationAverage',
  AdvertisementShowDurationIosAverage = 'advertisementShow_durationIosAverage',
  AdvertisementShowDurationIosSum = 'advertisementShow_durationIosSum',
  AdvertisementShowDurationSum = 'advertisementShow_durationSum',
  AdvertisementShowDurationWebAverage = 'advertisementShow_durationWebAverage',
  AdvertisementShowDurationWebSum = 'advertisementShow_durationWebSum',
  AdvertisementShowDurationWebTeamAverage = 'advertisementShow_durationWebTeamAverage',
  AdvertisementShowDurationWebTeamSum = 'advertisementShow_durationWebTeamSum',
  AdvertisementShowDurationWebUserAverage = 'advertisementShow_durationWebUserAverage',
  AdvertisementShowDurationWebUserSum = 'advertisementShow_durationWebUserSum',
  AdvertisementShowIosCount = 'advertisementShow_iosCount',
  AdvertisementShowIosUniqueUser = 'advertisementShow_iosUniqueUser',
  AdvertisementShowWebCount = 'advertisementShow_webCount',
  AdvertisementShowWebTeamCount = 'advertisementShow_webTeamCount',
  AdvertisementShowWebTeamUniqueUser = 'advertisementShow_webTeamUniqueUser',
  AdvertisementShowWebUniqueUser = 'advertisementShow_webUniqueUser',
  AdvertisementShowWebUserCount = 'advertisementShow_webUserCount',
  AdvertisementShowWebUserUniqueUser = 'advertisementShow_webUserUniqueUser',
  BookmarkReceiveAllCount = 'bookmarkReceive_allCount',
  BookmarkReceiveAllUniqueUser = 'bookmarkReceive_allUniqueUser',
  BookmarkReceiveTimestampMax = 'bookmarkReceive_timestampMax',
  BookmarkReceiveTimestampMin = 'bookmarkReceive_timestampMin',
  BookmarkAllCount = 'bookmark_allCount',
  BookmarkAllUniqueUser = 'bookmark_allUniqueUser',
  BookmarkTimestampMax = 'bookmark_timestampMax',
  BookmarkTimestampMin = 'bookmark_timestampMin',
  ChannelOpenAllCount = 'channelOpen_allCount',
  ChannelOpenAllUniqueUser = 'channelOpen_allUniqueUser',
  ChannelOpenAndroidCount = 'channelOpen_androidCount',
  ChannelOpenAndroidUniqueUser = 'channelOpen_androidUniqueUser',
  ChannelOpenIosCount = 'channelOpen_iosCount',
  ChannelOpenIosUniqueUser = 'channelOpen_iosUniqueUser',
  ChannelOpenWebCount = 'channelOpen_webCount',
  ChannelOpenWebTeamCount = 'channelOpen_webTeamCount',
  ChannelOpenWebTeamUniqueUser = 'channelOpen_webTeamUniqueUser',
  ChannelOpenWebUniqueUser = 'channelOpen_webUniqueUser',
  ChannelOpenWebUserCount = 'channelOpen_webUserCount',
  ChannelOpenWebUserUniqueUser = 'channelOpen_webUserUniqueUser',
  ConnectionReceiveAllCount = 'connectionReceive_allCount',
  ConnectionReceiveAllUnique = 'connectionReceive_allUnique',
  ConnectionReceiveAllUniqueUser = 'connectionReceive_allUniqueUser',
  ConnectionReceiveAllWithUniqueUser = 'connectionReceive_allWithUniqueUser',
  ConnectionReceiveNotScanCount = 'connectionReceive_notScanCount',
  ConnectionReceiveNotScanUnique = 'connectionReceive_notScanUnique',
  ConnectionReceiveNotScanUniqueUser = 'connectionReceive_notScanUniqueUser',
  ConnectionReceiveNotScanWithUniqueUser = 'connectionReceive_notScanWithUniqueUser',
  ConnectionReceiveScanCount = 'connectionReceive_scanCount',
  ConnectionReceiveScanUnique = 'connectionReceive_scanUnique',
  ConnectionReceiveScanUniqueUser = 'connectionReceive_scanUniqueUser',
  ConnectionReceiveScanWithUniqueUser = 'connectionReceive_scanWithUniqueUser',
  ConnectionReceiveScoreAverage = 'connectionReceive_scoreAverage',
  ConnectionReceiveScoreCount = 'connectionReceive_scoreCount',
  ConnectionReceiveScoreUnique = 'connectionReceive_scoreUnique',
  ConnectionReceiveScoreUniqueUser = 'connectionReceive_scoreUniqueUser',
  ConnectionReceiveScoreWithUniqueUser = 'connectionReceive_scoreWithUniqueUser',
  ConnectionRequestReceiveAcceptedCount = 'connectionRequestReceive_acceptedCount',
  ConnectionRequestReceiveAcceptedUniqueUser = 'connectionRequestReceive_acceptedUniqueUser',
  ConnectionRequestReceiveAcceptedWithUniqueUser = 'connectionRequestReceive_acceptedWithUniqueUser',
  ConnectionRequestReceiveAllCount = 'connectionRequestReceive_allCount',
  ConnectionRequestReceiveAllUniqueUser = 'connectionRequestReceive_allUniqueUser',
  ConnectionRequestReceiveAllWithUniqueUser = 'connectionRequestReceive_allWithUniqueUser',
  ConnectionRequestReceiveDeclinedCount = 'connectionRequestReceive_declinedCount',
  ConnectionRequestReceiveDeclinedUniqueUser = 'connectionRequestReceive_declinedUniqueUser',
  ConnectionRequestReceiveDeclinedWithUniqueUser = 'connectionRequestReceive_declinedWithUniqueUser',
  ConnectionRequestReceivePendingCount = 'connectionRequestReceive_pendingCount',
  ConnectionRequestReceivePendingUniqueUser = 'connectionRequestReceive_pendingUniqueUser',
  ConnectionRequestReceivePendingWithUniqueUser = 'connectionRequestReceive_pendingWithUniqueUser',
  ConnectionRequestAcceptedCount = 'connectionRequest_acceptedCount',
  ConnectionRequestAcceptedUniqueUser = 'connectionRequest_acceptedUniqueUser',
  ConnectionRequestAcceptedWithUniqueUser = 'connectionRequest_acceptedWithUniqueUser',
  ConnectionRequestAllCount = 'connectionRequest_allCount',
  ConnectionRequestAllUniqueUser = 'connectionRequest_allUniqueUser',
  ConnectionRequestAllWithUniqueUser = 'connectionRequest_allWithUniqueUser',
  ConnectionRequestDeclinedCount = 'connectionRequest_declinedCount',
  ConnectionRequestDeclinedUniqueUser = 'connectionRequest_declinedUniqueUser',
  ConnectionRequestDeclinedWithUniqueUser = 'connectionRequest_declinedWithUniqueUser',
  ConnectionRequestPendingCount = 'connectionRequest_pendingCount',
  ConnectionRequestPendingUniqueUser = 'connectionRequest_pendingUniqueUser',
  ConnectionRequestPendingWithUniqueUser = 'connectionRequest_pendingWithUniqueUser',
  ConnectionAllCount = 'connection_allCount',
  ConnectionAllUnique = 'connection_allUnique',
  ConnectionAllUniqueUser = 'connection_allUniqueUser',
  ConnectionAllWithUniqueUser = 'connection_allWithUniqueUser',
  ConnectionNotScanCount = 'connection_notScanCount',
  ConnectionNotScanUnique = 'connection_notScanUnique',
  ConnectionNotScanUniqueUser = 'connection_notScanUniqueUser',
  ConnectionNotScanWithUniqueUser = 'connection_notScanWithUniqueUser',
  ConnectionScanCount = 'connection_scanCount',
  ConnectionScanUnique = 'connection_scanUnique',
  ConnectionScanUniqueUser = 'connection_scanUniqueUser',
  ConnectionScanWithUniqueUser = 'connection_scanWithUniqueUser',
  ConnectionScoreAverage = 'connection_scoreAverage',
  ConnectionScoreCount = 'connection_scoreCount',
  ConnectionScoreUnique = 'connection_scoreUnique',
  ConnectionScoreUniqueUser = 'connection_scoreUniqueUser',
  ConnectionScoreWithUniqueUser = 'connection_scoreWithUniqueUser',
  ContactAllCount = 'contact_allCount',
  ContactAllUniqueUser = 'contact_allUniqueUser',
  ContactNotScanCount = 'contact_notScanCount',
  ContactNotScanUniqueUser = 'contact_notScanUniqueUser',
  ContactScanCount = 'contact_scanCount',
  ContactScanUniqueUser = 'contact_scanUniqueUser',
  DocumentOpenAllCount = 'documentOpen_allCount',
  DocumentOpenAllUniqueUser = 'documentOpen_allUniqueUser',
  DocumentOpenTimestampMax = 'documentOpen_timestampMax',
  DocumentOpenTimestampMin = 'documentOpen_timestampMin',
  EventShowAllCount = 'eventShow_allCount',
  EventShowAllUniqueUser = 'eventShow_allUniqueUser',
  EventShowAndroidCount = 'eventShow_androidCount',
  EventShowAndroidUniqueUser = 'eventShow_androidUniqueUser',
  EventShowIosCount = 'eventShow_iosCount',
  EventShowIosUniqueUser = 'eventShow_iosUniqueUser',
  EventShowWebCount = 'eventShow_webCount',
  EventShowWebTeamCount = 'eventShow_webTeamCount',
  EventShowWebTeamUniqueUser = 'eventShow_webTeamUniqueUser',
  EventShowWebUniqueUser = 'eventShow_webUniqueUser',
  EventShowWebUserCount = 'eventShow_webUserCount',
  EventShowWebUserUniqueUser = 'eventShow_webUserUniqueUser',
  EventViewShowAllCount = 'eventViewShow_allCount',
  EventViewShowAllUniqueUser = 'eventViewShow_allUniqueUser',
  EventViewShowAndroidCount = 'eventViewShow_androidCount',
  EventViewShowAndroidUniqueUser = 'eventViewShow_androidUniqueUser',
  EventViewShowIosCount = 'eventViewShow_iosCount',
  EventViewShowIosUniqueUser = 'eventViewShow_iosUniqueUser',
  EventViewShowWebCount = 'eventViewShow_webCount',
  EventViewShowWebTeamCount = 'eventViewShow_webTeamCount',
  EventViewShowWebTeamUniqueUser = 'eventViewShow_webTeamUniqueUser',
  EventViewShowWebUniqueUser = 'eventViewShow_webUniqueUser',
  EventViewShowWebUserCount = 'eventViewShow_webUserCount',
  EventViewShowWebUserUniqueUser = 'eventViewShow_webUserUniqueUser',
  ExhibitorAdvertisementOpenReceiveAllCount = 'exhibitorAdvertisementOpenReceive_allCount',
  ExhibitorAdvertisementOpenReceiveAllUniqueUser = 'exhibitorAdvertisementOpenReceive_allUniqueUser',
  ExhibitorAdvertisementOpenReceiveAndroidCount = 'exhibitorAdvertisementOpenReceive_androidCount',
  ExhibitorAdvertisementOpenReceiveAndroidUniqueUser = 'exhibitorAdvertisementOpenReceive_androidUniqueUser',
  ExhibitorAdvertisementOpenReceiveIosCount = 'exhibitorAdvertisementOpenReceive_iosCount',
  ExhibitorAdvertisementOpenReceiveIosUniqueUser = 'exhibitorAdvertisementOpenReceive_iosUniqueUser',
  ExhibitorAdvertisementOpenReceiveTimestampMax = 'exhibitorAdvertisementOpenReceive_timestampMax',
  ExhibitorAdvertisementOpenReceiveTimestampMin = 'exhibitorAdvertisementOpenReceive_timestampMin',
  ExhibitorAdvertisementOpenReceiveWebCount = 'exhibitorAdvertisementOpenReceive_webCount',
  ExhibitorAdvertisementOpenReceiveWebTeamCount = 'exhibitorAdvertisementOpenReceive_webTeamCount',
  ExhibitorAdvertisementOpenReceiveWebTeamUniqueUser = 'exhibitorAdvertisementOpenReceive_webTeamUniqueUser',
  ExhibitorAdvertisementOpenReceiveWebUniqueUser = 'exhibitorAdvertisementOpenReceive_webUniqueUser',
  ExhibitorAdvertisementOpenReceiveWebUserCount = 'exhibitorAdvertisementOpenReceive_webUserCount',
  ExhibitorAdvertisementOpenReceiveWebUserUniqueUser = 'exhibitorAdvertisementOpenReceive_webUserUniqueUser',
  ExhibitorAdvertisementOpenAllCount = 'exhibitorAdvertisementOpen_allCount',
  ExhibitorAdvertisementOpenAllUniqueUser = 'exhibitorAdvertisementOpen_allUniqueUser',
  ExhibitorAdvertisementOpenAndroidCount = 'exhibitorAdvertisementOpen_androidCount',
  ExhibitorAdvertisementOpenAndroidUniqueUser = 'exhibitorAdvertisementOpen_androidUniqueUser',
  ExhibitorAdvertisementOpenIosCount = 'exhibitorAdvertisementOpen_iosCount',
  ExhibitorAdvertisementOpenIosUniqueUser = 'exhibitorAdvertisementOpen_iosUniqueUser',
  ExhibitorAdvertisementOpenTimestampMax = 'exhibitorAdvertisementOpen_timestampMax',
  ExhibitorAdvertisementOpenTimestampMin = 'exhibitorAdvertisementOpen_timestampMin',
  ExhibitorAdvertisementOpenWebCount = 'exhibitorAdvertisementOpen_webCount',
  ExhibitorAdvertisementOpenWebTeamCount = 'exhibitorAdvertisementOpen_webTeamCount',
  ExhibitorAdvertisementOpenWebTeamUniqueUser = 'exhibitorAdvertisementOpen_webTeamUniqueUser',
  ExhibitorAdvertisementOpenWebUniqueUser = 'exhibitorAdvertisementOpen_webUniqueUser',
  ExhibitorAdvertisementOpenWebUserCount = 'exhibitorAdvertisementOpen_webUserCount',
  ExhibitorAdvertisementOpenWebUserUniqueUser = 'exhibitorAdvertisementOpen_webUserUniqueUser',
  ExhibitorAdvertisementShowReceiveAllCount = 'exhibitorAdvertisementShowReceive_allCount',
  ExhibitorAdvertisementShowReceiveAllUniqueUser = 'exhibitorAdvertisementShowReceive_allUniqueUser',
  ExhibitorAdvertisementShowReceiveAndroidCount = 'exhibitorAdvertisementShowReceive_androidCount',
  ExhibitorAdvertisementShowReceiveAndroidUniqueUser = 'exhibitorAdvertisementShowReceive_androidUniqueUser',
  ExhibitorAdvertisementShowReceiveIosCount = 'exhibitorAdvertisementShowReceive_iosCount',
  ExhibitorAdvertisementShowReceiveIosUniqueUser = 'exhibitorAdvertisementShowReceive_iosUniqueUser',
  ExhibitorAdvertisementShowReceiveTimestampMax = 'exhibitorAdvertisementShowReceive_timestampMax',
  ExhibitorAdvertisementShowReceiveTimestampMin = 'exhibitorAdvertisementShowReceive_timestampMin',
  ExhibitorAdvertisementShowReceiveWebCount = 'exhibitorAdvertisementShowReceive_webCount',
  ExhibitorAdvertisementShowReceiveWebTeamCount = 'exhibitorAdvertisementShowReceive_webTeamCount',
  ExhibitorAdvertisementShowReceiveWebTeamUniqueUser = 'exhibitorAdvertisementShowReceive_webTeamUniqueUser',
  ExhibitorAdvertisementShowReceiveWebUniqueUser = 'exhibitorAdvertisementShowReceive_webUniqueUser',
  ExhibitorAdvertisementShowReceiveWebUserCount = 'exhibitorAdvertisementShowReceive_webUserCount',
  ExhibitorAdvertisementShowReceiveWebUserUniqueUser = 'exhibitorAdvertisementShowReceive_webUserUniqueUser',
  ExhibitorAdvertisementShowAllCount = 'exhibitorAdvertisementShow_allCount',
  ExhibitorAdvertisementShowAllUniqueUser = 'exhibitorAdvertisementShow_allUniqueUser',
  ExhibitorAdvertisementShowAndroidCount = 'exhibitorAdvertisementShow_androidCount',
  ExhibitorAdvertisementShowAndroidUniqueUser = 'exhibitorAdvertisementShow_androidUniqueUser',
  ExhibitorAdvertisementShowIosCount = 'exhibitorAdvertisementShow_iosCount',
  ExhibitorAdvertisementShowIosUniqueUser = 'exhibitorAdvertisementShow_iosUniqueUser',
  ExhibitorAdvertisementShowTimestampMax = 'exhibitorAdvertisementShow_timestampMax',
  ExhibitorAdvertisementShowTimestampMin = 'exhibitorAdvertisementShow_timestampMin',
  ExhibitorAdvertisementShowWebCount = 'exhibitorAdvertisementShow_webCount',
  ExhibitorAdvertisementShowWebTeamCount = 'exhibitorAdvertisementShow_webTeamCount',
  ExhibitorAdvertisementShowWebTeamUniqueUser = 'exhibitorAdvertisementShow_webTeamUniqueUser',
  ExhibitorAdvertisementShowWebUniqueUser = 'exhibitorAdvertisementShow_webUniqueUser',
  ExhibitorAdvertisementShowWebUserCount = 'exhibitorAdvertisementShow_webUserCount',
  ExhibitorAdvertisementShowWebUserUniqueUser = 'exhibitorAdvertisementShow_webUserUniqueUser',
  ExhibitorBookmarkReceiveAllCount = 'exhibitorBookmarkReceive_allCount',
  ExhibitorBookmarkReceiveAllUniqueUser = 'exhibitorBookmarkReceive_allUniqueUser',
  ExhibitorBookmarkReceiveTimestampMax = 'exhibitorBookmarkReceive_timestampMax',
  ExhibitorBookmarkReceiveTimestampMin = 'exhibitorBookmarkReceive_timestampMin',
  ExhibitorBookmarkAllCount = 'exhibitorBookmark_allCount',
  ExhibitorBookmarkAllUniqueUser = 'exhibitorBookmark_allUniqueUser',
  ExhibitorBookmarkTimestampMax = 'exhibitorBookmark_timestampMax',
  ExhibitorBookmarkTimestampMin = 'exhibitorBookmark_timestampMin',
  ExhibitorPopularityAllCount = 'exhibitorPopularity_allCount',
  ExhibitorPopularityAllUniqueUser = 'exhibitorPopularity_allUniqueUser',
  ExhibitorPopularityAndroidCount = 'exhibitorPopularity_androidCount',
  ExhibitorPopularityAndroidUniqueUser = 'exhibitorPopularity_androidUniqueUser',
  ExhibitorPopularityIosCount = 'exhibitorPopularity_iosCount',
  ExhibitorPopularityIosUniqueUser = 'exhibitorPopularity_iosUniqueUser',
  ExhibitorPopularityTimestampMax = 'exhibitorPopularity_timestampMax',
  ExhibitorPopularityTimestampMin = 'exhibitorPopularity_timestampMin',
  ExhibitorPopularityWebCount = 'exhibitorPopularity_webCount',
  ExhibitorPopularityWebTeamCount = 'exhibitorPopularity_webTeamCount',
  ExhibitorPopularityWebTeamUniqueUser = 'exhibitorPopularity_webTeamUniqueUser',
  ExhibitorPopularityWebUniqueUser = 'exhibitorPopularity_webUniqueUser',
  ExhibitorPopularityWebUserCount = 'exhibitorPopularity_webUserCount',
  ExhibitorPopularityWebUserUniqueUser = 'exhibitorPopularity_webUserUniqueUser',
  ExhibitorSelfShowAllCount = 'exhibitorSelfShow_allCount',
  ExhibitorSelfShowAllUniqueUser = 'exhibitorSelfShow_allUniqueUser',
  ExhibitorSelfShowAndroidCount = 'exhibitorSelfShow_androidCount',
  ExhibitorSelfShowAndroidUniqueUser = 'exhibitorSelfShow_androidUniqueUser',
  ExhibitorSelfShowIosCount = 'exhibitorSelfShow_iosCount',
  ExhibitorSelfShowIosUniqueUser = 'exhibitorSelfShow_iosUniqueUser',
  ExhibitorSelfShowWebCount = 'exhibitorSelfShow_webCount',
  ExhibitorSelfShowWebTeamCount = 'exhibitorSelfShow_webTeamCount',
  ExhibitorSelfShowWebTeamUniqueUser = 'exhibitorSelfShow_webTeamUniqueUser',
  ExhibitorSelfShowWebUniqueUser = 'exhibitorSelfShow_webUniqueUser',
  ExhibitorSelfShowWebUserCount = 'exhibitorSelfShow_webUserCount',
  ExhibitorSelfShowWebUserUniqueUser = 'exhibitorSelfShow_webUserUniqueUser',
  ExhibitorShowReceiveAllCount = 'exhibitorShowReceive_allCount',
  ExhibitorShowReceiveAllUniqueUser = 'exhibitorShowReceive_allUniqueUser',
  ExhibitorShowReceiveAndroidCount = 'exhibitorShowReceive_androidCount',
  ExhibitorShowReceiveAndroidUniqueUser = 'exhibitorShowReceive_androidUniqueUser',
  ExhibitorShowReceiveIosCount = 'exhibitorShowReceive_iosCount',
  ExhibitorShowReceiveIosUniqueUser = 'exhibitorShowReceive_iosUniqueUser',
  ExhibitorShowReceiveTimestampMax = 'exhibitorShowReceive_timestampMax',
  ExhibitorShowReceiveTimestampMin = 'exhibitorShowReceive_timestampMin',
  ExhibitorShowReceiveWebCount = 'exhibitorShowReceive_webCount',
  ExhibitorShowReceiveWebTeamCount = 'exhibitorShowReceive_webTeamCount',
  ExhibitorShowReceiveWebTeamUniqueUser = 'exhibitorShowReceive_webTeamUniqueUser',
  ExhibitorShowReceiveWebUniqueUser = 'exhibitorShowReceive_webUniqueUser',
  ExhibitorShowReceiveWebUserCount = 'exhibitorShowReceive_webUserCount',
  ExhibitorShowReceiveWebUserUniqueUser = 'exhibitorShowReceive_webUserUniqueUser',
  ExhibitorShowAllCount = 'exhibitorShow_allCount',
  ExhibitorShowAllUniqueUser = 'exhibitorShow_allUniqueUser',
  ExhibitorShowAndroidCount = 'exhibitorShow_androidCount',
  ExhibitorShowAndroidUniqueUser = 'exhibitorShow_androidUniqueUser',
  ExhibitorShowIosCount = 'exhibitorShow_iosCount',
  ExhibitorShowIosUniqueUser = 'exhibitorShow_iosUniqueUser',
  ExhibitorShowTimestampMax = 'exhibitorShow_timestampMax',
  ExhibitorShowTimestampMin = 'exhibitorShow_timestampMin',
  ExhibitorShowWebCount = 'exhibitorShow_webCount',
  ExhibitorShowWebTeamCount = 'exhibitorShow_webTeamCount',
  ExhibitorShowWebTeamUniqueUser = 'exhibitorShow_webTeamUniqueUser',
  ExhibitorShowWebUniqueUser = 'exhibitorShow_webUniqueUser',
  ExhibitorShowWebUserCount = 'exhibitorShow_webUserCount',
  ExhibitorShowWebUserUniqueUser = 'exhibitorShow_webUserUniqueUser',
  InterstitialAddShowAllCount = 'interstitialAddShow_allCount',
  InterstitialAddShowAllUniqueUser = 'interstitialAddShow_allUniqueUser',
  InterstitialAddShowAndroidCount = 'interstitialAddShow_androidCount',
  InterstitialAddShowAndroidUniqueUser = 'interstitialAddShow_androidUniqueUser',
  InterstitialAddShowDurationAndroidAverage = 'interstitialAddShow_durationAndroidAverage',
  InterstitialAddShowDurationAndroidSum = 'interstitialAddShow_durationAndroidSum',
  InterstitialAddShowDurationAverage = 'interstitialAddShow_durationAverage',
  InterstitialAddShowDurationIosAverage = 'interstitialAddShow_durationIosAverage',
  InterstitialAddShowDurationIosSum = 'interstitialAddShow_durationIosSum',
  InterstitialAddShowDurationSum = 'interstitialAddShow_durationSum',
  InterstitialAddShowDurationWebAverage = 'interstitialAddShow_durationWebAverage',
  InterstitialAddShowDurationWebSum = 'interstitialAddShow_durationWebSum',
  InterstitialAddShowDurationWebTeamAverage = 'interstitialAddShow_durationWebTeamAverage',
  InterstitialAddShowDurationWebTeamSum = 'interstitialAddShow_durationWebTeamSum',
  InterstitialAddShowDurationWebUserAverage = 'interstitialAddShow_durationWebUserAverage',
  InterstitialAddShowDurationWebUserSum = 'interstitialAddShow_durationWebUserSum',
  InterstitialAddShowIosCount = 'interstitialAddShow_iosCount',
  InterstitialAddShowIosUniqueUser = 'interstitialAddShow_iosUniqueUser',
  InterstitialAddShowWebCount = 'interstitialAddShow_webCount',
  InterstitialAddShowWebTeamCount = 'interstitialAddShow_webTeamCount',
  InterstitialAddShowWebTeamUniqueUser = 'interstitialAddShow_webTeamUniqueUser',
  InterstitialAddShowWebUniqueUser = 'interstitialAddShow_webUniqueUser',
  InterstitialAddShowWebUserCount = 'interstitialAddShow_webUserCount',
  InterstitialAddShowWebUserUniqueUser = 'interstitialAddShow_webUserUniqueUser',
  MeetingParticipantAllCount = 'meetingParticipant_allCount',
  MeetingParticipantAllUnique = 'meetingParticipant_allUnique',
  MeetingParticipantAllUniqueUser = 'meetingParticipant_allUniqueUser',
  MeetingParticipantCanceledCount = 'meetingParticipant_canceledCount',
  MeetingParticipantCanceledUnique = 'meetingParticipant_canceledUnique',
  MeetingParticipantCanceledUniqueUser = 'meetingParticipant_canceledUniqueUser',
  MeetingParticipantConfirmedCount = 'meetingParticipant_confirmedCount',
  MeetingParticipantConfirmedUnique = 'meetingParticipant_confirmedUnique',
  MeetingParticipantConfirmedUniqueUser = 'meetingParticipant_confirmedUniqueUser',
  MeetingParticipantDeclinedCount = 'meetingParticipant_declinedCount',
  MeetingParticipantDeclinedUnique = 'meetingParticipant_declinedUnique',
  MeetingParticipantDeclinedUniqueUser = 'meetingParticipant_declinedUniqueUser',
  MeetingParticipantExpiredCount = 'meetingParticipant_expiredCount',
  MeetingParticipantExpiredUnique = 'meetingParticipant_expiredUnique',
  MeetingParticipantExpiredUniqueUser = 'meetingParticipant_expiredUniqueUser',
  MeetingParticipantNoShowCount = 'meetingParticipant_noShowCount',
  MeetingParticipantNoShowUnique = 'meetingParticipant_noShowUnique',
  MeetingParticipantNoShowUniqueUser = 'meetingParticipant_noShowUniqueUser',
  MeetingParticipantPendingCount = 'meetingParticipant_pendingCount',
  MeetingParticipantPendingUnique = 'meetingParticipant_pendingUnique',
  MeetingParticipantPendingUniqueUser = 'meetingParticipant_pendingUniqueUser',
  MeetingRequestReceiveAcceptedCount = 'meetingRequestReceive_acceptedCount',
  MeetingRequestReceiveAcceptedUniqueUser = 'meetingRequestReceive_acceptedUniqueUser',
  MeetingRequestReceiveAcceptedWithUniqueUser = 'meetingRequestReceive_acceptedWithUniqueUser',
  MeetingRequestReceiveAllCount = 'meetingRequestReceive_allCount',
  MeetingRequestReceiveAllUniqueUser = 'meetingRequestReceive_allUniqueUser',
  MeetingRequestReceiveAllWithUniqueUser = 'meetingRequestReceive_allWithUniqueUser',
  MeetingRequestReceiveCancelledCount = 'meetingRequestReceive_cancelledCount',
  MeetingRequestReceiveCancelledUniqueUser = 'meetingRequestReceive_cancelledUniqueUser',
  MeetingRequestReceiveCancelledWithUniqueUser = 'meetingRequestReceive_cancelledWithUniqueUser',
  MeetingRequestReceiveDeclinedCount = 'meetingRequestReceive_declinedCount',
  MeetingRequestReceiveDeclinedUniqueUser = 'meetingRequestReceive_declinedUniqueUser',
  MeetingRequestReceiveDeclinedWithUniqueUser = 'meetingRequestReceive_declinedWithUniqueUser',
  MeetingRequestReceiveExpiredCount = 'meetingRequestReceive_expiredCount',
  MeetingRequestReceiveExpiredUniqueUser = 'meetingRequestReceive_expiredUniqueUser',
  MeetingRequestReceiveExpiredWithUniqueUser = 'meetingRequestReceive_expiredWithUniqueUser',
  MeetingRequestReceivePendingCount = 'meetingRequestReceive_pendingCount',
  MeetingRequestReceivePendingUniqueUser = 'meetingRequestReceive_pendingUniqueUser',
  MeetingRequestReceivePendingWithUniqueUser = 'meetingRequestReceive_pendingWithUniqueUser',
  MeetingRequestAcceptedCount = 'meetingRequest_acceptedCount',
  MeetingRequestAcceptedUniqueUser = 'meetingRequest_acceptedUniqueUser',
  MeetingRequestAcceptedWithUniqueUser = 'meetingRequest_acceptedWithUniqueUser',
  MeetingRequestAllCount = 'meetingRequest_allCount',
  MeetingRequestAllUniqueUser = 'meetingRequest_allUniqueUser',
  MeetingRequestAllWithUniqueUser = 'meetingRequest_allWithUniqueUser',
  MeetingRequestCancelledCount = 'meetingRequest_cancelledCount',
  MeetingRequestCancelledUniqueUser = 'meetingRequest_cancelledUniqueUser',
  MeetingRequestCancelledWithUniqueUser = 'meetingRequest_cancelledWithUniqueUser',
  MeetingRequestDeclinedCount = 'meetingRequest_declinedCount',
  MeetingRequestDeclinedUniqueUser = 'meetingRequest_declinedUniqueUser',
  MeetingRequestDeclinedWithUniqueUser = 'meetingRequest_declinedWithUniqueUser',
  MeetingRequestExpiredCount = 'meetingRequest_expiredCount',
  MeetingRequestExpiredUniqueUser = 'meetingRequest_expiredUniqueUser',
  MeetingRequestExpiredWithUniqueUser = 'meetingRequest_expiredWithUniqueUser',
  MeetingRequestPendingCount = 'meetingRequest_pendingCount',
  MeetingRequestPendingUniqueUser = 'meetingRequest_pendingUniqueUser',
  MeetingRequestPendingWithUniqueUser = 'meetingRequest_pendingWithUniqueUser',
  MeetingAllCount = 'meeting_allCount',
  MeetingAllUnique = 'meeting_allUnique',
  MeetingAllUniqueUser = 'meeting_allUniqueUser',
  MeetingCanceledCount = 'meeting_canceledCount',
  MeetingCanceledUnique = 'meeting_canceledUnique',
  MeetingCanceledUniqueUser = 'meeting_canceledUniqueUser',
  MeetingConfirmedCount = 'meeting_confirmedCount',
  MeetingConfirmedUnique = 'meeting_confirmedUnique',
  MeetingConfirmedUniqueUser = 'meeting_confirmedUniqueUser',
  MeetingDeclinedCount = 'meeting_declinedCount',
  MeetingDeclinedUnique = 'meeting_declinedUnique',
  MeetingDeclinedUniqueUser = 'meeting_declinedUniqueUser',
  MeetingExpiredCount = 'meeting_expiredCount',
  MeetingExpiredUnique = 'meeting_expiredUnique',
  MeetingExpiredUniqueUser = 'meeting_expiredUniqueUser',
  MeetingNoShowCount = 'meeting_noShowCount',
  MeetingNoShowUnique = 'meeting_noShowUnique',
  MeetingNoShowUniqueUser = 'meeting_noShowUniqueUser',
  MeetingPendingCount = 'meeting_pendingCount',
  MeetingPendingUnique = 'meeting_pendingUnique',
  MeetingPendingUniqueUser = 'meeting_pendingUniqueUser',
  MeetingRescheduledCount = 'meeting_rescheduledCount',
  MeetingRescheduledUnique = 'meeting_rescheduledUnique',
  MeetingRescheduledUniqueUser = 'meeting_rescheduledUniqueUser',
  MessageReceiveAllCount = 'messageReceive_allCount',
  MessageReceiveAllUniqueUser = 'messageReceive_allUniqueUser',
  MessageReceiveChannelUnique = 'messageReceive_channelUnique',
  MessageReceivePrivateCount = 'messageReceive_privateCount',
  MessageReceivePrivateUniqueUser = 'messageReceive_privateUniqueUser',
  MessageReceivePrivateWithUniqueUser = 'messageReceive_privateWithUniqueUser',
  MessageReceivePublicCount = 'messageReceive_publicCount',
  MessageReceivePublicUniqueUser = 'messageReceive_publicUniqueUser',
  MessageAllCount = 'message_allCount',
  MessageAllUniqueUser = 'message_allUniqueUser',
  MessageChannelUnique = 'message_channelUnique',
  MessagePrivateCount = 'message_privateCount',
  MessagePrivateUniqueUser = 'message_privateUniqueUser',
  MessagePrivateWithUniqueUser = 'message_privateWithUniqueUser',
  MessagePublicCount = 'message_publicCount',
  MessagePublicUniqueUser = 'message_publicUniqueUser',
  NetworkActivityAllCount = 'networkActivity_allCount',
  NetworkActivityAllUnique = 'networkActivity_allUnique',
  NetworkActivityAllUniqueUser = 'networkActivity_allUniqueUser',
  NetworkActivityAllWithUniqueUser = 'networkActivity_allWithUniqueUser',
  PersonShowReceiveAllCount = 'personShowReceive_allCount',
  PersonShowReceiveAllUniqueUser = 'personShowReceive_allUniqueUser',
  PersonShowReceiveAllWithUniqueUser = 'personShowReceive_allWithUniqueUser',
  PersonShowReceiveAndroidCount = 'personShowReceive_androidCount',
  PersonShowReceiveAndroidUniqueUser = 'personShowReceive_androidUniqueUser',
  PersonShowReceiveAndroidWithUniqueUser = 'personShowReceive_androidWithUniqueUser',
  PersonShowReceiveIosCount = 'personShowReceive_iosCount',
  PersonShowReceiveIosUniqueUser = 'personShowReceive_iosUniqueUser',
  PersonShowReceiveIosWithUniqueUser = 'personShowReceive_iosWithUniqueUser',
  PersonShowReceiveWebCount = 'personShowReceive_webCount',
  PersonShowReceiveWebTeamCount = 'personShowReceive_webTeamCount',
  PersonShowReceiveWebTeamUniqueUser = 'personShowReceive_webTeamUniqueUser',
  PersonShowReceiveWebTeamWithUniqueUser = 'personShowReceive_webTeamWithUniqueUser',
  PersonShowReceiveWebUniqueUser = 'personShowReceive_webUniqueUser',
  PersonShowReceiveWebUserCount = 'personShowReceive_webUserCount',
  PersonShowReceiveWebUserUniqueUser = 'personShowReceive_webUserUniqueUser',
  PersonShowReceiveWebUserWithUniqueUser = 'personShowReceive_webUserWithUniqueUser',
  PersonShowReceiveWebWithUniqueUser = 'personShowReceive_webWithUniqueUser',
  PersonShowAllCount = 'personShow_allCount',
  PersonShowAllUniqueUser = 'personShow_allUniqueUser',
  PersonShowAllWithUniqueUser = 'personShow_allWithUniqueUser',
  PersonShowAndroidCount = 'personShow_androidCount',
  PersonShowAndroidUniqueUser = 'personShow_androidUniqueUser',
  PersonShowAndroidWithUniqueUser = 'personShow_androidWithUniqueUser',
  PersonShowIosCount = 'personShow_iosCount',
  PersonShowIosUniqueUser = 'personShow_iosUniqueUser',
  PersonShowIosWithUniqueUser = 'personShow_iosWithUniqueUser',
  PersonShowWebCount = 'personShow_webCount',
  PersonShowWebTeamCount = 'personShow_webTeamCount',
  PersonShowWebTeamUniqueUser = 'personShow_webTeamUniqueUser',
  PersonShowWebTeamWithUniqueUser = 'personShow_webTeamWithUniqueUser',
  PersonShowWebUniqueUser = 'personShow_webUniqueUser',
  PersonShowWebUserCount = 'personShow_webUserCount',
  PersonShowWebUserUniqueUser = 'personShow_webUserUniqueUser',
  PersonShowWebUserWithUniqueUser = 'personShow_webUserWithUniqueUser',
  PersonShowWebWithUniqueUser = 'personShow_webWithUniqueUser',
  PlanningBookmarkAllCount = 'planningBookmark_allCount',
  PlanningBookmarkAllUniqueUser = 'planningBookmark_allUniqueUser',
  PlanningPopularityAllCount = 'planningPopularity_allCount',
  PlanningPopularityAllUniqueUser = 'planningPopularity_allUniqueUser',
  PlanningPopularityAndroidCount = 'planningPopularity_androidCount',
  PlanningPopularityAndroidUniqueUser = 'planningPopularity_androidUniqueUser',
  PlanningPopularityIosCount = 'planningPopularity_iosCount',
  PlanningPopularityIosUniqueUser = 'planningPopularity_iosUniqueUser',
  PlanningPopularityTimestampMax = 'planningPopularity_timestampMax',
  PlanningPopularityTimestampMin = 'planningPopularity_timestampMin',
  PlanningPopularityWebCount = 'planningPopularity_webCount',
  PlanningPopularityWebTeamCount = 'planningPopularity_webTeamCount',
  PlanningPopularityWebTeamUniqueUser = 'planningPopularity_webTeamUniqueUser',
  PlanningPopularityWebUniqueUser = 'planningPopularity_webUniqueUser',
  PlanningPopularityWebUserCount = 'planningPopularity_webUserCount',
  PlanningPopularityWebUserUniqueUser = 'planningPopularity_webUserUniqueUser',
  PlanningStreamStartAllCount = 'planningStreamStart_allCount',
  PlanningStreamStartAllUniqueUser = 'planningStreamStart_allUniqueUser',
  PlanningStreamStartAndroidCount = 'planningStreamStart_androidCount',
  PlanningStreamStartAndroidUniqueUser = 'planningStreamStart_androidUniqueUser',
  PlanningStreamStartIosCount = 'planningStreamStart_iosCount',
  PlanningStreamStartIosUniqueUser = 'planningStreamStart_iosUniqueUser',
  PlanningStreamStartTimestampMax = 'planningStreamStart_timestampMax',
  PlanningStreamStartTimestampMin = 'planningStreamStart_timestampMin',
  PlanningStreamStartWebCount = 'planningStreamStart_webCount',
  PlanningStreamStartWebTeamCount = 'planningStreamStart_webTeamCount',
  PlanningStreamStartWebTeamUniqueUser = 'planningStreamStart_webTeamUniqueUser',
  PlanningStreamStartWebUniqueUser = 'planningStreamStart_webUniqueUser',
  PlanningStreamStartWebUserCount = 'planningStreamStart_webUserCount',
  PlanningStreamStartWebUserUniqueUser = 'planningStreamStart_webUserUniqueUser',
  PlanningStreamStopAllCount = 'planningStreamStop_allCount',
  PlanningStreamStopAllUniqueUser = 'planningStreamStop_allUniqueUser',
  PlanningStreamStopAndroidCount = 'planningStreamStop_androidCount',
  PlanningStreamStopAndroidUniqueUser = 'planningStreamStop_androidUniqueUser',
  PlanningStreamStopDurationAndroidAverage = 'planningStreamStop_durationAndroidAverage',
  PlanningStreamStopDurationAndroidSum = 'planningStreamStop_durationAndroidSum',
  PlanningStreamStopDurationAverage = 'planningStreamStop_durationAverage',
  PlanningStreamStopDurationIosAverage = 'planningStreamStop_durationIosAverage',
  PlanningStreamStopDurationIosSum = 'planningStreamStop_durationIosSum',
  PlanningStreamStopDurationSum = 'planningStreamStop_durationSum',
  PlanningStreamStopDurationWebAverage = 'planningStreamStop_durationWebAverage',
  PlanningStreamStopDurationWebSum = 'planningStreamStop_durationWebSum',
  PlanningStreamStopDurationWebTeamAverage = 'planningStreamStop_durationWebTeamAverage',
  PlanningStreamStopDurationWebTeamSum = 'planningStreamStop_durationWebTeamSum',
  PlanningStreamStopDurationWebUserAverage = 'planningStreamStop_durationWebUserAverage',
  PlanningStreamStopDurationWebUserSum = 'planningStreamStop_durationWebUserSum',
  PlanningStreamStopIosCount = 'planningStreamStop_iosCount',
  PlanningStreamStopIosUniqueUser = 'planningStreamStop_iosUniqueUser',
  PlanningStreamStopTimestampMax = 'planningStreamStop_timestampMax',
  PlanningStreamStopTimestampMin = 'planningStreamStop_timestampMin',
  PlanningStreamStopWebCount = 'planningStreamStop_webCount',
  PlanningStreamStopWebTeamCount = 'planningStreamStop_webTeamCount',
  PlanningStreamStopWebTeamUniqueUser = 'planningStreamStop_webTeamUniqueUser',
  PlanningStreamStopWebUniqueUser = 'planningStreamStop_webUniqueUser',
  PlanningStreamStopWebUserCount = 'planningStreamStop_webUserCount',
  PlanningStreamStopWebUserUniqueUser = 'planningStreamStop_webUserUniqueUser',
  PlanningStreamAllCount = 'planningStream_allCount',
  PlanningStreamAllUniqueUser = 'planningStream_allUniqueUser',
  PlanningStreamAndroidCount = 'planningStream_androidCount',
  PlanningStreamAndroidUniqueUser = 'planningStream_androidUniqueUser',
  PlanningStreamIosCount = 'planningStream_iosCount',
  PlanningStreamIosUniqueUser = 'planningStream_iosUniqueUser',
  PlanningStreamTimestampMax = 'planningStream_timestampMax',
  PlanningStreamTimestampMin = 'planningStream_timestampMin',
  PlanningStreamWebCount = 'planningStream_webCount',
  PlanningStreamWebTeamCount = 'planningStream_webTeamCount',
  PlanningStreamWebTeamUniqueUser = 'planningStream_webTeamUniqueUser',
  PlanningStreamWebUniqueUser = 'planningStream_webUniqueUser',
  PlanningStreamWebUserCount = 'planningStream_webUserCount',
  PlanningStreamWebUserUniqueUser = 'planningStream_webUserUniqueUser',
  PostLinkOpenAllCount = 'postLinkOpen_allCount',
  PostLinkOpenAllUniqueUser = 'postLinkOpen_allUniqueUser',
  PostLinkOpenAndroidCount = 'postLinkOpen_androidCount',
  PostLinkOpenAndroidUniqueUser = 'postLinkOpen_androidUniqueUser',
  PostLinkOpenIosCount = 'postLinkOpen_iosCount',
  PostLinkOpenIosUniqueUser = 'postLinkOpen_iosUniqueUser',
  PostLinkOpenWebCount = 'postLinkOpen_webCount',
  PostLinkOpenWebTeamCount = 'postLinkOpen_webTeamCount',
  PostLinkOpenWebTeamUniqueUser = 'postLinkOpen_webTeamUniqueUser',
  PostLinkOpenWebUniqueUser = 'postLinkOpen_webUniqueUser',
  PostLinkOpenWebUserCount = 'postLinkOpen_webUserCount',
  PostLinkOpenWebUserUniqueUser = 'postLinkOpen_webUserUniqueUser',
  ProductBookmarkAllCount = 'productBookmark_allCount',
  ProductBookmarkAllUniqueUser = 'productBookmark_allUniqueUser',
  ProductBookmarkTimestampMax = 'productBookmark_timestampMax',
  ProductBookmarkTimestampMin = 'productBookmark_timestampMin',
  ProductShowAllCount = 'productShow_allCount',
  ProductShowAllUniqueUser = 'productShow_allUniqueUser',
  ProductShowAndroidCount = 'productShow_androidCount',
  ProductShowAndroidUniqueUser = 'productShow_androidUniqueUser',
  ProductShowIosCount = 'productShow_iosCount',
  ProductShowIosUniqueUser = 'productShow_iosUniqueUser',
  ProductShowTimestampMax = 'productShow_timestampMax',
  ProductShowTimestampMin = 'productShow_timestampMin',
  ProductShowWebCount = 'productShow_webCount',
  ProductShowWebTeamCount = 'productShow_webTeamCount',
  ProductShowWebTeamUniqueUser = 'productShow_webTeamUniqueUser',
  ProductShowWebUniqueUser = 'productShow_webUniqueUser',
  ProductShowWebUserCount = 'productShow_webUserCount',
  ProductShowWebUserUniqueUser = 'productShow_webUserUniqueUser',
  RegistrationAbandonedCount = 'registration_abandonedCount',
  RegistrationAllCount = 'registration_allCount',
  RegistrationCanceledCount = 'registration_canceledCount',
  RegistrationCheckedInCount = 'registration_checkedInCount',
  RegistrationRegisteredCount = 'registration_registeredCount',
  SponsorShowAllCount = 'sponsorShow_allCount',
  SponsorShowAllUniqueUser = 'sponsorShow_allUniqueUser',
  SponsorShowAndroidCount = 'sponsorShow_androidCount',
  SponsorShowAndroidUniqueUser = 'sponsorShow_androidUniqueUser',
  SponsorShowIosCount = 'sponsorShow_iosCount',
  SponsorShowIosUniqueUser = 'sponsorShow_iosUniqueUser',
  SponsorShowTimestampMax = 'sponsorShow_timestampMax',
  SponsorShowTimestampMin = 'sponsorShow_timestampMin',
  SponsorShowWebCount = 'sponsorShow_webCount',
  SponsorShowWebTeamCount = 'sponsorShow_webTeamCount',
  SponsorShowWebTeamUniqueUser = 'sponsorShow_webTeamUniqueUser',
  SponsorShowWebUniqueUser = 'sponsorShow_webUniqueUser',
  SponsorShowWebUserCount = 'sponsorShow_webUserCount',
  SponsorShowWebUserUniqueUser = 'sponsorShow_webUserUniqueUser',
  StreamStartAllCount = 'streamStart_allCount',
  StreamStartAllUniqueUser = 'streamStart_allUniqueUser',
  StreamStartAndroidCount = 'streamStart_androidCount',
  StreamStartAndroidUniqueUser = 'streamStart_androidUniqueUser',
  StreamStartIosCount = 'streamStart_iosCount',
  StreamStartIosUniqueUser = 'streamStart_iosUniqueUser',
  StreamStartTimestampMax = 'streamStart_timestampMax',
  StreamStartTimestampMin = 'streamStart_timestampMin',
  StreamStartWebCount = 'streamStart_webCount',
  StreamStartWebTeamCount = 'streamStart_webTeamCount',
  StreamStartWebTeamUniqueUser = 'streamStart_webTeamUniqueUser',
  StreamStartWebUniqueUser = 'streamStart_webUniqueUser',
  StreamStartWebUserCount = 'streamStart_webUserCount',
  StreamStartWebUserUniqueUser = 'streamStart_webUserUniqueUser',
  StreamStopAllCount = 'streamStop_allCount',
  StreamStopAllUniqueUser = 'streamStop_allUniqueUser',
  StreamStopAndroidCount = 'streamStop_androidCount',
  StreamStopAndroidUniqueUser = 'streamStop_androidUniqueUser',
  StreamStopDurationAndroidAverage = 'streamStop_durationAndroidAverage',
  StreamStopDurationAndroidSum = 'streamStop_durationAndroidSum',
  StreamStopDurationAverage = 'streamStop_durationAverage',
  StreamStopDurationIosAverage = 'streamStop_durationIosAverage',
  StreamStopDurationIosSum = 'streamStop_durationIosSum',
  StreamStopDurationSum = 'streamStop_durationSum',
  StreamStopDurationWebAverage = 'streamStop_durationWebAverage',
  StreamStopDurationWebSum = 'streamStop_durationWebSum',
  StreamStopDurationWebTeamAverage = 'streamStop_durationWebTeamAverage',
  StreamStopDurationWebTeamSum = 'streamStop_durationWebTeamSum',
  StreamStopDurationWebUserAverage = 'streamStop_durationWebUserAverage',
  StreamStopDurationWebUserSum = 'streamStop_durationWebUserSum',
  StreamStopIosCount = 'streamStop_iosCount',
  StreamStopIosUniqueUser = 'streamStop_iosUniqueUser',
  StreamStopTimestampMax = 'streamStop_timestampMax',
  StreamStopTimestampMin = 'streamStop_timestampMin',
  StreamStopWebCount = 'streamStop_webCount',
  StreamStopWebTeamCount = 'streamStop_webTeamCount',
  StreamStopWebTeamUniqueUser = 'streamStop_webTeamUniqueUser',
  StreamStopWebUniqueUser = 'streamStop_webUniqueUser',
  StreamStopWebUserCount = 'streamStop_webUserCount',
  StreamStopWebUserUniqueUser = 'streamStop_webUserUniqueUser',
  UsageAllUniqueUser = 'usage_allUniqueUser',
  UsageAndroidUniqueUser = 'usage_androidUniqueUser',
  UsageIosUniqueUser = 'usage_iosUniqueUser',
  UsageWebTeamUniqueUser = 'usage_webTeamUniqueUser',
  UsageWebUniqueUser = 'usage_webUniqueUser',
  UsageWebUserUniqueUser = 'usage_webUserUniqueUser',
  VideoCallRoomAllCount = 'videoCallRoom_allCount',
  VideoCallRoomAllUniqueUser = 'videoCallRoom_allUniqueUser',
  VideoCallRoomAllWithUniqueUser = 'videoCallRoom_allWithUniqueUser',
  VideoCallRoomSucceededCount = 'videoCallRoom_succeededCount',
  VideoCallRoomSucceededDurationAverage = 'videoCallRoom_succeededDurationAverage',
  VideoCallRoomSucceededDurationSum = 'videoCallRoom_succeededDurationSum',
  VideoCallRoomSucceededUniqueUser = 'videoCallRoom_succeededUniqueUser',
  VideoCallRoomSucceededWithUniqueUser = 'videoCallRoom_succeededWithUniqueUser'
}

export type Analytics_SortGroups = {
  direction: Analytics_SortDirection;
  field: Analytics_SortGroupsField;
  limit?: InputMaybe<Scalars['Int']>;
};

export enum Analytics_SortGroupsField {
  ActivityTimestampMax = 'activity_timestampMax',
  ActivityTimestampMin = 'activity_timestampMin',
  AddOpenAllCount = 'addOpen_allCount',
  AddOpenAllUniqueUser = 'addOpen_allUniqueUser',
  AddOpenAndroidCount = 'addOpen_androidCount',
  AddOpenAndroidUniqueUser = 'addOpen_androidUniqueUser',
  AddOpenIosCount = 'addOpen_iosCount',
  AddOpenIosUniqueUser = 'addOpen_iosUniqueUser',
  AddOpenTimestampMax = 'addOpen_timestampMax',
  AddOpenTimestampMin = 'addOpen_timestampMin',
  AddOpenWebCount = 'addOpen_webCount',
  AddOpenWebTeamCount = 'addOpen_webTeamCount',
  AddOpenWebTeamUniqueUser = 'addOpen_webTeamUniqueUser',
  AddOpenWebUniqueUser = 'addOpen_webUniqueUser',
  AddOpenWebUserCount = 'addOpen_webUserCount',
  AddOpenWebUserUniqueUser = 'addOpen_webUserUniqueUser',
  AdvertisementOpenAllCount = 'advertisementOpen_allCount',
  AdvertisementOpenAllUniqueUser = 'advertisementOpen_allUniqueUser',
  AdvertisementOpenAndroidCount = 'advertisementOpen_androidCount',
  AdvertisementOpenAndroidUniqueUser = 'advertisementOpen_androidUniqueUser',
  AdvertisementOpenIosCount = 'advertisementOpen_iosCount',
  AdvertisementOpenIosUniqueUser = 'advertisementOpen_iosUniqueUser',
  AdvertisementOpenTimestampMax = 'advertisementOpen_timestampMax',
  AdvertisementOpenTimestampMin = 'advertisementOpen_timestampMin',
  AdvertisementOpenWebCount = 'advertisementOpen_webCount',
  AdvertisementOpenWebTeamCount = 'advertisementOpen_webTeamCount',
  AdvertisementOpenWebTeamUniqueUser = 'advertisementOpen_webTeamUniqueUser',
  AdvertisementOpenWebUniqueUser = 'advertisementOpen_webUniqueUser',
  AdvertisementOpenWebUserCount = 'advertisementOpen_webUserCount',
  AdvertisementOpenWebUserUniqueUser = 'advertisementOpen_webUserUniqueUser',
  AdvertisementShowAllCount = 'advertisementShow_allCount',
  AdvertisementShowAllUniqueUser = 'advertisementShow_allUniqueUser',
  AdvertisementShowAndroidCount = 'advertisementShow_androidCount',
  AdvertisementShowAndroidUniqueUser = 'advertisementShow_androidUniqueUser',
  AdvertisementShowDurationAndroidAverage = 'advertisementShow_durationAndroidAverage',
  AdvertisementShowDurationAndroidSum = 'advertisementShow_durationAndroidSum',
  AdvertisementShowDurationAverage = 'advertisementShow_durationAverage',
  AdvertisementShowDurationIosAverage = 'advertisementShow_durationIosAverage',
  AdvertisementShowDurationIosSum = 'advertisementShow_durationIosSum',
  AdvertisementShowDurationSum = 'advertisementShow_durationSum',
  AdvertisementShowDurationWebAverage = 'advertisementShow_durationWebAverage',
  AdvertisementShowDurationWebSum = 'advertisementShow_durationWebSum',
  AdvertisementShowDurationWebTeamAverage = 'advertisementShow_durationWebTeamAverage',
  AdvertisementShowDurationWebTeamSum = 'advertisementShow_durationWebTeamSum',
  AdvertisementShowDurationWebUserAverage = 'advertisementShow_durationWebUserAverage',
  AdvertisementShowDurationWebUserSum = 'advertisementShow_durationWebUserSum',
  AdvertisementShowIosCount = 'advertisementShow_iosCount',
  AdvertisementShowIosUniqueUser = 'advertisementShow_iosUniqueUser',
  AdvertisementShowWebCount = 'advertisementShow_webCount',
  AdvertisementShowWebTeamCount = 'advertisementShow_webTeamCount',
  AdvertisementShowWebTeamUniqueUser = 'advertisementShow_webTeamUniqueUser',
  AdvertisementShowWebUniqueUser = 'advertisementShow_webUniqueUser',
  AdvertisementShowWebUserCount = 'advertisementShow_webUserCount',
  AdvertisementShowWebUserUniqueUser = 'advertisementShow_webUserUniqueUser',
  BookmarkReceiveAllCount = 'bookmarkReceive_allCount',
  BookmarkReceiveAllUniqueUser = 'bookmarkReceive_allUniqueUser',
  BookmarkReceiveTimestampMax = 'bookmarkReceive_timestampMax',
  BookmarkReceiveTimestampMin = 'bookmarkReceive_timestampMin',
  BookmarkAllCount = 'bookmark_allCount',
  BookmarkAllUniqueUser = 'bookmark_allUniqueUser',
  BookmarkTimestampMax = 'bookmark_timestampMax',
  BookmarkTimestampMin = 'bookmark_timestampMin',
  ChannelOpenAllCount = 'channelOpen_allCount',
  ChannelOpenAllUniqueUser = 'channelOpen_allUniqueUser',
  ChannelOpenAndroidCount = 'channelOpen_androidCount',
  ChannelOpenAndroidUniqueUser = 'channelOpen_androidUniqueUser',
  ChannelOpenIosCount = 'channelOpen_iosCount',
  ChannelOpenIosUniqueUser = 'channelOpen_iosUniqueUser',
  ChannelOpenWebCount = 'channelOpen_webCount',
  ChannelOpenWebTeamCount = 'channelOpen_webTeamCount',
  ChannelOpenWebTeamUniqueUser = 'channelOpen_webTeamUniqueUser',
  ChannelOpenWebUniqueUser = 'channelOpen_webUniqueUser',
  ChannelOpenWebUserCount = 'channelOpen_webUserCount',
  ChannelOpenWebUserUniqueUser = 'channelOpen_webUserUniqueUser',
  ConnectionReceiveAllCount = 'connectionReceive_allCount',
  ConnectionReceiveAllUnique = 'connectionReceive_allUnique',
  ConnectionReceiveAllUniqueUser = 'connectionReceive_allUniqueUser',
  ConnectionReceiveAllWithUniqueUser = 'connectionReceive_allWithUniqueUser',
  ConnectionReceiveNotScanCount = 'connectionReceive_notScanCount',
  ConnectionReceiveNotScanUnique = 'connectionReceive_notScanUnique',
  ConnectionReceiveNotScanUniqueUser = 'connectionReceive_notScanUniqueUser',
  ConnectionReceiveNotScanWithUniqueUser = 'connectionReceive_notScanWithUniqueUser',
  ConnectionReceiveScanCount = 'connectionReceive_scanCount',
  ConnectionReceiveScanUnique = 'connectionReceive_scanUnique',
  ConnectionReceiveScanUniqueUser = 'connectionReceive_scanUniqueUser',
  ConnectionReceiveScanWithUniqueUser = 'connectionReceive_scanWithUniqueUser',
  ConnectionReceiveScoreAverage = 'connectionReceive_scoreAverage',
  ConnectionReceiveScoreCount = 'connectionReceive_scoreCount',
  ConnectionReceiveScoreUnique = 'connectionReceive_scoreUnique',
  ConnectionReceiveScoreUniqueUser = 'connectionReceive_scoreUniqueUser',
  ConnectionReceiveScoreWithUniqueUser = 'connectionReceive_scoreWithUniqueUser',
  ConnectionRequestReceiveAcceptedCount = 'connectionRequestReceive_acceptedCount',
  ConnectionRequestReceiveAcceptedUniqueUser = 'connectionRequestReceive_acceptedUniqueUser',
  ConnectionRequestReceiveAcceptedWithUniqueUser = 'connectionRequestReceive_acceptedWithUniqueUser',
  ConnectionRequestReceiveAllCount = 'connectionRequestReceive_allCount',
  ConnectionRequestReceiveAllUniqueUser = 'connectionRequestReceive_allUniqueUser',
  ConnectionRequestReceiveAllWithUniqueUser = 'connectionRequestReceive_allWithUniqueUser',
  ConnectionRequestReceiveDeclinedCount = 'connectionRequestReceive_declinedCount',
  ConnectionRequestReceiveDeclinedUniqueUser = 'connectionRequestReceive_declinedUniqueUser',
  ConnectionRequestReceiveDeclinedWithUniqueUser = 'connectionRequestReceive_declinedWithUniqueUser',
  ConnectionRequestReceivePendingCount = 'connectionRequestReceive_pendingCount',
  ConnectionRequestReceivePendingUniqueUser = 'connectionRequestReceive_pendingUniqueUser',
  ConnectionRequestReceivePendingWithUniqueUser = 'connectionRequestReceive_pendingWithUniqueUser',
  ConnectionRequestAcceptedCount = 'connectionRequest_acceptedCount',
  ConnectionRequestAcceptedUniqueUser = 'connectionRequest_acceptedUniqueUser',
  ConnectionRequestAcceptedWithUniqueUser = 'connectionRequest_acceptedWithUniqueUser',
  ConnectionRequestAllCount = 'connectionRequest_allCount',
  ConnectionRequestAllUniqueUser = 'connectionRequest_allUniqueUser',
  ConnectionRequestAllWithUniqueUser = 'connectionRequest_allWithUniqueUser',
  ConnectionRequestDeclinedCount = 'connectionRequest_declinedCount',
  ConnectionRequestDeclinedUniqueUser = 'connectionRequest_declinedUniqueUser',
  ConnectionRequestDeclinedWithUniqueUser = 'connectionRequest_declinedWithUniqueUser',
  ConnectionRequestPendingCount = 'connectionRequest_pendingCount',
  ConnectionRequestPendingUniqueUser = 'connectionRequest_pendingUniqueUser',
  ConnectionRequestPendingWithUniqueUser = 'connectionRequest_pendingWithUniqueUser',
  ConnectionAllCount = 'connection_allCount',
  ConnectionAllUnique = 'connection_allUnique',
  ConnectionAllUniqueUser = 'connection_allUniqueUser',
  ConnectionAllWithUniqueUser = 'connection_allWithUniqueUser',
  ConnectionNotScanCount = 'connection_notScanCount',
  ConnectionNotScanUnique = 'connection_notScanUnique',
  ConnectionNotScanUniqueUser = 'connection_notScanUniqueUser',
  ConnectionNotScanWithUniqueUser = 'connection_notScanWithUniqueUser',
  ConnectionScanCount = 'connection_scanCount',
  ConnectionScanUnique = 'connection_scanUnique',
  ConnectionScanUniqueUser = 'connection_scanUniqueUser',
  ConnectionScanWithUniqueUser = 'connection_scanWithUniqueUser',
  ConnectionScoreAverage = 'connection_scoreAverage',
  ConnectionScoreCount = 'connection_scoreCount',
  ConnectionScoreUnique = 'connection_scoreUnique',
  ConnectionScoreUniqueUser = 'connection_scoreUniqueUser',
  ConnectionScoreWithUniqueUser = 'connection_scoreWithUniqueUser',
  ContactAllCount = 'contact_allCount',
  ContactAllUniqueUser = 'contact_allUniqueUser',
  ContactNotScanCount = 'contact_notScanCount',
  ContactNotScanUniqueUser = 'contact_notScanUniqueUser',
  ContactScanCount = 'contact_scanCount',
  ContactScanUniqueUser = 'contact_scanUniqueUser',
  DocumentOpenAllCount = 'documentOpen_allCount',
  DocumentOpenAllUniqueUser = 'documentOpen_allUniqueUser',
  DocumentOpenTimestampMax = 'documentOpen_timestampMax',
  DocumentOpenTimestampMin = 'documentOpen_timestampMin',
  EventShowAllCount = 'eventShow_allCount',
  EventShowAllUniqueUser = 'eventShow_allUniqueUser',
  EventShowAndroidCount = 'eventShow_androidCount',
  EventShowAndroidUniqueUser = 'eventShow_androidUniqueUser',
  EventShowIosCount = 'eventShow_iosCount',
  EventShowIosUniqueUser = 'eventShow_iosUniqueUser',
  EventShowWebCount = 'eventShow_webCount',
  EventShowWebTeamCount = 'eventShow_webTeamCount',
  EventShowWebTeamUniqueUser = 'eventShow_webTeamUniqueUser',
  EventShowWebUniqueUser = 'eventShow_webUniqueUser',
  EventShowWebUserCount = 'eventShow_webUserCount',
  EventShowWebUserUniqueUser = 'eventShow_webUserUniqueUser',
  EventViewShowAllCount = 'eventViewShow_allCount',
  EventViewShowAllUniqueUser = 'eventViewShow_allUniqueUser',
  EventViewShowAndroidCount = 'eventViewShow_androidCount',
  EventViewShowAndroidUniqueUser = 'eventViewShow_androidUniqueUser',
  EventViewShowIosCount = 'eventViewShow_iosCount',
  EventViewShowIosUniqueUser = 'eventViewShow_iosUniqueUser',
  EventViewShowWebCount = 'eventViewShow_webCount',
  EventViewShowWebTeamCount = 'eventViewShow_webTeamCount',
  EventViewShowWebTeamUniqueUser = 'eventViewShow_webTeamUniqueUser',
  EventViewShowWebUniqueUser = 'eventViewShow_webUniqueUser',
  EventViewShowWebUserCount = 'eventViewShow_webUserCount',
  EventViewShowWebUserUniqueUser = 'eventViewShow_webUserUniqueUser',
  ExhibitorAdvertisementOpenReceiveAllCount = 'exhibitorAdvertisementOpenReceive_allCount',
  ExhibitorAdvertisementOpenReceiveAllUniqueUser = 'exhibitorAdvertisementOpenReceive_allUniqueUser',
  ExhibitorAdvertisementOpenReceiveAndroidCount = 'exhibitorAdvertisementOpenReceive_androidCount',
  ExhibitorAdvertisementOpenReceiveAndroidUniqueUser = 'exhibitorAdvertisementOpenReceive_androidUniqueUser',
  ExhibitorAdvertisementOpenReceiveIosCount = 'exhibitorAdvertisementOpenReceive_iosCount',
  ExhibitorAdvertisementOpenReceiveIosUniqueUser = 'exhibitorAdvertisementOpenReceive_iosUniqueUser',
  ExhibitorAdvertisementOpenReceiveTimestampMax = 'exhibitorAdvertisementOpenReceive_timestampMax',
  ExhibitorAdvertisementOpenReceiveTimestampMin = 'exhibitorAdvertisementOpenReceive_timestampMin',
  ExhibitorAdvertisementOpenReceiveWebCount = 'exhibitorAdvertisementOpenReceive_webCount',
  ExhibitorAdvertisementOpenReceiveWebTeamCount = 'exhibitorAdvertisementOpenReceive_webTeamCount',
  ExhibitorAdvertisementOpenReceiveWebTeamUniqueUser = 'exhibitorAdvertisementOpenReceive_webTeamUniqueUser',
  ExhibitorAdvertisementOpenReceiveWebUniqueUser = 'exhibitorAdvertisementOpenReceive_webUniqueUser',
  ExhibitorAdvertisementOpenReceiveWebUserCount = 'exhibitorAdvertisementOpenReceive_webUserCount',
  ExhibitorAdvertisementOpenReceiveWebUserUniqueUser = 'exhibitorAdvertisementOpenReceive_webUserUniqueUser',
  ExhibitorAdvertisementOpenAllCount = 'exhibitorAdvertisementOpen_allCount',
  ExhibitorAdvertisementOpenAllUniqueUser = 'exhibitorAdvertisementOpen_allUniqueUser',
  ExhibitorAdvertisementOpenAndroidCount = 'exhibitorAdvertisementOpen_androidCount',
  ExhibitorAdvertisementOpenAndroidUniqueUser = 'exhibitorAdvertisementOpen_androidUniqueUser',
  ExhibitorAdvertisementOpenIosCount = 'exhibitorAdvertisementOpen_iosCount',
  ExhibitorAdvertisementOpenIosUniqueUser = 'exhibitorAdvertisementOpen_iosUniqueUser',
  ExhibitorAdvertisementOpenTimestampMax = 'exhibitorAdvertisementOpen_timestampMax',
  ExhibitorAdvertisementOpenTimestampMin = 'exhibitorAdvertisementOpen_timestampMin',
  ExhibitorAdvertisementOpenWebCount = 'exhibitorAdvertisementOpen_webCount',
  ExhibitorAdvertisementOpenWebTeamCount = 'exhibitorAdvertisementOpen_webTeamCount',
  ExhibitorAdvertisementOpenWebTeamUniqueUser = 'exhibitorAdvertisementOpen_webTeamUniqueUser',
  ExhibitorAdvertisementOpenWebUniqueUser = 'exhibitorAdvertisementOpen_webUniqueUser',
  ExhibitorAdvertisementOpenWebUserCount = 'exhibitorAdvertisementOpen_webUserCount',
  ExhibitorAdvertisementOpenWebUserUniqueUser = 'exhibitorAdvertisementOpen_webUserUniqueUser',
  ExhibitorAdvertisementShowReceiveAllCount = 'exhibitorAdvertisementShowReceive_allCount',
  ExhibitorAdvertisementShowReceiveAllUniqueUser = 'exhibitorAdvertisementShowReceive_allUniqueUser',
  ExhibitorAdvertisementShowReceiveAndroidCount = 'exhibitorAdvertisementShowReceive_androidCount',
  ExhibitorAdvertisementShowReceiveAndroidUniqueUser = 'exhibitorAdvertisementShowReceive_androidUniqueUser',
  ExhibitorAdvertisementShowReceiveIosCount = 'exhibitorAdvertisementShowReceive_iosCount',
  ExhibitorAdvertisementShowReceiveIosUniqueUser = 'exhibitorAdvertisementShowReceive_iosUniqueUser',
  ExhibitorAdvertisementShowReceiveTimestampMax = 'exhibitorAdvertisementShowReceive_timestampMax',
  ExhibitorAdvertisementShowReceiveTimestampMin = 'exhibitorAdvertisementShowReceive_timestampMin',
  ExhibitorAdvertisementShowReceiveWebCount = 'exhibitorAdvertisementShowReceive_webCount',
  ExhibitorAdvertisementShowReceiveWebTeamCount = 'exhibitorAdvertisementShowReceive_webTeamCount',
  ExhibitorAdvertisementShowReceiveWebTeamUniqueUser = 'exhibitorAdvertisementShowReceive_webTeamUniqueUser',
  ExhibitorAdvertisementShowReceiveWebUniqueUser = 'exhibitorAdvertisementShowReceive_webUniqueUser',
  ExhibitorAdvertisementShowReceiveWebUserCount = 'exhibitorAdvertisementShowReceive_webUserCount',
  ExhibitorAdvertisementShowReceiveWebUserUniqueUser = 'exhibitorAdvertisementShowReceive_webUserUniqueUser',
  ExhibitorAdvertisementShowAllCount = 'exhibitorAdvertisementShow_allCount',
  ExhibitorAdvertisementShowAllUniqueUser = 'exhibitorAdvertisementShow_allUniqueUser',
  ExhibitorAdvertisementShowAndroidCount = 'exhibitorAdvertisementShow_androidCount',
  ExhibitorAdvertisementShowAndroidUniqueUser = 'exhibitorAdvertisementShow_androidUniqueUser',
  ExhibitorAdvertisementShowIosCount = 'exhibitorAdvertisementShow_iosCount',
  ExhibitorAdvertisementShowIosUniqueUser = 'exhibitorAdvertisementShow_iosUniqueUser',
  ExhibitorAdvertisementShowTimestampMax = 'exhibitorAdvertisementShow_timestampMax',
  ExhibitorAdvertisementShowTimestampMin = 'exhibitorAdvertisementShow_timestampMin',
  ExhibitorAdvertisementShowWebCount = 'exhibitorAdvertisementShow_webCount',
  ExhibitorAdvertisementShowWebTeamCount = 'exhibitorAdvertisementShow_webTeamCount',
  ExhibitorAdvertisementShowWebTeamUniqueUser = 'exhibitorAdvertisementShow_webTeamUniqueUser',
  ExhibitorAdvertisementShowWebUniqueUser = 'exhibitorAdvertisementShow_webUniqueUser',
  ExhibitorAdvertisementShowWebUserCount = 'exhibitorAdvertisementShow_webUserCount',
  ExhibitorAdvertisementShowWebUserUniqueUser = 'exhibitorAdvertisementShow_webUserUniqueUser',
  ExhibitorBookmarkReceiveAllCount = 'exhibitorBookmarkReceive_allCount',
  ExhibitorBookmarkReceiveAllUniqueUser = 'exhibitorBookmarkReceive_allUniqueUser',
  ExhibitorBookmarkReceiveTimestampMax = 'exhibitorBookmarkReceive_timestampMax',
  ExhibitorBookmarkReceiveTimestampMin = 'exhibitorBookmarkReceive_timestampMin',
  ExhibitorBookmarkAllCount = 'exhibitorBookmark_allCount',
  ExhibitorBookmarkAllUniqueUser = 'exhibitorBookmark_allUniqueUser',
  ExhibitorBookmarkTimestampMax = 'exhibitorBookmark_timestampMax',
  ExhibitorBookmarkTimestampMin = 'exhibitorBookmark_timestampMin',
  ExhibitorPopularityAllCount = 'exhibitorPopularity_allCount',
  ExhibitorPopularityAllUniqueUser = 'exhibitorPopularity_allUniqueUser',
  ExhibitorPopularityAndroidCount = 'exhibitorPopularity_androidCount',
  ExhibitorPopularityAndroidUniqueUser = 'exhibitorPopularity_androidUniqueUser',
  ExhibitorPopularityIosCount = 'exhibitorPopularity_iosCount',
  ExhibitorPopularityIosUniqueUser = 'exhibitorPopularity_iosUniqueUser',
  ExhibitorPopularityTimestampMax = 'exhibitorPopularity_timestampMax',
  ExhibitorPopularityTimestampMin = 'exhibitorPopularity_timestampMin',
  ExhibitorPopularityWebCount = 'exhibitorPopularity_webCount',
  ExhibitorPopularityWebTeamCount = 'exhibitorPopularity_webTeamCount',
  ExhibitorPopularityWebTeamUniqueUser = 'exhibitorPopularity_webTeamUniqueUser',
  ExhibitorPopularityWebUniqueUser = 'exhibitorPopularity_webUniqueUser',
  ExhibitorPopularityWebUserCount = 'exhibitorPopularity_webUserCount',
  ExhibitorPopularityWebUserUniqueUser = 'exhibitorPopularity_webUserUniqueUser',
  ExhibitorSelfShowAllCount = 'exhibitorSelfShow_allCount',
  ExhibitorSelfShowAllUniqueUser = 'exhibitorSelfShow_allUniqueUser',
  ExhibitorSelfShowAndroidCount = 'exhibitorSelfShow_androidCount',
  ExhibitorSelfShowAndroidUniqueUser = 'exhibitorSelfShow_androidUniqueUser',
  ExhibitorSelfShowIosCount = 'exhibitorSelfShow_iosCount',
  ExhibitorSelfShowIosUniqueUser = 'exhibitorSelfShow_iosUniqueUser',
  ExhibitorSelfShowWebCount = 'exhibitorSelfShow_webCount',
  ExhibitorSelfShowWebTeamCount = 'exhibitorSelfShow_webTeamCount',
  ExhibitorSelfShowWebTeamUniqueUser = 'exhibitorSelfShow_webTeamUniqueUser',
  ExhibitorSelfShowWebUniqueUser = 'exhibitorSelfShow_webUniqueUser',
  ExhibitorSelfShowWebUserCount = 'exhibitorSelfShow_webUserCount',
  ExhibitorSelfShowWebUserUniqueUser = 'exhibitorSelfShow_webUserUniqueUser',
  ExhibitorShowReceiveAllCount = 'exhibitorShowReceive_allCount',
  ExhibitorShowReceiveAllUniqueUser = 'exhibitorShowReceive_allUniqueUser',
  ExhibitorShowReceiveAndroidCount = 'exhibitorShowReceive_androidCount',
  ExhibitorShowReceiveAndroidUniqueUser = 'exhibitorShowReceive_androidUniqueUser',
  ExhibitorShowReceiveIosCount = 'exhibitorShowReceive_iosCount',
  ExhibitorShowReceiveIosUniqueUser = 'exhibitorShowReceive_iosUniqueUser',
  ExhibitorShowReceiveTimestampMax = 'exhibitorShowReceive_timestampMax',
  ExhibitorShowReceiveTimestampMin = 'exhibitorShowReceive_timestampMin',
  ExhibitorShowReceiveWebCount = 'exhibitorShowReceive_webCount',
  ExhibitorShowReceiveWebTeamCount = 'exhibitorShowReceive_webTeamCount',
  ExhibitorShowReceiveWebTeamUniqueUser = 'exhibitorShowReceive_webTeamUniqueUser',
  ExhibitorShowReceiveWebUniqueUser = 'exhibitorShowReceive_webUniqueUser',
  ExhibitorShowReceiveWebUserCount = 'exhibitorShowReceive_webUserCount',
  ExhibitorShowReceiveWebUserUniqueUser = 'exhibitorShowReceive_webUserUniqueUser',
  ExhibitorShowAllCount = 'exhibitorShow_allCount',
  ExhibitorShowAllUniqueUser = 'exhibitorShow_allUniqueUser',
  ExhibitorShowAndroidCount = 'exhibitorShow_androidCount',
  ExhibitorShowAndroidUniqueUser = 'exhibitorShow_androidUniqueUser',
  ExhibitorShowIosCount = 'exhibitorShow_iosCount',
  ExhibitorShowIosUniqueUser = 'exhibitorShow_iosUniqueUser',
  ExhibitorShowTimestampMax = 'exhibitorShow_timestampMax',
  ExhibitorShowTimestampMin = 'exhibitorShow_timestampMin',
  ExhibitorShowWebCount = 'exhibitorShow_webCount',
  ExhibitorShowWebTeamCount = 'exhibitorShow_webTeamCount',
  ExhibitorShowWebTeamUniqueUser = 'exhibitorShow_webTeamUniqueUser',
  ExhibitorShowWebUniqueUser = 'exhibitorShow_webUniqueUser',
  ExhibitorShowWebUserCount = 'exhibitorShow_webUserCount',
  ExhibitorShowWebUserUniqueUser = 'exhibitorShow_webUserUniqueUser',
  InterstitialAddShowAllCount = 'interstitialAddShow_allCount',
  InterstitialAddShowAllUniqueUser = 'interstitialAddShow_allUniqueUser',
  InterstitialAddShowAndroidCount = 'interstitialAddShow_androidCount',
  InterstitialAddShowAndroidUniqueUser = 'interstitialAddShow_androidUniqueUser',
  InterstitialAddShowDurationAndroidAverage = 'interstitialAddShow_durationAndroidAverage',
  InterstitialAddShowDurationAndroidSum = 'interstitialAddShow_durationAndroidSum',
  InterstitialAddShowDurationAverage = 'interstitialAddShow_durationAverage',
  InterstitialAddShowDurationIosAverage = 'interstitialAddShow_durationIosAverage',
  InterstitialAddShowDurationIosSum = 'interstitialAddShow_durationIosSum',
  InterstitialAddShowDurationSum = 'interstitialAddShow_durationSum',
  InterstitialAddShowDurationWebAverage = 'interstitialAddShow_durationWebAverage',
  InterstitialAddShowDurationWebSum = 'interstitialAddShow_durationWebSum',
  InterstitialAddShowDurationWebTeamAverage = 'interstitialAddShow_durationWebTeamAverage',
  InterstitialAddShowDurationWebTeamSum = 'interstitialAddShow_durationWebTeamSum',
  InterstitialAddShowDurationWebUserAverage = 'interstitialAddShow_durationWebUserAverage',
  InterstitialAddShowDurationWebUserSum = 'interstitialAddShow_durationWebUserSum',
  InterstitialAddShowIosCount = 'interstitialAddShow_iosCount',
  InterstitialAddShowIosUniqueUser = 'interstitialAddShow_iosUniqueUser',
  InterstitialAddShowWebCount = 'interstitialAddShow_webCount',
  InterstitialAddShowWebTeamCount = 'interstitialAddShow_webTeamCount',
  InterstitialAddShowWebTeamUniqueUser = 'interstitialAddShow_webTeamUniqueUser',
  InterstitialAddShowWebUniqueUser = 'interstitialAddShow_webUniqueUser',
  InterstitialAddShowWebUserCount = 'interstitialAddShow_webUserCount',
  InterstitialAddShowWebUserUniqueUser = 'interstitialAddShow_webUserUniqueUser',
  MeetingParticipantAllCount = 'meetingParticipant_allCount',
  MeetingParticipantAllUnique = 'meetingParticipant_allUnique',
  MeetingParticipantAllUniqueUser = 'meetingParticipant_allUniqueUser',
  MeetingParticipantCanceledCount = 'meetingParticipant_canceledCount',
  MeetingParticipantCanceledUnique = 'meetingParticipant_canceledUnique',
  MeetingParticipantCanceledUniqueUser = 'meetingParticipant_canceledUniqueUser',
  MeetingParticipantConfirmedCount = 'meetingParticipant_confirmedCount',
  MeetingParticipantConfirmedUnique = 'meetingParticipant_confirmedUnique',
  MeetingParticipantConfirmedUniqueUser = 'meetingParticipant_confirmedUniqueUser',
  MeetingParticipantDeclinedCount = 'meetingParticipant_declinedCount',
  MeetingParticipantDeclinedUnique = 'meetingParticipant_declinedUnique',
  MeetingParticipantDeclinedUniqueUser = 'meetingParticipant_declinedUniqueUser',
  MeetingParticipantExpiredCount = 'meetingParticipant_expiredCount',
  MeetingParticipantExpiredUnique = 'meetingParticipant_expiredUnique',
  MeetingParticipantExpiredUniqueUser = 'meetingParticipant_expiredUniqueUser',
  MeetingParticipantNoShowCount = 'meetingParticipant_noShowCount',
  MeetingParticipantNoShowUnique = 'meetingParticipant_noShowUnique',
  MeetingParticipantNoShowUniqueUser = 'meetingParticipant_noShowUniqueUser',
  MeetingParticipantPendingCount = 'meetingParticipant_pendingCount',
  MeetingParticipantPendingUnique = 'meetingParticipant_pendingUnique',
  MeetingParticipantPendingUniqueUser = 'meetingParticipant_pendingUniqueUser',
  MeetingRequestReceiveAcceptedCount = 'meetingRequestReceive_acceptedCount',
  MeetingRequestReceiveAcceptedUniqueUser = 'meetingRequestReceive_acceptedUniqueUser',
  MeetingRequestReceiveAcceptedWithUniqueUser = 'meetingRequestReceive_acceptedWithUniqueUser',
  MeetingRequestReceiveAllCount = 'meetingRequestReceive_allCount',
  MeetingRequestReceiveAllUniqueUser = 'meetingRequestReceive_allUniqueUser',
  MeetingRequestReceiveAllWithUniqueUser = 'meetingRequestReceive_allWithUniqueUser',
  MeetingRequestReceiveCancelledCount = 'meetingRequestReceive_cancelledCount',
  MeetingRequestReceiveCancelledUniqueUser = 'meetingRequestReceive_cancelledUniqueUser',
  MeetingRequestReceiveCancelledWithUniqueUser = 'meetingRequestReceive_cancelledWithUniqueUser',
  MeetingRequestReceiveDeclinedCount = 'meetingRequestReceive_declinedCount',
  MeetingRequestReceiveDeclinedUniqueUser = 'meetingRequestReceive_declinedUniqueUser',
  MeetingRequestReceiveDeclinedWithUniqueUser = 'meetingRequestReceive_declinedWithUniqueUser',
  MeetingRequestReceiveExpiredCount = 'meetingRequestReceive_expiredCount',
  MeetingRequestReceiveExpiredUniqueUser = 'meetingRequestReceive_expiredUniqueUser',
  MeetingRequestReceiveExpiredWithUniqueUser = 'meetingRequestReceive_expiredWithUniqueUser',
  MeetingRequestReceivePendingCount = 'meetingRequestReceive_pendingCount',
  MeetingRequestReceivePendingUniqueUser = 'meetingRequestReceive_pendingUniqueUser',
  MeetingRequestReceivePendingWithUniqueUser = 'meetingRequestReceive_pendingWithUniqueUser',
  MeetingRequestAcceptedCount = 'meetingRequest_acceptedCount',
  MeetingRequestAcceptedUniqueUser = 'meetingRequest_acceptedUniqueUser',
  MeetingRequestAcceptedWithUniqueUser = 'meetingRequest_acceptedWithUniqueUser',
  MeetingRequestAllCount = 'meetingRequest_allCount',
  MeetingRequestAllUniqueUser = 'meetingRequest_allUniqueUser',
  MeetingRequestAllWithUniqueUser = 'meetingRequest_allWithUniqueUser',
  MeetingRequestCancelledCount = 'meetingRequest_cancelledCount',
  MeetingRequestCancelledUniqueUser = 'meetingRequest_cancelledUniqueUser',
  MeetingRequestCancelledWithUniqueUser = 'meetingRequest_cancelledWithUniqueUser',
  MeetingRequestDeclinedCount = 'meetingRequest_declinedCount',
  MeetingRequestDeclinedUniqueUser = 'meetingRequest_declinedUniqueUser',
  MeetingRequestDeclinedWithUniqueUser = 'meetingRequest_declinedWithUniqueUser',
  MeetingRequestExpiredCount = 'meetingRequest_expiredCount',
  MeetingRequestExpiredUniqueUser = 'meetingRequest_expiredUniqueUser',
  MeetingRequestExpiredWithUniqueUser = 'meetingRequest_expiredWithUniqueUser',
  MeetingRequestPendingCount = 'meetingRequest_pendingCount',
  MeetingRequestPendingUniqueUser = 'meetingRequest_pendingUniqueUser',
  MeetingRequestPendingWithUniqueUser = 'meetingRequest_pendingWithUniqueUser',
  MeetingAllCount = 'meeting_allCount',
  MeetingAllUnique = 'meeting_allUnique',
  MeetingAllUniqueUser = 'meeting_allUniqueUser',
  MeetingCanceledCount = 'meeting_canceledCount',
  MeetingCanceledUnique = 'meeting_canceledUnique',
  MeetingCanceledUniqueUser = 'meeting_canceledUniqueUser',
  MeetingConfirmedCount = 'meeting_confirmedCount',
  MeetingConfirmedUnique = 'meeting_confirmedUnique',
  MeetingConfirmedUniqueUser = 'meeting_confirmedUniqueUser',
  MeetingDeclinedCount = 'meeting_declinedCount',
  MeetingDeclinedUnique = 'meeting_declinedUnique',
  MeetingDeclinedUniqueUser = 'meeting_declinedUniqueUser',
  MeetingExpiredCount = 'meeting_expiredCount',
  MeetingExpiredUnique = 'meeting_expiredUnique',
  MeetingExpiredUniqueUser = 'meeting_expiredUniqueUser',
  MeetingNoShowCount = 'meeting_noShowCount',
  MeetingNoShowUnique = 'meeting_noShowUnique',
  MeetingNoShowUniqueUser = 'meeting_noShowUniqueUser',
  MeetingPendingCount = 'meeting_pendingCount',
  MeetingPendingUnique = 'meeting_pendingUnique',
  MeetingPendingUniqueUser = 'meeting_pendingUniqueUser',
  MeetingRescheduledCount = 'meeting_rescheduledCount',
  MeetingRescheduledUnique = 'meeting_rescheduledUnique',
  MeetingRescheduledUniqueUser = 'meeting_rescheduledUniqueUser',
  MessageReceiveAllCount = 'messageReceive_allCount',
  MessageReceiveAllUniqueUser = 'messageReceive_allUniqueUser',
  MessageReceiveChannelUnique = 'messageReceive_channelUnique',
  MessageReceivePrivateCount = 'messageReceive_privateCount',
  MessageReceivePrivateUniqueUser = 'messageReceive_privateUniqueUser',
  MessageReceivePrivateWithUniqueUser = 'messageReceive_privateWithUniqueUser',
  MessageReceivePublicCount = 'messageReceive_publicCount',
  MessageReceivePublicUniqueUser = 'messageReceive_publicUniqueUser',
  MessageAllCount = 'message_allCount',
  MessageAllUniqueUser = 'message_allUniqueUser',
  MessageChannelUnique = 'message_channelUnique',
  MessagePrivateCount = 'message_privateCount',
  MessagePrivateUniqueUser = 'message_privateUniqueUser',
  MessagePrivateWithUniqueUser = 'message_privateWithUniqueUser',
  MessagePublicCount = 'message_publicCount',
  MessagePublicUniqueUser = 'message_publicUniqueUser',
  NetworkActivityAllCount = 'networkActivity_allCount',
  NetworkActivityAllUnique = 'networkActivity_allUnique',
  NetworkActivityAllUniqueUser = 'networkActivity_allUniqueUser',
  NetworkActivityAllWithUniqueUser = 'networkActivity_allWithUniqueUser',
  PersonShowReceiveAllCount = 'personShowReceive_allCount',
  PersonShowReceiveAllUniqueUser = 'personShowReceive_allUniqueUser',
  PersonShowReceiveAllWithUniqueUser = 'personShowReceive_allWithUniqueUser',
  PersonShowReceiveAndroidCount = 'personShowReceive_androidCount',
  PersonShowReceiveAndroidUniqueUser = 'personShowReceive_androidUniqueUser',
  PersonShowReceiveAndroidWithUniqueUser = 'personShowReceive_androidWithUniqueUser',
  PersonShowReceiveIosCount = 'personShowReceive_iosCount',
  PersonShowReceiveIosUniqueUser = 'personShowReceive_iosUniqueUser',
  PersonShowReceiveIosWithUniqueUser = 'personShowReceive_iosWithUniqueUser',
  PersonShowReceiveWebCount = 'personShowReceive_webCount',
  PersonShowReceiveWebTeamCount = 'personShowReceive_webTeamCount',
  PersonShowReceiveWebTeamUniqueUser = 'personShowReceive_webTeamUniqueUser',
  PersonShowReceiveWebTeamWithUniqueUser = 'personShowReceive_webTeamWithUniqueUser',
  PersonShowReceiveWebUniqueUser = 'personShowReceive_webUniqueUser',
  PersonShowReceiveWebUserCount = 'personShowReceive_webUserCount',
  PersonShowReceiveWebUserUniqueUser = 'personShowReceive_webUserUniqueUser',
  PersonShowReceiveWebUserWithUniqueUser = 'personShowReceive_webUserWithUniqueUser',
  PersonShowReceiveWebWithUniqueUser = 'personShowReceive_webWithUniqueUser',
  PersonShowAllCount = 'personShow_allCount',
  PersonShowAllUniqueUser = 'personShow_allUniqueUser',
  PersonShowAllWithUniqueUser = 'personShow_allWithUniqueUser',
  PersonShowAndroidCount = 'personShow_androidCount',
  PersonShowAndroidUniqueUser = 'personShow_androidUniqueUser',
  PersonShowAndroidWithUniqueUser = 'personShow_androidWithUniqueUser',
  PersonShowIosCount = 'personShow_iosCount',
  PersonShowIosUniqueUser = 'personShow_iosUniqueUser',
  PersonShowIosWithUniqueUser = 'personShow_iosWithUniqueUser',
  PersonShowWebCount = 'personShow_webCount',
  PersonShowWebTeamCount = 'personShow_webTeamCount',
  PersonShowWebTeamUniqueUser = 'personShow_webTeamUniqueUser',
  PersonShowWebTeamWithUniqueUser = 'personShow_webTeamWithUniqueUser',
  PersonShowWebUniqueUser = 'personShow_webUniqueUser',
  PersonShowWebUserCount = 'personShow_webUserCount',
  PersonShowWebUserUniqueUser = 'personShow_webUserUniqueUser',
  PersonShowWebUserWithUniqueUser = 'personShow_webUserWithUniqueUser',
  PersonShowWebWithUniqueUser = 'personShow_webWithUniqueUser',
  PlanningBookmarkAllCount = 'planningBookmark_allCount',
  PlanningBookmarkAllUniqueUser = 'planningBookmark_allUniqueUser',
  PlanningPopularityAllCount = 'planningPopularity_allCount',
  PlanningPopularityAllUniqueUser = 'planningPopularity_allUniqueUser',
  PlanningPopularityAndroidCount = 'planningPopularity_androidCount',
  PlanningPopularityAndroidUniqueUser = 'planningPopularity_androidUniqueUser',
  PlanningPopularityIosCount = 'planningPopularity_iosCount',
  PlanningPopularityIosUniqueUser = 'planningPopularity_iosUniqueUser',
  PlanningPopularityTimestampMax = 'planningPopularity_timestampMax',
  PlanningPopularityTimestampMin = 'planningPopularity_timestampMin',
  PlanningPopularityWebCount = 'planningPopularity_webCount',
  PlanningPopularityWebTeamCount = 'planningPopularity_webTeamCount',
  PlanningPopularityWebTeamUniqueUser = 'planningPopularity_webTeamUniqueUser',
  PlanningPopularityWebUniqueUser = 'planningPopularity_webUniqueUser',
  PlanningPopularityWebUserCount = 'planningPopularity_webUserCount',
  PlanningPopularityWebUserUniqueUser = 'planningPopularity_webUserUniqueUser',
  PlanningStreamStartAllCount = 'planningStreamStart_allCount',
  PlanningStreamStartAllUniqueUser = 'planningStreamStart_allUniqueUser',
  PlanningStreamStartAndroidCount = 'planningStreamStart_androidCount',
  PlanningStreamStartAndroidUniqueUser = 'planningStreamStart_androidUniqueUser',
  PlanningStreamStartIosCount = 'planningStreamStart_iosCount',
  PlanningStreamStartIosUniqueUser = 'planningStreamStart_iosUniqueUser',
  PlanningStreamStartTimestampMax = 'planningStreamStart_timestampMax',
  PlanningStreamStartTimestampMin = 'planningStreamStart_timestampMin',
  PlanningStreamStartWebCount = 'planningStreamStart_webCount',
  PlanningStreamStartWebTeamCount = 'planningStreamStart_webTeamCount',
  PlanningStreamStartWebTeamUniqueUser = 'planningStreamStart_webTeamUniqueUser',
  PlanningStreamStartWebUniqueUser = 'planningStreamStart_webUniqueUser',
  PlanningStreamStartWebUserCount = 'planningStreamStart_webUserCount',
  PlanningStreamStartWebUserUniqueUser = 'planningStreamStart_webUserUniqueUser',
  PlanningStreamStopAllCount = 'planningStreamStop_allCount',
  PlanningStreamStopAllUniqueUser = 'planningStreamStop_allUniqueUser',
  PlanningStreamStopAndroidCount = 'planningStreamStop_androidCount',
  PlanningStreamStopAndroidUniqueUser = 'planningStreamStop_androidUniqueUser',
  PlanningStreamStopDurationAndroidAverage = 'planningStreamStop_durationAndroidAverage',
  PlanningStreamStopDurationAndroidSum = 'planningStreamStop_durationAndroidSum',
  PlanningStreamStopDurationAverage = 'planningStreamStop_durationAverage',
  PlanningStreamStopDurationIosAverage = 'planningStreamStop_durationIosAverage',
  PlanningStreamStopDurationIosSum = 'planningStreamStop_durationIosSum',
  PlanningStreamStopDurationSum = 'planningStreamStop_durationSum',
  PlanningStreamStopDurationWebAverage = 'planningStreamStop_durationWebAverage',
  PlanningStreamStopDurationWebSum = 'planningStreamStop_durationWebSum',
  PlanningStreamStopDurationWebTeamAverage = 'planningStreamStop_durationWebTeamAverage',
  PlanningStreamStopDurationWebTeamSum = 'planningStreamStop_durationWebTeamSum',
  PlanningStreamStopDurationWebUserAverage = 'planningStreamStop_durationWebUserAverage',
  PlanningStreamStopDurationWebUserSum = 'planningStreamStop_durationWebUserSum',
  PlanningStreamStopIosCount = 'planningStreamStop_iosCount',
  PlanningStreamStopIosUniqueUser = 'planningStreamStop_iosUniqueUser',
  PlanningStreamStopTimestampMax = 'planningStreamStop_timestampMax',
  PlanningStreamStopTimestampMin = 'planningStreamStop_timestampMin',
  PlanningStreamStopWebCount = 'planningStreamStop_webCount',
  PlanningStreamStopWebTeamCount = 'planningStreamStop_webTeamCount',
  PlanningStreamStopWebTeamUniqueUser = 'planningStreamStop_webTeamUniqueUser',
  PlanningStreamStopWebUniqueUser = 'planningStreamStop_webUniqueUser',
  PlanningStreamStopWebUserCount = 'planningStreamStop_webUserCount',
  PlanningStreamStopWebUserUniqueUser = 'planningStreamStop_webUserUniqueUser',
  PlanningStreamAllCount = 'planningStream_allCount',
  PlanningStreamAllUniqueUser = 'planningStream_allUniqueUser',
  PlanningStreamAndroidCount = 'planningStream_androidCount',
  PlanningStreamAndroidUniqueUser = 'planningStream_androidUniqueUser',
  PlanningStreamIosCount = 'planningStream_iosCount',
  PlanningStreamIosUniqueUser = 'planningStream_iosUniqueUser',
  PlanningStreamTimestampMax = 'planningStream_timestampMax',
  PlanningStreamTimestampMin = 'planningStream_timestampMin',
  PlanningStreamWebCount = 'planningStream_webCount',
  PlanningStreamWebTeamCount = 'planningStream_webTeamCount',
  PlanningStreamWebTeamUniqueUser = 'planningStream_webTeamUniqueUser',
  PlanningStreamWebUniqueUser = 'planningStream_webUniqueUser',
  PlanningStreamWebUserCount = 'planningStream_webUserCount',
  PlanningStreamWebUserUniqueUser = 'planningStream_webUserUniqueUser',
  PostLinkOpenAllCount = 'postLinkOpen_allCount',
  PostLinkOpenAllUniqueUser = 'postLinkOpen_allUniqueUser',
  PostLinkOpenAndroidCount = 'postLinkOpen_androidCount',
  PostLinkOpenAndroidUniqueUser = 'postLinkOpen_androidUniqueUser',
  PostLinkOpenIosCount = 'postLinkOpen_iosCount',
  PostLinkOpenIosUniqueUser = 'postLinkOpen_iosUniqueUser',
  PostLinkOpenWebCount = 'postLinkOpen_webCount',
  PostLinkOpenWebTeamCount = 'postLinkOpen_webTeamCount',
  PostLinkOpenWebTeamUniqueUser = 'postLinkOpen_webTeamUniqueUser',
  PostLinkOpenWebUniqueUser = 'postLinkOpen_webUniqueUser',
  PostLinkOpenWebUserCount = 'postLinkOpen_webUserCount',
  PostLinkOpenWebUserUniqueUser = 'postLinkOpen_webUserUniqueUser',
  ProductBookmarkAllCount = 'productBookmark_allCount',
  ProductBookmarkAllUniqueUser = 'productBookmark_allUniqueUser',
  ProductBookmarkTimestampMax = 'productBookmark_timestampMax',
  ProductBookmarkTimestampMin = 'productBookmark_timestampMin',
  ProductShowAllCount = 'productShow_allCount',
  ProductShowAllUniqueUser = 'productShow_allUniqueUser',
  ProductShowAndroidCount = 'productShow_androidCount',
  ProductShowAndroidUniqueUser = 'productShow_androidUniqueUser',
  ProductShowIosCount = 'productShow_iosCount',
  ProductShowIosUniqueUser = 'productShow_iosUniqueUser',
  ProductShowTimestampMax = 'productShow_timestampMax',
  ProductShowTimestampMin = 'productShow_timestampMin',
  ProductShowWebCount = 'productShow_webCount',
  ProductShowWebTeamCount = 'productShow_webTeamCount',
  ProductShowWebTeamUniqueUser = 'productShow_webTeamUniqueUser',
  ProductShowWebUniqueUser = 'productShow_webUniqueUser',
  ProductShowWebUserCount = 'productShow_webUserCount',
  ProductShowWebUserUniqueUser = 'productShow_webUserUniqueUser',
  RegistrationAbandonedCount = 'registration_abandonedCount',
  RegistrationAllCount = 'registration_allCount',
  RegistrationCanceledCount = 'registration_canceledCount',
  RegistrationCheckedInCount = 'registration_checkedInCount',
  RegistrationRegisteredCount = 'registration_registeredCount',
  SponsorShowAllCount = 'sponsorShow_allCount',
  SponsorShowAllUniqueUser = 'sponsorShow_allUniqueUser',
  SponsorShowAndroidCount = 'sponsorShow_androidCount',
  SponsorShowAndroidUniqueUser = 'sponsorShow_androidUniqueUser',
  SponsorShowIosCount = 'sponsorShow_iosCount',
  SponsorShowIosUniqueUser = 'sponsorShow_iosUniqueUser',
  SponsorShowTimestampMax = 'sponsorShow_timestampMax',
  SponsorShowTimestampMin = 'sponsorShow_timestampMin',
  SponsorShowWebCount = 'sponsorShow_webCount',
  SponsorShowWebTeamCount = 'sponsorShow_webTeamCount',
  SponsorShowWebTeamUniqueUser = 'sponsorShow_webTeamUniqueUser',
  SponsorShowWebUniqueUser = 'sponsorShow_webUniqueUser',
  SponsorShowWebUserCount = 'sponsorShow_webUserCount',
  SponsorShowWebUserUniqueUser = 'sponsorShow_webUserUniqueUser',
  StreamStartAllCount = 'streamStart_allCount',
  StreamStartAllUniqueUser = 'streamStart_allUniqueUser',
  StreamStartAndroidCount = 'streamStart_androidCount',
  StreamStartAndroidUniqueUser = 'streamStart_androidUniqueUser',
  StreamStartIosCount = 'streamStart_iosCount',
  StreamStartIosUniqueUser = 'streamStart_iosUniqueUser',
  StreamStartTimestampMax = 'streamStart_timestampMax',
  StreamStartTimestampMin = 'streamStart_timestampMin',
  StreamStartWebCount = 'streamStart_webCount',
  StreamStartWebTeamCount = 'streamStart_webTeamCount',
  StreamStartWebTeamUniqueUser = 'streamStart_webTeamUniqueUser',
  StreamStartWebUniqueUser = 'streamStart_webUniqueUser',
  StreamStartWebUserCount = 'streamStart_webUserCount',
  StreamStartWebUserUniqueUser = 'streamStart_webUserUniqueUser',
  StreamStopAllCount = 'streamStop_allCount',
  StreamStopAllUniqueUser = 'streamStop_allUniqueUser',
  StreamStopAndroidCount = 'streamStop_androidCount',
  StreamStopAndroidUniqueUser = 'streamStop_androidUniqueUser',
  StreamStopDurationAndroidAverage = 'streamStop_durationAndroidAverage',
  StreamStopDurationAndroidSum = 'streamStop_durationAndroidSum',
  StreamStopDurationAverage = 'streamStop_durationAverage',
  StreamStopDurationIosAverage = 'streamStop_durationIosAverage',
  StreamStopDurationIosSum = 'streamStop_durationIosSum',
  StreamStopDurationSum = 'streamStop_durationSum',
  StreamStopDurationWebAverage = 'streamStop_durationWebAverage',
  StreamStopDurationWebSum = 'streamStop_durationWebSum',
  StreamStopDurationWebTeamAverage = 'streamStop_durationWebTeamAverage',
  StreamStopDurationWebTeamSum = 'streamStop_durationWebTeamSum',
  StreamStopDurationWebUserAverage = 'streamStop_durationWebUserAverage',
  StreamStopDurationWebUserSum = 'streamStop_durationWebUserSum',
  StreamStopIosCount = 'streamStop_iosCount',
  StreamStopIosUniqueUser = 'streamStop_iosUniqueUser',
  StreamStopTimestampMax = 'streamStop_timestampMax',
  StreamStopTimestampMin = 'streamStop_timestampMin',
  StreamStopWebCount = 'streamStop_webCount',
  StreamStopWebTeamCount = 'streamStop_webTeamCount',
  StreamStopWebTeamUniqueUser = 'streamStop_webTeamUniqueUser',
  StreamStopWebUniqueUser = 'streamStop_webUniqueUser',
  StreamStopWebUserCount = 'streamStop_webUserCount',
  StreamStopWebUserUniqueUser = 'streamStop_webUserUniqueUser',
  UsageAllUniqueUser = 'usage_allUniqueUser',
  UsageAndroidUniqueUser = 'usage_androidUniqueUser',
  UsageIosUniqueUser = 'usage_iosUniqueUser',
  UsageWebTeamUniqueUser = 'usage_webTeamUniqueUser',
  UsageWebUniqueUser = 'usage_webUniqueUser',
  UsageWebUserUniqueUser = 'usage_webUserUniqueUser',
  VideoCallRoomAllCount = 'videoCallRoom_allCount',
  VideoCallRoomAllUniqueUser = 'videoCallRoom_allUniqueUser',
  VideoCallRoomAllWithUniqueUser = 'videoCallRoom_allWithUniqueUser',
  VideoCallRoomSucceededCount = 'videoCallRoom_succeededCount',
  VideoCallRoomSucceededDurationAverage = 'videoCallRoom_succeededDurationAverage',
  VideoCallRoomSucceededDurationSum = 'videoCallRoom_succeededDurationSum',
  VideoCallRoomSucceededUniqueUser = 'videoCallRoom_succeededUniqueUser',
  VideoCallRoomSucceededWithUniqueUser = 'videoCallRoom_succeededWithUniqueUser'
}

export type Analytics_SortPlannings = {
  direction: Analytics_SortDirection;
  field: Analytics_SortPlanningsField;
  limit?: InputMaybe<Scalars['Int']>;
};

export enum Analytics_SortPlanningsField {
  PlanningBookmarkAllCount = 'planningBookmark_allCount',
  PlanningBookmarkAllUniqueUser = 'planningBookmark_allUniqueUser',
  PlanningPopularityAllCount = 'planningPopularity_allCount',
  PlanningPopularityAllUniqueUser = 'planningPopularity_allUniqueUser',
  PlanningPopularityAndroidCount = 'planningPopularity_androidCount',
  PlanningPopularityAndroidUniqueUser = 'planningPopularity_androidUniqueUser',
  PlanningPopularityIosCount = 'planningPopularity_iosCount',
  PlanningPopularityIosUniqueUser = 'planningPopularity_iosUniqueUser',
  PlanningPopularityTimestampMax = 'planningPopularity_timestampMax',
  PlanningPopularityTimestampMin = 'planningPopularity_timestampMin',
  PlanningPopularityWebCount = 'planningPopularity_webCount',
  PlanningPopularityWebTeamCount = 'planningPopularity_webTeamCount',
  PlanningPopularityWebTeamUniqueUser = 'planningPopularity_webTeamUniqueUser',
  PlanningPopularityWebUniqueUser = 'planningPopularity_webUniqueUser',
  PlanningPopularityWebUserCount = 'planningPopularity_webUserCount',
  PlanningPopularityWebUserUniqueUser = 'planningPopularity_webUserUniqueUser',
  PlanningStreamStartAllCount = 'planningStreamStart_allCount',
  PlanningStreamStartAllUniqueUser = 'planningStreamStart_allUniqueUser',
  PlanningStreamStartAndroidCount = 'planningStreamStart_androidCount',
  PlanningStreamStartAndroidUniqueUser = 'planningStreamStart_androidUniqueUser',
  PlanningStreamStartIosCount = 'planningStreamStart_iosCount',
  PlanningStreamStartIosUniqueUser = 'planningStreamStart_iosUniqueUser',
  PlanningStreamStartTimestampMax = 'planningStreamStart_timestampMax',
  PlanningStreamStartTimestampMin = 'planningStreamStart_timestampMin',
  PlanningStreamStartWebCount = 'planningStreamStart_webCount',
  PlanningStreamStartWebTeamCount = 'planningStreamStart_webTeamCount',
  PlanningStreamStartWebTeamUniqueUser = 'planningStreamStart_webTeamUniqueUser',
  PlanningStreamStartWebUniqueUser = 'planningStreamStart_webUniqueUser',
  PlanningStreamStartWebUserCount = 'planningStreamStart_webUserCount',
  PlanningStreamStartWebUserUniqueUser = 'planningStreamStart_webUserUniqueUser',
  PlanningStreamStopAllCount = 'planningStreamStop_allCount',
  PlanningStreamStopAllUniqueUser = 'planningStreamStop_allUniqueUser',
  PlanningStreamStopAndroidCount = 'planningStreamStop_androidCount',
  PlanningStreamStopAndroidUniqueUser = 'planningStreamStop_androidUniqueUser',
  PlanningStreamStopDurationAndroidAverage = 'planningStreamStop_durationAndroidAverage',
  PlanningStreamStopDurationAndroidSum = 'planningStreamStop_durationAndroidSum',
  PlanningStreamStopDurationAverage = 'planningStreamStop_durationAverage',
  PlanningStreamStopDurationIosAverage = 'planningStreamStop_durationIosAverage',
  PlanningStreamStopDurationIosSum = 'planningStreamStop_durationIosSum',
  PlanningStreamStopDurationSum = 'planningStreamStop_durationSum',
  PlanningStreamStopDurationWebAverage = 'planningStreamStop_durationWebAverage',
  PlanningStreamStopDurationWebSum = 'planningStreamStop_durationWebSum',
  PlanningStreamStopDurationWebTeamAverage = 'planningStreamStop_durationWebTeamAverage',
  PlanningStreamStopDurationWebTeamSum = 'planningStreamStop_durationWebTeamSum',
  PlanningStreamStopDurationWebUserAverage = 'planningStreamStop_durationWebUserAverage',
  PlanningStreamStopDurationWebUserSum = 'planningStreamStop_durationWebUserSum',
  PlanningStreamStopIosCount = 'planningStreamStop_iosCount',
  PlanningStreamStopIosUniqueUser = 'planningStreamStop_iosUniqueUser',
  PlanningStreamStopTimestampMax = 'planningStreamStop_timestampMax',
  PlanningStreamStopTimestampMin = 'planningStreamStop_timestampMin',
  PlanningStreamStopWebCount = 'planningStreamStop_webCount',
  PlanningStreamStopWebTeamCount = 'planningStreamStop_webTeamCount',
  PlanningStreamStopWebTeamUniqueUser = 'planningStreamStop_webTeamUniqueUser',
  PlanningStreamStopWebUniqueUser = 'planningStreamStop_webUniqueUser',
  PlanningStreamStopWebUserCount = 'planningStreamStop_webUserCount',
  PlanningStreamStopWebUserUniqueUser = 'planningStreamStop_webUserUniqueUser',
  PlanningStreamAllCount = 'planningStream_allCount',
  PlanningStreamAllUniqueUser = 'planningStream_allUniqueUser',
  PlanningStreamAndroidCount = 'planningStream_androidCount',
  PlanningStreamAndroidUniqueUser = 'planningStream_androidUniqueUser',
  PlanningStreamIosCount = 'planningStream_iosCount',
  PlanningStreamIosUniqueUser = 'planningStream_iosUniqueUser',
  PlanningStreamTimestampMax = 'planningStream_timestampMax',
  PlanningStreamTimestampMin = 'planningStream_timestampMin',
  PlanningStreamWebCount = 'planningStream_webCount',
  PlanningStreamWebTeamCount = 'planningStream_webTeamCount',
  PlanningStreamWebTeamUniqueUser = 'planningStream_webTeamUniqueUser',
  PlanningStreamWebUniqueUser = 'planningStream_webUniqueUser',
  PlanningStreamWebUserCount = 'planningStream_webUserCount',
  PlanningStreamWebUserUniqueUser = 'planningStream_webUserUniqueUser'
}

export type Analytics_SortUsers = {
  direction: Analytics_SortDirection;
  field: Analytics_SortUsersField;
  limit?: InputMaybe<Scalars['Int']>;
};

export enum Analytics_SortUsersField {
  ActivityTimestampMax = 'activity_timestampMax',
  ActivityTimestampMin = 'activity_timestampMin',
  AddOpenAllCount = 'addOpen_allCount',
  AddOpenAllUniqueUser = 'addOpen_allUniqueUser',
  AddOpenAndroidCount = 'addOpen_androidCount',
  AddOpenAndroidUniqueUser = 'addOpen_androidUniqueUser',
  AddOpenIosCount = 'addOpen_iosCount',
  AddOpenIosUniqueUser = 'addOpen_iosUniqueUser',
  AddOpenTimestampMax = 'addOpen_timestampMax',
  AddOpenTimestampMin = 'addOpen_timestampMin',
  AddOpenWebCount = 'addOpen_webCount',
  AddOpenWebTeamCount = 'addOpen_webTeamCount',
  AddOpenWebTeamUniqueUser = 'addOpen_webTeamUniqueUser',
  AddOpenWebUniqueUser = 'addOpen_webUniqueUser',
  AddOpenWebUserCount = 'addOpen_webUserCount',
  AddOpenWebUserUniqueUser = 'addOpen_webUserUniqueUser',
  AdvertisementOpenAllCount = 'advertisementOpen_allCount',
  AdvertisementOpenAllUniqueUser = 'advertisementOpen_allUniqueUser',
  AdvertisementOpenAndroidCount = 'advertisementOpen_androidCount',
  AdvertisementOpenAndroidUniqueUser = 'advertisementOpen_androidUniqueUser',
  AdvertisementOpenIosCount = 'advertisementOpen_iosCount',
  AdvertisementOpenIosUniqueUser = 'advertisementOpen_iosUniqueUser',
  AdvertisementOpenTimestampMax = 'advertisementOpen_timestampMax',
  AdvertisementOpenTimestampMin = 'advertisementOpen_timestampMin',
  AdvertisementOpenWebCount = 'advertisementOpen_webCount',
  AdvertisementOpenWebTeamCount = 'advertisementOpen_webTeamCount',
  AdvertisementOpenWebTeamUniqueUser = 'advertisementOpen_webTeamUniqueUser',
  AdvertisementOpenWebUniqueUser = 'advertisementOpen_webUniqueUser',
  AdvertisementOpenWebUserCount = 'advertisementOpen_webUserCount',
  AdvertisementOpenWebUserUniqueUser = 'advertisementOpen_webUserUniqueUser',
  AdvertisementShowAllCount = 'advertisementShow_allCount',
  AdvertisementShowAllUniqueUser = 'advertisementShow_allUniqueUser',
  AdvertisementShowAndroidCount = 'advertisementShow_androidCount',
  AdvertisementShowAndroidUniqueUser = 'advertisementShow_androidUniqueUser',
  AdvertisementShowDurationAndroidAverage = 'advertisementShow_durationAndroidAverage',
  AdvertisementShowDurationAndroidSum = 'advertisementShow_durationAndroidSum',
  AdvertisementShowDurationAverage = 'advertisementShow_durationAverage',
  AdvertisementShowDurationIosAverage = 'advertisementShow_durationIosAverage',
  AdvertisementShowDurationIosSum = 'advertisementShow_durationIosSum',
  AdvertisementShowDurationSum = 'advertisementShow_durationSum',
  AdvertisementShowDurationWebAverage = 'advertisementShow_durationWebAverage',
  AdvertisementShowDurationWebSum = 'advertisementShow_durationWebSum',
  AdvertisementShowDurationWebTeamAverage = 'advertisementShow_durationWebTeamAverage',
  AdvertisementShowDurationWebTeamSum = 'advertisementShow_durationWebTeamSum',
  AdvertisementShowDurationWebUserAverage = 'advertisementShow_durationWebUserAverage',
  AdvertisementShowDurationWebUserSum = 'advertisementShow_durationWebUserSum',
  AdvertisementShowIosCount = 'advertisementShow_iosCount',
  AdvertisementShowIosUniqueUser = 'advertisementShow_iosUniqueUser',
  AdvertisementShowWebCount = 'advertisementShow_webCount',
  AdvertisementShowWebTeamCount = 'advertisementShow_webTeamCount',
  AdvertisementShowWebTeamUniqueUser = 'advertisementShow_webTeamUniqueUser',
  AdvertisementShowWebUniqueUser = 'advertisementShow_webUniqueUser',
  AdvertisementShowWebUserCount = 'advertisementShow_webUserCount',
  AdvertisementShowWebUserUniqueUser = 'advertisementShow_webUserUniqueUser',
  BookmarkReceiveAllCount = 'bookmarkReceive_allCount',
  BookmarkReceiveAllUniqueUser = 'bookmarkReceive_allUniqueUser',
  BookmarkReceiveTimestampMax = 'bookmarkReceive_timestampMax',
  BookmarkReceiveTimestampMin = 'bookmarkReceive_timestampMin',
  BookmarkAllCount = 'bookmark_allCount',
  BookmarkAllUniqueUser = 'bookmark_allUniqueUser',
  BookmarkTimestampMax = 'bookmark_timestampMax',
  BookmarkTimestampMin = 'bookmark_timestampMin',
  ChannelOpenAllCount = 'channelOpen_allCount',
  ChannelOpenAllUniqueUser = 'channelOpen_allUniqueUser',
  ChannelOpenAndroidCount = 'channelOpen_androidCount',
  ChannelOpenAndroidUniqueUser = 'channelOpen_androidUniqueUser',
  ChannelOpenIosCount = 'channelOpen_iosCount',
  ChannelOpenIosUniqueUser = 'channelOpen_iosUniqueUser',
  ChannelOpenWebCount = 'channelOpen_webCount',
  ChannelOpenWebTeamCount = 'channelOpen_webTeamCount',
  ChannelOpenWebTeamUniqueUser = 'channelOpen_webTeamUniqueUser',
  ChannelOpenWebUniqueUser = 'channelOpen_webUniqueUser',
  ChannelOpenWebUserCount = 'channelOpen_webUserCount',
  ChannelOpenWebUserUniqueUser = 'channelOpen_webUserUniqueUser',
  ConnectionReceiveAllCount = 'connectionReceive_allCount',
  ConnectionReceiveAllUnique = 'connectionReceive_allUnique',
  ConnectionReceiveAllUniqueUser = 'connectionReceive_allUniqueUser',
  ConnectionReceiveAllWithUniqueUser = 'connectionReceive_allWithUniqueUser',
  ConnectionReceiveNotScanCount = 'connectionReceive_notScanCount',
  ConnectionReceiveNotScanUnique = 'connectionReceive_notScanUnique',
  ConnectionReceiveNotScanUniqueUser = 'connectionReceive_notScanUniqueUser',
  ConnectionReceiveNotScanWithUniqueUser = 'connectionReceive_notScanWithUniqueUser',
  ConnectionReceiveScanCount = 'connectionReceive_scanCount',
  ConnectionReceiveScanUnique = 'connectionReceive_scanUnique',
  ConnectionReceiveScanUniqueUser = 'connectionReceive_scanUniqueUser',
  ConnectionReceiveScanWithUniqueUser = 'connectionReceive_scanWithUniqueUser',
  ConnectionReceiveScoreAverage = 'connectionReceive_scoreAverage',
  ConnectionReceiveScoreCount = 'connectionReceive_scoreCount',
  ConnectionReceiveScoreUnique = 'connectionReceive_scoreUnique',
  ConnectionReceiveScoreUniqueUser = 'connectionReceive_scoreUniqueUser',
  ConnectionReceiveScoreWithUniqueUser = 'connectionReceive_scoreWithUniqueUser',
  ConnectionRequestReceiveAcceptedCount = 'connectionRequestReceive_acceptedCount',
  ConnectionRequestReceiveAcceptedUniqueUser = 'connectionRequestReceive_acceptedUniqueUser',
  ConnectionRequestReceiveAcceptedWithUniqueUser = 'connectionRequestReceive_acceptedWithUniqueUser',
  ConnectionRequestReceiveAllCount = 'connectionRequestReceive_allCount',
  ConnectionRequestReceiveAllUniqueUser = 'connectionRequestReceive_allUniqueUser',
  ConnectionRequestReceiveAllWithUniqueUser = 'connectionRequestReceive_allWithUniqueUser',
  ConnectionRequestReceiveDeclinedCount = 'connectionRequestReceive_declinedCount',
  ConnectionRequestReceiveDeclinedUniqueUser = 'connectionRequestReceive_declinedUniqueUser',
  ConnectionRequestReceiveDeclinedWithUniqueUser = 'connectionRequestReceive_declinedWithUniqueUser',
  ConnectionRequestReceivePendingCount = 'connectionRequestReceive_pendingCount',
  ConnectionRequestReceivePendingUniqueUser = 'connectionRequestReceive_pendingUniqueUser',
  ConnectionRequestReceivePendingWithUniqueUser = 'connectionRequestReceive_pendingWithUniqueUser',
  ConnectionRequestAcceptedCount = 'connectionRequest_acceptedCount',
  ConnectionRequestAcceptedUniqueUser = 'connectionRequest_acceptedUniqueUser',
  ConnectionRequestAcceptedWithUniqueUser = 'connectionRequest_acceptedWithUniqueUser',
  ConnectionRequestAllCount = 'connectionRequest_allCount',
  ConnectionRequestAllUniqueUser = 'connectionRequest_allUniqueUser',
  ConnectionRequestAllWithUniqueUser = 'connectionRequest_allWithUniqueUser',
  ConnectionRequestDeclinedCount = 'connectionRequest_declinedCount',
  ConnectionRequestDeclinedUniqueUser = 'connectionRequest_declinedUniqueUser',
  ConnectionRequestDeclinedWithUniqueUser = 'connectionRequest_declinedWithUniqueUser',
  ConnectionRequestPendingCount = 'connectionRequest_pendingCount',
  ConnectionRequestPendingUniqueUser = 'connectionRequest_pendingUniqueUser',
  ConnectionRequestPendingWithUniqueUser = 'connectionRequest_pendingWithUniqueUser',
  ConnectionAllCount = 'connection_allCount',
  ConnectionAllUnique = 'connection_allUnique',
  ConnectionAllUniqueUser = 'connection_allUniqueUser',
  ConnectionAllWithUniqueUser = 'connection_allWithUniqueUser',
  ConnectionNotScanCount = 'connection_notScanCount',
  ConnectionNotScanUnique = 'connection_notScanUnique',
  ConnectionNotScanUniqueUser = 'connection_notScanUniqueUser',
  ConnectionNotScanWithUniqueUser = 'connection_notScanWithUniqueUser',
  ConnectionScanCount = 'connection_scanCount',
  ConnectionScanUnique = 'connection_scanUnique',
  ConnectionScanUniqueUser = 'connection_scanUniqueUser',
  ConnectionScanWithUniqueUser = 'connection_scanWithUniqueUser',
  ConnectionScoreAverage = 'connection_scoreAverage',
  ConnectionScoreCount = 'connection_scoreCount',
  ConnectionScoreUnique = 'connection_scoreUnique',
  ConnectionScoreUniqueUser = 'connection_scoreUniqueUser',
  ConnectionScoreWithUniqueUser = 'connection_scoreWithUniqueUser',
  ContactAllCount = 'contact_allCount',
  ContactAllUniqueUser = 'contact_allUniqueUser',
  ContactNotScanCount = 'contact_notScanCount',
  ContactNotScanUniqueUser = 'contact_notScanUniqueUser',
  ContactScanCount = 'contact_scanCount',
  ContactScanUniqueUser = 'contact_scanUniqueUser',
  DocumentOpenAllCount = 'documentOpen_allCount',
  DocumentOpenAllUniqueUser = 'documentOpen_allUniqueUser',
  DocumentOpenTimestampMax = 'documentOpen_timestampMax',
  DocumentOpenTimestampMin = 'documentOpen_timestampMin',
  EventShowAllCount = 'eventShow_allCount',
  EventShowAllUniqueUser = 'eventShow_allUniqueUser',
  EventShowAndroidCount = 'eventShow_androidCount',
  EventShowAndroidUniqueUser = 'eventShow_androidUniqueUser',
  EventShowIosCount = 'eventShow_iosCount',
  EventShowIosUniqueUser = 'eventShow_iosUniqueUser',
  EventShowWebCount = 'eventShow_webCount',
  EventShowWebTeamCount = 'eventShow_webTeamCount',
  EventShowWebTeamUniqueUser = 'eventShow_webTeamUniqueUser',
  EventShowWebUniqueUser = 'eventShow_webUniqueUser',
  EventShowWebUserCount = 'eventShow_webUserCount',
  EventShowWebUserUniqueUser = 'eventShow_webUserUniqueUser',
  EventViewShowAllCount = 'eventViewShow_allCount',
  EventViewShowAllUniqueUser = 'eventViewShow_allUniqueUser',
  EventViewShowAndroidCount = 'eventViewShow_androidCount',
  EventViewShowAndroidUniqueUser = 'eventViewShow_androidUniqueUser',
  EventViewShowIosCount = 'eventViewShow_iosCount',
  EventViewShowIosUniqueUser = 'eventViewShow_iosUniqueUser',
  EventViewShowWebCount = 'eventViewShow_webCount',
  EventViewShowWebTeamCount = 'eventViewShow_webTeamCount',
  EventViewShowWebTeamUniqueUser = 'eventViewShow_webTeamUniqueUser',
  EventViewShowWebUniqueUser = 'eventViewShow_webUniqueUser',
  EventViewShowWebUserCount = 'eventViewShow_webUserCount',
  EventViewShowWebUserUniqueUser = 'eventViewShow_webUserUniqueUser',
  ExhibitorAdvertisementOpenReceiveAllCount = 'exhibitorAdvertisementOpenReceive_allCount',
  ExhibitorAdvertisementOpenReceiveAllUniqueUser = 'exhibitorAdvertisementOpenReceive_allUniqueUser',
  ExhibitorAdvertisementOpenReceiveAndroidCount = 'exhibitorAdvertisementOpenReceive_androidCount',
  ExhibitorAdvertisementOpenReceiveAndroidUniqueUser = 'exhibitorAdvertisementOpenReceive_androidUniqueUser',
  ExhibitorAdvertisementOpenReceiveIosCount = 'exhibitorAdvertisementOpenReceive_iosCount',
  ExhibitorAdvertisementOpenReceiveIosUniqueUser = 'exhibitorAdvertisementOpenReceive_iosUniqueUser',
  ExhibitorAdvertisementOpenReceiveTimestampMax = 'exhibitorAdvertisementOpenReceive_timestampMax',
  ExhibitorAdvertisementOpenReceiveTimestampMin = 'exhibitorAdvertisementOpenReceive_timestampMin',
  ExhibitorAdvertisementOpenReceiveWebCount = 'exhibitorAdvertisementOpenReceive_webCount',
  ExhibitorAdvertisementOpenReceiveWebTeamCount = 'exhibitorAdvertisementOpenReceive_webTeamCount',
  ExhibitorAdvertisementOpenReceiveWebTeamUniqueUser = 'exhibitorAdvertisementOpenReceive_webTeamUniqueUser',
  ExhibitorAdvertisementOpenReceiveWebUniqueUser = 'exhibitorAdvertisementOpenReceive_webUniqueUser',
  ExhibitorAdvertisementOpenReceiveWebUserCount = 'exhibitorAdvertisementOpenReceive_webUserCount',
  ExhibitorAdvertisementOpenReceiveWebUserUniqueUser = 'exhibitorAdvertisementOpenReceive_webUserUniqueUser',
  ExhibitorAdvertisementOpenAllCount = 'exhibitorAdvertisementOpen_allCount',
  ExhibitorAdvertisementOpenAllUniqueUser = 'exhibitorAdvertisementOpen_allUniqueUser',
  ExhibitorAdvertisementOpenAndroidCount = 'exhibitorAdvertisementOpen_androidCount',
  ExhibitorAdvertisementOpenAndroidUniqueUser = 'exhibitorAdvertisementOpen_androidUniqueUser',
  ExhibitorAdvertisementOpenIosCount = 'exhibitorAdvertisementOpen_iosCount',
  ExhibitorAdvertisementOpenIosUniqueUser = 'exhibitorAdvertisementOpen_iosUniqueUser',
  ExhibitorAdvertisementOpenTimestampMax = 'exhibitorAdvertisementOpen_timestampMax',
  ExhibitorAdvertisementOpenTimestampMin = 'exhibitorAdvertisementOpen_timestampMin',
  ExhibitorAdvertisementOpenWebCount = 'exhibitorAdvertisementOpen_webCount',
  ExhibitorAdvertisementOpenWebTeamCount = 'exhibitorAdvertisementOpen_webTeamCount',
  ExhibitorAdvertisementOpenWebTeamUniqueUser = 'exhibitorAdvertisementOpen_webTeamUniqueUser',
  ExhibitorAdvertisementOpenWebUniqueUser = 'exhibitorAdvertisementOpen_webUniqueUser',
  ExhibitorAdvertisementOpenWebUserCount = 'exhibitorAdvertisementOpen_webUserCount',
  ExhibitorAdvertisementOpenWebUserUniqueUser = 'exhibitorAdvertisementOpen_webUserUniqueUser',
  ExhibitorAdvertisementShowReceiveAllCount = 'exhibitorAdvertisementShowReceive_allCount',
  ExhibitorAdvertisementShowReceiveAllUniqueUser = 'exhibitorAdvertisementShowReceive_allUniqueUser',
  ExhibitorAdvertisementShowReceiveAndroidCount = 'exhibitorAdvertisementShowReceive_androidCount',
  ExhibitorAdvertisementShowReceiveAndroidUniqueUser = 'exhibitorAdvertisementShowReceive_androidUniqueUser',
  ExhibitorAdvertisementShowReceiveIosCount = 'exhibitorAdvertisementShowReceive_iosCount',
  ExhibitorAdvertisementShowReceiveIosUniqueUser = 'exhibitorAdvertisementShowReceive_iosUniqueUser',
  ExhibitorAdvertisementShowReceiveTimestampMax = 'exhibitorAdvertisementShowReceive_timestampMax',
  ExhibitorAdvertisementShowReceiveTimestampMin = 'exhibitorAdvertisementShowReceive_timestampMin',
  ExhibitorAdvertisementShowReceiveWebCount = 'exhibitorAdvertisementShowReceive_webCount',
  ExhibitorAdvertisementShowReceiveWebTeamCount = 'exhibitorAdvertisementShowReceive_webTeamCount',
  ExhibitorAdvertisementShowReceiveWebTeamUniqueUser = 'exhibitorAdvertisementShowReceive_webTeamUniqueUser',
  ExhibitorAdvertisementShowReceiveWebUniqueUser = 'exhibitorAdvertisementShowReceive_webUniqueUser',
  ExhibitorAdvertisementShowReceiveWebUserCount = 'exhibitorAdvertisementShowReceive_webUserCount',
  ExhibitorAdvertisementShowReceiveWebUserUniqueUser = 'exhibitorAdvertisementShowReceive_webUserUniqueUser',
  ExhibitorAdvertisementShowAllCount = 'exhibitorAdvertisementShow_allCount',
  ExhibitorAdvertisementShowAllUniqueUser = 'exhibitorAdvertisementShow_allUniqueUser',
  ExhibitorAdvertisementShowAndroidCount = 'exhibitorAdvertisementShow_androidCount',
  ExhibitorAdvertisementShowAndroidUniqueUser = 'exhibitorAdvertisementShow_androidUniqueUser',
  ExhibitorAdvertisementShowIosCount = 'exhibitorAdvertisementShow_iosCount',
  ExhibitorAdvertisementShowIosUniqueUser = 'exhibitorAdvertisementShow_iosUniqueUser',
  ExhibitorAdvertisementShowTimestampMax = 'exhibitorAdvertisementShow_timestampMax',
  ExhibitorAdvertisementShowTimestampMin = 'exhibitorAdvertisementShow_timestampMin',
  ExhibitorAdvertisementShowWebCount = 'exhibitorAdvertisementShow_webCount',
  ExhibitorAdvertisementShowWebTeamCount = 'exhibitorAdvertisementShow_webTeamCount',
  ExhibitorAdvertisementShowWebTeamUniqueUser = 'exhibitorAdvertisementShow_webTeamUniqueUser',
  ExhibitorAdvertisementShowWebUniqueUser = 'exhibitorAdvertisementShow_webUniqueUser',
  ExhibitorAdvertisementShowWebUserCount = 'exhibitorAdvertisementShow_webUserCount',
  ExhibitorAdvertisementShowWebUserUniqueUser = 'exhibitorAdvertisementShow_webUserUniqueUser',
  ExhibitorBookmarkReceiveAllCount = 'exhibitorBookmarkReceive_allCount',
  ExhibitorBookmarkReceiveAllUniqueUser = 'exhibitorBookmarkReceive_allUniqueUser',
  ExhibitorBookmarkReceiveTimestampMax = 'exhibitorBookmarkReceive_timestampMax',
  ExhibitorBookmarkReceiveTimestampMin = 'exhibitorBookmarkReceive_timestampMin',
  ExhibitorBookmarkAllCount = 'exhibitorBookmark_allCount',
  ExhibitorBookmarkAllUniqueUser = 'exhibitorBookmark_allUniqueUser',
  ExhibitorBookmarkTimestampMax = 'exhibitorBookmark_timestampMax',
  ExhibitorBookmarkTimestampMin = 'exhibitorBookmark_timestampMin',
  ExhibitorPopularityAllCount = 'exhibitorPopularity_allCount',
  ExhibitorPopularityAllUniqueUser = 'exhibitorPopularity_allUniqueUser',
  ExhibitorPopularityAndroidCount = 'exhibitorPopularity_androidCount',
  ExhibitorPopularityAndroidUniqueUser = 'exhibitorPopularity_androidUniqueUser',
  ExhibitorPopularityIosCount = 'exhibitorPopularity_iosCount',
  ExhibitorPopularityIosUniqueUser = 'exhibitorPopularity_iosUniqueUser',
  ExhibitorPopularityTimestampMax = 'exhibitorPopularity_timestampMax',
  ExhibitorPopularityTimestampMin = 'exhibitorPopularity_timestampMin',
  ExhibitorPopularityWebCount = 'exhibitorPopularity_webCount',
  ExhibitorPopularityWebTeamCount = 'exhibitorPopularity_webTeamCount',
  ExhibitorPopularityWebTeamUniqueUser = 'exhibitorPopularity_webTeamUniqueUser',
  ExhibitorPopularityWebUniqueUser = 'exhibitorPopularity_webUniqueUser',
  ExhibitorPopularityWebUserCount = 'exhibitorPopularity_webUserCount',
  ExhibitorPopularityWebUserUniqueUser = 'exhibitorPopularity_webUserUniqueUser',
  ExhibitorSelfShowAllCount = 'exhibitorSelfShow_allCount',
  ExhibitorSelfShowAllUniqueUser = 'exhibitorSelfShow_allUniqueUser',
  ExhibitorSelfShowAndroidCount = 'exhibitorSelfShow_androidCount',
  ExhibitorSelfShowAndroidUniqueUser = 'exhibitorSelfShow_androidUniqueUser',
  ExhibitorSelfShowIosCount = 'exhibitorSelfShow_iosCount',
  ExhibitorSelfShowIosUniqueUser = 'exhibitorSelfShow_iosUniqueUser',
  ExhibitorSelfShowWebCount = 'exhibitorSelfShow_webCount',
  ExhibitorSelfShowWebTeamCount = 'exhibitorSelfShow_webTeamCount',
  ExhibitorSelfShowWebTeamUniqueUser = 'exhibitorSelfShow_webTeamUniqueUser',
  ExhibitorSelfShowWebUniqueUser = 'exhibitorSelfShow_webUniqueUser',
  ExhibitorSelfShowWebUserCount = 'exhibitorSelfShow_webUserCount',
  ExhibitorSelfShowWebUserUniqueUser = 'exhibitorSelfShow_webUserUniqueUser',
  ExhibitorShowReceiveAllCount = 'exhibitorShowReceive_allCount',
  ExhibitorShowReceiveAllUniqueUser = 'exhibitorShowReceive_allUniqueUser',
  ExhibitorShowReceiveAndroidCount = 'exhibitorShowReceive_androidCount',
  ExhibitorShowReceiveAndroidUniqueUser = 'exhibitorShowReceive_androidUniqueUser',
  ExhibitorShowReceiveIosCount = 'exhibitorShowReceive_iosCount',
  ExhibitorShowReceiveIosUniqueUser = 'exhibitorShowReceive_iosUniqueUser',
  ExhibitorShowReceiveTimestampMax = 'exhibitorShowReceive_timestampMax',
  ExhibitorShowReceiveTimestampMin = 'exhibitorShowReceive_timestampMin',
  ExhibitorShowReceiveWebCount = 'exhibitorShowReceive_webCount',
  ExhibitorShowReceiveWebTeamCount = 'exhibitorShowReceive_webTeamCount',
  ExhibitorShowReceiveWebTeamUniqueUser = 'exhibitorShowReceive_webTeamUniqueUser',
  ExhibitorShowReceiveWebUniqueUser = 'exhibitorShowReceive_webUniqueUser',
  ExhibitorShowReceiveWebUserCount = 'exhibitorShowReceive_webUserCount',
  ExhibitorShowReceiveWebUserUniqueUser = 'exhibitorShowReceive_webUserUniqueUser',
  ExhibitorShowAllCount = 'exhibitorShow_allCount',
  ExhibitorShowAllUniqueUser = 'exhibitorShow_allUniqueUser',
  ExhibitorShowAndroidCount = 'exhibitorShow_androidCount',
  ExhibitorShowAndroidUniqueUser = 'exhibitorShow_androidUniqueUser',
  ExhibitorShowIosCount = 'exhibitorShow_iosCount',
  ExhibitorShowIosUniqueUser = 'exhibitorShow_iosUniqueUser',
  ExhibitorShowTimestampMax = 'exhibitorShow_timestampMax',
  ExhibitorShowTimestampMin = 'exhibitorShow_timestampMin',
  ExhibitorShowWebCount = 'exhibitorShow_webCount',
  ExhibitorShowWebTeamCount = 'exhibitorShow_webTeamCount',
  ExhibitorShowWebTeamUniqueUser = 'exhibitorShow_webTeamUniqueUser',
  ExhibitorShowWebUniqueUser = 'exhibitorShow_webUniqueUser',
  ExhibitorShowWebUserCount = 'exhibitorShow_webUserCount',
  ExhibitorShowWebUserUniqueUser = 'exhibitorShow_webUserUniqueUser',
  InterstitialAddShowAllCount = 'interstitialAddShow_allCount',
  InterstitialAddShowAllUniqueUser = 'interstitialAddShow_allUniqueUser',
  InterstitialAddShowAndroidCount = 'interstitialAddShow_androidCount',
  InterstitialAddShowAndroidUniqueUser = 'interstitialAddShow_androidUniqueUser',
  InterstitialAddShowDurationAndroidAverage = 'interstitialAddShow_durationAndroidAverage',
  InterstitialAddShowDurationAndroidSum = 'interstitialAddShow_durationAndroidSum',
  InterstitialAddShowDurationAverage = 'interstitialAddShow_durationAverage',
  InterstitialAddShowDurationIosAverage = 'interstitialAddShow_durationIosAverage',
  InterstitialAddShowDurationIosSum = 'interstitialAddShow_durationIosSum',
  InterstitialAddShowDurationSum = 'interstitialAddShow_durationSum',
  InterstitialAddShowDurationWebAverage = 'interstitialAddShow_durationWebAverage',
  InterstitialAddShowDurationWebSum = 'interstitialAddShow_durationWebSum',
  InterstitialAddShowDurationWebTeamAverage = 'interstitialAddShow_durationWebTeamAverage',
  InterstitialAddShowDurationWebTeamSum = 'interstitialAddShow_durationWebTeamSum',
  InterstitialAddShowDurationWebUserAverage = 'interstitialAddShow_durationWebUserAverage',
  InterstitialAddShowDurationWebUserSum = 'interstitialAddShow_durationWebUserSum',
  InterstitialAddShowIosCount = 'interstitialAddShow_iosCount',
  InterstitialAddShowIosUniqueUser = 'interstitialAddShow_iosUniqueUser',
  InterstitialAddShowWebCount = 'interstitialAddShow_webCount',
  InterstitialAddShowWebTeamCount = 'interstitialAddShow_webTeamCount',
  InterstitialAddShowWebTeamUniqueUser = 'interstitialAddShow_webTeamUniqueUser',
  InterstitialAddShowWebUniqueUser = 'interstitialAddShow_webUniqueUser',
  InterstitialAddShowWebUserCount = 'interstitialAddShow_webUserCount',
  InterstitialAddShowWebUserUniqueUser = 'interstitialAddShow_webUserUniqueUser',
  MeetingParticipantAllCount = 'meetingParticipant_allCount',
  MeetingParticipantAllUnique = 'meetingParticipant_allUnique',
  MeetingParticipantAllUniqueUser = 'meetingParticipant_allUniqueUser',
  MeetingParticipantCanceledCount = 'meetingParticipant_canceledCount',
  MeetingParticipantCanceledUnique = 'meetingParticipant_canceledUnique',
  MeetingParticipantCanceledUniqueUser = 'meetingParticipant_canceledUniqueUser',
  MeetingParticipantConfirmedCount = 'meetingParticipant_confirmedCount',
  MeetingParticipantConfirmedUnique = 'meetingParticipant_confirmedUnique',
  MeetingParticipantConfirmedUniqueUser = 'meetingParticipant_confirmedUniqueUser',
  MeetingParticipantDeclinedCount = 'meetingParticipant_declinedCount',
  MeetingParticipantDeclinedUnique = 'meetingParticipant_declinedUnique',
  MeetingParticipantDeclinedUniqueUser = 'meetingParticipant_declinedUniqueUser',
  MeetingParticipantExpiredCount = 'meetingParticipant_expiredCount',
  MeetingParticipantExpiredUnique = 'meetingParticipant_expiredUnique',
  MeetingParticipantExpiredUniqueUser = 'meetingParticipant_expiredUniqueUser',
  MeetingParticipantNoShowCount = 'meetingParticipant_noShowCount',
  MeetingParticipantNoShowUnique = 'meetingParticipant_noShowUnique',
  MeetingParticipantNoShowUniqueUser = 'meetingParticipant_noShowUniqueUser',
  MeetingParticipantPendingCount = 'meetingParticipant_pendingCount',
  MeetingParticipantPendingUnique = 'meetingParticipant_pendingUnique',
  MeetingParticipantPendingUniqueUser = 'meetingParticipant_pendingUniqueUser',
  MeetingRequestReceiveAcceptedCount = 'meetingRequestReceive_acceptedCount',
  MeetingRequestReceiveAcceptedUniqueUser = 'meetingRequestReceive_acceptedUniqueUser',
  MeetingRequestReceiveAcceptedWithUniqueUser = 'meetingRequestReceive_acceptedWithUniqueUser',
  MeetingRequestReceiveAllCount = 'meetingRequestReceive_allCount',
  MeetingRequestReceiveAllUniqueUser = 'meetingRequestReceive_allUniqueUser',
  MeetingRequestReceiveAllWithUniqueUser = 'meetingRequestReceive_allWithUniqueUser',
  MeetingRequestReceiveCancelledCount = 'meetingRequestReceive_cancelledCount',
  MeetingRequestReceiveCancelledUniqueUser = 'meetingRequestReceive_cancelledUniqueUser',
  MeetingRequestReceiveCancelledWithUniqueUser = 'meetingRequestReceive_cancelledWithUniqueUser',
  MeetingRequestReceiveDeclinedCount = 'meetingRequestReceive_declinedCount',
  MeetingRequestReceiveDeclinedUniqueUser = 'meetingRequestReceive_declinedUniqueUser',
  MeetingRequestReceiveDeclinedWithUniqueUser = 'meetingRequestReceive_declinedWithUniqueUser',
  MeetingRequestReceiveExpiredCount = 'meetingRequestReceive_expiredCount',
  MeetingRequestReceiveExpiredUniqueUser = 'meetingRequestReceive_expiredUniqueUser',
  MeetingRequestReceiveExpiredWithUniqueUser = 'meetingRequestReceive_expiredWithUniqueUser',
  MeetingRequestReceivePendingCount = 'meetingRequestReceive_pendingCount',
  MeetingRequestReceivePendingUniqueUser = 'meetingRequestReceive_pendingUniqueUser',
  MeetingRequestReceivePendingWithUniqueUser = 'meetingRequestReceive_pendingWithUniqueUser',
  MeetingRequestAcceptedCount = 'meetingRequest_acceptedCount',
  MeetingRequestAcceptedUniqueUser = 'meetingRequest_acceptedUniqueUser',
  MeetingRequestAcceptedWithUniqueUser = 'meetingRequest_acceptedWithUniqueUser',
  MeetingRequestAllCount = 'meetingRequest_allCount',
  MeetingRequestAllUniqueUser = 'meetingRequest_allUniqueUser',
  MeetingRequestAllWithUniqueUser = 'meetingRequest_allWithUniqueUser',
  MeetingRequestCancelledCount = 'meetingRequest_cancelledCount',
  MeetingRequestCancelledUniqueUser = 'meetingRequest_cancelledUniqueUser',
  MeetingRequestCancelledWithUniqueUser = 'meetingRequest_cancelledWithUniqueUser',
  MeetingRequestDeclinedCount = 'meetingRequest_declinedCount',
  MeetingRequestDeclinedUniqueUser = 'meetingRequest_declinedUniqueUser',
  MeetingRequestDeclinedWithUniqueUser = 'meetingRequest_declinedWithUniqueUser',
  MeetingRequestExpiredCount = 'meetingRequest_expiredCount',
  MeetingRequestExpiredUniqueUser = 'meetingRequest_expiredUniqueUser',
  MeetingRequestExpiredWithUniqueUser = 'meetingRequest_expiredWithUniqueUser',
  MeetingRequestPendingCount = 'meetingRequest_pendingCount',
  MeetingRequestPendingUniqueUser = 'meetingRequest_pendingUniqueUser',
  MeetingRequestPendingWithUniqueUser = 'meetingRequest_pendingWithUniqueUser',
  MeetingAllCount = 'meeting_allCount',
  MeetingAllUnique = 'meeting_allUnique',
  MeetingAllUniqueUser = 'meeting_allUniqueUser',
  MeetingCanceledCount = 'meeting_canceledCount',
  MeetingCanceledUnique = 'meeting_canceledUnique',
  MeetingCanceledUniqueUser = 'meeting_canceledUniqueUser',
  MeetingConfirmedCount = 'meeting_confirmedCount',
  MeetingConfirmedUnique = 'meeting_confirmedUnique',
  MeetingConfirmedUniqueUser = 'meeting_confirmedUniqueUser',
  MeetingDeclinedCount = 'meeting_declinedCount',
  MeetingDeclinedUnique = 'meeting_declinedUnique',
  MeetingDeclinedUniqueUser = 'meeting_declinedUniqueUser',
  MeetingExpiredCount = 'meeting_expiredCount',
  MeetingExpiredUnique = 'meeting_expiredUnique',
  MeetingExpiredUniqueUser = 'meeting_expiredUniqueUser',
  MeetingNoShowCount = 'meeting_noShowCount',
  MeetingNoShowUnique = 'meeting_noShowUnique',
  MeetingNoShowUniqueUser = 'meeting_noShowUniqueUser',
  MeetingPendingCount = 'meeting_pendingCount',
  MeetingPendingUnique = 'meeting_pendingUnique',
  MeetingPendingUniqueUser = 'meeting_pendingUniqueUser',
  MeetingRescheduledCount = 'meeting_rescheduledCount',
  MeetingRescheduledUnique = 'meeting_rescheduledUnique',
  MeetingRescheduledUniqueUser = 'meeting_rescheduledUniqueUser',
  MessageReceiveAllCount = 'messageReceive_allCount',
  MessageReceiveAllUniqueUser = 'messageReceive_allUniqueUser',
  MessageReceiveChannelUnique = 'messageReceive_channelUnique',
  MessageReceivePrivateCount = 'messageReceive_privateCount',
  MessageReceivePrivateUniqueUser = 'messageReceive_privateUniqueUser',
  MessageReceivePrivateWithUniqueUser = 'messageReceive_privateWithUniqueUser',
  MessageReceivePublicCount = 'messageReceive_publicCount',
  MessageReceivePublicUniqueUser = 'messageReceive_publicUniqueUser',
  MessageAllCount = 'message_allCount',
  MessageAllUniqueUser = 'message_allUniqueUser',
  MessageChannelUnique = 'message_channelUnique',
  MessagePrivateCount = 'message_privateCount',
  MessagePrivateUniqueUser = 'message_privateUniqueUser',
  MessagePrivateWithUniqueUser = 'message_privateWithUniqueUser',
  MessagePublicCount = 'message_publicCount',
  MessagePublicUniqueUser = 'message_publicUniqueUser',
  NetworkActivityAllCount = 'networkActivity_allCount',
  NetworkActivityAllUnique = 'networkActivity_allUnique',
  NetworkActivityAllUniqueUser = 'networkActivity_allUniqueUser',
  NetworkActivityAllWithUniqueUser = 'networkActivity_allWithUniqueUser',
  PersonShowReceiveAllCount = 'personShowReceive_allCount',
  PersonShowReceiveAllUniqueUser = 'personShowReceive_allUniqueUser',
  PersonShowReceiveAllWithUniqueUser = 'personShowReceive_allWithUniqueUser',
  PersonShowReceiveAndroidCount = 'personShowReceive_androidCount',
  PersonShowReceiveAndroidUniqueUser = 'personShowReceive_androidUniqueUser',
  PersonShowReceiveAndroidWithUniqueUser = 'personShowReceive_androidWithUniqueUser',
  PersonShowReceiveIosCount = 'personShowReceive_iosCount',
  PersonShowReceiveIosUniqueUser = 'personShowReceive_iosUniqueUser',
  PersonShowReceiveIosWithUniqueUser = 'personShowReceive_iosWithUniqueUser',
  PersonShowReceiveWebCount = 'personShowReceive_webCount',
  PersonShowReceiveWebTeamCount = 'personShowReceive_webTeamCount',
  PersonShowReceiveWebTeamUniqueUser = 'personShowReceive_webTeamUniqueUser',
  PersonShowReceiveWebTeamWithUniqueUser = 'personShowReceive_webTeamWithUniqueUser',
  PersonShowReceiveWebUniqueUser = 'personShowReceive_webUniqueUser',
  PersonShowReceiveWebUserCount = 'personShowReceive_webUserCount',
  PersonShowReceiveWebUserUniqueUser = 'personShowReceive_webUserUniqueUser',
  PersonShowReceiveWebUserWithUniqueUser = 'personShowReceive_webUserWithUniqueUser',
  PersonShowReceiveWebWithUniqueUser = 'personShowReceive_webWithUniqueUser',
  PersonShowAllCount = 'personShow_allCount',
  PersonShowAllUniqueUser = 'personShow_allUniqueUser',
  PersonShowAllWithUniqueUser = 'personShow_allWithUniqueUser',
  PersonShowAndroidCount = 'personShow_androidCount',
  PersonShowAndroidUniqueUser = 'personShow_androidUniqueUser',
  PersonShowAndroidWithUniqueUser = 'personShow_androidWithUniqueUser',
  PersonShowIosCount = 'personShow_iosCount',
  PersonShowIosUniqueUser = 'personShow_iosUniqueUser',
  PersonShowIosWithUniqueUser = 'personShow_iosWithUniqueUser',
  PersonShowWebCount = 'personShow_webCount',
  PersonShowWebTeamCount = 'personShow_webTeamCount',
  PersonShowWebTeamUniqueUser = 'personShow_webTeamUniqueUser',
  PersonShowWebTeamWithUniqueUser = 'personShow_webTeamWithUniqueUser',
  PersonShowWebUniqueUser = 'personShow_webUniqueUser',
  PersonShowWebUserCount = 'personShow_webUserCount',
  PersonShowWebUserUniqueUser = 'personShow_webUserUniqueUser',
  PersonShowWebUserWithUniqueUser = 'personShow_webUserWithUniqueUser',
  PersonShowWebWithUniqueUser = 'personShow_webWithUniqueUser',
  PlanningBookmarkAllCount = 'planningBookmark_allCount',
  PlanningBookmarkAllUniqueUser = 'planningBookmark_allUniqueUser',
  PlanningPopularityAllCount = 'planningPopularity_allCount',
  PlanningPopularityAllUniqueUser = 'planningPopularity_allUniqueUser',
  PlanningPopularityAndroidCount = 'planningPopularity_androidCount',
  PlanningPopularityAndroidUniqueUser = 'planningPopularity_androidUniqueUser',
  PlanningPopularityIosCount = 'planningPopularity_iosCount',
  PlanningPopularityIosUniqueUser = 'planningPopularity_iosUniqueUser',
  PlanningPopularityTimestampMax = 'planningPopularity_timestampMax',
  PlanningPopularityTimestampMin = 'planningPopularity_timestampMin',
  PlanningPopularityWebCount = 'planningPopularity_webCount',
  PlanningPopularityWebTeamCount = 'planningPopularity_webTeamCount',
  PlanningPopularityWebTeamUniqueUser = 'planningPopularity_webTeamUniqueUser',
  PlanningPopularityWebUniqueUser = 'planningPopularity_webUniqueUser',
  PlanningPopularityWebUserCount = 'planningPopularity_webUserCount',
  PlanningPopularityWebUserUniqueUser = 'planningPopularity_webUserUniqueUser',
  PlanningStreamStartAllCount = 'planningStreamStart_allCount',
  PlanningStreamStartAllUniqueUser = 'planningStreamStart_allUniqueUser',
  PlanningStreamStartAndroidCount = 'planningStreamStart_androidCount',
  PlanningStreamStartAndroidUniqueUser = 'planningStreamStart_androidUniqueUser',
  PlanningStreamStartIosCount = 'planningStreamStart_iosCount',
  PlanningStreamStartIosUniqueUser = 'planningStreamStart_iosUniqueUser',
  PlanningStreamStartTimestampMax = 'planningStreamStart_timestampMax',
  PlanningStreamStartTimestampMin = 'planningStreamStart_timestampMin',
  PlanningStreamStartWebCount = 'planningStreamStart_webCount',
  PlanningStreamStartWebTeamCount = 'planningStreamStart_webTeamCount',
  PlanningStreamStartWebTeamUniqueUser = 'planningStreamStart_webTeamUniqueUser',
  PlanningStreamStartWebUniqueUser = 'planningStreamStart_webUniqueUser',
  PlanningStreamStartWebUserCount = 'planningStreamStart_webUserCount',
  PlanningStreamStartWebUserUniqueUser = 'planningStreamStart_webUserUniqueUser',
  PlanningStreamStopAllCount = 'planningStreamStop_allCount',
  PlanningStreamStopAllUniqueUser = 'planningStreamStop_allUniqueUser',
  PlanningStreamStopAndroidCount = 'planningStreamStop_androidCount',
  PlanningStreamStopAndroidUniqueUser = 'planningStreamStop_androidUniqueUser',
  PlanningStreamStopDurationAndroidAverage = 'planningStreamStop_durationAndroidAverage',
  PlanningStreamStopDurationAndroidSum = 'planningStreamStop_durationAndroidSum',
  PlanningStreamStopDurationAverage = 'planningStreamStop_durationAverage',
  PlanningStreamStopDurationIosAverage = 'planningStreamStop_durationIosAverage',
  PlanningStreamStopDurationIosSum = 'planningStreamStop_durationIosSum',
  PlanningStreamStopDurationSum = 'planningStreamStop_durationSum',
  PlanningStreamStopDurationWebAverage = 'planningStreamStop_durationWebAverage',
  PlanningStreamStopDurationWebSum = 'planningStreamStop_durationWebSum',
  PlanningStreamStopDurationWebTeamAverage = 'planningStreamStop_durationWebTeamAverage',
  PlanningStreamStopDurationWebTeamSum = 'planningStreamStop_durationWebTeamSum',
  PlanningStreamStopDurationWebUserAverage = 'planningStreamStop_durationWebUserAverage',
  PlanningStreamStopDurationWebUserSum = 'planningStreamStop_durationWebUserSum',
  PlanningStreamStopIosCount = 'planningStreamStop_iosCount',
  PlanningStreamStopIosUniqueUser = 'planningStreamStop_iosUniqueUser',
  PlanningStreamStopTimestampMax = 'planningStreamStop_timestampMax',
  PlanningStreamStopTimestampMin = 'planningStreamStop_timestampMin',
  PlanningStreamStopWebCount = 'planningStreamStop_webCount',
  PlanningStreamStopWebTeamCount = 'planningStreamStop_webTeamCount',
  PlanningStreamStopWebTeamUniqueUser = 'planningStreamStop_webTeamUniqueUser',
  PlanningStreamStopWebUniqueUser = 'planningStreamStop_webUniqueUser',
  PlanningStreamStopWebUserCount = 'planningStreamStop_webUserCount',
  PlanningStreamStopWebUserUniqueUser = 'planningStreamStop_webUserUniqueUser',
  PlanningStreamAllCount = 'planningStream_allCount',
  PlanningStreamAllUniqueUser = 'planningStream_allUniqueUser',
  PlanningStreamAndroidCount = 'planningStream_androidCount',
  PlanningStreamAndroidUniqueUser = 'planningStream_androidUniqueUser',
  PlanningStreamIosCount = 'planningStream_iosCount',
  PlanningStreamIosUniqueUser = 'planningStream_iosUniqueUser',
  PlanningStreamTimestampMax = 'planningStream_timestampMax',
  PlanningStreamTimestampMin = 'planningStream_timestampMin',
  PlanningStreamWebCount = 'planningStream_webCount',
  PlanningStreamWebTeamCount = 'planningStream_webTeamCount',
  PlanningStreamWebTeamUniqueUser = 'planningStream_webTeamUniqueUser',
  PlanningStreamWebUniqueUser = 'planningStream_webUniqueUser',
  PlanningStreamWebUserCount = 'planningStream_webUserCount',
  PlanningStreamWebUserUniqueUser = 'planningStream_webUserUniqueUser',
  PostLinkOpenAllCount = 'postLinkOpen_allCount',
  PostLinkOpenAllUniqueUser = 'postLinkOpen_allUniqueUser',
  PostLinkOpenAndroidCount = 'postLinkOpen_androidCount',
  PostLinkOpenAndroidUniqueUser = 'postLinkOpen_androidUniqueUser',
  PostLinkOpenIosCount = 'postLinkOpen_iosCount',
  PostLinkOpenIosUniqueUser = 'postLinkOpen_iosUniqueUser',
  PostLinkOpenWebCount = 'postLinkOpen_webCount',
  PostLinkOpenWebTeamCount = 'postLinkOpen_webTeamCount',
  PostLinkOpenWebTeamUniqueUser = 'postLinkOpen_webTeamUniqueUser',
  PostLinkOpenWebUniqueUser = 'postLinkOpen_webUniqueUser',
  PostLinkOpenWebUserCount = 'postLinkOpen_webUserCount',
  PostLinkOpenWebUserUniqueUser = 'postLinkOpen_webUserUniqueUser',
  ProductBookmarkAllCount = 'productBookmark_allCount',
  ProductBookmarkAllUniqueUser = 'productBookmark_allUniqueUser',
  ProductBookmarkTimestampMax = 'productBookmark_timestampMax',
  ProductBookmarkTimestampMin = 'productBookmark_timestampMin',
  ProductShowAllCount = 'productShow_allCount',
  ProductShowAllUniqueUser = 'productShow_allUniqueUser',
  ProductShowAndroidCount = 'productShow_androidCount',
  ProductShowAndroidUniqueUser = 'productShow_androidUniqueUser',
  ProductShowIosCount = 'productShow_iosCount',
  ProductShowIosUniqueUser = 'productShow_iosUniqueUser',
  ProductShowTimestampMax = 'productShow_timestampMax',
  ProductShowTimestampMin = 'productShow_timestampMin',
  ProductShowWebCount = 'productShow_webCount',
  ProductShowWebTeamCount = 'productShow_webTeamCount',
  ProductShowWebTeamUniqueUser = 'productShow_webTeamUniqueUser',
  ProductShowWebUniqueUser = 'productShow_webUniqueUser',
  ProductShowWebUserCount = 'productShow_webUserCount',
  ProductShowWebUserUniqueUser = 'productShow_webUserUniqueUser',
  RegistrationAbandonedCount = 'registration_abandonedCount',
  RegistrationAllCount = 'registration_allCount',
  RegistrationCanceledCount = 'registration_canceledCount',
  RegistrationCheckedInCount = 'registration_checkedInCount',
  RegistrationRegisteredCount = 'registration_registeredCount',
  SponsorShowAllCount = 'sponsorShow_allCount',
  SponsorShowAllUniqueUser = 'sponsorShow_allUniqueUser',
  SponsorShowAndroidCount = 'sponsorShow_androidCount',
  SponsorShowAndroidUniqueUser = 'sponsorShow_androidUniqueUser',
  SponsorShowIosCount = 'sponsorShow_iosCount',
  SponsorShowIosUniqueUser = 'sponsorShow_iosUniqueUser',
  SponsorShowTimestampMax = 'sponsorShow_timestampMax',
  SponsorShowTimestampMin = 'sponsorShow_timestampMin',
  SponsorShowWebCount = 'sponsorShow_webCount',
  SponsorShowWebTeamCount = 'sponsorShow_webTeamCount',
  SponsorShowWebTeamUniqueUser = 'sponsorShow_webTeamUniqueUser',
  SponsorShowWebUniqueUser = 'sponsorShow_webUniqueUser',
  SponsorShowWebUserCount = 'sponsorShow_webUserCount',
  SponsorShowWebUserUniqueUser = 'sponsorShow_webUserUniqueUser',
  StreamStartAllCount = 'streamStart_allCount',
  StreamStartAllUniqueUser = 'streamStart_allUniqueUser',
  StreamStartAndroidCount = 'streamStart_androidCount',
  StreamStartAndroidUniqueUser = 'streamStart_androidUniqueUser',
  StreamStartIosCount = 'streamStart_iosCount',
  StreamStartIosUniqueUser = 'streamStart_iosUniqueUser',
  StreamStartTimestampMax = 'streamStart_timestampMax',
  StreamStartTimestampMin = 'streamStart_timestampMin',
  StreamStartWebCount = 'streamStart_webCount',
  StreamStartWebTeamCount = 'streamStart_webTeamCount',
  StreamStartWebTeamUniqueUser = 'streamStart_webTeamUniqueUser',
  StreamStartWebUniqueUser = 'streamStart_webUniqueUser',
  StreamStartWebUserCount = 'streamStart_webUserCount',
  StreamStartWebUserUniqueUser = 'streamStart_webUserUniqueUser',
  StreamStopAllCount = 'streamStop_allCount',
  StreamStopAllUniqueUser = 'streamStop_allUniqueUser',
  StreamStopAndroidCount = 'streamStop_androidCount',
  StreamStopAndroidUniqueUser = 'streamStop_androidUniqueUser',
  StreamStopDurationAndroidAverage = 'streamStop_durationAndroidAverage',
  StreamStopDurationAndroidSum = 'streamStop_durationAndroidSum',
  StreamStopDurationAverage = 'streamStop_durationAverage',
  StreamStopDurationIosAverage = 'streamStop_durationIosAverage',
  StreamStopDurationIosSum = 'streamStop_durationIosSum',
  StreamStopDurationSum = 'streamStop_durationSum',
  StreamStopDurationWebAverage = 'streamStop_durationWebAverage',
  StreamStopDurationWebSum = 'streamStop_durationWebSum',
  StreamStopDurationWebTeamAverage = 'streamStop_durationWebTeamAverage',
  StreamStopDurationWebTeamSum = 'streamStop_durationWebTeamSum',
  StreamStopDurationWebUserAverage = 'streamStop_durationWebUserAverage',
  StreamStopDurationWebUserSum = 'streamStop_durationWebUserSum',
  StreamStopIosCount = 'streamStop_iosCount',
  StreamStopIosUniqueUser = 'streamStop_iosUniqueUser',
  StreamStopTimestampMax = 'streamStop_timestampMax',
  StreamStopTimestampMin = 'streamStop_timestampMin',
  StreamStopWebCount = 'streamStop_webCount',
  StreamStopWebTeamCount = 'streamStop_webTeamCount',
  StreamStopWebTeamUniqueUser = 'streamStop_webTeamUniqueUser',
  StreamStopWebUniqueUser = 'streamStop_webUniqueUser',
  StreamStopWebUserCount = 'streamStop_webUserCount',
  StreamStopWebUserUniqueUser = 'streamStop_webUserUniqueUser',
  UsageAllUniqueUser = 'usage_allUniqueUser',
  UsageAndroidUniqueUser = 'usage_androidUniqueUser',
  UsageIosUniqueUser = 'usage_iosUniqueUser',
  UsageWebTeamUniqueUser = 'usage_webTeamUniqueUser',
  UsageWebUniqueUser = 'usage_webUniqueUser',
  UsageWebUserUniqueUser = 'usage_webUserUniqueUser',
  VideoCallRoomAllCount = 'videoCallRoom_allCount',
  VideoCallRoomAllUniqueUser = 'videoCallRoom_allUniqueUser',
  VideoCallRoomAllWithUniqueUser = 'videoCallRoom_allWithUniqueUser',
  VideoCallRoomSucceededCount = 'videoCallRoom_succeededCount',
  VideoCallRoomSucceededDurationAverage = 'videoCallRoom_succeededDurationAverage',
  VideoCallRoomSucceededDurationSum = 'videoCallRoom_succeededDurationSum',
  VideoCallRoomSucceededUniqueUser = 'videoCallRoom_succeededUniqueUser',
  VideoCallRoomSucceededWithUniqueUser = 'videoCallRoom_succeededWithUniqueUser'
}

export enum Analytics_Source {
  NotScan = 'NotScan',
  Scan = 'Scan'
}

export type Analytics_SponsorShow = {
  __typename?: 'Analytics_SponsorShow';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_SponsorShowArray = {
  __typename?: 'Analytics_SponsorShowArray';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  sponsorId: Scalars['String'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_StreamStart = {
  __typename?: 'Analytics_StreamStart';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_StreamStartArray = {
  __typename?: 'Analytics_StreamStartArray';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  planningId?: Maybe<Scalars['String']>;
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_StreamStop = {
  __typename?: 'Analytics_StreamStop';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  durationAndroidAverage?: Maybe<Scalars['Float']>;
  durationAndroidSum?: Maybe<Scalars['Float']>;
  durationAverage?: Maybe<Scalars['Float']>;
  durationIosAverage?: Maybe<Scalars['Float']>;
  durationIosSum?: Maybe<Scalars['Float']>;
  durationSum?: Maybe<Scalars['Float']>;
  durationWebAverage?: Maybe<Scalars['Float']>;
  durationWebSum?: Maybe<Scalars['Float']>;
  durationWebTeamAverage?: Maybe<Scalars['Float']>;
  durationWebTeamSum?: Maybe<Scalars['Float']>;
  durationWebUserAverage?: Maybe<Scalars['Float']>;
  durationWebUserSum?: Maybe<Scalars['Float']>;
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_StreamStopArray = {
  __typename?: 'Analytics_StreamStopArray';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  androidCount: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  durationAndroidAverage?: Maybe<Scalars['Float']>;
  durationAndroidSum?: Maybe<Scalars['Float']>;
  durationAverage?: Maybe<Scalars['Float']>;
  durationIosAverage?: Maybe<Scalars['Float']>;
  durationIosSum?: Maybe<Scalars['Float']>;
  durationSum?: Maybe<Scalars['Float']>;
  durationWebAverage?: Maybe<Scalars['Float']>;
  durationWebSum?: Maybe<Scalars['Float']>;
  durationWebTeamAverage?: Maybe<Scalars['Float']>;
  durationWebTeamSum?: Maybe<Scalars['Float']>;
  durationWebUserAverage?: Maybe<Scalars['Float']>;
  durationWebUserSum?: Maybe<Scalars['Float']>;
  iosCount: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  planningId?: Maybe<Scalars['String']>;
  timestampMax?: Maybe<Scalars['Analytics_Date']>;
  timestampMin?: Maybe<Scalars['Analytics_Date']>;
  webCount: Scalars['Int'];
  webTeamCount: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserCount: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export enum Analytics_TimeUnit {
  Day = 'Day',
  Hour = 'Hour',
  Minute = 'Minute',
  Month = 'Month',
  Second = 'Second',
  Week = 'Week'
}

export type Analytics_Timeline = {
  __typename?: 'Analytics_Timeline';
  activity: Analytics_Activity;
  addOpen: Analytics_AddOpen;
  addOpenArray: Array<Analytics_AddOpenArray>;
  advertisementOpen: Analytics_AdvertisementOpen;
  advertisementOpenArray: Array<Analytics_AdvertisementOpenArray>;
  advertisementShow: Analytics_AdvertisementShow;
  advertisementShowArray: Array<Analytics_AdvertisementShowArray>;
  bookmark: Analytics_Bookmark;
  bookmarkReceive: Analytics_BookmarkReceive;
  bucket: Scalars['Analytics_Date'];
  channelOpen: Analytics_ChannelOpen;
  channelOpenArray: Array<Analytics_ChannelOpenArray>;
  connection: Analytics_Connection;
  connectionReceive: Analytics_ConnectionReceive;
  connectionRequest: Analytics_ConnectionRequest;
  connectionRequestReceive: Analytics_ConnectionRequestReceive;
  contact: Analytics_Contact;
  documentOpen: Analytics_DocumentOpen;
  documentOpenArray: Array<Analytics_DocumentOpenArray>;
  eventShow: Analytics_EventShow;
  eventViewShow: Analytics_EventViewShow;
  eventViewShowArray: Array<Analytics_EventViewShowArray>;
  exhibitorAdvertisementOpen: Analytics_ExhibitorAdvertisementOpen;
  exhibitorAdvertisementOpenArray: Array<Analytics_ExhibitorAdvertisementOpenArray>;
  exhibitorAdvertisementOpenReceive: Analytics_ExhibitorAdvertisementOpenReceive;
  exhibitorAdvertisementOpenReceiveArray: Array<Analytics_ExhibitorAdvertisementOpenReceiveArray>;
  exhibitorAdvertisementShow: Analytics_ExhibitorAdvertisementShow;
  exhibitorAdvertisementShowArray: Array<Analytics_ExhibitorAdvertisementShowArray>;
  exhibitorAdvertisementShowReceive: Analytics_ExhibitorAdvertisementShowReceive;
  exhibitorAdvertisementShowReceiveArray: Array<Analytics_ExhibitorAdvertisementShowReceiveArray>;
  exhibitorBookmark: Analytics_ExhibitorBookmark;
  exhibitorBookmarkArray: Array<Analytics_ExhibitorBookmarkArray>;
  exhibitorBookmarkReceive: Analytics_ExhibitorBookmarkReceive;
  exhibitorPopularity: Analytics_ExhibitorPopularity;
  exhibitorSelfShow: Analytics_ExhibitorSelfShow;
  exhibitorShow: Analytics_ExhibitorShow;
  exhibitorShowArray: Array<Analytics_ExhibitorShowArray>;
  exhibitorShowReceive: Analytics_ExhibitorShowReceive;
  interstitialAddShow: Analytics_InterstitialAddShow;
  interstitialAddShowArray: Array<Analytics_InterstitialAddShowArray>;
  meeting: Analytics_Meeting;
  meetingParticipant: Analytics_MeetingParticipant;
  meetingRequest: Analytics_MeetingRequest;
  meetingRequestReceive: Analytics_MeetingRequestReceive;
  message: Analytics_Message;
  messageReceive: Analytics_MessageReceive;
  networkActivity: Analytics_NetworkActivity;
  personShow: Analytics_PersonShow;
  personShowReceive: Analytics_PersonShowReceive;
  planningBookmark: Analytics_PlanningBookmark;
  planningPopularity: Analytics_PlanningPopularity;
  planningStream: Analytics_PlanningStream;
  planningStreamArray: Array<Analytics_PlanningStreamArray>;
  planningStreamStart: Analytics_PlanningStreamStart;
  planningStreamStartArray: Array<Analytics_PlanningStreamStartArray>;
  planningStreamStop: Analytics_PlanningStreamStop;
  planningStreamStopArray: Array<Analytics_PlanningStreamStopArray>;
  postLinkOpen: Analytics_PostLinkOpen;
  postLinkOpenArray: Array<Analytics_PostLinkOpenArray>;
  productBookmark: Analytics_ProductBookmark;
  productBookmarkArray: Array<Analytics_ProductBookmarkArray>;
  productShow: Analytics_ProductShow;
  productShowArray: Array<Analytics_ProductShowArray>;
  registration: Analytics_Registration;
  sponsorShow: Analytics_SponsorShow;
  sponsorShowArray: Array<Analytics_SponsorShowArray>;
  streamStart: Analytics_StreamStart;
  streamStartArray: Array<Analytics_StreamStartArray>;
  streamStop: Analytics_StreamStop;
  streamStopArray: Array<Analytics_StreamStopArray>;
  usage: Analytics_Usage;
  videoCallRoom: Analytics_VideoCallRoom;
};


export type Analytics_TimelineActivityArgs = {
  events?: InputMaybe<Array<Analytics_EventName>>;
};


export type Analytics_TimelineChannelOpenArgs = {
  channel?: InputMaybe<Scalars['String']>;
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineChannelOpenArrayArgs = {
  channel?: InputMaybe<Scalars['String']>;
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineDocumentOpenArgs = {
  documentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineDocumentOpenArrayArgs = {
  documentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineEventViewShowArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineEventViewShowArrayArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineExhibitorAdvertisementOpenArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineExhibitorAdvertisementOpenArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineExhibitorAdvertisementOpenReceiveArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineExhibitorAdvertisementOpenReceiveArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineExhibitorAdvertisementShowArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineExhibitorAdvertisementShowArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineExhibitorAdvertisementShowReceiveArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineExhibitorAdvertisementShowReceiveArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineExhibitorBookmarkArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineExhibitorBookmarkArrayArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineExhibitorBookmarkReceiveArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineExhibitorShowArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_TimelineExhibitorShowArrayArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_TimelineExhibitorShowReceiveArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_TimelinePlanningStreamArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelinePlanningStreamArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelinePlanningStreamStartArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelinePlanningStreamStartArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelinePlanningStreamStopArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelinePlanningStreamStopArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelinePostLinkOpenArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
  postLink?: InputMaybe<Scalars['String']>;
};


export type Analytics_TimelinePostLinkOpenArrayArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
  postLink?: InputMaybe<Scalars['String']>;
};


export type Analytics_TimelineProductBookmarkArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineProductBookmarkArrayArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineProductShowArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_TimelineProductShowArrayArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_TimelineStreamStartArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineStreamStartArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineStreamStopArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_TimelineStreamStopArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Analytics_Usage = {
  __typename?: 'Analytics_Usage';
  allUniqueUser: Scalars['Int'];
  androidUniqueUser: Scalars['Int'];
  iosUniqueUser: Scalars['Int'];
  webTeamUniqueUser: Scalars['Int'];
  webUniqueUser: Scalars['Int'];
  webUserUniqueUser: Scalars['Int'];
};

export type Analytics_Users = {
  __typename?: 'Analytics_Users';
  activity: Analytics_Activity;
  addOpen: Analytics_AddOpen;
  addOpenArray: Array<Analytics_AddOpenArray>;
  advertisementOpen: Analytics_AdvertisementOpen;
  advertisementOpenArray: Array<Analytics_AdvertisementOpenArray>;
  advertisementShow: Analytics_AdvertisementShow;
  advertisementShowArray: Array<Analytics_AdvertisementShowArray>;
  bookmark: Analytics_Bookmark;
  bookmarkReceive: Analytics_BookmarkReceive;
  channelOpen: Analytics_ChannelOpen;
  channelOpenArray: Array<Analytics_ChannelOpenArray>;
  connection: Analytics_Connection;
  connectionReceive: Analytics_ConnectionReceive;
  connectionRequest: Analytics_ConnectionRequest;
  connectionRequestReceive: Analytics_ConnectionRequestReceive;
  contact: Analytics_Contact;
  documentOpen: Analytics_DocumentOpen;
  documentOpenArray: Array<Analytics_DocumentOpenArray>;
  eventShow: Analytics_EventShow;
  eventViewShow: Analytics_EventViewShow;
  eventViewShowArray: Array<Analytics_EventViewShowArray>;
  exhibitorAdvertisementOpen: Analytics_ExhibitorAdvertisementOpen;
  exhibitorAdvertisementOpenArray: Array<Analytics_ExhibitorAdvertisementOpenArray>;
  exhibitorAdvertisementOpenReceive: Analytics_ExhibitorAdvertisementOpenReceive;
  exhibitorAdvertisementOpenReceiveArray: Array<Analytics_ExhibitorAdvertisementOpenReceiveArray>;
  exhibitorAdvertisementShow: Analytics_ExhibitorAdvertisementShow;
  exhibitorAdvertisementShowArray: Array<Analytics_ExhibitorAdvertisementShowArray>;
  exhibitorAdvertisementShowReceive: Analytics_ExhibitorAdvertisementShowReceive;
  exhibitorAdvertisementShowReceiveArray: Array<Analytics_ExhibitorAdvertisementShowReceiveArray>;
  exhibitorBookmark: Analytics_ExhibitorBookmark;
  exhibitorBookmarkArray: Array<Analytics_ExhibitorBookmarkArray>;
  exhibitorBookmarkReceive: Analytics_ExhibitorBookmarkReceive;
  exhibitorPopularity: Analytics_ExhibitorPopularity;
  exhibitorSelfShow: Analytics_ExhibitorSelfShow;
  exhibitorShow: Analytics_ExhibitorShow;
  exhibitorShowArray: Array<Analytics_ExhibitorShowArray>;
  exhibitorShowReceive: Analytics_ExhibitorShowReceive;
  interstitialAddShow: Analytics_InterstitialAddShow;
  interstitialAddShowArray: Array<Analytics_InterstitialAddShowArray>;
  meeting: Analytics_Meeting;
  meetingParticipant: Analytics_MeetingParticipant;
  meetingRequest: Analytics_MeetingRequest;
  meetingRequestReceive: Analytics_MeetingRequestReceive;
  message: Analytics_Message;
  messageReceive: Analytics_MessageReceive;
  networkActivity: Analytics_NetworkActivity;
  personShow: Analytics_PersonShow;
  personShowReceive: Analytics_PersonShowReceive;
  planningBookmark: Analytics_PlanningBookmark;
  planningPopularity: Analytics_PlanningPopularity;
  planningStream: Analytics_PlanningStream;
  planningStreamArray: Array<Analytics_PlanningStreamArray>;
  planningStreamStart: Analytics_PlanningStreamStart;
  planningStreamStartArray: Array<Analytics_PlanningStreamStartArray>;
  planningStreamStop: Analytics_PlanningStreamStop;
  planningStreamStopArray: Array<Analytics_PlanningStreamStopArray>;
  postLinkOpen: Analytics_PostLinkOpen;
  postLinkOpenArray: Array<Analytics_PostLinkOpenArray>;
  productBookmark: Analytics_ProductBookmark;
  productBookmarkArray: Array<Analytics_ProductBookmarkArray>;
  productShow: Analytics_ProductShow;
  productShowArray: Array<Analytics_ProductShowArray>;
  registration: Analytics_Registration;
  sponsorShow: Analytics_SponsorShow;
  sponsorShowArray: Array<Analytics_SponsorShowArray>;
  streamStart: Analytics_StreamStart;
  streamStartArray: Array<Analytics_StreamStartArray>;
  streamStop: Analytics_StreamStop;
  streamStopArray: Array<Analytics_StreamStopArray>;
  usage: Analytics_Usage;
  userId: Scalars['String'];
  videoCallRoom: Analytics_VideoCallRoom;
};


export type Analytics_UsersActivityArgs = {
  events?: InputMaybe<Array<Analytics_EventName>>;
};


export type Analytics_UsersChannelOpenArgs = {
  channel?: InputMaybe<Scalars['String']>;
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersChannelOpenArrayArgs = {
  channel?: InputMaybe<Scalars['String']>;
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersDocumentOpenArgs = {
  documentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersDocumentOpenArrayArgs = {
  documentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersEventViewShowArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersEventViewShowArrayArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersExhibitorAdvertisementOpenArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersExhibitorAdvertisementOpenArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersExhibitorAdvertisementOpenReceiveArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersExhibitorAdvertisementOpenReceiveArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersExhibitorAdvertisementShowArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersExhibitorAdvertisementShowArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersExhibitorAdvertisementShowReceiveArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersExhibitorAdvertisementShowReceiveArrayArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersExhibitorBookmarkArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersExhibitorBookmarkArrayArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersExhibitorBookmarkReceiveArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersExhibitorShowArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_UsersExhibitorShowArrayArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_UsersExhibitorShowReceiveArgs = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_UsersPlanningStreamArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersPlanningStreamArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersPlanningStreamStartArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersPlanningStreamStartArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersPlanningStreamStopArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersPlanningStreamStopArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersPostLinkOpenArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
  postLink?: InputMaybe<Scalars['String']>;
};


export type Analytics_UsersPostLinkOpenArrayArgs = {
  eventViewIds?: InputMaybe<Array<Scalars['ID']>>;
  postLink?: InputMaybe<Scalars['String']>;
};


export type Analytics_UsersProductBookmarkArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersProductBookmarkArrayArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersProductShowArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_UsersProductShowArrayArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Analytics_Source>;
};


export type Analytics_UsersStreamStartArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersStreamStartArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersStreamStopArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Analytics_UsersStreamStopArrayArgs = {
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Analytics_VideoCallRoom = {
  __typename?: 'Analytics_VideoCallRoom';
  allCount: Scalars['Int'];
  allUniqueUser: Scalars['Int'];
  allWithUniqueUser: Scalars['Int'];
  succeededCount: Scalars['Int'];
  succeededDurationAverage?: Maybe<Scalars['Float']>;
  succeededDurationSum?: Maybe<Scalars['Float']>;
  succeededUniqueUser: Scalars['Int'];
  succeededWithUniqueUser: Scalars['Int'];
};

export enum Analytics_WeekDay {
  Fri = 'Fri',
  Mon = 'Mon',
  Sat = 'Sat',
  Sun = 'Sun',
  Thu = 'Thu',
  Tue = 'Tue',
  Wed = 'Wed'
}

export type Auth_ApiKey = {
  __typename?: 'Auth_ApiKey';
  _id: Scalars['Auth_ObjectID'];
  createdAt: Scalars['Auth_DateTime'];
  label: Scalars['String'];
};

export type Auth_ApiKeyScopeInput = {
  adminOrg?: InputMaybe<Scalars['Boolean']>;
  selfExhibitor?: InputMaybe<Scalars['Boolean']>;
};

export type Auth_AuthMethodInterface = {
  order: Scalars['Int'];
};

export type Auth_AuthMethodUnion = Auth_BadgeAuthMethod | Auth_ComexposiumAuthMethod | Auth_GlEventAuthMethod | Auth_LoginPasswordAuthMethod | Auth_OAuthAuthMethod | Auth_SamlAuthMethod;

export type Auth_AuthMethodsResult = {
  __typename?: 'Auth_AuthMethodsResult';
  authMethods: Array<Maybe<Auth_AuthMethodUnion>>;
};

export type Auth_BadgeAuthMethod = Auth_AuthMethodInterface & {
  __typename?: 'Auth_BadgeAuthMethod';
  inputLabel?: Maybe<Auth_TextTranslation>;
  order: Scalars['Int'];
};

export type Auth_ChallengeResponseInput = {
  kind: Auth_MfaStrategyKind;
  totpToken?: InputMaybe<Scalars['String']>;
};

export type Auth_ComexposiumAuthMethod = Auth_AuthMethodInterface & {
  __typename?: 'Auth_ComexposiumAuthMethod';
  buttonLabel?: Maybe<Auth_TextTranslation>;
  comexposiumApplicationId?: Maybe<Scalars['String']>;
  comexposiumSalonId?: Maybe<Scalars['String']>;
  comexposiumSessionId?: Maybe<Scalars['String']>;
  inputLabel?: Maybe<Auth_TextTranslation>;
  order: Scalars['Int'];
};

export type Auth_Connexion = {
  __typename?: 'Auth_Connexion';
  accessToken: Scalars['String'];
  refreshToken?: Maybe<Scalars['String']>;
  session: Auth_Session;
};

export type Auth_Email = {
  __typename?: 'Auth_Email';
  address: Scalars['String'];
  createdAt: Scalars['Auth_DateTime'];
  isPrimary: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['Auth_DateTime']>;
  validatedAt?: Maybe<Scalars['Auth_DateTime']>;
};

export type Auth_GlEventAuthMethod = Auth_AuthMethodInterface & {
  __typename?: 'Auth_GLEventAuthMethod';
  buttonLabel?: Maybe<Auth_TextTranslation>;
  inputLabel?: Maybe<Auth_TextTranslation>;
  order: Scalars['Int'];
  redirectUrl?: Maybe<Scalars['String']>;
};

export enum Auth_Locale {
  EnUs = 'en_US',
  FrFr = 'fr_FR'
}

export type Auth_LoginPasswordAuthMethod = Auth_AuthMethodInterface & {
  __typename?: 'Auth_LoginPasswordAuthMethod';
  /** @deprecated This method is not supported for this auth method */
  canRegister: Scalars['Boolean'];
  inputLabel?: Maybe<Auth_TextTranslation>;
  order: Scalars['Int'];
};

export type Auth_Lookup = {
  __typename?: 'Auth_Lookup';
  alreadyRegistered: Scalars['Boolean'];
  emails: Array<Auth_LookupEmailMasked>;
  firstName?: Maybe<Scalars['String']>;
  hasAPassword: Scalars['Boolean'];
  isCommunityMember?: Maybe<Scalars['Boolean']>;
  isEmailValid: Scalars['Boolean'];
  isEmailValidate: Scalars['Boolean'];
  isEventMember?: Maybe<Scalars['Boolean']>;
  mfaStrategies: Array<Auth_MfaStrategy>;
  phones?: Maybe<Array<Auth_LookupPhoneMasked>>;
  registration?: Maybe<Scalars['Int']>;
  registrationStatus?: Maybe<Auth_RegistrationStatus>;
  upcomingEvent?: Maybe<Auth_LookupEvent>;
};

export type Auth_LookupEmailMasked = {
  __typename?: 'Auth_LookupEmailMasked';
  address: Scalars['String'];
};

export type Auth_LookupEvent = {
  __typename?: 'Auth_LookupEvent';
  id: Scalars['String'];
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type Auth_LookupPhoneMasked = {
  __typename?: 'Auth_LookupPhoneMasked';
  number: Scalars['String'];
};

export type Auth_MfaOnboardingUnion = Auth_TotpOnboarding;

export type Auth_MfaStrategy = {
  __typename?: 'Auth_MFAStrategy';
  createdAt: Scalars['Auth_DateTime'];
  kind: Auth_MfaStrategyKind;
  recoveryCode: Scalars['String'];
};

export enum Auth_MfaStrategyKind {
  Totp = 'TOTP'
}

export type Auth_OAuthAuthMethod = Auth_AuthMethodInterface & {
  __typename?: 'Auth_OAuthAuthMethod';
  buttonLabel?: Maybe<Auth_TextTranslation>;
  inputLabel?: Maybe<Auth_TextTranslation>;
  order: Scalars['Int'];
  provider: Scalars['String'];
  redirectUrl: Scalars['String'];
};

export type Auth_Phone = {
  __typename?: 'Auth_Phone';
  _id: Scalars['Auth_ObjectID'];
  createdAt: Scalars['Auth_DateTime'];
  id: Scalars['ID'];
  number: Scalars['String'];
  updatedAt?: Maybe<Scalars['Auth_DateTime']>;
  validatedAt?: Maybe<Scalars['Auth_DateTime']>;
};

export enum Auth_RegistrationStatus {
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  Registered = 'REGISTERED'
}

export type Auth_SamlAuthMethod = Auth_AuthMethodInterface & {
  __typename?: 'Auth_SAMLAuthMethod';
  buttonLabel?: Maybe<Auth_TextTranslation>;
  errorLabel?: Maybe<Auth_SamlAuthMethodErrorLabel>;
  identityProviderId?: Maybe<Scalars['String']>;
  inputLabel?: Maybe<Auth_TextTranslation>;
  order: Scalars['Int'];
};

export type Auth_SamlAuthMethodErrorLabel = {
  __typename?: 'Auth_SAMLAuthMethodErrorLabel';
  ssoDefault?: Maybe<Auth_TextTranslation>;
};

export type Auth_SendDeleteMeOtpPayload = {
  __typename?: 'Auth_SendDeleteMeOtpPayload';
  key: Scalars['String'];
};

export type Auth_Session = {
  __typename?: 'Auth_Session';
  _id: Scalars['Auth_ObjectID'];
  id: Scalars['ID'];
  user: Auth_User;
};

export type Auth_TotpOnboarding = {
  __typename?: 'Auth_TOTPOnboarding';
  keyUri: Scalars['String'];
  secret: Scalars['String'];
};

export type Auth_TextTranslation = {
  __typename?: 'Auth_TextTranslation';
  locale: Scalars['String'];
  value: Scalars['String'];
};

export type Auth_User = {
  __typename?: 'Auth_User';
  _id: Scalars['Auth_ObjectID'];
  apiKeys: Array<Auth_ApiKey>;
  coreApiId?: Maybe<Scalars['String']>;
  createdAt: Scalars['Auth_DateTime'];
  emails: Array<Auth_Email>;
  /** Return always true if the session is in a SSO context */
  hasPassword: Scalars['Boolean'];
  id: Scalars['ID'];
  mfaStrategies: Array<Auth_MfaStrategy>;
  phones: Array<Auth_Phone>;
  updatedAt?: Maybe<Scalars['Auth_DateTime']>;
};

export type Backstage_GraphQlError = {
  __typename?: 'Backstage_GraphQLError';
  locations?: Maybe<Array<Backstage_GraphQlErrorLocation>>;
  message: Scalars['String'];
  path?: Maybe<Array<Scalars['String']>>;
};

export type Backstage_GraphQlErrorLocation = {
  __typename?: 'Backstage_GraphQLErrorLocation';
  column: Scalars['Int'];
  line: Scalars['Int'];
};

export type Backstage_JoinRoomPayload = {
  __typename?: 'Backstage_JoinRoomPayload';
  data?: Maybe<Scalars['String']>;
  errors: Array<Backstage_GraphQlError>;
  role?: Maybe<Backstage_RoomRole>;
};

export type Backstage_Room = {
  __typename?: 'Backstage_Room';
  activeScene?: Maybe<Backstage_Scene>;
  capacity: Scalars['Int'];
  id: Scalars['ID'];
  isStreaming: Scalars['Boolean'];
  name: Scalars['String'];
  scenes: Array<Backstage_Scene>;
};

/** The role assigned to the user in a backstage room */
export enum Backstage_RoomRole {
  Moderator = 'MODERATOR',
  Speaker = 'SPEAKER',
  Viewer = 'VIEWER'
}

export type Backstage_Scene = {
  __typename?: 'Backstage_Scene';
  data?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  room: Backstage_Room;
};

export type Backstage_StartLive = {
  __typename?: 'Backstage_StartLive';
  /** If the operation was successful */
  success: Scalars['Boolean'];
};

export type Backstage_StartLivePayload = {
  __typename?: 'Backstage_StartLivePayload';
  data?: Maybe<Backstage_StartLive>;
  errors: Array<Backstage_GraphQlError>;
};

export type Backstage_StopLive = {
  __typename?: 'Backstage_StopLive';
  /** If the operation was successful */
  success: Scalars['Boolean'];
};

export type Backstage_StopLivePayload = {
  __typename?: 'Backstage_StopLivePayload';
  data?: Maybe<Backstage_StopLive>;
  errors: Array<Backstage_GraphQlError>;
};

export type Backstage_UpdateScenePayload = {
  __typename?: 'Backstage_UpdateScenePayload';
  data?: Maybe<Backstage_Scene>;
  errors: Array<Backstage_GraphQlError>;
};

/** An activity */
export type Chat_Activity = {
  __typename?: 'Chat_Activity';
  /** How many channel have unread messages */
  channelWithUnreadMessageCount: Scalars['Int'];
  user: Chat_User;
};

export type Chat_Bot = Chat_ExternalRessourceInterface & {
  __typename?: 'Chat_Bot';
  displayName: Scalars['String'];
  id: Scalars['String'];
  pictureUrl?: Maybe<Scalars['String']>;
};

export type Chat_Channel = {
  __typename?: 'Chat_Channel';
  /** How many people are within the channel */
  channelUserCount: Scalars['Int'];
  /** People within the channel */
  channelUsers: Array<Chat_ChannelUser>;
  communityId?: Maybe<Scalars['String']>;
  createdAt: Scalars['Chat_DateTime'];
  /** The channel text description */
  description?: Maybe<Scalars['String']>;
  /** @deprecated Use interactionsConfig instead */
  enabledInteractions: Array<Chat_ChannelInteractionType>;
  externalLinks: Array<Chat_ExternalLink>;
  /** The channel unique id, should be stored by the caller if needed */
  id: Scalars['Chat_UUID'];
  /** @deprecated Use imageUrl instead */
  imageFile?: Maybe<Chat_File>;
  /** @deprecated Use imageUrl instead */
  imageFile_id?: Maybe<Scalars['Chat_ObjectID']>;
  imageUrl?: Maybe<Scalars['String']>;
  interactionsConfig: Array<Chat_ChannelInteractionConfigUnion>;
  /** @deprecated Use interactionsConfig instead */
  interactionsOrder: Array<Chat_ChannelInteractionType>;
  isClosed: Scalars['Boolean'];
  /**
   * Whether or not the channel is publicly listable
   * @deprecated Use permissions/options instead
   */
  isPrivate: Scalars['Boolean'];
  /** Message count within this channel */
  messageCount: Scalars['Int'];
  /** Messages within this channel */
  messages: Array<Chat_Message>;
  /** The default channel name string */
  name?: Maybe<Scalars['String']>;
  /** Describe what a user can do on a specific channel */
  right: Chat_Right;
  /** The channel name from the stored translations, in the preferred language (user language if present otherwise language from headers). If the translations are not added or the preferred language can't be inferred, it'll be null */
  translatedName?: Maybe<Scalars['String']>;
  translations: Array<Chat_ChannelTranslation>;
  type: Chat_ChannelType;
  /** People typings within the channel */
  typingChannelUsers: Array<Chat_ChannelUser>;
  updatedAt: Scalars['Chat_DateTime'];
  /** Shortcut to get directly users */
  users: Array<Chat_User>;
};


export type Chat_ChannelChannelUsersArgs = {
  pagination?: InputMaybe<Chat_OffsetPaginationInput>;
};


export type Chat_ChannelMessageCountArgs = {
  types?: InputMaybe<Array<InputMaybe<Chat_MessageType>>>;
};


export type Chat_ChannelMessagesArgs = {
  filters?: InputMaybe<Array<Chat_MessageFilterInput>>;
  pagination?: Chat_CursorPaginationInput;
  sort?: InputMaybe<Array<Chat_MessageSortInput>>;
};


export type Chat_ChannelUsersArgs = {
  externalRessourceTypes?: InputMaybe<Array<Chat_ExternalRessourceType>>;
  pagination?: InputMaybe<Chat_OffsetPaginationInput>;
};

export type Chat_ChannelInteractionChatConfig = Chat_ChannelInteractionConfigInterface & {
  __typename?: 'Chat_ChannelInteractionChatConfig';
  enabled: Scalars['Boolean'];
};

export type Chat_ChannelInteractionConfigEmbeddedWebviewDataInput = {
  viewId: Scalars['String'];
};

export type Chat_ChannelInteractionConfigInput = {
  embeddedWebviewData?: InputMaybe<Chat_ChannelInteractionConfigEmbeddedWebviewDataInput>;
  enabled: Scalars['Boolean'];
  type: Chat_ChannelInteractionType;
};

export type Chat_ChannelInteractionConfigInterface = {
  enabled: Scalars['Boolean'];
};

export type Chat_ChannelInteractionConfigUnion = Chat_ChannelInteractionChatConfig | Chat_ChannelInteractionEmbeddedWebviewConfig | Chat_ChannelInteractionPollsConfig | Chat_ChannelInteractionQuestionsConfig;

export type Chat_ChannelInteractionEmbeddedWebviewConfig = Chat_ChannelInteractionConfigInterface & {
  __typename?: 'Chat_ChannelInteractionEmbeddedWebviewConfig';
  enabled: Scalars['Boolean'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type Chat_ChannelInteractionPollsConfig = Chat_ChannelInteractionConfigInterface & {
  __typename?: 'Chat_ChannelInteractionPollsConfig';
  enabled: Scalars['Boolean'];
};

export type Chat_ChannelInteractionQuestionsConfig = Chat_ChannelInteractionConfigInterface & {
  __typename?: 'Chat_ChannelInteractionQuestionsConfig';
  enabled: Scalars['Boolean'];
};

export enum Chat_ChannelInteractionType {
  Chat = 'CHAT',
  EmbeddedWebview = 'EMBEDDED_WEBVIEW',
  Polls = 'POLLS',
  Questions = 'QUESTIONS'
}

/** Channel details translation in a language */
export type Chat_ChannelTranslation = {
  __typename?: 'Chat_ChannelTranslation';
  language: Chat_LanguageEnum;
  name?: Maybe<Scalars['String']>;
};

export type Chat_ChannelTranslationInput = {
  language: Chat_LanguageEnum;
  name?: InputMaybe<Scalars['String']>;
};

export enum Chat_ChannelType {
  Feed = 'FEED',
  Livestream = 'LIVESTREAM',
  Messaging = 'MESSAGING',
  Team = 'TEAM'
}

/** Some kind of link between a user and a channel */
export type Chat_ChannelUser = {
  __typename?: 'Chat_ChannelUser';
  channel: Chat_Channel;
  /** A pretty display name for the channel */
  channelDisplayName: Scalars['String'];
  channelId: Scalars['Chat_UUID'];
  /** The date the user entered the channel */
  createdAt: Scalars['Chat_DateTime'];
  /** The date the user leaved the channel */
  deletedAt?: Maybe<Scalars['Chat_DateTime']>;
  hasLeaved: Scalars['Boolean'];
  id: Scalars['ID'];
  /** If true, the user is allowed to edit the channel */
  isChannelAdmin: Scalars['Boolean'];
  isMuted: Scalars['Boolean'];
  /** If true, the user is currently typing */
  isTyping: Scalars['Boolean'];
  /** The latest activity date, aka: probably the thing you should use to sort your channels */
  latestActivityAt?: Maybe<Scalars['Chat_DateTime']>;
  /** The latest message seen by this user within this channel */
  latestMessageSeen?: Maybe<Chat_Message>;
  /** The latest message id seen by this user within this channel */
  latestMessageSeenId?: Maybe<Scalars['Chat_ObjectID']>;
  /** The count of messages the user has not seen yet within this channel */
  notSeenMessageCount: Scalars['Int'];
  /** The messages the user has not seen yet within this channel sorted by insertion date */
  notSeenMessages: Array<Chat_Message>;
  profileRedirection?: Maybe<Chat_ProfileRedirectionUnion>;
  updatedAt: Scalars['Chat_DateTime'];
  user: Chat_User;
  userId: Scalars['String'];
};


/** Some kind of link between a user and a channel */
export type Chat_ChannelUserNotSeenMessagesArgs = {
  pagination?: Chat_CursorPaginationInput;
};

export type Chat_ChannelUserPermissions = {
  isChannelAdmin?: InputMaybe<Scalars['Boolean']>;
};

export type Chat_Community = Chat_ExternalRessourceInterface & {
  __typename?: 'Chat_Community';
  displayName: Scalars['String'];
  id: Scalars['String'];
  pictureUrl?: Maybe<Scalars['String']>;
};

export type Chat_CommunityExhibitorProfileRedirection = {
  __typename?: 'Chat_CommunityExhibitorProfileRedirection';
  communityId: Scalars['ID'];
  communitySlug: Scalars['String'];
  /** return exhibitor id */
  id: Scalars['ID'];
};

export type Chat_CommunityProfileRedirection = {
  __typename?: 'Chat_CommunityProfileRedirection';
  communityId: Scalars['ID'];
  communitySlug: Scalars['String'];
  /** return community profile id */
  id: Scalars['ID'];
};

export type Chat_ConnectionProfileRedirection = {
  __typename?: 'Chat_ConnectionProfileRedirection';
  /** return connection id */
  id: Scalars['ID'];
  /** return user id linked to the connection */
  userId: Scalars['ID'];
};

export type Chat_CreateChannelInput = {
  communityId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** @deprecated use interactionsConfig instead */
  enabledInteractions?: InputMaybe<Array<Chat_ChannelInteractionType>>;
  externalLinks?: InputMaybe<Array<Chat_ExternalLinkInput>>;
  interactionsConfig?: InputMaybe<Array<Chat_ChannelInteractionConfigInput>>;
  /** @deprecated use interactionsConfig instead */
  interactionsOrder?: InputMaybe<Array<Chat_ChannelInteractionType>>;
  /** @deprecated use type field instead */
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  translations?: InputMaybe<Array<Chat_ChannelTranslationInput>>;
  type?: InputMaybe<Chat_ChannelType>;
};

export type Chat_CreateInitialMessageInput = {
  files?: Array<Chat_MessageFileInput>;
  mentions?: Array<Chat_MessageMentionInput>;
  /** If this is set to a value, it will create a thread, but creating a thread within a thread will throw an error */
  parentId?: InputMaybe<Scalars['Chat_ObjectID']>;
  /** The text content of the message, optional since some messages may only have files attached */
  textContent?: InputMaybe<Scalars['String']>;
};

export type Chat_CreateMessageInput = {
  attachments?: Array<Chat_MessageAttachmentInput>;
  channelId: Scalars['Chat_UUID'];
  files?: Array<Chat_MessageFileInput>;
  mentions?: Array<Chat_MessageMentionInput>;
  /** If this is set to a value, it will create a thread, but creating a thread within a thread will throw an error */
  parentId?: InputMaybe<Scalars['Chat_ObjectID']>;
  /** The text content of the message, optional since some messages may only have files attached */
  textContent?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Chat_MessageType>;
};

export type Chat_CursorPaginationInput = {
  /** Get results after this id */
  after?: InputMaybe<Scalars['Chat_ObjectID']>;
  /** Get results before this id */
  before?: InputMaybe<Scalars['Chat_ObjectID']>;
  /** Get at most this result count */
  limit: Scalars['Int'];
};

export type Chat_Emoji = {
  __typename?: 'Chat_Emoji';
  char: Scalars['String'];
  name: Scalars['String'];
};

export type Chat_EmojiCategory = {
  __typename?: 'Chat_EmojiCategory';
  emojis: Array<Chat_Emoji>;
  name: Scalars['String'];
};

export type Chat_Event = Chat_ExternalRessourceInterface & {
  __typename?: 'Chat_Event';
  displayName: Scalars['String'];
  id: Scalars['String'];
  pictureUrl?: Maybe<Scalars['String']>;
};

export type Chat_EventExhibitorProfileRedirection = {
  __typename?: 'Chat_EventExhibitorProfileRedirection';
  eventId: Scalars['ID'];
  eventSlug: Scalars['String'];
  /** return connection id */
  id: Scalars['ID'];
};

export type Chat_EventProfileRedirection = {
  __typename?: 'Chat_EventProfileRedirection';
  eventId: Scalars['ID'];
  eventSlug: Scalars['String'];
  /** return event profile id */
  id: Scalars['ID'];
};

export type Chat_Exhibitor = Chat_ExternalRessourceInterface & {
  __typename?: 'Chat_Exhibitor';
  displayName: Scalars['String'];
  id: Scalars['String'];
  pictureUrl?: Maybe<Scalars['String']>;
};

export type Chat_ExternalLink = {
  __typename?: 'Chat_ExternalLink';
  deleted: Scalars['Boolean'];
  id: Scalars['String'];
  type: Chat_ExternalLinkType;
};

export type Chat_ExternalLinkInput = {
  id: Scalars['String'];
  type: Chat_ExternalLinkType;
};

export enum Chat_ExternalLinkType {
  Backstage = 'BACKSTAGE',
  Community = 'COMMUNITY',
  Event = 'EVENT',
  Meeting = 'MEETING',
  Planning = 'PLANNING',
  View = 'VIEW'
}

export type Chat_ExternalMessageAttachment = {
  __typename?: 'Chat_ExternalMessageAttachment';
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  type: Scalars['String'];
};

export type Chat_ExternalRessourceInterface = {
  displayName: Scalars['String'];
  id: Scalars['String'];
  pictureUrl?: Maybe<Scalars['String']>;
};

export enum Chat_ExternalRessourceType {
  Bot = 'BOT',
  Community = 'COMMUNITY',
  Event = 'EVENT',
  Exhibitor = 'EXHIBITOR',
  User = 'USER'
}

export type Chat_ExternalUser = Chat_ExternalRessourceInterface & {
  __typename?: 'Chat_ExternalUser';
  displayName: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  pictureUrl?: Maybe<Scalars['String']>;
};

export type Chat_File = {
  __typename?: 'Chat_File';
  contentLength: Scalars['Int'];
  contentType: Scalars['String'];
  createdAt: Scalars['Chat_DateTime'];
  creator: Chat_User;
  creatorId: Scalars['String'];
  downloadUrl: Scalars['String'];
  id: Scalars['Chat_ObjectID'];
  name: Scalars['String'];
  postUploadUrl: Chat_UploadUrl;
  torrent?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Chat_DateTime']>;
  /** @deprecated Use postUploadUrl instead */
  uploadUrl: Scalars['String'];
};

export type Chat_FileInput = {
  contentLength: Scalars['Int'];
  contentType: Scalars['String'];
  name: Scalars['String'];
};

export enum Chat_LanguageEnum {
  ArAe = 'ar_AE',
  BgBg = 'bg_BG',
  CaEs = 'ca_ES',
  CsCz = 'cs_CZ',
  CyGb = 'cy_GB',
  DaDk = 'da_DK',
  DeDe = 'de_DE',
  ElGr = 'el_GR',
  EnUs = 'en_US',
  EsEs = 'es_ES',
  EtEe = 'et_EE',
  FiFi = 'fi_FI',
  FrCa = 'fr_CA',
  FrFr = 'fr_FR',
  GaIe = 'ga_IE',
  HrHr = 'hr_HR',
  HuHu = 'hu_HU',
  IdId = 'id_ID',
  ItIt = 'it_IT',
  JaJp = 'ja_JP',
  KoKr = 'ko_KR',
  LtLt = 'lt_LT',
  LvLv = 'lv_LV',
  MtMt = 'mt_MT',
  NlNl = 'nl_NL',
  PlPl = 'pl_PL',
  PtBr = 'pt_BR',
  PtPt = 'pt_PT',
  RoRo = 'ro_RO',
  RuRu = 'ru_RU',
  SkSk = 'sk_SK',
  SlSi = 'sl_SI',
  SvSe = 'sv_SE',
  ThTh = 'th_TH',
  ViVn = 'vi_VN',
  ZhCn = 'zh_CN'
}

export type Chat_Message = {
  __typename?: 'Chat_Message';
  attachments: Array<Chat_MessageAttachmentUnion>;
  channel: Chat_Channel;
  channelId: Scalars['Chat_UUID'];
  channelUser?: Maybe<Chat_ChannelUser>;
  channelUserId?: Maybe<Scalars['Chat_ObjectID']>;
  /** Get the replied messages. Filled when someone reply to a message */
  children: Array<Chat_Message>;
  /** Get number of replies */
  childrenCount: Scalars['Int'];
  /** The message text content */
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['Chat_DateTime'];
  deleted: Scalars['Boolean'];
  files: Array<Chat_MessageFile>;
  id: Scalars['ID'];
  links: Array<Chat_MessageLink>;
  mentions: Array<Chat_MessageMention>;
  ownVote: Chat_VoteState;
  /** If this is not null it means the message is part of a thread */
  parent?: Maybe<Chat_Message>;
  /** If this is not null it means the message is part of a thread */
  parentId?: Maybe<Scalars['Chat_ObjectID']>;
  reactions: Array<Chat_MessageReaction>;
  score: Scalars['Int'];
  /** A list of users who have seen the message */
  seenBy: Array<Chat_ChannelUser>;
  /** Count of users who have seen the message */
  seenByCount: Scalars['Int'];
  /**
   * The message text content
   * @deprecated use content
   */
  textContent?: Maybe<Scalars['String']>;
  /** The message type */
  type: Scalars['String'];
  /** Last update date */
  updatedAt: Scalars['Chat_DateTime'];
  user?: Maybe<Chat_User>;
  userId?: Maybe<Scalars['String']>;
  videoCallRoom?: Maybe<Chat_VideoCallRoom>;
};


export type Chat_MessageChildrenArgs = {
  pagination?: Chat_CursorPaginationInput;
  sort?: InputMaybe<Chat_MessageSortInput>;
};


export type Chat_MessageSeenByArgs = {
  pagination?: Chat_OffsetPaginationInput;
};

export type Chat_MessageAttachmentInput = {
  id?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Chat_MessageAttachmentUnion = Chat_ExternalMessageAttachment;

export type Chat_MessageFile = {
  __typename?: 'Chat_MessageFile';
  comment?: Maybe<Scalars['String']>;
  file: Chat_File;
  fileId: Scalars['Chat_ObjectID'];
};

export type Chat_MessageFileInput = {
  comment?: InputMaybe<Scalars['String']>;
  fileId: Scalars['Chat_ObjectID'];
};

export type Chat_MessageFilterInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  types?: InputMaybe<Array<InputMaybe<Chat_MessageType>>>;
};

export type Chat_MessageLink = {
  __typename?: 'Chat_MessageLink';
  author?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Chat_DateTime']>;
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  position: Chat_MessageMetaPosition;
  publisher?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type Chat_MessageMention = {
  __typename?: 'Chat_MessageMention';
  /** The position of the meta within the text so the message display can be enriched */
  position: Chat_MessageMetaPosition;
  profileRedirection?: Maybe<Chat_ProfileRedirectionUnion>;
  user: Chat_User;
  userId: Scalars['String'];
};

export type Chat_MessageMentionInput = {
  /** The position of the meta within the text so the message display can be enriched */
  position: Chat_MessageMetaPositionInput;
  userId: Scalars['String'];
};

/** The position of the meta within the textContent */
export type Chat_MessageMetaPosition = {
  __typename?: 'Chat_MessageMetaPosition';
  /** The position where the meta ends within the textContent */
  end: Scalars['Int'];
  /** The position where the meta begin within the textContent */
  start: Scalars['Int'];
};

export type Chat_MessageMetaPositionInput = {
  /** The position where the meta ends within the textContent */
  end: Scalars['Int'];
  /** The position where the meta begin within the textContent */
  start: Scalars['Int'];
};

export type Chat_MessageReaction = {
  __typename?: 'Chat_MessageReaction';
  channelUsers: Array<Chat_ChannelUser>;
  /** The emoji of the reaction */
  char: Scalars['String'];
  count: Scalars['Int'];
  /** The name of the reaction */
  name: Scalars['String'];
};

export enum Chat_MessageSortField {
  Score = 'SCORE'
}

export type Chat_MessageSortInput = {
  field: Chat_MessageSortField;
  order: Chat_SortOrder;
};

export enum Chat_MessageType {
  Question = 'QUESTION',
  Regular = 'REGULAR'
}

export type Chat_OffsetPaginationInput = {
  /** Get at most this result count */
  limit: Scalars['Int'];
  /** Skip that much of results */
  offset?: Scalars['Int'];
};

export type Chat_OwnedUserFiltersInput = {
  /** A list of users ids to filter on */
  ids?: InputMaybe<Array<Scalars['String']>>;
  /** Returned only users that have channelUsers linked to it */
  mustHaveChannelUsers: Scalars['Boolean'];
};

export type Chat_ProfileRedirectionUnion = Chat_CommunityExhibitorProfileRedirection | Chat_CommunityProfileRedirection | Chat_ConnectionProfileRedirection | Chat_EventExhibitorProfileRedirection | Chat_EventProfileRedirection | Chat_UserProfileRedirection;

export type Chat_PublicChannelFilterInput = {
  /** @deprecated use externalLinks */
  externalLink?: InputMaybe<Chat_ExternalLinkInput>;
  /** Perform a filter between all externalLinks provided */
  externalLinks?: InputMaybe<Array<Chat_ExternalLinkInput>>;
  ids?: InputMaybe<Array<Scalars['Chat_UUID']>>;
};

export type Chat_PublicChannelWrapper = {
  __typename?: 'Chat_PublicChannelWrapper';
  channel: Chat_Channel;
  channelUser?: Maybe<Chat_ChannelUser>;
  joined: Scalars['Boolean'];
};

/** The information to remove link on the message */
export type Chat_RemoveLinkOnMessageInput = {
  asUserId: Scalars['String'];
  linkUrl: Scalars['String'];
  messageId: Scalars['Chat_ObjectID'];
};

export type Chat_RemoveLinkOnMessagePayload = {
  __typename?: 'Chat_RemoveLinkOnMessagePayload';
  message: Chat_Message;
};

/**
 * *canComment*: the user can reply to a message or answer to a post in a feed;
 * *canModerate*: the user can delete messages;
 * *canPost*: the user can post a message or post in a feed;
 * *canReact*: the user can add a reaction on a message or in a feed;
 */
export type Chat_Right = {
  __typename?: 'Chat_Right';
  canComment: Scalars['Boolean'];
  canModerate: Scalars['Boolean'];
  canPost: Scalars['Boolean'];
  canReact: Scalars['Boolean'];
};

export enum Chat_SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** What to update on the message */
export type Chat_UpdateChannelInput = {
  /** Send undefined to leave as is, or null to remove */
  description?: InputMaybe<Scalars['String']>;
  /** @deprecated use interactionsConfig instead - Update the enabled interactions and their order */
  enabledInteractions?: InputMaybe<Array<Chat_ChannelInteractionType>>;
  /** Send undefined to leave as is, or null to remove */
  imageUrl?: InputMaybe<Scalars['String']>;
  interactionsConfig?: InputMaybe<Array<Chat_ChannelInteractionConfigInput>>;
  /** @deprecated use interactionsConfig instead - Update the enabled interactions and their order */
  interactionsOrder?: InputMaybe<Array<Chat_ChannelInteractionType>>;
  /** Send undefined to leave as is, or a boolean to change his value, null is not allowed */
  name?: InputMaybe<Scalars['String']>;
  /** Translations for channel meta fields like name */
  translations?: InputMaybe<Array<Chat_ChannelTranslationInput>>;
};

/** The information to update on the message */
export type Chat_UpdateMessageInput = {
  files?: InputMaybe<Array<Chat_MessageFileInput>>;
  mentions?: InputMaybe<Array<Chat_MessageMentionInput>>;
  textContent?: InputMaybe<Scalars['String']>;
};

export type Chat_UploadUrl = {
  __typename?: 'Chat_UploadUrl';
  fields: Array<Chat_UploadUrlField>;
  maxSizeInBytes: Scalars['Int'];
  url: Scalars['String'];
};

export type Chat_UploadUrlField = {
  __typename?: 'Chat_UploadUrlField';
  name: Scalars['String'];
  value: Scalars['String'];
};

/** Metadata contained in a url */
export type Chat_UrlMetadata = {
  __typename?: 'Chat_UrlMetadata';
  author?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Chat_DateTime']>;
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
  publisher?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** A chat user */
export type Chat_User = {
  __typename?: 'Chat_User';
  /** How many channel user is linked to this user */
  channelUserCount: Scalars['Int'];
  /** How many channel have unread messages */
  channelWithUnreadMessageCount: Scalars['Int'];
  /** Channels linked to this user */
  channels: Array<Chat_Channel>;
  /** Channels users linked to this user */
  channelsUsers: Array<Chat_ChannelUser>;
  /** The user creation date */
  createdAt: Scalars['Chat_DateTime'];
  /** The linked external ressource, can be null if the backend did not respond or if down for any reason */
  externalRessource?: Maybe<Chat_ExternalRessourceInterface>;
  id: Scalars['ID'];
  unreadMessageCount: Scalars['Int'];
  /** The user last update date */
  updatedAt: Scalars['Chat_DateTime'];
};


/** A chat user */
export type Chat_UserChannelsArgs = {
  pagination?: Chat_OffsetPaginationInput;
};


/** A chat user */
export type Chat_UserChannelsUsersArgs = {
  channels_ids?: InputMaybe<Array<Scalars['Chat_UUID']>>;
  latestActivityAfter?: InputMaybe<Scalars['Chat_DateTime']>;
  pagination?: InputMaybe<Chat_OffsetPaginationInput>;
};

export type Chat_UserProfileRedirection = {
  __typename?: 'Chat_UserProfileRedirection';
  /** return user id */
  id: Scalars['ID'];
};

export type Chat_VideoCallJoinData = Chat_VideoCallJoinDataVonage | Chat_VideoCallJoinDataWhereBy;

export type Chat_VideoCallJoinDataVonage = {
  __typename?: 'Chat_VideoCallJoinDataVonage';
  apiKey: Scalars['String'];
  sessionId: Scalars['String'];
  token: Scalars['String'];
};

export type Chat_VideoCallJoinDataWhereBy = {
  __typename?: 'Chat_VideoCallJoinDataWhereBy';
  url: Scalars['String'];
};

export enum Chat_VideoCallProviderEnum {
  Vonage = 'VONAGE',
  Whereby = 'WHEREBY'
}

export type Chat_VideoCallRoom = {
  __typename?: 'Chat_VideoCallRoom';
  createdAt: Scalars['Chat_DateTime'];
  createdBy?: Maybe<Chat_ChannelUser>;
  hasEnded: Scalars['Boolean'];
  id: Scalars['Chat_UUID'];
  isParticipant: Scalars['Boolean'];
  /** Use mutation joinVideoCallRoom to get data required to join the call from the provider. */
  joinVideoCall?: Maybe<Chat_VideoCallJoinData>;
  participants: Array<Chat_ChannelUser>;
  /** @deprecated Use joinVideoCall field instead */
  url?: Maybe<Scalars['String']>;
};

export type Chat_Viewer = {
  __typename?: 'Chat_Viewer';
  /** How many channel have unread messages */
  channelWithUnreadMessageCount: Scalars['Int'];
  countOwnedUsers: Scalars['Int'];
  ownedChannels: Array<Chat_Channel>;
  ownedUsers: Array<Chat_User>;
};


export type Chat_ViewerCountOwnedUsersArgs = {
  filters?: InputMaybe<Array<Chat_OwnedUserFiltersInput>>;
};


export type Chat_ViewerOwnedChannelsArgs = {
  ids?: InputMaybe<Array<Scalars['Chat_UUID']>>;
  pagination?: InputMaybe<Chat_OffsetPaginationInput>;
};


export type Chat_ViewerOwnedUsersArgs = {
  filters?: InputMaybe<Array<Chat_OwnedUserFiltersInput>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  pagination?: InputMaybe<Chat_OffsetPaginationInput>;
};

export enum Chat_VoteState {
  Down = 'DOWN',
  None = 'NONE',
  Up = 'UP'
}

export type Core_AcceptUserTermsInput = {
  eventPersonId: Scalars['ID'];
  userTerms: Array<Core_UserTermInput>;
};

export type Core_AcceptUserTermsPayload = {
  __typename?: 'Core_AcceptUserTermsPayload';
  deletedUserTermIds?: Maybe<Array<Scalars['ID']>>;
  errors?: Maybe<Array<Core_PayloadError>>;
  eventPerson?: Maybe<Core_EventPerson>;
};

export type Core_ActivitiesConnection = {
  __typename?: 'Core_ActivitiesConnection';
  nodes: Array<Core_Activity>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_Activity = Core_ConnectionRequestActivity | Core_ConnectionScanActivity | Core_CustomActivity | Core_ExhibitorMeetingAssignedActivity | Core_ExhibitorMeetingUnassignedActivity | Core_FeedActivity | Core_MeetingActivity | Core_PlanningActivity;

export type Core_ActivityContent = {
  __typename?: 'Core_ActivityContent';
  message: Scalars['String'];
  title: Scalars['String'];
};

/** Represent a single filter for activities. Each field of the input adds a new "AND" condition. */
export type Core_ActivityFilterInput = {
  /** Filters activities with createdAt after this date */
  createdAfter?: InputMaybe<Scalars['Core_DateTime']>;
  /** Filters activities seen or unseen */
  isSeen?: InputMaybe<Scalars['Boolean']>;
  /** Filters activities made within these communities */
  shouldCommunityIdIn?: InputMaybe<Array<Scalars['ID']>>;
  /** Filters activities made during one or more events */
  shouldEventIdIn?: InputMaybe<Array<Scalars['ID']>>;
};

export type Core_ActivityInterface = {
  /** The community in which the activity happened. */
  community?: Maybe<Core_Community>;
  /** The event in which the activity happened. */
  event?: Maybe<Core_Event>;
  id: Scalars['ID'];
  seen: Scalars['Boolean'];
  sentAt: Scalars['Core_DateTime'];
};


export type Core_ActivityInterfaceSentAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_ActivityRedirectUrl = {
  __typename?: 'Core_ActivityRedirectUrl';
  url: Scalars['String'];
};

export type Core_AddReplyToFormInput = {
  connectionId?: InputMaybe<Scalars['ID']>;
  formId: Scalars['ID'];
  ignoreDeleted?: InputMaybe<Scalars['Boolean']>;
  replies: Array<Core_ReplyFormFieldInput>;
};

export type Core_AddReplyToFormPayload = {
  __typename?: 'Core_AddReplyToFormPayload';
  form: Core_Form;
};

export type Core_Address = {
  __typename?: 'Core_Address';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  type: Core_AddressEnum;
  zipCode?: Maybe<Scalars['String']>;
};

export enum Core_AddressEnum {
  Home = 'HOME',
  Work = 'WORK'
}

export type Core_AddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  type: Core_AddressEnum;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type Core_AdvertisementExhibitorInterface = {
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
};

export type Core_AdvertisementExhibitorRedirectProduct = Core_AdvertisementExhibitorInterface & {
  __typename?: 'Core_AdvertisementExhibitorRedirectProduct';
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  product: Core_Product;
};

export type Core_AdvertisementExhibitorRedirectUrl = Core_AdvertisementExhibitorInterface & {
  __typename?: 'Core_AdvertisementExhibitorRedirectUrl';
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  redirectUrl: Scalars['String'];
};

export type Core_AdvertisementExhibitorUnion = Core_AdvertisementExhibitorRedirectProduct | Core_AdvertisementExhibitorRedirectUrl;

export type Core_AdvertisementFilterInput = {
  /**
   * Filter advertisements by event view ids.
   * If no id is provided : event home advertisements will be returned.
   */
  viewId?: InputMaybe<Scalars['ID']>;
};

export type Core_AdvertisementInterface = {
  id: Scalars['ID'];
  /** @deprecated Use webImageUrl instead */
  imageUrl: Scalars['String'];
  mobileImageUrl: Scalars['String'];
  webImageUrl: Scalars['String'];
};

export type Core_AdvertisementUnion = Core_ExhibitorAdvertisement | Core_RedirectNoneAdvertisement | Core_RedirectUrlAdvertisement;

export type Core_AgendaItem = Core_Meeting | Core_Planning;

export type Core_Aggregation = {
  __typename?: 'Core_Aggregation';
  aggregationId: Scalars['ID'];
  size: Scalars['Int'];
  value: Core_AggregationValue;
};

export type Core_AggregationDateValue = {
  __typename?: 'Core_AggregationDateValue';
  date: Scalars['Core_DateTime'];
};

export type Core_AggregationTextValue = {
  __typename?: 'Core_AggregationTextValue';
  text: Scalars['String'];
};

export type Core_AggregationValue = Core_AggregationDateValue | Core_AggregationTextValue;

export type Core_AllExhibitorMeetingsFilter = {
  mustIdIn?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * If empty list, returns all meetings
   * If null, will return unassigned meetings
   */
  mustUserIdIn?: InputMaybe<Array<Scalars['ID']>>;
  shouldStatusIn?: InputMaybe<Array<Core_ExhibitorMeetingDetailedStatus>>;
};

export type Core_Application = {
  __typename?: 'Core_Application';
  _id: Scalars['ID'];
  androidBundleId?: Maybe<Scalars['String']>;
  androidCertificate?: Maybe<Scalars['String']>;
  androidDebugCertificate?: Maybe<Scalars['String']>;
  appLegalUrl?: Maybe<Scalars['String']>;
  appSupportUrl?: Maybe<Scalars['String']>;
  appWebDomain?: Maybe<Scalars['String']>;
  codeSnippets: Array<Core_CodeSnippet>;
  cookiePolicyUrl?: Maybe<Scalars['String']>;
  displayOnDefaultApp?: Maybe<Scalars['Boolean']>;
  fonts?: Maybe<Array<Maybe<Core_Font>>>;
  googleAnalyticsTrackingCode?: Maybe<Scalars['String']>;
  iosBundleId?: Maybe<Scalars['String']>;
  iosSupportUrl?: Maybe<Scalars['String']>;
  iosTeamId?: Maybe<Scalars['String']>;
  isDefault: Scalars['Boolean'];
  legalNoticeUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pendoCode?: Maybe<Scalars['String']>;
  pendoCodeWeb?: Maybe<Scalars['String']>;
  pendoSchemeIdMobile?: Maybe<Scalars['String']>;
  /** @deprecated Use themes instead */
  primaryColor?: Maybe<Scalars['String']>;
  privacyPolicyUrl?: Maybe<Scalars['String']>;
  resourceCenterUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use themes instead */
  secondaryColor?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  studioWebDomain?: Maybe<Scalars['String']>;
  teamWebDomain?: Maybe<Scalars['String']>;
  termsOfUseUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use themes instead */
  textColor?: Maybe<Scalars['String']>;
  themes?: Maybe<Array<Maybe<Core_ThemeLink>>>;
  /** @deprecated Use appWebDomain instead */
  webDomain?: Maybe<Scalars['String']>;
  webIcon?: Maybe<Scalars['String']>;
};

export enum Core_ApplicationEnum {
  VivaTechnology = 'VIVA_TECHNOLOGY'
}

export type Core_AssignLeadInput = {
  eventId: Scalars['ID'];
  exhibitorId: Scalars['ID'];
  exhibitorMemberCommunityProfileId?: InputMaybe<Scalars['ID']>;
  leadContactId?: InputMaybe<Scalars['ID']>;
  leadEventProfileId?: InputMaybe<Scalars['ID']>;
};

export type Core_AssignLeadPayload = {
  __typename?: 'Core_AssignLeadPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  recommendedLead?: Maybe<Core_RecommendedLead>;
  teamConnection?: Maybe<Core_TeamConnection>;
};

export type Core_AssignMeetingParticipantInput = {
  /** Id of the meeting participant belonging to the exhibitor. */
  participantId: Scalars['ID'];
  /** Id of the eventPerson to assign */
  personId: Scalars['ID'];
};

export type Core_AssignMeetingParticipantPayload = {
  __typename?: 'Core_AssignMeetingParticipantPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  participant?: Maybe<Core_MeetingParticipant>;
};

export type Core_AttendeeFilterInput = {
  mustFiltersIn?: InputMaybe<Array<Core_EventFilterInInput>>;
  status?: InputMaybe<Core_AttendeeStatusEnum>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userStatus?: InputMaybe<Core_UserStatusEnum>;
};

export enum Core_AttendeeStatusEnum {
  Attending = 'ATTENDING',
  NotAttending = 'NOT_ATTENDING',
  Pending = 'PENDING'
}

export enum Core_AttendingAsEnum {
  AsAttendee = 'AS_ATTENDEE',
  AsSpeaker = 'AS_SPEAKER'
}

export type Core_AvailableMeetingSlotsByDay = {
  __typename?: 'Core_AvailableMeetingSlotsByDay';
  day: Scalars['Core_DateTime'];
  /** Number of possible meeting slots on this day for this exhibitor. */
  slotsCount: Scalars['Int'];
};

export type Core_Badge = {
  __typename?: 'Core_Badge';
  code?: Maybe<Scalars['String']>;
  ticketType?: Maybe<Core_TicketType>;
  url: Scalars['String'];
};

export type Core_BadgeTemplate = {
  __typename?: 'Core_BadgeTemplate';
  badgeTemplateElements: Array<Core_BadgeTemplateElementUnion>;
  config: Core_BadgeTemplateConfiguration;
  format: Core_BadgeTemplateFormatEnum;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  measurement: Core_BadgeTemplateMeasurementEnum;
  name: Scalars['String'];
};

export type Core_BadgeTemplateConfiguration = {
  __typename?: 'Core_BadgeTemplateConfiguration';
  height: Scalars['Float'];
  marginBottom: Scalars['Float'];
  marginLeft: Scalars['Float'];
  marginRight: Scalars['Float'];
  marginTop: Scalars['Float'];
  width: Scalars['Float'];
};

export enum Core_BadgeTemplateElementAlignmentEnum {
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type Core_BadgeTemplateElementBarcodeField = Core_BadgeTemplateElementInterface & {
  __typename?: 'Core_BadgeTemplateElementBarcodeField';
  barcodeType?: Maybe<Core_BadgeTemplateElementBarcodeTypeEnum>;
  config: Core_BadgeTemplateElementConfiguration;
  id: Scalars['ID'];
  type: Core_BadgeTemplateElementTypeEnum;
};

export enum Core_BadgeTemplateElementBarcodeTypeEnum {
  BarcodeC39 = 'BARCODE_C39',
  BarcodeC128 = 'BARCODE_C128',
  BarcodeUpc = 'BARCODE_UPC',
  QrCode = 'QR_CODE'
}

export type Core_BadgeTemplateElementConfiguration = {
  __typename?: 'Core_BadgeTemplateElementConfiguration';
  align: Core_BadgeTemplateElementAlignmentEnum;
  backgroundColor: Scalars['String'];
  bold: Scalars['Boolean'];
  fontFamily: Scalars['String'];
  fontSize: Scalars['Float'];
  height: Scalars['Float'];
  italic: Scalars['Boolean'];
  marginTop: Scalars['Float'];
  sizeUnit: Core_BadgeTemplateElementSizeUnitEnum;
  textColor: Scalars['String'];
  underline: Scalars['Boolean'];
  width: Scalars['Float'];
  zIndex: Scalars['Int'];
};

export type Core_BadgeTemplateElementCustomField = Core_BadgeTemplateElementInterface & {
  __typename?: 'Core_BadgeTemplateElementCustomField';
  config: Core_BadgeTemplateElementConfiguration;
  fieldDefinition?: Maybe<Core_FieldDefinitionUnion>;
  id: Scalars['ID'];
  type: Core_BadgeTemplateElementTypeEnum;
};

export type Core_BadgeTemplateElementImageField = Core_BadgeTemplateElementInterface & {
  __typename?: 'Core_BadgeTemplateElementImageField';
  config: Core_BadgeTemplateElementConfiguration;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  type: Core_BadgeTemplateElementTypeEnum;
};

export type Core_BadgeTemplateElementInterface = {
  config: Core_BadgeTemplateElementConfiguration;
  id: Scalars['ID'];
  type: Core_BadgeTemplateElementTypeEnum;
};

export type Core_BadgeTemplateElementRegularField = Core_BadgeTemplateElementInterface & {
  __typename?: 'Core_BadgeTemplateElementRegularField';
  config: Core_BadgeTemplateElementConfiguration;
  id: Scalars['ID'];
  regularFieldType?: Maybe<Core_BadgeTemplateElementRegularFieldTypeEnum>;
  type: Core_BadgeTemplateElementTypeEnum;
};

export enum Core_BadgeTemplateElementRegularFieldTypeEnum {
  Address = 'ADDRESS',
  Biography = 'BIOGRAPHY',
  Company = 'COMPANY',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  FullName = 'FULL_NAME',
  JobTitle = 'JOB_TITLE',
  Landline = 'LANDLINE',
  LastName = 'LAST_NAME',
  Phone = 'PHONE',
  Website = 'WEBSITE'
}

export enum Core_BadgeTemplateElementSizeUnitEnum {
  Inherit = 'INHERIT',
  Percentage = 'PERCENTAGE'
}

export type Core_BadgeTemplateElementTextField = Core_BadgeTemplateElementInterface & {
  __typename?: 'Core_BadgeTemplateElementTextField';
  config: Core_BadgeTemplateElementConfiguration;
  id: Scalars['ID'];
  type: Core_BadgeTemplateElementTypeEnum;
  value?: Maybe<Scalars['String']>;
};

export enum Core_BadgeTemplateElementTypeEnum {
  BarcodeField = 'BARCODE_FIELD',
  CustomField = 'CUSTOM_FIELD',
  ImageField = 'IMAGE_FIELD',
  RegularField = 'REGULAR_FIELD',
  TextField = 'TEXT_FIELD'
}

export type Core_BadgeTemplateElementUnion = Core_BadgeTemplateElementBarcodeField | Core_BadgeTemplateElementCustomField | Core_BadgeTemplateElementImageField | Core_BadgeTemplateElementRegularField | Core_BadgeTemplateElementTextField;

export enum Core_BadgeTemplateFormatEnum {
  A4 = 'A4',
  A6 = 'A6',
  Custom = 'CUSTOM',
  FoldedA4 = 'FOLDED_A4',
  FoldedLetter = 'FOLDED_LETTER'
}

export enum Core_BadgeTemplateMeasurementEnum {
  Imperial = 'IMPERIAL',
  Metric = 'METRIC'
}

export enum Core_BadgeTypeEnum {
  BadgeTemplate = 'BADGE_TEMPLATE',
  BarcodeC39 = 'BARCODE_C39',
  BarcodeC128 = 'BARCODE_C128',
  BarcodeUpc = 'BARCODE_UPC',
  File = 'FILE',
  QrCode = 'QR_CODE'
}

export type Core_Banner = {
  __typename?: 'Core_Banner';
  embeddedVideo?: Maybe<Core_EmbeddedVideoUnion>;
  imageUrl?: Maybe<Scalars['String']>;
};

export type Core_BannerInput = {
  embeddedVideo?: InputMaybe<Core_EmbeddedVideoInput>;
  imageUrl?: InputMaybe<Scalars['String']>;
};

export type Core_BookmarkAwareEntity = Core_Planning;

export type Core_BookmarkAwareInterface = {
  bookmark?: Maybe<Core_BookmarkComponent>;
};

export type Core_BookmarkComponent = {
  __typename?: 'Core_BookmarkComponent';
  bookmarkedSince?: Maybe<Scalars['Core_DateTime']>;
  canBookmark?: Maybe<Scalars['Boolean']>;
  isBookmarked?: Maybe<Scalars['Boolean']>;
};

export type Core_ButtonConfiguration = {
  __typename?: 'Core_ButtonConfiguration';
  _id: Scalars['ID'];
  backgroundColor: Scalars['String'];
  label: Core_TranslatedString;
  options: Core_ButtonConfigurationOptions;
  textColor: Scalars['String'];
  type: Core_ButtonTypeEnum;
};

export type Core_ButtonConfigurationOptions = {
  __typename?: 'Core_ButtonConfigurationOptions';
  /** @deprecated No longer supported */
  appName?: Maybe<Scalars['String']>;
  badgeColor?: Maybe<Scalars['String']>;
  badgeSize?: Maybe<Scalars['Int']>;
  badgeType?: Maybe<Core_BadgeTypeEnum>;
  hideCount: Scalars['Boolean'];
};

export enum Core_ButtonTypeEnum {
  ApiLink = 'API_LINK',
  Attendees = 'ATTENDEES',
  Badge = 'BADGE',
  Chat = 'CHAT',
  DeepLink = 'DEEP_LINK',
  Exhibitors = 'EXHIBITORS',
  Link = 'LINK',
  Plannings = 'PLANNINGS',
  Speakers = 'SPEAKERS'
}

export type Core_CancelOrderAndDeleteRegistrationInput = {
  email: Scalars['String'];
  eventId: Scalars['ID'];
};

export type Core_CancelOrderAndDeleteRegistrationPayload = {
  __typename?: 'Core_CancelOrderAndDeleteRegistrationPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  result?: Maybe<Scalars['Boolean']>;
};

export type Core_CancelOrderAndMoveItemsToDraftInput = {
  orderId: Scalars['ID'];
  orderSecret: Scalars['String'];
};

export type Core_CancelOrderAndMoveItemsToDraftPayload = {
  __typename?: 'Core_CancelOrderAndMoveItemsToDraftPayload';
  draftOrder?: Maybe<Core_DraftOrder>;
  errors?: Maybe<Array<Core_PayloadError>>;
};

export type Core_ChatMessage = {
  __typename?: 'Core_ChatMessage';
  channelId: Scalars['ID'];
  content: Scalars['String'];
  files?: Maybe<Array<Maybe<Core_ChatMessageFile>>>;
  id: Scalars['ID'];
};

export type Core_ChatMessageFile = {
  __typename?: 'Core_ChatMessageFile';
  contentLength: Scalars['Int'];
  contentType: Scalars['String'];
  downloadUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  uploadedFileName?: Maybe<Scalars['String']>;
};

export type Core_CodeSnippet = {
  __typename?: 'Core_CodeSnippet';
  cookies: Array<Core_CodeSnippetCookie>;
  id: Scalars['String'];
  requireUserConsent: Scalars['Boolean'];
  snippet: Scalars['String'];
};

export type Core_CodeSnippetCookie = {
  __typename?: 'Core_CodeSnippetCookie';
  description: Scalars['String'];
  expireAfter: Scalars['String'];
  name: Scalars['String'];
};

export type Core_CommunitiesConnection = {
  __typename?: 'Core_CommunitiesConnection';
  nodes: Array<Core_Community>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_CommunitiesFilterInput = {
  addApplicationPublicCommunities?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  slugs?: InputMaybe<Array<Scalars['String']>>;
  withEventsOfTimeStatus?: InputMaybe<Core_TimeStatusEnum>;
};

export type Core_Community = {
  __typename?: 'Core_Community';
  /** @deprecated Use themes instead */
  backgroundImageUrl?: Maybe<Scalars['String']>;
  bannerImageUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use themes instead */
  buttonsColor: Scalars['String'];
  contents?: Maybe<Core_CommunityContents>;
  description?: Maybe<Scalars['String']>;
  editableProfileFields: Array<Core_EditableCommunityProfileField>;
  events: Core_EventsConnection;
  exhibitorRoles: Array<Core_Role>;
  /** Return a list of exhibitors in the community. */
  exhibitors?: Maybe<Core_ExhibitorsConnection>;
  id: Scalars['ID'];
  isFeatureEnabled?: Maybe<Array<Core_Feature>>;
  isPublic: Scalars['Boolean'];
  isVisibleAsAttendee: Scalars['Boolean'];
  language: Core_LanguageEnum;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  plannings: Core_PlanningsConnection;
  /** @deprecated Use themes instead */
  primaryColor: Scalars['String'];
  productCategories: Core_ProductCategoriesConnection;
  /** Return a list of products in the community. */
  products: Core_EventProducts;
  /** Returns the community profile of the current user in this community. */
  profile?: Maybe<Core_EventPerson>;
  profiles?: Maybe<Core_EventPeopleConnection>;
  slug: Scalars['String'];
  suggestedEvents?: Maybe<Core_EventsConnection>;
  /** @deprecated Use themes instead */
  textColor: Scalars['String'];
  themes?: Maybe<Array<Maybe<Core_ThemeLink>>>;
  title?: Maybe<Scalars['String']>;
  translationLanguages?: Maybe<Array<Core_LanguageEnum>>;
  /** The current user's settings for this community and all events belonging to it */
  userSettings?: Maybe<Core_UserSettings>;
};


export type Core_CommunityEventsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  filter?: InputMaybe<Core_EventsFilterInput>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<Core_EventSortInput>>;
};


export type Core_CommunityExhibitorsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  filter?: InputMaybe<Core_CommunityExhibitorsFilterInput>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<Core_CommunityExhibitorsSortInput>>;
};


export type Core_CommunityIsFeatureEnabledArgs = {
  codes: Array<Scalars['String']>;
};


export type Core_CommunityPlanningsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  filter?: InputMaybe<Core_CommunityPlanningFilterInput>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<Core_InputCommunityPlanningSortEnum>>;
};


export type Core_CommunityProductCategoriesArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  filter?: InputMaybe<Core_ProductCategoriesFilterInput>;
  search?: InputMaybe<Scalars['String']>;
};


export type Core_CommunityProductsArgs = {
  filter?: InputMaybe<Core_CommunityProductsFilterInput>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<Core_ProductSortInput>>;
};


export type Core_CommunityProfilesArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  filter?: InputMaybe<Core_CommunityProfilesFilterInput>;
  sort?: InputMaybe<Array<Core_CommunityProfilesSortInput>>;
};


export type Core_CommunitySuggestedEventsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  sort?: InputMaybe<Array<Core_EventSortInput>>;
};

export type Core_CommunityContents = {
  __typename?: 'Core_CommunityContents';
  view?: Maybe<Core_CommunityView>;
  /** List all views in community visible by current user. */
  views: Array<Core_CommunityView>;
  viewsLayout: Core_EventViewsLayout;
};


export type Core_CommunityContentsViewArgs = {
  id: Scalars['ID'];
};

export type Core_CommunityExhibitorsFilterInput = {
  /** Filters exhibitors having **all** these categories. */
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filters exhibitors bookmarked or not by the user. */
  isBookmarked?: InputMaybe<Scalars['Boolean']>;
  mustFiltersIn?: InputMaybe<Array<Core_EventFilterInInput>>;
  /** Filters exhibitors having **at least one** type among these ones. */
  shouldTypeIn?: InputMaybe<Array<Scalars['ID']>>;
};

export type Core_CommunityExhibitorsSortInput = {
  field: Core_ExhibitorSortEnum;
  order?: InputMaybe<Core_SortOrderEnum>;
};

export type Core_CommunityPlanningFilterInput = {
  formats?: InputMaybe<Array<Core_PlanningFormatEnum>>;
  isBookmarked?: InputMaybe<Scalars['Boolean']>;
};

export enum Core_CommunityPlanningSortField {
  BeginsAt = 'BEGINS_AT',
  BookmarkedSince = 'BOOKMARKED_SINCE',
  CreatedAt = 'CREATED_AT',
  Description = 'DESCRIPTION',
  EndsAt = 'ENDS_AT',
  Place = 'PLACE',
  Title = 'TITLE',
  TotalAttendees = 'TOTAL_ATTENDEES',
  TotalCategories = 'TOTAL_CATEGORIES',
  TotalDocuments = 'TOTAL_DOCUMENTS',
  TotalExhibitors = 'TOTAL_EXHIBITORS',
  TotalSpeakers = 'TOTAL_SPEAKERS',
  Type = 'TYPE'
}

export type Core_CommunityProductsFilterInput = {
  category?: InputMaybe<Core_ProductCategoryFilterInput>;
};

export type Core_CommunityProfilesFilterInput = {
  AND?: InputMaybe<Array<Core_CommunityProfilesFilterInput>>;
  NOT?: InputMaybe<Array<Core_CommunityProfilesFilterInput>>;
  OR?: InputMaybe<Array<Core_CommunityProfilesFilterInput>>;
  /** If false, exclude the profile of the current user */
  includeSelf?: InputMaybe<Scalars['Boolean']>;
  /** Filter profiles connected within this community */
  isConnected?: InputMaybe<Scalars['Boolean']>;
  /** Filter profiles with outgoing pending connection requests within this community */
  isConnectionRequestSent?: InputMaybe<Scalars['Boolean']>;
  shouldBeAttendeeOnPlannings?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter profiles that are member of exhibitors */
  shouldBeMemberOfExhibitors?: InputMaybe<Array<Scalars['ID']>>;
  shouldBeSpeakerOnPlannings?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter community profiles user ids */
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum Core_CommunityProfilesSortFieldEnum {
  CreatedAt = 'CREATED_AT',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME'
}

export type Core_CommunityProfilesSortInput = {
  field: Core_CommunityProfilesSortFieldEnum;
  order?: InputMaybe<Core_SortOrderEnum>;
};

export enum Core_CommunitySortEnum {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export type Core_CommunitySortInput = {
  field: Core_CommunitySortEnum;
  order?: InputMaybe<Core_SortOrderEnum>;
};

export type Core_CommunityView = Core_CommunityViewMyCommunity | Core_EventChatroomView | Core_EventExhibitorListView | Core_EventFeedView | Core_EventGroupView | Core_EventMyVisitView | Core_EventPeopleListView | Core_EventPlanningListView | Core_EventProductListView | Core_EventRedirectUrlView;

export type Core_CommunityViewMyCommunity = Core_EventViewInterface & {
  __typename?: 'Core_CommunityViewMyCommunity';
  advertisements: Array<Core_AdvertisementUnion>;
  backgroundImageUrl?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  group?: Maybe<Core_EventGroupView>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  pageBackgroundUrl?: Maybe<Scalars['String']>;
  tabs: Array<Core_MyCommunityTab>;
};

export type Core_Company = {
  __typename?: 'Core_Company';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  userStatus: Core_CompanyUserStatus;
  websiteUrl?: Maybe<Scalars['String']>;
};


export type Core_CompanyLogoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};

export enum Core_CompanyUserStatus {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  None = 'NONE'
}

export type Core_ConnectionContact = Core_ConnectionInterface & Core_ContactInterface & Core_PersonInterface & Core_PublicPersonInterface & {
  __typename?: 'Core_ConnectionContact';
  _id: Scalars['ID'];
  addresses?: Maybe<Array<Maybe<Core_Address>>>;
  biography?: Maybe<Scalars['String']>;
  /**  List of events where the currently logged in user can qualify the Connection.  */
  community?: Maybe<Core_Community>;
  /** @deprecated No longer supported */
  company?: Maybe<Core_Company>;
  connectedAtCommunity?: Maybe<Core_Community>;
  connectedAtEvent?: Maybe<Core_Event>;
  createdAt?: Maybe<Scalars['Core_DateTime']>;
  /** @deprecated Use createdAt with format as TIMESTAMP */
  createdAtTs?: Maybe<Scalars['Int']>;
  /** @deprecated You should use field crmDetails instead */
  crmMetadata?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  event?: Maybe<Core_Event>;
  eventsForQualification: Core_EdgeListEvent;
  firstName?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  interests?: Maybe<Array<Maybe<Scalars['String']>>>;
  isOneWay?: Maybe<Scalars['Boolean']>;
  isScanned?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastName?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use event instead */
  metAtEvent?: Maybe<Core_ConnectionEvent>;
  note: Scalars['String'];
  organization?: Maybe<Scalars['String']>;
  /** @deprecated Use the field userInfo instead */
  personType?: Maybe<Core_PersonTypeEnum>;
  phoneNumbers?: Maybe<Array<Maybe<Core_PhoneNumber>>>;
  photoUrl?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  scannedCardUrl?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  secondJobTitle?: Maybe<Scalars['String']>;
  socialNetworks?: Maybe<Array<Maybe<Core_SocialNetwork>>>;
  tags?: Maybe<Array<Maybe<Core_Tag>>>;
  userInfo: Core_UserInfo;
  /** @deprecated Use the field userInfo instead */
  userStatus?: Maybe<Core_UserStatusEnum>;
  vcardUrl: Scalars['String'];
  websiteUrl?: Maybe<Scalars['String']>;
};


export type Core_ConnectionContactCreatedAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_ConnectionContactEventsForQualificationArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Core_EventsForQualificationFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<Core_EventSortInput>>;
};


export type Core_ConnectionContactLogoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};


export type Core_ConnectionContactPhoneNumbersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Core_PhoneNumberEnum>;
};


export type Core_ConnectionContactPhotoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};

export type Core_ConnectionDataInput = {
  note?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['Float']>;
  tags?: InputMaybe<Array<Core_TagInput>>;
};

export type Core_ConnectionEvent = {
  __typename?: 'Core_ConnectionEvent';
  _id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

/** Represent a single filter for connections. Each field of the input adds a new "AND" condition. */
export type Core_ConnectionFilterInput = {
  /** Filters connections made within one or more communities */
  shouldCommunityIdIn?: InputMaybe<Array<Scalars['ID']>>;
  /** Filters connections made during one or more events */
  shouldEventIdIn?: InputMaybe<Array<Scalars['ID']>>;
};

export type Core_ConnectionInfo = {
  __typename?: 'Core_ConnectionInfo';
  commonConnections: Array<Core_ConnectionUnion>;
  commonConnectionsCount: Scalars['Int'];
  connectedAt: Scalars['Core_DateTime'];
  connectedAtCommunity?: Maybe<Core_Community>;
  connectedAtEvent?: Maybe<Core_Event>;
  isOneWay: Scalars['Boolean'];
  isScanned: Scalars['Boolean'];
  note: Scalars['String'];
  rating?: Maybe<Scalars['Float']>;
  tags: Array<Core_Tag>;
  vcardUrl: Scalars['String'];
};


export type Core_ConnectionInfoCommonConnectionsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};

export type Core_ConnectionInterface = {
  /**  List of events where the currently logged in user can qualify the Connection.  */
  community?: Maybe<Core_Community>;
  createdAt?: Maybe<Scalars['Core_DateTime']>;
  /** @deprecated Use createdAt with format as TIMESTAMP */
  createdAtTs?: Maybe<Scalars['Int']>;
  /** @deprecated You should use field crmDetails instead */
  crmMetadata?: Maybe<Scalars['String']>;
  event?: Maybe<Core_Event>;
  eventsForQualification: Core_EdgeListEvent;
  isOneWay?: Maybe<Scalars['Boolean']>;
  isScanned?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use event instead */
  metAtEvent?: Maybe<Core_ConnectionEvent>;
  note: Scalars['String'];
  rating?: Maybe<Scalars['Float']>;
  tags?: Maybe<Array<Maybe<Core_Tag>>>;
  vcardUrl: Scalars['String'];
};


export type Core_ConnectionInterfaceCreatedAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_ConnectionInterfaceEventsForQualificationArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Core_EventsForQualificationFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<Core_EventSortInput>>;
};

export type Core_ConnectionRequest = Core_ConnectionRequestReceived | Core_ConnectionRequestSent;

export type Core_ConnectionRequestActivity = Core_ActivityInterface & {
  __typename?: 'Core_ConnectionRequestActivity';
  /** The community in which the activity happened. */
  community?: Maybe<Core_Community>;
  /** The event in which the activity happened. */
  event?: Maybe<Core_Event>;
  id: Scalars['ID'];
  kind: Core_ConnectionRequestActivityKind;
  request: Core_ConnectionRequest;
  seen: Scalars['Boolean'];
  sentAt: Scalars['Core_DateTime'];
};


export type Core_ConnectionRequestActivitySentAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export enum Core_ConnectionRequestActivityKind {
  ConnectionReceivedAccepted = 'CONNECTION_RECEIVED_ACCEPTED',
  ConnectionReceivedDeclined = 'CONNECTION_RECEIVED_DECLINED',
  ConnectionSentAccepted = 'CONNECTION_SENT_ACCEPTED'
}

export type Core_ConnectionRequestReceived = Core_RequestInterface & {
  __typename?: 'Core_ConnectionRequestReceived';
  community?: Maybe<Core_Community>;
  event?: Maybe<Core_Event>;
  /** Same as user, but in the context of the community/event related to the request. */
  eventPerson?: Maybe<Core_EventPerson>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  repliedAt?: Maybe<Scalars['Core_DateTime']>;
  seen: Scalars['Boolean'];
  sentAt: Scalars['Core_DateTime'];
  status: Core_RequestStatus;
  /**
   * The requester or recipient of the request.
   * If the current user is the recipient, the user will be the requester
   * otherwise it will be the recipient.
   */
  user: Core_PublicUser;
};


export type Core_ConnectionRequestReceivedRepliedAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_ConnectionRequestReceivedSentAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_ConnectionRequestSent = Core_RequestInterface & {
  __typename?: 'Core_ConnectionRequestSent';
  community?: Maybe<Core_Community>;
  event?: Maybe<Core_Event>;
  /** Same as user, but in the context of the community/event related to the request. */
  eventPerson?: Maybe<Core_EventPerson>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  repliedAt?: Maybe<Scalars['Core_DateTime']>;
  seen: Scalars['Boolean'];
  sentAt: Scalars['Core_DateTime'];
  status: Core_RequestStatus;
  /**
   * The requester or recipient of the request.
   * If the current user is the recipient, the user will be the requester
   * otherwise it will be the recipient.
   */
  user: Core_PublicUser;
};


export type Core_ConnectionRequestSentRepliedAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_ConnectionRequestSentSentAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_ConnectionScan = {
  __typename?: 'Core_ConnectionScan';
  event?: Maybe<Core_Event>;
  eventPerson?: Maybe<Core_EventPerson>;
  scannedAt: Scalars['Core_DateTime'];
  user: Core_ConnectionUser;
};


export type Core_ConnectionScanScannedAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_ConnectionScanActivity = Core_ActivityInterface & {
  __typename?: 'Core_ConnectionScanActivity';
  /** The community in which the activity happened. */
  community?: Maybe<Core_Community>;
  /** The event in which the activity happened. */
  event?: Maybe<Core_Event>;
  id: Scalars['ID'];
  kind: Core_ConnectionScanActivityKind;
  scan: Core_ConnectionScan;
  seen: Scalars['Boolean'];
  sentAt: Scalars['Core_DateTime'];
};


export type Core_ConnectionScanActivitySentAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export enum Core_ConnectionScanActivityKind {
  ScanReceived = 'SCAN_RECEIVED',
  ScanSent = 'SCAN_SENT'
}

export enum Core_ConnectionSortEnum {
  CompanyName = 'COMPANY_NAME',
  CreatedAt = 'CREATED_AT',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME'
}

export type Core_ConnectionSpeakerUser = Core_ConnectionInterface & Core_PersonInterface & Core_PublicPersonInterface & Core_PublicUserInterface & Core_SpeakerInterface & Core_UserInterface & {
  __typename?: 'Core_ConnectionSpeakerUser';
  _id: Scalars['ID'];
  addresses?: Maybe<Array<Maybe<Core_Address>>>;
  biography?: Maybe<Scalars['String']>;
  canViewConnections?: Maybe<Scalars['Boolean']>;
  commonConnections?: Maybe<Core_EdgeListConnectionUnion>;
  /**  List of events where the currently logged in user can qualify the Connection.  */
  community?: Maybe<Core_Community>;
  /** @deprecated No longer supported */
  company?: Maybe<Core_Company>;
  createdAt?: Maybe<Scalars['Core_DateTime']>;
  /** @deprecated Use createdAt with format as TIMESTAMP */
  createdAtTs?: Maybe<Scalars['Int']>;
  /** @deprecated You should use field crmDetails instead */
  crmMetadata?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  event?: Maybe<Core_Event>;
  eventsForQualification: Core_EdgeListEvent;
  exhibitorList?: Maybe<Array<Maybe<Core_Exhibitor>>>;
  firstName?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  interests?: Maybe<Array<Maybe<Scalars['String']>>>;
  isOneWay?: Maybe<Scalars['Boolean']>;
  isScanned?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  isUserResourceAvailable: Core_ResourceAvailable;
  jobTitle?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastName?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  lookingForTags: Array<Scalars['String']>;
  /** @deprecated Use event instead */
  metAtEvent?: Maybe<Core_ConnectionEvent>;
  note: Scalars['String'];
  organization?: Maybe<Scalars['String']>;
  pendingRequests: Array<Core_Request>;
  /** @deprecated Use the field userInfo instead */
  personType?: Maybe<Core_PersonTypeEnum>;
  phoneNumbers?: Maybe<Array<Maybe<Core_PhoneNumber>>>;
  photoUrl?: Maybe<Scalars['String']>;
  planningList?: Maybe<Array<Maybe<Core_Planning>>>;
  rating?: Maybe<Scalars['Float']>;
  /** @deprecated No longer supported */
  secondJobTitle?: Maybe<Scalars['String']>;
  socialNetworks?: Maybe<Array<Maybe<Core_SocialNetwork>>>;
  tags?: Maybe<Array<Maybe<Core_Tag>>>;
  type?: Maybe<Scalars['String']>;
  typeOrder?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['ID']>;
  userInfo: Core_UserInfo;
  /** @deprecated Use the field userInfo instead */
  userStatus?: Maybe<Core_UserStatusEnum>;
  vcardUrl: Scalars['String'];
  websiteUrl?: Maybe<Scalars['String']>;
};


export type Core_ConnectionSpeakerUserCommonConnectionsArgs = {
  _userId?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Core_SortInput>>>;
};


export type Core_ConnectionSpeakerUserCreatedAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_ConnectionSpeakerUserEventsForQualificationArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Core_EventsForQualificationFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<Core_EventSortInput>>;
};


export type Core_ConnectionSpeakerUserIsUserResourceAvailableArgs = {
  resource: Core_UserResourceEnum;
};


export type Core_ConnectionSpeakerUserLogoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};


export type Core_ConnectionSpeakerUserPhoneNumbersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Core_PhoneNumberEnum>;
};


export type Core_ConnectionSpeakerUserPhotoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};

export type Core_ConnectionUnion = Core_ConnectionContact | Core_ConnectionUser;

export type Core_ConnectionUser = Core_ConnectionInterface & Core_PersonInterface & Core_PublicPersonInterface & Core_PublicUserInterface & Core_TeamMemberInterface & Core_UserInterface & {
  __typename?: 'Core_ConnectionUser';
  _id: Scalars['ID'];
  addresses?: Maybe<Array<Maybe<Core_Address>>>;
  biography?: Maybe<Scalars['String']>;
  canViewConnections?: Maybe<Scalars['Boolean']>;
  commonConnections?: Maybe<Core_EdgeListConnectionUnion>;
  /**  List of events where the currently logged in user can qualify the Connection.  */
  community?: Maybe<Core_Community>;
  /** @deprecated No longer supported */
  company?: Maybe<Core_Company>;
  createdAt?: Maybe<Scalars['Core_DateTime']>;
  /** @deprecated Use createdAt with format as TIMESTAMP */
  createdAtTs?: Maybe<Scalars['Int']>;
  /** @deprecated You should use field crmDetails instead */
  crmMetadata?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  event?: Maybe<Core_Event>;
  eventsForQualification: Core_EdgeListEvent;
  exhibitorList?: Maybe<Array<Maybe<Core_Exhibitor>>>;
  firstName?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  interests?: Maybe<Array<Maybe<Scalars['String']>>>;
  isOneWay?: Maybe<Scalars['Boolean']>;
  isScanned?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  isUserResourceAvailable: Core_ResourceAvailable;
  jobTitle?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastName?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  lookingForTags: Array<Scalars['String']>;
  /** @deprecated Use event instead */
  metAtEvent?: Maybe<Core_ConnectionEvent>;
  note: Scalars['String'];
  organization?: Maybe<Scalars['String']>;
  pendingRequests: Array<Core_Request>;
  /** @deprecated Use the field userInfo instead */
  personType?: Maybe<Core_PersonTypeEnum>;
  phoneNumbers?: Maybe<Array<Maybe<Core_PhoneNumber>>>;
  photoUrl?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  /** @deprecated No longer supported */
  secondJobTitle?: Maybe<Scalars['String']>;
  socialNetworks?: Maybe<Array<Maybe<Core_SocialNetwork>>>;
  tags?: Maybe<Array<Maybe<Core_Tag>>>;
  teamOptions?: Maybe<Core_TeamOptions>;
  userInfo: Core_UserInfo;
  /** @deprecated Use the field userInfo instead */
  userStatus?: Maybe<Core_UserStatusEnum>;
  vcardUrl: Scalars['String'];
  websiteUrl?: Maybe<Scalars['String']>;
};


export type Core_ConnectionUserCommonConnectionsArgs = {
  _userId?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Core_SortInput>>>;
};


export type Core_ConnectionUserCreatedAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_ConnectionUserEventsForQualificationArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Core_EventsForQualificationFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<Core_EventSortInput>>;
};


export type Core_ConnectionUserIsUserResourceAvailableArgs = {
  resource: Core_UserResourceEnum;
};


export type Core_ConnectionUserLogoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};


export type Core_ConnectionUserPhoneNumbersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Core_PhoneNumberEnum>;
};


export type Core_ConnectionUserPhotoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};

export type Core_ContactInterface = {
  _id: Scalars['ID'];
  addresses?: Maybe<Array<Maybe<Core_Address>>>;
  biography?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  company?: Maybe<Core_Company>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  interests?: Maybe<Array<Maybe<Scalars['String']>>>;
  jobTitle?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastName?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  /** @deprecated Use the field userInfo instead */
  personType?: Maybe<Core_PersonTypeEnum>;
  phoneNumbers?: Maybe<Array<Maybe<Core_PhoneNumber>>>;
  photoUrl?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  secondJobTitle?: Maybe<Scalars['String']>;
  socialNetworks?: Maybe<Array<Maybe<Core_SocialNetwork>>>;
  userInfo: Core_UserInfo;
  /** @deprecated Use the field userInfo instead */
  userStatus?: Maybe<Core_UserStatusEnum>;
  websiteUrl?: Maybe<Scalars['String']>;
};


export type Core_ContactInterfaceLogoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};


export type Core_ContactInterfacePhoneNumbersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Core_PhoneNumberEnum>;
};


export type Core_ContactInterfacePhotoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};

export type Core_ContactUnion = Core_ConnectionContact | Core_EventPerson;

export type Core_ContactsUnionConnection = {
  __typename?: 'Core_ContactsUnionConnection';
  nodes: Array<Core_ContactUnion>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_CreateContactPayload = {
  __typename?: 'Core_CreateContactPayload';
  contact?: Maybe<Core_ConnectionContact>;
  errors?: Maybe<Array<Core_PayloadError>>;
};

export type Core_CreateContactV2Input = {
  biography?: InputMaybe<Scalars['String']>;
  businessCardImageUrl?: InputMaybe<Scalars['String']>;
  communityId?: InputMaybe<Scalars['ID']>;
  companyName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  eventId?: InputMaybe<Scalars['ID']>;
  firstName: Scalars['String'];
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  phoneNumbers?: InputMaybe<Array<Core_PhoneNumberInput>>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type Core_CreateDocumentInput = {
  clientId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type Core_CreateDraftOrderInput = {
  eventId: Scalars['ID'];
  promoCode?: InputMaybe<Scalars['String']>;
  registrations: Array<Core_CreateRegistrationInput>;
  reusedAbandonedOrder?: InputMaybe<Scalars['Boolean']>;
};

export type Core_CreateDraftOrderPayload = {
  __typename?: 'Core_CreateDraftOrderPayload';
  draftOrder?: Maybe<Core_DraftOrder>;
  errors?: Maybe<Array<Core_PayloadError>>;
};

export type Core_CreateExhibitorAdvertisementInput = {
  eventID: Scalars['ID'];
  exhibitorId: Scalars['ID'];
  imageUrl: Scalars['String'];
  redirectProduct?: InputMaybe<Core_ExhibitorAdvertisementRedirectProductInput>;
  redirectUrl?: InputMaybe<Core_ExhibitorAdvertisementRedirectUrlInput>;
};

export type Core_CreateExhibitorAdvertisementPayload = {
  __typename?: 'Core_CreateExhibitorAdvertisementPayload';
  advertisement?: Maybe<Core_AdvertisementExhibitorUnion>;
  errors?: Maybe<Array<Core_PayloadError>>;
  exhibitor?: Maybe<Core_Exhibitor>;
};

export type Core_CreateFieldDefinitionInput = {
  configuration?: InputMaybe<Core_FieldDefinitionConfigurationInput>;
  index?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  nameTranslations?: InputMaybe<Array<Core_TranslationStringInput>>;
  placeholder?: InputMaybe<Scalars['String']>;
  placeholderTranslations?: InputMaybe<Array<Core_TranslationStringInput>>;
  sectionId?: InputMaybe<Scalars['ID']>;
  type: Core_FieldType;
};

export type Core_CreateFieldInput = {
  definitionId: Scalars['ID'];
  locale?: InputMaybe<Core_LanguageEnum>;
  selectOptionKey?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
};

export type Core_CreateFormAnswerValueInput = {
  locale?: InputMaybe<Core_LanguageEnum>;
  value: Scalars['String'];
};

export type Core_CreateFormFieldInput = {
  correctAnswers?: InputMaybe<Array<Core_CreateFormAnswerValueInput>>;
  fieldDefinition: Core_CreateFieldDefinitionInput;
};

export type Core_CreateFormInput = {
  availableFrom?: InputMaybe<Scalars['Core_DateTime']>;
  availableUntil?: InputMaybe<Scalars['Core_DateTime']>;
  configuration?: InputMaybe<Core_FormConfigurationInput>;
  eventId: Scalars['ID'];
  exhibitorId?: InputMaybe<Scalars['ID']>;
  fields: Array<Core_CreateFormFieldInput>;
  name?: InputMaybe<Scalars['String']>;
  /** A form can only be linked to one planning. Throws an error if you pass multiple IDs */
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
  type: Core_FormType;
};

export type Core_CreateFormPayload = {
  __typename?: 'Core_CreateFormPayload';
  form: Core_Form;
};

export type Core_CreateMeetingInput = {
  description?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  /** ID of a EventPerson to set as organizer, or current user if not set */
  organizerId?: InputMaybe<Scalars['ID']>;
  participants: Array<Core_CreateMeetingParticipantInput>;
  placeId: Scalars['ID'];
  slotId: Scalars['ID'];
};

export type Core_CreateMeetingParticipantInput = {
  /** Accepted types: EventPerson, Exhibitor */
  id: Scalars['ID'];
  /** A message sent on the MeetingRequest and on the meeting channel created */
  message?: InputMaybe<Scalars['String']>;
};

export type Core_CreateMeetingPayload = {
  __typename?: 'Core_CreateMeetingPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  meeting?: Maybe<Core_Meeting>;
};

export type Core_CreateOrderByDraftOrderInput = {
  draftOrderId: Scalars['String'];
  draftOrderSecret: Scalars['String'];
};

export type Core_CreateOrderByDraftOrderPayload = {
  __typename?: 'Core_CreateOrderByDraftOrderPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  order?: Maybe<Core_Order>;
};

export type Core_CreateOrderPaymentInput = {
  orderId: Scalars['String'];
  orderSecret: Scalars['String'];
};

export type Core_CreateOrderPaymentPayload = {
  __typename?: 'Core_CreateOrderPaymentPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  orderId?: Maybe<Scalars['ID']>;
  orderPayment?: Maybe<Core_OrderPayment>;
  orderSecret?: Maybe<Scalars['String']>;
};

export type Core_CreatePaymentIntentForOrderInput = {
  orderId: Scalars['ID'];
  orderSecret: Scalars['String'];
};

export type Core_CreatePaymentIntentForOrderPayload = {
  __typename?: 'Core_CreatePaymentIntentForOrderPayload';
  email?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Core_PayloadError>>;
  order?: Maybe<Core_Order>;
  paymentIntentId?: Maybe<Scalars['ID']>;
  paymentIntentSecret?: Maybe<Scalars['String']>;
  totalAmountCents?: Maybe<Scalars['Int']>;
};

export type Core_CreateProductInput = {
  categoryId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  descriptionTranslations?: InputMaybe<Array<Core_TranslationStringInput>>;
  eventId?: InputMaybe<Scalars['ID']>;
  fields?: InputMaybe<Array<Core_CreateFieldInput>>;
  imageUrl?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  nameTranslations?: InputMaybe<Array<Core_TranslationStringInput>>;
};

export type Core_CreateQualifierQuestionInput = {
  field: Core_CreateFormFieldInput;
  formId: Scalars['ID'];
  move?: InputMaybe<Core_QualifierQuestionMoveInput>;
};

export type Core_CreateQualifierQuestionPayload = {
  __typename?: 'Core_CreateQualifierQuestionPayload';
  form?: Maybe<Core_Form>;
};

export type Core_CreateRegistrationInput = {
  address?: InputMaybe<Core_AddressInput>;
  biography?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Array<Core_CustomFieldUnionInput>>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  jobTitle?: InputMaybe<Scalars['String']>;
  landlinePhone?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mobilePhone?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Scalars['String']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  registeredAt?: InputMaybe<Scalars['Core_DateTime']>;
  socialNetworks?: InputMaybe<Array<Core_SocialNetworkInput>>;
  ticketTypeId: Scalars['ID'];
  userTerms: Array<Core_UserTermInput>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type Core_CreateUploadUrlInput = {
  fileName?: InputMaybe<Scalars['String']>;
  mimeType: Scalars['Core_MimeType'];
};

export type Core_CreateUploadUrlResult = {
  __typename?: 'Core_CreateUploadUrlResult';
  fields: Array<Core_UploadUrlFormField>;
  fileUrl: Scalars['String'];
  url: Scalars['String'];
};

export type Core_CreditCardPaymentMethod = {
  __typename?: 'Core_CreditCardPaymentMethod';
  brand: Scalars['String'];
  cardLast4: Scalars['String'];
  expMonth: Scalars['Int'];
  expYear: Scalars['Int'];
  id: Scalars['String'];
};

export type Core_CrowdConnectedConfiguration = {
  __typename?: 'Core_CrowdConnectedConfiguration';
  appKey: Scalars['String'];
  secret: Scalars['String'];
  token: Scalars['String'];
};

export type Core_CursorPaginationInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type Core_CustomActivity = Core_ActivityInterface & {
  __typename?: 'Core_CustomActivity';
  /** The community in which the activity happened. */
  community?: Maybe<Core_Community>;
  content: Core_ActivityContent;
  /** The event in which the activity happened. */
  event?: Maybe<Core_Event>;
  id: Scalars['ID'];
  resource: Core_CustomActivityResource;
  seen: Scalars['Boolean'];
  sentAt: Scalars['Core_DateTime'];
};


export type Core_CustomActivitySentAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_CustomActivityResource = Core_ActivityRedirectUrl | Core_Event | Core_Exhibitor | Core_Planning;

export type Core_CustomFieldChoicesInput = {
  /** The list of selected choices keys. The choices can be managed with mutation "setCustomFieldChoices". */
  keys: Array<Scalars['String']>;
  /** If true all choices are replaced by "keys", otherwise only new keys are added. */
  overwrite?: InputMaybe<Scalars['Boolean']>;
};

export type Core_CustomFieldDateInput = {
  value: Scalars['Core_DateTime'];
};

export type Core_CustomFieldNumberInput = {
  value: Scalars['Int'];
};

export type Core_CustomFieldTextInput = {
  /** The language of the text value (default is the event language). */
  language?: InputMaybe<Core_LanguageEnum>;
  /** If null, removes only the value in "language". */
  value?: InputMaybe<Scalars['String']>;
};

export type Core_CustomFieldTextsInput = {
  /** The language of the text values (default is the event language). */
  language?: InputMaybe<Core_LanguageEnum>;
  /** If null, removes all values of "language". */
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type Core_CustomFieldUnionInput = {
  /** If the custom field is configured to have only unique values. */
  choices?: InputMaybe<Core_CustomFieldChoicesInput>;
  /** If the custom field is configured to be a date. */
  date?: InputMaybe<Core_CustomFieldDateInput>;
  definitionId: Scalars['ID'];
  /** If the custom field is configured to be a number. */
  number?: InputMaybe<Core_CustomFieldNumberInput>;
  /** If the custom field is configured to have only a single open text value. */
  text?: InputMaybe<Core_CustomFieldTextInput>;
  /** If the custom field is configured to have multiple open text values. */
  texts?: InputMaybe<Array<Core_CustomFieldTextsInput>>;
};

export type Core_DateAggregation = {
  __typename?: 'Core_DateAggregation';
  count?: Maybe<Scalars['Int']>;
  date: Scalars['Core_DateTime'];
};

export type Core_DateField = Core_FieldInterface & {
  __typename?: 'Core_DateField';
  definition: Core_DateFieldDefinition;
  /** @deprecated Use specialized field `definition.id` on type `FieldUnion` instead */
  id: Scalars['ID'];
  /** @deprecated Use specialized field `definition.isEditable` on type `FieldUnion` instead */
  isEditable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isFilterable` on type `FieldUnion` instead */
  isFilterable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isVisible` on type `FieldUnion` instead */
  isVisible: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.name` on type `FieldUnion` instead */
  name: Scalars['String'];
  /** @deprecated Use specialized field `definition.placeholder` on type `FieldUnion` instead */
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated Use specialized field `definition.section` on type `FieldUnion` instead */
  section?: Maybe<Core_FieldDefinitionSection>;
  value?: Maybe<Core_DateFieldValue>;
};

export type Core_DateFieldDefinition = Core_FieldDefinitionInterface & {
  __typename?: 'Core_DateFieldDefinition';
  id: Scalars['ID'];
  isEditable: Scalars['Boolean'];
  /** @deprecated No longer supported */
  isFilterable: Scalars['Boolean'];
  /** Do not use, always true */
  isVisible: Scalars['Boolean'];
  name: Scalars['String'];
  /** @deprecated use field `translations` instead */
  nameTranslations: Array<Core_TranslationString>;
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated use field `translations` instead */
  placeholderTranslations: Array<Core_TranslationString>;
  section?: Maybe<Core_FieldDefinitionSection>;
  translations: Array<Core_FieldDefinitionTranslation>;
};

export type Core_DateFieldValue = {
  __typename?: 'Core_DateFieldValue';
  date: Scalars['Core_DateTime'];
  id: Scalars['ID'];
};


export type Core_DateFieldValueDateArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_DateRangeInput = {
  end?: InputMaybe<Scalars['Core_DateTime']>;
  start?: InputMaybe<Scalars['Core_DateTime']>;
};

export enum Core_DateTimeFormat {
  /** Formats the date as a day (eg. "2019-03-10") */
  Day = 'DAY',
  Iso8601 = 'ISO8601',
  Timestamp = 'TIMESTAMP'
}

export type Core_DeleteAbandonedRegistrationPayload = {
  __typename?: 'Core_DeleteAbandonedRegistrationPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  result?: Maybe<Scalars['Boolean']>;
};

export type Core_DeleteExhibitorAdvertisementsInput = {
  advertisementIds: Array<Scalars['ID']>;
  exhibitorId: Scalars['ID'];
};

export type Core_DeleteExhibitorAdvertisementsPayload = {
  __typename?: 'Core_DeleteExhibitorAdvertisementsPayload';
  deletedAdvertisementIds?: Maybe<Array<Scalars['ID']>>;
  errors?: Maybe<Array<Core_PayloadError>>;
};

export type Core_DeleteFormInput = {
  formId: Scalars['ID'];
};

export type Core_DeleteFormPayload = {
  __typename?: 'Core_DeleteFormPayload';
  formId: Scalars['ID'];
};

export type Core_DeleteQualifierQuestionInput = {
  fieldDefinitionId: Scalars['ID'];
  formId: Scalars['ID'];
};

export type Core_DeleteQualifierQuestionPayload = {
  __typename?: 'Core_DeleteQualifierQuestionPayload';
  form?: Maybe<Core_Form>;
};

export type Core_DeletedAbandonedRegistrationInput = {
  secretToken: Scalars['String'];
};

export type Core_Document = {
  __typename?: 'Core_Document';
  clientId?: Maybe<Scalars['String']>;
  communityId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  embeddedUrl?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type: Core_DocumentTypeEnum;
  url: Scalars['String'];
};

export enum Core_DocumentTypeEnum {
  Document = 'DOCUMENT',
  File = 'FILE',
  Image = 'IMAGE',
  Link = 'LINK',
  Video = 'VIDEO'
}

export type Core_DraftOrder = {
  __typename?: 'Core_DraftOrder';
  id: Scalars['String'];
  orderItems: Array<Core_DraftOrderItem>;
  registrations: Array<Core_DraftRegistration>;
  remainingTimeInSec?: Maybe<Scalars['Int']>;
  secret: Scalars['String'];
  totalPriceCents: Scalars['Int'];
};

export type Core_DraftOrderItem = {
  __typename?: 'Core_DraftOrderItem';
  discountedUnitPriceCents: Scalars['Int'];
  label: Scalars['String'];
  quantity: Scalars['Int'];
  totalPriceCents: Scalars['Int'];
  unitPriceCents: Scalars['Int'];
};

export type Core_DraftRegistration = {
  __typename?: 'Core_DraftRegistration';
  address?: Maybe<Core_Address>;
  biography?: Maybe<Scalars['String']>;
  customFields?: Maybe<Array<Core_DraftRegistrationCustomFieldUnion>>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  jobTitle?: Maybe<Scalars['String']>;
  landlinePhone?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  mobilePhone?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  registeredAt?: Maybe<Scalars['Core_DateTime']>;
  socialNetworks?: Maybe<Array<Core_SocialNetwork>>;
  ticketTypeId: Scalars['ID'];
  userTerms: Array<Core_DraftRegistrationUserTerm>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type Core_DraftRegistrationCustomFieldChoices = {
  __typename?: 'Core_DraftRegistrationCustomFieldChoices';
  /** The list of selected choices keys. The choices can be managed with mutation "setCustomFieldChoices". */
  keys: Array<Scalars['String']>;
  /** If true all choices are replaced by "keys", otherwise only new keys are added. */
  overwrite?: Maybe<Scalars['Boolean']>;
};

export type Core_DraftRegistrationCustomFieldDate = {
  __typename?: 'Core_DraftRegistrationCustomFieldDate';
  value: Scalars['Core_DateTime'];
};

export type Core_DraftRegistrationCustomFieldNumber = {
  __typename?: 'Core_DraftRegistrationCustomFieldNumber';
  value: Scalars['Int'];
};

export type Core_DraftRegistrationCustomFieldText = {
  __typename?: 'Core_DraftRegistrationCustomFieldText';
  /** The language of the text value (default is the event language). */
  language?: Maybe<Core_LanguageEnum>;
  /** If null, removes only the value in "language". */
  value: Scalars['String'];
};

export type Core_DraftRegistrationCustomFieldTexts = {
  __typename?: 'Core_DraftRegistrationCustomFieldTexts';
  /** The language of the text values (default is the event language). */
  language?: Maybe<Core_LanguageEnum>;
  /** If null, removes all values of "language". */
  values?: Maybe<Array<Scalars['String']>>;
};

export type Core_DraftRegistrationCustomFieldUnion = {
  __typename?: 'Core_DraftRegistrationCustomFieldUnion';
  /** If the custom field is configured to have only unique values. */
  choices?: Maybe<Core_DraftRegistrationCustomFieldChoices>;
  /** If the custom field is configured to be a date. */
  date?: Maybe<Core_DraftRegistrationCustomFieldDate>;
  definitionId: Scalars['ID'];
  /** If the custom field is configured to be a number. */
  number?: Maybe<Core_DraftRegistrationCustomFieldNumber>;
  singleText?: Maybe<Core_DraftRegistrationCustomFieldText>;
  /**
   * If the custom field is configured to have only a single open text value.
   * @deprecated Use singleText instead
   */
  text?: Maybe<Core_DraftRegistrationCustomFieldTexts>;
  /** If the custom field is configured to have multiple open text values. */
  texts?: Maybe<Array<Core_DraftRegistrationCustomFieldTexts>>;
};

export type Core_DraftRegistrationUserTerm = {
  __typename?: 'Core_DraftRegistrationUserTerm';
  accepted?: Maybe<Scalars['Boolean']>;
  userTermId: Scalars['ID'];
};

export type Core_EdgeListAttendeeUnion = {
  __typename?: 'Core_EdgeListAttendeeUnion';
  pageInfo?: Maybe<Core_PageInfoType>;
};

export type Core_EdgeListConnectionUnion = {
  __typename?: 'Core_EdgeListConnectionUnion';
  nodes?: Maybe<Array<Maybe<Core_ConnectionUnion>>>;
  pageInfo?: Maybe<Core_PageInfoType>;
};

export type Core_EdgeListEvent = {
  __typename?: 'Core_EdgeListEvent';
  edges?: Maybe<Array<Maybe<Core_NodeEvent>>>;
  nodes?: Maybe<Array<Maybe<Core_Event>>>;
  pageInfo?: Maybe<Core_PageInfoType>;
};

export type Core_EdgeListExhibitor = {
  __typename?: 'Core_EdgeListExhibitor';
  nodes?: Maybe<Array<Maybe<Core_Exhibitor>>>;
  pageInfo?: Maybe<Core_PageInfoType>;
};

export type Core_EdgeListPlanning = {
  __typename?: 'Core_EdgeListPlanning';
  nodes?: Maybe<Array<Maybe<Core_Planning>>>;
  pageInfo?: Maybe<Core_PageInfoType>;
};

export type Core_EdgeListTag = {
  __typename?: 'Core_EdgeListTag';
  nodes?: Maybe<Array<Maybe<Core_Tag>>>;
  pageInfo?: Maybe<Core_PageInfoType>;
};

export type Core_EdgeListUserUnion = {
  __typename?: 'Core_EdgeListUserUnion';
  nodes?: Maybe<Array<Maybe<Core_UserUnion>>>;
  pageInfo?: Maybe<Core_PageInfoType>;
};

/** EventPerson fields that the user is allowed to edit */
export enum Core_EditableCommunityProfileField {
  Address = 'ADDRESS',
  Biography = 'BIOGRAPHY',
  Company = 'COMPANY',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  JobTitle = 'JOB_TITLE',
  LastName = 'LAST_NAME',
  PhoneNumbers = 'PHONE_NUMBERS',
  ProfilePicture = 'PROFILE_PICTURE',
  SocialNetworks = 'SOCIAL_NETWORKS',
  Website = 'WEBSITE'
}

export type Core_EditableExhibitorFields = {
  __typename?: 'Core_EditableExhibitorFields';
  address: Scalars['Boolean'];
  advertisements: Scalars['Boolean'];
  backgroundImage: Scalars['Boolean'];
  bannerImage: Scalars['Boolean'];
  bannerVideo: Scalars['Boolean'];
  booth: Scalars['Boolean'];
  categories: Scalars['Boolean'];
  description: Scalars['Boolean'];
  email: Scalars['Boolean'];
  logoUrl: Scalars['Boolean'];
  name: Scalars['Boolean'];
  phoneNumbers: Scalars['Boolean'];
  socialNetworks: Scalars['Boolean'];
  type: Scalars['Boolean'];
  websiteUrl: Scalars['Boolean'];
};

export type Core_EmbeddedVideoInput = {
  iframe?: InputMaybe<Core_IframeEmbeddedVideoInput>;
  vimeo?: InputMaybe<Core_VimeoEmbeddedVideoInput>;
  youtube?: InputMaybe<Core_YoutubeEmbeddedVideoInput>;
};

export type Core_EmbeddedVideoUnion = Core_IframeEmbeddedVideo | Core_RtmpLiveStreamVideo | Core_UploadedFileEmbeddedVideo | Core_VimeoEmbeddedVideo | Core_YoutubeEmbeddedVideo;

export type Core_EntityInterface = {
  id: Scalars['ID'];
};

export type Core_Evaluation = {
  __typename?: 'Core_Evaluation';
  comment?: Maybe<Scalars['String']>;
  grade: Scalars['Float'];
};

export type Core_Event = Core_EventInterface & {
  __typename?: 'Core_Event';
  _id: Scalars['ID'];
  address?: Maybe<Core_Address>;
  /**
   * Return advertisements based on event views, if no viewId is provided, return event home advertisements.
   * The event must have purchased the feature to get event views advertisements.
   */
  advertisements?: Maybe<Array<Core_AdvertisementUnion>>;
  allowedDomains: Array<Scalars['String']>;
  application?: Maybe<Core_Application>;
  /**
   * Lists available meeting slots that the current user can use for a meeting.
   * Slots without available places are not returned.
   */
  availableMeetingSlots?: Maybe<Core_MeetingSlotsConnection>;
  /** Returns the number of available meetingSlots by day for the given filters. */
  availableMeetingSlotsByDay?: Maybe<Array<Core_AvailableMeetingSlotsByDay>>;
  /** @deprecated Use themes instead */
  backgroundImageUrl?: Maybe<Scalars['String']>;
  banner?: Maybe<Core_Banner>;
  bannerUrl?: Maybe<Scalars['String']>;
  beginsAt: Scalars['Core_DateTime'];
  /** @deprecated Use registrationSettings instead */
  canRegister: Scalars['Boolean'];
  codeSnippets: Array<Core_CodeSnippet>;
  community: Core_Community;
  configuration: Core_EventConfiguration;
  contents: Core_EventContents;
  createdAt?: Maybe<Scalars['Core_DateTime']>;
  description?: Maybe<Scalars['String']>;
  endsAt: Scalars['Core_DateTime'];
  /** Return the current user profile in this event. */
  eventPerson?: Maybe<Core_EventPerson>;
  eventStatus?: Maybe<Core_EventStatusEnum>;
  exhibitorRoles: Array<Core_Role>;
  exhibitorsWithPlannings?: Maybe<Array<Core_Exhibitor>>;
  features?: Maybe<Array<Core_Feature>>;
  forms: Core_FormsConnection;
  hasCode: Scalars['Boolean'];
  hasValidMeetingRules: Scalars['Boolean'];
  homePage?: Maybe<Core_Page>;
  htmlDescription?: Maybe<Scalars['String']>;
  /** List people that the current user can invite for a meeting */
  invitableMeetingPeople?: Maybe<Core_InvitableMeetingPeopleConnection>;
  isArchived: Scalars['Boolean'];
  isLive: Scalars['Boolean'];
  isPromoCodeActive: Scalars['Boolean'];
  isPublic: Scalars['Boolean'];
  /** @deprecated Use registrationSettings instead */
  isRegistrationEnabled: Scalars['Boolean'];
  isVisibleAsAttendee: Scalars['Boolean'];
  language: Core_LanguageEnum;
  latitude?: Maybe<Scalars['Float']>;
  locations: Core_LocationsConnection;
  longitude?: Maybe<Scalars['Float']>;
  organizerSupportEmail?: Maybe<Scalars['String']>;
  pages: Array<Core_Page>;
  paymentSettings: Core_EventPaymentSettings;
  /** @deprecated Use filters in type "EventPlanningListView" instead */
  planningsCategories: Array<Core_LabelString>;
  planningsDays: Array<Scalars['Core_Date']>;
  /** @deprecated Use filters in type "EventPlanningListView" instead */
  planningsPlaces: Array<Core_LabelString>;
  /** @deprecated Use filters in type "EventPlanningListView" instead */
  planningsTypes: Array<Core_LabelString>;
  productCategories: Core_ProductCategoriesConnection;
  /**
   * The active profile of the user for this event (his mask)
   * @deprecated Use eventPerson instead
   */
  profile?: Maybe<Core_EventProfile>;
  registrationForms?: Maybe<Array<Core_EventRegistrationForm>>;
  registrationSettings: Core_RegistrationSettings;
  /** @deprecated Use field `isVisibleAsAttendee` on type `Event` or `isBookmarked` on type `Planning` instead */
  selfAttendeeStatus?: Maybe<Core_AttendeeStatusEnum>;
  slug?: Maybe<Scalars['String']>;
  sponsorsByCategory: Array<Maybe<Core_SponsorCategory>>;
  supportTimeSlots: Array<Core_SupportTimeSlot>;
  themes?: Maybe<Array<Maybe<Core_ThemeLink>>>;
  ticketTypes?: Maybe<Array<Core_TicketType>>;
  /** @deprecated Use registrationSettings instead */
  ticketUrl?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  translationLanguages?: Maybe<Array<Core_LanguageEnum>>;
  twitterHashtag?: Maybe<Scalars['String']>;
  type: Core_EventTypeEnum;
  updatedAt?: Maybe<Scalars['Core_DateTime']>;
  userRole?: Maybe<Core_UserRoleEnum>;
  userStatus?: Maybe<Core_UserStatus>;
  userTerms?: Maybe<Array<Core_UserTerm>>;
  workflowLastExecution?: Maybe<Scalars['Core_DateTime']>;
};


export type Core_EventAdvertisementsArgs = {
  filter?: InputMaybe<Core_AdvertisementFilterInput>;
};


export type Core_EventAvailableMeetingSlotsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  dateRange?: InputMaybe<Core_DateRangeInput>;
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  peopleIds?: InputMaybe<Array<Scalars['ID']>>;
  slotIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Core_EventAvailableMeetingSlotsByDayArgs = {
  dateRange: Core_DateRangeInput;
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  peopleIds?: InputMaybe<Array<Scalars['ID']>>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type Core_EventBannerUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};


export type Core_EventBeginsAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_EventCreatedAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_EventEndsAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_EventFormsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  filters?: InputMaybe<Array<Core_EventFormFilterInput>>;
  sort?: InputMaybe<Array<Core_FormSortInput>>;
};


export type Core_EventInvitableMeetingPeopleArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  isConnectedOrSentRequest?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Core_EventLocationsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  filters?: InputMaybe<Core_EventLocationsFilterInput>;
};


export type Core_EventPagesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type Core_EventPlanningsCategoriesArgs = {
  onlyUsed?: InputMaybe<Scalars['Boolean']>;
};


export type Core_EventPlanningsPlacesArgs = {
  onlyUsed?: InputMaybe<Scalars['Boolean']>;
};


export type Core_EventPlanningsTypesArgs = {
  onlyUsed?: InputMaybe<Scalars['Boolean']>;
};


export type Core_EventProductCategoriesArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  filter?: InputMaybe<Core_ProductCategoriesFilterInput>;
};


export type Core_EventRegistrationFormsArgs = {
  filter?: InputMaybe<Core_EventRegistrationFormFilterInput>;
};


export type Core_EventTicketTypesArgs = {
  filter?: InputMaybe<Core_TicketTypeFilterInput>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type Core_EventUpdatedAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_EventUserTermsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  promptLocation?: InputMaybe<Core_PromptLocationEnum>;
};


export type Core_EventWorkflowLastExecutionArgs = {
  type: Core_EventWorkflowTypeEnum;
};

export type Core_EventAgenda = Core_ExhibitorMeetingBooked | Core_Planning | Core_UserMeetingBooked;

export type Core_EventBadgeView = Core_EventViewInterface & {
  __typename?: 'Core_EventBadgeView';
  advertisements: Array<Core_AdvertisementUnion>;
  allowPrint: Scalars['Boolean'];
  backgroundImageUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use badges field */
  badgeCode?: Maybe<Scalars['String']>;
  badgeTemplates: Array<Core_BadgeTemplate>;
  badgeType: Core_BadgeTypeEnum;
  /** @deprecated Use badges field */
  badgeUrl: Scalars['String'];
  badges: Array<Core_Badge>;
  color?: Maybe<Scalars['String']>;
  group?: Maybe<Core_EventGroupView>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  pageBackgroundUrl?: Maybe<Scalars['String']>;
};

export type Core_EventChatroomView = Core_EventViewInterface & {
  __typename?: 'Core_EventChatroomView';
  advertisements: Array<Core_AdvertisementUnion>;
  backgroundImageUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use externalLinks filter on chat-api channels query instead */
  channels: Array<Scalars['ID']>;
  color?: Maybe<Scalars['String']>;
  group?: Maybe<Core_EventGroupView>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  pageBackgroundUrl?: Maybe<Scalars['String']>;
};

export type Core_EventConfiguration = {
  __typename?: 'Core_EventConfiguration';
  /** @deprecated See field "canBookmark" on type Planning instead */
  allowPlanningChange: Scalars['Boolean'];
  backgroundColor: Scalars['String'];
  /** @deprecated Use field "contents" in Event type instead */
  buttons: Array<Core_ButtonConfiguration>;
  buttonsColor: Scalars['String'];
  primaryColor: Scalars['String'];
  textColor: Scalars['String'];
};


export type Core_EventConfigurationButtonsArgs = {
  types?: InputMaybe<Array<Core_ButtonTypeEnum>>;
};

export type Core_EventContents = {
  __typename?: 'Core_EventContents';
  views: Array<Core_EventView>;
  viewsLayout: Core_EventViewsLayout;
};


export type Core_EventContentsViewsArgs = {
  withGroups?: InputMaybe<Scalars['Boolean']>;
};

export type Core_EventExhibitorListView = Core_EventViewInterface & {
  __typename?: 'Core_EventExhibitorListView';
  advertisements: Array<Core_AdvertisementUnion>;
  backgroundImageUrl?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  exhibitorListSort: Core_EventExhibitorListViewSort;
  exhibitors: Core_ExhibitorsConnection;
  filters: Array<Core_EventFilter>;
  group?: Maybe<Core_EventGroupView>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  pageBackgroundUrl?: Maybe<Scalars['String']>;
  recommendations?: Maybe<Core_ExhibitorRecommendation>;
  /** @deprecated Use recommendations instead */
  recommended?: Maybe<Core_ExhibitorsConnection>;
  viewMode: Core_EventExhibitorListViewModeEnum;
};


export type Core_EventExhibitorListViewExhibitorsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
};


export type Core_EventExhibitorListViewRecommendedArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
};

export type Core_EventExhibitorListViewFilterInput = {
  mustEventFiltersIn?: InputMaybe<Array<Core_EventFilterInInput>>;
  shouldTypeIn?: InputMaybe<Array<Scalars['ID']>>;
};

export enum Core_EventExhibitorListViewModeEnum {
  Grid = 'GRID',
  List = 'LIST'
}

export enum Core_EventExhibitorListViewSort {
  Name = 'NAME',
  Type = 'TYPE'
}

export type Core_EventFeedView = Core_EventViewInterface & {
  __typename?: 'Core_EventFeedView';
  advertisements: Array<Core_AdvertisementUnion>;
  backgroundImageUrl?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  group?: Maybe<Core_EventGroupView>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  pageBackgroundUrl?: Maybe<Scalars['String']>;
};

export type Core_EventFilter = {
  __typename?: 'Core_EventFilter';
  display: Core_EventFilterDisplay;
  displayName: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  values: Array<Core_LabelString>;
};

export enum Core_EventFilterDisplay {
  List = 'LIST',
  Tags = 'TAGS',
  Tree = 'TREE'
}

export type Core_EventFilterInInput = {
  filterId: Scalars['ID'];
  values: Array<Scalars['ID']>;
};

export type Core_EventFilterInput = {
  applicationSlug?: InputMaybe<Scalars['String']>;
  attendingAs?: InputMaybe<Core_AttendingAsEnum>;
  canEdit?: InputMaybe<Scalars['Boolean']>;
  eventStatus?: InputMaybe<Core_EventStatusEnum>;
  role?: InputMaybe<Core_UserRoleEnum>;
  selfAttendeeStatus?: InputMaybe<Core_AttendeeStatusEnum>;
};

export type Core_EventFormElement = {
  __typename?: 'Core_EventFormElement';
  createUploadUrl?: Maybe<Core_CreateUploadUrlResult>;
  fieldDefinition?: Maybe<Core_FieldDefinitionUnion>;
  filters: Array<Core_EventFormElementFilter>;
  formId: Scalars['ID'];
  id: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  parent?: Maybe<Core_EventFormElement>;
  regularFieldType?: Maybe<Core_RegularFieldTypeEnum>;
  type: Core_FormElementTypeEnum;
  value?: Maybe<Scalars['String']>;
};


export type Core_EventFormElementCreateUploadUrlArgs = {
  fileName?: InputMaybe<Scalars['String']>;
  mimeType: Scalars['Core_MimeType'];
  size?: InputMaybe<Scalars['Float']>;
};

export type Core_EventFormElementFilter = {
  __typename?: 'Core_EventFormElementFilter';
  condition?: Maybe<Core_RightFilterConditionEnum>;
  fieldValue?: Maybe<Core_FieldValueUnion>;
  id: Scalars['ID'];
  operator?: Maybe<Core_FormElementFilterOperatorEnum>;
  parentId?: Maybe<Scalars['ID']>;
  ticketType?: Maybe<Core_TicketType>;
  triggerFormElement?: Maybe<Core_EventFormElement>;
};

export type Core_EventFormFilterInput = {
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  isExhibitorQualifier?: InputMaybe<Scalars['Boolean']>;
  /**
   * true : only published forms returned + ordered by availableFrom
   * false : only unpublished forms returned + ordered by createdAt
   * null : all forms returned + ordered by createdAt / no regressions brought
   */
  isPublished?: InputMaybe<Scalars['Boolean']>;
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Core_EventGroup = {
  __typename?: 'Core_EventGroup';
  /** @deprecated Use announcementMessage on Exhibitor type */
  announcementMessage?: Maybe<Scalars['String']>;
  documentLimit?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Core_EventGroupView = Core_EventViewInterface & {
  __typename?: 'Core_EventGroupView';
  advertisements: Array<Core_AdvertisementUnion>;
  backgroundImageUrl?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  group?: Maybe<Core_EventGroupView>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  pageBackgroundUrl?: Maybe<Scalars['String']>;
};

export type Core_EventHostedBuyersListView = Core_EventViewInterface & {
  __typename?: 'Core_EventHostedBuyersListView';
  advertisements: Array<Core_AdvertisementUnion>;
  backgroundImageUrl?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  condition: Core_HostedMeetingCondition;
  eventPeopleListSort: Core_EventPeopleListViewSort;
  filters: Array<Core_EventFilter>;
  group?: Maybe<Core_EventGroupView>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  pageBackgroundUrl?: Maybe<Scalars['String']>;
  /** Lists people with data specific to the list view display preferences. */
  people: Core_PeopleViewFeaturedCardConnection;
};


export type Core_EventHostedBuyersListViewPeopleArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  sort?: InputMaybe<Core_EventHostedBuyersSortInput>;
};

export type Core_EventHostedBuyersListViewFilterInput = {
  isConnected?: InputMaybe<Scalars['Boolean']>;
  isExcluded?: InputMaybe<Scalars['Boolean']>;
  isSelected?: InputMaybe<Scalars['Boolean']>;
  mustEventFiltersIn?: InputMaybe<Array<Core_EventFilterInInput>>;
};

export enum Core_EventHostedBuyersSortFieldEnum {
  CreatedAt = 'CREATED_AT',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME'
}

export type Core_EventHostedBuyersSortInput = {
  field: Core_EventHostedBuyersSortFieldEnum;
  order?: InputMaybe<Core_SortOrderEnum>;
};

export type Core_EventInterface = {
  _id: Scalars['ID'];
  address?: Maybe<Core_Address>;
  bannerUrl?: Maybe<Scalars['String']>;
  beginsAt: Scalars['Core_DateTime'];
  createdAt?: Maybe<Scalars['Core_DateTime']>;
  description?: Maybe<Scalars['String']>;
  endsAt: Scalars['Core_DateTime'];
  eventStatus?: Maybe<Core_EventStatusEnum>;
  htmlDescription?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  /** @deprecated Use field `isVisibleAsAttendee` on type `Event` or `isBookmarked` on type `Planning` instead */
  selfAttendeeStatus?: Maybe<Core_AttendeeStatusEnum>;
  title: Scalars['String'];
  twitterHashtag?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Core_DateTime']>;
  userRole?: Maybe<Core_UserRoleEnum>;
};


export type Core_EventInterfaceBannerUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};


export type Core_EventInterfaceBeginsAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_EventInterfaceCreatedAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_EventInterfaceEndsAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_EventInterfaceUpdatedAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_EventLocationsFilterInput = {
  /** Find specific location ids */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** Filters by matching location names */
  search?: InputMaybe<Scalars['String']>;
};

export type Core_EventMapsProviderExpoFp = {
  __typename?: 'Core_EventMapsProviderExpoFP';
  mapsUrl?: Maybe<Scalars['String']>;
};

export type Core_EventMapsProviderMapsIndoors = {
  __typename?: 'Core_EventMapsProviderMapsIndoors';
  mapsApiKey?: Maybe<Scalars['String']>;
  mapsVenueId?: Maybe<Scalars['String']>;
  orientation?: Maybe<Scalars['Int']>;
  zoom?: Maybe<Core_Zoom>;
};

export type Core_EventMapsProviderUnion = Core_EventMapsProviderExpoFp | Core_EventMapsProviderMapsIndoors;

export type Core_EventMapsView = Core_EventViewInterface & {
  __typename?: 'Core_EventMapsView';
  advertisements: Array<Core_AdvertisementUnion>;
  backgroundImageUrl?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  eventMapsProvider: Core_EventMapsProviderUnion;
  group?: Maybe<Core_EventGroupView>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** @deprecated Use eventMapsProvider instead */
  mapsApiKey?: Maybe<Scalars['String']>;
  /** @deprecated Use eventMapsProvider instead */
  mapsProvider?: Maybe<Core_MapsProviderEnum>;
  /** @deprecated Use eventMapsProvider instead */
  mapsUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use eventMapsProvider instead */
  mapsVenueId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  pageBackgroundUrl?: Maybe<Scalars['String']>;
  positioningProvider?: Maybe<Core_PositioningProviderUnion>;
};

export type Core_EventMyAiRecommendationsView = Core_EventViewInterface & {
  __typename?: 'Core_EventMyAiRecommendationsView';
  advertisements: Array<Core_AdvertisementUnion>;
  backgroundImageUrl?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  contentOrder: Array<Core_MyAiRecommendationsEnum>;
  group?: Maybe<Core_EventGroupView>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  pageBackgroundUrl?: Maybe<Scalars['String']>;
  /**
   * Returns AI Recommendations selected to be displayed, for entities: people, exhibitors, plannings and products.
   * - null: carrousel should be disabled; we don't have the entity type toggled on the enum, or we have less than 20 entities on the event (minimum for recommendations)
   * - empty: we don't have enough data yet to recommend.
   */
  recommendations?: Maybe<Core_MyAiRecommendationsPayload>;
};

export type Core_EventMyVisitView = Core_EventViewInterface & {
  __typename?: 'Core_EventMyVisitView';
  advertisements: Array<Core_AdvertisementUnion>;
  backgroundImageUrl?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  group?: Maybe<Core_EventGroupView>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** @deprecated Use myAiRecommendations instead */
  myVisitRecommendations: Array<Core_MyVisitRecommendation>;
  name?: Maybe<Scalars['String']>;
  pageBackgroundUrl?: Maybe<Scalars['String']>;
  tabs: Array<Core_MyVisitTab>;
};

export type Core_EventPaymentSettings = {
  __typename?: 'Core_EventPaymentSettings';
  currency: Scalars['String'];
  paymentProviders: Array<Core_PaymentProvider>;
  vatLabel?: Maybe<Scalars['String']>;
  vatRate?: Maybe<Scalars['Float']>;
};

export type Core_EventPeopleConnection = {
  __typename?: 'Core_EventPeopleConnection';
  edges: Array<Core_EventPersonEdge>;
  nodes: Array<Core_EventPerson>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_EventPeopleListView = Core_EventViewInterface & {
  __typename?: 'Core_EventPeopleListView';
  advertisements: Array<Core_AdvertisementUnion>;
  /** Lists the slots in which the user can request a meeting.  */
  availabilityFilter?: Maybe<Core_PersonMeetingSlotsConnection>;
  backgroundImageUrl?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  eventPeopleListSort: Core_EventPeopleListViewSort;
  filters: Array<Core_EventFilter>;
  group?: Maybe<Core_EventGroupView>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  /** List all people currently online. */
  onlinePeople: Core_EventPeopleConnection;
  pageBackgroundUrl?: Maybe<Scalars['String']>;
  /** Lists people in the event. */
  people: Core_EventPeopleConnection;
  /** Lists people with data specific to the list view display preferences. */
  peopleViewFeaturedCards: Core_PeopleViewFeaturedCardConnection;
  /** Lists most recommended people for the current user. */
  recommendations?: Maybe<Core_EventPersonRecommendation>;
  /**
   * List of most recommended people for the current user.
   * @deprecated Use recommendations instead
   */
  recommendedPeople?: Maybe<Core_EventPeopleConnection>;
  viewMode: Core_EventPeopleListViewModeEnum;
};


export type Core_EventPeopleListViewAvailabilityFilterArgs = {
  cursor: Core_CursorPaginationInput;
};


export type Core_EventPeopleListViewOnlinePeopleArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  includeSelf?: InputMaybe<Scalars['Boolean']>;
};


export type Core_EventPeopleListViewPeopleArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  includeSelf?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Core_EventPeopleSortInput>;
};


export type Core_EventPeopleListViewPeopleViewFeaturedCardsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  includeSelf?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Core_EventPeopleSortInput>;
};


export type Core_EventPeopleListViewRecommendedPeopleArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
};

export type Core_EventPeopleListViewFilterInput = {
  isConnected?: InputMaybe<Scalars['Boolean']>;
  mustEventFiltersIn?: InputMaybe<Array<Core_EventFilterInInput>>;
  /** Filter by availability to request a meeting on at least one of these time slots */
  mustHaveTimeSlotIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum Core_EventPeopleListViewModeEnum {
  Grid = 'GRID',
  List = 'LIST'
}

export enum Core_EventPeopleListViewSort {
  CreatedAt = 'CREATED_AT',
  Default = 'DEFAULT',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  /** @deprecated Use LAST_NAME instead */
  Name = 'NAME',
  /** @deprecated Not used */
  Recommendation = 'RECOMMENDATION',
  /** @deprecated Use aggregations with custom fields instead */
  Type = 'TYPE'
}

export enum Core_EventPeopleSortFieldEnum {
  CreatedAt = 'CREATED_AT',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME'
}

export type Core_EventPeopleSortInput = {
  field: Core_EventPeopleSortFieldEnum;
  order?: InputMaybe<Core_SortOrderEnum>;
};

export type Core_EventPerson = Core_EventPersonInterface & {
  __typename?: 'Core_EventPerson';
  address?: Maybe<Core_Address>;
  aggregation?: Maybe<Core_Aggregation>;
  attendeeOnPlannings: Array<Core_Planning>;
  biography?: Maybe<Scalars['String']>;
  canScanBadge: Scalars['Boolean'];
  community: Core_Community;
  /** @deprecated No longer supported */
  company?: Maybe<Core_Company>;
  connectionInfo?: Maybe<Core_ConnectionInfo>;
  email?: Maybe<Scalars['String']>;
  /** @deprecated use EventPerson.withEvent */
  event: Core_Event;
  events?: Maybe<Core_EventsConnection>;
  fields: Array<Core_FieldUnion>;
  firstName: Scalars['String'];
  /** Return true if user should accept or decline the data. */
  hasPendingChanges?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isGuestModeActive: Scalars['Boolean'];
  jobTitle?: Maybe<Scalars['String']>;
  landlinePhone?: Maybe<Core_PhoneNumber>;
  lastName: Scalars['String'];
  /** @deprecated use withEvent.meetings */
  meetings?: Maybe<Array<Core_Meeting>>;
  memberOnExhibitors: Array<Core_Exhibitor>;
  mobilePhone?: Maybe<Core_PhoneNumber>;
  organization?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  recommendationExplanations?: Maybe<Array<Core_RecommendationExplanation>>;
  /** @deprecated No longer supported */
  secondJobTitle?: Maybe<Scalars['String']>;
  socialNetworks: Array<Core_SocialNetwork>;
  speakerOnPlannings: Array<Core_Planning>;
  /** @deprecated No longer supported */
  tags: Array<Scalars['String']>;
  type?: Maybe<Core_EventPersonType>;
  userId?: Maybe<Scalars['ID']>;
  userInfo?: Maybe<Core_UserInfo>;
  userTermResponses?: Maybe<Array<Core_EventPersonUserTerm>>;
  websiteUrl?: Maybe<Scalars['String']>;
  withEvent?: Maybe<Core_EventPersonWithEvent>;
};


export type Core_EventPersonAttendeeOnPlanningsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_EventPersonEventsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
};


export type Core_EventPersonMeetingsArgs = {
  isPast?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Array<Core_MeetingStatus>>;
};


export type Core_EventPersonMemberOnExhibitorsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_EventPersonSpeakerOnPlanningsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_EventPersonUserTermResponsesArgs = {
  promptLocation?: InputMaybe<Core_PromptLocationEnum>;
  userTermIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Core_EventPersonWithEventArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
  eventSlug?: InputMaybe<Scalars['String']>;
};

export type Core_EventPersonEdge = {
  __typename?: 'Core_EventPersonEdge';
  cursor: Scalars['String'];
  node: Core_EventPerson;
};

export type Core_EventPersonInterface = {
  address?: Maybe<Core_Address>;
  attendeeOnPlannings: Array<Core_Planning>;
  biography?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  company?: Maybe<Core_Company>;
  connectionInfo?: Maybe<Core_ConnectionInfo>;
  email?: Maybe<Scalars['String']>;
  fields: Array<Core_FieldUnion>;
  firstName: Scalars['String'];
  jobTitle?: Maybe<Scalars['String']>;
  landlinePhone?: Maybe<Core_PhoneNumber>;
  lastName: Scalars['String'];
  memberOnExhibitors: Array<Core_Exhibitor>;
  mobilePhone?: Maybe<Core_PhoneNumber>;
  organization?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  recommendationExplanations?: Maybe<Array<Core_RecommendationExplanation>>;
  /** @deprecated No longer supported */
  secondJobTitle?: Maybe<Scalars['String']>;
  socialNetworks: Array<Core_SocialNetwork>;
  speakerOnPlannings: Array<Core_Planning>;
  /** @deprecated No longer supported */
  tags: Array<Scalars['String']>;
  type?: Maybe<Core_EventPersonType>;
  userId?: Maybe<Scalars['ID']>;
  userInfo?: Maybe<Core_UserInfo>;
  websiteUrl?: Maybe<Scalars['String']>;
};


export type Core_EventPersonInterfaceAttendeeOnPlanningsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_EventPersonInterfaceMemberOnExhibitorsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_EventPersonInterfaceSpeakerOnPlanningsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};

export type Core_EventPersonRecommendation = {
  __typename?: 'Core_EventPersonRecommendation';
  metadata: Scalars['String'];
  recommendedEntities?: Maybe<Array<Core_EventPersonRecommended>>;
  totalCount: Scalars['Int'];
};

export type Core_EventPersonRecommendationExplanation = {
  __typename?: 'Core_EventPersonRecommendationExplanation';
  origin: Core_RecommendationExplanationOriginEnum;
  type: Core_RecommendationExplanationTypeEnum;
  values?: Maybe<Array<Core_EventPerson>>;
};

export type Core_EventPersonRecommended = {
  __typename?: 'Core_EventPersonRecommended';
  explanations?: Maybe<Array<Core_RecommendationExplanation>>;
  person: Core_EventPerson;
};

export type Core_EventPersonType = {
  __typename?: 'Core_EventPersonType';
  id: Scalars['ID'];
  isVisible: Scalars['Boolean'];
  value: Scalars['String'];
};

export type Core_EventPersonUserTerm = {
  __typename?: 'Core_EventPersonUserTerm';
  accepted: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['Core_DateTime']>;
  updatedAtTs?: Maybe<Scalars['Core_Timestamp']>;
  userTerm: Core_UserTerm;
};


export type Core_EventPersonUserTermUpdatedAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_EventPersonWithEvent = {
  __typename?: 'Core_EventPersonWithEvent';
  attendeeOnPlannings: Array<Core_Planning>;
  canMeet: Scalars['Boolean'];
  event: Core_Event;
  fields: Array<Core_FieldUnion>;
  groups: Array<Core_EventGroup>;
  hostedBuyersSelection: Core_HostedBuyersSelection;
  id: Scalars['ID'];
  isGuestModeActive: Scalars['Boolean'];
  /** Get count of meeting invitations between user and exhibitor. Default: both individual and group meetings. */
  meetingInvitationsCount: Scalars['Int'];
  /** Return paginated meetingSlots with isDisabled flag */
  meetingSlots: Core_PersonMeetingSlotsConnection;
  /** Get count of meeting slots per day. */
  meetingSlotsByDay?: Maybe<Core_MeetingSlotsByDayConnection>;
  meetings?: Maybe<Array<Core_Meeting>>;
  memberOnExhibitors: Array<Core_Exhibitor>;
  registration?: Maybe<Core_Registration>;
  speakerOnPlannings: Array<Core_Planning>;
  userTermResponses?: Maybe<Array<Core_EventPersonUserTerm>>;
};


export type Core_EventPersonWithEventAttendeeOnPlanningsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_EventPersonWithEventHostedBuyersSelectionArgs = {
  viewId: Scalars['ID'];
};


export type Core_EventPersonWithEventMeetingInvitationsCountArgs = {
  isIndividualMeeting?: InputMaybe<Scalars['Boolean']>;
};


export type Core_EventPersonWithEventMeetingSlotsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  filter?: InputMaybe<Core_MeetingSlotsFilterInput>;
};


export type Core_EventPersonWithEventMeetingSlotsByDayArgs = {
  dateRange: Core_DateRangeInput;
  timezone?: InputMaybe<Scalars['String']>;
};


export type Core_EventPersonWithEventMeetingsArgs = {
  isPast?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Array<Core_MeetingSortInput>>;
  status?: InputMaybe<Array<Core_MeetingStatus>>;
};


export type Core_EventPersonWithEventMemberOnExhibitorsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_EventPersonWithEventSpeakerOnPlanningsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_EventPersonWithEventUserTermResponsesArgs = {
  promptLocation?: InputMaybe<Core_PromptLocationEnum>;
  userTermIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Core_EventPlanningListView = Core_EventViewInterface & {
  __typename?: 'Core_EventPlanningListView';
  advertisements: Array<Core_AdvertisementUnion>;
  backgroundImageUrl?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  displayMode: Core_EventPlanningListViewDisplayMode;
  filters: Array<Core_EventFilter>;
  group?: Maybe<Core_EventGroupView>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  /** Returns a list of aggregations for plannings based on view configuration. */
  navigation?: Maybe<Array<Core_Aggregation>>;
  pageBackgroundUrl?: Maybe<Scalars['String']>;
  plannings: Core_PlanningsConnection;
  /**
   * Return aggregations of plannings by day filtered upfront by the view parameters.
   * By default it uses the timezone of the event to group by days.
   */
  planningsByDay: Array<Core_DateAggregation>;
  recommendations?: Maybe<Core_PlanningRecommendation>;
  /** @deprecated Use recommendations instead */
  recommended?: Maybe<Core_PlanningsConnection>;
};


export type Core_EventPlanningListViewNavigationArgs = {
  timezone?: InputMaybe<Scalars['String']>;
};


export type Core_EventPlanningListViewPlanningsArgs = {
  aggregationsIds?: InputMaybe<Array<Scalars['ID']>>;
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  range?: InputMaybe<Core_DateRangeInput>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type Core_EventPlanningListViewPlanningsByDayArgs = {
  timezone?: InputMaybe<Scalars['String']>;
};


export type Core_EventPlanningListViewRecommendationsArgs = {
  aggregationsIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type Core_EventPlanningListViewRecommendedArgs = {
  aggregationsIds?: InputMaybe<Array<Scalars['ID']>>;
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  range?: InputMaybe<Core_DateRangeInput>;
};

export enum Core_EventPlanningListViewDisplayMode {
  Grid = 'GRID',
  List = 'LIST',
  Live = 'LIVE'
}

export type Core_EventPlanningListViewFilterInput = {
  customFields?: InputMaybe<Core_IdFilter>;
  isAttending?: InputMaybe<Scalars['Boolean']>;
  /** Deprecated: use "customFields" instead */
  mustCategoryIn?: InputMaybe<Array<Scalars['ID']>>;
  /** Deprecated: use "customFields" instead */
  mustEventFiltersIn?: InputMaybe<Array<Core_EventFilterInInput>>;
  /** Deprecated: use "customFields" instead */
  mustTypeIn?: InputMaybe<Array<Scalars['ID']>>;
  notPlanningIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Deprecated: use "customFields" instead */
  shouldCategoryIn?: InputMaybe<Array<Scalars['ID']>>;
  shouldDayIn?: InputMaybe<Array<Scalars['Core_DateTime']>>;
  shouldExhibitorIn?: InputMaybe<Array<Scalars['ID']>>;
  /** Deprecated: use "customFields" instead */
  shouldPlaceIn?: InputMaybe<Array<Scalars['ID']>>;
  /** Deprecated: use "customFields" instead */
  shouldTypeIn?: InputMaybe<Array<Scalars['ID']>>;
};

export type Core_EventProductCategoriesResult = {
  __typename?: 'Core_EventProductCategoriesResult';
  categories: Array<Core_EventProductCategory>;
  totalCount: Scalars['Int'];
};

export type Core_EventProductCategory = {
  __typename?: 'Core_EventProductCategory';
  category: Core_ProductCategory;
  productCount: Scalars['Int'];
  products: Array<Core_Product>;
  /** @deprecated Use product count */
  recursiveProductCount: Scalars['Int'];
};


export type Core_EventProductCategoryProductsArgs = {
  recursive: Scalars['Boolean'];
  take: Scalars['Int'];
};

export type Core_EventProductCategoryFilterInput = {
  id?: InputMaybe<Scalars['ID']>;
  recursive?: InputMaybe<Scalars['Boolean']>;
};

export type Core_EventProductExpressionFilterInput = {
  eventFilterValueIds: Core_IdFilter;
};

export type Core_EventProductExpressionFiltersInput = {
  expressions: Array<Core_EventProductExpressionFilterInput>;
  operation?: InputMaybe<Core_FilterOperation>;
};

export type Core_EventProductListView = Core_EventViewInterface & {
  __typename?: 'Core_EventProductListView';
  advertisements: Array<Core_AdvertisementUnion>;
  backgroundImageUrl?: Maybe<Scalars['String']>;
  category: Core_ProductCategoryUnion;
  color?: Maybe<Scalars['String']>;
  group?: Maybe<Core_EventGroupView>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  pageBackgroundUrl?: Maybe<Scalars['String']>;
  viewMode: Core_ViewModeEnum;
};

export type Core_EventProductListViewV2 = Core_EventViewInterface & {
  __typename?: 'Core_EventProductListViewV2';
  advertisements: Array<Core_AdvertisementUnion>;
  backgroundImageUrl?: Maybe<Scalars['String']>;
  category?: Maybe<Core_ProductCategory>;
  color?: Maybe<Scalars['String']>;
  eventProducts: Core_EventProducts;
  group?: Maybe<Core_EventGroupView>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  pageBackgroundUrl?: Maybe<Scalars['String']>;
  viewMode: Core_ViewModeEnum;
};

export type Core_EventProductSortInput = {
  field: Core_ProductSortFieldEnum;
  order?: InputMaybe<Core_SortOrderEnum>;
};

export type Core_EventProducts = {
  __typename?: 'Core_EventProducts';
  bookmarks: Core_ProductsConnection;
  filters: Array<Core_EventFilter>;
  products: Core_ProductsConnection;
  recommendations?: Maybe<Core_ProductRecommendation>;
  /** @deprecated use recommendations instead */
  recommended: Core_ProductsConnection;
  /** @deprecated use recommendations instead */
  recommendedV2?: Maybe<Core_ProductsConnection>;
  subcategories: Core_EventProductCategoriesResult;
};


export type Core_EventProductsBookmarksArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
};


export type Core_EventProductsProductsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
};


export type Core_EventProductsRecommendedArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
};


export type Core_EventProductsRecommendedV2Args = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
};


export type Core_EventProductsSubcategoriesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take: Scalars['Int'];
};

export type Core_EventProductsQueryFilterInput = {
  category?: InputMaybe<Core_EventProductCategoryFilterInput>;
  exhibitorId?: InputMaybe<Scalars['ID']>;
  expressionFilters?: InputMaybe<Core_EventProductExpressionFiltersInput>;
  notProductIds?: InputMaybe<Array<Scalars['ID']>>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Core_EventProfile = {
  __typename?: 'Core_EventProfile';
  addresses?: Maybe<Array<Maybe<Core_Address>>>;
  biography?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  company?: Maybe<Core_Company>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  interests?: Maybe<Array<Maybe<Scalars['String']>>>;
  jobTitle?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastName?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  personType?: Maybe<Core_PersonTypeEnum>;
  phoneNumbers?: Maybe<Array<Maybe<Core_PhoneNumber>>>;
  photoUrl?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  secondJobTitle?: Maybe<Scalars['String']>;
  socialNetworks?: Maybe<Array<Maybe<Core_SocialNetwork>>>;
  userStatus?: Maybe<Core_UserStatusEnum>;
  websiteUrl?: Maybe<Scalars['String']>;
};


export type Core_EventProfileLogoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};


export type Core_EventProfilePhoneNumbersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Core_PhoneNumberEnum>;
};


export type Core_EventProfilePhotoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};

export type Core_EventRecommendationExplanation = {
  __typename?: 'Core_EventRecommendationExplanation';
  origin: Core_RecommendationExplanationOriginEnum;
  type: Core_RecommendationExplanationTypeEnum;
  values?: Maybe<Array<Core_Event>>;
};

export type Core_EventRedirectUrlView = Core_EventViewInterface & {
  __typename?: 'Core_EventRedirectUrlView';
  advertisements: Array<Core_AdvertisementUnion>;
  backgroundImageUrl?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  group?: Maybe<Core_EventGroupView>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  pageBackgroundUrl?: Maybe<Scalars['String']>;
  redirectUrl: Scalars['String'];
  redirectUrlOpenAs: Core_RedirectUrlOpenAsEnum;
};

export type Core_EventRegistrationForm = {
  __typename?: 'Core_EventRegistrationForm';
  formElements?: Maybe<Array<Core_EventFormElement>>;
  id: Scalars['ID'];
  title: Scalars['String'];
  type: Core_RegistrationFormTypeEnum;
};


export type Core_EventRegistrationFormFormElementsArgs = {
  filter?: InputMaybe<Core_EventRegistrationFormElementFilterInput>;
};

export type Core_EventRegistrationFormElementFilterInput = {
  formElementId?: InputMaybe<Scalars['ID']>;
};

export type Core_EventRegistrationFormFilterInput = {
  formElementFilter?: InputMaybe<Core_EventRegistrationFormFormElementFilterInput>;
  id?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<Core_RegistrationFormTypeEnum>;
};

export type Core_EventRegistrationFormFormElementFilterInput = {
  formElementId?: InputMaybe<Scalars['ID']>;
  ticketTypeId?: InputMaybe<Scalars['ID']>;
};

export enum Core_EventSortEnum {
  BeginsAt = 'BEGINS_AT'
}

export type Core_EventSortInput = {
  field: Core_EventSortEnum;
  order?: InputMaybe<Core_SortOrderEnum>;
};

export enum Core_EventStatusEnum {
  OnGoing = 'ON_GOING',
  Past = 'PAST',
  Upcoming = 'UPCOMING'
}

export enum Core_EventTypeEnum {
  Hybrid = 'HYBRID',
  Physical = 'PHYSICAL',
  Virtual = 'VIRTUAL'
}

/** Deprecated. All new operations use the UserSettings type */
export type Core_EventUserSettings = {
  __typename?: 'Core_EventUserSettings';
  sendEmailActivitiesReminder: Scalars['Boolean'];
  sendEmailMeetingsReminder: Scalars['Boolean'];
  sendEmailRequestsReminder: Scalars['Boolean'];
  sendOrganizerEmail: Scalars['Boolean'];
};

export type Core_EventView = Core_EventBadgeView | Core_EventChatroomView | Core_EventExhibitorListView | Core_EventFeedView | Core_EventGroupView | Core_EventHostedBuyersListView | Core_EventMapsView | Core_EventMyAiRecommendationsView | Core_EventMyVisitView | Core_EventPeopleListView | Core_EventPlanningListView | Core_EventProductListView | Core_EventRedirectUrlView;

export type Core_EventViewInterface = {
  advertisements: Array<Core_AdvertisementUnion>;
  backgroundImageUrl?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  group?: Maybe<Core_EventGroupView>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  pageBackgroundUrl?: Maybe<Scalars['String']>;
};

export enum Core_EventViewsLayout {
  Grid = 'GRID',
  List = 'LIST'
}

export enum Core_EventVisibilityEnum {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum Core_EventWorkflowTypeEnum {
  ExhibitorRecommendedLeads = 'EXHIBITOR_RECOMMENDED_LEADS'
}

export type Core_EventsConnection = {
  __typename?: 'Core_EventsConnection';
  nodes: Array<Core_Event>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_EventsFilterInput = {
  AND?: InputMaybe<Array<Core_EventsFilterInput>>;
  OR?: InputMaybe<Array<Core_EventsFilterInput>>;
  /** Filters events that shouldn't be sent in response. */
  excludeEventIds?: InputMaybe<Array<Scalars['ID']>>;
  isOrganizationMember?: InputMaybe<Scalars['Boolean']>;
  timeStatus?: InputMaybe<Core_EventStatusEnum>;
};

export type Core_EventsForQualificationFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  onlyExhibitorsWithForm?: InputMaybe<Scalars['Boolean']>;
};

export type Core_Exhibitor = {
  __typename?: 'Core_Exhibitor';
  _id: Scalars['ID'];
  address?: Maybe<Core_Address>;
  /**
   * Return a list of advertisements attached to this exhibitor.
   * @deprecated Use withEvent.advertisements instead
   */
  advertisements: Array<Core_AdvertisementExhibitorUnion>;
  analytics?: Maybe<Analytics_ExhibitorWrapper>;
  /** @deprecated Use withEvent.announcementMessage */
  announcementMessage?: Maybe<Scalars['String']>;
  backgroundImageUrl?: Maybe<Scalars['String']>;
  banner?: Maybe<Core_Banner>;
  /** @deprecated Use withEvent.booths instead */
  booth?: Maybe<Scalars['String']>;
  /** @deprecated Use withEvent.canInviteMembers instead */
  canInviteMembers: Scalars['Boolean'];
  /** @deprecated Use withEvent.canScanBadge instead */
  canScanBadge: Scalars['Boolean'];
  /** Whether the user is allowed to talk with the exhibitor at community level, use withEvent.canTalkTo for events. */
  canTalkTo: Scalars['Boolean'];
  /** @deprecated Use withEvent.canViewVisits instead */
  canViewVisits: Scalars['Boolean'];
  /** @deprecated Categories can be found in field 'fields' */
  categories: Array<Scalars['String']>;
  community: Core_Community;
  description?: Maybe<Scalars['String']>;
  documentLimit?: Maybe<Scalars['Int']>;
  documents: Array<Core_Document>;
  editableFields: Core_EditableExhibitorFields;
  email?: Maybe<Scalars['String']>;
  /** @deprecated use Exhibitor.events instead */
  event: Core_Event;
  events?: Maybe<Core_EventsConnection>;
  exhibitorMemberRole: Core_ExhibitorMemberRole;
  exhibitorStatus?: Maybe<Core_ExhibitorStatusEnum>;
  fields: Array<Core_FieldUnion>;
  /** @deprecated Use withEvent.announcementMessage, withEvent.editableFields instead */
  group?: Maybe<Core_EventGroup>;
  groupBy?: Maybe<Core_GroupByField>;
  htmlDescription?: Maybe<Scalars['String']>;
  htmlDescriptionTranslations: Array<Core_TranslationString>;
  /** Represents if the Exhibitor has been bookmarked at Community Level */
  isBookmarked?: Maybe<Scalars['Boolean']>;
  isGuestModeActive: Scalars['Boolean'];
  linkedExhibitors: Array<Core_Exhibitor>;
  logoUrl?: Maybe<Scalars['String']>;
  /**
   * The URL to the page to manage meetings of the exhibitor (if any).
   * @deprecated Use withEvent.meetingsUrls instead
   */
  meetingsUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nameTranslations: Array<Core_TranslationString>;
  phoneNumbers: Array<Core_PhoneNumber>;
  /** Get a unique product on this exhibitor. */
  product?: Maybe<Core_Product>;
  products: Core_EventProducts;
  rootProductCategories: Core_ExhibitorRootProductCategoriesConnection;
  similarExhibitors: Array<Core_Exhibitor>;
  socialNetworks: Array<Core_SocialNetwork>;
  type?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  withEvent?: Maybe<Core_ExhibitorWithEvent>;
};


export type Core_ExhibitorAnalyticsArgs = {
  with?: InputMaybe<Scalars['Boolean']>;
};


export type Core_ExhibitorEventsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  filter?: InputMaybe<Core_ExhibitorEventsFilterInput>;
  sort?: InputMaybe<Core_ExhibitorEventsSortInput>;
};


export type Core_ExhibitorLinkedExhibitorsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_ExhibitorLogoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};


export type Core_ExhibitorPhoneNumbersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Core_PhoneNumberEnum>;
};


export type Core_ExhibitorProductArgs = {
  id: Scalars['ID'];
};


export type Core_ExhibitorProductsArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<Core_ExhibitorProductsFilterInput>;
  search?: InputMaybe<Scalars['String']>;
};


export type Core_ExhibitorRootProductCategoriesArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
};


export type Core_ExhibitorSimilarExhibitorsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_ExhibitorWithEventArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
  eventSlug?: InputMaybe<Scalars['String']>;
};

export type Core_ExhibitorAdvertisement = Core_AdvertisementInterface & {
  __typename?: 'Core_ExhibitorAdvertisement';
  exhibitor: Core_Exhibitor;
  id: Scalars['ID'];
  /** @deprecated Use webImageUrl instead */
  imageUrl: Scalars['String'];
  mobileImageUrl: Scalars['String'];
  webImageUrl: Scalars['String'];
};

export type Core_ExhibitorAdvertisementRedirectProductInput = {
  productId: Scalars['ID'];
};

export type Core_ExhibitorAdvertisementRedirectUrlInput = {
  redirectUrl: Scalars['String'];
};

export type Core_ExhibitorEventsFilterInput = {
  isLive?: InputMaybe<Scalars['Boolean']>;
  isPast?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
};

export enum Core_ExhibitorEventsSortEnum {
  BeginsAt = 'BEGINS_AT'
}

export type Core_ExhibitorEventsSortInput = {
  field: Core_ExhibitorEventsSortEnum;
  order?: InputMaybe<Core_SortOrderEnum>;
};

export type Core_ExhibitorFilterInput = {
  /** Filters exhibitors having **all** these categories. */
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filters exhibitors bookmarked or not by the user. */
  isBookmarked?: InputMaybe<Scalars['Boolean']>;
  mustFiltersIn?: InputMaybe<Array<Core_EventFilterInInput>>;
  notExhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filters exhibitors having **at least one** type among these ones. */
  shouldTypeIn?: InputMaybe<Array<Scalars['ID']>>;
};

export type Core_ExhibitorInput = {
  address?: InputMaybe<Core_AddressInput>;
  backgroundImageUrl?: InputMaybe<Scalars['String']>;
  banner?: InputMaybe<Core_BannerInput>;
  /** @deprecated use booths instead */
  booth?: InputMaybe<Scalars['String']>;
  /**
   * Complete updated list of ordered location ids.
   * Should be used to add/remove or reorder booths for this exhibitor
   * If previously existing boothIds are not in the list, they will be removed.
   */
  booths?: InputMaybe<Array<Scalars['ID']>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  createFields?: InputMaybe<Array<Core_CreateFieldInput>>;
  deleteFields?: InputMaybe<Array<Scalars['ID']>>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  htmlDescription?: InputMaybe<Scalars['String']>;
  htmlDescriptionTranslations?: InputMaybe<Array<Core_TranslationStringInput>>;
  logoUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameTranslations?: InputMaybe<Array<Core_TranslationStringInput>>;
  phoneNumbers?: InputMaybe<Array<Core_PhoneNumberInput>>;
  socialNetworks?: InputMaybe<Array<Core_SocialNetworkInput>>;
  type?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type Core_ExhibitorMeeting = Core_MeetingInterface & {
  __typename?: 'Core_ExhibitorMeeting';
  /** @deprecated Use 'meeting' instead */
  booking?: Maybe<Core_ExhibitorMeetingBooking>;
  ends: Scalars['Core_DateTime'];
  id: Scalars['ID'];
  meeting?: Maybe<Core_Meeting>;
  places: Array<Core_MeetingPlace>;
  starts: Scalars['Core_DateTime'];
};


export type Core_ExhibitorMeetingEndsArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_ExhibitorMeetingStartsArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_ExhibitorMeetingAssignedActivity = Core_ActivityInterface & {
  __typename?: 'Core_ExhibitorMeetingAssignedActivity';
  /** The community in which the activity happened. */
  community?: Maybe<Core_Community>;
  /** The event in which the activity happened. */
  event?: Maybe<Core_Event>;
  exhibitor: Core_Exhibitor;
  id: Scalars['ID'];
  kind: Core_ExhibitorMeetingAssignedActivityKind;
  /** @deprecated Use field meetingV2 instead */
  meeting: Core_ExhibitorMeeting;
  meetingV2: Core_Meeting;
  seen: Scalars['Boolean'];
  sentAt: Scalars['Core_DateTime'];
  /** The meeting participant who triggered the activity. */
  triggeredByParticipant?: Maybe<Core_MeetingParticipant>;
  withPerson: Core_EventPerson;
  /** @deprecated Use withPerson instead */
  withUser: Core_UserUnion;
};


export type Core_ExhibitorMeetingAssignedActivitySentAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export enum Core_ExhibitorMeetingAssignedActivityKind {
  ExhibitorMeetingAssignedInvitationReminderBeforeExpiration = 'EXHIBITOR_MEETING_ASSIGNED_INVITATION_REMINDER_BEFORE_EXPIRATION',
  ExhibitorMeetingAssignedReminderBefore = 'EXHIBITOR_MEETING_ASSIGNED_REMINDER_BEFORE',
  ExhibitorMeetingAssignedSentAccepted = 'EXHIBITOR_MEETING_ASSIGNED_SENT_ACCEPTED',
  ExhibitorMeetingAssignedToMe = 'EXHIBITOR_MEETING_ASSIGNED_TO_ME'
}

export type Core_ExhibitorMeetingBooked = Core_MeetingInterface & {
  __typename?: 'Core_ExhibitorMeetingBooked';
  /** @deprecated Use 'meeting' instead */
  booking: Core_ExhibitorMeetingBooking;
  ends: Scalars['Core_DateTime'];
  id: Scalars['ID'];
  meeting?: Maybe<Core_Meeting>;
  places: Array<Core_MeetingPlace>;
  starts: Scalars['Core_DateTime'];
  userRating?: Maybe<Scalars['Float']>;
};


export type Core_ExhibitorMeetingBookedEndsArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_ExhibitorMeetingBookedStartsArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_ExhibitorMeetingBooking = {
  __typename?: 'Core_ExhibitorMeetingBooking';
  exhibitor: Core_Exhibitor;
  place: Core_MeetingPlace;
  requesterMessage?: Maybe<Scalars['String']>;
  status: Core_MeetingBookingStatus;
  /** Return the person who meets the current user. */
  withPerson?: Maybe<Core_EventPerson>;
  /**
   * Return the host or the requester of the meeting who is not the current user (if present).
   * @deprecated Use withPerson instead
   */
  withUser?: Maybe<Core_UserUnion>;
};

export type Core_ExhibitorMeetingDetailed = Core_MeetingInterface & {
  __typename?: 'Core_ExhibitorMeetingDetailed';
  createdAt: Scalars['Core_DateTime'];
  ends: Scalars['Core_DateTime'];
  /** @deprecated BUILDER-1959/1962: Frontend always expects the input exhibitor of the root query */
  exhibitor: Core_Exhibitor;
  explanations?: Maybe<Core_MeetingGenerationExplanations>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  organizer: Core_MeetingParticipant;
  participants: Array<Core_MeetingParticipant>;
  place: Core_MeetingPlace;
  places: Array<Core_MeetingPlace>;
  rescheduledFrom?: Maybe<Core_Meeting>;
  rescheduledInto?: Maybe<Core_Meeting>;
  starts: Scalars['Core_DateTime'];
  status: Core_ExhibitorMeetingDetailedStatus;
};


export type Core_ExhibitorMeetingDetailedCreatedAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_ExhibitorMeetingDetailedEndsArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_ExhibitorMeetingDetailedStartsArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_ExhibitorMeetingDetailedResults = {
  __typename?: 'Core_ExhibitorMeetingDetailedResults';
  meetings: Array<Core_ExhibitorMeetingDetailed>;
  pageInfo: Core_PageResultsInfo;
};

export enum Core_ExhibitorMeetingDetailedStatus {
  Canceled = 'CANCELED',
  /** Future and past CONFIRMED meetings */
  Confirmed = 'CONFIRMED',
  /** @deprecated Replaced by CANCELED */
  Declined = 'DECLINED',
  /** Future PENDING meetings requested by users who are not members of this exhibitor */
  PendingReceived = 'PENDING_RECEIVED',
  /** Future PENDING meetings requested by members of this exhibitor */
  PendingSent = 'PENDING_SENT',
  Rescheduled = 'RESCHEDULED'
}

export type Core_ExhibitorMeetingSlot = Core_MeetingInterface & {
  __typename?: 'Core_ExhibitorMeetingSlot';
  ends: Scalars['Core_DateTime'];
  id: Scalars['ID'];
  isDisabled: Scalars['Boolean'];
  places: Array<Core_MeetingPlace>;
  starts: Scalars['Core_DateTime'];
};


export type Core_ExhibitorMeetingSlotEndsArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_ExhibitorMeetingSlotStartsArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_ExhibitorMeetingSlotsConnection = {
  __typename?: 'Core_ExhibitorMeetingSlotsConnection';
  nodes: Array<Core_ExhibitorMeetingSlot>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_ExhibitorMeetingUnassignedActivity = Core_ActivityInterface & {
  __typename?: 'Core_ExhibitorMeetingUnassignedActivity';
  /** The community in which the activity happened. */
  community?: Maybe<Core_Community>;
  /** The event in which the activity happened. */
  event?: Maybe<Core_Event>;
  exhibitor: Core_Exhibitor;
  id: Scalars['ID'];
  kind: Core_ExhibitorMeetingUnassignedActivityKind;
  /** @deprecated use field meetingV2 instead */
  meeting: Core_ExhibitorMeeting;
  /** The URL to the web page to manage this meeting. */
  meetingUrl: Scalars['String'];
  meetingV2: Core_Meeting;
  /** The user who requested the meeting */
  requester: Core_UserUnion;
  requesterEventPerson: Core_EventPerson;
  seen: Scalars['Boolean'];
  sentAt: Scalars['Core_DateTime'];
  /** The meeting participant who triggered the activity. */
  triggeredByParticipant?: Maybe<Core_MeetingParticipant>;
};


export type Core_ExhibitorMeetingUnassignedActivitySentAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export enum Core_ExhibitorMeetingUnassignedActivityKind {
  ExhibitorMeetingUnassignedCanceledByExhibitor = 'EXHIBITOR_MEETING_UNASSIGNED_CANCELED_BY_EXHIBITOR',
  ExhibitorMeetingUnassignedCanceledByMe = 'EXHIBITOR_MEETING_UNASSIGNED_CANCELED_BY_ME',
  ExhibitorMeetingUnassignedConfirmedByEventOrganizer = 'EXHIBITOR_MEETING_UNASSIGNED_CONFIRMED_BY_EVENT_ORGANIZER',
  ExhibitorMeetingUnassignedInvitationReminderBeforeExpiration = 'EXHIBITOR_MEETING_UNASSIGNED_INVITATION_REMINDER_BEFORE_EXPIRATION',
  ExhibitorMeetingUnassignedReminderBefore = 'EXHIBITOR_MEETING_UNASSIGNED_REMINDER_BEFORE',
  ExhibitorMeetingUnassignedRequestReceived = 'EXHIBITOR_MEETING_UNASSIGNED_REQUEST_RECEIVED',
  ExhibitorMeetingUnassignedSentAccepted = 'EXHIBITOR_MEETING_UNASSIGNED_SENT_ACCEPTED',
  ExhibitorMeetingUnassignedSentDeclined = 'EXHIBITOR_MEETING_UNASSIGNED_SENT_DECLINED'
}

export type Core_ExhibitorMeetingsFilterInput = {
  isBooked?: InputMaybe<Scalars['Boolean']>;
  isPast?: InputMaybe<Scalars['Boolean']>;
};

export type Core_ExhibitorMember = Core_EventPersonInterface & {
  __typename?: 'Core_ExhibitorMember';
  address?: Maybe<Core_Address>;
  attendeeOnPlannings: Array<Core_Planning>;
  biography?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  company?: Maybe<Core_Company>;
  connectionInfo?: Maybe<Core_ConnectionInfo>;
  email?: Maybe<Scalars['String']>;
  exhibitorMemberRole: Core_ExhibitorMemberRole;
  fields: Array<Core_FieldUnion>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  jobTitle?: Maybe<Scalars['String']>;
  landlinePhone?: Maybe<Core_PhoneNumber>;
  lastName: Scalars['String'];
  memberOnExhibitors: Array<Core_Exhibitor>;
  mobilePhone?: Maybe<Core_PhoneNumber>;
  /** @deprecated Use withEvent.options instead */
  options: Core_ExhibitorMemberOptions;
  organization?: Maybe<Scalars['String']>;
  /** @deprecated Use communityProfile or withEvent.eventProfile instead */
  personId: Scalars['ID'];
  photoUrl?: Maybe<Scalars['String']>;
  recommendationExplanations?: Maybe<Array<Core_RecommendationExplanation>>;
  roles: Array<Core_Role>;
  /** @deprecated No longer supported */
  secondJobTitle?: Maybe<Scalars['String']>;
  socialNetworks: Array<Core_SocialNetwork>;
  speakerOnPlannings: Array<Core_Planning>;
  /** @deprecated No longer supported */
  tags: Array<Scalars['String']>;
  type?: Maybe<Core_EventPersonType>;
  userId?: Maybe<Scalars['ID']>;
  userInfo?: Maybe<Core_UserInfo>;
  websiteUrl?: Maybe<Scalars['String']>;
  withEvent?: Maybe<Core_ExhibitorMemberWithEvent>;
};


export type Core_ExhibitorMemberAttendeeOnPlanningsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_ExhibitorMemberMemberOnExhibitorsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_ExhibitorMemberSpeakerOnPlanningsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_ExhibitorMemberWithEventArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
  eventSlug?: InputMaybe<Scalars['String']>;
};

export type Core_ExhibitorMemberOptions = {
  __typename?: 'Core_ExhibitorMemberOptions';
  isVisible: Scalars['Boolean'];
  shareConnections: Scalars['Boolean'];
  showOnBoarding: Scalars['Boolean'];
};

export type Core_ExhibitorMemberOptionsInput = {
  isVisible?: InputMaybe<Scalars['Boolean']>;
  shareConnections?: InputMaybe<Scalars['Boolean']>;
};

export enum Core_ExhibitorMemberRole {
  Admin = 'ADMIN',
  Anonymous = 'ANONYMOUS',
  Member = 'MEMBER'
}

export enum Core_ExhibitorMemberSortEnum {
  Name = 'NAME',
  Role = 'ROLE'
}

export type Core_ExhibitorMemberUser = {
  __typename?: 'Core_ExhibitorMemberUser';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type Core_ExhibitorMemberWithEvent = {
  __typename?: 'Core_ExhibitorMemberWithEvent';
  eventProfile: Core_EventPerson;
  options: Core_ExhibitorMemberOptions;
  roles: Array<Core_Role>;
};

export type Core_ExhibitorMembersConnection = {
  __typename?: 'Core_ExhibitorMembersConnection';
  nodes: Array<Core_ExhibitorMember>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_ExhibitorMembersFilterInput = {
  /** Excludes members who are not available during this meeting or meetingSlot */
  availableMeetingSlotId?: InputMaybe<Scalars['ID']>;
  communityProfileIds?: InputMaybe<Array<Scalars['ID']>>;
  exhibitorMemberIds?: InputMaybe<Array<Scalars['ID']>>;
  notUserIds?: InputMaybe<Array<Scalars['ID']>>;
  roles?: InputMaybe<Array<Core_ExhibitorMemberRole>>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Core_ExhibitorMembersSortInput = {
  field: Core_ExhibitorMemberSortEnum;
  order?: InputMaybe<Core_SortOrderEnum>;
};

export type Core_ExhibitorPlanningsFilterInput = {
  formats?: InputMaybe<Array<Core_PlanningFormatEnum>>;
};

export type Core_ExhibitorProductsFilterInput = {
  AND?: InputMaybe<Array<Core_ExhibitorProductsFilterInput>>;
  OR?: InputMaybe<Array<Core_ExhibitorProductsFilterInput>>;
  fieldValueIds?: InputMaybe<Array<Scalars['ID']>>;
  showProductsNotLinkedToEvents?: InputMaybe<Scalars['Boolean']>;
};

export type Core_ExhibitorRecommendation = {
  __typename?: 'Core_ExhibitorRecommendation';
  metadata: Scalars['String'];
  recommendedEntities?: Maybe<Array<Core_ExhibitorRecommended>>;
  totalCount: Scalars['Int'];
};

export type Core_ExhibitorRecommendationExplanation = {
  __typename?: 'Core_ExhibitorRecommendationExplanation';
  origin: Core_RecommendationExplanationOriginEnum;
  type: Core_RecommendationExplanationTypeEnum;
  values?: Maybe<Array<Core_Exhibitor>>;
};

export type Core_ExhibitorRecommended = {
  __typename?: 'Core_ExhibitorRecommended';
  exhibitor: Core_Exhibitor;
};

export type Core_ExhibitorRootProductCategoriesConnection = {
  __typename?: 'Core_ExhibitorRootProductCategoriesConnection';
  nodes: Array<Core_ExhibitorRootProductCategory>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_ExhibitorRootProductCategory = {
  __typename?: 'Core_ExhibitorRootProductCategory';
  category: Core_ProductCategory;
  productCount: Scalars['Int'];
  totalLimit?: Maybe<Scalars['Int']>;
};

export enum Core_ExhibitorSortEnum {
  Name = 'NAME',
  Type = 'TYPE'
}

export enum Core_ExhibitorStatusEnum {
  Member = 'MEMBER',
  NotMember = 'NOT_MEMBER'
}

export type Core_ExhibitorWithEvent = {
  __typename?: 'Core_ExhibitorWithEvent';
  /** Return a list of advertisements attached to this exhibitor. */
  advertisements: Array<Core_AdvertisementExhibitorUnion>;
  announcementMessage?: Maybe<Scalars['String']>;
  /** @deprecated Use ExhibitorWithEvent.booths instead */
  booth?: Maybe<Scalars['String']>;
  booths: Array<Core_Location>;
  /** Whether the user is allowed to edit roles. */
  canEditRoles: Scalars['Boolean'];
  canExportAdvertisements: Scalars['Boolean'];
  canExportChats: Scalars['Boolean'];
  canExportContacts: Scalars['Boolean'];
  canExportDocuments: Scalars['Boolean'];
  canExportExhibitorItems: Scalars['Boolean'];
  canExportExhibitorPages: Scalars['Boolean'];
  canExportMeetingsConfirmed: Scalars['Boolean'];
  canExportRegistrations: Scalars['Boolean'];
  canExportSessionScanning: Scalars['Boolean'];
  canExportWatchedExhibitorPlannings: Scalars['Boolean'];
  canInviteMembers: Scalars['Boolean'];
  canQualifyLeads: Scalars['Boolean'];
  canScanBadge: Scalars['Boolean'];
  canSeeRecommendedLeads: Scalars['Boolean'];
  canSeeTeamConnections: Scalars['Boolean'];
  /** Whether the user is allowed to talk with the exhibitor. */
  canTalkTo: Scalars['Boolean'];
  /** True if meetings & meeting slots can be viewed and managed at exhibitor level */
  canViewMeetings: Scalars['Boolean'];
  canViewVisits: Scalars['Boolean'];
  documentLimit?: Maybe<Scalars['Int']>;
  documents: Array<Core_Document>;
  editableFields: Core_EditableExhibitorFields;
  /** Options for the user if the user is exhibitor member. */
  exhibitorMemberOptions?: Maybe<Core_ExhibitorMemberOptions>;
  fields: Array<Core_FieldUnion>;
  forms: Core_FormsConnection;
  generateApiKey: Scalars['Boolean'];
  group?: Maybe<Core_EventGroup>;
  isBookmarked?: Maybe<Scalars['Boolean']>;
  isGuestModeActive: Scalars['Boolean'];
  leadsRecommendedCount: Scalars['Int'];
  linkedExhibitors: Array<Core_Exhibitor>;
  /** Get count of meeting invitations between user and exhibitor. Default: both individual and group meetings. */
  meetingInvitationsCount: Scalars['Int'];
  /** Return meetingSlots of exhibitor. */
  meetingSlots: Core_ExhibitorMeetingSlotsConnection;
  /** Get count of meeting slots per day. */
  meetingSlotsByDay?: Maybe<Core_MeetingSlotsByDayConnection>;
  /** The URL to the page to manage meetings of the exhibitor (if any). */
  meetingsUrl?: Maybe<Scalars['String']>;
  /** Get a unique product on this exhibitor. */
  product?: Maybe<Core_Product>;
  /**
   * Return the limit of a product category for an exhibitor in an event.
   * If null, the limit is infinite.
   */
  productCategoryLimit?: Maybe<Scalars['Int']>;
  products: Core_EventProducts;
  qrCodeAccess: Scalars['Boolean'];
  rootProductCategories?: Maybe<Core_ExhibitorRootProductCategoriesConnection>;
  similarExhibitors: Array<Core_Exhibitor>;
  totalMembers: Scalars['Int'];
};


export type Core_ExhibitorWithEventFormsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  filters?: InputMaybe<Array<Core_EventFormFilterInput>>;
  sort?: InputMaybe<Array<Core_FormSortInput>>;
};


export type Core_ExhibitorWithEventLinkedExhibitorsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_ExhibitorWithEventMeetingInvitationsCountArgs = {
  isIndividualMeeting?: InputMaybe<Scalars['Boolean']>;
};


export type Core_ExhibitorWithEventMeetingSlotsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  filter?: InputMaybe<Core_MeetingSlotsFilterInput>;
};


export type Core_ExhibitorWithEventMeetingSlotsByDayArgs = {
  date?: InputMaybe<Scalars['Core_DateTime']>;
  dateRange?: InputMaybe<Core_DateRangeInput>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type Core_ExhibitorWithEventProductArgs = {
  id: Scalars['ID'];
};


export type Core_ExhibitorWithEventProductCategoryLimitArgs = {
  productCategoryId: Scalars['ID'];
};


export type Core_ExhibitorWithEventProductsArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<Core_ExhibitorProductsFilterInput>;
  search?: InputMaybe<Scalars['String']>;
};


export type Core_ExhibitorWithEventRootProductCategoriesArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
};


export type Core_ExhibitorWithEventSimilarExhibitorsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};

export type Core_ExhibitorsConnection = {
  __typename?: 'Core_ExhibitorsConnection';
  nodes: Array<Core_Exhibitor>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_ExportEventAgendaAsICalendarInput = {
  includesConfirmedMeetings?: InputMaybe<Scalars['Boolean']>;
  includesPendingMeetings?: InputMaybe<Scalars['Boolean']>;
  includesPlannings?: InputMaybe<Scalars['Boolean']>;
};

export type Core_ExportExhibitorLeadsInput = {
  after: Scalars['Core_DateTime'];
  before: Scalars['Core_DateTime'];
  eventId: Scalars['ID'];
  exhibitorId: Scalars['ID'];
  exportChat?: InputMaybe<Scalars['Boolean']>;
  exportConnections?: InputMaybe<Scalars['Boolean']>;
  exportExhibitorAdvertisementViewer?: InputMaybe<Scalars['Boolean']>;
  exportExhibitorDocumentViewer?: InputMaybe<Scalars['Boolean']>;
  exportExhibitorPlanningViewer?: InputMaybe<Scalars['Boolean']>;
  exportExhibitorProductViewer?: InputMaybe<Scalars['Boolean']>;
  exportExhibitorViewer?: InputMaybe<Scalars['Boolean']>;
  exportMeeting?: InputMaybe<Scalars['Boolean']>;
  exportPlanningAttendees?: InputMaybe<Scalars['Boolean']>;
  exportPlanningScans?: InputMaybe<Scalars['Boolean']>;
};

export type Core_ExportExhibitorLeadsPayload = {
  __typename?: 'Core_ExportExhibitorLeadsPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  url?: Maybe<Scalars['String']>;
};

export type Core_ExportExhibitorMeetingsInput = {
  eventId: Scalars['ID'];
  exhibitorId: Scalars['ID'];
};

export type Core_ExportExhibitorMeetingsPayload = {
  __typename?: 'Core_ExportExhibitorMeetingsPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  url?: Maybe<Scalars['String']>;
};

export type Core_ExportPlanningFormRepliesInput = {
  eventId: Scalars['ID'];
  formIds?: InputMaybe<Array<Scalars['ID']>>;
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Core_ExportPlanningFormRepliesPayload = {
  __typename?: 'Core_ExportPlanningFormRepliesPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  url?: Maybe<Scalars['String']>;
};

export type Core_ExportPlanningPollRepliesInput = {
  eventId: Scalars['ID'];
  planningIds?: InputMaybe<Array<Scalars['ID']>>;
  pollIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Core_ExportPlanningPollRepliesPayload = {
  __typename?: 'Core_ExportPlanningPollRepliesPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  url?: Maybe<Scalars['String']>;
};

export type Core_Feature = {
  __typename?: 'Core_Feature';
  code: Scalars['String'];
  status: Core_FeatureStatusEnum;
};

export enum Core_FeatureStatusEnum {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type Core_FeedActivity = Core_ActivityInterface & {
  __typename?: 'Core_FeedActivity';
  /** The community in which the activity happened. */
  community?: Maybe<Core_Community>;
  /** The event in which the activity happened. */
  event?: Maybe<Core_Event>;
  feedViewId: Scalars['ID'];
  id: Scalars['ID'];
  interactionType: Core_FeedActivityType;
  interactionsQty: Scalars['Int'];
  message?: Maybe<Core_ChatMessage>;
  seen: Scalars['Boolean'];
  sentAt: Scalars['Core_DateTime'];
};


export type Core_FeedActivitySentAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export enum Core_FeedActivityType {
  Comment = 'COMMENT',
  Reaction = 'REACTION'
}

export type Core_FieldDefinitionConfigurationInput = {
  maxCharacters?: InputMaybe<Scalars['Int']>;
  maxChoices?: InputMaybe<Scalars['Int']>;
  selectOptions?: InputMaybe<Array<Core_FieldDefinitionConfigurationSelectOptionInput>>;
};

export type Core_FieldDefinitionConfigurationSelectOptionInput = {
  position?: InputMaybe<Scalars['Int']>;
  translations?: InputMaybe<Array<Core_TranslationStringInput>>;
  value: Scalars['String'];
};

export type Core_FieldDefinitionInterface = {
  id: Scalars['ID'];
  isEditable: Scalars['Boolean'];
  /** @deprecated No longer supported */
  isFilterable: Scalars['Boolean'];
  /** Do not use, always true */
  isVisible: Scalars['Boolean'];
  name: Scalars['String'];
  /** @deprecated use field `translations` instead */
  nameTranslations: Array<Core_TranslationString>;
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated use field `translations` instead */
  placeholderTranslations: Array<Core_TranslationString>;
  section?: Maybe<Core_FieldDefinitionSection>;
  translations: Array<Core_FieldDefinitionTranslation>;
};

export type Core_FieldDefinitionSection = {
  __typename?: 'Core_FieldDefinitionSection';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Core_FieldDefinitionTranslation = {
  __typename?: 'Core_FieldDefinitionTranslation';
  language: Core_LanguageEnum;
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
};

export type Core_FieldDefinitionUnion = Core_DateFieldDefinition | Core_LongTextFieldDefinition | Core_MediaFieldDefinition | Core_MultipleSelectFieldDefinition | Core_MultipleTextFieldDefinition | Core_NumberFieldDefinition | Core_SelectFieldDefinition | Core_TextFieldDefinition | Core_TreeFieldDefinition | Core_UrlFieldDefinition;

export type Core_FieldInterface = {
  /** @deprecated Use specialized field `definition.id` on type `FieldUnion` instead */
  id: Scalars['ID'];
  /** @deprecated Use specialized field `definition.isEditable` on type `FieldUnion` instead */
  isEditable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isFilterable` on type `FieldUnion` instead */
  isFilterable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isVisible` on type `FieldUnion` instead */
  isVisible: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.name` on type `FieldUnion` instead */
  name: Scalars['String'];
  /** @deprecated Use specialized field `definition.placeholder` on type `FieldUnion` instead */
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated Use specialized field `definition.section` on type `FieldUnion` instead */
  section?: Maybe<Core_FieldDefinitionSection>;
};

export enum Core_FieldType {
  Date = 'DATE',
  LongText = 'LONG_TEXT',
  Media = 'MEDIA',
  MultipleSelect = 'MULTIPLE_SELECT',
  MultipleText = 'MULTIPLE_TEXT',
  Number = 'NUMBER',
  Select = 'SELECT',
  Text = 'TEXT',
  Tree = 'TREE',
  Url = 'URL'
}

export type Core_FieldUnion = Core_DateField | Core_LongTextField | Core_MediaField | Core_MultipleSelectField | Core_MultipleTextField | Core_NumberField | Core_SelectField | Core_TextField | Core_TreeField | Core_UrlField;

export type Core_FieldValueUnion = Core_DateFieldValue | Core_LongTextFieldValue | Core_MediaFieldValue | Core_NumberFieldValue | Core_SelectFieldValue | Core_TextFieldValue | Core_TreeFieldValue | Core_UrlFieldValue;

export type Core_FieldWithReplies = {
  __typename?: 'Core_FieldWithReplies';
  fieldDefinitionId?: Maybe<Scalars['ID']>;
  replies?: Maybe<Array<Maybe<Core_FieldValueUnion>>>;
};

export enum Core_FilterOperation {
  AllMustMatch = 'ALL_MUST_MATCH',
  NoneMustMatch = 'NONE_MUST_MATCH',
  SomeShouldMatch = 'SOME_SHOULD_MATCH'
}

export type Core_Font = {
  __typename?: 'Core_Font';
  family: Scalars['String'];
  format: Scalars['String'];
  style: Scalars['String'];
  url: Scalars['String'];
  weight: Scalars['String'];
};

export type Core_Form = {
  __typename?: 'Core_Form';
  availableFrom?: Maybe<Scalars['Core_DateTime']>;
  availableUntil?: Maybe<Scalars['Core_DateTime']>;
  configuration: Core_FormConfiguration;
  createdAt: Scalars['Core_DateTime'];
  creator: Core_UserUnion;
  exhibitorId?: Maybe<Scalars['ID']>;
  formFields: Array<Core_FormField>;
  hasMyQualification?: Maybe<Scalars['Boolean']>;
  hasOtherQualifications?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  /** The requesting user is allowed or not to manage the form */
  isAllowedToManage: Scalars['Boolean'];
  name: Scalars['String'];
  qualifiers?: Maybe<Core_FormQualifiers>;
  totalQualifiedLeads?: Maybe<Scalars['Int']>;
  type: Core_FormType;
  /** All distinct replies */
  uniqueRepliesByDefinition?: Maybe<Array<Core_FormUniqueRepliesByDefinition>>;
  /** The number of unique replied to the form */
  uniqueUserRepliesCount?: Maybe<Scalars['Int']>;
};


export type Core_FormHasMyQualificationArgs = {
  connectionId: Scalars['ID'];
};


export type Core_FormHasOtherQualificationsArgs = {
  connectionId: Scalars['ID'];
};


export type Core_FormQualifiersArgs = {
  connectionId: Scalars['ID'];
};

export type Core_FormConfiguration = {
  __typename?: 'Core_FormConfiguration';
  showResults: Core_FormShowResultOption;
};

export type Core_FormConfigurationInput = {
  showResults?: InputMaybe<Core_FormShowResultOption>;
};

export enum Core_FormElementFilterOperatorEnum {
  Eq = 'EQ'
}

export type Core_FormElementTranslation = {
  __typename?: 'Core_FormElementTranslation';
  language: Core_LanguageEnum;
  value?: Maybe<Scalars['String']>;
};

export enum Core_FormElementTypeEnum {
  HtmlText = 'HTML_TEXT',
  Input = 'INPUT',
  Row = 'ROW'
}

export type Core_FormField = {
  __typename?: 'Core_FormField';
  fieldDefinition: Core_FieldDefinitionUnion;
};

export type Core_FormQualifiers = {
  __typename?: 'Core_FormQualifiers';
  myQualifiers?: Maybe<Core_Qualifiers>;
  otherQualifiers?: Maybe<Array<Maybe<Core_Qualifiers>>>;
};

export type Core_FormReplyValue = {
  __typename?: 'Core_FormReplyValue';
  isCorrectAnswer?: Maybe<Scalars['Boolean']>;
  ownReply?: Maybe<Scalars['Boolean']>;
  totalCount?: Maybe<Scalars['Int']>;
  value?: Maybe<Core_FieldValueUnion>;
};

export enum Core_FormShowResultOption {
  Always = 'ALWAYS',
  FormClosed = 'FORM_CLOSED',
  IfUserReply = 'IF_USER_REPLY',
  Never = 'NEVER'
}

export enum Core_FormSortEnum {
  CreatedAt = 'CREATED_AT',
  PublishedAt = 'PUBLISHED_AT'
}

export type Core_FormSortInput = {
  field: Core_FormSortEnum;
  order?: InputMaybe<Core_SortOrderEnum>;
};

export enum Core_FormType {
  PollOpinion = 'POLL_OPINION',
  PollQuiz = 'POLL_QUIZ',
  PollRating = 'POLL_RATING',
  PollText = 'POLL_TEXT',
  Survey = 'SURVEY'
}

export type Core_FormUniqueRepliesByDefinition = {
  __typename?: 'Core_FormUniqueRepliesByDefinition';
  definition: Core_FieldDefinitionUnion;
  hasQualifyLeadsReplies?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use form.qualifiers.otherQualifiers instead. */
  otherQualifiersRepliesByConnection: Array<Maybe<Core_OtherQualifiersRepliesByConnection>>;
  replies: Array<Core_FormReplyValue>;
  /** @deprecated Use form.qualifiers.myQualifiers instead. */
  repliesByConnection: Core_RepliesByConnection;
  uniqueUserReplyCount?: Maybe<Scalars['Int']>;
};


export type Core_FormUniqueRepliesByDefinitionOtherQualifiersRepliesByConnectionArgs = {
  connectionId: Scalars['ID'];
};


export type Core_FormUniqueRepliesByDefinitionRepliesByConnectionArgs = {
  connectionId: Scalars['ID'];
};

export type Core_FormsConnection = {
  __typename?: 'Core_FormsConnection';
  nodes: Array<Core_Form>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_GetMediaDocumentUrlInput = {
  documentId: Scalars['ID'];
};

export type Core_GetMediaDocumentUrlPayload = {
  __typename?: 'Core_GetMediaDocumentUrlPayload';
  documentUrl?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Core_PayloadError>>;
};

export type Core_GroupByField = {
  __typename?: 'Core_GroupByField';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Core_HlsPlayback = {
  __typename?: 'Core_HlsPlayback';
  isLive: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export type Core_HostMeeting = Core_MeetingInterface & {
  __typename?: 'Core_HostMeeting';
  /** @deprecated Use 'meeting' instead */
  booking?: Maybe<Core_MeetingBooking>;
  ends: Scalars['Core_DateTime'];
  id: Scalars['ID'];
  isAvailable: Scalars['Boolean'];
  meeting?: Maybe<Core_Meeting>;
  places: Array<Core_MeetingPlace>;
  starts: Scalars['Core_DateTime'];
  /** Rating of the current user for this Meeting */
  userRating?: Maybe<Scalars['Float']>;
};


export type Core_HostMeetingEndsArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_HostMeetingStartsArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_HostedBuyersSelection = {
  __typename?: 'Core_HostedBuyersSelection';
  canBeSelected: Scalars['Boolean'];
  choice?: Maybe<Core_HostedMeetingCandidateSelectionEnum>;
};

export enum Core_HostedMeetingCandidateSelectionEnum {
  ExcludeFromMeetings = 'EXCLUDE_FROM_MEETINGS',
  MustMeet = 'MUST_MEET',
  NiceToMeet = 'NICE_TO_MEET'
}

export type Core_HostedMeetingCondition = {
  __typename?: 'Core_HostedMeetingCondition';
  excludedCount: Scalars['Int'];
  generatedMeetingsCount?: Maybe<Scalars['Int']>;
  maxToSelectLimit?: Maybe<Scalars['Int']>;
  maximumMeetingsAmount?: Maybe<Scalars['Int']>;
  minToSelectTarget?: Maybe<Scalars['Int']>;
  selectedCount: Scalars['Int'];
  selectionEndsAt: Scalars['Core_DateTime'];
  selectionStartsAt: Scalars['Core_DateTime'];
  status: Core_HostedMeetingConditionPhase;
  targetedMeetingsAmount: Scalars['Int'];
};

export enum Core_HostedMeetingConditionPhase {
  BeforeSelection = 'BEFORE_SELECTION',
  Generated = 'GENERATED',
  Preparation = 'PREPARATION',
  Selection = 'SELECTION'
}

/** Generic input to filter by a list of ID */
export type Core_IdFilter = {
  ids: Array<Scalars['ID']>;
  operation: Core_FilterOperation;
};

export enum Core_IdentityHashPlatformEnum {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type Core_IframeEmbeddedVideo = {
  __typename?: 'Core_IframeEmbeddedVideo';
  iframeSource: Scalars['String'];
};

export type Core_IframeEmbeddedVideoInput = {
  iframeSource: Scalars['String'];
};

export type Core_IframePlanningStream = Core_PlanningStreamInterface & {
  __typename?: 'Core_IframePlanningStream';
  availableAt?: Maybe<Scalars['Core_DateTime']>;
  endsAt?: Maybe<Scalars['Core_DateTime']>;
  id: Scalars['ID'];
  isLiveStream: Scalars['Boolean'];
  isPublic: Scalars['Boolean'];
  source: Scalars['String'];
  /** @deprecated use availableAt instead */
  startsAt: Scalars['Core_DateTime'];
};


export type Core_IframePlanningStreamStartsAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_InputCommunityPlanningSortEnum = {
  field: Core_CommunityPlanningSortField;
  order: Core_SortOrderEnum;
};

export type Core_InputExhibitorSortEnum = {
  field: Core_ExhibitorSortEnum;
  order?: InputMaybe<Core_SortOrderEnum>;
};

export type Core_InputPlanningSortEnum = {
  field: Core_PlanningSortEnum;
  order?: InputMaybe<Core_SortOrderEnum>;
};

export type Core_InvitableMeetingPeopleConnection = {
  __typename?: 'Core_InvitableMeetingPeopleConnection';
  nodes: Array<Core_InvitableMeetingPerson>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_InvitableMeetingPerson = {
  __typename?: 'Core_InvitableMeetingPerson';
  isAvailable: Scalars['Boolean'];
  person: Core_EventPerson;
  /** The reason why a person cannot be invited to this meeting. */
  reason?: Maybe<Core_NotInvitableMeetingReason>;
};

export type Core_InviteMeetingParticipantsInput = {
  /** List of EventPerson IDs to invite. */
  invitedPeopleIds: Array<Scalars['ID']>;
  meetingId: Scalars['ID'];
};

export type Core_InviteMeetingParticipantsPayload = {
  __typename?: 'Core_InviteMeetingParticipantsPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  invitedParticipants?: Maybe<Array<Core_MeetingParticipant>>;
  meeting?: Maybe<Core_Meeting>;
};

export type Core_Invoice = {
  __typename?: 'Core_Invoice';
  createdAt?: Maybe<Scalars['Core_DateTime']>;
  currency: Scalars['String'];
  id: Scalars['String'];
  invoiceItems: Array<Core_InvoiceItem>;
  total: Scalars['Int'];
  totalExcludingTax: Scalars['Int'];
};

export type Core_InvoiceItem = {
  __typename?: 'Core_InvoiceItem';
  currency: Scalars['String'];
  id: Scalars['String'];
  taxItems: Array<Core_InvoiceTaxItem>;
  unitPriceCents: Scalars['Int'];
};

export type Core_InvoiceTaxItem = {
  __typename?: 'Core_InvoiceTaxItem';
  rate: Scalars['Float'];
  totalAmountCents: Scalars['Int'];
};

export type Core_JoinEventWithCodeResult = {
  __typename?: 'Core_JoinEventWithCodeResult';
  /** True if the user was already in the event. */
  alreadyInEvent?: Maybe<Scalars['Boolean']>;
  /** Null if the code didn't match an event. */
  event?: Maybe<Core_Event>;
};

export type Core_JoinOrganizationEventInput = {
  eventId: Scalars['ID'];
};

export type Core_JoinOrganizationEventPayload = {
  __typename?: 'Core_JoinOrganizationEventPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  event?: Maybe<Core_Event>;
  eventPerson?: Maybe<Core_EventPerson>;
};

export type Core_JoinPublicEventInput = {
  eventId: Scalars['ID'];
};

export type Core_JoinPublicEventPayload = {
  __typename?: 'Core_JoinPublicEventPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  event?: Maybe<Core_Event>;
  eventPerson?: Maybe<Core_EventPerson>;
};

export type Core_JoinRoundtableRoomInput = {
  /** Id of the entity that contains the roundtable */
  entityId: Scalars['ID'];
};

export type Core_JoinRoundtableRoomPayload = {
  __typename?: 'Core_JoinRoundtableRoomPayload';
  /**
   * true if the participant joined the room for the first time
   *
   * false if the participant has already joined before.
   */
  didJoin: Scalars['Boolean'];
  entity?: Maybe<Core_RoundtableAwareEntity>;
  errors?: Maybe<Array<Core_PayloadError>>;
  roomData?: Maybe<Core_RoundtableRoomData>;
};

export type Core_LabelString = {
  __typename?: 'Core_LabelString';
  _id: Scalars['ID'];
  color?: Maybe<Scalars['String']>;
  elements?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  path?: Maybe<Array<Core_TreePathTranslationValue>>;
  position: Scalars['Int'];
  value: Scalars['String'];
};

export enum Core_LanguageEnum {
  /** @deprecated No longer supported */
  En = 'EN',
  /** @deprecated No longer supported */
  Es = 'ES',
  /** @deprecated No longer supported */
  Fr = 'FR',
  ArAe = 'ar_AE',
  /** @deprecated No longer supported */
  ArQa = 'ar_QA',
  BgBg = 'bg_BG',
  CaEs = 'ca_ES',
  CsCz = 'cs_CZ',
  CyGb = 'cy_GB',
  DaDk = 'da_DK',
  DeDe = 'de_DE',
  ElGr = 'el_GR',
  EnUs = 'en_US',
  EsEs = 'es_ES',
  EtEe = 'et_EE',
  FiFi = 'fi_FI',
  FrCa = 'fr_CA',
  FrFr = 'fr_FR',
  GaIe = 'ga_IE',
  HrHr = 'hr_HR',
  HuHu = 'hu_HU',
  IdId = 'id_ID',
  ItIt = 'it_IT',
  JaJp = 'ja_JP',
  KoKr = 'ko_KR',
  LtLt = 'lt_LT',
  LvLv = 'lv_LV',
  MtMt = 'mt_MT',
  NlNl = 'nl_NL',
  PlPl = 'pl_PL',
  PtBr = 'pt_BR',
  PtPt = 'pt_PT',
  RoRo = 'ro_RO',
  RuRu = 'ru_RU',
  SkSk = 'sk_SK',
  SlSi = 'sl_SI',
  SvSe = 'sv_SE',
  ThTh = 'th_TH',
  TrTr = 'tr_TR',
  ViVn = 'vi_VN',
  ZhCn = 'zh_CN'
}

export type Core_LeadActivity = {
  __typename?: 'Core_LeadActivity';
  documentsViewed: Scalars['Int'];
  exhibitorBookmarkedPage: Scalars['Boolean'];
  exhibitorChattedWith: Scalars['Boolean'];
  exhibitorClicksOnAdvertisement: Scalars['Int'];
  exhibitorConnectedWithMembers: Scalars['Int'];
  exhibitorMetMembers: Scalars['Int'];
  exhibitorScannedQrCode: Scalars['Boolean'];
  exhibitorVisitsOnPage: Scalars['Int'];
  from: Scalars['String'];
  itemsBookmarked: Scalars['Int'];
  itemsPagesVisited: Scalars['Int'];
  planningsAttendedOnSite: Scalars['Int'];
  planningsRegistered: Scalars['Int'];
  planningsStreamsWatched: Scalars['Int'];
  to: Scalars['String'];
};

export enum Core_LeadLastActivityType {
  AdOpen = 'AD_OPEN',
  Chat = 'CHAT',
  Connection = 'CONNECTION',
  DocumentOpen = 'DOCUMENT_OPEN',
  ExhibitorBookmark = 'EXHIBITOR_BOOKMARK',
  ExhibitorVisit = 'EXHIBITOR_VISIT',
  Meeting = 'MEETING',
  ProductBookmark = 'PRODUCT_BOOKMARK',
  ProductVisit = 'PRODUCT_VISIT',
  SessionAttend = 'SESSION_ATTEND',
  SessionRegister = 'SESSION_REGISTER',
  SessionWatch = 'SESSION_WATCH'
}

export type Core_ListConnectionsFilterInput = {
  communityId?: InputMaybe<Scalars['ID']>;
  eventId?: InputMaybe<Scalars['ID']>;
  notInCommunityIds?: InputMaybe<Array<Scalars['ID']>>;
  notInEventIds?: InputMaybe<Array<Scalars['ID']>>;
  preferredEventContext?: InputMaybe<Scalars['ID']>;
};

export type Core_ListEventPeopleFilter = {
  hasRequestReceived?: InputMaybe<Scalars['Boolean']>;
  hasRequestSent?: InputMaybe<Scalars['Boolean']>;
  isConnected?: InputMaybe<Scalars['Boolean']>;
  /** Deprecated: Use [{isConnected: true}, {hasRequestSent:true}] to apply OR logic instead */
  isConnectedOrSentRequest?: InputMaybe<Scalars['Boolean']>;
  isUser?: InputMaybe<Scalars['Boolean']>;
  shouldBeAttendeeOnPlannings?: InputMaybe<Array<Scalars['ID']>>;
  shouldBeMemberOnExhibitors?: InputMaybe<Array<Scalars['ID']>>;
  shouldBeSpeakerOnPlannings?: InputMaybe<Array<Scalars['ID']>>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Core_LiveStreamAwareInterface = {
  liveStream?: Maybe<Core_LiveStreamComponent>;
};


export type Core_LiveStreamAwareInterfaceLiveStreamArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
};

export type Core_LiveStreamComponent = {
  __typename?: 'Core_LiveStreamComponent';
  availableAt: Scalars['Core_DateTime'];
  availableUntil?: Maybe<Scalars['Core_DateTime']>;
  id: Scalars['ID'];
  isPublic: Scalars['Boolean'];
  stream: Core_EmbeddedVideoUnion;
};

export type Core_Location = {
  __typename?: 'Core_Location';
  boothOfExhibitors: Array<Core_Exhibitor>;
  capacity?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isVirtual: Scalars['Boolean'];
  name: Scalars['String'];
};

export type Core_LocationsConnection = {
  __typename?: 'Core_LocationsConnection';
  nodes: Array<Core_Location>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_LongTextField = Core_FieldInterface & {
  __typename?: 'Core_LongTextField';
  definition: Core_LongTextFieldDefinition;
  /** @deprecated Use specialized field `definition.id` on type `FieldUnion` instead */
  id: Scalars['ID'];
  /** @deprecated Use specialized field `definition.isEditable` on type `FieldUnion` instead */
  isEditable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isFilterable` on type `FieldUnion` instead */
  isFilterable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isVisible` on type `FieldUnion` instead */
  isVisible: Scalars['Boolean'];
  /** @deprecated Use field `definition.maxCharacters` on type `TextField` instead */
  maxCharacters?: Maybe<Scalars['Int']>;
  /** @deprecated Use specialized field `definition.name` on type `FieldUnion` instead */
  name: Scalars['String'];
  /** @deprecated Use specialized field `definition.placeholder` on type `FieldUnion` instead */
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated Use specialized field `definition.section` on type `FieldUnion` instead */
  section?: Maybe<Core_FieldDefinitionSection>;
  translatedValues: Array<Core_LongTextFieldValue>;
  value?: Maybe<Core_LongTextFieldValue>;
};

export type Core_LongTextFieldDefinition = Core_FieldDefinitionInterface & {
  __typename?: 'Core_LongTextFieldDefinition';
  id: Scalars['ID'];
  isEditable: Scalars['Boolean'];
  /** @deprecated No longer supported */
  isFilterable: Scalars['Boolean'];
  /** Do not use, always true */
  isVisible: Scalars['Boolean'];
  maxCharacters?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** @deprecated use field `translations` instead */
  nameTranslations: Array<Core_TranslationString>;
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated use field `translations` instead */
  placeholderTranslations: Array<Core_TranslationString>;
  section?: Maybe<Core_FieldDefinitionSection>;
  translations: Array<Core_FieldDefinitionTranslation>;
};

export type Core_LongTextFieldValue = {
  __typename?: 'Core_LongTextFieldValue';
  id: Scalars['ID'];
  locale?: Maybe<Core_LanguageEnum>;
  longText: Scalars['String'];
};

export enum Core_MapsProviderEnum {
  Expofp = 'EXPOFP',
  Mapsindoors = 'MAPSINDOORS'
}

export type Core_MarkIrrelevantRecommendationsPayload = {
  __typename?: 'Core_MarkIrrelevantRecommendationsPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  status: Scalars['Boolean'];
};

export type Core_MarkMeetingAsNotHeldPayload = {
  __typename?: 'Core_MarkMeetingAsNotHeldPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  meeting?: Maybe<Core_Meeting>;
};

export type Core_MarkRecommendationAsIrrelevantInput = {
  entityType: Core_RecommendationEntityEnum;
  eventId?: InputMaybe<Scalars['ID']>;
  /** ID's of irrelevant recommendations */
  irrelevantRecommendationsIds: Array<Scalars['ID']>;
  viewId: Scalars['ID'];
};

export enum Core_MatchingLabelEnum {
  Industry = 'INDUSTRY',
  JobTitle = 'JOB_TITLE',
  Label = 'LABEL'
}

export type Core_MatchingLabelInput = {
  type: Core_MatchingLabelEnum;
  value: Scalars['String'];
};

export type Core_MediaField = Core_FieldInterface & {
  __typename?: 'Core_MediaField';
  definition: Core_MediaFieldDefinition;
  /** @deprecated Use MediaFieldValue value.fileName field */
  fileName?: Maybe<Scalars['String']>;
  /** @deprecated Use specialized field `definition.id` on type `FieldUnion` instead */
  id: Scalars['ID'];
  /** @deprecated Use specialized field `definition.isEditable` on type `FieldUnion` instead */
  isEditable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isFilterable` on type `FieldUnion` instead */
  isFilterable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isVisible` on type `FieldUnion` instead */
  isVisible: Scalars['Boolean'];
  /** @deprecated Use MediaFieldValue value.mimeType field */
  mimeType?: Maybe<Scalars['Core_MimeType']>;
  /** @deprecated Use specialized field `definition.name` on type `FieldUnion` instead */
  name: Scalars['String'];
  /** @deprecated Use specialized field `definition.placeholder` on type `FieldUnion` instead */
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated Use specialized field `definition.section` on type `FieldUnion` instead */
  section?: Maybe<Core_FieldDefinitionSection>;
  value?: Maybe<Core_MediaFieldValue>;
};

export type Core_MediaFieldDefinition = Core_FieldDefinitionInterface & {
  __typename?: 'Core_MediaFieldDefinition';
  id: Scalars['ID'];
  isEditable: Scalars['Boolean'];
  /** @deprecated No longer supported */
  isFilterable: Scalars['Boolean'];
  /** Do not use, always true */
  isVisible: Scalars['Boolean'];
  name: Scalars['String'];
  /** @deprecated use field `translations` instead */
  nameTranslations: Array<Core_TranslationString>;
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated use field `translations` instead */
  placeholderTranslations: Array<Core_TranslationString>;
  section?: Maybe<Core_FieldDefinitionSection>;
  translations: Array<Core_FieldDefinitionTranslation>;
};

export type Core_MediaFieldValue = {
  __typename?: 'Core_MediaFieldValue';
  /** fileName set for the media file */
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** mimeType set for the media file */
  mimeType?: Maybe<Scalars['Core_MimeType']>;
  url: Scalars['String'];
};

export enum Core_MediaSizeEnum {
  Original = 'ORIGINAL',
  Small = 'SMALL'
}

export type Core_Meeting = Core_RoundtableAwareInterface & {
  __typename?: 'Core_Meeting';
  beginsAt: Scalars['Core_DateTime'];
  canCancel: Scalars['Boolean'];
  canReschedule: Scalars['Boolean'];
  channelId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  endsAt: Scalars['Core_DateTime'];
  event: Core_Event;
  /** @deprecated Use participants instead */
  exhibitor?: Maybe<Core_Exhibitor>;
  explanations?: Maybe<Core_MeetingGenerationExplanations>;
  id: Scalars['ID'];
  invitablePeople?: Maybe<Core_InvitableMeetingPeopleConnection>;
  organizer?: Maybe<Core_MeetingParticipant>;
  /** All the participants of this meeting */
  participants?: Maybe<Array<Core_MeetingParticipant>>;
  place: Core_MeetingPlace;
  rescheduledFrom?: Maybe<Core_Meeting>;
  rescheduledInto?: Maybe<Core_Meeting>;
  roundtable?: Maybe<Core_RoundtableComponent>;
  status: Core_MeetingStatus;
  /**
   * Returns a list of attending meetings and bookmarked plannings that overlap with this meeting for the current user.
   * ON_DEMAND plannings are excluded.
   */
  userAgendaConflicts?: Maybe<Array<Core_AgendaItem>>;
  /** The MeetingParticipant of the current user for this meeting */
  userParticipant?: Maybe<Core_MeetingParticipant>;
  userRating?: Maybe<Scalars['Float']>;
  /**
   * Return the person who meets the current user.
   * @deprecated Use participants instead
   */
  withPerson: Core_EventPerson;
  /** @deprecated Use participants instead */
  withUser: Core_PublicUser;
};


export type Core_MeetingBeginsAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_MeetingEndsAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_MeetingInvitablePeopleArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

export type Core_MeetingActivity = Core_ActivityInterface & {
  __typename?: 'Core_MeetingActivity';
  /** The community in which the activity happened. */
  community?: Maybe<Core_Community>;
  /** The event in which the activity happened. */
  event?: Maybe<Core_Event>;
  id: Scalars['ID'];
  kind: Core_MeetingActivityKind;
  meeting: Core_Meeting;
  seen: Scalars['Boolean'];
  sentAt: Scalars['Core_DateTime'];
  /** The meeting participant who triggered the activity. */
  triggeredByParticipant?: Maybe<Core_MeetingParticipant>;
};


export type Core_MeetingActivitySentAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export enum Core_MeetingActivityKind {
  MeetingCanceledByEventOrganizer = 'MEETING_CANCELED_BY_EVENT_ORGANIZER',
  MeetingCanceledByMe = 'MEETING_CANCELED_BY_ME',
  MeetingCanceledByOther = 'MEETING_CANCELED_BY_OTHER',
  MeetingConfirmedByEventOrganizer = 'MEETING_CONFIRMED_BY_EVENT_ORGANIZER',
  MeetingInvitationReminderBeforeExpiration = 'MEETING_INVITATION_REMINDER_BEFORE_EXPIRATION',
  MeetingReceivedAccepted = 'MEETING_RECEIVED_ACCEPTED',
  MeetingReceivedDeclined = 'MEETING_RECEIVED_DECLINED',
  MeetingReminderBefore = 'MEETING_REMINDER_BEFORE',
  MeetingSentAccepted = 'MEETING_SENT_ACCEPTED',
  MeetingSentDeclined = 'MEETING_SENT_DECLINED'
}

export type Core_MeetingBookedUnion = Core_ExhibitorMeetingBooked | Core_UserMeetingBooked;

export type Core_MeetingBooking = Core_ExhibitorMeetingBooking | Core_UserMeetingBooking;

export enum Core_MeetingBookingStatus {
  Confirmed = 'CONFIRMED',
  PendingReceived = 'PENDING_RECEIVED',
  PendingSent = 'PENDING_SENT'
}

export type Core_MeetingGenerationExplanations = {
  __typename?: 'Core_MeetingGenerationExplanations';
  eventsInCommon: Array<Core_Event>;
  keywords: Array<Scalars['String']>;
  peopleInCommon: Array<Core_EventPerson>;
  selectedMustMeet?: Maybe<Array<Core_EventPerson>>;
  selectedNiceToMeet?: Maybe<Array<Core_EventPerson>>;
};

export type Core_MeetingInterface = {
  ends: Scalars['Core_DateTime'];
  id: Scalars['ID'];
  places: Array<Core_MeetingPlace>;
  starts: Scalars['Core_DateTime'];
};


export type Core_MeetingInterfaceEndsArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_MeetingInterfaceStartsArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_MeetingParticipant = {
  __typename?: 'Core_MeetingParticipant';
  exhibitor?: Maybe<Core_Exhibitor>;
  id: Scalars['ID'];
  invitationExpiresAt?: Maybe<Scalars['Core_DateTime']>;
  /**
   * Describes if the participant is attending the meeting.
   * Will become false if participant declines or meeting is CANCELED or marked as NOT_HELD
   */
  isGoing?: Maybe<Scalars['Boolean']>;
  person?: Maybe<Core_EventPerson>;
  status: Core_MeetingParticipantStatusEnum;
};

export enum Core_MeetingParticipantStatusEnum {
  Confirmed = 'CONFIRMED',
  Declined = 'DECLINED',
  NoShow = 'NO_SHOW',
  Pending = 'PENDING'
}

export enum Core_MeetingParticipationStatus {
  Going = 'GOING',
  NotGoing = 'NOT_GOING'
}

export type Core_MeetingPlace = {
  __typename?: 'Core_MeetingPlace';
  /** @deprecated Use field id instead */
  _id?: Maybe<Scalars['ID']>;
  capacity?: Maybe<Scalars['Int']>;
  group?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isBooth: Scalars['Boolean'];
  isVirtual: Scalars['Boolean'];
  name: Scalars['String'];
  /** @deprecated No longer supported */
  remainingPlaces?: Maybe<Scalars['Int']>;
};

export type Core_MeetingPlaceInput = {
  _id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Core_MeetingRequestReceived = Core_RequestInterface & {
  __typename?: 'Core_MeetingRequestReceived';
  community?: Maybe<Core_Community>;
  event?: Maybe<Core_Event>;
  /** Same as user, but in the context of the community/event related to the request. */
  eventPerson?: Maybe<Core_EventPerson>;
  id: Scalars['ID'];
  meeting: Core_Meeting;
  message?: Maybe<Scalars['String']>;
  repliedAt?: Maybe<Scalars['Core_DateTime']>;
  seen: Scalars['Boolean'];
  sentAt: Scalars['Core_DateTime'];
  status: Core_RequestStatus;
  /**
   * The requester or recipient of the request.
   * If the current user is the recipient, the user will be the requester
   * otherwise it will be the recipient.
   */
  user: Core_PublicUser;
};


export type Core_MeetingRequestReceivedRepliedAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_MeetingRequestReceivedSentAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_MeetingRequestSent = Core_RequestInterface & {
  __typename?: 'Core_MeetingRequestSent';
  community?: Maybe<Core_Community>;
  event?: Maybe<Core_Event>;
  /** Same as user, but in the context of the community/event related to the request. */
  eventPerson?: Maybe<Core_EventPerson>;
  id: Scalars['ID'];
  meeting: Core_Meeting;
  message?: Maybe<Scalars['String']>;
  repliedAt?: Maybe<Scalars['Core_DateTime']>;
  seen: Scalars['Boolean'];
  sentAt: Scalars['Core_DateTime'];
  status: Core_RequestStatus;
  /**
   * The requester or recipient of the request.
   * If the current user is the recipient, the user will be the requester
   * otherwise it will be the recipient.
   */
  user: Core_PublicUser;
};


export type Core_MeetingRequestSentRepliedAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_MeetingRequestSentSentAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_MeetingRequestUnion = Core_MeetingRequestReceived | Core_MeetingRequestSent;

export type Core_MeetingSlot = Core_MeetingInterface & {
  __typename?: 'Core_MeetingSlot';
  ends: Scalars['Core_DateTime'];
  id: Scalars['ID'];
  places: Array<Core_MeetingPlace>;
  starts: Scalars['Core_DateTime'];
};


export type Core_MeetingSlotEndsArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_MeetingSlotStartsArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_MeetingSlotsByDay = {
  __typename?: 'Core_MeetingSlotsByDay';
  /** Number of possible meeting slots on this day for this exhibitor. */
  allSlotsCount: Scalars['Int'];
  day: Scalars['Core_DateTime'];
  /** Number of meeting slots disabled on this day for this exhibitor. */
  disabledSlotsCount: Scalars['Int'];
};

export type Core_MeetingSlotsByDayConnection = {
  __typename?: 'Core_MeetingSlotsByDayConnection';
  /** The next day if there are more results, null otherwise. */
  nextDay?: Maybe<Scalars['Core_DateTime']>;
  slotsByDay?: Maybe<Array<Core_MeetingSlotsByDay>>;
};

export type Core_MeetingSlotsConnection = {
  __typename?: 'Core_MeetingSlotsConnection';
  nodes: Array<Core_MeetingSlot>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_MeetingSlotsFilterInput = {
  /** Filter meeting slots between 2 dates. */
  dateRange?: InputMaybe<Core_DateRangeInput>;
  /**
   * If true, return only disabled slots.
   * If false, return only non-disabled slots.
   */
  isDisabled?: InputMaybe<Scalars['Boolean']>;
};

export enum Core_MeetingSortFieldEnum {
  BeginsAt = 'BEGINS_AT'
}

export type Core_MeetingSortInput = {
  field: Core_MeetingSortFieldEnum;
  order: Core_SortOrderEnum;
};

export enum Core_MeetingStatus {
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  /** @deprecated Replaced by CANCELED */
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  NoShow = 'NO_SHOW',
  Past = 'PAST',
  Pending = 'PENDING',
  Rescheduled = 'RESCHEDULED'
}

export type Core_Merge = {
  __typename?: 'Core_Merge';
  emailSentAt: Scalars['Core_DateTime'];
  isIssuer: Scalars['Boolean'];
  with: Core_MergeUser;
};

export type Core_MergeUser = {
  __typename?: 'Core_MergeUser';
  _id: Scalars['ID'];
  email: Scalars['String'];
};

export type Core_MessageSuggestion = {
  __typename?: 'Core_MessageSuggestion';
  id: Scalars['ID'];
  language: Core_LanguageEnum;
  slug: Scalars['String'];
  type: Core_MessageSuggestionType;
  value: Scalars['String'];
};

export enum Core_MessageSuggestionType {
  ExhibitorMeeting = 'EXHIBITOR_MEETING',
  IndividualConnection = 'INDIVIDUAL_CONNECTION',
  IndividualMeeting = 'INDIVIDUAL_MEETING',
  MultiParticipantMeeting = 'MULTI_PARTICIPANT_MEETING'
}

export type Core_MoveMediaInput = {
  item: Scalars['String'];
  moveAfter: Scalars['Boolean'];
  toItem: Scalars['String'];
};

export type Core_MultipleSelectField = Core_FieldInterface & {
  __typename?: 'Core_MultipleSelectField';
  definition: Core_MultipleSelectFieldDefinition;
  /** @deprecated Use specialized field `definition.id` on type `FieldUnion` instead */
  id: Scalars['ID'];
  /** @deprecated Use specialized field `definition.isEditable` on type `FieldUnion` instead */
  isEditable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isFilterable` on type `FieldUnion` instead */
  isFilterable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isVisible` on type `FieldUnion` instead */
  isVisible: Scalars['Boolean'];
  /** @deprecated Use field `definition.maxChoices` on type `MultiSelectField` instead */
  maxChoices?: Maybe<Scalars['Int']>;
  /** @deprecated Use specialized field `definition.name` on type `FieldUnion` instead */
  name: Scalars['String'];
  /** @deprecated Use specialized field `definition.placeholder` on type `FieldUnion` instead */
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated Use specialized field `definition.section` on type `FieldUnion` instead */
  section?: Maybe<Core_FieldDefinitionSection>;
  /** @deprecated Use field `definition.selectOptions` on type `MultiSelectField` instead */
  selectOptions: Array<Core_SelectOptionsValue>;
  values: Array<Core_SelectFieldValue>;
};

export type Core_MultipleSelectFieldDefinition = Core_FieldDefinitionInterface & {
  __typename?: 'Core_MultipleSelectFieldDefinition';
  id: Scalars['ID'];
  isEditable: Scalars['Boolean'];
  /** @deprecated No longer supported */
  isFilterable: Scalars['Boolean'];
  /** Do not use, always true */
  isVisible: Scalars['Boolean'];
  maxChoices?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** @deprecated use field `translations` instead */
  nameTranslations: Array<Core_TranslationString>;
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated use field `translations` instead */
  placeholderTranslations: Array<Core_TranslationString>;
  section?: Maybe<Core_FieldDefinitionSection>;
  selectOptions: Array<Core_SelectOptionsValue>;
  translations: Array<Core_FieldDefinitionTranslation>;
};

export type Core_MultipleTextField = Core_FieldInterface & {
  __typename?: 'Core_MultipleTextField';
  definition: Core_MultipleTextFieldDefinition;
  /** @deprecated Use specialized field `definition.id` on type `FieldUnion` instead */
  id: Scalars['ID'];
  /** @deprecated Use specialized field `definition.isEditable` on type `FieldUnion` instead */
  isEditable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isFilterable` on type `FieldUnion` instead */
  isFilterable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isVisible` on type `FieldUnion` instead */
  isVisible: Scalars['Boolean'];
  /** @deprecated Use field `definition.maxCharacters` on type `MultiTextField` instead */
  maxCharacters?: Maybe<Scalars['Int']>;
  /** @deprecated Use field `definition.maxChoices` on type `MultiTextField` instead */
  maxChoices?: Maybe<Scalars['Int']>;
  /** @deprecated Use specialized field `definition.name` on type `FieldUnion` instead */
  name: Scalars['String'];
  /** @deprecated Use specialized field `definition.placeholder` on type `FieldUnion` instead */
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated Use specialized field `definition.section` on type `FieldUnion` instead */
  section?: Maybe<Core_FieldDefinitionSection>;
  translatedValues: Array<Core_TextFieldValue>;
  values: Array<Core_TextFieldValue>;
};

export type Core_MultipleTextFieldDefinition = Core_FieldDefinitionInterface & {
  __typename?: 'Core_MultipleTextFieldDefinition';
  id: Scalars['ID'];
  isEditable: Scalars['Boolean'];
  /** @deprecated No longer supported */
  isFilterable: Scalars['Boolean'];
  /** Do not use, always true */
  isVisible: Scalars['Boolean'];
  maxCharacters?: Maybe<Scalars['Int']>;
  maxChoices?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** @deprecated use field `translations` instead */
  nameTranslations: Array<Core_TranslationString>;
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated use field `translations` instead */
  placeholderTranslations: Array<Core_TranslationString>;
  section?: Maybe<Core_FieldDefinitionSection>;
  translations: Array<Core_FieldDefinitionTranslation>;
};

/** Available recommendation carousels for showing on My Ai Recommendations view */
export enum Core_MyAiRecommendationsEnum {
  Exhibitors = 'EXHIBITORS',
  People = 'PEOPLE',
  Plannings = 'PLANNINGS',
  Products = 'PRODUCTS'
}

export type Core_MyAiRecommendationsPayload = {
  __typename?: 'Core_MyAiRecommendationsPayload';
  exhibitors?: Maybe<Core_ExhibitorRecommendation>;
  people?: Maybe<Core_EventPersonRecommendation>;
  plannings?: Maybe<Core_PlanningRecommendation>;
  products?: Maybe<Core_ProductRecommendation>;
};

export enum Core_MyCommunityTab {
  BookmarkedExhibitors = 'BOOKMARKED_EXHIBITORS',
  BookmarkedProducts = 'BOOKMARKED_PRODUCTS',
  MyNetwork = 'MY_NETWORK',
  MyVideos = 'MY_VIDEOS',
  Schedule = 'SCHEDULE'
}

export type Core_MyExhibitorsFilter = {
  eventIds?: InputMaybe<Array<Scalars['ID']>>;
  eventStatus?: InputMaybe<Core_EventStatusEnum>;
  exhibitorIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum Core_MyExhibitorsSortEnum {
  EventBeginsAt = 'EVENT_BEGINS_AT'
}

export type Core_MyExhibitorsSortInput = {
  field: Core_MyExhibitorsSortEnum;
  order?: InputMaybe<Core_SortOrderEnum>;
};

/** Available recommendation carousels for showing on My Visit → Explore Event */
export enum Core_MyVisitRecommendation {
  Exhibitors = 'EXHIBITORS',
  People = 'PEOPLE',
  Plannings = 'PLANNINGS',
  Products = 'PRODUCTS'
}

/** Tabs that you can have per event */
export enum Core_MyVisitTab {
  BookmarkedExhibitors = 'BOOKMARKED_EXHIBITORS',
  BookmarkedProducts = 'BOOKMARKED_PRODUCTS',
  ConnectedEventPeople = 'CONNECTED_EVENT_PEOPLE',
  ExploreEvent = 'EXPLORE_EVENT',
  Meetings = 'MEETINGS',
  MyVideos = 'MY_VIDEOS',
  Schedule = 'SCHEDULE'
}

export type Core_NodeEvent = {
  __typename?: 'Core_NodeEvent';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Core_Event>;
};

export enum Core_NotInvitableMeetingReason {
  /** User is already in the meeting (checked) */
  AlreadyInMeeting = 'ALREADY_IN_MEETING',
  /** All allowed places for this slot have reached their full capacity */
  PlaceAtFullCapacity = 'PLACE_AT_FULL_CAPACITY',
  /** No rule allows this user to take a meeting on this slot and location */
  RuleNotFound = 'RULE_NOT_FOUND',
  /** User has disabled this slot */
  SlotUnavailableForUser = 'SLOT_UNAVAILABLE_FOR_USER'
}

export type Core_Notification = Core_ConnectionRequestActivity | Core_ConnectionRequestReceived | Core_ConnectionRequestSent | Core_ConnectionScanActivity | Core_CustomActivity | Core_ExhibitorMeetingAssignedActivity | Core_ExhibitorMeetingUnassignedActivity | Core_FeedActivity | Core_MeetingActivity | Core_MeetingRequestReceived | Core_MeetingRequestSent | Core_PlanningActivity;

export type Core_NumberField = Core_FieldInterface & {
  __typename?: 'Core_NumberField';
  definition: Core_NumberFieldDefinition;
  /** @deprecated Use specialized field `definition.id` on type `FieldUnion` instead */
  id: Scalars['ID'];
  /** @deprecated Use specialized field `definition.isEditable` on type `FieldUnion` instead */
  isEditable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isFilterable` on type `FieldUnion` instead */
  isFilterable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isVisible` on type `FieldUnion` instead */
  isVisible: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.name` on type `FieldUnion` instead */
  name: Scalars['String'];
  /** @deprecated Use specialized field `definition.placeholder` on type `FieldUnion` instead */
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated Use specialized field `definition.section` on type `FieldUnion` instead */
  section?: Maybe<Core_FieldDefinitionSection>;
  value?: Maybe<Core_NumberFieldValue>;
};

export type Core_NumberFieldDefinition = Core_FieldDefinitionInterface & {
  __typename?: 'Core_NumberFieldDefinition';
  id: Scalars['ID'];
  isEditable: Scalars['Boolean'];
  /** @deprecated No longer supported */
  isFilterable: Scalars['Boolean'];
  /** Do not use, always true */
  isVisible: Scalars['Boolean'];
  name: Scalars['String'];
  /** @deprecated use field `translations` instead */
  nameTranslations: Array<Core_TranslationString>;
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated use field `translations` instead */
  placeholderTranslations: Array<Core_TranslationString>;
  section?: Maybe<Core_FieldDefinitionSection>;
  translations: Array<Core_FieldDefinitionTranslation>;
};

export type Core_NumberFieldValue = {
  __typename?: 'Core_NumberFieldValue';
  id: Scalars['ID'];
  number: Scalars['Int'];
};

export type Core_OAuthInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  authorizationCode?: InputMaybe<Scalars['String']>;
  redirectUri?: InputMaybe<Scalars['String']>;
};

export type Core_OcrContact = Core_PersonInterface & {
  __typename?: 'Core_OCRContact';
  addresses?: Maybe<Array<Maybe<Core_Address>>>;
  biography?: Maybe<Scalars['String']>;
  cardUrl: Scalars['String'];
  /** @deprecated No longer supported */
  company?: Maybe<Core_Company>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  interests?: Maybe<Array<Maybe<Scalars['String']>>>;
  jobTitle?: Maybe<Scalars['String']>;
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastName?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  personType?: Maybe<Core_PersonTypeEnum>;
  phoneNumbers?: Maybe<Array<Maybe<Core_PhoneNumber>>>;
  photoUrl?: Maybe<Scalars['String']>;
  secondJobTitle?: Maybe<Scalars['String']>;
  socialNetworks?: Maybe<Array<Maybe<Core_SocialNetwork>>>;
  userInfo: Core_UserInfo;
  userStatus?: Maybe<Core_UserStatusEnum>;
  websiteUrl?: Maybe<Scalars['String']>;
};


export type Core_OcrContactLogoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};


export type Core_OcrContactPhoneNumbersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Core_PhoneNumberEnum>;
};


export type Core_OcrContactPhotoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};

export type Core_OnDemandAwareInterface = {
  onDemand?: Maybe<Core_OnDemandComponent>;
};


export type Core_OnDemandAwareInterfaceOnDemandArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
};

export type Core_OnDemandComponent = {
  __typename?: 'Core_OnDemandComponent';
  availableAt?: Maybe<Scalars['Core_DateTime']>;
  availableUntil?: Maybe<Scalars['Core_DateTime']>;
  id: Scalars['ID'];
  isPublic: Scalars['Boolean'];
  video: Core_EmbeddedVideoUnion;
};

export type Core_Order = {
  __typename?: 'Core_Order';
  currency: Scalars['String'];
  id: Scalars['ID'];
  orderItems: Array<Core_OrderItem>;
  registrations: Array<Core_Registration>;
  totalAmountCents: Scalars['Int'];
  totalAmountPaid: Scalars['Int'];
  totalExcludingTaxCents: Scalars['Int'];
  transactions?: Maybe<Array<Core_OrderTransaction>>;
};

export type Core_OrderItem = {
  __typename?: 'Core_OrderItem';
  amountIncludingTaxCents?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  orderItemTaxes: Array<Core_OrderItemTax>;
  quantity: Scalars['Int'];
  taxAmountCents?: Maybe<Scalars['Int']>;
  ticketType?: Maybe<Core_TicketType>;
  unitPriceCents: Scalars['Int'];
};

export type Core_OrderItemTax = {
  __typename?: 'Core_OrderItemTax';
  amountCents: Scalars['Int'];
  description: Scalars['String'];
  id: Scalars['ID'];
  rate: Scalars['Float'];
};

export type Core_OrderPayment = Core_StripeFreeOrder | Core_StripeOrderPaymentIntent;

export type Core_OrderTransaction = Core_Payment | Core_Refund;

export type Core_OtherQualifiersRepliesByConnection = {
  __typename?: 'Core_OtherQualifiersRepliesByConnection';
  exhibitorMemberUser?: Maybe<Core_ExhibitorMemberUser>;
  isPrimaryQualification: Scalars['Boolean'];
  replies: Array<Core_FormReplyValue>;
};

export type Core_Page = {
  __typename?: 'Core_Page';
  allBlocks: Array<Core_PageBlock>;
  id: Scalars['ID'];
  rootBlockIds: Array<Scalars['ID']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type Core_PageBlock = Core_PageBlockButton | Core_PageBlockButtonsCommunityViews | Core_PageBlockButtonsEventViews | Core_PageBlockContainer | Core_PageBlockEventInformation | Core_PageBlockImage | Core_PageBlockRichText | Core_PageBlockSponsors | Core_PageBlockText;

export type Core_PageBlockButton = Core_PageBlockInterface & {
  __typename?: 'Core_PageBlockButton';
  defaultDefinition: Core_PageBlockButtonDefinition;
  id: Scalars['ID'];
  layoutProperties?: Maybe<Core_PageBlockChildWithLayoutProperties>;
  overrideDefinitions: Array<Core_PageBlockButtonDefinitionOverride>;
  pageRedirect: Core_PageRedirect;
  text?: Maybe<Scalars['String']>;
};

export type Core_PageBlockButtonDefinition = Core_PageBlockDefinitionInterface & {
  __typename?: 'Core_PageBlockButtonDefinition';
  innerSpacing?: Maybe<Core_PageBlockSpacing>;
  outerSpacing?: Maybe<Core_PageBlockSpacing>;
};

export type Core_PageBlockButtonDefinitionOverride = {
  __typename?: 'Core_PageBlockButtonDefinitionOverride';
  breakpoint: Core_PageBreakPoint;
  definition: Core_PageBlockButtonDefinition;
};

export type Core_PageBlockButtonsCommunityViews = Core_PageBlockInterface & {
  __typename?: 'Core_PageBlockButtonsCommunityViews';
  communityViews: Array<Core_CommunityView>;
  defaultDefinition: Core_PageBlockButtonsViewDefinition;
  format: Core_PageBlockButtonsFormatEnum;
  id: Scalars['ID'];
  layoutProperties?: Maybe<Core_PageBlockChildWithLayoutProperties>;
  overrideDefinitions: Array<Core_PageBlockButtonsViewDefinitionOverride>;
};

export type Core_PageBlockButtonsEventViews = Core_PageBlockInterface & {
  __typename?: 'Core_PageBlockButtonsEventViews';
  defaultDefinition: Core_PageBlockButtonsViewDefinition;
  eventViews: Array<Core_EventView>;
  format: Core_PageBlockButtonsFormatEnum;
  id: Scalars['ID'];
  layoutProperties?: Maybe<Core_PageBlockChildWithLayoutProperties>;
  overrideDefinitions: Array<Core_PageBlockButtonsViewDefinitionOverride>;
};

export enum Core_PageBlockButtonsFormatEnum {
  Background = 'BACKGROUND',
  Icon = 'ICON'
}

export type Core_PageBlockButtonsViewDefinition = Core_PageBlockDefinitionInterface & {
  __typename?: 'Core_PageBlockButtonsViewDefinition';
  innerSpacing?: Maybe<Core_PageBlockSpacing>;
  outerSpacing?: Maybe<Core_PageBlockSpacing>;
};

export type Core_PageBlockButtonsViewDefinitionOverride = {
  __typename?: 'Core_PageBlockButtonsViewDefinitionOverride';
  breakpoint: Core_PageBreakPoint;
  definition: Core_PageBlockButtonsViewDefinition;
};

export type Core_PageBlockChildLayoutProperties = {
  __typename?: 'Core_PageBlockChildLayoutProperties';
  width?: Maybe<Core_PageBlockChildLayoutPropertiesWidth>;
};

export type Core_PageBlockChildLayoutPropertiesOverride = {
  __typename?: 'Core_PageBlockChildLayoutPropertiesOverride';
  breakpoint?: Maybe<Core_PageBreakPoint>;
  properties?: Maybe<Core_PageBlockChildLayoutProperties>;
};

export type Core_PageBlockChildLayoutPropertiesWidth = Core_PageBlockChildLayoutPropertiesWidthPercentage | Core_PageBlockChildLayoutPropertiesWidthPixels;

export type Core_PageBlockChildLayoutPropertiesWidthInterface = {
  type: Core_PageBlockChildLayoutPropertiesWidthTypeEnum;
};

export type Core_PageBlockChildLayoutPropertiesWidthPercentage = Core_PageBlockChildLayoutPropertiesWidthInterface & {
  __typename?: 'Core_PageBlockChildLayoutPropertiesWidthPercentage';
  type: Core_PageBlockChildLayoutPropertiesWidthTypeEnum;
  value?: Maybe<Scalars['Int']>;
};

export type Core_PageBlockChildLayoutPropertiesWidthPixels = Core_PageBlockChildLayoutPropertiesWidthInterface & {
  __typename?: 'Core_PageBlockChildLayoutPropertiesWidthPixels';
  type: Core_PageBlockChildLayoutPropertiesWidthTypeEnum;
  value?: Maybe<Scalars['Int']>;
};

export enum Core_PageBlockChildLayoutPropertiesWidthTypeEnum {
  Percentage = 'PERCENTAGE',
  Pixels = 'PIXELS'
}

export type Core_PageBlockChildWithLayoutProperties = {
  __typename?: 'Core_PageBlockChildWithLayoutProperties';
  blockId: Scalars['ID'];
  defaultProperties?: Maybe<Core_PageBlockChildLayoutProperties>;
  overrideProperties: Array<Core_PageBlockChildLayoutPropertiesOverride>;
};

export type Core_PageBlockContainer = Core_PageBlockInterface & {
  __typename?: 'Core_PageBlockContainer';
  children: Array<Core_PageBlockChildWithLayoutProperties>;
  defaultDefinition: Core_PageBlockContainerDefinition;
  id: Scalars['ID'];
  layoutProperties?: Maybe<Core_PageBlockChildWithLayoutProperties>;
  overrideDefinitions: Array<Core_PageBlockContainerDefinitionOverride>;
  section?: Maybe<Scalars['String']>;
};

export type Core_PageBlockContainerDefinition = Core_PageBlockContainerDefinitionHorizontal | Core_PageBlockContainerDefinitionVertical;

export type Core_PageBlockContainerDefinitionHorizontal = Core_PageBlockContainerDefinitionInterface & {
  __typename?: 'Core_PageBlockContainerDefinitionHorizontal';
  align?: Maybe<Core_PageBlockDefinitionAlignEnum>;
  aspectRatio?: Maybe<Scalars['Int']>;
  backgroundImage?: Maybe<Scalars['String']>;
  gap?: Maybe<Core_PageSpacing>;
  innerSpacing?: Maybe<Core_PageBlockSpacing>;
  justify?: Maybe<Core_PageBlockDefinitionJustifyEnum>;
  outerSpacing?: Maybe<Core_PageBlockSpacing>;
};

export type Core_PageBlockContainerDefinitionInterface = {
  innerSpacing?: Maybe<Core_PageBlockSpacing>;
  outerSpacing?: Maybe<Core_PageBlockSpacing>;
};

export type Core_PageBlockContainerDefinitionOverride = {
  __typename?: 'Core_PageBlockContainerDefinitionOverride';
  breakpoint: Core_PageBreakPoint;
  definition: Core_PageBlockContainerDefinition;
};

export type Core_PageBlockContainerDefinitionVertical = Core_PageBlockContainerDefinitionInterface & {
  __typename?: 'Core_PageBlockContainerDefinitionVertical';
  align?: Maybe<Core_PageBlockDefinitionAlignEnum>;
  aspectRatio?: Maybe<Scalars['Int']>;
  backgroundImage?: Maybe<Scalars['String']>;
  gap?: Maybe<Core_PageSpacing>;
  innerSpacing?: Maybe<Core_PageBlockSpacing>;
  justify?: Maybe<Core_PageBlockDefinitionJustifyEnum>;
  outerSpacing?: Maybe<Core_PageBlockSpacing>;
};

export type Core_PageBlockDefinition = Core_PageBlockButtonDefinition | Core_PageBlockButtonsViewDefinition | Core_PageBlockContainerDefinitionHorizontal | Core_PageBlockContainerDefinitionVertical | Core_PageBlockEventInformationDefinition | Core_PageBlockImageDefinition | Core_PageBlockRichTextDefinition | Core_PageBlockSponsorsDefinition | Core_PageBlockTextDefinition;

export enum Core_PageBlockDefinitionAlignEnum {
  Center = 'CENTER',
  End = 'END',
  Start = 'START'
}

export type Core_PageBlockDefinitionInterface = {
  innerSpacing?: Maybe<Core_PageBlockSpacing>;
  outerSpacing?: Maybe<Core_PageBlockSpacing>;
};

export enum Core_PageBlockDefinitionJustifyEnum {
  Center = 'CENTER',
  End = 'END',
  Start = 'START'
}

export enum Core_PageBlockDefinitionLevelEnum {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  H6 = 'H6',
  P = 'P'
}

export type Core_PageBlockEventInformation = Core_PageBlockInterface & {
  __typename?: 'Core_PageBlockEventInformation';
  defaultDefinition: Core_PageBlockEventInformationDefinition;
  id: Scalars['ID'];
  layoutProperties?: Maybe<Core_PageBlockChildWithLayoutProperties>;
  overrideDefinitions: Array<Core_PageBlockEventInformationDefinitionOverride>;
};

export type Core_PageBlockEventInformationDefinition = Core_PageBlockDefinitionInterface & {
  __typename?: 'Core_PageBlockEventInformationDefinition';
  innerSpacing?: Maybe<Core_PageBlockSpacing>;
  outerSpacing?: Maybe<Core_PageBlockSpacing>;
};

export type Core_PageBlockEventInformationDefinitionOverride = {
  __typename?: 'Core_PageBlockEventInformationDefinitionOverride';
  breakpoint: Core_PageBreakPoint;
  definition: Core_PageBlockEventInformationDefinition;
};

export type Core_PageBlockImage = Core_PageBlockInterface & {
  __typename?: 'Core_PageBlockImage';
  alt?: Maybe<Scalars['String']>;
  defaultDefinition: Core_PageBlockImageDefinition;
  id: Scalars['ID'];
  layoutProperties?: Maybe<Core_PageBlockChildWithLayoutProperties>;
  overrideDefinitions: Array<Core_PageBlockImageDefinitionOverride>;
  src?: Maybe<Scalars['String']>;
};

export type Core_PageBlockImageDefinition = Core_PageBlockDefinitionInterface & {
  __typename?: 'Core_PageBlockImageDefinition';
  innerSpacing?: Maybe<Core_PageBlockSpacing>;
  outerSpacing?: Maybe<Core_PageBlockSpacing>;
};

export type Core_PageBlockImageDefinitionOverride = {
  __typename?: 'Core_PageBlockImageDefinitionOverride';
  breakpoint: Core_PageBreakPoint;
  definition: Core_PageBlockImageDefinition;
};

export type Core_PageBlockInterface = {
  id: Scalars['ID'];
  layoutProperties?: Maybe<Core_PageBlockChildWithLayoutProperties>;
};

export type Core_PageBlockRichText = Core_PageBlockInterface & {
  __typename?: 'Core_PageBlockRichText';
  defaultDefinition: Core_PageBlockRichTextDefinition;
  id: Scalars['ID'];
  layoutProperties?: Maybe<Core_PageBlockChildWithLayoutProperties>;
  overrideDefinitions: Array<Core_PageBlockRichTextDefinitionOverride>;
  text?: Maybe<Scalars['String']>;
};

export type Core_PageBlockRichTextDefinition = Core_PageBlockDefinitionInterface & {
  __typename?: 'Core_PageBlockRichTextDefinition';
  align?: Maybe<Core_PageBlockDefinitionAlignEnum>;
  innerSpacing?: Maybe<Core_PageBlockSpacing>;
  outerSpacing?: Maybe<Core_PageBlockSpacing>;
};

export type Core_PageBlockRichTextDefinitionOverride = {
  __typename?: 'Core_PageBlockRichTextDefinitionOverride';
  breakpoint: Core_PageBreakPoint;
  definition: Core_PageBlockRichTextDefinition;
};

export type Core_PageBlockSpacing = {
  __typename?: 'Core_PageBlockSpacing';
  bottom: Core_PageSpacing;
  end: Core_PageSpacing;
  start: Core_PageSpacing;
  top: Core_PageSpacing;
};

export type Core_PageBlockSponsors = Core_PageBlockInterface & {
  __typename?: 'Core_PageBlockSponsors';
  defaultDefinition: Core_PageBlockSponsorsDefinition;
  id: Scalars['ID'];
  layoutProperties?: Maybe<Core_PageBlockChildWithLayoutProperties>;
  overrideDefinitions: Array<Core_PageBlockButtonsViewDefinitionOverride>;
};

export type Core_PageBlockSponsorsDefinition = Core_PageBlockDefinitionInterface & {
  __typename?: 'Core_PageBlockSponsorsDefinition';
  innerSpacing?: Maybe<Core_PageBlockSpacing>;
  outerSpacing?: Maybe<Core_PageBlockSpacing>;
};

export type Core_PageBlockSponsorsDefinitionOverride = {
  __typename?: 'Core_PageBlockSponsorsDefinitionOverride';
  breakpoint: Core_PageBreakPoint;
  definition: Core_PageBlockSponsorsDefinition;
};

export type Core_PageBlockText = Core_PageBlockInterface & {
  __typename?: 'Core_PageBlockText';
  defaultDefinition: Core_PageBlockTextDefinition;
  id: Scalars['ID'];
  layoutProperties?: Maybe<Core_PageBlockChildWithLayoutProperties>;
  overrideDefinitions: Array<Core_PageBlockTextDefinitionOverride>;
  text?: Maybe<Scalars['String']>;
};

export type Core_PageBlockTextDefinition = Core_PageBlockDefinitionInterface & {
  __typename?: 'Core_PageBlockTextDefinition';
  align?: Maybe<Core_PageBlockDefinitionAlignEnum>;
  innerSpacing?: Maybe<Core_PageBlockSpacing>;
  level?: Maybe<Core_PageBlockDefinitionLevelEnum>;
  outerSpacing?: Maybe<Core_PageBlockSpacing>;
};

export type Core_PageBlockTextDefinitionOverride = {
  __typename?: 'Core_PageBlockTextDefinitionOverride';
  breakpoint: Core_PageBreakPoint;
  definition: Core_PageBlockTextDefinition;
};

export type Core_PageBreakPoint = Core_PageBreakPointTheme;

export type Core_PageBreakPointInterface = {
  type: Core_PageBreakPointTypeEnum;
};

export type Core_PageBreakPointTheme = Core_PageBreakPointInterface & {
  __typename?: 'Core_PageBreakPointTheme';
  max?: Maybe<Core_PageBreakPointThemeValueEnum>;
  min: Core_PageBreakPointThemeValueEnum;
  type: Core_PageBreakPointTypeEnum;
};

export enum Core_PageBreakPointThemeValueEnum {
  Lg = 'LG',
  Md = 'MD',
  Sm = 'SM',
  Xl = 'XL',
  Xs = 'XS'
}

export enum Core_PageBreakPointTypeEnum {
  Theme = 'THEME'
}

export type Core_PageInfo = {
  __typename?: 'Core_PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type Core_PageInfoType = {
  __typename?: 'Core_PageInfoType';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  nextCursor?: Maybe<Scalars['String']>;
  totalEdges: Scalars['Int'];
};

export type Core_PageRedirect = Core_PageRedirectDefault | Core_PageRedirectEventPerson | Core_PageRedirectEventView | Core_PageRedirectExhibitor | Core_PageRedirectPlanning | Core_PageRedirectProduct;

export type Core_PageRedirectDefault = Core_PageRedirectInterface & {
  __typename?: 'Core_PageRedirectDefault';
  type?: Maybe<Core_PageRedirectTypeEnum>;
};

export type Core_PageRedirectEventPerson = Core_PageRedirectInterface & {
  __typename?: 'Core_PageRedirectEventPerson';
  eventPerson?: Maybe<Core_EventPerson>;
  type?: Maybe<Core_PageRedirectTypeEnum>;
};

export type Core_PageRedirectEventView = Core_PageRedirectInterface & {
  __typename?: 'Core_PageRedirectEventView';
  type?: Maybe<Core_PageRedirectTypeEnum>;
  view?: Maybe<Core_EventView>;
};

export type Core_PageRedirectExhibitor = Core_PageRedirectInterface & {
  __typename?: 'Core_PageRedirectExhibitor';
  exhibitor?: Maybe<Core_Exhibitor>;
  type?: Maybe<Core_PageRedirectTypeEnum>;
};

export type Core_PageRedirectInterface = {
  type?: Maybe<Core_PageRedirectTypeEnum>;
};

export type Core_PageRedirectPlanning = Core_PageRedirectInterface & {
  __typename?: 'Core_PageRedirectPlanning';
  planning?: Maybe<Core_Planning>;
  type?: Maybe<Core_PageRedirectTypeEnum>;
};

export type Core_PageRedirectProduct = Core_PageRedirectInterface & {
  __typename?: 'Core_PageRedirectProduct';
  product?: Maybe<Core_Product>;
  type?: Maybe<Core_PageRedirectTypeEnum>;
};

export enum Core_PageRedirectTypeEnum {
  Default = 'DEFAULT',
  EventProfile = 'EVENT_PROFILE',
  EventView = 'EVENT_VIEW',
  Exhibitor = 'EXHIBITOR',
  Planning = 'PLANNING',
  Product = 'PRODUCT'
}

export type Core_PageResultsInfo = {
  __typename?: 'Core_PageResultsInfo';
  currentPage: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  lastPage: Scalars['Int'];
  totalResults: Scalars['Int'];
};

export type Core_PageSpacing = Core_PageSpacingPixel | Core_PageSpacingTheme;

export type Core_PageSpacingInterface = {
  type: Core_PageSpacingTypeEnum;
};

export type Core_PageSpacingPixel = Core_PageSpacingInterface & {
  __typename?: 'Core_PageSpacingPixel';
  type: Core_PageSpacingTypeEnum;
  value?: Maybe<Scalars['Int']>;
};

export type Core_PageSpacingTheme = Core_PageSpacingInterface & {
  __typename?: 'Core_PageSpacingTheme';
  type: Core_PageSpacingTypeEnum;
  value?: Maybe<Core_PageSpacingThemeValueEnum>;
};

export enum Core_PageSpacingThemeValueEnum {
  S_1 = 'S_1',
  S_2 = 'S_2',
  S_3 = 'S_3',
  S_4 = 'S_4',
  S_5 = 'S_5',
  S_6 = 'S_6',
  S_8 = 'S_8',
  S_10 = 'S_10',
  S_12 = 'S_12'
}

export enum Core_PageSpacingTypeEnum {
  Pixel = 'PIXEL',
  Theme = 'THEME'
}

/** Represents an error that occurred during a Mutation. */
export type Core_PayloadError = {
  __typename?: 'Core_PayloadError';
  code: Scalars['String'];
  message: Scalars['String'];
  path?: Maybe<Scalars['String']>;
  subCode?: Maybe<Scalars['String']>;
};

export type Core_Payment = {
  __typename?: 'Core_Payment';
  amountCents: Scalars['Int'];
  applicationFeeCents: Scalars['Int'];
  currency: Scalars['String'];
  id: Scalars['ID'];
  paidAt?: Maybe<Scalars['Core_DateTime']>;
  paymentMethod?: Maybe<Core_PaymentMethodUnion>;
};

export type Core_PaymentMethodUnion = Core_CreditCardPaymentMethod;

export type Core_PaymentProvider = Core_StripePaymentProvider;

export type Core_PdfExportPayload = {
  __typename?: 'Core_PdfExportPayload';
  error?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Core_PeopleViewFeaturedCard = Core_EventPersonInterface & {
  __typename?: 'Core_PeopleViewFeaturedCard';
  address?: Maybe<Core_Address>;
  aggregation?: Maybe<Core_Aggregation>;
  attendeeOnPlannings: Array<Core_Planning>;
  biography?: Maybe<Scalars['String']>;
  community: Core_Community;
  /** @deprecated No longer supported */
  company?: Maybe<Core_Company>;
  connectionInfo?: Maybe<Core_ConnectionInfo>;
  email?: Maybe<Scalars['String']>;
  fields: Array<Core_FieldUnion>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  jobTitle?: Maybe<Scalars['String']>;
  landlinePhone?: Maybe<Core_PhoneNumber>;
  lastName: Scalars['String'];
  memberOnExhibitors: Array<Core_Exhibitor>;
  mobilePhone?: Maybe<Core_PhoneNumber>;
  organization?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  recommendationExplanations?: Maybe<Array<Core_RecommendationExplanation>>;
  /** @deprecated No longer supported */
  secondJobTitle?: Maybe<Scalars['String']>;
  socialNetworks: Array<Core_SocialNetwork>;
  speakerOnPlannings: Array<Core_Planning>;
  /** @deprecated No longer supported */
  tags: Array<Scalars['String']>;
  type?: Maybe<Core_EventPersonType>;
  userId?: Maybe<Scalars['ID']>;
  userInfo?: Maybe<Core_UserInfo>;
  websiteUrl?: Maybe<Scalars['String']>;
  withEvent?: Maybe<Core_EventPersonWithEvent>;
};


export type Core_PeopleViewFeaturedCardAttendeeOnPlanningsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_PeopleViewFeaturedCardMemberOnExhibitorsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_PeopleViewFeaturedCardSpeakerOnPlanningsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};

export type Core_PeopleViewFeaturedCardConnection = {
  __typename?: 'Core_PeopleViewFeaturedCardConnection';
  nodes: Array<Core_PeopleViewFeaturedCard>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_Permission = {
  __typename?: 'Core_Permission';
  code: Core_PermissionCodeEnum;
  description: Scalars['String'];
  id: Scalars['ID'];
  type: Core_RolePermissionTypeEnum;
};

export enum Core_PermissionCodeEnum {
  ExhibitorExportLeads = 'EXHIBITOR_EXPORT_LEADS',
  ExhibitorExportMeetings = 'EXHIBITOR_EXPORT_MEETINGS',
  ExhibitorManageAdvertisement = 'EXHIBITOR_MANAGE_ADVERTISEMENT',
  ExhibitorManageCompany = 'EXHIBITOR_MANAGE_COMPANY',
  ExhibitorManageDocuments = 'EXHIBITOR_MANAGE_DOCUMENTS',
  ExhibitorManageItems = 'EXHIBITOR_MANAGE_ITEMS',
  ExhibitorManageMeetings = 'EXHIBITOR_MANAGE_MEETINGS',
  ExhibitorManageMembers = 'EXHIBITOR_MANAGE_MEMBERS'
}

export type Core_PersonInput = {
  addresses?: InputMaybe<Array<Core_AddressInput>>;
  biography?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  interests?: InputMaybe<Array<Scalars['String']>>;
  jobTitle?: InputMaybe<Scalars['String']>;
  /** Deprecated */
  labels?: InputMaybe<Array<Scalars['String']>>;
  lastName?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<Core_PhoneNumberInput>>;
  photoUrl?: InputMaybe<Scalars['String']>;
  /** Deprecated */
  secondJobTitle?: InputMaybe<Scalars['String']>;
  socialNetworks?: InputMaybe<Array<Core_SocialNetworkInput>>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type Core_PersonInterface = {
  addresses?: Maybe<Array<Maybe<Core_Address>>>;
  biography?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  company?: Maybe<Core_Company>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  interests?: Maybe<Array<Maybe<Scalars['String']>>>;
  jobTitle?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastName?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  /** @deprecated Use the field userInfo instead */
  personType?: Maybe<Core_PersonTypeEnum>;
  phoneNumbers?: Maybe<Array<Maybe<Core_PhoneNumber>>>;
  photoUrl?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  secondJobTitle?: Maybe<Scalars['String']>;
  socialNetworks?: Maybe<Array<Maybe<Core_SocialNetwork>>>;
  userInfo: Core_UserInfo;
  /** @deprecated Use the field userInfo instead */
  userStatus?: Maybe<Core_UserStatusEnum>;
  websiteUrl?: Maybe<Scalars['String']>;
};


export type Core_PersonInterfaceLogoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};


export type Core_PersonInterfacePhoneNumbersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Core_PhoneNumberEnum>;
};


export type Core_PersonInterfacePhotoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};

export type Core_PersonMeetingSlot = Core_MeetingInterface & {
  __typename?: 'Core_PersonMeetingSlot';
  ends: Scalars['Core_DateTime'];
  id: Scalars['ID'];
  isDisabled: Scalars['Boolean'];
  places: Array<Core_MeetingPlace>;
  starts: Scalars['Core_DateTime'];
};


export type Core_PersonMeetingSlotEndsArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_PersonMeetingSlotStartsArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_PersonMeetingSlotsConnection = {
  __typename?: 'Core_PersonMeetingSlotsConnection';
  nodes: Array<Core_PersonMeetingSlot>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export enum Core_PersonTypeEnum {
  Contact = 'CONTACT',
  User = 'USER'
}

export type Core_PhoneNumber = {
  __typename?: 'Core_PhoneNumber';
  countryCode?: Maybe<Scalars['Int']>;
  formattedNumber?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  type?: Maybe<Core_PhoneNumberEnum>;
};

export enum Core_PhoneNumberEnum {
  Fax = 'FAX',
  Landline = 'LANDLINE',
  Mobile = 'MOBILE'
}

export type Core_PhoneNumberInput = {
  countryCode?: InputMaybe<Scalars['Int']>;
  number?: InputMaybe<Scalars['String']>;
  type: Core_PhoneNumberEnum;
};

export type Core_Planning = Core_BookmarkAwareInterface & Core_EntityInterface & Core_EventInterface & Core_LiveStreamAwareInterface & Core_OnDemandAwareInterface & Core_PreRecordedAwareInterface & Core_RoundtableAwareInterface & {
  __typename?: 'Core_Planning';
  /**
   * Event related fields.
   * @deprecated Use withEvent._id instead
   */
  _id: Scalars['ID'];
  address?: Maybe<Core_Address>;
  /** The aggregation where the planning belongs in the context of an aggregated list. */
  aggregation?: Maybe<Core_Aggregation>;
  attendeeProfiles?: Maybe<Core_EventPeopleConnection>;
  /** @deprecated Use fields totalAttendees or withEvent.totalAttendees instead */
  attendees?: Maybe<Core_EdgeListAttendeeUnion>;
  backstage?: Maybe<Core_VideoBackstage>;
  bannerUrl?: Maybe<Scalars['String']>;
  beginsAt: Scalars['Core_DateTime'];
  bookmark?: Maybe<Core_BookmarkComponent>;
  /** @deprecated Use withEvent.canBookmark instead */
  canBookmark: Scalars['Boolean'];
  categories: Array<Core_LabelString>;
  community: Core_Community;
  /** @deprecated No longer supported */
  configuration: Core_PlanningConfiguration;
  contents: Core_PlanningContents;
  createdAt?: Maybe<Scalars['Core_DateTime']>;
  /** @deprecated Use htmlDescription or withEvent.htmlDescription instead */
  description?: Maybe<Scalars['String']>;
  documents: Array<Maybe<Core_Document>>;
  endsAt: Scalars['Core_DateTime'];
  evaluation?: Maybe<Core_Evaluation>;
  /** @deprecated use Planning.events instead */
  event?: Maybe<Core_Event>;
  /** @deprecated Use withEvent.eventStatus instead */
  eventStatus?: Maybe<Core_EventStatusEnum>;
  events?: Maybe<Core_EventsConnection>;
  exhibitorList: Array<Maybe<Core_Exhibitor>>;
  fields: Array<Core_FieldUnion>;
  firstSpeakers: Array<Core_EventPerson>;
  format: Core_PlanningFormatEnum;
  forms: Core_FormsConnection;
  groupBy?: Maybe<Core_GroupByField>;
  hideAttendees: Scalars['Boolean'];
  htmlDescription?: Maybe<Scalars['String']>;
  /** Planning related fields. */
  id: Scalars['ID'];
  isBookmarked: Scalars['Boolean'];
  isGuestModeActive: Scalars['Boolean'];
  isRatable: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Float']>;
  linkedPlannings: Array<Core_Planning>;
  liveStream?: Maybe<Core_LiveStreamComponent>;
  longitude?: Maybe<Scalars['Float']>;
  maxSeats?: Maybe<Scalars['Int']>;
  onDemand?: Maybe<Core_OnDemandComponent>;
  place?: Maybe<Scalars['String']>;
  preRecorded?: Maybe<Core_PreRecordedComponent>;
  /** Remaining seats of the planning. null signifies unlimited seats. */
  remainingSeats?: Maybe<Scalars['Int']>;
  roundtable?: Maybe<Core_RoundtableComponent>;
  /** @deprecated Use field `isVisibleAsAttendee` on type `Event` or `isBookmarked` on type `Planning` instead */
  selfAttendeeStatus?: Maybe<Core_AttendeeStatusEnum>;
  similarPlannings: Array<Core_Planning>;
  speakerList?: Maybe<Array<Maybe<Core_SpeakerUnion>>>;
  streams: Array<Core_PlanningStream>;
  ticketUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  totalAttendees: Scalars['Int'];
  twitterHashtag?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Core_DateTime']>;
  userRole?: Maybe<Core_UserRoleEnum>;
  /** Return the current user in event if speaker of the session. */
  userSpeaker?: Maybe<Core_EventPerson>;
  visibility?: Maybe<Core_EventVisibilityEnum>;
  withEvent?: Maybe<Core_PlanningWithEvent>;
};


export type Core_PlanningAttendeeProfilesArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
};


export type Core_PlanningAttendeesArgs = {
  _eventIdV1?: InputMaybe<Scalars['ID']>;
  _id?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<Core_AttendeeFilterInput>>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Core_PlanningBannerUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};


export type Core_PlanningBeginsAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_PlanningCreatedAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_PlanningEndsAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_PlanningFirstSpeakersArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_PlanningFormsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  filters?: InputMaybe<Array<Core_PlanningFormFilterInput>>;
  sort?: InputMaybe<Array<Core_FormSortInput>>;
};


export type Core_PlanningLinkedPlanningsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_PlanningLiveStreamArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
};


export type Core_PlanningOnDemandArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
};


export type Core_PlanningPreRecordedArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
};


export type Core_PlanningSimilarPlanningsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_PlanningUpdatedAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_PlanningWithEventArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
  eventSlug?: InputMaybe<Scalars['String']>;
};

export type Core_PlanningActivity = Core_ActivityInterface & {
  __typename?: 'Core_PlanningActivity';
  /** The community in which the activity happened. */
  community?: Maybe<Core_Community>;
  /** The event in which the activity happened. */
  event?: Maybe<Core_Event>;
  id: Scalars['ID'];
  kind: Core_PlanningActivityKind;
  planning: Core_Planning;
  seen: Scalars['Boolean'];
  sentAt: Scalars['Core_DateTime'];
};


export type Core_PlanningActivitySentAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export enum Core_PlanningActivityKind {
  PlanningReminderBefore = 'PLANNING_REMINDER_BEFORE',
  PlanningReminderRating = 'PLANNING_REMINDER_RATING'
}

export type Core_PlanningConfiguration = {
  __typename?: 'Core_PlanningConfiguration';
  /** @deprecated Use Planning.hideAttendees instead */
  hideAttendees: Scalars['Boolean'];
  /** @deprecated Use Planning.maxSeats instead */
  maxSeats?: Maybe<Scalars['Int']>;
};

export type Core_PlanningContents = {
  __typename?: 'Core_PlanningContents';
  views: Array<Core_PlanningView>;
};

/** Represent a single filter for plannings. Each field of the input adds a new "AND" condition. */
export type Core_PlanningFilterInput = {
  /** Filter plannings having **one of the following** formats. */
  formats?: InputMaybe<Array<Core_PlanningFormatEnum>>;
  /** Filters plannings on these ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** Filters plannings having **all** these categories. */
  mustCategoryIn?: InputMaybe<Array<Scalars['ID']>>;
  /** Filters plannings having **all** these types. */
  mustTypeIn?: InputMaybe<Array<Scalars['ID']>>;
  /** Filters plannings having **at least one** category among these ones. */
  shouldCategoryIn?: InputMaybe<Array<Scalars['ID']>>;
  /** Filters plannings starting the same day than **at least one** of these ones. */
  shouldDayIn?: InputMaybe<Array<Scalars['Core_DateTime']>>;
  /** Filters plannings having **at least one** exhibitor among these ones. */
  shouldExhibitorIn?: InputMaybe<Array<Scalars['ID']>>;
  /** Filters plannings having **at least one** place among these ones. */
  shouldPlaceIn?: InputMaybe<Array<Scalars['ID']>>;
  /** Filters plannings where the user have **at least one** of these status. */
  shouldSelfAttendeeStatusIn?: InputMaybe<Array<Core_AttendeeStatusEnum>>;
  /** Filters plannings having **at least one** type among these ones. */
  shouldTypeIn?: InputMaybe<Array<Scalars['ID']>>;
};

export type Core_PlanningFormFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * true : only published forms returned + ordered by availableFrom
   * false : only unpublished forms returned + ordered by createdAt
   * null : all forms returned + ordered by createdAt / no regressions brought
   */
  isPublished?: InputMaybe<Scalars['Boolean']>;
};

export enum Core_PlanningFormatEnum {
  LiveStream = 'LIVE_STREAM',
  OnDemand = 'ON_DEMAND',
  Physical = 'PHYSICAL',
  PreRecorded = 'PRE_RECORDED',
  Roundtable = 'ROUNDTABLE'
}

export type Core_PlanningRecommendation = {
  __typename?: 'Core_PlanningRecommendation';
  metadata: Scalars['String'];
  recommendedEntities?: Maybe<Array<Core_PlanningRecommended>>;
  totalCount: Scalars['Int'];
};

export type Core_PlanningRecommendationExplanation = {
  __typename?: 'Core_PlanningRecommendationExplanation';
  origin: Core_RecommendationExplanationOriginEnum;
  type: Core_RecommendationExplanationTypeEnum;
  values?: Maybe<Array<Core_Planning>>;
};

export type Core_PlanningRecommended = {
  __typename?: 'Core_PlanningRecommended';
  planning: Core_Planning;
};

export enum Core_PlanningSortEnum {
  BeginsAt = 'BEGINS_AT',
  BookmarkedSince = 'BOOKMARKED_SINCE'
}

export type Core_PlanningStream = Core_IframePlanningStream | Core_RtmpPlanningStream | Core_VimeoPlanningStream | Core_YoutubePlanningStream;

export type Core_PlanningStreamInterface = {
  id: Scalars['ID'];
  isPublic: Scalars['Boolean'];
};

export type Core_PlanningView = Core_EventChatroomView | Core_EventRedirectUrlView;

export type Core_PlanningWithEvent = Core_BookmarkAwareInterface & Core_LiveStreamAwareInterface & Core_OnDemandAwareInterface & Core_PreRecordedAwareInterface & Core_RoundtableAwareInterface & {
  __typename?: 'Core_PlanningWithEvent';
  attendeeProfiles?: Maybe<Core_EventPeopleConnection>;
  beginsAt: Scalars['Core_DateTime'];
  bookmark?: Maybe<Core_BookmarkComponent>;
  canBookmark: Scalars['Boolean'];
  documents: Array<Maybe<Core_Document>>;
  endsAt: Scalars['Core_DateTime'];
  evaluation?: Maybe<Core_Evaluation>;
  exhibitorList: Array<Maybe<Core_Exhibitor>>;
  fields: Array<Core_FieldUnion>;
  firstSpeakers: Array<Core_EventPerson>;
  htmlDescription?: Maybe<Scalars['String']>;
  isGuestModeActive: Scalars['Boolean'];
  linkedPlannings: Array<Core_Planning>;
  liveStream?: Maybe<Core_LiveStreamComponent>;
  onDemand?: Maybe<Core_OnDemandComponent>;
  preRecorded?: Maybe<Core_PreRecordedComponent>;
  roundtable?: Maybe<Core_RoundtableComponent>;
  similarPlannings: Array<Core_Planning>;
  title: Scalars['String'];
  totalAttendees: Scalars['Int'];
  /**
   * Returns a list of attending meetings and bookmarked plannings that overlap with this planning for the current user.
   * ON_DEMAND plannings are excluded.
   */
  userAgendaConflicts?: Maybe<Array<Core_AgendaItem>>;
  userSpeaker?: Maybe<Core_EventPerson>;
};


export type Core_PlanningWithEventAttendeeProfilesArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
};


export type Core_PlanningWithEventBeginsAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_PlanningWithEventEndsAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_PlanningWithEventFirstSpeakersArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_PlanningWithEventLinkedPlanningsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_PlanningWithEventLiveStreamArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
};


export type Core_PlanningWithEventOnDemandArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
};


export type Core_PlanningWithEventPreRecordedArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
};


export type Core_PlanningWithEventSimilarPlanningsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};

export type Core_PlanningsConnection = {
  __typename?: 'Core_PlanningsConnection';
  nodes: Array<Core_Planning>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_PngExportPayload = {
  __typename?: 'Core_PngExportPayload';
  error?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Core_PositioningProviderUnion = Core_CrowdConnectedConfiguration;

export type Core_PreRecordedAwareInterface = {
  preRecorded?: Maybe<Core_PreRecordedComponent>;
};


export type Core_PreRecordedAwareInterfacePreRecordedArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
};

export type Core_PreRecordedComponent = {
  __typename?: 'Core_PreRecordedComponent';
  availableAt: Scalars['Core_DateTime'];
  availableUntil?: Maybe<Scalars['Core_DateTime']>;
  id: Scalars['ID'];
  isPublic: Scalars['Boolean'];
  video: Core_EmbeddedVideoUnion;
};

export type Core_Product = {
  __typename?: 'Core_Product';
  category?: Maybe<Core_ProductCategory>;
  community: Core_Community;
  description?: Maybe<Scalars['String']>;
  descriptionTranslations: Array<Core_TranslationString>;
  events?: Maybe<Core_EventsConnection>;
  /** Exhibitors linked to products across the community. For event specific information, use withEvent.exhibitors */
  exhibitors: Array<Core_Exhibitor>;
  /** Get custom field values for this product. For getting only fields enabled on an event, use withEvent.fields */
  fields: Array<Core_FieldUnion>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  /** Represents if the Product has been bookmarked by the current user at Community Level */
  isBookmarked: Scalars['Boolean'];
  isGuestModeActive: Scalars['Boolean'];
  media: Array<Scalars['String']>;
  name: Scalars['String'];
  nameTranslations: Array<Core_TranslationString>;
  /** Get similar products in the community. Use withEvent.similarProducts for similar products in a specific event */
  similarProducts: Array<Core_Product>;
  withEvent?: Maybe<Core_ProductWithEvent>;
};


export type Core_ProductEventsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  sort?: InputMaybe<Array<Core_ProductEventsSortInput>>;
};


export type Core_ProductSimilarProductsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};


export type Core_ProductWithEventArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
  eventSlug?: InputMaybe<Scalars['String']>;
};

export type Core_ProductCategoriesConnection = {
  __typename?: 'Core_ProductCategoriesConnection';
  nodes: Array<Core_ProductCategory>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_ProductCategoriesFilterInput = {
  AND?: InputMaybe<Array<Core_ProductCategoriesFilterInput>>;
  OR?: InputMaybe<Array<Core_ProductCategoriesFilterInput>>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  isRoot?: InputMaybe<Scalars['Boolean']>;
  parentIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Core_ProductCategory = {
  __typename?: 'Core_ProductCategory';
  children: Array<Core_ProductCategory>;
  color?: Maybe<Scalars['String']>;
  events?: Maybe<Core_EventsConnection>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  isGuestModeActive: Scalars['Boolean'];
  name: Scalars['String'];
  parent?: Maybe<Core_ProductCategory>;
  parents: Array<Core_ProductCategory>;
};


export type Core_ProductCategoryEventsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  sort?: InputMaybe<Array<Core_ProductCategoryEventsSortInput>>;
};

export enum Core_ProductCategoryEventsSortEnum {
  BeginsAt = 'BEGINS_AT'
}

export type Core_ProductCategoryEventsSortInput = {
  field: Core_ProductCategoryEventsSortEnum;
  order?: InputMaybe<Core_SortOrderEnum>;
};

export type Core_ProductCategoryFilterInput = {
  id?: InputMaybe<Scalars['ID']>;
  recursive?: InputMaybe<Scalars['Boolean']>;
};

export type Core_ProductCategoryUnion = Core_ProductCategory | Core_RootProductCategory;

export enum Core_ProductEventsSortEnum {
  BeginsAt = 'BEGINS_AT'
}

export type Core_ProductEventsSortInput = {
  field: Core_ProductEventsSortEnum;
  order?: InputMaybe<Core_SortOrderEnum>;
};

export type Core_ProductRecommendation = {
  __typename?: 'Core_ProductRecommendation';
  metadata: Scalars['String'];
  recommendedEntities?: Maybe<Array<Core_ProductRecommended>>;
  totalCount: Scalars['Int'];
};

export type Core_ProductRecommendationExplanation = {
  __typename?: 'Core_ProductRecommendationExplanation';
  origin: Core_RecommendationExplanationOriginEnum;
  type: Core_RecommendationExplanationTypeEnum;
  values?: Maybe<Array<Core_Product>>;
};

export type Core_ProductRecommended = {
  __typename?: 'Core_ProductRecommended';
  product: Core_Product;
};

export enum Core_ProductSortFieldEnum {
  CategoryPath = 'CATEGORY_PATH',
  Name = 'NAME'
}

export type Core_ProductSortInput = {
  field: Core_ProductSortFieldEnum;
  order?: InputMaybe<Core_SortOrderEnum>;
};

export type Core_ProductWithEvent = {
  __typename?: 'Core_ProductWithEvent';
  exhibitors: Array<Core_Exhibitor>;
  fields: Array<Core_FieldUnion>;
  isBookmarked: Scalars['Boolean'];
  isGuestModeActive: Scalars['Boolean'];
  similarProducts: Array<Core_Product>;
};


export type Core_ProductWithEventSimilarProductsArgs = {
  size?: InputMaybe<Scalars['Int']>;
};

export type Core_ProductWithEventDataInput = {
  _?: InputMaybe<Scalars['Boolean']>;
};

export type Core_ProductWithEventInput = {
  data?: InputMaybe<Core_ProductWithEventDataInput>;
  eventId: Scalars['ID'];
};

export type Core_ProductsConnection = {
  __typename?: 'Core_ProductsConnection';
  nodes: Array<Core_Product>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_ProductsFilterInput = {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  rootCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum Core_PromptLocationEnum {
  OnEventOpening = 'ON_EVENT_OPENING',
  OnRegistration = 'ON_REGISTRATION'
}

export type Core_PublicPersonInterface = {
  biography?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  company?: Maybe<Core_Company>;
  firstName?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  interests?: Maybe<Array<Maybe<Scalars['String']>>>;
  jobTitle?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastName?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  /** @deprecated Use the field userInfo instead */
  personType?: Maybe<Core_PersonTypeEnum>;
  photoUrl?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  secondJobTitle?: Maybe<Scalars['String']>;
  socialNetworks?: Maybe<Array<Maybe<Core_SocialNetwork>>>;
  userInfo: Core_UserInfo;
  /** @deprecated Use the field userInfo instead */
  userStatus?: Maybe<Core_UserStatusEnum>;
};


export type Core_PublicPersonInterfacePhotoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};

export type Core_PublicSpeakerUser = Core_PublicPersonInterface & Core_PublicUserInterface & Core_SpeakerInterface & {
  __typename?: 'Core_PublicSpeakerUser';
  _id: Scalars['ID'];
  biography?: Maybe<Scalars['String']>;
  canViewConnections?: Maybe<Scalars['Boolean']>;
  commonConnections?: Maybe<Core_EdgeListConnectionUnion>;
  /** @deprecated No longer supported */
  company?: Maybe<Core_Company>;
  exhibitorList?: Maybe<Array<Maybe<Core_Exhibitor>>>;
  firstName?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  interests?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** @deprecated No longer supported */
  isUserResourceAvailable: Core_ResourceAvailable;
  jobTitle?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastName?: Maybe<Scalars['String']>;
  lookingForTags: Array<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  pendingRequests: Array<Core_Request>;
  /** @deprecated Use the field userInfo instead */
  personType?: Maybe<Core_PersonTypeEnum>;
  photoUrl?: Maybe<Scalars['String']>;
  planningList?: Maybe<Array<Maybe<Core_Planning>>>;
  /** @deprecated No longer supported */
  secondJobTitle?: Maybe<Scalars['String']>;
  socialNetworks?: Maybe<Array<Maybe<Core_SocialNetwork>>>;
  type?: Maybe<Scalars['String']>;
  typeOrder?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['ID']>;
  userInfo: Core_UserInfo;
  /** @deprecated Use the field userInfo instead */
  userStatus?: Maybe<Core_UserStatusEnum>;
};


export type Core_PublicSpeakerUserCommonConnectionsArgs = {
  _userId?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Core_SortInput>>>;
};


export type Core_PublicSpeakerUserIsUserResourceAvailableArgs = {
  resource: Core_UserResourceEnum;
};


export type Core_PublicSpeakerUserPhotoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};

export type Core_PublicUser = Core_PublicPersonInterface & Core_PublicUserInterface & Core_TeamMemberInterface & {
  __typename?: 'Core_PublicUser';
  _id: Scalars['ID'];
  biography?: Maybe<Scalars['String']>;
  canViewConnections?: Maybe<Scalars['Boolean']>;
  commonConnections?: Maybe<Core_EdgeListConnectionUnion>;
  /** @deprecated No longer supported */
  company?: Maybe<Core_Company>;
  exhibitorList?: Maybe<Array<Maybe<Core_Exhibitor>>>;
  firstName?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  interests?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** @deprecated No longer supported */
  isUserResourceAvailable: Core_ResourceAvailable;
  jobTitle?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastName?: Maybe<Scalars['String']>;
  lookingForTags: Array<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  pendingRequests: Array<Core_Request>;
  /** @deprecated Use the field userInfo instead */
  personType?: Maybe<Core_PersonTypeEnum>;
  photoUrl?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  secondJobTitle?: Maybe<Scalars['String']>;
  socialNetworks?: Maybe<Array<Maybe<Core_SocialNetwork>>>;
  teamOptions?: Maybe<Core_TeamOptions>;
  userInfo: Core_UserInfo;
  /** @deprecated Use the field userInfo instead */
  userStatus?: Maybe<Core_UserStatusEnum>;
};


export type Core_PublicUserCommonConnectionsArgs = {
  _userId?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Core_SortInput>>>;
};


export type Core_PublicUserIsUserResourceAvailableArgs = {
  resource: Core_UserResourceEnum;
};


export type Core_PublicUserPhotoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};

export type Core_PublicUserInterface = {
  _id: Scalars['ID'];
  biography?: Maybe<Scalars['String']>;
  canViewConnections?: Maybe<Scalars['Boolean']>;
  commonConnections?: Maybe<Core_EdgeListConnectionUnion>;
  /** @deprecated No longer supported */
  company?: Maybe<Core_Company>;
  exhibitorList?: Maybe<Array<Maybe<Core_Exhibitor>>>;
  firstName?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  interests?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** @deprecated No longer supported */
  isUserResourceAvailable: Core_ResourceAvailable;
  jobTitle?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastName?: Maybe<Scalars['String']>;
  lookingForTags: Array<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  pendingRequests: Array<Core_Request>;
  /** @deprecated Use the field userInfo instead */
  personType?: Maybe<Core_PersonTypeEnum>;
  photoUrl?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  secondJobTitle?: Maybe<Scalars['String']>;
  socialNetworks?: Maybe<Array<Maybe<Core_SocialNetwork>>>;
  userInfo: Core_UserInfo;
  /** @deprecated Use the field userInfo instead */
  userStatus?: Maybe<Core_UserStatusEnum>;
};


export type Core_PublicUserInterfaceCommonConnectionsArgs = {
  _userId?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Core_SortInput>>>;
};


export type Core_PublicUserInterfaceIsUserResourceAvailableArgs = {
  resource: Core_UserResourceEnum;
};


export type Core_PublicUserInterfacePhotoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};

export enum Core_PushDeviceEnum {
  AndroidPhone = 'ANDROID_PHONE',
  IosPhone = 'IOS_PHONE'
}

export type Core_PushProfileInput = {
  application?: InputMaybe<Core_ApplicationEnum>;
  device: Core_PushDeviceEnum;
  removeToken?: InputMaybe<Scalars['Boolean']>;
  token?: InputMaybe<Scalars['String']>;
};

export type Core_QualifierQuestionMoveInput = {
  position: Core_QualifierQuestionMovePosition;
  targetId: Scalars['ID'];
};

export enum Core_QualifierQuestionMovePosition {
  Above = 'ABOVE',
  Below = 'BELOW'
}

export type Core_Qualifiers = {
  __typename?: 'Core_Qualifiers';
  exhibitorMemberEventProfile?: Maybe<Core_EventPerson>;
  fieldWithReplies: Array<Core_FieldWithReplies>;
  isPrimaryQualification?: Maybe<Scalars['Boolean']>;
};

export enum Core_QualifyLeadsError {
  FeatureNotAllowed = 'FEATURE_NOT_ALLOWED',
  NotExhibitorMember = 'NOT_EXHIBITOR_MEMBER',
  UserNotInEvent = 'USER_NOT_IN_EVENT'
}

export type Core_RtmpLiveStreamVideo = {
  __typename?: 'Core_RTMPLiveStreamVideo';
  playback?: Maybe<Core_RtmpLiveStreamVideoPlayback>;
};

export type Core_RtmpLiveStreamVideoPlayback = {
  __typename?: 'Core_RTMPLiveStreamVideoPlayback';
  url: Scalars['String'];
};

export type Core_RtmpPlanningStream = Core_PlanningStreamInterface & {
  __typename?: 'Core_RTMPPlanningStream';
  availableAt?: Maybe<Scalars['Core_DateTime']>;
  endsAt?: Maybe<Scalars['Core_DateTime']>;
  id: Scalars['ID'];
  isLiveStream: Scalars['Boolean'];
  isPublic: Scalars['Boolean'];
  /** @deprecated use availableAt instead */
  startsAt: Scalars['Core_DateTime'];
  stream?: Maybe<Core_RtmpLiveStreamVideo>;
};


export type Core_RtmpPlanningStreamStartsAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export enum Core_RadiusEnum {
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
  Zero = 'zero'
}

export type Core_Recommendation = Core_EventPersonRecommendation | Core_ExhibitorRecommendation | Core_PlanningRecommendation | Core_ProductRecommendation;

export enum Core_RecommendationEntityEnum {
  Exhibitor = 'EXHIBITOR',
  People = 'PEOPLE',
  Product = 'PRODUCT',
  Session = 'SESSION'
}

export type Core_RecommendationExplanation = Core_EventPersonRecommendationExplanation | Core_EventRecommendationExplanation | Core_ExhibitorRecommendationExplanation | Core_PlanningRecommendationExplanation | Core_ProductRecommendationExplanation | Core_StringRecommendationExplanation;

export enum Core_RecommendationExplanationOriginEnum {
  Source = 'SOURCE',
  Target = 'TARGET'
}

export enum Core_RecommendationExplanationTypeEnum {
  /** @deprecated Renamed to BIOGRAPHY */
  Biographies = 'BIOGRAPHIES',
  Biography = 'BIOGRAPHY',
  BookExhibitor = 'BOOK_EXHIBITOR',
  BookPlanning = 'BOOK_PLANNING',
  BookProduct = 'BOOK_PRODUCT',
  Categories = 'CATEGORIES',
  Company = 'COMPANY',
  Description = 'DESCRIPTION',
  Events = 'EVENTS',
  Exhibitor = 'EXHIBITOR',
  Fields = 'FIELDS',
  Filters = 'FILTERS',
  /** @deprecated No longer supported */
  Industries = 'INDUSTRIES',
  Interest = 'INTEREST',
  Jobs = 'JOBS',
  Knowledge = 'KNOWLEDGE',
  /** @deprecated No longer supported */
  Language = 'LANGUAGE',
  Name = 'NAME',
  Network = 'NETWORK',
  Searches = 'SEARCHES',
  Streams = 'STREAMS',
  Tags = 'TAGS'
}

export type Core_RecommendedLead = {
  __typename?: 'Core_RecommendedLead';
  assignedTo?: Maybe<Core_EventPerson>;
  interactionScore: Scalars['Int'];
  lastActivity: Scalars['String'];
  lastActivityAt: Scalars['Core_DateTime'];
  profile: Core_EventPerson;
  requestSent: Scalars['Boolean'];
};

export enum Core_RecommendedLeadSortEnum {
  AssignedTo = 'ASSIGNED_TO',
  FullName = 'FULL_NAME',
  InteractionScore = 'INTERACTION_SCORE',
  LastActivityAt = 'LAST_ACTIVITY_AT',
  Organization = 'ORGANIZATION'
}

export type Core_RecommendedLeadsConnection = {
  __typename?: 'Core_RecommendedLeadsConnection';
  nodes: Array<Core_RecommendedLead>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_RecommendedLeadsFilterInput = {
  assignedToCommunityProfile?: InputMaybe<Array<Scalars['ID']>>;
  interactionScore?: InputMaybe<Array<Core_SimpleGaugeEnum>>;
  requestSent?: InputMaybe<Scalars['Boolean']>;
};

export type Core_RecommendedLeadsSortInput = {
  direction?: InputMaybe<Core_SortOrderEnum>;
  field: Core_RecommendedLeadSortEnum;
};

export type Core_Redirect = {
  __typename?: 'Core_Redirect';
  redirectTo: Core_RedirectEnum;
  resourceId?: Maybe<Scalars['String']>;
};

export enum Core_RedirectEnum {
  Exhibitor = 'EXHIBITOR'
}

export type Core_RedirectNoneAdvertisement = Core_AdvertisementInterface & {
  __typename?: 'Core_RedirectNoneAdvertisement';
  id: Scalars['ID'];
  /** @deprecated Use webImageUrl instead */
  imageUrl: Scalars['String'];
  mobileImageUrl: Scalars['String'];
  webImageUrl: Scalars['String'];
};

export type Core_RedirectUrlAdvertisement = Core_AdvertisementInterface & {
  __typename?: 'Core_RedirectUrlAdvertisement';
  id: Scalars['ID'];
  /** @deprecated Use webImageUrl instead */
  imageUrl: Scalars['String'];
  mobileImageUrl: Scalars['String'];
  redirectUrl: Scalars['String'];
  webImageUrl: Scalars['String'];
};

export enum Core_RedirectUrlOpenAsEnum {
  Iframe = 'IFRAME',
  NewTab = 'NEW_TAB'
}

export type Core_Refund = {
  __typename?: 'Core_Refund';
  amountCents: Scalars['Int'];
  createdAt: Scalars['Core_DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  paymentId: Scalars['ID'];
  refundedAt?: Maybe<Scalars['Core_DateTime']>;
  status: Core_RefundStatusEnum;
};

export enum Core_RefundStatusEnum {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  PartialRefund = 'PARTIAL_REFUND',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
  Unknown = 'UNKNOWN'
}

export type Core_Registration = {
  __typename?: 'Core_Registration';
  canceledAt?: Maybe<Scalars['Core_DateTime']>;
  confirmationCode: Scalars['String'];
  eventPerson: Core_EventPerson;
  id: Scalars['ID'];
  registeredAt: Scalars['Core_DateTime'];
  status: Core_RegistrationStatusEnum;
  ticketType: Core_TicketType;
};

export type Core_RegistrationFormTranslation = {
  __typename?: 'Core_RegistrationFormTranslation';
  language: Core_LanguageEnum;
  title?: Maybe<Scalars['String']>;
};

export enum Core_RegistrationFormTypeEnum {
  Registration = 'REGISTRATION'
}

export type Core_RegistrationSettings = {
  __typename?: 'Core_RegistrationSettings';
  type?: Maybe<Core_RegistrationSettingsEnum>;
  url?: Maybe<Scalars['String']>;
};

export enum Core_RegistrationSettingsEnum {
  External = 'EXTERNAL',
  InAppSignup = 'IN_APP_SIGNUP',
  Swapcard = 'SWAPCARD'
}

export enum Core_RegistrationStatusEnum {
  Canceled = 'CANCELED',
  Registered = 'REGISTERED'
}

export enum Core_RegularFieldTypeEnum {
  Address = 'ADDRESS',
  Biography = 'BIOGRAPHY',
  Company = 'COMPANY',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  JobTitle = 'JOB_TITLE',
  Landline = 'LANDLINE',
  LastName = 'LAST_NAME',
  Phone = 'PHONE',
  Picture = 'PICTURE',
  Text = 'TEXT',
  Website = 'WEBSITE'
}

export type Core_RemoveMeetingParticipantsInput = {
  meetingId: Scalars['ID'];
  /** List of MeetingParticipant IDs to remove. */
  participantIds: Array<Scalars['ID']>;
};

export type Core_RemoveMeetingParticipantsPayload = {
  __typename?: 'Core_RemoveMeetingParticipantsPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  meeting?: Maybe<Core_Meeting>;
  removedParticipantIds?: Maybe<Array<Scalars['ID']>>;
};

export type Core_RepliesByConnection = {
  __typename?: 'Core_RepliesByConnection';
  connectionId: Scalars['ID'];
  isPrimaryQualification: Scalars['Boolean'];
  replies: Array<Core_FormReplyValue>;
};

export type Core_ReplyFormFieldInput = {
  fieldId: Scalars['ID'];
  reply: Scalars['String'];
};

export type Core_Request = Core_ConnectionRequestReceived | Core_ConnectionRequestSent | Core_MeetingRequestReceived | Core_MeetingRequestSent;

/** Represent a single filter for requests. Each field of the input adds a new "AND" condition. */
export type Core_RequestFilterInput = {
  /** Filters requests with createdAt after this date */
  createdAfter?: InputMaybe<Scalars['Core_DateTime']>;
  /** Filters requests seen or unseen */
  isSeen?: InputMaybe<Scalars['Boolean']>;
  /** Filters activities made within these communities */
  shouldCommunityIdIn?: InputMaybe<Array<Scalars['ID']>>;
  /** Filters requests made during one or more events */
  shouldEventIdIn?: InputMaybe<Array<Scalars['ID']>>;
  /** Filters requests matching **at least one** status among these ones. */
  shouldRequestStatusIn?: InputMaybe<Array<Core_RequestStatus>>;
  /** Filters requests matching **at least one** type among these ones. */
  shouldRequestTypeIn?: InputMaybe<Array<Core_RequestType>>;
};

export type Core_RequestInterface = {
  community?: Maybe<Core_Community>;
  event?: Maybe<Core_Event>;
  /** Same as user, but in the context of the community/event related to the request. */
  eventPerson?: Maybe<Core_EventPerson>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  repliedAt?: Maybe<Scalars['Core_DateTime']>;
  seen: Scalars['Boolean'];
  sentAt: Scalars['Core_DateTime'];
  status: Core_RequestStatus;
  /**
   * The requester or recipient of the request.
   * If the current user is the recipient, the user will be the requester
   * otherwise it will be the recipient.
   */
  user: Core_PublicUser;
};


export type Core_RequestInterfaceRepliedAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_RequestInterfaceSentAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_RequestMessageSuggestionsInput = {
  /** The Event id (mandatory unless it's a connection request at community level). */
  eventId?: InputMaybe<Scalars['ID']>;
  /** The Exhibitor id (only needed on EXHIBITOR_MEETING, can be ignored on MULTI_PARTICIPANT_MEETING). */
  exhibitorId?: InputMaybe<Scalars['ID']>;
  /** The community/event profile id of the possible recipients. */
  recipientsProfileIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * The request type of the messages.
   * INDIVIDUAL_CONNECTION: Connection with a person
   * INDIVIDUAL_MEETING: Meeting with a person
   * EXHIBITOR_MEETING: Meeting with an unassigned exhibitor
   * MULTI_PARTICIPANT_MEETING: Meeting with multiple recipients
   */
  requestType: Core_MessageSuggestionType;
};

export type Core_RequestReceived = Core_ConnectionRequestReceived | Core_MeetingRequestReceived;

export type Core_RequestSent = Core_ConnectionRequestSent | Core_MeetingRequestSent;

export enum Core_RequestStatus {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export enum Core_RequestType {
  ConnectionRequest = 'CONNECTION_REQUEST',
  MeetingRequest = 'MEETING_REQUEST'
}

export type Core_RequestsConnection = {
  __typename?: 'Core_RequestsConnection';
  nodes: Array<Core_Request>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_RescheduleMeetingInput = {
  description?: InputMaybe<Scalars['String']>;
  meetingId: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  placeId: Scalars['ID'];
  slotId: Scalars['ID'];
};

export type Core_RescheduleMeetingPayload = {
  __typename?: 'Core_RescheduleMeetingPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  meeting?: Maybe<Core_Meeting>;
};

export enum Core_ResourceAvailabilityReasonEnum {
  /** The result of the resource is an empty list */
  EmptyList = 'EMPTY_LIST',
  /** The current user is not allowed to query the resource */
  NotAllowed = 'NOT_ALLOWED'
}

export type Core_ResourceAvailable = {
  __typename?: 'Core_ResourceAvailable';
  available: Scalars['Boolean'];
  reason?: Maybe<Core_ResourceAvailabilityReasonEnum>;
};

export enum Core_RightFilterConditionEnum {
  And = 'AND',
  Not = 'NOT',
  Or = 'OR'
}

export type Core_Role = {
  __typename?: 'Core_Role';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
  permissions: Array<Core_Permission>;
  type: Core_RolePermissionTypeEnum;
};

export enum Core_RolePermissionTypeEnum {
  Exhibitor = 'EXHIBITOR'
}

export type Core_RootProductCategory = {
  __typename?: 'Core_RootProductCategory';
  children: Array<Core_ProductCategory>;
};

export type Core_RoundtableAwareEntity = Core_Meeting | Core_Planning;

export type Core_RoundtableAwareInterface = {
  roundtable?: Maybe<Core_RoundtableComponent>;
};

export type Core_RoundtableComponent = {
  __typename?: 'Core_RoundtableComponent';
  /** If set to true, only audio streams will be allowed for the roundtable */
  audioOnly: Scalars['Boolean'];
  /** If present, normal users can join the roundtable only after this date */
  availableAt?: Maybe<Scalars['Core_DateTime']>;
  /** If specified, normal users can join the roundtable only before this date. */
  availableUntil?: Maybe<Scalars['Core_DateTime']>;
  /**
   * True for plannings if
   * - user can register to this planning
   * - the roundtable is ongoing/started, if dates are specified (except speakers)
   * - the maxParticipants have not been reached yet
   * True for meetings if
   * - user is meeting participant or member of the exhibitor participant.
   * Event admins can always join.
   */
  canJoin?: Maybe<Scalars['Boolean']>;
  /**
   * true if any of
   * - user is speaker/requester
   * - user is part of organization members
   */
  canModerate?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  maxParticipants: Scalars['Int'];
  /** If set to true, moderators will decide who can turn on their camera/mic */
  moderatedStage: Scalars['Boolean'];
  /** Returns the ongoing recording, if any */
  ongoingRecording?: Maybe<Core_RoundtableRecording>;
  participants?: Maybe<Core_RoundtableParticipantsConnection>;
  videoBackgroundImageUrl?: Maybe<Scalars['String']>;
};


export type Core_RoundtableComponentParticipantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  isModerator?: InputMaybe<Scalars['Boolean']>;
};

export type Core_RoundtableParticipant = {
  __typename?: 'Core_RoundtableParticipant';
  id: Scalars['ID'];
  /**
   * moderators get the "moderator" vonage token and have the right to moderate
   * e.g. record roundtable, mute others or add/remove people from the stage in a moderated roundtable
   */
  isModerator: Scalars['Boolean'];
  /** If a participant is on stage, they can enable their audio or video. */
  onStage: Scalars['Boolean'];
  person?: Maybe<Core_EventPerson>;
  /** True when a participant has raised their hand to request going on stage. */
  raisedHand: Scalars['Boolean'];
};

export type Core_RoundtableParticipantsConnection = {
  __typename?: 'Core_RoundtableParticipantsConnection';
  nodes?: Maybe<Array<Core_RoundtableParticipant>>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_RoundtableRecording = {
  __typename?: 'Core_RoundtableRecording';
  id: Scalars['ID'];
  publicUrl?: Maybe<Scalars['String']>;
  startedAt: Scalars['Core_DateTime'];
  status: Scalars['String'];
};

export type Core_RoundtableRoomData = Core_VonageRoundtableRoomData;

export type Core_ScanCodeConnectionContact = {
  __typename?: 'Core_ScanCodeConnectionContact';
  connectionContact: Core_ConnectionContact;
  /** Whether the scan created a new connection. */
  isNewConnection: Scalars['Boolean'];
};

export enum Core_ScanCodeError {
  CodeNotFound = 'CODE_NOT_FOUND',
  FeatureNotAllowed = 'FEATURE_NOT_ALLOWED',
  UserNotInEvent = 'USER_NOT_IN_EVENT'
}

export type Core_ScanCodeEventPerson = {
  __typename?: 'Core_ScanCodeEventPerson';
  connectionInfo: Core_ConnectionInfo;
  /** Whether the scan created a new connection. */
  isNewConnection: Scalars['Boolean'];
  person: Core_EventPerson;
};

export type Core_ScanCodeFailure = {
  __typename?: 'Core_ScanCodeFailure';
  errorCode: Core_ScanCodeError;
  errorRedirectUrl?: Maybe<Scalars['String']>;
};

export type Core_ScanCodeMe = {
  __typename?: 'Core_ScanCodeMe';
  me: Core_SelfUser;
};

export type Core_ScanCodeResult = Core_ScanCodeConnectionContact | Core_ScanCodeEventPerson | Core_ScanCodeFailure | Core_ScanCodeMe | Core_ScanCodeUser;

export type Core_ScanCodeUser = {
  __typename?: 'Core_ScanCodeUser';
  connectionInfo: Core_ConnectionInfo;
  /** Whether the scan created a new connection. */
  isNewConnection: Scalars['Boolean'];
  user: Core_PublicUser;
};

export type Core_SelectField = Core_FieldInterface & {
  __typename?: 'Core_SelectField';
  definition: Core_SelectFieldDefinition;
  /** @deprecated Use specialized field `definition.id` on type `FieldUnion` instead */
  id: Scalars['ID'];
  /** @deprecated Use specialized field `definition.isEditable` on type `FieldUnion` instead */
  isEditable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isFilterable` on type `FieldUnion` instead */
  isFilterable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isVisible` on type `FieldUnion` instead */
  isVisible: Scalars['Boolean'];
  /** @deprecated Use field `definition.maxChoices` on type `SelectField` instead */
  maxChoices?: Maybe<Scalars['Int']>;
  /** @deprecated Use specialized field `definition.name` on type `FieldUnion` instead */
  name: Scalars['String'];
  /** @deprecated Use specialized field `definition.placeholder` on type `FieldUnion` instead */
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated Use specialized field `definition.section` on type `FieldUnion` instead */
  section?: Maybe<Core_FieldDefinitionSection>;
  /** @deprecated Use field `definition.selectOptions` on type `SelectField` instead */
  selectOptions: Array<Core_SelectOptionsValue>;
  value?: Maybe<Core_SelectFieldValue>;
};

export type Core_SelectFieldDefinition = Core_FieldDefinitionInterface & {
  __typename?: 'Core_SelectFieldDefinition';
  id: Scalars['ID'];
  isEditable: Scalars['Boolean'];
  /** @deprecated No longer supported */
  isFilterable: Scalars['Boolean'];
  /** Do not use, always true */
  isVisible: Scalars['Boolean'];
  name: Scalars['String'];
  /** @deprecated use field `translations` instead */
  nameTranslations: Array<Core_TranslationString>;
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated use field `translations` instead */
  placeholderTranslations: Array<Core_TranslationString>;
  section?: Maybe<Core_FieldDefinitionSection>;
  selectOptions: Array<Core_SelectOptionsValue>;
  translations: Array<Core_FieldDefinitionTranslation>;
};

export type Core_SelectFieldValue = {
  __typename?: 'Core_SelectFieldValue';
  id: Scalars['ID'];
  text: Scalars['String'];
  value: Scalars['String'];
};

export type Core_SelectHostedMeetingConditionCandidateInput = {
  eventProfileId: Scalars['ID'];
  selection?: InputMaybe<Core_HostedMeetingCandidateSelectionEnum>;
  viewId: Scalars['ID'];
};

export type Core_SelectHostedMeetingConditionCandidatePayload = {
  __typename?: 'Core_SelectHostedMeetingConditionCandidatePayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  eventProfile?: Maybe<Core_EventPerson>;
};

export type Core_SelectOptionsValue = {
  __typename?: 'Core_SelectOptionsValue';
  text: Scalars['String'];
  translations: Array<Core_TranslationString>;
  value: Scalars['String'];
};

export type Core_SelfSpeakerUser = Core_PersonInterface & Core_PublicPersonInterface & Core_PublicUserInterface & Core_SpeakerInterface & Core_UserInterface & {
  __typename?: 'Core_SelfSpeakerUser';
  _id: Scalars['ID'];
  addresses?: Maybe<Array<Maybe<Core_Address>>>;
  biography?: Maybe<Scalars['String']>;
  canViewConnections?: Maybe<Scalars['Boolean']>;
  commonConnections?: Maybe<Core_EdgeListConnectionUnion>;
  /** @deprecated No longer supported */
  company?: Maybe<Core_Company>;
  email?: Maybe<Scalars['String']>;
  exhibitorList?: Maybe<Array<Maybe<Core_Exhibitor>>>;
  firstName?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  interests?: Maybe<Array<Maybe<Scalars['String']>>>;
  invitationUrl: Scalars['String'];
  /** @deprecated No longer supported */
  isOrganizationVerified?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  isUserResourceAvailable: Core_ResourceAvailable;
  jobTitle?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  language: Core_LanguageEnum;
  lastName?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  lookingForTags: Array<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  pendingRequests: Array<Core_Request>;
  /** @deprecated Use the field userInfo instead */
  personType?: Maybe<Core_PersonTypeEnum>;
  phoneNumbers?: Maybe<Array<Maybe<Core_PhoneNumber>>>;
  photoUrl?: Maybe<Scalars['String']>;
  planningList?: Maybe<Array<Maybe<Core_Planning>>>;
  preferences: Core_UserPreferences;
  primaryEmail?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  secondJobTitle?: Maybe<Scalars['String']>;
  socialNetworks?: Maybe<Array<Maybe<Core_SocialNetwork>>>;
  type?: Maybe<Scalars['String']>;
  typeOrder?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Core_DateTime']>;
  updatedAtTs?: Maybe<Scalars['Core_Timestamp']>;
  useMaskLogic: Scalars['Boolean'];
  userId?: Maybe<Scalars['ID']>;
  userInfo: Core_UserInfo;
  /** @deprecated Use the field userInfo instead */
  userStatus?: Maybe<Core_UserStatusEnum>;
  vcardUrl: Scalars['String'];
  websiteUrl?: Maybe<Scalars['String']>;
};


export type Core_SelfSpeakerUserCommonConnectionsArgs = {
  _userId?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Core_SortInput>>>;
};


export type Core_SelfSpeakerUserIsUserResourceAvailableArgs = {
  resource: Core_UserResourceEnum;
};


export type Core_SelfSpeakerUserLogoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};


export type Core_SelfSpeakerUserPhoneNumbersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Core_PhoneNumberEnum>;
};


export type Core_SelfSpeakerUserPhotoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};

export type Core_SelfUser = Core_PersonInterface & Core_PublicPersonInterface & Core_PublicUserInterface & Core_TeamMemberInterface & Core_UserInterface & {
  __typename?: 'Core_SelfUser';
  _id: Scalars['ID'];
  addresses?: Maybe<Array<Maybe<Core_Address>>>;
  biography?: Maybe<Scalars['String']>;
  canViewConnections?: Maybe<Scalars['Boolean']>;
  commonConnections?: Maybe<Core_EdgeListConnectionUnion>;
  /** @deprecated No longer supported */
  company?: Maybe<Core_Company>;
  email?: Maybe<Scalars['String']>;
  exhibitorList?: Maybe<Array<Maybe<Core_Exhibitor>>>;
  firstName?: Maybe<Scalars['String']>;
  identityHash: Scalars['String'];
  /** @deprecated No longer supported */
  interests?: Maybe<Array<Maybe<Scalars['String']>>>;
  invitationUrl: Scalars['String'];
  /** @deprecated No longer supported */
  isOrganizationVerified?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  isUserResourceAvailable: Core_ResourceAvailable;
  jobTitle?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  language: Core_LanguageEnum;
  lastName?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  lookingForTags: Array<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  pendingRequests: Array<Core_Request>;
  /** @deprecated Use the field userInfo instead */
  personType?: Maybe<Core_PersonTypeEnum>;
  phoneNumbers?: Maybe<Array<Maybe<Core_PhoneNumber>>>;
  photoUrl?: Maybe<Scalars['String']>;
  preferences: Core_UserPreferences;
  primaryEmail?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  secondJobTitle?: Maybe<Scalars['String']>;
  socialNetworks?: Maybe<Array<Maybe<Core_SocialNetwork>>>;
  teamOptions?: Maybe<Core_TeamOptions>;
  termsAgreedOn?: Maybe<Scalars['Core_DateTime']>;
  updatedAt?: Maybe<Scalars['Core_DateTime']>;
  updatedAtTs?: Maybe<Scalars['Core_Timestamp']>;
  useMaskLogic: Scalars['Boolean'];
  userInfo: Core_UserInfo;
  /** @deprecated Use the field userInfo instead */
  userStatus?: Maybe<Core_UserStatusEnum>;
  vcardUrl: Scalars['String'];
  websiteUrl?: Maybe<Scalars['String']>;
};


export type Core_SelfUserCommonConnectionsArgs = {
  _userId?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Core_SortInput>>>;
};


export type Core_SelfUserIdentityHashArgs = {
  platform?: InputMaybe<Core_IdentityHashPlatformEnum>;
};


export type Core_SelfUserIsUserResourceAvailableArgs = {
  resource: Core_UserResourceEnum;
};


export type Core_SelfUserLogoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};


export type Core_SelfUserPhoneNumbersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Core_PhoneNumberEnum>;
};


export type Core_SelfUserPhotoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};


export type Core_SelfUserUpdatedAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_SendConnectionRequestInput = {
  /** The community where the connection request is made. */
  communityId?: InputMaybe<Scalars['ID']>;
  /** The event where the connection request is made. */
  eventId?: InputMaybe<Scalars['ID']>;
  /**
   * The matching score of the user if the connection request is sent
   * in the context of the matching feature.
   */
  matchingScore?: InputMaybe<Scalars['Float']>;
  /** A message to send to the user. */
  message?: InputMaybe<Scalars['String']>;
  /** The recipient user of the connection request. */
  userId: Scalars['ID'];
};

export type Core_SendContinueExistingOrderEmailInput = {
  email: Scalars['String'];
  eventId: Scalars['ID'];
};

export type Core_SendContinueExistingOrderEmailPayload = {
  __typename?: 'Core_SendContinueExistingOrderEmailPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  sent: Scalars['Boolean'];
};

export type Core_SendExhibitorMeetingRequestV2Input = {
  exhibitorId: Scalars['ID'];
  meetingId: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  placeId: Scalars['ID'];
};

export type Core_SendFeedbackOnMeetingInput = {
  /** Deprecated: "use markMeetingAsNotHeld mutation instead" */
  didHappen?: InputMaybe<Scalars['Boolean']>;
  /** Id of the meeting */
  meetingId: Scalars['ID'];
  rating?: InputMaybe<Scalars['Float']>;
};

export type Core_SendFeedbackOnMeetingPayload = {
  __typename?: 'Core_SendFeedbackOnMeetingPayload';
  meeting: Core_Meeting;
};

export type Core_SendMeetingRequestV2Input = {
  /** The meeting slot to request. */
  meetingId: Scalars['ID'];
  /** An optional message to send to the user. */
  message?: InputMaybe<Scalars['String']>;
  /** The place of the meeting. */
  place: Core_MeetingPlaceInput;
  /** The recipient user of the meeting request. */
  userId: Scalars['ID'];
};

export type Core_SetUserTermsAgreementInput = {
  hasAgreed: Scalars['Boolean'];
};

export type Core_SetUserTermsAgreementPayload = {
  __typename?: 'Core_SetUserTermsAgreementPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  user?: Maybe<Core_SelfUser>;
};

export type Core_SharedConnectionsFilter = {
  exhibitorMemberIds?: InputMaybe<Array<Scalars['ID']>>;
  tags?: InputMaybe<Array<Scalars['ID']>>;
};

export enum Core_SimpleGaugeEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type Core_SliceInput = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type Core_SocialNetwork = {
  __typename?: 'Core_SocialNetwork';
  profile?: Maybe<Scalars['String']>;
  type?: Maybe<Core_SocialNetworkEnum>;
};

export enum Core_SocialNetworkEnum {
  Dribbble = 'DRIBBBLE',
  Facebook = 'FACEBOOK',
  Flickr = 'FLICKR',
  Foursquare = 'FOURSQUARE',
  Github = 'GITHUB',
  Googleplus = 'GOOGLEPLUS',
  Instagram = 'INSTAGRAM',
  Linkedin = 'LINKEDIN',
  Pinterest = 'PINTEREST',
  Skype = 'SKYPE',
  Soundcloud = 'SOUNDCLOUD',
  Tumblr = 'TUMBLR',
  Twitter = 'TWITTER',
  /** @deprecated No longer supported */
  Viadeo = 'VIADEO',
  Vimeo = 'VIMEO',
  /** @deprecated No longer supported */
  Vine = 'VINE',
  Youtube = 'YOUTUBE'
}

export type Core_SocialNetworkInput = {
  profile?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Core_SocialNetworkEnum>;
};

export type Core_SortExhibitorProductsInput = {
  eventId?: InputMaybe<Scalars['ID']>;
  exhibitorId: Scalars['ID'];
  productIds: Array<InputMaybe<Scalars['ID']>>;
};

export type Core_SortExhibitorProductsPayload = {
  __typename?: 'Core_SortExhibitorProductsPayload';
  errors?: Maybe<Array<Maybe<Core_PayloadError>>>;
  products: Array<Maybe<Core_Product>>;
};

export type Core_SortInput = {
  field: Core_ConnectionSortEnum;
  order?: InputMaybe<Core_SortOrderEnum>;
};

export enum Core_SortOrderEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Core_SpeakerContact = Core_ContactInterface & Core_PersonInterface & Core_PublicPersonInterface & Core_SpeakerInterface & {
  __typename?: 'Core_SpeakerContact';
  _id: Scalars['ID'];
  addresses?: Maybe<Array<Maybe<Core_Address>>>;
  biography?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  company?: Maybe<Core_Company>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  interests?: Maybe<Array<Maybe<Scalars['String']>>>;
  jobTitle?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastName?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  /** @deprecated Use the field userInfo instead */
  personType?: Maybe<Core_PersonTypeEnum>;
  phoneNumbers?: Maybe<Array<Maybe<Core_PhoneNumber>>>;
  photoUrl?: Maybe<Scalars['String']>;
  planningList?: Maybe<Array<Maybe<Core_Planning>>>;
  /** @deprecated No longer supported */
  secondJobTitle?: Maybe<Scalars['String']>;
  socialNetworks?: Maybe<Array<Maybe<Core_SocialNetwork>>>;
  type?: Maybe<Scalars['String']>;
  typeOrder?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['ID']>;
  userInfo: Core_UserInfo;
  /** @deprecated Use the field userInfo instead */
  userStatus?: Maybe<Core_UserStatusEnum>;
  websiteUrl?: Maybe<Scalars['String']>;
};


export type Core_SpeakerContactLogoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};


export type Core_SpeakerContactPhoneNumbersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Core_PhoneNumberEnum>;
};


export type Core_SpeakerContactPhotoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};

export type Core_SpeakerInterface = {
  _id: Scalars['ID'];
  planningList?: Maybe<Array<Maybe<Core_Planning>>>;
  socialNetworks?: Maybe<Array<Maybe<Core_SocialNetwork>>>;
  type?: Maybe<Scalars['String']>;
  typeOrder?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['ID']>;
};

export type Core_SpeakerUnion = Core_ConnectionSpeakerUser | Core_PublicSpeakerUser | Core_SelfSpeakerUser | Core_SpeakerContact;

export type Core_Sponsor = Core_SponsorInterface & {
  __typename?: 'Core_Sponsor';
  _id?: Maybe<Scalars['ID']>;
  category: Core_LabelString;
  externalUrl?: Maybe<Scalars['String']>;
  logoUrl: Scalars['String'];
  mode: Core_SponsorModeEnum;
  name: Scalars['String'];
  type: Core_SponsorTypeEnum;
};

export type Core_SponsorCategory = {
  __typename?: 'Core_SponsorCategory';
  color?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  sponsors: Array<Maybe<Core_SponsorUnion>>;
};

export type Core_SponsorExhibitor = Core_SponsorInterface & {
  __typename?: 'Core_SponsorExhibitor';
  _id?: Maybe<Scalars['ID']>;
  category: Core_LabelString;
  logoUrl: Scalars['String'];
  mode: Core_SponsorModeEnum;
  name: Scalars['String'];
  redirect?: Maybe<Core_Redirect>;
  type: Core_SponsorTypeEnum;
};

export type Core_SponsorInterface = {
  _id?: Maybe<Scalars['ID']>;
  category: Core_LabelString;
  logoUrl: Scalars['String'];
  mode: Core_SponsorModeEnum;
  name: Scalars['String'];
  type: Core_SponsorTypeEnum;
};

export enum Core_SponsorModeEnum {
  FullWidth = 'FULL_WIDTH',
  Normal = 'NORMAL'
}

export enum Core_SponsorTypeEnum {
  Sponsor = 'SPONSOR',
  SponsorExhibitor = 'SPONSOR_EXHIBITOR'
}

export type Core_SponsorUnion = Core_Sponsor | Core_SponsorExhibitor;

export type Core_StartRecordingRoundtableInput = {
  /** Id of the entity that contains the roundtable */
  entityId: Scalars['ID'];
};

export type Core_StartRecordingRoundtablePayload = {
  __typename?: 'Core_StartRecordingRoundtablePayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  recording?: Maybe<Core_RoundtableRecording>;
};

export type Core_StopRecordingRoundtableInput = {
  /** Id of the entity that contains the roundtable */
  entityId: Scalars['ID'];
};

export type Core_StopRecordingRoundtablePayload = {
  __typename?: 'Core_StopRecordingRoundtablePayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  recording?: Maybe<Core_RoundtableRecording>;
};

export type Core_StringRecommendationExplanation = {
  __typename?: 'Core_StringRecommendationExplanation';
  origin: Core_RecommendationExplanationOriginEnum;
  type: Core_RecommendationExplanationTypeEnum;
  values?: Maybe<Array<Scalars['String']>>;
};

export type Core_StripeFreeOrder = {
  __typename?: 'Core_StripeFreeOrder';
  type: Scalars['String'];
};

export type Core_StripeOrderPaymentIntent = {
  __typename?: 'Core_StripeOrderPaymentIntent';
  stripeIntentId: Scalars['String'];
  stripeIntentSecret: Scalars['String'];
};

export type Core_StripePaymentProvider = {
  __typename?: 'Core_StripePaymentProvider';
  stripeAccountId: Scalars['String'];
  stripePublishableKey: Scalars['String'];
  type: Scalars['String'];
};

export type Core_SupportTimeSlot = {
  __typename?: 'Core_SupportTimeSlot';
  createdAt: Scalars['Core_DateTime'];
  endDate: Scalars['Core_DateTime'];
  eventId: Scalars['ID'];
  id: Scalars['ID'];
  isOnline: Scalars['Boolean'];
  startDate: Scalars['Core_DateTime'];
  updatedAt: Scalars['Core_DateTime'];
};


export type Core_SupportTimeSlotEndDateArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_SupportTimeSlotStartDateArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_Tag = {
  __typename?: 'Core_Tag';
  _id: Scalars['ID'];
  /** @deprecated CRM synchronization is not handled by Tag anymore */
  crmName?: Maybe<Scalars['String']>;
  type: Core_TagTypeEnum;
  value: Scalars['String'];
};

export type Core_TagInput = {
  type: Core_TagTypeEnum;
  value: Scalars['String'];
};

export enum Core_TagTypeEnum {
  /** @deprecated CRM synchronization is not handled by Tag anymore */
  Crm = 'CRM',
  Team = 'TEAM',
  User = 'USER'
}

export type Core_Team = {
  __typename?: 'Core_Team';
  _id: Scalars['ID'];
  createdAt?: Maybe<Scalars['Core_DateTime']>;
  createdAtTs?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Core_UserUnion>;
  exhibitor?: Maybe<Core_Exhibitor>;
  name?: Maybe<Scalars['String']>;
  selfOptions?: Maybe<Core_TeamOptions>;
  selfRole: Core_TeamRoleEnum;
  updatedAt?: Maybe<Scalars['Core_DateTime']>;
  updatedAtTs?: Maybe<Scalars['Int']>;
};

export type Core_TeamConnectedMember = {
  __typename?: 'Core_TeamConnectedMember';
  connectedAt: Scalars['Core_DateTime'];
  connectionInfo: Core_ConnectionInfo;
  profile: Core_EventPerson;
};

export type Core_TeamConnection = {
  __typename?: 'Core_TeamConnection';
  assignedTo?: Maybe<Core_EventPerson>;
  connectedWith?: Maybe<Array<Maybe<Core_TeamConnectedMember>>>;
  contact?: Maybe<Core_ConnectionContact>;
  interactionScore?: Maybe<Scalars['Int']>;
  profile?: Maybe<Core_EventPerson>;
  qualified: Scalars['Boolean'];
};

export enum Core_TeamConnectionSortEnum {
  AssignedTo = 'ASSIGNED_TO',
  ConnectedAt = 'CONNECTED_AT',
  FullName = 'FULL_NAME',
  InteractionScore = 'INTERACTION_SCORE',
  Organization = 'ORGANIZATION'
}

export type Core_TeamConnectionsConnection = {
  __typename?: 'Core_TeamConnectionsConnection';
  nodes: Array<Core_TeamConnection>;
  pageInfo: Core_PageInfo;
  totalCount: Scalars['Int'];
};

export type Core_TeamConnectionsFilterInput = {
  assignedToCommunityProfile?: InputMaybe<Array<Scalars['ID']>>;
  interactionScore?: InputMaybe<Array<Core_SimpleGaugeEnum>>;
  isQualified?: InputMaybe<Scalars['Boolean']>;
  onlyConnectedInThisEvent?: InputMaybe<Scalars['Boolean']>;
  onlyConnectedWithMe?: InputMaybe<Scalars['Boolean']>;
};

export type Core_TeamConnectionsSortInput = {
  direction?: InputMaybe<Core_SortOrderEnum>;
  field: Core_TeamConnectionSortEnum;
};

export type Core_TeamMemberInterface = {
  teamOptions?: Maybe<Core_TeamOptions>;
};

export type Core_TeamOptions = {
  __typename?: 'Core_TeamOptions';
  shareConnections: Scalars['Boolean'];
  /** @deprecated Not used anymore */
  showOnBoarding: Scalars['Boolean'];
};

export enum Core_TeamRoleEnum {
  Admin = 'ADMIN',
  Anonymous = 'ANONYMOUS',
  Member = 'MEMBER'
}

export type Core_TextField = Core_FieldInterface & {
  __typename?: 'Core_TextField';
  definition: Core_TextFieldDefinition;
  /** @deprecated Use specialized field `definition.id` on type `FieldUnion` instead */
  id: Scalars['ID'];
  /** @deprecated Use specialized field `definition.isEditable` on type `FieldUnion` instead */
  isEditable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isFilterable` on type `FieldUnion` instead */
  isFilterable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isVisible` on type `FieldUnion` instead */
  isVisible: Scalars['Boolean'];
  /** @deprecated Use field `definition.maxCharacters` on type `TextField` instead */
  maxCharacters?: Maybe<Scalars['Int']>;
  /** @deprecated Use specialized field `definition.name` on type `FieldUnion` instead */
  name: Scalars['String'];
  /** @deprecated Use specialized field `definition.placeholder` on type `FieldUnion` instead */
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated Use specialized field `definition.section` on type `FieldUnion` instead */
  section?: Maybe<Core_FieldDefinitionSection>;
  translatedValues: Array<Core_TextFieldValue>;
  value?: Maybe<Core_TextFieldValue>;
};

export type Core_TextFieldDefinition = Core_FieldDefinitionInterface & {
  __typename?: 'Core_TextFieldDefinition';
  id: Scalars['ID'];
  isEditable: Scalars['Boolean'];
  /** @deprecated No longer supported */
  isFilterable: Scalars['Boolean'];
  /** Do not use, always true */
  isVisible: Scalars['Boolean'];
  maxCharacters?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** @deprecated use field `translations` instead */
  nameTranslations: Array<Core_TranslationString>;
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated use field `translations` instead */
  placeholderTranslations: Array<Core_TranslationString>;
  section?: Maybe<Core_FieldDefinitionSection>;
  translations: Array<Core_FieldDefinitionTranslation>;
};

export type Core_TextFieldValue = {
  __typename?: 'Core_TextFieldValue';
  id: Scalars['ID'];
  locale?: Maybe<Core_LanguageEnum>;
  text: Scalars['String'];
};

export type Core_Theme = {
  __typename?: 'Core_Theme';
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundImageUrl?: Maybe<Scalars['String']>;
  buttonsColor?: Maybe<Scalars['String']>;
  containerColor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mode?: Maybe<Core_ThemeModeEnum>;
  name?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  radius?: Maybe<Core_RadiusEnum>;
  secondaryColor?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
};

export type Core_ThemeLink = {
  __typename?: 'Core_ThemeLink';
  isDefault?: Maybe<Scalars['Boolean']>;
  theme?: Maybe<Core_Theme>;
};

export enum Core_ThemeModeEnum {
  Dark = 'DARK',
  Light = 'LIGHT'
}

export type Core_TicketType = {
  __typename?: 'Core_TicketType';
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Core_TicketTypeDiscount>;
  endsAt: Scalars['Core_DateTime'];
  eventGroup: Core_EventGroup;
  id: Scalars['ID'];
  isSoldOut: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
  name: Scalars['String'];
  priceCents?: Maybe<Scalars['Int']>;
  /** @deprecated Use priceCentsFormatted instead */
  priceCentsFormated?: Maybe<Scalars['String']>;
  priceCentsFormatted?: Maybe<Scalars['String']>;
  startsAt: Scalars['Core_DateTime'];
  translations?: Maybe<Array<Core_TicketTypeTranslation>>;
};

export type Core_TicketTypeDiscount = {
  __typename?: 'Core_TicketTypeDiscount';
  amountOffCents?: Maybe<Scalars['Int']>;
  amountOffCentsFormatted?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  discountedPriceCents: Scalars['Int'];
  discountedPriceCentsFormatted: Scalars['String'];
  percentageOff?: Maybe<Scalars['Float']>;
};

export type Core_TicketTypeFilterInput = {
  includeSoldOut?: InputMaybe<Scalars['Boolean']>;
  promotionCode?: InputMaybe<Scalars['String']>;
};

export type Core_TicketTypeTranslation = {
  __typename?: 'Core_TicketTypeTranslation';
  description?: Maybe<Scalars['String']>;
  language: Core_LanguageEnum;
  name?: Maybe<Scalars['String']>;
};

export enum Core_TimeStatusEnum {
  OnGoing = 'ON_GOING',
  Past = 'PAST',
  Upcoming = 'UPCOMING'
}

export type Core_TranslatedString = {
  __typename?: 'Core_TranslatedString';
  en?: Maybe<Scalars['String']>;
  es?: Maybe<Scalars['String']>;
  fr?: Maybe<Scalars['String']>;
};

export type Core_TranslationString = {
  __typename?: 'Core_TranslationString';
  language: Core_LanguageEnum;
  value: Scalars['String'];
};

export type Core_TranslationStringInput = {
  language: Core_LanguageEnum;
  value?: InputMaybe<Scalars['String']>;
};

export type Core_TreeField = Core_FieldInterface & {
  __typename?: 'Core_TreeField';
  definition: Core_TreeFieldDefinition;
  /** @deprecated Use specialized field `definition.id` on type `FieldUnion` instead */
  id: Scalars['ID'];
  /** @deprecated Use specialized field `definition.isEditable` on type `FieldUnion` instead */
  isEditable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isFilterable` on type `FieldUnion` instead */
  isFilterable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isVisible` on type `FieldUnion` instead */
  isVisible: Scalars['Boolean'];
  /** @deprecated Use field `definition.maxChoices` on type `TreeField` instead */
  maxChoices?: Maybe<Scalars['Int']>;
  /** @deprecated Use specialized field `definition.name` on type `FieldUnion` instead */
  name: Scalars['String'];
  /** @deprecated Use field `definition.options` on type `TreeField` instead */
  options?: Maybe<Array<Core_TreeFieldNode>>;
  /** @deprecated Use specialized field `definition.placeholder` on type `FieldUnion` instead */
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated Use specialized field `definition.section` on type `FieldUnion` instead */
  section?: Maybe<Core_FieldDefinitionSection>;
  values: Array<Core_TreeFieldValue>;
};

export type Core_TreeFieldDefinition = Core_FieldDefinitionInterface & {
  __typename?: 'Core_TreeFieldDefinition';
  id: Scalars['ID'];
  isEditable: Scalars['Boolean'];
  /** @deprecated No longer supported */
  isFilterable: Scalars['Boolean'];
  /** Do not use, always true */
  isVisible: Scalars['Boolean'];
  maxChoices?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** @deprecated use field `translations` instead */
  nameTranslations: Array<Core_TranslationString>;
  options?: Maybe<Array<Core_TreeFieldNode>>;
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated use field `translations` instead */
  placeholderTranslations: Array<Core_TranslationString>;
  section?: Maybe<Core_FieldDefinitionSection>;
  translations: Array<Core_FieldDefinitionTranslation>;
};

export type Core_TreeFieldNode = {
  __typename?: 'Core_TreeFieldNode';
  path: Array<Core_TreePathTranslationValue>;
  value: Scalars['String'];
};

export type Core_TreeFieldValue = {
  __typename?: 'Core_TreeFieldValue';
  id: Scalars['ID'];
  path: Array<Core_TreePathTranslationValue>;
  value: Scalars['String'];
};

export type Core_TreePathTranslationValue = {
  __typename?: 'Core_TreePathTranslationValue';
  text: Scalars['String'];
  value: Scalars['String'];
};

export type Core_UpdateConfigurationOptionsInput = {
  position?: InputMaybe<Scalars['Int']>;
  translations?: InputMaybe<Array<Core_TranslationStringInput>>;
  value: Scalars['String'];
};

export type Core_UpdateDocumentInput = {
  clientId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type Core_UpdateDraftOrderInput = {
  extendRemainingTime?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['String'];
  orderSecret: Scalars['String'];
  promoCode?: InputMaybe<Scalars['String']>;
  registrations?: InputMaybe<Array<Core_CreateRegistrationInput>>;
};

export type Core_UpdateDraftOrderPayload = {
  __typename?: 'Core_UpdateDraftOrderPayload';
  draftOrder?: Maybe<Core_DraftOrder>;
  errors?: Maybe<Array<Core_PayloadError>>;
};

export type Core_UpdateEventPersonInput = {
  address?: InputMaybe<Core_AddressInput>;
  biography?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Array<Core_CustomFieldUnionInput>>;
  email?: InputMaybe<Scalars['String']>;
  eventPersonId: Scalars['ID'];
  firstName?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mobilePhone?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Scalars['String']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  socialNetworks?: InputMaybe<Array<InputMaybe<Core_SocialNetworkInput>>>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type Core_UpdateEventPersonPayload = {
  __typename?: 'Core_UpdateEventPersonPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  eventPerson?: Maybe<Core_EventPerson>;
};

export type Core_UpdateEventUserSettingsInput = {
  eventId: Scalars['ID'];
  sendEmailActivitiesReminder?: InputMaybe<Scalars['Boolean']>;
  sendEmailMeetingsReminder?: InputMaybe<Scalars['Boolean']>;
  sendEmailRequestsReminder?: InputMaybe<Scalars['Boolean']>;
  sendOrganizerEmail?: InputMaybe<Scalars['Boolean']>;
};

export type Core_UpdateEventUserSettingsPayload = {
  __typename?: 'Core_UpdateEventUserSettingsPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  event?: Maybe<Core_Event>;
  eventUserSettings?: Maybe<Core_EventUserSettings>;
};

export type Core_UpdateExhibitorMeetingSlotsDisabledInput = {
  /** The event in which slots must be enabled or disabled. */
  eventId: Scalars['ID'];
  exhibitorId: Scalars['ID'];
  /**
   * If true, make the selected slots disabled.
   * If false, make the selected slots enabled.
   */
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  /** To update specific slots. */
  meetingSlotIds?: InputMaybe<Array<Scalars['ID']>>;
  /** To update a range of slots */
  meetingSlotRange?: InputMaybe<Core_DateRangeInput>;
};

export type Core_UpdateExhibitorMeetingSlotsDisabledPayload = {
  __typename?: 'Core_UpdateExhibitorMeetingSlotsDisabledPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  exhibitor?: Maybe<Core_Exhibitor>;
  updatedMeetingSlots?: Maybe<Array<Core_MeetingSlot>>;
};

export type Core_UpdateExhibitorMemberRolesInput = {
  eventId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  roleIds: Array<Scalars['ID']>;
};

export type Core_UpdateExhibitorMemberRolesPayload = {
  __typename?: 'Core_UpdateExhibitorMemberRolesPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  exhibitorMember?: Maybe<Core_ExhibitorMember>;
};

export type Core_UpdateFieldDefinitionConfigurationInput = {
  addSelectOptions?: InputMaybe<Array<Core_FieldDefinitionConfigurationSelectOptionInput>>;
  maxCharacters?: InputMaybe<Scalars['Int']>;
  maxChoices?: InputMaybe<Scalars['Int']>;
  removeSelectOptions?: InputMaybe<Array<Scalars['String']>>;
  updateSelectOptions?: InputMaybe<Array<Core_UpdateConfigurationOptionsInput>>;
};

export type Core_UpdateFieldDefinitionInput = {
  configuration?: InputMaybe<Core_UpdateFieldDefinitionConfigurationInput>;
  id: Scalars['ID'];
  index?: InputMaybe<Scalars['Int']>;
  isEditable?: InputMaybe<Scalars['Boolean']>;
  isFilterable?: InputMaybe<Scalars['Boolean']>;
  isSearchable?: InputMaybe<Scalars['Boolean']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  nameTranslations?: InputMaybe<Array<Core_TranslationStringInput>>;
  placeholder?: InputMaybe<Scalars['String']>;
  placeholderTranslations?: InputMaybe<Array<Core_TranslationStringInput>>;
  sectionId?: InputMaybe<Scalars['ID']>;
};

export type Core_UpdateFormFieldInput = {
  fieldDefinition: Core_UpdateFieldDefinitionInput;
};

export type Core_UpdateFormInput = {
  availableFrom?: InputMaybe<Scalars['Core_DateTime']>;
  availableUntil?: InputMaybe<Scalars['Core_DateTime']>;
  configuration?: InputMaybe<Core_FormConfigurationInput>;
  fields?: InputMaybe<Array<Core_UpdateFormFieldInput>>;
  formId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type Core_UpdateFormPayload = {
  __typename?: 'Core_UpdateFormPayload';
  form: Core_Form;
};

export type Core_UpdateHostMeetingInput = {
  isAvailable?: InputMaybe<Scalars['Boolean']>;
};

export type Core_UpdateHostMeetingsByEventInput = {
  isAvailable?: InputMaybe<Scalars['Boolean']>;
};

export type Core_UpdateMeetingInput = {
  description?: InputMaybe<Scalars['String']>;
  meetingId: Scalars['ID'];
};

export type Core_UpdateMeetingParticipationInput = {
  meetingParticipantId: Scalars['ID'];
  status: Core_MeetingParticipationStatus;
};

export type Core_UpdateMeetingParticipationPayload = {
  __typename?: 'Core_UpdateMeetingParticipationPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  meeting: Core_Meeting;
  /** The user participant */
  meetingParticipant: Core_MeetingParticipant;
};

export type Core_UpdateMeetingPayload = {
  __typename?: 'Core_UpdateMeetingPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  meeting?: Maybe<Core_Meeting>;
};

export type Core_UpdatePersonMeetingSlotsDisabledInput = {
  eventId: Scalars['ID'];
  /**
   * If true, disable slots matching the input filters.
   * If false, enable them
   */
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  /** By slot ids. */
  meetingSlotIds?: InputMaybe<Array<Scalars['ID']>>;
  /** By time range in UTC timezone */
  meetingSlotRange?: InputMaybe<Core_DateRangeInput>;
  /** EventPerson or User id if it's not the user from the context. */
  personId?: InputMaybe<Scalars['ID']>;
};

export type Core_UpdatePersonMeetingSlotsDisabledPayload = {
  __typename?: 'Core_UpdatePersonMeetingSlotsDisabledPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  person?: Maybe<Core_EventPersonWithEvent>;
  updatedMeetingSlots?: Maybe<Array<Core_MeetingSlot>>;
};

export type Core_UpdateProductInput = {
  categoryId?: InputMaybe<Scalars['ID']>;
  createFields?: InputMaybe<Array<Core_CreateFieldInput>>;
  createMedia?: InputMaybe<Array<Scalars['String']>>;
  deleteFields?: InputMaybe<Array<Scalars['ID']>>;
  deleteMedia?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  descriptionTranslations?: InputMaybe<Array<Core_TranslationStringInput>>;
  imageUrl?: InputMaybe<Scalars['String']>;
  moveMedia?: InputMaybe<Array<Core_MoveMediaInput>>;
  name?: InputMaybe<Scalars['String']>;
  nameTranslations?: InputMaybe<Array<Core_TranslationStringInput>>;
  withEvent?: InputMaybe<Array<Core_ProductWithEventInput>>;
};

export type Core_UpdateQualifierQuestionInput = {
  fieldDefinition: Core_UpdateFieldDefinitionInput;
  formId: Scalars['ID'];
  move?: InputMaybe<Core_QualifierQuestionMoveInput>;
};

export type Core_UpdateQualifierQuestionPayload = {
  __typename?: 'Core_UpdateQualifierQuestionPayload';
  form?: Maybe<Core_Form>;
};

export type Core_UpdateRoundtableParticipantOnStageInput = {
  onStage: Scalars['Boolean'];
  participantId: Scalars['ID'];
};

export type Core_UpdateRoundtableParticipantOnStagePayload = {
  __typename?: 'Core_UpdateRoundtableParticipantOnStagePayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  participant?: Maybe<Core_RoundtableParticipant>;
};

export type Core_UpdateRoundtableParticipantRaisedHandInput = {
  participantId: Scalars['ID'];
  raisedHand: Scalars['Boolean'];
};

export type Core_UpdateRoundtableParticipantRaisedHandPayload = {
  __typename?: 'Core_UpdateRoundtableParticipantRaisedHandPayload';
  errors?: Maybe<Array<Core_PayloadError>>;
  participant?: Maybe<Core_RoundtableParticipant>;
};

export type Core_UpdateUserSettingsInput = {
  communityId: Scalars['ID'];
  sendEmailActivitiesReminder?: InputMaybe<Scalars['Boolean']>;
  sendEmailMeetingsReminder?: InputMaybe<Scalars['Boolean']>;
  sendEmailRequestsReminder?: InputMaybe<Scalars['Boolean']>;
  sendOrganizerEmail?: InputMaybe<Scalars['Boolean']>;
};

export type Core_UpdateUserSettingsPayload = {
  __typename?: 'Core_UpdateUserSettingsPayload';
  community?: Maybe<Core_Community>;
  errors?: Maybe<Array<Core_PayloadError>>;
  userSettings?: Maybe<Core_UserSettings>;
};

export type Core_UpdateUserV2Input = {
  hidePresenceStatus?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Core_LanguageEnum>;
};

export type Core_UpdateUserV2Payload = {
  __typename?: 'Core_UpdateUserV2Payload';
  errors?: Maybe<Array<Core_PayloadError>>;
  user?: Maybe<Core_SelfUser>;
};

export type Core_UploadUrlFormField = {
  __typename?: 'Core_UploadUrlFormField';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type Core_UploadedFileEmbeddedVideo = {
  __typename?: 'Core_UploadedFileEmbeddedVideo';
  playback?: Maybe<Core_HlsPlayback>;
};

export type Core_UrlField = Core_FieldInterface & {
  __typename?: 'Core_UrlField';
  definition: Core_UrlFieldDefinition;
  /** @deprecated Use specialized field `definition.id` on type `FieldUnion` instead */
  id: Scalars['ID'];
  /** @deprecated Use specialized field `definition.isEditable` on type `FieldUnion` instead */
  isEditable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isFilterable` on type `FieldUnion` instead */
  isFilterable: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.isVisible` on type `FieldUnion` instead */
  isVisible: Scalars['Boolean'];
  /** @deprecated Use specialized field `definition.name` on type `FieldUnion` instead */
  name: Scalars['String'];
  /** @deprecated Use specialized field `definition.placeholder` on type `FieldUnion` instead */
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated Use specialized field `definition.section` on type `FieldUnion` instead */
  section?: Maybe<Core_FieldDefinitionSection>;
  translatedValues: Array<Core_UrlFieldValue>;
  value?: Maybe<Core_UrlFieldValue>;
};

export type Core_UrlFieldDefinition = Core_FieldDefinitionInterface & {
  __typename?: 'Core_UrlFieldDefinition';
  id: Scalars['ID'];
  isEditable: Scalars['Boolean'];
  /** @deprecated No longer supported */
  isFilterable: Scalars['Boolean'];
  /** Do not use, always true */
  isVisible: Scalars['Boolean'];
  name: Scalars['String'];
  /** @deprecated use field `translations` instead */
  nameTranslations: Array<Core_TranslationString>;
  placeholder?: Maybe<Scalars['String']>;
  /** @deprecated use field `translations` instead */
  placeholderTranslations: Array<Core_TranslationString>;
  section?: Maybe<Core_FieldDefinitionSection>;
  translations: Array<Core_FieldDefinitionTranslation>;
};

export type Core_UrlFieldValue = {
  __typename?: 'Core_UrlFieldValue';
  id: Scalars['ID'];
  locale?: Maybe<Core_LanguageEnum>;
  url: Scalars['String'];
};

/** Set of information about a user related to the user in context. */
export type Core_UserInfo = {
  __typename?: 'Core_UserInfo';
  /** @deprecated No longer supported */
  company?: Maybe<Core_Company>;
  eventsInCommon: Array<Core_Event>;
  hasReceivedRequest: Scalars['Boolean'];
  hasSentRequest: Scalars['Boolean'];
  id?: Maybe<Scalars['ID']>;
  isConnected: Scalars['Boolean'];
  isSelf: Scalars['Boolean'];
  isUser: Scalars['Boolean'];
  /** Pending requests with the user in the context. */
  pendingRequests: Array<Core_Request>;
  presenceStatus?: Maybe<Core_UserPresenceStatusEnum>;
};

export type Core_UserInput = {
  addresses?: InputMaybe<Array<InputMaybe<Core_AddressInput>>>;
  biography?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  interests?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  jobTitle?: InputMaybe<Scalars['String']>;
  /** Deprecated */
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Core_LanguageEnum>;
  lastName?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  /** Deprecated: use "lookingForTags" instead */
  lookingFor?: InputMaybe<Array<InputMaybe<Core_MatchingLabelInput>>>;
  lookingForTags?: InputMaybe<Array<Scalars['String']>>;
  organization?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<Core_PhoneNumberInput>>>;
  photoUrl?: InputMaybe<Scalars['String']>;
  preferences?: InputMaybe<Core_UserPreferencesInput>;
  /** Deprecated */
  secondJobTitle?: InputMaybe<Scalars['String']>;
  secondaryEmails?: InputMaybe<Array<Scalars['String']>>;
  socialNetworks?: InputMaybe<Array<InputMaybe<Core_SocialNetworkInput>>>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type Core_UserInterface = {
  _id: Scalars['ID'];
  biography?: Maybe<Scalars['String']>;
  canViewConnections?: Maybe<Scalars['Boolean']>;
  commonConnections?: Maybe<Core_EdgeListConnectionUnion>;
  /** @deprecated No longer supported */
  company?: Maybe<Core_Company>;
  exhibitorList?: Maybe<Array<Maybe<Core_Exhibitor>>>;
  firstName?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  interests?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** @deprecated No longer supported */
  isUserResourceAvailable: Core_ResourceAvailable;
  jobTitle?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastName?: Maybe<Scalars['String']>;
  lookingForTags: Array<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  pendingRequests: Array<Core_Request>;
  /** @deprecated Use the field userInfo instead */
  personType?: Maybe<Core_PersonTypeEnum>;
  photoUrl?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  secondJobTitle?: Maybe<Scalars['String']>;
  socialNetworks?: Maybe<Array<Maybe<Core_SocialNetwork>>>;
  userInfo: Core_UserInfo;
  /** @deprecated Use the field userInfo instead */
  userStatus?: Maybe<Core_UserStatusEnum>;
  vcardUrl: Scalars['String'];
};


export type Core_UserInterfaceCommonConnectionsArgs = {
  _userId?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Core_SortInput>>>;
};


export type Core_UserInterfaceIsUserResourceAvailableArgs = {
  resource: Core_UserResourceEnum;
};


export type Core_UserInterfacePhotoUrlArgs = {
  size?: InputMaybe<Core_MediaSizeEnum>;
};

export type Core_UserMeeting = Core_MeetingInterface & {
  __typename?: 'Core_UserMeeting';
  /** @deprecated Use 'meeting' instead */
  booking?: Maybe<Core_UserMeetingBooking>;
  ends: Scalars['Core_DateTime'];
  id: Scalars['ID'];
  meeting?: Maybe<Core_Meeting>;
  places: Array<Core_MeetingPlace>;
  starts: Scalars['Core_DateTime'];
};


export type Core_UserMeetingEndsArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_UserMeetingStartsArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_UserMeetingBooked = Core_MeetingInterface & {
  __typename?: 'Core_UserMeetingBooked';
  /** @deprecated Use 'meeting' instead */
  booking: Core_UserMeetingBooking;
  ends: Scalars['Core_DateTime'];
  id: Scalars['ID'];
  meeting?: Maybe<Core_Meeting>;
  places: Array<Core_MeetingPlace>;
  starts: Scalars['Core_DateTime'];
  userRating?: Maybe<Scalars['Float']>;
};


export type Core_UserMeetingBookedEndsArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};


export type Core_UserMeetingBookedStartsArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_UserMeetingBooking = {
  __typename?: 'Core_UserMeetingBooking';
  place: Core_MeetingPlace;
  request?: Maybe<Core_MeetingRequestUnion>;
  requesterMessage?: Maybe<Scalars['String']>;
  status: Core_MeetingBookingStatus;
  /** Return the person who meets the current user. */
  withPerson: Core_EventPerson;
  /**
   * Return the host or the requester who is not the current user.
   * @deprecated Use withPerson instead
   */
  withUser: Core_UserUnion;
};

export type Core_UserMeetingsFilterInput = {
  isBooked?: InputMaybe<Scalars['Boolean']>;
  isConfirmed?: InputMaybe<Scalars['Boolean']>;
  isPast?: InputMaybe<Scalars['Boolean']>;
};

export type Core_UserPreferences = {
  __typename?: 'Core_UserPreferences';
  /** @deprecated Use Event settings instead */
  emailActivitiesReminder: Scalars['Boolean'];
  /** @deprecated No longer supported */
  emailNewConnectionRequest: Scalars['Boolean'];
  /** @deprecated No longer supported */
  emailNewsletter: Scalars['Boolean'];
  /** @deprecated Use Event settings instead */
  emailRequestsReminder: Scalars['Boolean'];
  hideConnections: Scalars['Boolean'];
  hidePresenceStatus: Scalars['Boolean'];
  /** @deprecated No longer supported */
  pushChatNewMessage: Scalars['Boolean'];
  /** @deprecated No longer supported */
  pushNewConnection: Scalars['Boolean'];
  /** @deprecated No longer supported */
  pushNewConnectionRequest: Scalars['Boolean'];
  /** @deprecated No longer supported */
  pushNewMeetingRequest: Scalars['Boolean'];
};

export type Core_UserPreferencesInput = {
  emailActivitiesReminder?: InputMaybe<Scalars['Boolean']>;
  emailNewConnectionRequest?: InputMaybe<Scalars['Boolean']>;
  emailNewsletter?: InputMaybe<Scalars['Boolean']>;
  emailRequestsReminder?: InputMaybe<Scalars['Boolean']>;
  hideConnections?: InputMaybe<Scalars['Boolean']>;
  hidePresenceStatus?: InputMaybe<Scalars['Boolean']>;
  pushChatNewMessage?: InputMaybe<Scalars['Boolean']>;
  pushNewConnection?: InputMaybe<Scalars['Boolean']>;
  pushNewConnectionRequest?: InputMaybe<Scalars['Boolean']>;
  pushNewMeetingRequest?: InputMaybe<Scalars['Boolean']>;
};

export enum Core_UserPresenceStatusEnum {
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export enum Core_UserResourceEnum {
  HasEventMeetings = 'HAS_EVENT_MEETINGS'
}

export enum Core_UserRoleEnum {
  Admin = 'ADMIN',
  CommunityManager = 'COMMUNITY_MANAGER',
  EventManager = 'EVENT_MANAGER',
  None = 'NONE',
  /** @deprecated Use the new roles instead (EVENT_MANAGER / COMMUNITY_MANAGER). */
  OrganizationMember = 'ORGANIZATION_MEMBER'
}

export type Core_UserSettings = {
  __typename?: 'Core_UserSettings';
  sendEmailActivitiesReminder: Scalars['Boolean'];
  sendEmailMeetingsReminder: Scalars['Boolean'];
  sendEmailRequestsReminder: Scalars['Boolean'];
  sendOrganizerEmail: Scalars['Boolean'];
};

/** Set of information about a user related to the user in context. */
export type Core_UserStatus = {
  __typename?: 'Core_UserStatus';
  isAdmin: Scalars['Boolean'];
  isAttending: Scalars['Boolean'];
};

export enum Core_UserStatusEnum {
  Connection = 'CONNECTION',
  None = 'NONE',
  RequestedConnection = 'REQUESTED_CONNECTION',
  Self = 'SELF'
}

export type Core_UserTerm = {
  __typename?: 'Core_UserTerm';
  description: Scalars['String'];
  id: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  label: Scalars['String'];
  promptLocations?: Maybe<Array<Core_PromptLocationEnum>>;
};

export type Core_UserTermInput = {
  accepted?: InputMaybe<Scalars['Boolean']>;
  userTermId: Scalars['ID'];
};

export type Core_UserTermTranslation = {
  __typename?: 'Core_UserTermTranslation';
  description?: Maybe<Scalars['String']>;
  language: Core_LanguageEnum;
};

export type Core_UserUnion = Core_ConnectionUser | Core_PublicUser | Core_SelfUser;

export type Core_VideoBackstage = {
  __typename?: 'Core_VideoBackstage';
  token: Scalars['String'];
};

export enum Core_ViewModeEnum {
  Grid = 'GRID',
  List = 'LIST'
}

export type Core_VimeoEmbeddedVideo = {
  __typename?: 'Core_VimeoEmbeddedVideo';
  videoId: Scalars['ID'];
};

export type Core_VimeoEmbeddedVideoInput = {
  videoId: Scalars['ID'];
};

export type Core_VimeoPlanningStream = Core_PlanningStreamInterface & {
  __typename?: 'Core_VimeoPlanningStream';
  availableAt?: Maybe<Scalars['Core_DateTime']>;
  endsAt?: Maybe<Scalars['Core_DateTime']>;
  id: Scalars['ID'];
  isLiveStream: Scalars['Boolean'];
  isPublic: Scalars['Boolean'];
  /** @deprecated use availableAt instead */
  startsAt: Scalars['Core_DateTime'];
  videoId: Scalars['ID'];
};


export type Core_VimeoPlanningStreamStartsAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export enum Core_VisibilityEnum {
  All = 'ALL',
  NotVisible = 'NOT_VISIBLE',
  Visible = 'VISIBLE'
}

export type Core_VonageRoundtableRoomData = {
  __typename?: 'Core_VonageRoundtableRoomData';
  /** static Vonage apiKey */
  apiKey: Scalars['String'];
  /** Vonage sessionId corresponding to this roundtable */
  sessionId: Scalars['String'];
  /** The generated Vonage token used to connect to the session */
  token: Scalars['String'];
};

export type Core_YoutubeEmbeddedVideo = {
  __typename?: 'Core_YoutubeEmbeddedVideo';
  videoId: Scalars['ID'];
};

export type Core_YoutubeEmbeddedVideoInput = {
  videoId: Scalars['ID'];
};

export type Core_YoutubePlanningStream = Core_PlanningStreamInterface & {
  __typename?: 'Core_YoutubePlanningStream';
  availableAt?: Maybe<Scalars['Core_DateTime']>;
  endsAt?: Maybe<Scalars['Core_DateTime']>;
  id: Scalars['ID'];
  isLiveStream: Scalars['Boolean'];
  isPublic: Scalars['Boolean'];
  /** @deprecated use availableAt instead */
  startsAt: Scalars['Core_DateTime'];
  videoId: Scalars['ID'];
};


export type Core_YoutubePlanningStreamStartsAtArgs = {
  format?: InputMaybe<Core_DateTimeFormat>;
};

export type Core_Zoom = {
  __typename?: 'Core_Zoom';
  default: Scalars['Int'];
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export enum DeviceType {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type Me = {
  __typename?: 'Me';
  account: Auth_User;
  events: Core_EdgeListEvent;
  user: Core_UserUnion;
};


export type MeEventsArgs = {
  filters?: InputMaybe<Array<InputMaybe<Core_EventFilterInput>>>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<Core_EventSortInput>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Attach an email address to the account */
  Auth_attachEmailAddress: Scalars['Boolean'];
  /** Delete an api key */
  Auth_deleteApiKey: Scalars['Boolean'];
  /** Detach an email address on the account */
  Auth_detachEmailAddress: Scalars['Boolean'];
  /** Generate a personal api key */
  Auth_generateApiKey: Scalars['String'];
  Auth_loginUsingAccessCode: Auth_Connexion;
  Auth_loginUsingSecret: Auth_Connexion;
  Auth_refreshAccessToken: Scalars['String'];
  /** Remove a MFA strategy from the user using their password */
  Auth_removeMFAStrategy: Scalars['Boolean'];
  /** Remove MFA strategy by MFA credentials */
  Auth_removeMFAStrategyByMFA: Scalars['Boolean'];
  /** Remove MFA strategy by recovery code */
  Auth_removeMFAStrategyByRecoveryCode: Scalars['Boolean'];
  Auth_resetAndLoginUsingSecret: Auth_Connexion;
  Auth_sendDeleteMeOtp: Auth_SendDeleteMeOtpPayload;
  Auth_sendMagicLinkToEmailAddress: Scalars['Boolean'];
  /** Set a password */
  Auth_setPassword: Scalars['Boolean'];
  /** Set primary email address to the account */
  Auth_setPrimaryEmailAddress: Scalars['Boolean'];
  /** Setup a new MFA strategy for the current user */
  Auth_setupMFAStrategy: Auth_MfaOnboardingUnion;
  /** Verify an onboarding MFA strategy using a challenge response */
  Auth_verifyMFAStrategy: Auth_MfaStrategy;
  Backstage_joinRoom: Backstage_JoinRoomPayload;
  /** Start live stream for a specific room */
  Backstage_startLive: Backstage_StartLivePayload;
  /** Stops live stream for a specific room */
  Backstage_stopLive: Backstage_StopLivePayload;
  /** Stops live stream for a specific room */
  Backstage_updateScene: Backstage_UpdateScenePayload;
  Chat_addReactionOnMessage: Chat_Message;
  Chat_closeChannel: Chat_Channel;
  Chat_createChannel: Chat_ChannelUser;
  Chat_createVideoCallRoom: Chat_VideoCallRoom;
  Chat_declareLatestMessageSeen: Chat_ChannelUser;
  /** Declare that the user is typing, so he will appear as typing during a short amount of time */
  Chat_declareTyping: Chat_ChannelUser;
  Chat_deleteMessages: Array<Chat_Message>;
  Chat_inviteUsersToChannel: Array<Chat_ChannelUser>;
  /** Used to interact (add messages - reactions) on a channel - will create a channel user and be linked to the channel */
  Chat_joinChannel: Chat_ChannelUser;
  Chat_joinVideoCallRoom: Chat_VideoCallRoom;
  Chat_leaveChannel: Chat_ChannelUser;
  Chat_leaveVideoCallRoom: Chat_VideoCallRoom;
  Chat_postMessage: Chat_Message;
  Chat_removeLinkOnMessage: Chat_RemoveLinkOnMessagePayload;
  Chat_removeReactionOnMessage: Chat_Message;
  Chat_removeUserFromChannel: Array<Chat_ChannelUser>;
  Chat_requestFileUpload: Array<Chat_File>;
  Chat_toggleMuteChannel: Chat_ChannelUser;
  Chat_updateChannel: Chat_Channel;
  Chat_updateChannelUserPermissions: Chat_ChannelUser;
  /** Update a message content */
  Chat_updateMessage: Chat_Message;
  Chat_voteOnMessage: Chat_Message;
  Core_acceptRequest: Core_RequestReceived;
  Core_acceptUserTerms: Core_AcceptUserTermsPayload;
  Core_addExhibitorMemberByEmail: Core_ExhibitorMember;
  /** Add a reply to a form */
  Core_addReplyToForm: Core_AddReplyToFormPayload;
  /** Apply a profile from event or community to the current user. */
  Core_applyEventProfile: Core_SelfUser;
  /** Assigns or unassigns the given member to a lead. */
  Core_assignLead: Core_AssignLeadPayload;
  /**
   * Assigns the given person to this participant.
   * It will replace the previous person, if any.
   */
  Core_assignMeetingParticipant: Core_AssignMeetingParticipantPayload;
  Core_bookmarkExhibitor: Core_Exhibitor;
  Core_bookmarkPlanning: Core_Planning;
  Core_bookmarkProduct: Core_Product;
  /**
   * Cancel an exhibitor meeting received.
   * The user must be admin of the exhibitor to cancel the meeting.
   */
  Core_cancelExhibitorMeeting: Core_ExhibitorMeetingDetailed;
  /** Cancel a pending or confirmed meeting. */
  Core_cancelMeetingV2: Core_MeetingSlot;
  Core_cancelOrderAndDeleteRegistration: Core_CancelOrderAndDeleteRegistrationPayload;
  Core_cancelOrderAndMoveItemsToDraft: Core_CancelOrderAndMoveItemsToDraftPayload;
  Core_createContact?: Maybe<Core_ConnectionContact>;
  Core_createContactV2?: Maybe<Core_CreateContactPayload>;
  Core_createDraftOrder: Core_CreateDraftOrderPayload;
  /** Create a new advertisement attached to an exhibitor. */
  Core_createExhibitorAdvertisement: Core_CreateExhibitorAdvertisementPayload;
  Core_createExhibitorDocument: Core_Document;
  /** Create a form on an event */
  Core_createForm: Core_CreateFormPayload;
  Core_createMeeting: Core_CreateMeetingPayload;
  Core_createOCRContact?: Maybe<Core_OcrContact>;
  Core_createOrderByDraftOrder: Core_CreateOrderByDraftOrderPayload;
  Core_createOrderPayment: Core_CreateOrderPaymentPayload;
  Core_createPaymentIntentForOrder: Core_CreatePaymentIntentForOrderPayload;
  /** Create a qualifier question */
  Core_createQualifierQuestion: Core_CreateQualifierQuestionPayload;
  Core_createUploadUrl: Core_CreateUploadUrlResult;
  Core_declineRequest: Core_RequestReceived;
  Core_deleteAbandonedRegistration: Core_DeleteAbandonedRegistrationPayload;
  Core_deleteAccountUsingOTP: Scalars['Boolean'];
  Core_deleteConnection?: Maybe<Core_ConnectionUnion>;
  /** Delete advertisements attached to an exhibitor. */
  Core_deleteExhibitorAdvertisements: Core_DeleteExhibitorAdvertisementsPayload;
  Core_deleteExhibitorDocuments: Array<Scalars['ID']>;
  /** Delete a form */
  Core_deleteForm: Core_DeleteFormPayload;
  Core_deleteMe: Scalars['Boolean'];
  /** Delete a qualifier question */
  Core_deleteQualifierQuestion: Core_DeleteQualifierQuestionPayload;
  Core_discardEventProfile: Core_SelfUser;
  Core_exhibitorCreateProduct: Core_Product;
  Core_exhibitorDeleteProduct: Scalars['ID'];
  Core_exhibitorUpdateProduct: Core_Product;
  /** Returns URL to a PDF file with information about a connection. */
  Core_exportConnectionInfoAsPdf?: Maybe<Scalars['String']>;
  Core_exportContacts: Scalars['String'];
  Core_exportExhibitorLeads: Core_ExportExhibitorLeadsPayload;
  Core_exportExhibitorMeetings: Core_ExportExhibitorMeetingsPayload;
  /** Returns signed URL to an excel file with information of poll replies of eventId. */
  Core_exportPlanningPollReplies: Core_ExportPlanningPollRepliesPayload;
  /** Returns presigned URL to a document's media. */
  Core_getMediaDocumentUrl: Core_GetMediaDocumentUrlPayload;
  Core_inviteMeetingParticipants: Core_InviteMeetingParticipantsPayload;
  /** Join an Organization's own event. */
  Core_joinOrganizationEvent: Core_JoinOrganizationEventPayload;
  /** Join a public event. */
  Core_joinPublicEvent: Core_JoinPublicEventPayload;
  /**
   * Joins user to the roundtable & generates a vonage token with the matching rights.
   * For plannings, if not registered to the planning, it will automatically register the user.
   * For meetings, if no roundtable is attached, it will automatically attach a roundtable.
   * Requesters/speakers & event admins join with special priviledges.
   */
  Core_joinRoundtableRoom: Core_JoinRoundtableRoomPayload;
  /** Marks meeting as not held and updates the isGoing flag for all participants. */
  Core_markMeetingAsNotHeld: Core_MarkMeetingAsNotHeldPayload;
  Core_markRecommendationAsIrrelevant?: Maybe<Core_MarkIrrelevantRecommendationsPayload>;
  Core_ratePlanning: Core_Planning;
  Core_removeMeetingParticipants: Core_RemoveMeetingParticipantsPayload;
  Core_rescheduleMeeting: Core_RescheduleMeetingPayload;
  /**
   * Reset the number of new notifications (requests and activities) and return
   * number of new notifications since this time.
   * This number can be fetched using the Query `notificationCounter`
   */
  Core_resetNotificationCounter: Scalars['Int'];
  /**
   * Scan a QR code and creates a connection if it matches a person.
   * Returns ScanCodeFailure if the code does not match anything.
   */
  Core_scanCode: Core_ScanCodeResult;
  /** Selects a meeting candidate as Must meet, Nice to Meet, or Exclude */
  Core_selectHostedMeetingConditionCandidate: Core_SelectHostedMeetingConditionCandidatePayload;
  Core_sendConnectionRequest: Core_ConnectionRequestSent;
  Core_sendContinueExistingOrderEmail: Core_SendContinueExistingOrderEmailPayload;
  /** Send a feedback on a past meeting. */
  Core_sendFeedbackOnMeeting?: Maybe<Core_SendFeedbackOnMeetingPayload>;
  Core_setNotificationsAsSeen: Array<Core_Notification>;
  Core_setUserTermsAgreement: Core_SetUserTermsAgreementPayload;
  /** Sort exhibitor products. */
  Core_sortExhibitorProducts: Core_SortExhibitorProductsPayload;
  Core_startRecordingRoundtable: Core_StartRecordingRoundtablePayload;
  Core_stopRecordingRoundtable: Core_StopRecordingRoundtablePayload;
  /** Change the visibility of the user in the attendee list of an event or a community. */
  Core_switchAttendeeVisibility: Scalars['Boolean'];
  Core_updateConnection?: Maybe<Core_ConnectionUnion>;
  Core_updateDraftOrder: Core_UpdateDraftOrderPayload;
  Core_updateEventPerson: Core_UpdateEventPersonPayload;
  Core_updateExhibitor: Core_Exhibitor;
  Core_updateExhibitorDocument: Core_Document;
  /** Update meeting slots for an exhibitor to make them disabled. */
  Core_updateExhibitorMeetingSlotsDisabled: Core_UpdateExhibitorMeetingSlotsDisabledPayload;
  Core_updateExhibitorMember: Core_ExhibitorMember;
  /** Update meeting slots for an exhibitor to make them disabled. */
  Core_updateExhibitorMemberRoles: Core_UpdateExhibitorMemberRolesPayload;
  /** Update a form */
  Core_updateForm: Core_UpdateFormPayload;
  /**
   * Update a meeting as a host.
   * @deprecated Use updatePersonMeetingSlotsDisabled or updateMeeting instead
   */
  Core_updateHostMeeting: Core_HostMeeting;
  /**
   * Update several meetings as a host in an event.
   * @deprecated Use updatePersonMeetingSlotsDisabled instead
   */
  Core_updateHostMeetingsByEvent: Array<Core_HostMeeting>;
  Core_updateMeeting: Core_UpdateMeetingPayload;
  Core_updateMeetingParticipation: Core_UpdateMeetingParticipationPayload;
  /** Enable/disable MeetingSlots based on the filters from the input. All filters apply, if present */
  Core_updatePersonMeetingSlotsDisabled: Core_UpdatePersonMeetingSlotsDisabledPayload;
  /** Update a qualifier question */
  Core_updateQualifierQuestion: Core_UpdateQualifierQuestionPayload;
  /**
   * Can be called by moderator to invite/kick the participant from the stage
   * or by the participant if he chooses to leave the stage.
   * A signal will be sent to all the roundtable participants when this is updated.
   * When a participant joins the stage, the raisedHand will automatically be cancelled.
   */
  Core_updateRoundtableParticipantOnStage: Core_UpdateRoundtableParticipantOnStagePayload;
  /**
   * Can be called by the participant when he chooses to raiseHand or cancel the raisedHand.
   * A signal will be sent to all the roundtable participants when this is updated.
   */
  Core_updateRoundtableParticipantRaisedHand: Core_UpdateRoundtableParticipantRaisedHandPayload;
  /** @deprecated Use updateEventPerson, updateUserSettings, updateUserV2 instead */
  Core_updateUser?: Maybe<Core_SelfUser>;
  /** Update user settings for the given community. Includes all events within the community. */
  Core_updateUserSettings: Core_UpdateUserSettingsPayload;
  /** Update user's language and hidePresenceStatus settings. */
  Core_updateUserV2: Core_UpdateUserV2Payload;
  Sync_linkCalendar: Sync_CalendarUnion;
  /** Will mute calendar reminder for 7 days. Calendars will still be visible by providing "CalendarsFilterInput.subscribed = false" to Sync_calendars query */
  Sync_muteCalendarReminder?: Maybe<Scalars['Boolean']>;
  /** Remove calendar and revoke calendar */
  Sync_revokeCalendar?: Maybe<Scalars['Boolean']>;
  /** Disable (unlink) calendar configuration - revoke oauth refresh token and delete created calendar and all events */
  Sync_unlinkCalendar?: Maybe<Scalars['Boolean']>;
  /** Register device id */
  registerDeviceId: Scalars['Boolean'];
  /** Un-register a device id */
  unRegisterDeviceId: Scalars['Boolean'];
};


export type MutationAuth_AttachEmailAddressArgs = {
  emailAddress: Scalars['Auth_EmailAddress'];
};


export type MutationAuth_DeleteApiKeyArgs = {
  id: Scalars['Auth_ObjectID'];
};


export type MutationAuth_DetachEmailAddressArgs = {
  emailAddress: Scalars['Auth_EmailAddress'];
};


export type MutationAuth_GenerateApiKeyArgs = {
  name: Scalars['String'];
  scope?: InputMaybe<Auth_ApiKeyScopeInput>;
};


export type MutationAuth_LoginUsingAccessCodeArgs = {
  code: Scalars['String'];
  username: Scalars['String'];
};


export type MutationAuth_LoginUsingSecretArgs = {
  key: Scalars['String'];
  secret: Scalars['String'];
};


export type MutationAuth_RefreshAccessTokenArgs = {
  refreshToken: Scalars['String'];
};


export type MutationAuth_RemoveMfaStrategyArgs = {
  kind: Auth_MfaStrategyKind;
  password: Scalars['String'];
};


export type MutationAuth_RemoveMfaStrategyByMfaArgs = {
  challengeResponse: Auth_ChallengeResponseInput;
};


export type MutationAuth_RemoveMfaStrategyByRecoveryCodeArgs = {
  recoveryCode: Scalars['String'];
};


export type MutationAuth_ResetAndLoginUsingSecretArgs = {
  key: Scalars['String'];
  secret: Scalars['String'];
};


export type MutationAuth_SendMagicLinkToEmailAddressArgs = {
  emailAddress: Scalars['Auth_EmailAddress'];
  isResetPassword?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Auth_Locale>;
  target?: InputMaybe<Scalars['String']>;
};


export type MutationAuth_SetPasswordArgs = {
  currentPassword?: InputMaybe<Scalars['String']>;
  newPassword: Scalars['String'];
};


export type MutationAuth_SetPrimaryEmailAddressArgs = {
  emailAddress: Scalars['Auth_EmailAddress'];
};


export type MutationAuth_SetupMfaStrategyArgs = {
  strategy: Auth_MfaStrategyKind;
};


export type MutationAuth_VerifyMfaStrategyArgs = {
  challengeResponse: Auth_ChallengeResponseInput;
};


export type MutationBackstage_StartLiveArgs = {
  url: Scalars['String'];
};


export type MutationBackstage_UpdateSceneArgs = {
  data: Scalars['String'];
  sceneId: Scalars['String'];
};


export type MutationChat_AddReactionOnMessageArgs = {
  asUserId: Scalars['String'];
  messageId: Scalars['Chat_ObjectID'];
  reaction: Scalars['String'];
};


export type MutationChat_CloseChannelArgs = {
  asUserId: Scalars['String'];
  channelId?: InputMaybe<Scalars['Chat_UUID']>;
  channelIds?: InputMaybe<Array<Scalars['Chat_UUID']>>;
};


export type MutationChat_CreateChannelArgs = {
  asUserId: Scalars['String'];
  channel: Chat_CreateChannelInput;
  distinct?: InputMaybe<Scalars['Boolean']>;
  initialMessage?: InputMaybe<Chat_CreateInitialMessageInput>;
  inviteUsersIds: Array<Scalars['String']>;
};


export type MutationChat_CreateVideoCallRoomArgs = {
  asUserId: Scalars['String'];
  channelId: Scalars['Chat_UUID'];
  provider?: InputMaybe<Chat_VideoCallProviderEnum>;
};


export type MutationChat_DeclareLatestMessageSeenArgs = {
  channelUserId: Scalars['Chat_ObjectID'];
  messageId: Scalars['Chat_ObjectID'];
};


export type MutationChat_DeclareTypingArgs = {
  channelUserId: Scalars['Chat_ObjectID'];
};


export type MutationChat_DeleteMessagesArgs = {
  asUserId: Scalars['String'];
  messagesIds: Array<Scalars['Chat_ObjectID']>;
};


export type MutationChat_InviteUsersToChannelArgs = {
  asUserId: Scalars['String'];
  channelId: Scalars['Chat_UUID'];
  usersIds: Array<Scalars['String']>;
};


export type MutationChat_JoinChannelArgs = {
  asUserId: Scalars['String'];
  channelId: Scalars['Chat_UUID'];
};


export type MutationChat_JoinVideoCallRoomArgs = {
  asUserId: Scalars['String'];
  videoCallRoomId: Scalars['Chat_UUID'];
};


export type MutationChat_LeaveChannelArgs = {
  asUserId: Scalars['String'];
  channelUserId: Scalars['Chat_ObjectID'];
};


export type MutationChat_LeaveVideoCallRoomArgs = {
  asUserId: Scalars['String'];
  videoCallRoomId: Scalars['Chat_UUID'];
};


export type MutationChat_PostMessageArgs = {
  asUserId: Scalars['String'];
  message: Chat_CreateMessageInput;
};


export type MutationChat_RemoveLinkOnMessageArgs = {
  input: Chat_RemoveLinkOnMessageInput;
};


export type MutationChat_RemoveReactionOnMessageArgs = {
  asUserId: Scalars['String'];
  messageId: Scalars['Chat_ObjectID'];
  reaction: Scalars['String'];
};


export type MutationChat_RemoveUserFromChannelArgs = {
  asUserId: Scalars['String'];
  channelId: Scalars['Chat_UUID'];
  userIds: Array<Scalars['String']>;
};


export type MutationChat_RequestFileUploadArgs = {
  asUserId: Scalars['String'];
  files: Array<Chat_FileInput>;
};


export type MutationChat_ToggleMuteChannelArgs = {
  asUserId: Scalars['String'];
  channelId: Scalars['Chat_UUID'];
  isMuted: Scalars['Boolean'];
};


export type MutationChat_UpdateChannelArgs = {
  asUserId: Scalars['String'];
  channel: Chat_UpdateChannelInput;
  channelId: Scalars['Chat_UUID'];
};


export type MutationChat_UpdateChannelUserPermissionsArgs = {
  asUserId: Scalars['String'];
  channelId: Scalars['Chat_UUID'];
  permissions: Chat_ChannelUserPermissions;
  userId: Scalars['String'];
};


export type MutationChat_UpdateMessageArgs = {
  asUserId: Scalars['String'];
  attributes: Chat_UpdateMessageInput;
  messageId: Scalars['Chat_ObjectID'];
};


export type MutationChat_VoteOnMessageArgs = {
  asUserId: Scalars['String'];
  messageId: Scalars['Chat_ObjectID'];
  vote: Chat_VoteState;
};


export type MutationCore_AcceptRequestArgs = {
  id: Scalars['ID'];
};


export type MutationCore_AcceptUserTermsArgs = {
  input: Core_AcceptUserTermsInput;
};


export type MutationCore_AddExhibitorMemberByEmailArgs = {
  email: Scalars['String'];
  eventId: Scalars['ID'];
  exhibitorId: Scalars['ID'];
};


export type MutationCore_AddReplyToFormArgs = {
  input: Core_AddReplyToFormInput;
};


export type MutationCore_ApplyEventProfileArgs = {
  _eventId?: InputMaybe<Scalars['ID']>;
  communityId?: InputMaybe<Scalars['ID']>;
};


export type MutationCore_AssignLeadArgs = {
  input: Core_AssignLeadInput;
};


export type MutationCore_AssignMeetingParticipantArgs = {
  input: Core_AssignMeetingParticipantInput;
};


export type MutationCore_BookmarkExhibitorArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type MutationCore_BookmarkPlanningArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type MutationCore_BookmarkProductArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type MutationCore_CancelExhibitorMeetingArgs = {
  meetingId: Scalars['ID'];
};


export type MutationCore_CancelMeetingV2Args = {
  meetingId: Scalars['ID'];
};


export type MutationCore_CancelOrderAndDeleteRegistrationArgs = {
  input: Core_CancelOrderAndDeleteRegistrationInput;
};


export type MutationCore_CancelOrderAndMoveItemsToDraftArgs = {
  input: Core_CancelOrderAndMoveItemsToDraftInput;
};


export type MutationCore_CreateContactArgs = {
  communityId?: InputMaybe<Scalars['ID']>;
  eventId?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  personData: Core_PersonInput;
};


export type MutationCore_CreateContactV2Args = {
  input: Core_CreateContactV2Input;
};


export type MutationCore_CreateDraftOrderArgs = {
  input: Core_CreateDraftOrderInput;
};


export type MutationCore_CreateExhibitorAdvertisementArgs = {
  input: Core_CreateExhibitorAdvertisementInput;
};


export type MutationCore_CreateExhibitorDocumentArgs = {
  data: Core_CreateDocumentInput;
  eventId?: InputMaybe<Scalars['ID']>;
  exhibitorId: Scalars['ID'];
};


export type MutationCore_CreateFormArgs = {
  input: Core_CreateFormInput;
};


export type MutationCore_CreateMeetingArgs = {
  input: Core_CreateMeetingInput;
};


export type MutationCore_CreateOcrContactArgs = {
  imageUrl: Scalars['String'];
};


export type MutationCore_CreateOrderByDraftOrderArgs = {
  input: Core_CreateOrderByDraftOrderInput;
};


export type MutationCore_CreateOrderPaymentArgs = {
  input: Core_CreateOrderPaymentInput;
};


export type MutationCore_CreatePaymentIntentForOrderArgs = {
  input: Core_CreatePaymentIntentForOrderInput;
};


export type MutationCore_CreateQualifierQuestionArgs = {
  input: Core_CreateQualifierQuestionInput;
};


export type MutationCore_CreateUploadUrlArgs = {
  input: Core_CreateUploadUrlInput;
};


export type MutationCore_DeclineRequestArgs = {
  id: Scalars['ID'];
};


export type MutationCore_DeleteAbandonedRegistrationArgs = {
  input: Core_DeletedAbandonedRegistrationInput;
};


export type MutationCore_DeleteAccountUsingOtpArgs = {
  key: Scalars['String'];
  otp: Scalars['String'];
};


export type MutationCore_DeleteConnectionArgs = {
  _id: Scalars['ID'];
};


export type MutationCore_DeleteExhibitorAdvertisementsArgs = {
  input: Core_DeleteExhibitorAdvertisementsInput;
};


export type MutationCore_DeleteExhibitorDocumentsArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
  exhibitorId: Scalars['ID'];
  ids: Array<Scalars['ID']>;
};


export type MutationCore_DeleteFormArgs = {
  input: Core_DeleteFormInput;
};


export type MutationCore_DeleteMeArgs = {
  password: Scalars['String'];
};


export type MutationCore_DeleteQualifierQuestionArgs = {
  input: Core_DeleteQualifierQuestionInput;
};


export type MutationCore_DiscardEventProfileArgs = {
  _eventId?: InputMaybe<Scalars['ID']>;
  communityId?: InputMaybe<Scalars['ID']>;
};


export type MutationCore_ExhibitorCreateProductArgs = {
  data: Core_CreateProductInput;
  exhibitorId: Scalars['ID'];
};


export type MutationCore_ExhibitorDeleteProductArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
  exhibitorId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationCore_ExhibitorUpdateProductArgs = {
  data: Core_UpdateProductInput;
  eventId?: InputMaybe<Scalars['ID']>;
  exhibitorId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationCore_ExportConnectionInfoAsPdfArgs = {
  id: Scalars['ID'];
};


export type MutationCore_ExportContactsArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
};


export type MutationCore_ExportExhibitorLeadsArgs = {
  input: Core_ExportExhibitorLeadsInput;
};


export type MutationCore_ExportExhibitorMeetingsArgs = {
  input: Core_ExportExhibitorMeetingsInput;
};


export type MutationCore_ExportPlanningPollRepliesArgs = {
  input: Core_ExportPlanningPollRepliesInput;
};


export type MutationCore_GetMediaDocumentUrlArgs = {
  input: Core_GetMediaDocumentUrlInput;
};


export type MutationCore_InviteMeetingParticipantsArgs = {
  input: Core_InviteMeetingParticipantsInput;
};


export type MutationCore_JoinOrganizationEventArgs = {
  input: Core_JoinOrganizationEventInput;
};


export type MutationCore_JoinPublicEventArgs = {
  input: Core_JoinPublicEventInput;
};


export type MutationCore_JoinRoundtableRoomArgs = {
  input: Core_JoinRoundtableRoomInput;
};


export type MutationCore_MarkMeetingAsNotHeldArgs = {
  meetingId: Scalars['ID'];
};


export type MutationCore_MarkRecommendationAsIrrelevantArgs = {
  input: Core_MarkRecommendationAsIrrelevantInput;
};


export type MutationCore_RatePlanningArgs = {
  _id: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['ID']>;
  grade?: InputMaybe<Scalars['Float']>;
};


export type MutationCore_RemoveMeetingParticipantsArgs = {
  input: Core_RemoveMeetingParticipantsInput;
};


export type MutationCore_RescheduleMeetingArgs = {
  input: Core_RescheduleMeetingInput;
};


export type MutationCore_ResetNotificationCounterArgs = {
  since: Scalars['Core_DateTime'];
};


export type MutationCore_ScanCodeArgs = {
  code: Scalars['String'];
  connectionData?: InputMaybe<Core_ConnectionDataInput>;
  eventId?: InputMaybe<Scalars['ID']>;
};


export type MutationCore_SelectHostedMeetingConditionCandidateArgs = {
  input: Core_SelectHostedMeetingConditionCandidateInput;
};


export type MutationCore_SendConnectionRequestArgs = {
  data: Core_SendConnectionRequestInput;
};


export type MutationCore_SendContinueExistingOrderEmailArgs = {
  input: Core_SendContinueExistingOrderEmailInput;
};


export type MutationCore_SendFeedbackOnMeetingArgs = {
  input: Core_SendFeedbackOnMeetingInput;
};


export type MutationCore_SetNotificationsAsSeenArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationCore_SetUserTermsAgreementArgs = {
  input: Core_SetUserTermsAgreementInput;
};


export type MutationCore_SortExhibitorProductsArgs = {
  input: Core_SortExhibitorProductsInput;
};


export type MutationCore_StartRecordingRoundtableArgs = {
  input: Core_StartRecordingRoundtableInput;
};


export type MutationCore_StopRecordingRoundtableArgs = {
  input: Core_StopRecordingRoundtableInput;
};


export type MutationCore_SwitchAttendeeVisibilityArgs = {
  communityId?: InputMaybe<Scalars['ID']>;
  eventId?: InputMaybe<Scalars['ID']>;
  isVisible: Scalars['Boolean'];
};


export type MutationCore_UpdateConnectionArgs = {
  _id: Scalars['ID'];
  eventId?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['Float']>;
  tags?: InputMaybe<Array<InputMaybe<Core_TagInput>>>;
};


export type MutationCore_UpdateDraftOrderArgs = {
  input: Core_UpdateDraftOrderInput;
};


export type MutationCore_UpdateEventPersonArgs = {
  input: Core_UpdateEventPersonInput;
};


export type MutationCore_UpdateExhibitorArgs = {
  _id: Scalars['ID'];
  eventId: Scalars['ID'];
  exhibitorData: Core_ExhibitorInput;
};


export type MutationCore_UpdateExhibitorDocumentArgs = {
  data: Core_UpdateDocumentInput;
  eventId?: InputMaybe<Scalars['ID']>;
  exhibitorId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationCore_UpdateExhibitorMeetingSlotsDisabledArgs = {
  input: Core_UpdateExhibitorMeetingSlotsDisabledInput;
};


export type MutationCore_UpdateExhibitorMemberArgs = {
  data: Core_ExhibitorMemberOptionsInput;
  eventId?: InputMaybe<Scalars['ID']>;
  exhibitorMemberId: Scalars['ID'];
};


export type MutationCore_UpdateExhibitorMemberRolesArgs = {
  input: Core_UpdateExhibitorMemberRolesInput;
};


export type MutationCore_UpdateFormArgs = {
  input: Core_UpdateFormInput;
};


export type MutationCore_UpdateHostMeetingArgs = {
  data: Core_UpdateHostMeetingInput;
  meetingId: Scalars['ID'];
};


export type MutationCore_UpdateHostMeetingsByEventArgs = {
  data: Core_UpdateHostMeetingsByEventInput;
  day?: InputMaybe<Scalars['Core_DateTime']>;
  eventId: Scalars['ID'];
};


export type MutationCore_UpdateMeetingArgs = {
  input: Core_UpdateMeetingInput;
};


export type MutationCore_UpdateMeetingParticipationArgs = {
  input: Core_UpdateMeetingParticipationInput;
};


export type MutationCore_UpdatePersonMeetingSlotsDisabledArgs = {
  input: Core_UpdatePersonMeetingSlotsDisabledInput;
};


export type MutationCore_UpdateQualifierQuestionArgs = {
  input: Core_UpdateQualifierQuestionInput;
};


export type MutationCore_UpdateRoundtableParticipantOnStageArgs = {
  input: Core_UpdateRoundtableParticipantOnStageInput;
};


export type MutationCore_UpdateRoundtableParticipantRaisedHandArgs = {
  input: Core_UpdateRoundtableParticipantRaisedHandInput;
};


export type MutationCore_UpdateUserArgs = {
  linkedinData?: InputMaybe<Core_OAuthInput>;
  overrideData?: InputMaybe<Scalars['Boolean']>;
  personData?: InputMaybe<Core_PersonInput>;
  pushProfile?: InputMaybe<Core_PushProfileInput>;
  userData?: InputMaybe<Core_UserInput>;
};


export type MutationCore_UpdateUserSettingsArgs = {
  input: Core_UpdateUserSettingsInput;
};


export type MutationCore_UpdateUserV2Args = {
  input: Core_UpdateUserV2Input;
};


export type MutationSync_LinkCalendarArgs = {
  bundleId?: InputMaybe<Scalars['String']>;
  calendarType: Sync_CalendarType;
  originId?: InputMaybe<Scalars['String']>;
  sourceRedirectUrl: Scalars['String'];
};


export type MutationSync_RevokeCalendarArgs = {
  calendarType: Sync_CalendarType;
};


export type MutationSync_UnlinkCalendarArgs = {
  calendarId: Scalars['String'];
  calendarType: Sync_CalendarType;
};


export type MutationRegisterDeviceIdArgs = {
  appId: Scalars['String'];
  deviceId: Scalars['String'];
  deviceType: DeviceType;
};


export type MutationUnRegisterDeviceIdArgs = {
  deviceId: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  Auth_authMethods?: Maybe<Auth_AuthMethodsResult>;
  Auth_emailAddress: Array<Auth_Email>;
  Auth_lookup: Auth_Lookup;
  Auth_ping: Scalars['Boolean'];
  Auth_user: Auth_User;
  Backstage_room?: Maybe<Backstage_Room>;
  /** List all available emojis and category */
  Chat_emojis: Array<Chat_EmojiCategory>;
  /** List children's message */
  Chat_listMessageChildren: Array<Chat_Message>;
  /** List private channels (messaging) */
  Chat_ownedChannels: Array<Chat_Channel>;
  /** Pong */
  Chat_ping: Scalars['String'];
  /** Get public channels (livestream - feed) */
  Chat_publicChannels: Array<Chat_PublicChannelWrapper>;
  /** Get url metadata */
  Chat_urlMetadata?: Maybe<Chat_UrlMetadata>;
  /** Get personal user's information from the context */
  Chat_viewer: Chat_Viewer;
  /** Return activities sorted by most recent first. */
  Core_activities: Core_ActivitiesConnection;
  /** Return all exhibitor meetings for an exhibitor. The user must be admin of the exhibitor to see the meetings. */
  Core_allExhibitorMeetings: Core_ExhibitorMeetingDetailedResults;
  /**
   * Return the application from the context.
   * It uses HTTP headers to guess the application and always fallback to the default application.
   */
  Core_application: Core_Application;
  /** Return an application by its slug. */
  Core_applicationBySlug?: Maybe<Core_Application>;
  /** Check that an application exists based on HTTP headers and context. */
  Core_applicationExists: Scalars['Boolean'];
  Core_commonConnections?: Maybe<Core_EdgeListConnectionUnion>;
  Core_communities: Core_CommunitiesConnection;
  Core_community?: Maybe<Core_Community>;
  Core_connection?: Maybe<Core_ConnectionUnion>;
  /** @deprecated Use listConnections instead */
  Core_connections?: Maybe<Core_EdgeListConnectionUnion>;
  /** Return the draft order for the given key & secret */
  Core_draftOrder: Core_DraftOrder;
  Core_event: Core_Event;
  /** Return the contents of an event exhibitor list view. */
  Core_eventExhibitorListView: Core_EventExhibitorListView;
  Core_eventHostedBuyersListView: Core_EventHostedBuyersListView;
  /** Return a list of event people connected with the current user. */
  Core_eventPeopleConnected: Core_EventPeopleConnection;
  /** Return the contents of an event people list view. */
  Core_eventPeopleListView: Core_EventPeopleListView;
  /** Return an event person by its ID. */
  Core_eventPersonDetails: Core_EventPerson;
  /** Return meetings for an event person */
  Core_eventPersonMeetings: Array<Core_UserMeeting>;
  /** Return the contents of an event planning list view. */
  Core_eventPlanningListView: Core_EventPlanningListView;
  /** @deprecated Use Event.productCategories or Community.productCategories instead. */
  Core_eventProductCategory: Core_ProductCategoryUnion;
  /** Return the content of an event product list view */
  Core_eventProductListViewV2: Core_EventProductListViewV2;
  Core_eventProducts: Core_EventProducts;
  Core_events?: Maybe<Core_EdgeListEvent>;
  Core_exhibitor?: Maybe<Core_Exhibitor>;
  /** Return exhibitor meetings (booked or not) for an exhibitor. */
  Core_exhibitorMeetings: Array<Core_ExhibitorMeeting>;
  Core_exhibitorMembers: Core_ExhibitorMembersConnection;
  Core_exhibitorMembersWithLeadsAssigned: Core_ExhibitorMembersConnection;
  Core_exhibitorPlannings?: Maybe<Core_EdgeListPlanning>;
  Core_exhibitorRootProductCategories: Array<Core_ExhibitorRootProductCategory>;
  /** @deprecated Use Community.exhibitors instead */
  Core_exhibitors?: Maybe<Core_EdgeListExhibitor>;
  /** Returns URL to a badge preview PNG file. */
  Core_exportBadgePreviewPng: Core_PngExportPayload;
  /** Returns URL to a badge template PDF file. */
  Core_exportBadgeTemplatePdf: Core_PdfExportPayload;
  /**
   * Export the user agenda of an event as a iCalendar file. The argument "options" controls
   * what is exported in the iCalendar.
   * Returns null if the calendar is empty.
   */
  Core_exportEventAgendaAsICalendar?: Maybe<Scalars['String']>;
  Core_leadActivity: Core_LeadActivity;
  /** List connections including profiles and contacts */
  Core_listConnections: Core_ContactsUnionConnection;
  /**
   * List event people in an event that the user is allowed to see.
   * To list speakers on a planning, prefer using the query "listSpeakersByPlanning"
   */
  Core_listEventPeople: Core_EventPeopleConnection;
  /**
   * List exhibitors linked to a specific exhibitor.
   * Exhibitors are group by their link.
   */
  Core_listExhibitorsLinkedToExhibitor: Core_ExhibitorsConnection;
  /**
   * List plannings linked to a specific planning.
   * Plannings are group by their link.
   */
  Core_listPlanningsLinkedToPlanning: Core_PlanningsConnection;
  /** List event people speaking at a planning. */
  Core_listSpeakersByPlanning: Core_EventPeopleConnection;
  Core_meeting: Core_Meeting;
  Core_myAiRecommendationsView: Core_EventMyAiRecommendationsView;
  /** Return plannings the user have bookmarked and all his booked meetings for an event. */
  Core_myEventAgendaV2: Array<Core_EventAgenda>;
  /** Return exhibitor of an event where the current user is member. */
  Core_myExhibitor?: Maybe<Core_Exhibitor>;
  /** Return exhibitors where user is member. */
  Core_myExhibitors: Core_ExhibitorsConnection;
  /** Return meetings of a user in an event. */
  Core_myMeetings: Array<Core_HostMeeting>;
  /**
   * Return recommendations selected to be displayed.
   * @deprecated Use myAiRecommendations instead
   */
  Core_myRecommendations?: Maybe<Array<Core_Recommendation>>;
  /** Returns URL to a PDF file with user content in an event. */
  Core_myVisitAsPDF?: Maybe<Scalars['String']>;
  /**
   * Return the number of new notifications (requests and activities).
   * This number can be reset using the Mutation `resetNotificationCounter`
   */
  Core_notificationCounter: Scalars['Int'];
  /** Return the payment intent by order id & secret */
  Core_orderPaymentIntent?: Maybe<Core_OrderPayment>;
  Core_planning: Core_Planning;
  Core_plannings?: Maybe<Core_EdgeListPlanning>;
  Core_product: Core_Product;
  Core_recommendedLeads: Core_RecommendedLeadsConnection;
  /** Suggests messages on connection and meeting requests. */
  Core_requestMessageSuggestions: Array<Core_MessageSuggestion>;
  /**
   * Return received requests sorted by most recent first.
   * By default only pending requests are returned.
   */
  Core_requests: Core_RequestsConnection;
  /** @deprecated Use teamConnections */
  Core_sharedConnections?: Maybe<Core_EdgeListConnectionUnion>;
  /**
   * List suggested events (on-going and upcoming) in the same app.
   * Events where user is already attending are not returned.
   * Returns null if the query is used not in the context of an application.
   */
  Core_suggestedEvents?: Maybe<Core_EventsConnection>;
  /** @deprecated Do not use */
  Core_suggestedTags: Array<Maybe<Scalars['String']>>;
  Core_teamConnection: Core_TeamConnection;
  Core_teamConnections: Core_TeamConnectionsConnection;
  Core_teamMembers?: Maybe<Core_EdgeListUserUnion>;
  Core_teams: Array<Core_Team>;
  Core_user?: Maybe<Core_UserUnion>;
  /** Return meetings for a user in an event. */
  Core_userMeetings: Array<Core_UserMeeting>;
  Core_userTags?: Maybe<Core_EdgeListTag>;
  Sync_calendars: Array<Sync_CalendarUnion>;
  /** Get information about me */
  me?: Maybe<Me>;
  ping: Scalars['Boolean'];
};


export type QueryAuth_LookupArgs = {
  communityId?: InputMaybe<Scalars['String']>;
  emailAddress: Scalars['Auth_EmailAddress'];
  eventId?: InputMaybe<Scalars['String']>;
};


export type QueryBackstage_RoomArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryChat_EmojisArgs = {
  jwtToken?: InputMaybe<Scalars['Chat_JWTToken']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryChat_ListMessageChildrenArgs = {
  channelId: Scalars['Chat_UUID'];
  messageId: Scalars['Chat_ObjectID'];
  pagination: Chat_CursorPaginationInput;
};


export type QueryChat_OwnedChannelsArgs = {
  ids?: InputMaybe<Array<Scalars['Chat_UUID']>>;
  pagination?: InputMaybe<Chat_OffsetPaginationInput>;
};


export type QueryChat_PublicChannelsArgs = {
  asUserId: Scalars['String'];
  filters?: InputMaybe<Array<Chat_PublicChannelFilterInput>>;
  ids?: InputMaybe<Array<Scalars['Chat_UUID']>>;
};


export type QueryChat_UrlMetadataArgs = {
  url: Scalars['String'];
};


export type QueryChat_ViewerArgs = {
  jwtToken?: InputMaybe<Scalars['Chat_JWTToken']>;
};


export type QueryCore_ActivitiesArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  filters?: InputMaybe<Array<Core_ActivityFilterInput>>;
};


export type QueryCore_AllExhibitorMeetingsArgs = {
  eventId: Scalars['ID'];
  exhibitorId: Scalars['ID'];
  filters?: InputMaybe<Array<Core_AllExhibitorMeetingsFilter>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryCore_ApplicationBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryCore_CommonConnectionsArgs = {
  _userId?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Core_SortInput>>>;
};


export type QueryCore_CommunitiesArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  filter?: InputMaybe<Core_CommunitiesFilterInput>;
  sort?: InputMaybe<Core_CommunitySortInput>;
};


export type QueryCore_CommunityArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryCore_ConnectionArgs = {
  _id: Scalars['ID'];
};


export type QueryCore_ConnectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<Core_ConnectionFilterInput>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  slice?: InputMaybe<Core_SliceInput>;
  sort?: InputMaybe<Array<InputMaybe<Core_SortInput>>>;
};


export type QueryCore_DraftOrderArgs = {
  id: Scalars['String'];
  secret: Scalars['String'];
};


export type QueryCore_EventArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryCore_EventExhibitorListViewArgs = {
  filters?: InputMaybe<Array<Core_EventExhibitorListViewFilterInput>>;
  search?: InputMaybe<Scalars['String']>;
  viewId: Scalars['ID'];
};


export type QueryCore_EventHostedBuyersListViewArgs = {
  filters?: InputMaybe<Array<Core_EventHostedBuyersListViewFilterInput>>;
  search?: InputMaybe<Scalars['String']>;
  viewId: Scalars['ID'];
};


export type QueryCore_EventPeopleConnectedArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  eventId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryCore_EventPeopleListViewArgs = {
  filters?: InputMaybe<Array<Core_EventPeopleListViewFilterInput>>;
  search?: InputMaybe<Scalars['String']>;
  viewId: Scalars['ID'];
};


export type QueryCore_EventPersonDetailsArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type QueryCore_EventPersonMeetingsArgs = {
  eventPersonId: Scalars['ID'];
  filter?: InputMaybe<Core_UserMeetingsFilterInput>;
};


export type QueryCore_EventPlanningListViewArgs = {
  filterOperation?: InputMaybe<Core_FilterOperation>;
  filters?: InputMaybe<Array<Core_EventPlanningListViewFilterInput>>;
  search?: InputMaybe<Scalars['String']>;
  viewId: Scalars['ID'];
};


export type QueryCore_EventProductCategoryArgs = {
  eventId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCore_EventProductListViewV2Args = {
  filter?: InputMaybe<Core_EventProductsQueryFilterInput>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<Core_EventProductSortInput>>;
  viewId: Scalars['ID'];
};


export type QueryCore_EventProductsArgs = {
  eventId: Scalars['ID'];
  filter?: InputMaybe<Core_EventProductsQueryFilterInput>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<Core_EventProductSortInput>>;
};


export type QueryCore_EventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<Core_EventFilterInput>>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<Core_EventSortInput>>;
};


export type QueryCore_ExhibitorArgs = {
  _id: Scalars['ID'];
  eventId?: InputMaybe<Scalars['ID']>;
};


export type QueryCore_ExhibitorMeetingsArgs = {
  eventId: Scalars['ID'];
  exhibitorId: Scalars['ID'];
  filter?: InputMaybe<Core_ExhibitorMeetingsFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryCore_ExhibitorMembersArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  eventId?: InputMaybe<Scalars['ID']>;
  exhibitorId: Scalars['ID'];
  filters?: InputMaybe<Array<Core_ExhibitorMembersFilterInput>>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Core_ExhibitorMembersSortInput>>>;
};


export type QueryCore_ExhibitorMembersWithLeadsAssignedArgs = {
  eventId: Scalars['ID'];
  exhibitorId: Scalars['ID'];
  isConnectedWithTeam?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCore_ExhibitorPlanningsArgs = {
  _exhibitorId: Scalars['ID'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<Array<Core_ExhibitorPlanningsFilterInput>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryCore_ExhibitorRootProductCategoriesArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  eventId?: InputMaybe<Scalars['ID']>;
  exhibitorId: Scalars['ID'];
};


export type QueryCore_ExhibitorsArgs = {
  _eventId?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<Core_ExhibitorFilterInput>>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Core_InputExhibitorSortEnum>>>;
};


export type QueryCore_ExportBadgePreviewPngArgs = {
  eventId: Scalars['ID'];
};


export type QueryCore_ExportBadgeTemplatePdfArgs = {
  eventId: Scalars['ID'];
};


export type QueryCore_ExportEventAgendaAsICalendarArgs = {
  eventId: Scalars['ID'];
  options?: InputMaybe<Core_ExportEventAgendaAsICalendarInput>;
};


export type QueryCore_LeadActivityArgs = {
  eventProfileId: Scalars['ID'];
  exhibitorId: Scalars['ID'];
};


export type QueryCore_ListConnectionsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  filter?: InputMaybe<Core_ListConnectionsFilterInput>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Core_SortInput>;
};


export type QueryCore_ListEventPeopleArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  eventId: Scalars['ID'];
  filters?: InputMaybe<Array<Core_ListEventPeopleFilter>>;
  includeSelf?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<Core_EventPeopleSortInput>>;
  visibility?: InputMaybe<Core_VisibilityEnum>;
};


export type QueryCore_ListExhibitorsLinkedToExhibitorArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  eventId?: InputMaybe<Scalars['ID']>;
  exhibitorId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryCore_ListPlanningsLinkedToPlanningArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  eventId?: InputMaybe<Scalars['ID']>;
  planningId: Scalars['ID'];
};


export type QueryCore_ListSpeakersByPlanningArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  eventId?: InputMaybe<Scalars['ID']>;
  includeSelf?: InputMaybe<Scalars['Boolean']>;
  planningId: Scalars['ID'];
};


export type QueryCore_MeetingArgs = {
  id: Scalars['ID'];
};


export type QueryCore_MyAiRecommendationsViewArgs = {
  viewId: Scalars['ID'];
};


export type QueryCore_MyEventAgendaV2Args = {
  dateRange?: InputMaybe<Core_DateRangeInput>;
  eventId: Scalars['ID'];
};


export type QueryCore_MyExhibitorArgs = {
  eventId: Scalars['ID'];
};


export type QueryCore_MyExhibitorsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  filters?: InputMaybe<Array<Core_MyExhibitorsFilter>>;
  sort?: InputMaybe<Array<InputMaybe<Core_MyExhibitorsSortInput>>>;
};


export type QueryCore_MyMeetingsArgs = {
  eventId: Scalars['ID'];
};


export type QueryCore_MyRecommendationsArgs = {
  viewId: Scalars['ID'];
};


export type QueryCore_MyVisitAsPdfArgs = {
  eventId: Scalars['ID'];
  timezone?: InputMaybe<Scalars['String']>;
};


export type QueryCore_OrderPaymentIntentArgs = {
  orderId: Scalars['ID'];
  secret: Scalars['String'];
};


export type QueryCore_PlanningArgs = {
  _id: Scalars['ID'];
  eventId?: InputMaybe<Scalars['ID']>;
};


export type QueryCore_PlanningsArgs = {
  _eventId?: InputMaybe<Scalars['ID']>;
  _personId?: InputMaybe<Scalars['ID']>;
  _userId?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  attendingAs?: InputMaybe<Core_AttendingAsEnum>;
  before?: InputMaybe<Scalars['String']>;
  filterList?: InputMaybe<Array<Core_PlanningFilterInput>>;
  filters?: InputMaybe<Array<InputMaybe<Core_EventFilterInput>>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  slice?: InputMaybe<Core_SliceInput>;
  sort?: InputMaybe<Array<Core_InputPlanningSortEnum>>;
};


export type QueryCore_ProductArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type QueryCore_RecommendedLeadsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  eventId: Scalars['ID'];
  exhibitorId: Scalars['ID'];
  filter?: InputMaybe<Core_RecommendedLeadsFilterInput>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<Core_RecommendedLeadsSortInput>>;
};


export type QueryCore_RequestMessageSuggestionsArgs = {
  input: Core_RequestMessageSuggestionsInput;
};


export type QueryCore_RequestsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  filters?: InputMaybe<Array<Core_RequestFilterInput>>;
};


export type QueryCore_SharedConnectionsArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<Array<Core_SharedConnectionsFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  slice?: InputMaybe<Core_SliceInput>;
  sort?: InputMaybe<Array<InputMaybe<Core_SortInput>>>;
};


export type QueryCore_SuggestedEventsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
};


export type QueryCore_SuggestedTagsArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryCore_TeamConnectionArgs = {
  contactId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  exhibitorId: Scalars['ID'];
  profileId?: InputMaybe<Scalars['ID']>;
};


export type QueryCore_TeamConnectionsArgs = {
  cursor?: InputMaybe<Core_CursorPaginationInput>;
  eventId: Scalars['ID'];
  exhibitorId: Scalars['ID'];
  filter?: InputMaybe<Core_TeamConnectionsFilterInput>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<Core_TeamConnectionsSortInput>>;
};


export type QueryCore_TeamMembersArgs = {
  _exhibitorId?: InputMaybe<Scalars['ID']>;
  _id?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  meetingBeginsAt?: InputMaybe<Scalars['Core_DateTime']>;
  meetingBeginsAtTs?: InputMaybe<Scalars['Int']>;
  meetingId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryCore_UserArgs = {
  _id?: InputMaybe<Scalars['ID']>;
};


export type QueryCore_UserMeetingsArgs = {
  eventId: Scalars['ID'];
  filter?: InputMaybe<Core_UserMeetingsFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  userId: Scalars['ID'];
};


export type QueryCore_UserTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySync_CalendarsArgs = {
  bundleId?: InputMaybe<Scalars['String']>;
  originId?: InputMaybe<Scalars['String']>;
  subscribed?: InputMaybe<Scalars['Boolean']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Is triggered when a user has activities on his channels */
  Chat_activities: Chat_Activity;
  /** Is triggered when a channel is updated */
  Chat_channelUpdated: Chat_Channel;
  /** Is triggered when a channel user has activities on his channel */
  Chat_channelUserActivity: Chat_ChannelUser;
  /** Is triggered when a channel user type on his channel */
  Chat_channelUserChangedTypingStatus: Chat_ChannelUser;
  /** Is triggered when a user entered in a channel */
  Chat_channelUserJoined: Chat_ChannelUser;
  /** Is triggered when a user leave a channel */
  Chat_channelUserLeaved: Chat_ChannelUser;
  /** Is triggered when a user see new messages */
  Chat_channelUserSawMessages: Chat_ChannelUser;
  /** Is triggered when a message is deleted on a channel */
  Chat_messageDeleted: Chat_Message;
  /** Is triggered when a message is updated */
  Chat_messageUpdated: Chat_Message;
  /** Is triggered when a new message is created */
  Chat_newMessage: Chat_Message;
  /** Something happened to this user */
  Chat_userActivity: Chat_User;
  /** Is triggered when a video call room is created */
  Chat_videoCallRoomCreated: Chat_VideoCallRoom;
};


export type SubscriptionChat_ActivitiesArgs = {
  jwtToken?: InputMaybe<Scalars['Chat_JWTToken']>;
};


export type SubscriptionChat_ChannelUpdatedArgs = {
  backstageToken?: InputMaybe<Scalars['String']>;
  channelId?: InputMaybe<Scalars['Chat_UUID']>;
  channelsIds?: InputMaybe<Array<Scalars['Chat_UUID']>>;
  jwtToken?: InputMaybe<Scalars['Chat_JWTToken']>;
};


export type SubscriptionChat_ChannelUserActivityArgs = {
  backstageToken?: InputMaybe<Scalars['String']>;
  jwtToken?: InputMaybe<Scalars['Chat_JWTToken']>;
};


export type SubscriptionChat_ChannelUserChangedTypingStatusArgs = {
  backstageToken?: InputMaybe<Scalars['String']>;
  channelUsersIds?: InputMaybe<Array<Scalars['Chat_ObjectID']>>;
  channelsIds?: InputMaybe<Array<Scalars['Chat_UUID']>>;
  jwtToken?: InputMaybe<Scalars['Chat_JWTToken']>;
};


export type SubscriptionChat_ChannelUserJoinedArgs = {
  backstageToken?: InputMaybe<Scalars['String']>;
  jwtToken?: InputMaybe<Scalars['Chat_JWTToken']>;
};


export type SubscriptionChat_ChannelUserLeavedArgs = {
  backstageToken?: InputMaybe<Scalars['String']>;
  jwtToken?: InputMaybe<Scalars['Chat_JWTToken']>;
};


export type SubscriptionChat_ChannelUserSawMessagesArgs = {
  backstageToken?: InputMaybe<Scalars['String']>;
  jwtToken?: InputMaybe<Scalars['Chat_JWTToken']>;
};


export type SubscriptionChat_MessageDeletedArgs = {
  backstageToken?: InputMaybe<Scalars['String']>;
  channelId?: InputMaybe<Scalars['Chat_UUID']>;
  channelsIds?: InputMaybe<Array<Scalars['Chat_UUID']>>;
  jwtToken?: InputMaybe<Scalars['Chat_JWTToken']>;
};


export type SubscriptionChat_MessageUpdatedArgs = {
  backstageToken?: InputMaybe<Scalars['String']>;
  channelId?: InputMaybe<Scalars['Chat_UUID']>;
  jwtToken?: InputMaybe<Scalars['Chat_JWTToken']>;
};


export type SubscriptionChat_NewMessageArgs = {
  backstageToken?: InputMaybe<Scalars['String']>;
  channelId?: InputMaybe<Scalars['Chat_UUID']>;
  channelsIds?: InputMaybe<Array<Scalars['Chat_UUID']>>;
  jwtToken?: InputMaybe<Scalars['Chat_JWTToken']>;
};


export type SubscriptionChat_UserActivityArgs = {
  asUserId?: InputMaybe<Scalars['String']>;
  backstageToken?: InputMaybe<Scalars['String']>;
  bundleId?: InputMaybe<Scalars['String']>;
  jwtToken?: InputMaybe<Scalars['Chat_JWTToken']>;
  originId?: InputMaybe<Scalars['String']>;
};


export type SubscriptionChat_VideoCallRoomCreatedArgs = {
  backstageToken?: InputMaybe<Scalars['String']>;
  jwtToken?: InputMaybe<Scalars['Chat_JWTToken']>;
};

export enum Sync_CalendarType {
  Google = 'GOOGLE'
}

export type Sync_CalendarUnion = Sync_GoogleCalendarDetails;

export type Sync_Configuration = {
  __typename?: 'Sync_Configuration';
  createdAt: Scalars['Sync_DateTime'];
  credential: Sync_Credential;
  definition?: Maybe<Sync_Connector>;
  enabled: Scalars['Boolean'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  job?: Maybe<Sync_Job>;
  label?: Maybe<Scalars['String']>;
  logs?: Maybe<Sync_ConfigurationLogsConnection>;
  objects: Sync_ObjectsConnection;
  owners: Array<Sync_Owner>;
  properties?: Maybe<Array<Sync_Property>>;
  provider: Sync_Provider;
  streams: Array<Sync_ConfigurationStream>;
  updatedAt?: Maybe<Scalars['Sync_DateTime']>;
};


export type Sync_ConfigurationLogsArgs = {
  cursor?: InputMaybe<Sync_CursorPaginationInput>;
  filters?: InputMaybe<Array<Sync_LogsFilterInput>>;
  search?: InputMaybe<Scalars['String']>;
};


export type Sync_ConfigurationObjectsArgs = {
  cursor?: InputMaybe<Sync_CursorPaginationInput>;
  filters?: InputMaybe<Sync_ObjectsFilterInput>;
};

export type Sync_ConfigurationLog = {
  __typename?: 'Sync_ConfigurationLog';
  data: Scalars['String'];
  id: Scalars['String'];
  level: Sync_ConfigurationLogLevel;
  time: Scalars['String'];
};

export enum Sync_ConfigurationLogEventName {
  ApiCall = 'api_call',
  ConnectionFailure = 'connection_failure',
  ConnectionSuccessful = 'connection_successful',
  InsertData = 'insert_data',
  ModifyData = 'modify_data',
  ScanBadge = 'scan_badge',
  SyncEnd = 'sync_end',
  SyncStarted = 'sync_started',
  UpdateData = 'update_data'
}

export enum Sync_ConfigurationLogLevel {
  Debug = 'debug',
  Error = 'error',
  Fatal = 'fatal',
  Info = 'info',
  Warn = 'warn'
}

export type Sync_ConfigurationLogsConnection = {
  __typename?: 'Sync_ConfigurationLogsConnection';
  nodes?: Maybe<Array<Sync_ConfigurationLog>>;
  pageInfo?: Maybe<Sync_PageInfo>;
  totalCount: Scalars['Int'];
};

export type Sync_ConfigurationStream = {
  __typename?: 'Sync_ConfigurationStream';
  createdAt: Scalars['Sync_DateTime'];
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type Sync_ConfigurationsConnection = {
  __typename?: 'Sync_ConfigurationsConnection';
  nodes?: Maybe<Array<Sync_Configuration>>;
  pageInfo?: Maybe<Sync_PageInfo>;
  totalCount: Scalars['Int'];
};

export type Sync_Connector = {
  __typename?: 'Sync_Connector';
  documentationUrl?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  provider: Sync_Provider;
  skippedEventsLookup: Scalars['Boolean'];
};

export type Sync_CreateAuthTokenResult = {
  __typename?: 'Sync_CreateAuthTokenResult';
  authToken: Scalars['String'];
  created: Scalars['Boolean'];
};

export type Sync_Credential = {
  __typename?: 'Sync_Credential';
  createdAt: Scalars['Sync_DateTime'];
  expired?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  provider: Scalars['String'];
  updatedAt?: Maybe<Scalars['Sync_DateTime']>;
};

export type Sync_CursorPaginationInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export enum Sync_CventRestRegion {
  Eu = 'EU',
  Na = 'NA'
}

export enum Sync_EtouchesRegion {
  Au = 'AU',
  Eu = 'EU',
  Na = 'NA'
}

export enum Sync_FieldType {
  Date = 'date',
  Number = 'number',
  PickList = 'pickList',
  Question = 'question',
  String = 'string',
  StringArray = 'stringArray'
}

export type Sync_Filter = Sync_FilterCompositeCondition | Sync_FilterCondition;

export type Sync_FilterCompositeCondition = {
  __typename?: 'Sync_FilterCompositeCondition';
  conditions: Array<Sync_Filter>;
  type: Sync_FilterLogicalOperator;
};

export type Sync_FilterCompositeConditionInput = {
  conditions: Array<Sync_FilterConditionInput>;
  type: Sync_FilterLogicalOperator;
};

export type Sync_FilterCondition = {
  __typename?: 'Sync_FilterCondition';
  field: Scalars['String'];
  operator: Sync_FilterOperator;
  value: Scalars['String'];
};

export type Sync_FilterConditionInput = {
  field: Scalars['String'];
  operator: Sync_FilterOperator;
  value: Scalars['String'];
};

export enum Sync_FilterLogicalOperator {
  And = 'AND',
  Or = 'OR'
}

export enum Sync_FilterOperator {
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN',
  NotEqual = 'NOT_EQUAL'
}

export type Sync_GoogleCalendarDetails = {
  __typename?: 'Sync_GoogleCalendarDetails';
  /** Correspond to the google authentication redirection url. */
  authenticationUrl?: Maybe<Scalars['String']>;
  calendarId?: Maybe<Scalars['String']>;
  type: Sync_CalendarType;
};

export type Sync_Job = {
  __typename?: 'Sync_Job';
  frequencyInSeconds?: Maybe<Scalars['Int']>;
  lastRunAt?: Maybe<Scalars['Sync_DateTime']>;
  nextRunAt?: Maybe<Scalars['Sync_DateTime']>;
  /** @deprecated Use `frequencyInSeconds` instead */
  repeatInterval?: Maybe<Scalars['String']>;
};

export type Sync_JobInput = {
  /** Job frequency value (ex: 30) */
  repeatEvery?: InputMaybe<Scalars['Int']>;
  /** Job frequency unit (ex: minutes) */
  repeatEveryUnit?: InputMaybe<Scalars['String']>;
};

export type Sync_LogsFilterInput = {
  endTime?: InputMaybe<Scalars['String']>;
  events?: InputMaybe<Array<Sync_ConfigurationLogEventName>>;
  levels?: InputMaybe<Array<Sync_ConfigurationLogLevel>>;
  startTime?: InputMaybe<Scalars['String']>;
};

export type Sync_Mapping = {
  __typename?: 'Sync_Mapping';
  /** The expected answer for the field */
  expectedAnswer?: Maybe<Scalars['String']>;
  /** The swapcard side field, can be null if the user want the field to be ignored */
  internalKey?: Maybe<Scalars['String']>;
  isACustomField?: Maybe<Scalars['Boolean']>;
  options: Sync_MappingOptions;
  providerKey: Scalars['String'];
  type?: Maybe<Sync_FieldType>;
};

export type Sync_MappingFormatterInput = {
  capitalizedFirstLetter?: InputMaybe<Scalars['Boolean']>;
  capitalizedWords?: InputMaybe<Scalars['Boolean']>;
  lowerCase?: InputMaybe<Scalars['Boolean']>;
  upperCase?: InputMaybe<Scalars['Boolean']>;
};

export type Sync_MappingInput = {
  expectedAnswer?: InputMaybe<Scalars['String']>;
  /** Swapcard side field key/identifier, can be null if the user want it to be ignored */
  internalKey?: InputMaybe<Scalars['String']>;
  /** If the field is a custom one or not */
  isACustomField?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Sync_MappingOptionsInput>;
  /** Provider side field key/identifier */
  providerKey: Scalars['String'];
  required?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Sync_FieldType>;
};

export type Sync_MappingOptionFormatter = {
  __typename?: 'Sync_MappingOptionFormatter';
  capitalizedFirstLetter?: Maybe<Scalars['Boolean']>;
  capitalizedWords?: Maybe<Scalars['Boolean']>;
  lowerCase?: Maybe<Scalars['Boolean']>;
  upperCase?: Maybe<Scalars['Boolean']>;
};

export type Sync_MappingOptionReplace = {
  __typename?: 'Sync_MappingOptionReplace';
  ifRecordCreate: Scalars['Boolean'];
  ifRecordUpdate: Scalars['Boolean'];
};

export type Sync_MappingOptionReplaceInput = {
  ifRecordCreate: Scalars['Boolean'];
  ifRecordUpdate: Scalars['Boolean'];
};

export type Sync_MappingOptions = {
  __typename?: 'Sync_MappingOptions';
  formatter?: Maybe<Sync_MappingOptionFormatter>;
  replace?: Maybe<Sync_MappingOptionReplace>;
};

export type Sync_MappingOptionsInput = {
  formatter?: InputMaybe<Sync_MappingFormatterInput>;
  replace?: InputMaybe<Sync_MappingOptionReplaceInput>;
};

export type Sync_Object = {
  __typename?: 'Sync_Object';
  allowedSynchronizationGroups: Array<Sync_SynchronizationGroup>;
  allowedSynchronizationTypes: Array<Scalars['String']>;
  configurationId: Scalars['String'];
  enabled: Scalars['Boolean'];
  forceImport: Scalars['Boolean'];
  id: Scalars['ID'];
  importAsNonVisible: Scalars['Boolean'];
  key: Scalars['String'];
  label: Scalars['String'];
  mappings: Array<Sync_Mapping>;
  options: Sync_ObjectOptionsUnion;
  providerFields?: Maybe<Array<Sync_ProviderField>>;
  swapcardFields: Array<Sync_SwapcardField>;
  synchronizationGroup?: Maybe<Sync_SynchronizationGroup>;
  synchronizationGroupId?: Maybe<Scalars['String']>;
  synchronizationType: Scalars['String'];
};

export type Sync_ObjectExternalRegistrationOptions = {
  __typename?: 'Sync_ObjectExternalRegistrationOptions';
  assignGroup: Sync_ObjectOptionAssignGroup;
  filters?: Maybe<Sync_Filter>;
};

export type Sync_ObjectOptionAssignGroup = {
  __typename?: 'Sync_ObjectOptionAssignGroup';
  defaultGroupId?: Maybe<Scalars['String']>;
  rules: Array<Maybe<Sync_ObjectOptionAssignGroupRule>>;
};

export type Sync_ObjectOptionAssignGroupInput = {
  defaultGroupId?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Array<Sync_ObjectOptionAssignGroupRuleInput>>;
};

export type Sync_ObjectOptionAssignGroupRule = {
  __typename?: 'Sync_ObjectOptionAssignGroupRule';
  filter: Sync_Filter;
  groupId: Scalars['String'];
};

export type Sync_ObjectOptionAssignGroupRuleInput = {
  filter: Sync_FilterCompositeConditionInput;
  groupId: Scalars['String'];
};

export type Sync_ObjectOptionsInput = {
  assignGroup?: InputMaybe<Sync_ObjectOptionAssignGroupInput>;
  filters?: InputMaybe<Sync_FilterCompositeConditionInput>;
};

export type Sync_ObjectOptionsUnion = Sync_ObjectExternalRegistrationOptions;

export type Sync_ObjectsConnection = {
  __typename?: 'Sync_ObjectsConnection';
  nodes?: Maybe<Array<Sync_Object>>;
  pageInfo?: Maybe<Sync_PageInfo>;
  totalCount: Scalars['Int'];
};

export type Sync_ObjectsFilterInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type Sync_Owner = {
  __typename?: 'Sync_Owner';
  id: Scalars['String'];
  type: Scalars['String'];
};

export type Sync_OwnerInput = {
  id: Scalars['String'];
  type: Sync_OwnerType;
};

export enum Sync_OwnerType {
  Event = 'event',
  User = 'user'
}

export type Sync_PageInfo = {
  __typename?: 'Sync_PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type Sync_Property = {
  __typename?: 'Sync_Property';
  /** Property description */
  description: Scalars['String'];
  /** Property label */
  label: Scalars['String'];
  /** Reference field key/identifier */
  reference: Scalars['String'];
  /** Property type */
  type: Sync_PropertyType;
  /** Value field key/identifier */
  value: Scalars['String'];
};

export type Sync_PropertyInput = {
  /** Reference field key/identifier */
  reference?: InputMaybe<Scalars['String']>;
  /** Value field key/identifier */
  value?: InputMaybe<Scalars['String']>;
};

export enum Sync_PropertyType {
  Boolean = 'boolean',
  Number = 'number',
  String = 'string'
}

export enum Sync_Provider {
  A2z = 'a2z',
  AspShowoff = 'aspShowoff',
  AttendeeInteractive = 'attendeeInteractive',
  AttendeeInteractiveAhce = 'attendeeInteractiveAhce',
  Bento = 'bento',
  Bizzabo = 'bizzabo',
  Cadmium = 'cadmium',
  Circdata = 'circdata',
  Coasis = 'coasis',
  Cventonsite = 'cventonsite',
  Cventrest = 'cventrest',
  Dia = 'dia',
  Digitevent = 'digitevent',
  Dimedis = 'dimedis',
  Dmexco = 'dmexco',
  Eshow = 'eshow',
  Etouches = 'etouches',
  Evenium = 'evenium',
  Eventbrite = 'eventbrite',
  Eventmaker = 'eventmaker',
  Eventrebels = 'eventrebels',
  Experient = 'experient',
  Gevme = 'gevme',
  Glevents = 'glevents',
  GoogleCalendar = 'googleCalendar',
  Hubspot = 'hubspot',
  InformaCore = 'informaCore',
  Koelnmesse = 'koelnmesse',
  Leni = 'leni',
  LeniBepositive2025 = 'leniBepositive2025',
  LeniFicEurope2025 = 'leniFicEurope2025',
  LeniGi2025 = 'leniGi2025',
  LeniSirha2025 = 'leniSirha2025',
  MaritzAhce = 'maritzAhce',
  Mediactive = 'mediactive',
  Mys = 'mys',
  Pimcore = 'pimcore',
  SalesforceHlth = 'salesforceHlth',
  SalesforceNscp = 'salesforceNscp',
  Streampoint = 'streampoint',
  Swoogo = 'swoogo',
  Tito = 'tito',
  TmForumStrapi = 'tmForumStrapi',
  Tufabrica = 'tufabrica',
  Universe = 'universe',
  Visit = 'visit',
  Weezevent = 'weezevent',
  Yurplan = 'yurplan'
}

export type Sync_ProviderEvent = {
  __typename?: 'Sync_ProviderEvent';
  endDate?: Maybe<Scalars['Sync_DateTime']>;
  id: Scalars['String'];
  name: Scalars['String'];
  startDate?: Maybe<Scalars['Sync_DateTime']>;
  state?: Maybe<Sync_ProviderEventState>;
};

export enum Sync_ProviderEventState {
  NotSyncable = 'NOT_SYNCABLE',
  Syncable = 'SYNCABLE'
}

export type Sync_ProviderField = {
  __typename?: 'Sync_ProviderField';
  expectedAnswer?: Maybe<Scalars['String']>;
  /** Whether or not the field is a custom field */
  isACustomField?: Maybe<Scalars['Boolean']>;
  /** Whether or not the field is required by the provider */
  isRequired: Scalars['Boolean'];
  key: Scalars['String'];
  /** A displayable labels */
  label: Scalars['String'];
  type: Sync_FieldType;
};

export type Sync_SwapcardField = {
  __typename?: 'Sync_SwapcardField';
  /** Whether or not the field is required to be mapped */
  isRequired: Scalars['Boolean'];
  key: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  type: Sync_FieldType;
};

export type Sync_SynchronizationGroup = {
  __typename?: 'Sync_SynchronizationGroup';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum Sync_SynchronizationType {
  Exhibitor = 'exhibitor',
  People = 'people',
  Product = 'product',
  Session = 'session'
}

export type Sync_TriggerJobInput = {
  configurationId: Scalars['String'];
  fullReload?: InputMaybe<Scalars['Boolean']>;
};

export type Sync_UpdateJobInput = {
  configurationId: Scalars['String'];
  job: Sync_JobInput;
};

export enum Sync_DimedisClient {
  Hamburg = 'hamburg',
  Koeln = 'koeln'
}

export enum Sync_DimedisEnvironment {
  Prod = 'prod',
  Test = 'test'
}

export type TeamApplicationQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamApplicationQueryQuery = { __typename?: 'Query', application: { __typename?: 'Core_Application', webIcon?: string | null, name: string, appWebDomain?: string | null, teamWebDomain?: string | null, isDefault: boolean, slug: string, legalNoticeUrl?: string | null, termsOfUseUrl?: string | null, privacyPolicyUrl?: string | null, id: string, fonts?: Array<{ __typename?: 'Core_Font', url: string, family: string, style: string, weight: string, format: string } | null> | null, themes?: Array<{ __typename?: 'Core_ThemeLink', theme?: { __typename?: 'Core_Theme', id: string, primaryColor?: string | null, buttonsColor?: string | null, textColor?: string | null, backgroundColor?: string | null, containerColor?: string | null, mode?: Core_ThemeModeEnum | null } | null } | null> | null } };

export type CustomThemeQueryQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type CustomThemeQueryQuery = { __typename?: 'Query', event: { __typename?: 'Core_Event', id: string, application?: { __typename?: 'Core_Application', themes?: Array<{ __typename?: 'Core_ThemeLink', theme?: { __typename?: 'Core_Theme', id: string, textColor?: string | null, buttonsColor?: string | null, backgroundColor?: string | null, primaryColor?: string | null, containerColor?: string | null, mode?: Core_ThemeModeEnum | null } | null } | null> | null } | null, community: { __typename?: 'Core_Community', themes?: Array<{ __typename?: 'Core_ThemeLink', theme?: { __typename?: 'Core_Theme', id: string, textColor?: string | null, buttonsColor?: string | null, backgroundColor?: string | null, primaryColor?: string | null, containerColor?: string | null, mode?: Core_ThemeModeEnum | null } | null } | null> | null }, themes?: Array<{ __typename?: 'Core_ThemeLink', theme?: { __typename?: 'Core_Theme', id: string, textColor?: string | null, buttonsColor?: string | null, backgroundColor?: string | null, primaryColor?: string | null, containerColor?: string | null, mode?: Core_ThemeModeEnum | null } | null } | null> | null } };

export type EventBySlugQueryVariables = Exact<{
  eventSlug: Scalars['String'];
}>;


export type EventBySlugQuery = { __typename?: 'Query', event: { __typename?: 'Core_Event', title: string, beginsAt: any, endsAt: any, createdAt?: any | null, description?: string | null, slug?: string | null, isLive: boolean, isPublic: boolean, updatedAt?: any | null, language: Core_LanguageEnum, latitude?: number | null, longitude?: number | null, timezone?: string | null, id: string, banner?: { __typename?: 'Core_Banner', imageUrl?: string | null } | null, address?: { __typename?: 'Core_Address', city?: string | null, country?: string | null, place?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null, themes?: Array<{ __typename?: 'Core_ThemeLink', theme?: { __typename?: 'Core_Theme', backgroundImageUrl?: string | null } | null } | null> | null, contents: { __typename?: 'Core_EventContents', views: Array<{ __typename: 'Core_EventBadgeView' } | { __typename: 'Core_EventChatroomView' } | { __typename: 'Core_EventExhibitorListView', id: string } | { __typename: 'Core_EventFeedView' } | { __typename: 'Core_EventGroupView' } | { __typename: 'Core_EventHostedBuyersListView' } | { __typename: 'Core_EventMapsView' } | { __typename: 'Core_EventMyAiRecommendationsView' } | { __typename: 'Core_EventMyVisitView' } | { __typename: 'Core_EventPeopleListView', id: string } | { __typename: 'Core_EventPlanningListView', id: string } | { __typename: 'Core_EventProductListView', id: string } | { __typename: 'Core_EventRedirectUrlView' }> } } };

export type ExhibitorAndSelfRightsQueryQueryVariables = Exact<{
  exhibitorId: Scalars['ID'];
  eventId: Scalars['ID'];
}>;


export type ExhibitorAndSelfRightsQueryQuery = { __typename?: 'Query', exhibitor?: { __typename?: 'Core_Exhibitor', exhibitorMemberRole: Core_ExhibitorMemberRole, id: string, events?: { __typename?: 'Core_EventsConnection', nodes: Array<{ __typename?: 'Core_Event', slug?: string | null, id: string }> } | null, withEvent?: { __typename?: 'Core_ExhibitorWithEvent', canInviteMembers: boolean } | null } | null };

export type ExhibitorBackgroundQueryQueryVariables = Exact<{
  exhibitorId: Scalars['ID'];
  eventId?: InputMaybe<Scalars['ID']>;
}>;


export type ExhibitorBackgroundQueryQuery = { __typename?: 'Query', exhibitor?: { __typename?: 'Core_Exhibitor', backgroundImageUrl?: string | null, id: string } | null };

export type Layout_ExhibitorEventsQueryVariables = Exact<{
  exhibitorId: Scalars['ID'];
}>;


export type Layout_ExhibitorEventsQuery = { __typename?: 'Query', exhibitor?: { __typename?: 'Core_Exhibitor', exhibitorStatus?: Core_ExhibitorStatusEnum | null, id: string, events?: { __typename?: 'Core_EventsConnection', nodes: Array<{ __typename?: 'Core_Event', title: string, bannerUrl?: string | null, beginsAt: any, endsAt: any, type: Core_EventTypeEnum, timezone?: string | null, id: string, themes?: Array<{ __typename?: 'Core_ThemeLink', theme?: { __typename?: 'Core_Theme', id: string, backgroundImageUrl?: string | null } | null } | null> | null }> } | null } | null };

export type ExhibitorMeetingsStatusesFiltersQueryQueryVariables = Exact<{
  exhibitorId: Scalars['ID'];
  eventId: Scalars['ID'];
}>;


export type ExhibitorMeetingsStatusesFiltersQueryQuery = { __typename?: 'Query', pendingReceived: { __typename?: 'Core_ExhibitorMeetingDetailedResults', pageInfo: { __typename?: 'Core_PageResultsInfo', totalResults: number } }, confirmed: { __typename?: 'Core_ExhibitorMeetingDetailedResults', pageInfo: { __typename?: 'Core_PageResultsInfo', totalResults: number } }, pendingSent: { __typename?: 'Core_ExhibitorMeetingDetailedResults', pageInfo: { __typename?: 'Core_PageResultsInfo', totalResults: number } }, canceled: { __typename?: 'Core_ExhibitorMeetingDetailedResults', pageInfo: { __typename?: 'Core_PageResultsInfo', totalResults: number } } };

export type ExhibitorMenuQueryQueryVariables = Exact<{
  exhibitorId: Scalars['ID'];
  eventId: Scalars['ID'];
  dateRange?: InputMaybe<Core_DateRangeInput>;
}>;


export type ExhibitorMenuQueryQuery = { __typename?: 'Query', exhibitor?: { __typename?: 'Core_Exhibitor', name: string, type?: string | null, logoUrl?: string | null, id: string, events?: { __typename?: 'Core_EventsConnection', nodes: Array<{ __typename?: 'Core_Event', isLive: boolean, slug?: string | null, type: Core_EventTypeEnum, timezone?: string | null, beginsAt: any, endsAt: any, title: string, id: string, community: { __typename?: 'Core_Community', id: string, slug: string, name: string, logoUrl?: string | null } }> } | null, withEvent?: { __typename?: 'Core_ExhibitorWithEvent', booth?: string | null, fields: Array<{ __typename: 'Core_DateField' } | { __typename: 'Core_LongTextField' } | { __typename: 'Core_MediaField' } | { __typename: 'Core_MultipleSelectField' } | { __typename: 'Core_MultipleTextField' } | { __typename: 'Core_NumberField' } | { __typename: 'Core_SelectField', id: string, value?: { __typename?: 'Core_SelectFieldValue', id: string, text: string } | null } | { __typename: 'Core_TextField', id: string, value?: { __typename?: 'Core_TextFieldValue', id: string, text: string } | null } | { __typename: 'Core_TreeField' } | { __typename: 'Core_UrlField' }>, meetingSlots: { __typename?: 'Core_ExhibitorMeetingSlotsConnection', totalCount: number } } | null } | null, rootProductCategories: Array<{ __typename?: 'Core_ExhibitorRootProductCategory', totalLimit?: number | null, productCount: number, category: { __typename?: 'Core_ProductCategory', id: string, name: string } }> };

export type ExhibitorMembersQueryQueryVariables = Exact<{
  exhibitorId: Scalars['ID'];
  eventId?: InputMaybe<Scalars['ID']>;
  count?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  withEvent?: InputMaybe<Scalars['Boolean']>;
  withEventId: Scalars['ID'];
}>;


export type ExhibitorMembersQueryQuery = { __typename?: 'Query', members: { __typename?: 'Core_ExhibitorMembersConnection', totalCount: number, pageInfo: { __typename?: 'Core_PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes: Array<(
      { __typename?: 'Core_ExhibitorMember' }
      & { ' $fragmentRefs'?: { 'ExhibitorMemberFragmentFragment': ExhibitorMemberFragmentFragment } }
    )> } };

export type ExhibitorMemberFragmentFragment = { __typename?: 'Core_ExhibitorMember', id: string, firstName: string, lastName: string, photoUrl?: string | null, jobTitle?: string | null, organization?: string | null, exhibitorMemberRole: Core_ExhibitorMemberRole, withEvent?: { __typename?: 'Core_ExhibitorMemberWithEvent', eventProfile: { __typename?: 'Core_EventPerson', id: string }, options: { __typename?: 'Core_ExhibitorMemberOptions', shareConnections: boolean, isVisible: boolean } } | null } & { ' $fragmentName'?: 'ExhibitorMemberFragmentFragment' };

export type SelectLanguageMutationMutationVariables = Exact<{
  language?: InputMaybe<Core_LanguageEnum>;
}>;


export type SelectLanguageMutationMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'Core_SelfUser', firstName?: string | null, lastName?: string | null, photoUrl?: string | null, language: Core_LanguageEnum, id: string } | null };

export type Layout_LoginQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type Layout_LoginQueryQuery = { __typename?: 'Query', application: { __typename?: 'Core_Application', slug: string, isDefault: boolean, id: string } };

export type SelfExhibitorQueryQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type SelfExhibitorQueryQuery = { __typename?: 'Query', exhibitors: { __typename?: 'Core_ExhibitorsConnection', nodes: Array<{ __typename?: 'Core_Exhibitor', _id: string, name: string }> }, application: { __typename?: 'Core_Application', teamWebDomain?: string | null, id: string } };

export type Layout_SelfUserQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type Layout_SelfUserQueryQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user: { __typename: 'Core_ConnectionUser' } | { __typename: 'Core_PublicUser' } | { __typename: 'Core_SelfUser', firstName?: string | null, lastName?: string | null, photoUrl?: string | null, language: Core_LanguageEnum, email?: string | null, id: string } } | null };

export type Layout_TopBarQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type Layout_TopBarQueryQuery = { __typename?: 'Query', exhibitors: { __typename?: 'Core_ExhibitorsConnection', nodes: Array<{ __typename?: 'Core_Exhibitor', name: string, logoUrl?: string | null, id: string, events?: { __typename?: 'Core_EventsConnection', nodes: Array<{ __typename?: 'Core_Event', slug?: string | null, title: string, isLive: boolean, id: string, community: { __typename?: 'Core_Community', id: string, name: string, logoUrl?: string | null } }> } | null }> } };

export const ExhibitorMemberFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExhibitorMemberFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Core_ExhibitorMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"exhibitorMemberRole"}},{"kind":"Field","name":{"kind":"Name","value":"withEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withEventId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withEvent"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shareConnections"}},{"kind":"Field","name":{"kind":"Name","value":"isVisible"}}]}}]}}]}}]} as unknown as DocumentNode<ExhibitorMemberFragmentFragment, unknown>;
export const TeamApplicationQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamApplicationQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"application"},"name":{"kind":"Name","value":"Core_application"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"fonts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"family"}},{"kind":"Field","name":{"kind":"Name","value":"style"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"format"}}]}},{"kind":"Field","name":{"kind":"Name","value":"themes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"buttonsColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"containerColor"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"webIcon"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"appWebDomain"}},{"kind":"Field","name":{"kind":"Name","value":"teamWebDomain"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"legalNoticeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"termsOfUseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"privacyPolicyUrl"}}]}}]}}]} as unknown as DocumentNode<TeamApplicationQueryQuery, TeamApplicationQueryQueryVariables>;
export const CustomThemeQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomThemeQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"Core_event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"application"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"themes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"buttonsColor"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"containerColor"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"themes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"buttonsColor"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"containerColor"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"themes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"buttonsColor"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"containerColor"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CustomThemeQueryQuery, CustomThemeQueryQueryVariables>;
export const EventBySlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"Core_event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"beginsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isLive"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"banner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"themes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backgroundImageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"views"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Core_EventPlanningListView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Core_EventExhibitorListView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Core_EventPeopleListView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Core_EventProductListView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EventBySlugQuery, EventBySlugQueryVariables>;
export const ExhibitorAndSelfRightsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExhibitorAndSelfRightsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exhibitorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitor"},"name":{"kind":"Name","value":"Core_exhibitor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exhibitorId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"exhibitorMemberRole"}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"withEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canInviteMembers"}}]}}]}}]}}]} as unknown as DocumentNode<ExhibitorAndSelfRightsQueryQuery, ExhibitorAndSelfRightsQueryQueryVariables>;
export const ExhibitorBackgroundQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExhibitorBackgroundQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exhibitorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitor"},"name":{"kind":"Name","value":"Core_exhibitor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exhibitorId"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundImageUrl"}}]}}]}}]} as unknown as DocumentNode<ExhibitorBackgroundQueryQuery, ExhibitorBackgroundQueryQueryVariables>;
export const Layout_ExhibitorEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Layout_ExhibitorEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exhibitorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitor"},"name":{"kind":"Name","value":"Core_exhibitor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exhibitorId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"exhibitorStatus"}},{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"30"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"BEGINS_AT"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"bannerUrl"}},{"kind":"Field","name":{"kind":"Name","value":"beginsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"themes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundImageUrl"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Layout_ExhibitorEventsQuery, Layout_ExhibitorEventsQueryVariables>;
export const ExhibitorMeetingsStatusesFiltersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExhibitorMeetingsStatusesFiltersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exhibitorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pendingReceived"},"name":{"kind":"Name","value":"Core_allExhibitorMeetings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"exhibitorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exhibitorId"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"shouldStatusIn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PENDING_RECEIVED"}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"confirmed"},"name":{"kind":"Name","value":"Core_allExhibitorMeetings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"exhibitorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exhibitorId"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"shouldStatusIn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CONFIRMED"}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pendingSent"},"name":{"kind":"Name","value":"Core_allExhibitorMeetings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"exhibitorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exhibitorId"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"shouldStatusIn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PENDING_SENT"}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"canceled"},"name":{"kind":"Name","value":"Core_allExhibitorMeetings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"exhibitorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exhibitorId"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"shouldStatusIn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CANCELED"}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]}}]} as unknown as DocumentNode<ExhibitorMeetingsStatusesFiltersQueryQuery, ExhibitorMeetingsStatusesFiltersQueryQueryVariables>;
export const ExhibitorMenuQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExhibitorMenuQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exhibitorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Core_DateRangeInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitor"},"name":{"kind":"Name","value":"Core_exhibitor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exhibitorId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"isLive"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"beginsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"withEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"booth"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Core_TextField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Core_SelectField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meetingSlots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rootProductCategories"},"name":{"kind":"Name","value":"Core_exhibitorRootProductCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"exhibitorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exhibitorId"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalLimit"}},{"kind":"Field","name":{"kind":"Name","value":"productCount"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ExhibitorMenuQueryQuery, ExhibitorMenuQueryQueryVariables>;
export const ExhibitorMembersQueryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExhibitorMembersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exhibitorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"count"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withEvent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withEventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"members"},"name":{"kind":"Name","value":"Core_exhibitorMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"exhibitorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exhibitorId"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"count"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"NAME"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitorMemberFragment"}}]}}]}}]}},...ExhibitorMemberFragmentFragmentDoc.definitions]} as unknown as DocumentNode<ExhibitorMembersQueryQuery, ExhibitorMembersQueryQueryVariables>;
export const SelectLanguageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SelectLanguageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Core_LanguageEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"updateUser"},"name":{"kind":"Name","value":"Core_updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userData"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]} as unknown as DocumentNode<SelectLanguageMutationMutation, SelectLanguageMutationMutationVariables>;
export const Layout_LoginQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Layout_LoginQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"application"},"name":{"kind":"Name","value":"Core_application"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]}}]} as unknown as DocumentNode<Layout_LoginQueryQuery, Layout_LoginQueryQueryVariables>;
export const SelfExhibitorQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SelfExhibitorQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitors"},"name":{"kind":"Name","value":"Core_myExhibitors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"application"},"name":{"kind":"Name","value":"Core_application"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"teamWebDomain"}}]}}]}}]} as unknown as DocumentNode<SelfExhibitorQueryQuery, SelfExhibitorQueryQueryVariables>;
export const Layout_SelfUserQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Layout_SelfUserQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Core_SelfUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Layout_SelfUserQueryQuery, Layout_SelfUserQueryQueryVariables>;
export const Layout_TopBarQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Layout_TopBarQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exhibitors"},"name":{"kind":"Name","value":"Core_myExhibitors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"30"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"BEGINS_AT"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isLive"}},{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Layout_TopBarQueryQuery, Layout_TopBarQueryQueryVariables>;